(function () {
	'use strict';

	!function () {

	  if ("undefined" != typeof window) {
	    var t = window.navigator.userAgent.match(/Edge\/(\d{2})\./),
	      e = t ? parseInt(t[1], 10) : null,
	      n = !!e && 16 <= e && e <= 18;
	    if (!("objectFit" in document.documentElement.style != false) || n) {
	      var o = function (t, e, i) {
	          var n, o, l, a, d;
	          if ((i = i.split(" ")).length < 2 && (i[1] = i[0]), "x" === t) n = i[0], o = i[1], l = "left", a = "right", d = e.clientWidth;else {
	            if ("y" !== t) return;
	            n = i[1], o = i[0], l = "top", a = "bottom", d = e.clientHeight;
	          }
	          if (n !== l && o !== l) {
	            if (n !== a && o !== a) return "center" === n || "50%" === n ? (e.style[l] = "50%", void (e.style["margin-" + l] = d / -2 + "px")) : void (0 <= n.indexOf("%") ? (n = parseInt(n, 10)) < 50 ? (e.style[l] = n + "%", e.style["margin-" + l] = d * (n / -100) + "px") : (n = 100 - n, e.style[a] = n + "%", e.style["margin-" + a] = d * (n / -100) + "px") : e.style[l] = n);
	            e.style[a] = "0";
	          } else e.style[l] = "0";
	        },
	        l = function (t) {
	          var e = t.dataset ? t.dataset.objectFit : t.getAttribute("data-object-fit"),
	            i = t.dataset ? t.dataset.objectPosition : t.getAttribute("data-object-position");
	          e = e || "cover", i = i || "50% 50%";
	          var n = t.parentNode;
	          return function (t) {
	            var e = window.getComputedStyle(t, null),
	              i = e.getPropertyValue("position"),
	              n = e.getPropertyValue("overflow"),
	              o = e.getPropertyValue("display");
	            i && "static" !== i || (t.style.position = "relative"), "hidden" !== n && (t.style.overflow = "hidden"), o && "inline" !== o || (t.style.display = "block"), 0 === t.clientHeight && (t.style.height = "100%"), -1 === t.className.indexOf("object-fit-polyfill") && (t.className = t.className + " object-fit-polyfill");
	          }(n), function (t) {
	            var e = window.getComputedStyle(t, null),
	              i = {
	                "max-width": "none",
	                "max-height": "none",
	                "min-width": "0px",
	                "min-height": "0px",
	                top: "auto",
	                right: "auto",
	                bottom: "auto",
	                left: "auto",
	                "margin-top": "0px",
	                "margin-right": "0px",
	                "margin-bottom": "0px",
	                "margin-left": "0px"
	              };
	            for (var n in i) e.getPropertyValue(n) !== i[n] && (t.style[n] = i[n]);
	          }(t), t.style.position = "absolute", t.style.width = "auto", t.style.height = "auto", "scale-down" === e && (e = t.clientWidth < n.clientWidth && t.clientHeight < n.clientHeight ? "none" : "contain"), "none" === e ? (o("x", t, i), void o("y", t, i)) : "fill" === e ? (t.style.width = "100%", t.style.height = "100%", o("x", t, i), void o("y", t, i)) : (t.style.height = "100%", void ("cover" === e && t.clientWidth > n.clientWidth || "contain" === e && t.clientWidth < n.clientWidth ? (t.style.top = "0", t.style.marginTop = "0", o("x", t, i)) : (t.style.width = "100%", t.style.height = "auto", t.style.left = "0", t.style.marginLeft = "0", o("y", t, i))));
	        },
	        i = function (t) {
	          if (void 0 === t || t instanceof Event) t = document.querySelectorAll("[data-object-fit]");else if (t && t.nodeName) t = [t];else {
	            if ("object" != typeof t || !t.length || !t[0].nodeName) return false;
	            t = t;
	          }
	          for (var e = 0; e < t.length; e++) if (t[e].nodeName) {
	            var i = t[e].nodeName.toLowerCase();
	            if ("img" === i) {
	              if (n) continue;
	              t[e].complete ? l(t[e]) : t[e].addEventListener("load", function () {
	                l(this);
	              });
	            } else "video" === i ? 0 < t[e].readyState ? l(t[e]) : t[e].addEventListener("loadedmetadata", function () {
	              l(this);
	            }) : l(t[e]);
	          }
	          return true;
	        };
	      "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", i) : i(), window.addEventListener("resize", i), window.objectFitPolyfill = i;
	    } else window.objectFitPolyfill = function () {
	      return false;
	    };
	  }
	}();

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	var whatInput = {exports: {}};

	/**
	 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
	 * @version v5.2.12
	 * @link https://github.com/ten1seven/what-input
	 * @license MIT
	 */
	(function (module, exports$1) {
	  (function webpackUniversalModuleDefinition(root, factory) {
	    module.exports = factory();
	  })(commonjsGlobal, function () {
	    return /******/function (modules) {
	      // webpackBootstrap
	      /******/ // The module cache
	      /******/
	      var installedModules = {};

	      /******/ // The require function
	      /******/
	      function __webpack_require__(moduleId) {
	        /******/ // Check if module is in cache
	        /******/if (installedModules[moduleId]) /******/return installedModules[moduleId].exports;

	        /******/ // Create a new module (and put it into the cache)
	        /******/
	        var module = installedModules[moduleId] = {
	          /******/exports: {},
	          /******/id: moduleId,
	          /******/loaded: false
	          /******/
	        };

	        /******/ // Execute the module function
	        /******/
	        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

	        /******/ // Flag the module as loaded
	        /******/
	        module.loaded = true;

	        /******/ // Return the exports of the module
	        /******/
	        return module.exports;
	        /******/
	      }

	      /******/ // expose the modules object (__webpack_modules__)
	      /******/
	      __webpack_require__.m = modules;

	      /******/ // expose the module cache
	      /******/
	      __webpack_require__.c = installedModules;

	      /******/ // __webpack_public_path__
	      /******/
	      __webpack_require__.p = "";

	      /******/ // Load entry module and return exports
	      /******/
	      return __webpack_require__(0);
	      /******/
	    }
	    /************************************************************************/
	    /******/([(/* 0 */
	    /***/function (module, exports$1) {

	      module.exports = function () {
	        /*
	         * bail out if there is no document or window
	         * (i.e. in a node/non-DOM environment)
	         *
	         * Return a stubbed API instead
	         */
	        if (typeof document === 'undefined' || typeof window === 'undefined') {
	          return {
	            // always return "initial" because no interaction will ever be detected
	            ask: function ask() {
	              return 'initial';
	            },
	            // always return null
	            element: function element() {
	              return null;
	            },
	            // no-op
	            ignoreKeys: function ignoreKeys() {},
	            // no-op
	            specificKeys: function specificKeys() {},
	            // no-op
	            registerOnChange: function registerOnChange() {},
	            // no-op
	            unRegisterOnChange: function unRegisterOnChange() {}
	          };
	        }

	        /*
	         * variables
	         */

	        // cache document.documentElement
	        var docElem = document.documentElement;

	        // currently focused dom element
	        var currentElement = null;

	        // last used input type
	        var currentInput = 'initial';

	        // last used input intent
	        var currentIntent = currentInput;

	        // UNIX timestamp of current event
	        var currentTimestamp = Date.now();

	        // check for a `data-whatpersist` attribute on either the `html` or `body` elements, defaults to `true`
	        var shouldPersist = false;

	        // form input types
	        var formInputs = ['button', 'input', 'select', 'textarea'];

	        // empty array for holding callback functions
	        var functionList = [];

	        // list of modifier keys commonly used with the mouse and
	        // can be safely ignored to prevent false keyboard detection
	        var ignoreMap = [16,
	        // shift
	        17,
	        // control
	        18,
	        // alt
	        91,
	        // Windows key / left Apple cmd
	        93 // Windows menu / right Apple cmd
	        ];
	        var specificMap = [];

	        // mapping of events to input types
	        var inputMap = {
	          keydown: 'keyboard',
	          keyup: 'keyboard',
	          mousedown: 'mouse',
	          mousemove: 'mouse',
	          MSPointerDown: 'pointer',
	          MSPointerMove: 'pointer',
	          pointerdown: 'pointer',
	          pointermove: 'pointer',
	          touchstart: 'touch',
	          touchend: 'touch'

	          // boolean: true if the page is being scrolled
	        };
	        var isScrolling = false;

	        // store current mouse position
	        var mousePos = {
	          x: null,
	          y: null

	          // map of IE 10 pointer events
	        };
	        var pointerMap = {
	          2: 'touch',
	          3: 'touch',
	          // treat pen like touch
	          4: 'mouse'

	          // check support for passive event listeners
	        };
	        var supportsPassive = false;
	        try {
	          var opts = Object.defineProperty({}, 'passive', {
	            get: function get() {
	              supportsPassive = true;
	            }
	          });
	          window.addEventListener('test', null, opts);
	        } catch (e) {}
	        // fail silently

	        /*
	         * set up
	         */

	        var setUp = function setUp() {
	          // add correct mouse wheel event mapping to `inputMap`
	          inputMap[detectWheel()] = 'mouse';
	          addListeners();
	        };

	        /*
	         * events
	         */

	        var addListeners = function addListeners() {
	          // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
	          // can only demonstrate potential, but not actual, interaction
	          // and are treated separately
	          var options = supportsPassive ? {
	            passive: true,
	            capture: true
	          } : true;
	          document.addEventListener('DOMContentLoaded', setPersist, true);

	          // pointer events (mouse, pen, touch)
	          if (window.PointerEvent) {
	            window.addEventListener('pointerdown', setInput, true);
	            window.addEventListener('pointermove', setIntent, true);
	          } else if (window.MSPointerEvent) {
	            window.addEventListener('MSPointerDown', setInput, true);
	            window.addEventListener('MSPointerMove', setIntent, true);
	          } else {
	            // mouse events
	            window.addEventListener('mousedown', setInput, true);
	            window.addEventListener('mousemove', setIntent, true);

	            // touch events
	            if ('ontouchstart' in window) {
	              window.addEventListener('touchstart', setInput, options);
	              window.addEventListener('touchend', setInput, true);
	            }
	          }

	          // mouse wheel
	          window.addEventListener(detectWheel(), setIntent, options);

	          // keyboard events
	          window.addEventListener('keydown', setInput, true);
	          window.addEventListener('keyup', setInput, true);

	          // focus events
	          window.addEventListener('focusin', setElement, true);
	          window.addEventListener('focusout', clearElement, true);
	        };

	        // checks if input persistence should happen and
	        // get saved state from session storage if true (defaults to `false`)
	        var setPersist = function setPersist() {
	          shouldPersist = !(docElem.getAttribute('data-whatpersist') === 'false' || document.body.getAttribute('data-whatpersist') === 'false');
	          if (shouldPersist) {
	            // check for session variables and use if available
	            try {
	              if (window.sessionStorage.getItem('what-input')) {
	                currentInput = window.sessionStorage.getItem('what-input');
	              }
	              if (window.sessionStorage.getItem('what-intent')) {
	                currentIntent = window.sessionStorage.getItem('what-intent');
	              }
	            } catch (e) {
	              // fail silently
	            }
	          }

	          // always run these so at least `initial` state is set
	          doUpdate('input');
	          doUpdate('intent');
	        };

	        // checks conditions before updating new input
	        var setInput = function setInput(event) {
	          var eventKey = event.which;
	          var value = inputMap[event.type];
	          if (value === 'pointer') {
	            value = pointerType(event);
	          }
	          var ignoreMatch = !specificMap.length && ignoreMap.indexOf(eventKey) === -1;
	          var specificMatch = specificMap.length && specificMap.indexOf(eventKey) !== -1;
	          var shouldUpdate = value === 'keyboard' && eventKey && (ignoreMatch || specificMatch) || value === 'mouse' || value === 'touch';

	          // prevent touch detection from being overridden by event execution order
	          if (validateTouch(value)) {
	            shouldUpdate = false;
	          }
	          if (shouldUpdate && currentInput !== value) {
	            currentInput = value;
	            persistInput('input', currentInput);
	            doUpdate('input');
	          }
	          if (shouldUpdate && currentIntent !== value) {
	            // preserve intent for keyboard interaction with form fields
	            var activeElem = document.activeElement;
	            var notFormInput = activeElem && activeElem.nodeName && (formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1 || activeElem.nodeName.toLowerCase() === 'button' && !checkClosest(activeElem, 'form'));
	            if (notFormInput) {
	              currentIntent = value;
	              persistInput('intent', currentIntent);
	              doUpdate('intent');
	            }
	          }
	        };

	        // updates the doc and `inputTypes` array with new input
	        var doUpdate = function doUpdate(which) {
	          docElem.setAttribute('data-what' + which, which === 'input' ? currentInput : currentIntent);
	          fireFunctions(which);
	        };

	        // updates input intent for `mousemove` and `pointermove`
	        var setIntent = function setIntent(event) {
	          var value = inputMap[event.type];
	          if (value === 'pointer') {
	            value = pointerType(event);
	          }

	          // test to see if `mousemove` happened relative to the screen to detect scrolling versus mousemove
	          detectScrolling(event);

	          // only execute if scrolling isn't happening
	          if ((!isScrolling && !validateTouch(value) || isScrolling && event.type === 'wheel' || event.type === 'mousewheel' || event.type === 'DOMMouseScroll') && currentIntent !== value) {
	            currentIntent = value;
	            persistInput('intent', currentIntent);
	            doUpdate('intent');
	          }
	        };
	        var setElement = function setElement(event) {
	          if (!event.target.nodeName) {
	            // If nodeName is undefined, clear the element
	            // This can happen if click inside an <svg> element.
	            clearElement();
	            return;
	          }
	          currentElement = event.target.nodeName.toLowerCase();
	          docElem.setAttribute('data-whatelement', currentElement);
	          if (event.target.classList && event.target.classList.length) {
	            docElem.setAttribute('data-whatclasses', event.target.classList.toString().replace(' ', ','));
	          }
	        };
	        var clearElement = function clearElement() {
	          currentElement = null;
	          docElem.removeAttribute('data-whatelement');
	          docElem.removeAttribute('data-whatclasses');
	        };
	        var persistInput = function persistInput(which, value) {
	          if (shouldPersist) {
	            try {
	              window.sessionStorage.setItem('what-' + which, value);
	            } catch (e) {
	              // fail silently
	            }
	          }
	        };

	        /*
	         * utilities
	         */

	        var pointerType = function pointerType(event) {
	          if (typeof event.pointerType === 'number') {
	            return pointerMap[event.pointerType];
	          } else {
	            // treat pen like touch
	            return event.pointerType === 'pen' ? 'touch' : event.pointerType;
	          }
	        };

	        // prevent touch detection from being overridden by event execution order
	        var validateTouch = function validateTouch(value) {
	          var timestamp = Date.now();
	          var touchIsValid = value === 'mouse' && currentInput === 'touch' && timestamp - currentTimestamp < 200;
	          currentTimestamp = timestamp;
	          return touchIsValid;
	        };

	        // detect version of mouse wheel event to use
	        // via https://developer.mozilla.org/en-US/docs/Web/API/Element/wheel_event
	        var detectWheel = function detectWheel() {
	          var wheelType = null;

	          // Modern browsers support "wheel"
	          if ('onwheel' in document.createElement('div')) {
	            wheelType = 'wheel';
	          } else {
	            // Webkit and IE support at least "mousewheel"
	            // or assume that remaining browsers are older Firefox
	            wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
	          }
	          return wheelType;
	        };

	        // runs callback functions
	        var fireFunctions = function fireFunctions(type) {
	          for (var i = 0, len = functionList.length; i < len; i++) {
	            if (functionList[i].type === type) {
	              functionList[i].fn.call(undefined, type === 'input' ? currentInput : currentIntent);
	            }
	          }
	        };

	        // finds matching element in an object
	        var objPos = function objPos(match) {
	          for (var i = 0, len = functionList.length; i < len; i++) {
	            if (functionList[i].fn === match) {
	              return i;
	            }
	          }
	        };
	        var detectScrolling = function detectScrolling(event) {
	          if (mousePos.x !== event.screenX || mousePos.y !== event.screenY) {
	            isScrolling = false;
	            mousePos.x = event.screenX;
	            mousePos.y = event.screenY;
	          } else {
	            isScrolling = true;
	          }
	        };

	        // manual version of `closest()`
	        var checkClosest = function checkClosest(elem, tag) {
	          var ElementPrototype = window.Element.prototype;
	          if (!ElementPrototype.matches) {
	            ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.webkitMatchesSelector;
	          }
	          if (!ElementPrototype.closest) {
	            do {
	              if (elem.matches(tag)) {
	                return elem;
	              }
	              elem = elem.parentElement || elem.parentNode;
	            } while (elem !== null && elem.nodeType === 1);
	            return null;
	          } else {
	            return elem.closest(tag);
	          }
	        };

	        /*
	         * init
	         */

	        // don't start script unless browser cuts the mustard
	        // (also passes if polyfills are used)
	        if ('addEventListener' in window && Array.prototype.indexOf) {
	          setUp();
	        }

	        /*
	         * api
	         */

	        return {
	          // returns string: the current input type
	          // opt: 'intent'|'input'
	          // 'input' (default): returns the same value as the `data-whatinput` attribute
	          // 'intent': includes `data-whatintent` value if it's different than `data-whatinput`
	          ask: function ask(opt) {
	            return opt === 'intent' ? currentIntent : currentInput;
	          },
	          // returns string: the currently focused element or null
	          element: function element() {
	            return currentElement;
	          },
	          // overwrites ignored keys with provided array
	          ignoreKeys: function ignoreKeys(arr) {
	            ignoreMap = arr;
	          },
	          // overwrites specific char keys to update on
	          specificKeys: function specificKeys(arr) {
	            specificMap = arr;
	          },
	          // attach functions to input and intent "events"
	          // funct: function to fire on change
	          // eventType: 'input'|'intent'
	          registerOnChange: function registerOnChange(fn, eventType) {
	            functionList.push({
	              fn: fn,
	              type: eventType || 'input'
	            });
	          },
	          unRegisterOnChange: function unRegisterOnChange(fn) {
	            var position = objPos(fn);
	            if (position || position === 0) {
	              functionList.splice(position, 1);
	            }
	          },
	          clearStorage: function clearStorage() {
	            window.sessionStorage.clear();
	          }
	        };
	      }();

	      /***/
	    }
	    /******/)]);
	  });
	})(whatInput);

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}

	/*!
	 * Splide.js
	 * Version  : 4.1.4
	 * License  : MIT
	 * Copyright: 2022 Naotoshi Fujita
	 */
	var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
	var CREATED = 1;
	var MOUNTED = 2;
	var IDLE = 3;
	var MOVING = 4;
	var SCROLLING = 5;
	var DRAGGING = 6;
	var DESTROYED = 7;
	var STATES = {
	  CREATED: CREATED,
	  MOUNTED: MOUNTED,
	  IDLE: IDLE,
	  MOVING: MOVING,
	  SCROLLING: SCROLLING,
	  DRAGGING: DRAGGING,
	  DESTROYED: DESTROYED
	};
	function empty(array) {
	  array.length = 0;
	}
	function slice(arrayLike, start, end) {
	  return Array.prototype.slice.call(arrayLike, start, end);
	}
	function apply(func) {
	  return func.bind.apply(func, [null].concat(slice(arguments, 1)));
	}
	var nextTick = setTimeout;
	var noop = function noop() {};
	function raf(func) {
	  return requestAnimationFrame(func);
	}
	function typeOf(type, subject) {
	  return typeof subject === type;
	}
	function isObject$1(subject) {
	  return !isNull(subject) && typeOf("object", subject);
	}
	var isArray = Array.isArray;
	var isFunction = apply(typeOf, "function");
	var isString = apply(typeOf, "string");
	var isUndefined = apply(typeOf, "undefined");
	function isNull(subject) {
	  return subject === null;
	}
	function isHTMLElement(subject) {
	  try {
	    return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
	  } catch (e) {
	    return false;
	  }
	}
	function toArray(value) {
	  return isArray(value) ? value : [value];
	}
	function forEach(values, iteratee) {
	  toArray(values).forEach(iteratee);
	}
	function includes(array, value) {
	  return array.indexOf(value) > -1;
	}
	function push(array, items) {
	  array.push.apply(array, toArray(items));
	  return array;
	}
	function toggleClass(elm, classes, add) {
	  if (elm) {
	    forEach(classes, function (name) {
	      if (name) {
	        elm.classList[add ? "add" : "remove"](name);
	      }
	    });
	  }
	}
	function addClass(elm, classes) {
	  toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
	}
	function append(parent, children) {
	  forEach(children, parent.appendChild.bind(parent));
	}
	function before(nodes, ref) {
	  forEach(nodes, function (node) {
	    var parent = (ref || node).parentNode;
	    if (parent) {
	      parent.insertBefore(node, ref);
	    }
	  });
	}
	function matches(elm, selector) {
	  return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
	}
	function children(parent, selector) {
	  var children2 = parent ? slice(parent.children) : [];
	  return selector ? children2.filter(function (child) {
	    return matches(child, selector);
	  }) : children2;
	}
	function child(parent, selector) {
	  return selector ? children(parent, selector)[0] : parent.firstElementChild;
	}
	var ownKeys = Object.keys;
	function forOwn(object, iteratee, right) {
	  if (object) {
	    (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function (key) {
	      key !== "__proto__" && iteratee(object[key], key);
	    });
	  }
	  return object;
	}
	function assign(object) {
	  slice(arguments, 1).forEach(function (source) {
	    forOwn(source, function (value, key) {
	      object[key] = source[key];
	    });
	  });
	  return object;
	}
	function merge(object) {
	  slice(arguments, 1).forEach(function (source) {
	    forOwn(source, function (value, key) {
	      if (isArray(value)) {
	        object[key] = value.slice();
	      } else if (isObject$1(value)) {
	        object[key] = merge({}, isObject$1(object[key]) ? object[key] : {}, value);
	      } else {
	        object[key] = value;
	      }
	    });
	  });
	  return object;
	}
	function omit(object, keys) {
	  forEach(keys || ownKeys(object), function (key) {
	    delete object[key];
	  });
	}
	function removeAttribute(elms, attrs) {
	  forEach(elms, function (elm) {
	    forEach(attrs, function (attr) {
	      elm && elm.removeAttribute(attr);
	    });
	  });
	}
	function setAttribute(elms, attrs, value) {
	  if (isObject$1(attrs)) {
	    forOwn(attrs, function (value2, name) {
	      setAttribute(elms, name, value2);
	    });
	  } else {
	    forEach(elms, function (elm) {
	      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
	    });
	  }
	}
	function create(tag, attrs, parent) {
	  var elm = document.createElement(tag);
	  if (attrs) {
	    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
	  }
	  parent && append(parent, elm);
	  return elm;
	}
	function style(elm, prop, value) {
	  if (isUndefined(value)) {
	    return getComputedStyle(elm)[prop];
	  }
	  if (!isNull(value)) {
	    elm.style[prop] = "" + value;
	  }
	}
	function display(elm, display2) {
	  style(elm, "display", display2);
	}
	function focus(elm) {
	  elm["setActive"] && elm["setActive"]() || elm.focus({
	    preventScroll: true
	  });
	}
	function getAttribute(elm, attr) {
	  return elm.getAttribute(attr);
	}
	function hasClass(elm, className) {
	  return elm && elm.classList.contains(className);
	}
	function rect(target) {
	  return target.getBoundingClientRect();
	}
	function remove(nodes) {
	  forEach(nodes, function (node) {
	    if (node && node.parentNode) {
	      node.parentNode.removeChild(node);
	    }
	  });
	}
	function parseHtml(html) {
	  return child(new DOMParser().parseFromString(html, "text/html").body);
	}
	function prevent(e, stopPropagation) {
	  e.preventDefault();
	  if (stopPropagation) {
	    e.stopPropagation();
	    e.stopImmediatePropagation();
	  }
	}
	function query(parent, selector) {
	  return parent && parent.querySelector(selector);
	}
	function queryAll(parent, selector) {
	  return selector ? slice(parent.querySelectorAll(selector)) : [];
	}
	function removeClass(elm, classes) {
	  toggleClass(elm, classes, false);
	}
	function timeOf(e) {
	  return e.timeStamp;
	}
	function unit(value) {
	  return isString(value) ? value : value ? value + "px" : "";
	}
	var PROJECT_CODE = "splide";
	var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
	  }
	}
	var min = Math.min,
	  max = Math.max,
	  floor = Math.floor,
	  ceil = Math.ceil,
	  abs = Math.abs;
	function approximatelyEqual(x, y, epsilon) {
	  return abs(x - y) < epsilon;
	}
	function between(number, x, y, exclusive) {
	  var minimum = min(x, y);
	  var maximum = max(x, y);
	  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
	}
	function clamp$1(number, x, y) {
	  var minimum = min(x, y);
	  var maximum = max(x, y);
	  return min(max(minimum, number), maximum);
	}
	function sign(x) {
	  return +(x > 0) - +(x < 0);
	}
	function format(string, replacements) {
	  forEach(replacements, function (replacement) {
	    string = string.replace("%s", "" + replacement);
	  });
	  return string;
	}
	function pad(number) {
	  return number < 10 ? "0" + number : "" + number;
	}
	var ids = {};
	function uniqueId(prefix) {
	  return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
	}
	function EventBinder() {
	  var listeners = [];
	  function bind(targets, events, callback, options) {
	    forEachEvent(targets, events, function (target, event, namespace) {
	      var isEventTarget = "addEventListener" in target;
	      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
	      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
	      listeners.push([target, event, namespace, callback, remover]);
	    });
	  }
	  function unbind(targets, events, callback) {
	    forEachEvent(targets, events, function (target, event, namespace) {
	      listeners = listeners.filter(function (listener) {
	        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
	          listener[4]();
	          return false;
	        }
	        return true;
	      });
	    });
	  }
	  function dispatch(target, type, detail) {
	    var e;
	    var bubbles = true;
	    if (typeof CustomEvent === "function") {
	      e = new CustomEvent(type, {
	        bubbles: bubbles,
	        detail: detail
	      });
	    } else {
	      e = document.createEvent("CustomEvent");
	      e.initCustomEvent(type, bubbles, false, detail);
	    }
	    target.dispatchEvent(e);
	    return e;
	  }
	  function forEachEvent(targets, events, iteratee) {
	    forEach(targets, function (target) {
	      target && forEach(events, function (events2) {
	        events2.split(" ").forEach(function (eventNS) {
	          var fragment = eventNS.split(".");
	          iteratee(target, fragment[0], fragment[1]);
	        });
	      });
	    });
	  }
	  function destroy() {
	    listeners.forEach(function (data) {
	      data[4]();
	    });
	    empty(listeners);
	  }
	  return {
	    bind: bind,
	    unbind: unbind,
	    dispatch: dispatch,
	    destroy: destroy
	  };
	}
	var EVENT_MOUNTED = "mounted";
	var EVENT_READY = "ready";
	var EVENT_MOVE = "move";
	var EVENT_MOVED = "moved";
	var EVENT_CLICK = "click";
	var EVENT_ACTIVE = "active";
	var EVENT_INACTIVE = "inactive";
	var EVENT_VISIBLE = "visible";
	var EVENT_HIDDEN = "hidden";
	var EVENT_REFRESH = "refresh";
	var EVENT_UPDATED = "updated";
	var EVENT_RESIZE = "resize";
	var EVENT_RESIZED = "resized";
	var EVENT_DRAG = "drag";
	var EVENT_DRAGGING = "dragging";
	var EVENT_DRAGGED = "dragged";
	var EVENT_SCROLL = "scroll";
	var EVENT_SCROLLED = "scrolled";
	var EVENT_OVERFLOW = "overflow";
	var EVENT_DESTROY = "destroy";
	var EVENT_ARROWS_MOUNTED = "arrows:mounted";
	var EVENT_ARROWS_UPDATED = "arrows:updated";
	var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
	var EVENT_PAGINATION_UPDATED = "pagination:updated";
	var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
	var EVENT_AUTOPLAY_PLAY = "autoplay:play";
	var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
	var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
	var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
	var EVENT_SLIDE_KEYDOWN = "sk";
	var EVENT_SHIFTED = "sh";
	var EVENT_END_INDEX_CHANGED = "ei";
	function EventInterface(Splide2) {
	  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
	  var binder = EventBinder();
	  function on(events, callback) {
	    binder.bind(bus, toArray(events).join(" "), function (e) {
	      callback.apply(callback, isArray(e.detail) ? e.detail : []);
	    });
	  }
	  function emit(event) {
	    binder.dispatch(bus, event, slice(arguments, 1));
	  }
	  if (Splide2) {
	    Splide2.event.on(EVENT_DESTROY, binder.destroy);
	  }
	  return assign(binder, {
	    bus: bus,
	    on: on,
	    off: apply(binder.unbind, bus),
	    emit: emit
	  });
	}
	function RequestInterval(interval, onInterval, onUpdate, limit) {
	  var now = Date.now;
	  var startTime;
	  var rate = 0;
	  var id;
	  var paused = true;
	  var count = 0;
	  function update() {
	    if (!paused) {
	      rate = interval ? min((now() - startTime) / interval, 1) : 1;
	      onUpdate && onUpdate(rate);
	      if (rate >= 1) {
	        onInterval();
	        startTime = now();
	        if (limit && ++count >= limit) {
	          return pause();
	        }
	      }
	      id = raf(update);
	    }
	  }
	  function start(resume) {
	    resume || cancel();
	    startTime = now() - (resume ? rate * interval : 0);
	    paused = false;
	    id = raf(update);
	  }
	  function pause() {
	    paused = true;
	  }
	  function rewind() {
	    startTime = now();
	    rate = 0;
	    if (onUpdate) {
	      onUpdate(rate);
	    }
	  }
	  function cancel() {
	    id && cancelAnimationFrame(id);
	    rate = 0;
	    id = 0;
	    paused = true;
	  }
	  function set(time) {
	    interval = time;
	  }
	  function isPaused() {
	    return paused;
	  }
	  return {
	    start: start,
	    rewind: rewind,
	    pause: pause,
	    cancel: cancel,
	    set: set,
	    isPaused: isPaused
	  };
	}
	function State(initialState) {
	  var state = initialState;
	  function set(value) {
	    state = value;
	  }
	  function is(states) {
	    return includes(toArray(states), state);
	  }
	  return {
	    set: set,
	    is: is
	  };
	}
	function Throttle(func, duration) {
	  var interval = RequestInterval(0, func, null, 1);
	  return function () {
	    interval.isPaused() && interval.start();
	  };
	}
	function Media(Splide2, Components2, options) {
	  var state = Splide2.state;
	  var breakpoints = options.breakpoints || {};
	  var reducedMotion = options.reducedMotion || {};
	  var binder = EventBinder();
	  var queries = [];
	  function setup() {
	    var isMin = options.mediaQuery === "min";
	    ownKeys(breakpoints).sort(function (n, m) {
	      return isMin ? +n - +m : +m - +n;
	    }).forEach(function (key) {
	      register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
	    });
	    register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
	    update();
	  }
	  function destroy(completely) {
	    if (completely) {
	      binder.destroy();
	    }
	  }
	  function register(options2, query) {
	    var queryList = matchMedia(query);
	    binder.bind(queryList, "change", update);
	    queries.push([options2, queryList]);
	  }
	  function update() {
	    var destroyed = state.is(DESTROYED);
	    var direction = options.direction;
	    var merged = queries.reduce(function (merged2, entry) {
	      return merge(merged2, entry[1].matches ? entry[0] : {});
	    }, {});
	    omit(options);
	    set(merged);
	    if (options.destroy) {
	      Splide2.destroy(options.destroy === "completely");
	    } else if (destroyed) {
	      destroy(true);
	      Splide2.mount();
	    } else {
	      direction !== options.direction && Splide2.refresh();
	    }
	  }
	  function reduce(enable) {
	    if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
	      enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
	    }
	  }
	  function set(opts, base, notify) {
	    merge(options, opts);
	    base && merge(Object.getPrototypeOf(options), opts);
	    if (notify || !state.is(CREATED)) {
	      Splide2.emit(EVENT_UPDATED, options);
	    }
	  }
	  return {
	    setup: setup,
	    destroy: destroy,
	    reduce: reduce,
	    set: set
	  };
	}
	var ARROW = "Arrow";
	var ARROW_LEFT = ARROW + "Left";
	var ARROW_RIGHT = ARROW + "Right";
	var ARROW_UP = ARROW + "Up";
	var ARROW_DOWN = ARROW + "Down";
	var RTL = "rtl";
	var TTB = "ttb";
	var ORIENTATION_MAP = {
	  width: ["height"],
	  left: ["top", "right"],
	  right: ["bottom", "left"],
	  x: ["y"],
	  X: ["Y"],
	  Y: ["X"],
	  ArrowLeft: [ARROW_UP, ARROW_RIGHT],
	  ArrowRight: [ARROW_DOWN, ARROW_LEFT]
	};
	function Direction(Splide2, Components2, options) {
	  function resolve(prop, axisOnly, direction) {
	    direction = direction || options.direction;
	    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
	    return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function (match, offset) {
	      var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
	      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
	    });
	  }
	  function orient(value) {
	    return value * (options.direction === RTL ? 1 : -1);
	  }
	  return {
	    resolve: resolve,
	    orient: orient
	  };
	}
	var ROLE = "role";
	var TAB_INDEX = "tabindex";
	var DISABLED = "disabled";
	var ARIA_PREFIX = "aria-";
	var ARIA_CONTROLS = ARIA_PREFIX + "controls";
	var ARIA_CURRENT = ARIA_PREFIX + "current";
	var ARIA_SELECTED = ARIA_PREFIX + "selected";
	var ARIA_LABEL = ARIA_PREFIX + "label";
	var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
	var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
	var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
	var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
	var ARIA_LIVE = ARIA_PREFIX + "live";
	var ARIA_BUSY = ARIA_PREFIX + "busy";
	var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
	var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
	var CLASS_PREFIX = PROJECT_CODE + "__";
	var STATUS_CLASS_PREFIX = "is-";
	var CLASS_ROOT = PROJECT_CODE;
	var CLASS_TRACK = CLASS_PREFIX + "track";
	var CLASS_LIST = CLASS_PREFIX + "list";
	var CLASS_SLIDE = CLASS_PREFIX + "slide";
	var CLASS_CLONE = CLASS_SLIDE + "--clone";
	var CLASS_CONTAINER = CLASS_SLIDE + "__container";
	var CLASS_ARROWS = CLASS_PREFIX + "arrows";
	var CLASS_ARROW = CLASS_PREFIX + "arrow";
	var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
	var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
	var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
	var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
	var CLASS_PROGRESS = CLASS_PREFIX + "progress";
	var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
	var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
	var CLASS_SPINNER = CLASS_PREFIX + "spinner";
	var CLASS_SR = CLASS_PREFIX + "sr";
	var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
	var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
	var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
	var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
	var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
	var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
	var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
	var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
	var STATUS_CLASSES$1 = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
	var CLASSES = {
	  slide: CLASS_SLIDE,
	  clone: CLASS_CLONE,
	  arrows: CLASS_ARROWS,
	  arrow: CLASS_ARROW,
	  prev: CLASS_ARROW_PREV,
	  next: CLASS_ARROW_NEXT,
	  pagination: CLASS_PAGINATION,
	  page: CLASS_PAGINATION_PAGE,
	  spinner: CLASS_SPINNER
	};
	function closest(from, selector) {
	  if (isFunction(from.closest)) {
	    return from.closest(selector);
	  }
	  var elm = from;
	  while (elm && elm.nodeType === 1) {
	    if (matches(elm, selector)) {
	      break;
	    }
	    elm = elm.parentElement;
	  }
	  return elm;
	}
	var FRICTION = 5;
	var LOG_INTERVAL = 200;
	var POINTER_DOWN_EVENTS = "touchstart mousedown";
	var POINTER_MOVE_EVENTS = "touchmove mousemove";
	var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
	function Elements(Splide2, Components2, options) {
	  var _EventInterface = EventInterface(Splide2),
	    on = _EventInterface.on,
	    bind = _EventInterface.bind;
	  var root = Splide2.root;
	  var i18n = options.i18n;
	  var elements = {};
	  var slides = [];
	  var rootClasses = [];
	  var trackClasses = [];
	  var track;
	  var list;
	  var isUsingKey;
	  function setup() {
	    collect();
	    init();
	    update();
	  }
	  function mount() {
	    on(EVENT_REFRESH, destroy);
	    on(EVENT_REFRESH, setup);
	    on(EVENT_UPDATED, update);
	    bind(document, POINTER_DOWN_EVENTS + " keydown", function (e) {
	      isUsingKey = e.type === "keydown";
	    }, {
	      capture: true
	    });
	    bind(root, "focusin", function () {
	      toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
	    });
	  }
	  function destroy(completely) {
	    var attrs = ALL_ATTRIBUTES.concat("style");
	    empty(slides);
	    removeClass(root, rootClasses);
	    removeClass(track, trackClasses);
	    removeAttribute([track, list], attrs);
	    removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
	  }
	  function update() {
	    removeClass(root, rootClasses);
	    removeClass(track, trackClasses);
	    rootClasses = getClasses(CLASS_ROOT);
	    trackClasses = getClasses(CLASS_TRACK);
	    addClass(root, rootClasses);
	    addClass(track, trackClasses);
	    setAttribute(root, ARIA_LABEL, options.label);
	    setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
	  }
	  function collect() {
	    track = find("." + CLASS_TRACK);
	    list = child(track, "." + CLASS_LIST);
	    assert(track && list, "A track/list element is missing.");
	    push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
	    forOwn({
	      arrows: CLASS_ARROWS,
	      pagination: CLASS_PAGINATION,
	      prev: CLASS_ARROW_PREV,
	      next: CLASS_ARROW_NEXT,
	      bar: CLASS_PROGRESS_BAR,
	      toggle: CLASS_TOGGLE
	    }, function (className, key) {
	      elements[key] = find("." + className);
	    });
	    assign(elements, {
	      root: root,
	      track: track,
	      list: list,
	      slides: slides
	    });
	  }
	  function init() {
	    var id = root.id || uniqueId(PROJECT_CODE);
	    var role = options.role;
	    root.id = id;
	    track.id = track.id || id + "-track";
	    list.id = list.id || id + "-list";
	    if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
	      setAttribute(root, ROLE, role);
	    }
	    setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
	    setAttribute(list, ROLE, "presentation");
	  }
	  function find(selector) {
	    var elm = query(root, selector);
	    return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
	  }
	  function getClasses(base) {
	    return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
	  }
	  return assign(elements, {
	    setup: setup,
	    mount: mount,
	    destroy: destroy
	  });
	}
	var SLIDE = "slide";
	var LOOP = "loop";
	var FADE = "fade";
	function Slide$1(Splide2, index, slideIndex, slide) {
	  var event = EventInterface(Splide2);
	  var on = event.on,
	    emit = event.emit,
	    bind = event.bind;
	  var Components = Splide2.Components,
	    root = Splide2.root,
	    options = Splide2.options;
	  var isNavigation = options.isNavigation,
	    updateOnMove = options.updateOnMove,
	    i18n = options.i18n,
	    pagination = options.pagination,
	    slideFocus = options.slideFocus;
	  var resolve = Components.Direction.resolve;
	  var styles = getAttribute(slide, "style");
	  var label = getAttribute(slide, ARIA_LABEL);
	  var isClone = slideIndex > -1;
	  var container = child(slide, "." + CLASS_CONTAINER);
	  var destroyed;
	  function mount() {
	    if (!isClone) {
	      slide.id = root.id + "-slide" + pad(index + 1);
	      setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
	      setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
	      setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
	    }
	    listen();
	  }
	  function listen() {
	    bind(slide, "click", apply(emit, EVENT_CLICK, self));
	    bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self));
	    on([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
	    on(EVENT_NAVIGATION_MOUNTED, initNavigation);
	    if (updateOnMove) {
	      on(EVENT_MOVE, onMove);
	    }
	  }
	  function destroy() {
	    destroyed = true;
	    event.destroy();
	    removeClass(slide, STATUS_CLASSES$1);
	    removeAttribute(slide, ALL_ATTRIBUTES);
	    setAttribute(slide, "style", styles);
	    setAttribute(slide, ARIA_LABEL, label || "");
	  }
	  function initNavigation() {
	    var controls = Splide2.splides.map(function (target) {
	      var Slide2 = target.splide.Components.Slides.getAt(index);
	      return Slide2 ? Slide2.slide.id : "";
	    }).join(" ");
	    setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
	    setAttribute(slide, ARIA_CONTROLS, controls);
	    setAttribute(slide, ROLE, slideFocus ? "button" : "");
	    slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
	  }
	  function onMove() {
	    if (!destroyed) {
	      update();
	    }
	  }
	  function update() {
	    if (!destroyed) {
	      var curr = Splide2.index;
	      updateActivity();
	      updateVisibility();
	      toggleClass(slide, CLASS_PREV, index === curr - 1);
	      toggleClass(slide, CLASS_NEXT, index === curr + 1);
	    }
	  }
	  function updateActivity() {
	    var active = isActive();
	    if (active !== hasClass(slide, CLASS_ACTIVE)) {
	      toggleClass(slide, CLASS_ACTIVE, active);
	      setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
	      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self);
	    }
	  }
	  function updateVisibility() {
	    var visible = isVisible();
	    var hidden = !visible && (!isActive() || isClone);
	    if (!Splide2.state.is([MOVING, SCROLLING])) {
	      setAttribute(slide, ARIA_HIDDEN, hidden || "");
	    }
	    setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
	    if (slideFocus) {
	      setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
	    }
	    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
	      toggleClass(slide, CLASS_VISIBLE, visible);
	      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self);
	    }
	    if (!visible && document.activeElement === slide) {
	      var Slide2 = Components.Slides.getAt(Splide2.index);
	      Slide2 && focus(Slide2.slide);
	    }
	  }
	  function style$1(prop, value, useContainer) {
	    style(useContainer && container || slide, prop, value);
	  }
	  function isActive() {
	    var curr = Splide2.index;
	    return curr === index || options.cloneStatus && curr === slideIndex;
	  }
	  function isVisible() {
	    if (Splide2.is(FADE)) {
	      return isActive();
	    }
	    var trackRect = rect(Components.Elements.track);
	    var slideRect = rect(slide);
	    var left = resolve("left", true);
	    var right = resolve("right", true);
	    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
	  }
	  function isWithin(from, distance) {
	    var diff = abs(from - index);
	    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
	      diff = min(diff, Splide2.length - diff);
	    }
	    return diff <= distance;
	  }
	  var self = {
	    index: index,
	    slideIndex: slideIndex,
	    slide: slide,
	    container: container,
	    isClone: isClone,
	    mount: mount,
	    destroy: destroy,
	    update: update,
	    style: style$1,
	    isWithin: isWithin
	  };
	  return self;
	}
	function Slides(Splide2, Components2, options) {
	  var _EventInterface2 = EventInterface(Splide2),
	    on = _EventInterface2.on,
	    emit = _EventInterface2.emit,
	    bind = _EventInterface2.bind;
	  var _Components2$Elements = Components2.Elements,
	    slides = _Components2$Elements.slides,
	    list = _Components2$Elements.list;
	  var Slides2 = [];
	  function mount() {
	    init();
	    on(EVENT_REFRESH, destroy);
	    on(EVENT_REFRESH, init);
	  }
	  function init() {
	    slides.forEach(function (slide, index) {
	      register(slide, index, -1);
	    });
	  }
	  function destroy() {
	    forEach$1(function (Slide2) {
	      Slide2.destroy();
	    });
	    empty(Slides2);
	  }
	  function update() {
	    forEach$1(function (Slide2) {
	      Slide2.update();
	    });
	  }
	  function register(slide, index, slideIndex) {
	    var object = Slide$1(Splide2, index, slideIndex, slide);
	    object.mount();
	    Slides2.push(object);
	    Slides2.sort(function (Slide1, Slide2) {
	      return Slide1.index - Slide2.index;
	    });
	  }
	  function get(excludeClones) {
	    return excludeClones ? filter(function (Slide2) {
	      return !Slide2.isClone;
	    }) : Slides2;
	  }
	  function getIn(page) {
	    var Controller = Components2.Controller;
	    var index = Controller.toIndex(page);
	    var max = Controller.hasFocus() ? 1 : options.perPage;
	    return filter(function (Slide2) {
	      return between(Slide2.index, index, index + max - 1);
	    });
	  }
	  function getAt(index) {
	    return filter(index)[0];
	  }
	  function add(items, index) {
	    forEach(items, function (slide) {
	      if (isString(slide)) {
	        slide = parseHtml(slide);
	      }
	      if (isHTMLElement(slide)) {
	        var ref = slides[index];
	        ref ? before(slide, ref) : append(list, slide);
	        addClass(slide, options.classes.slide);
	        observeImages(slide, apply(emit, EVENT_RESIZE));
	      }
	    });
	    emit(EVENT_REFRESH);
	  }
	  function remove$1(matcher) {
	    remove(filter(matcher).map(function (Slide2) {
	      return Slide2.slide;
	    }));
	    emit(EVENT_REFRESH);
	  }
	  function forEach$1(iteratee, excludeClones) {
	    get(excludeClones).forEach(iteratee);
	  }
	  function filter(matcher) {
	    return Slides2.filter(isFunction(matcher) ? matcher : function (Slide2) {
	      return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
	    });
	  }
	  function style(prop, value, useContainer) {
	    forEach$1(function (Slide2) {
	      Slide2.style(prop, value, useContainer);
	    });
	  }
	  function observeImages(elm, callback) {
	    var images = queryAll(elm, "img");
	    var length = images.length;
	    if (length) {
	      images.forEach(function (img) {
	        bind(img, "load error", function () {
	          if (! --length) {
	            callback();
	          }
	        });
	      });
	    } else {
	      callback();
	    }
	  }
	  function getLength(excludeClones) {
	    return excludeClones ? slides.length : Slides2.length;
	  }
	  function isEnough() {
	    return Slides2.length > options.perPage;
	  }
	  return {
	    mount: mount,
	    destroy: destroy,
	    update: update,
	    register: register,
	    get: get,
	    getIn: getIn,
	    getAt: getAt,
	    add: add,
	    remove: remove$1,
	    forEach: forEach$1,
	    filter: filter,
	    style: style,
	    getLength: getLength,
	    isEnough: isEnough
	  };
	}
	function Layout(Splide2, Components2, options) {
	  var _EventInterface3 = EventInterface(Splide2),
	    on = _EventInterface3.on,
	    bind = _EventInterface3.bind,
	    emit = _EventInterface3.emit;
	  var Slides = Components2.Slides;
	  var resolve = Components2.Direction.resolve;
	  var _Components2$Elements2 = Components2.Elements,
	    root = _Components2$Elements2.root,
	    track = _Components2$Elements2.track,
	    list = _Components2$Elements2.list;
	  var getAt = Slides.getAt,
	    styleSlides = Slides.style;
	  var vertical;
	  var rootRect;
	  var overflow;
	  function mount() {
	    init();
	    bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
	    on([EVENT_UPDATED, EVENT_REFRESH], init);
	    on(EVENT_RESIZE, resize);
	  }
	  function init() {
	    vertical = options.direction === TTB;
	    style(root, "maxWidth", unit(options.width));
	    style(track, resolve("paddingLeft"), cssPadding(false));
	    style(track, resolve("paddingRight"), cssPadding(true));
	    resize(true);
	  }
	  function resize(force) {
	    var newRect = rect(root);
	    if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
	      style(track, "height", cssTrackHeight());
	      styleSlides(resolve("marginRight"), unit(options.gap));
	      styleSlides("width", cssSlideWidth());
	      styleSlides("height", cssSlideHeight(), true);
	      rootRect = newRect;
	      emit(EVENT_RESIZED);
	      if (overflow !== (overflow = isOverflow())) {
	        toggleClass(root, CLASS_OVERFLOW, overflow);
	        emit(EVENT_OVERFLOW, overflow);
	      }
	    }
	  }
	  function cssPadding(right) {
	    var padding = options.padding;
	    var prop = resolve(right ? "right" : "left");
	    return padding && unit(padding[prop] || (isObject$1(padding) ? 0 : padding)) || "0px";
	  }
	  function cssTrackHeight() {
	    var height = "";
	    if (vertical) {
	      height = cssHeight();
	      assert(height, "height or heightRatio is missing.");
	      height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
	    }
	    return height;
	  }
	  function cssHeight() {
	    return unit(options.height || rect(list).width * options.heightRatio);
	  }
	  function cssSlideWidth() {
	    return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
	  }
	  function cssSlideHeight() {
	    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
	  }
	  function cssSlideSize() {
	    var gap = unit(options.gap);
	    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
	  }
	  function listSize() {
	    return rect(list)[resolve("width")];
	  }
	  function slideSize(index, withoutGap) {
	    var Slide = getAt(index || 0);
	    return Slide ? rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
	  }
	  function totalSize(index, withoutGap) {
	    var Slide = getAt(index);
	    if (Slide) {
	      var right = rect(Slide.slide)[resolve("right")];
	      var left = rect(list)[resolve("left")];
	      return abs(right - left) + (withoutGap ? 0 : getGap());
	    }
	    return 0;
	  }
	  function sliderSize(withoutGap) {
	    return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
	  }
	  function getGap() {
	    var Slide = getAt(0);
	    return Slide && parseFloat(style(Slide.slide, resolve("marginRight"))) || 0;
	  }
	  function getPadding(right) {
	    return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
	  }
	  function isOverflow() {
	    return Splide2.is(FADE) || sliderSize(true) > listSize();
	  }
	  return {
	    mount: mount,
	    resize: resize,
	    listSize: listSize,
	    slideSize: slideSize,
	    sliderSize: sliderSize,
	    totalSize: totalSize,
	    getPadding: getPadding,
	    isOverflow: isOverflow
	  };
	}
	var MULTIPLIER = 2;
	function Clones(Splide2, Components2, options) {
	  var event = EventInterface(Splide2);
	  var on = event.on;
	  var Elements = Components2.Elements,
	    Slides = Components2.Slides;
	  var resolve = Components2.Direction.resolve;
	  var clones = [];
	  var cloneCount;
	  function mount() {
	    on(EVENT_REFRESH, remount);
	    on([EVENT_UPDATED, EVENT_RESIZE], observe);
	    if (cloneCount = computeCloneCount()) {
	      generate(cloneCount);
	      Components2.Layout.resize(true);
	    }
	  }
	  function remount() {
	    destroy();
	    mount();
	  }
	  function destroy() {
	    remove(clones);
	    empty(clones);
	    event.destroy();
	  }
	  function observe() {
	    var count = computeCloneCount();
	    if (cloneCount !== count) {
	      if (cloneCount < count || !count) {
	        event.emit(EVENT_REFRESH);
	      }
	    }
	  }
	  function generate(count) {
	    var slides = Slides.get().slice();
	    var length = slides.length;
	    if (length) {
	      while (slides.length < count) {
	        push(slides, slides);
	      }
	      push(slides.slice(-count), slides.slice(0, count)).forEach(function (Slide, index) {
	        var isHead = index < count;
	        var clone = cloneDeep(Slide.slide, index);
	        isHead ? before(clone, slides[0].slide) : append(Elements.list, clone);
	        push(clones, clone);
	        Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
	      });
	    }
	  }
	  function cloneDeep(elm, index) {
	    var clone = elm.cloneNode(true);
	    addClass(clone, options.classes.clone);
	    clone.id = Splide2.root.id + "-clone" + pad(index + 1);
	    return clone;
	  }
	  function computeCloneCount() {
	    var clones2 = options.clones;
	    if (!Splide2.is(LOOP)) {
	      clones2 = 0;
	    } else if (isUndefined(clones2)) {
	      var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
	      var fixedCount = fixedSize && ceil(rect(Elements.track)[resolve("width")] / fixedSize);
	      clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
	    }
	    return clones2;
	  }
	  return {
	    mount: mount,
	    destroy: destroy
	  };
	}
	function Move(Splide2, Components2, options) {
	  var _EventInterface4 = EventInterface(Splide2),
	    on = _EventInterface4.on,
	    emit = _EventInterface4.emit;
	  var set = Splide2.state.set;
	  var _Components2$Layout = Components2.Layout,
	    slideSize = _Components2$Layout.slideSize,
	    getPadding = _Components2$Layout.getPadding,
	    totalSize = _Components2$Layout.totalSize,
	    listSize = _Components2$Layout.listSize,
	    sliderSize = _Components2$Layout.sliderSize;
	  var _Components2$Directio = Components2.Direction,
	    resolve = _Components2$Directio.resolve,
	    orient = _Components2$Directio.orient;
	  var _Components2$Elements3 = Components2.Elements,
	    list = _Components2$Elements3.list,
	    track = _Components2$Elements3.track;
	  var Transition;
	  function mount() {
	    Transition = Components2.Transition;
	    on([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
	  }
	  function reposition() {
	    if (!Components2.Controller.isBusy()) {
	      Components2.Scroll.cancel();
	      jump(Splide2.index);
	      Components2.Slides.update();
	    }
	  }
	  function move(dest, index, prev, callback) {
	    if (dest !== index && canShift(dest > prev)) {
	      cancel();
	      translate(shift(getPosition(), dest > prev), true);
	    }
	    set(MOVING);
	    emit(EVENT_MOVE, index, prev, dest);
	    Transition.start(index, function () {
	      set(IDLE);
	      emit(EVENT_MOVED, index, prev, dest);
	      callback && callback();
	    });
	  }
	  function jump(index) {
	    translate(toPosition(index, true));
	  }
	  function translate(position, preventLoop) {
	    if (!Splide2.is(FADE)) {
	      var destination = preventLoop ? position : loop(position);
	      style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
	      position !== destination && emit(EVENT_SHIFTED);
	    }
	  }
	  function loop(position) {
	    if (Splide2.is(LOOP)) {
	      var index = toIndex(position);
	      var exceededMax = index > Components2.Controller.getEnd();
	      var exceededMin = index < 0;
	      if (exceededMin || exceededMax) {
	        position = shift(position, exceededMax);
	      }
	    }
	    return position;
	  }
	  function shift(position, backwards) {
	    var excess = position - getLimit(backwards);
	    var size = sliderSize();
	    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
	    return position;
	  }
	  function cancel() {
	    translate(getPosition(), true);
	    Transition.cancel();
	  }
	  function toIndex(position) {
	    var Slides = Components2.Slides.get();
	    var index = 0;
	    var minDistance = Infinity;
	    for (var i = 0; i < Slides.length; i++) {
	      var slideIndex = Slides[i].index;
	      var distance = abs(toPosition(slideIndex, true) - position);
	      if (distance <= minDistance) {
	        minDistance = distance;
	        index = slideIndex;
	      } else {
	        break;
	      }
	    }
	    return index;
	  }
	  function toPosition(index, trimming) {
	    var position = orient(totalSize(index - 1) - offset(index));
	    return trimming ? trim(position) : position;
	  }
	  function getPosition() {
	    var left = resolve("left");
	    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
	  }
	  function trim(position) {
	    if (options.trimSpace && Splide2.is(SLIDE)) {
	      position = clamp$1(position, 0, orient(sliderSize(true) - listSize()));
	    }
	    return position;
	  }
	  function offset(index) {
	    var focus = options.focus;
	    return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
	  }
	  function getLimit(max) {
	    return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
	  }
	  function canShift(backwards) {
	    var shifted = orient(shift(getPosition(), backwards));
	    return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
	  }
	  function exceededLimit(max, position) {
	    position = isUndefined(position) ? getPosition() : position;
	    var exceededMin = max !== true && orient(position) < orient(getLimit(false));
	    var exceededMax = max !== false && orient(position) > orient(getLimit(true));
	    return exceededMin || exceededMax;
	  }
	  return {
	    mount: mount,
	    move: move,
	    jump: jump,
	    translate: translate,
	    shift: shift,
	    cancel: cancel,
	    toIndex: toIndex,
	    toPosition: toPosition,
	    getPosition: getPosition,
	    getLimit: getLimit,
	    exceededLimit: exceededLimit,
	    reposition: reposition
	  };
	}
	function Controller(Splide2, Components2, options) {
	  var _EventInterface5 = EventInterface(Splide2),
	    on = _EventInterface5.on,
	    emit = _EventInterface5.emit;
	  var Move = Components2.Move;
	  var getPosition = Move.getPosition,
	    getLimit = Move.getLimit,
	    toPosition = Move.toPosition;
	  var _Components2$Slides = Components2.Slides,
	    isEnough = _Components2$Slides.isEnough,
	    getLength = _Components2$Slides.getLength;
	  var omitEnd = options.omitEnd;
	  var isLoop = Splide2.is(LOOP);
	  var isSlide = Splide2.is(SLIDE);
	  var getNext = apply(getAdjacent, false);
	  var getPrev = apply(getAdjacent, true);
	  var currIndex = options.start || 0;
	  var endIndex;
	  var prevIndex = currIndex;
	  var slideCount;
	  var perMove;
	  var perPage;
	  function mount() {
	    init();
	    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
	    on(EVENT_RESIZED, onResized);
	  }
	  function init() {
	    slideCount = getLength(true);
	    perMove = options.perMove;
	    perPage = options.perPage;
	    endIndex = getEnd();
	    var index = clamp$1(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
	    if (index !== currIndex) {
	      currIndex = index;
	      Move.reposition();
	    }
	  }
	  function onResized() {
	    if (endIndex !== getEnd()) {
	      emit(EVENT_END_INDEX_CHANGED);
	    }
	  }
	  function go(control, allowSameIndex, callback) {
	    if (!isBusy()) {
	      var dest = parse(control);
	      var index = loop(dest);
	      if (index > -1 && (allowSameIndex || index !== currIndex)) {
	        setIndex(index);
	        Move.move(dest, index, prevIndex, callback);
	      }
	    }
	  }
	  function scroll(destination, duration, snap, callback) {
	    Components2.Scroll.scroll(destination, duration, snap, function () {
	      var index = loop(Move.toIndex(getPosition()));
	      setIndex(omitEnd ? min(index, endIndex) : index);
	      callback && callback();
	    });
	  }
	  function parse(control) {
	    var index = currIndex;
	    if (isString(control)) {
	      var _ref = control.match(/([+\-<>])(\d+)?/) || [],
	        indicator = _ref[1],
	        number = _ref[2];
	      if (indicator === "+" || indicator === "-") {
	        index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
	      } else if (indicator === ">") {
	        index = number ? toIndex(+number) : getNext(true);
	      } else if (indicator === "<") {
	        index = getPrev(true);
	      }
	    } else {
	      index = isLoop ? control : clamp$1(control, 0, endIndex);
	    }
	    return index;
	  }
	  function getAdjacent(prev, destination) {
	    var number = perMove || (hasFocus() ? 1 : perPage);
	    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
	    if (dest === -1 && isSlide) {
	      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
	        return prev ? 0 : endIndex;
	      }
	    }
	    return destination ? dest : loop(dest);
	  }
	  function computeDestIndex(dest, from, snapPage) {
	    if (isEnough() || hasFocus()) {
	      var index = computeMovableDestIndex(dest);
	      if (index !== dest) {
	        from = dest;
	        dest = index;
	        snapPage = false;
	      }
	      if (dest < 0 || dest > endIndex) {
	        if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
	          dest = toIndex(toPage(dest));
	        } else {
	          if (isLoop) {
	            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
	          } else if (options.rewind) {
	            dest = dest < 0 ? endIndex : 0;
	          } else {
	            dest = -1;
	          }
	        }
	      } else {
	        if (snapPage && dest !== from) {
	          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
	        }
	      }
	    } else {
	      dest = -1;
	    }
	    return dest;
	  }
	  function computeMovableDestIndex(dest) {
	    if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
	      var position = getPosition();
	      while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
	        dest < currIndex ? --dest : ++dest;
	      }
	    }
	    return dest;
	  }
	  function loop(index) {
	    return isLoop ? (index + slideCount) % slideCount || 0 : index;
	  }
	  function getEnd() {
	    var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
	    while (omitEnd && end-- > 0) {
	      if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
	        end++;
	        break;
	      }
	    }
	    return clamp$1(end, 0, slideCount - 1);
	  }
	  function toIndex(page) {
	    return clamp$1(hasFocus() ? page : perPage * page, 0, endIndex);
	  }
	  function toPage(index) {
	    return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
	  }
	  function toDest(destination) {
	    var closest = Move.toIndex(destination);
	    return isSlide ? clamp$1(closest, 0, endIndex) : closest;
	  }
	  function setIndex(index) {
	    if (index !== currIndex) {
	      prevIndex = currIndex;
	      currIndex = index;
	    }
	  }
	  function getIndex(prev) {
	    return prev ? prevIndex : currIndex;
	  }
	  function hasFocus() {
	    return !isUndefined(options.focus) || options.isNavigation;
	  }
	  function isBusy() {
	    return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
	  }
	  return {
	    mount: mount,
	    go: go,
	    scroll: scroll,
	    getNext: getNext,
	    getPrev: getPrev,
	    getAdjacent: getAdjacent,
	    getEnd: getEnd,
	    setIndex: setIndex,
	    getIndex: getIndex,
	    toIndex: toIndex,
	    toPage: toPage,
	    toDest: toDest,
	    hasFocus: hasFocus,
	    isBusy: isBusy
	  };
	}
	var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
	var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
	var SIZE = 40;
	function Arrows(Splide2, Components2, options) {
	  var event = EventInterface(Splide2);
	  var on = event.on,
	    bind = event.bind,
	    emit = event.emit;
	  var classes = options.classes,
	    i18n = options.i18n;
	  var Elements = Components2.Elements,
	    Controller = Components2.Controller;
	  var placeholder = Elements.arrows,
	    track = Elements.track;
	  var wrapper = placeholder;
	  var prev = Elements.prev;
	  var next = Elements.next;
	  var created;
	  var wrapperClasses;
	  var arrows = {};
	  function mount() {
	    init();
	    on(EVENT_UPDATED, remount);
	  }
	  function remount() {
	    destroy();
	    mount();
	  }
	  function init() {
	    var enabled = options.arrows;
	    if (enabled && !(prev && next)) {
	      createArrows();
	    }
	    if (prev && next) {
	      assign(arrows, {
	        prev: prev,
	        next: next
	      });
	      display(wrapper, enabled ? "" : "none");
	      addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
	      if (enabled) {
	        listen();
	        update();
	        setAttribute([prev, next], ARIA_CONTROLS, track.id);
	        emit(EVENT_ARROWS_MOUNTED, prev, next);
	      }
	    }
	  }
	  function destroy() {
	    event.destroy();
	    removeClass(wrapper, wrapperClasses);
	    if (created) {
	      remove(placeholder ? [prev, next] : wrapper);
	      prev = next = null;
	    } else {
	      removeAttribute([prev, next], ALL_ATTRIBUTES);
	    }
	  }
	  function listen() {
	    on([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
	    bind(next, "click", apply(go, ">"));
	    bind(prev, "click", apply(go, "<"));
	  }
	  function go(control) {
	    Controller.go(control, true);
	  }
	  function createArrows() {
	    wrapper = placeholder || create("div", classes.arrows);
	    prev = createArrow(true);
	    next = createArrow(false);
	    created = true;
	    append(wrapper, [prev, next]);
	    !placeholder && before(wrapper, track);
	  }
	  function createArrow(prev2) {
	    var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + XML_NAME_SPACE + "\" viewBox=\"0 0 " + SIZE + " " + SIZE + "\" width=\"" + SIZE + "\" height=\"" + SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || PATH) + "\" />";
	    return parseHtml(arrow);
	  }
	  function update() {
	    if (prev && next) {
	      var index = Splide2.index;
	      var prevIndex = Controller.getPrev();
	      var nextIndex = Controller.getNext();
	      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
	      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
	      prev.disabled = prevIndex < 0;
	      next.disabled = nextIndex < 0;
	      setAttribute(prev, ARIA_LABEL, prevLabel);
	      setAttribute(next, ARIA_LABEL, nextLabel);
	      emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
	    }
	  }
	  return {
	    arrows: arrows,
	    mount: mount,
	    destroy: destroy,
	    update: update
	  };
	}
	var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
	function Autoplay(Splide2, Components2, options) {
	  var _EventInterface6 = EventInterface(Splide2),
	    on = _EventInterface6.on,
	    bind = _EventInterface6.bind,
	    emit = _EventInterface6.emit;
	  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
	  var isPaused = interval.isPaused;
	  var Elements = Components2.Elements,
	    _Components2$Elements4 = Components2.Elements,
	    root = _Components2$Elements4.root,
	    toggle = _Components2$Elements4.toggle;
	  var autoplay = options.autoplay;
	  var hovered;
	  var focused;
	  var stopped = autoplay === "pause";
	  function mount() {
	    if (autoplay) {
	      listen();
	      toggle && setAttribute(toggle, ARIA_CONTROLS, Elements.track.id);
	      stopped || play();
	      update();
	    }
	  }
	  function listen() {
	    if (options.pauseOnHover) {
	      bind(root, "mouseenter mouseleave", function (e) {
	        hovered = e.type === "mouseenter";
	        autoToggle();
	      });
	    }
	    if (options.pauseOnFocus) {
	      bind(root, "focusin focusout", function (e) {
	        focused = e.type === "focusin";
	        autoToggle();
	      });
	    }
	    if (toggle) {
	      bind(toggle, "click", function () {
	        stopped ? play() : pause(true);
	      });
	    }
	    on([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
	    on(EVENT_MOVE, onMove);
	  }
	  function play() {
	    if (isPaused() && Components2.Slides.isEnough()) {
	      interval.start(!options.resetProgress);
	      focused = hovered = stopped = false;
	      update();
	      emit(EVENT_AUTOPLAY_PLAY);
	    }
	  }
	  function pause(stop) {
	    if (stop === void 0) {
	      stop = true;
	    }
	    stopped = !!stop;
	    update();
	    if (!isPaused()) {
	      interval.pause();
	      emit(EVENT_AUTOPLAY_PAUSE);
	    }
	  }
	  function autoToggle() {
	    if (!stopped) {
	      hovered || focused ? pause(false) : play();
	    }
	  }
	  function update() {
	    if (toggle) {
	      toggleClass(toggle, CLASS_ACTIVE, !stopped);
	      setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
	    }
	  }
	  function onAnimationFrame(rate) {
	    var bar = Elements.bar;
	    bar && style(bar, "width", rate * 100 + "%");
	    emit(EVENT_AUTOPLAY_PLAYING, rate);
	  }
	  function onMove(index) {
	    var Slide = Components2.Slides.getAt(index);
	    interval.set(Slide && +getAttribute(Slide.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
	  }
	  return {
	    mount: mount,
	    destroy: interval.cancel,
	    play: play,
	    pause: pause,
	    isPaused: isPaused
	  };
	}
	function Cover(Splide2, Components2, options) {
	  var _EventInterface7 = EventInterface(Splide2),
	    on = _EventInterface7.on;
	  function mount() {
	    if (options.cover) {
	      on(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
	      on([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
	    }
	  }
	  function cover(cover2) {
	    Components2.Slides.forEach(function (Slide) {
	      var img = child(Slide.container || Slide.slide, "img");
	      if (img && img.src) {
	        toggle(cover2, img, Slide);
	      }
	    });
	  }
	  function toggle(cover2, img, Slide) {
	    Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
	    display(img, cover2 ? "none" : "");
	  }
	  return {
	    mount: mount,
	    destroy: apply(cover, false)
	  };
	}
	var BOUNCE_DIFF_THRESHOLD = 10;
	var BOUNCE_DURATION = 600;
	var FRICTION_FACTOR = 0.6;
	var BASE_VELOCITY = 1.5;
	var MIN_DURATION = 800;
	function Scroll(Splide2, Components2, options) {
	  var _EventInterface8 = EventInterface(Splide2),
	    on = _EventInterface8.on,
	    emit = _EventInterface8.emit;
	  var set = Splide2.state.set;
	  var Move = Components2.Move;
	  var getPosition = Move.getPosition,
	    getLimit = Move.getLimit,
	    exceededLimit = Move.exceededLimit,
	    translate = Move.translate;
	  var isSlide = Splide2.is(SLIDE);
	  var interval;
	  var callback;
	  var friction = 1;
	  function mount() {
	    on(EVENT_MOVE, clear);
	    on([EVENT_UPDATED, EVENT_REFRESH], cancel);
	  }
	  function scroll(destination, duration, snap, onScrolled, noConstrain) {
	    var from = getPosition();
	    clear();
	    if (snap && (!isSlide || !exceededLimit())) {
	      var size = Components2.Layout.sliderSize();
	      var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
	      destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
	    }
	    var noDistance = approximatelyEqual(from, destination, 1);
	    friction = 1;
	    duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
	    callback = onScrolled;
	    interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
	    set(SCROLLING);
	    emit(EVENT_SCROLL);
	    interval.start();
	  }
	  function onEnd() {
	    set(IDLE);
	    callback && callback();
	    emit(EVENT_SCROLLED);
	  }
	  function update(from, to, noConstrain, rate) {
	    var position = getPosition();
	    var target = from + (to - from) * easing(rate);
	    var diff = (target - position) * friction;
	    translate(position + diff);
	    if (isSlide && !noConstrain && exceededLimit()) {
	      friction *= FRICTION_FACTOR;
	      if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
	        scroll(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
	      }
	    }
	  }
	  function clear() {
	    if (interval) {
	      interval.cancel();
	    }
	  }
	  function cancel() {
	    if (interval && !interval.isPaused()) {
	      clear();
	      onEnd();
	    }
	  }
	  function easing(t) {
	    var easingFunc = options.easingFunc;
	    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
	  }
	  return {
	    mount: mount,
	    destroy: clear,
	    scroll: scroll,
	    cancel: cancel
	  };
	}
	var SCROLL_LISTENER_OPTIONS = {
	  passive: false,
	  capture: true
	};
	function Drag(Splide2, Components2, options) {
	  var _EventInterface9 = EventInterface(Splide2),
	    on = _EventInterface9.on,
	    emit = _EventInterface9.emit,
	    bind = _EventInterface9.bind,
	    unbind = _EventInterface9.unbind;
	  var state = Splide2.state;
	  var Move = Components2.Move,
	    Scroll = Components2.Scroll,
	    Controller = Components2.Controller,
	    track = Components2.Elements.track,
	    reduce = Components2.Media.reduce;
	  var _Components2$Directio2 = Components2.Direction,
	    resolve = _Components2$Directio2.resolve,
	    orient = _Components2$Directio2.orient;
	  var getPosition = Move.getPosition,
	    exceededLimit = Move.exceededLimit;
	  var basePosition;
	  var baseEvent;
	  var prevBaseEvent;
	  var isFree;
	  var dragging;
	  var exceeded = false;
	  var clickPrevented;
	  var disabled;
	  var target;
	  function mount() {
	    bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
	    bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
	    bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
	    bind(track, "click", onClick, {
	      capture: true
	    });
	    bind(track, "dragstart", prevent);
	    on([EVENT_MOUNTED, EVENT_UPDATED], init);
	  }
	  function init() {
	    var drag = options.drag;
	    disable(!drag);
	    isFree = drag === "free";
	  }
	  function onPointerDown(e) {
	    clickPrevented = false;
	    if (!disabled) {
	      var isTouch = isTouchEvent(e);
	      if (isDraggable(e.target) && (isTouch || !e.button)) {
	        if (!Controller.isBusy()) {
	          target = isTouch ? track : window;
	          dragging = state.is([MOVING, SCROLLING]);
	          prevBaseEvent = null;
	          bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
	          bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
	          Move.cancel();
	          Scroll.cancel();
	          save(e);
	        } else {
	          prevent(e, true);
	        }
	      }
	    }
	  }
	  function onPointerMove(e) {
	    if (!state.is(DRAGGING)) {
	      state.set(DRAGGING);
	      emit(EVENT_DRAG);
	    }
	    if (e.cancelable) {
	      if (dragging) {
	        Move.translate(basePosition + constrain(diffCoord(e)));
	        var expired = diffTime(e) > LOG_INTERVAL;
	        var hasExceeded = exceeded !== (exceeded = exceededLimit());
	        if (expired || hasExceeded) {
	          save(e);
	        }
	        clickPrevented = true;
	        emit(EVENT_DRAGGING);
	        prevent(e);
	      } else if (isSliderDirection(e)) {
	        dragging = shouldStart(e);
	        prevent(e);
	      }
	    }
	  }
	  function onPointerUp(e) {
	    if (state.is(DRAGGING)) {
	      state.set(IDLE);
	      emit(EVENT_DRAGGED);
	    }
	    if (dragging) {
	      move(e);
	      prevent(e);
	    }
	    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
	    unbind(target, POINTER_UP_EVENTS, onPointerUp);
	    dragging = false;
	  }
	  function onClick(e) {
	    if (!disabled && clickPrevented) {
	      prevent(e, true);
	    }
	  }
	  function save(e) {
	    prevBaseEvent = baseEvent;
	    baseEvent = e;
	    basePosition = getPosition();
	  }
	  function move(e) {
	    var velocity = computeVelocity(e);
	    var destination = computeDestination(velocity);
	    var rewind = options.rewind && options.rewindByDrag;
	    reduce(false);
	    if (isFree) {
	      Controller.scroll(destination, 0, options.snap);
	    } else if (Splide2.is(FADE)) {
	      Controller.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
	    } else if (Splide2.is(SLIDE) && exceeded && rewind) {
	      Controller.go(exceededLimit(true) ? ">" : "<");
	    } else {
	      Controller.go(Controller.toDest(destination), true);
	    }
	    reduce(true);
	  }
	  function shouldStart(e) {
	    var thresholds = options.dragMinThreshold;
	    var isObj = isObject$1(thresholds);
	    var mouse = isObj && thresholds.mouse || 0;
	    var touch = (isObj ? thresholds.touch : +thresholds) || 10;
	    return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
	  }
	  function isSliderDirection(e) {
	    return abs(diffCoord(e)) > abs(diffCoord(e, true));
	  }
	  function computeVelocity(e) {
	    if (Splide2.is(LOOP) || !exceeded) {
	      var time = diffTime(e);
	      if (time && time < LOG_INTERVAL) {
	        return diffCoord(e) / time;
	      }
	    }
	    return 0;
	  }
	  function computeDestination(velocity) {
	    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
	  }
	  function diffCoord(e, orthogonal) {
	    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
	  }
	  function diffTime(e) {
	    return timeOf(e) - timeOf(getBaseEvent(e));
	  }
	  function getBaseEvent(e) {
	    return baseEvent === e && prevBaseEvent || baseEvent;
	  }
	  function coordOf(e, orthogonal) {
	    return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
	  }
	  function constrain(diff) {
	    return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
	  }
	  function isDraggable(target2) {
	    var noDrag = options.noDrag;
	    return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
	  }
	  function isTouchEvent(e) {
	    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
	  }
	  function isDragging() {
	    return dragging;
	  }
	  function disable(value) {
	    disabled = value;
	  }
	  return {
	    mount: mount,
	    disable: disable,
	    isDragging: isDragging
	  };
	}
	var NORMALIZATION_MAP = {
	  Spacebar: " ",
	  Right: ARROW_RIGHT,
	  Left: ARROW_LEFT,
	  Up: ARROW_UP,
	  Down: ARROW_DOWN
	};
	function normalizeKey(key) {
	  key = isString(key) ? key : key.key;
	  return NORMALIZATION_MAP[key] || key;
	}
	var KEYBOARD_EVENT = "keydown";
	function Keyboard(Splide2, Components2, options) {
	  var _EventInterface10 = EventInterface(Splide2),
	    on = _EventInterface10.on,
	    bind = _EventInterface10.bind,
	    unbind = _EventInterface10.unbind;
	  var root = Splide2.root;
	  var resolve = Components2.Direction.resolve;
	  var target;
	  var disabled;
	  function mount() {
	    init();
	    on(EVENT_UPDATED, destroy);
	    on(EVENT_UPDATED, init);
	    on(EVENT_MOVE, onMove);
	  }
	  function init() {
	    var keyboard = options.keyboard;
	    if (keyboard) {
	      target = keyboard === "global" ? window : root;
	      bind(target, KEYBOARD_EVENT, onKeydown);
	    }
	  }
	  function destroy() {
	    unbind(target, KEYBOARD_EVENT);
	  }
	  function disable(value) {
	    disabled = value;
	  }
	  function onMove() {
	    var _disabled = disabled;
	    disabled = true;
	    nextTick(function () {
	      disabled = _disabled;
	    });
	  }
	  function onKeydown(e) {
	    if (!disabled) {
	      var key = normalizeKey(e);
	      if (key === resolve(ARROW_LEFT)) {
	        Splide2.go("<");
	      } else if (key === resolve(ARROW_RIGHT)) {
	        Splide2.go(">");
	      }
	    }
	  }
	  return {
	    mount: mount,
	    destroy: destroy,
	    disable: disable
	  };
	}
	var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
	var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
	var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
	function LazyLoad(Splide2, Components2, options) {
	  var _EventInterface11 = EventInterface(Splide2),
	    on = _EventInterface11.on,
	    off = _EventInterface11.off,
	    bind = _EventInterface11.bind,
	    emit = _EventInterface11.emit;
	  var isSequential = options.lazyLoad === "sequential";
	  var events = [EVENT_MOVED, EVENT_SCROLLED];
	  var entries = [];
	  function mount() {
	    if (options.lazyLoad) {
	      init();
	      on(EVENT_REFRESH, init);
	    }
	  }
	  function init() {
	    empty(entries);
	    register();
	    if (isSequential) {
	      loadNext();
	    } else {
	      off(events);
	      on(events, check);
	      check();
	    }
	  }
	  function register() {
	    Components2.Slides.forEach(function (Slide) {
	      queryAll(Slide.slide, IMAGE_SELECTOR).forEach(function (img) {
	        var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
	        var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
	        if (src !== img.src || srcset !== img.srcset) {
	          var className = options.classes.spinner;
	          var parent = img.parentElement;
	          var spinner = child(parent, "." + className) || create("span", className, parent);
	          entries.push([img, Slide, spinner]);
	          img.src || display(img, "none");
	        }
	      });
	    });
	  }
	  function check() {
	    entries = entries.filter(function (data) {
	      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
	      return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
	    });
	    entries.length || off(events);
	  }
	  function load(data) {
	    var img = data[0];
	    addClass(data[1].slide, CLASS_LOADING);
	    bind(img, "load error", apply(onLoad, data));
	    setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
	    setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
	    removeAttribute(img, SRC_DATA_ATTRIBUTE);
	    removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
	  }
	  function onLoad(data, e) {
	    var img = data[0],
	      Slide = data[1];
	    removeClass(Slide.slide, CLASS_LOADING);
	    if (e.type !== "error") {
	      remove(data[2]);
	      display(img, "");
	      emit(EVENT_LAZYLOAD_LOADED, img, Slide);
	      emit(EVENT_RESIZE);
	    }
	    isSequential && loadNext();
	  }
	  function loadNext() {
	    entries.length && load(entries.shift());
	  }
	  return {
	    mount: mount,
	    destroy: apply(empty, entries),
	    check: check
	  };
	}
	function Pagination(Splide2, Components2, options) {
	  var event = EventInterface(Splide2);
	  var on = event.on,
	    emit = event.emit,
	    bind = event.bind;
	  var Slides = Components2.Slides,
	    Elements = Components2.Elements,
	    Controller = Components2.Controller;
	  var hasFocus = Controller.hasFocus,
	    getIndex = Controller.getIndex,
	    go = Controller.go;
	  var resolve = Components2.Direction.resolve;
	  var placeholder = Elements.pagination;
	  var items = [];
	  var list;
	  var paginationClasses;
	  function mount() {
	    destroy();
	    on([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
	    var enabled = options.pagination;
	    placeholder && display(placeholder, enabled ? "" : "none");
	    if (enabled) {
	      on([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
	      createPagination();
	      update();
	      emit(EVENT_PAGINATION_MOUNTED, {
	        list: list,
	        items: items
	      }, getAt(Splide2.index));
	    }
	  }
	  function destroy() {
	    if (list) {
	      remove(placeholder ? slice(list.children) : list);
	      removeClass(list, paginationClasses);
	      empty(items);
	      list = null;
	    }
	    event.destroy();
	  }
	  function createPagination() {
	    var length = Splide2.length;
	    var classes = options.classes,
	      i18n = options.i18n,
	      perPage = options.perPage;
	    var max = hasFocus() ? Controller.getEnd() + 1 : ceil(length / perPage);
	    list = placeholder || create("ul", classes.pagination, Elements.track.parentElement);
	    addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
	    setAttribute(list, ROLE, "tablist");
	    setAttribute(list, ARIA_LABEL, i18n.select);
	    setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
	    for (var i = 0; i < max; i++) {
	      var li = create("li", null, list);
	      var button = create("button", {
	        class: classes.page,
	        type: "button"
	      }, li);
	      var controls = Slides.getIn(i).map(function (Slide) {
	        return Slide.slide.id;
	      });
	      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
	      bind(button, "click", apply(onClick, i));
	      if (options.paginationKeyboard) {
	        bind(button, "keydown", apply(onKeydown, i));
	      }
	      setAttribute(li, ROLE, "presentation");
	      setAttribute(button, ROLE, "tab");
	      setAttribute(button, ARIA_CONTROLS, controls.join(" "));
	      setAttribute(button, ARIA_LABEL, format(text, i + 1));
	      setAttribute(button, TAB_INDEX, -1);
	      items.push({
	        li: li,
	        button: button,
	        page: i
	      });
	    }
	  }
	  function onClick(page) {
	    go(">" + page, true);
	  }
	  function onKeydown(page, e) {
	    var length = items.length;
	    var key = normalizeKey(e);
	    var dir = getDirection();
	    var nextPage = -1;
	    if (key === resolve(ARROW_RIGHT, false, dir)) {
	      nextPage = ++page % length;
	    } else if (key === resolve(ARROW_LEFT, false, dir)) {
	      nextPage = (--page + length) % length;
	    } else if (key === "Home") {
	      nextPage = 0;
	    } else if (key === "End") {
	      nextPage = length - 1;
	    }
	    var item = items[nextPage];
	    if (item) {
	      focus(item.button);
	      go(">" + nextPage);
	      prevent(e, true);
	    }
	  }
	  function getDirection() {
	    return options.paginationDirection || options.direction;
	  }
	  function getAt(index) {
	    return items[Controller.toPage(index)];
	  }
	  function update() {
	    var prev = getAt(getIndex(true));
	    var curr = getAt(getIndex());
	    if (prev) {
	      var button = prev.button;
	      removeClass(button, CLASS_ACTIVE);
	      removeAttribute(button, ARIA_SELECTED);
	      setAttribute(button, TAB_INDEX, -1);
	    }
	    if (curr) {
	      var _button = curr.button;
	      addClass(_button, CLASS_ACTIVE);
	      setAttribute(_button, ARIA_SELECTED, true);
	      setAttribute(_button, TAB_INDEX, "");
	    }
	    emit(EVENT_PAGINATION_UPDATED, {
	      list: list,
	      items: items
	    }, prev, curr);
	  }
	  return {
	    items: items,
	    mount: mount,
	    destroy: destroy,
	    getAt: getAt,
	    update: update
	  };
	}
	var TRIGGER_KEYS = [" ", "Enter"];
	function Sync(Splide2, Components2, options) {
	  var isNavigation = options.isNavigation,
	    slideFocus = options.slideFocus;
	  var events = [];
	  function mount() {
	    Splide2.splides.forEach(function (target) {
	      if (!target.isParent) {
	        sync(Splide2, target.splide);
	        sync(target.splide, Splide2);
	      }
	    });
	    if (isNavigation) {
	      navigate();
	    }
	  }
	  function destroy() {
	    events.forEach(function (event) {
	      event.destroy();
	    });
	    empty(events);
	  }
	  function remount() {
	    destroy();
	    mount();
	  }
	  function sync(splide, target) {
	    var event = EventInterface(splide);
	    event.on(EVENT_MOVE, function (index, prev, dest) {
	      target.go(target.is(LOOP) ? dest : index);
	    });
	    events.push(event);
	  }
	  function navigate() {
	    var event = EventInterface(Splide2);
	    var on = event.on;
	    on(EVENT_CLICK, onClick);
	    on(EVENT_SLIDE_KEYDOWN, onKeydown);
	    on([EVENT_MOUNTED, EVENT_UPDATED], update);
	    events.push(event);
	    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
	  }
	  function update() {
	    setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
	  }
	  function onClick(Slide) {
	    Splide2.go(Slide.index);
	  }
	  function onKeydown(Slide, e) {
	    if (includes(TRIGGER_KEYS, normalizeKey(e))) {
	      onClick(Slide);
	      prevent(e);
	    }
	  }
	  return {
	    setup: apply(Components2.Media.set, {
	      slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
	    }, true),
	    mount: mount,
	    destroy: destroy,
	    remount: remount
	  };
	}
	function Wheel(Splide2, Components2, options) {
	  var _EventInterface12 = EventInterface(Splide2),
	    bind = _EventInterface12.bind;
	  var lastTime = 0;
	  function mount() {
	    if (options.wheel) {
	      bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
	    }
	  }
	  function onWheel(e) {
	    if (e.cancelable) {
	      var deltaY = e.deltaY;
	      var backwards = deltaY < 0;
	      var timeStamp = timeOf(e);
	      var _min = options.wheelMinThreshold || 0;
	      var sleep = options.wheelSleep || 0;
	      if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
	        Splide2.go(backwards ? "<" : ">");
	        lastTime = timeStamp;
	      }
	      shouldPrevent(backwards) && prevent(e);
	    }
	  }
	  function shouldPrevent(backwards) {
	    return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
	  }
	  return {
	    mount: mount
	  };
	}
	var SR_REMOVAL_DELAY = 90;
	function Live(Splide2, Components2, options) {
	  var _EventInterface13 = EventInterface(Splide2),
	    on = _EventInterface13.on;
	  var track = Components2.Elements.track;
	  var enabled = options.live && !options.isNavigation;
	  var sr = create("span", CLASS_SR);
	  var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
	  function mount() {
	    if (enabled) {
	      disable(!Components2.Autoplay.isPaused());
	      setAttribute(track, ARIA_ATOMIC, true);
	      sr.textContent = "\u2026";
	      on(EVENT_AUTOPLAY_PLAY, apply(disable, true));
	      on(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
	      on([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
	    }
	  }
	  function toggle(active) {
	    setAttribute(track, ARIA_BUSY, active);
	    if (active) {
	      append(track, sr);
	      interval.start();
	    } else {
	      remove(sr);
	      interval.cancel();
	    }
	  }
	  function destroy() {
	    removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
	    remove(sr);
	  }
	  function disable(disabled) {
	    if (enabled) {
	      setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
	    }
	  }
	  return {
	    mount: mount,
	    disable: disable,
	    destroy: destroy
	  };
	}
	var ComponentConstructors = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  Media: Media,
	  Direction: Direction,
	  Elements: Elements,
	  Slides: Slides,
	  Layout: Layout,
	  Clones: Clones,
	  Move: Move,
	  Controller: Controller,
	  Arrows: Arrows,
	  Autoplay: Autoplay,
	  Cover: Cover,
	  Scroll: Scroll,
	  Drag: Drag,
	  Keyboard: Keyboard,
	  LazyLoad: LazyLoad,
	  Pagination: Pagination,
	  Sync: Sync,
	  Wheel: Wheel,
	  Live: Live
	});
	var I18N = {
	  prev: "Previous slide",
	  next: "Next slide",
	  first: "Go to first slide",
	  last: "Go to last slide",
	  slideX: "Go to slide %s",
	  pageX: "Go to page %s",
	  play: "Start autoplay",
	  pause: "Pause autoplay",
	  carousel: "carousel",
	  slide: "slide",
	  select: "Select a slide to show",
	  slideLabel: "%s of %s"
	};
	var DEFAULTS = {
	  type: "slide",
	  role: "region",
	  speed: 400,
	  perPage: 1,
	  cloneStatus: true,
	  arrows: true,
	  pagination: true,
	  paginationKeyboard: true,
	  interval: 5e3,
	  pauseOnHover: true,
	  pauseOnFocus: true,
	  resetProgress: true,
	  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
	  drag: true,
	  direction: "ltr",
	  trimSpace: true,
	  focusableNodes: "a, button, textarea, input, select, iframe",
	  live: true,
	  classes: CLASSES,
	  i18n: I18N,
	  reducedMotion: {
	    speed: 0,
	    rewindSpeed: 0,
	    autoplay: "pause"
	  }
	};
	function Fade(Splide2, Components2, options) {
	  var Slides = Components2.Slides;
	  function mount() {
	    EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
	  }
	  function init() {
	    Slides.forEach(function (Slide) {
	      Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
	    });
	  }
	  function start(index, done) {
	    Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
	    nextTick(done);
	  }
	  return {
	    mount: mount,
	    start: start,
	    cancel: noop
	  };
	}
	function Slide(Splide2, Components2, options) {
	  var Move = Components2.Move,
	    Controller = Components2.Controller,
	    Scroll = Components2.Scroll;
	  var list = Components2.Elements.list;
	  var transition = apply(style, list, "transition");
	  var endCallback;
	  function mount() {
	    EventInterface(Splide2).bind(list, "transitionend", function (e) {
	      if (e.target === list && endCallback) {
	        cancel();
	        endCallback();
	      }
	    });
	  }
	  function start(index, done) {
	    var destination = Move.toPosition(index, true);
	    var position = Move.getPosition();
	    var speed = getSpeed(index);
	    if (abs(destination - position) >= 1 && speed >= 1) {
	      if (options.useScroll) {
	        Scroll.scroll(destination, speed, false, done);
	      } else {
	        transition("transform " + speed + "ms " + options.easing);
	        Move.translate(destination, true);
	        endCallback = done;
	      }
	    } else {
	      Move.jump(index);
	      done();
	    }
	  }
	  function cancel() {
	    transition("");
	    Scroll.cancel();
	  }
	  function getSpeed(index) {
	    var rewindSpeed = options.rewindSpeed;
	    if (Splide2.is(SLIDE) && rewindSpeed) {
	      var prev = Controller.getIndex(true);
	      var end = Controller.getEnd();
	      if (prev === 0 && index >= end || prev >= end && index === 0) {
	        return rewindSpeed;
	      }
	    }
	    return options.speed;
	  }
	  return {
	    mount: mount,
	    start: start,
	    cancel: cancel
	  };
	}
	var _Splide = /*#__PURE__*/function () {
	  function _Splide(target, options) {
	    this.event = EventInterface();
	    this.Components = {};
	    this.state = State(CREATED);
	    this.splides = [];
	    this._o = {};
	    this._E = {};
	    var root = isString(target) ? query(document, target) : target;
	    assert(root, root + " is invalid.");
	    this.root = root;
	    options = merge({
	      label: getAttribute(root, ARIA_LABEL) || "",
	      labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
	    }, DEFAULTS, _Splide.defaults, options || {});
	    try {
	      merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
	    } catch (e) {
	      assert(false, "Invalid JSON");
	    }
	    this._o = Object.create(merge({}, options));
	  }
	  var _proto = _Splide.prototype;
	  _proto.mount = function mount(Extensions, Transition) {
	    var _this = this;
	    var state = this.state,
	      Components2 = this.Components;
	    assert(state.is([CREATED, DESTROYED]), "Already mounted!");
	    state.set(CREATED);
	    this._C = Components2;
	    this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
	    this._E = Extensions || this._E;
	    var Constructors = assign({}, ComponentConstructors, this._E, {
	      Transition: this._T
	    });
	    forOwn(Constructors, function (Component, key) {
	      var component = Component(_this, Components2, _this._o);
	      Components2[key] = component;
	      component.setup && component.setup();
	    });
	    forOwn(Components2, function (component) {
	      component.mount && component.mount();
	    });
	    this.emit(EVENT_MOUNTED);
	    addClass(this.root, CLASS_INITIALIZED);
	    state.set(IDLE);
	    this.emit(EVENT_READY);
	    return this;
	  };
	  _proto.sync = function sync(splide) {
	    this.splides.push({
	      splide: splide
	    });
	    splide.splides.push({
	      splide: this,
	      isParent: true
	    });
	    if (this.state.is(IDLE)) {
	      this._C.Sync.remount();
	      splide.Components.Sync.remount();
	    }
	    return this;
	  };
	  _proto.go = function go(control) {
	    this._C.Controller.go(control);
	    return this;
	  };
	  _proto.on = function on(events, callback) {
	    this.event.on(events, callback);
	    return this;
	  };
	  _proto.off = function off(events) {
	    this.event.off(events);
	    return this;
	  };
	  _proto.emit = function emit(event) {
	    var _this$event;
	    (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
	    return this;
	  };
	  _proto.add = function add(slides, index) {
	    this._C.Slides.add(slides, index);
	    return this;
	  };
	  _proto.remove = function remove(matcher) {
	    this._C.Slides.remove(matcher);
	    return this;
	  };
	  _proto.is = function is(type) {
	    return this._o.type === type;
	  };
	  _proto.refresh = function refresh() {
	    this.emit(EVENT_REFRESH);
	    return this;
	  };
	  _proto.destroy = function destroy(completely) {
	    if (completely === void 0) {
	      completely = true;
	    }
	    var event = this.event,
	      state = this.state;
	    if (state.is(CREATED)) {
	      EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
	    } else {
	      forOwn(this._C, function (component) {
	        component.destroy && component.destroy(completely);
	      }, true);
	      event.emit(EVENT_DESTROY);
	      event.destroy();
	      completely && empty(this.splides);
	      state.set(DESTROYED);
	    }
	    return this;
	  };
	  _createClass(_Splide, [{
	    key: "options",
	    get: function get() {
	      return this._o;
	    },
	    set: function set(options) {
	      this._C.Media.set(options, true, true);
	    }
	  }, {
	    key: "length",
	    get: function get() {
	      return this._C.Slides.getLength(true);
	    }
	  }, {
	    key: "index",
	    get: function get() {
	      return this._C.Controller.getIndex();
	    }
	  }]);
	  return _Splide;
	}();
	var Splide = _Splide;
	Splide.defaults = {};
	Splide.STATES = STATES;

	/** Set variables accessible anywhere * */

	const freezer = {
	  // freezeKeyboardEvents : false,
	  KeyboardEvents: false
	};
	const DOM = {
	  get generalWrapper() {
	    return document.querySelector('.general-wrapper');
	  },
	  get bannerAlerts() {
	    return document.querySelector('.o-banner-alert');
	  },
	  get cardsSlider() {
	    return document.querySelectorAll('.mod-list-cards .o-cards-slider');
	  },
	  get formFilters() {
	    return document.querySelectorAll('.form-has-chips');
	  },
	  get footerMain() {
	    return document.querySelector('.o-footer-main');
	  },
	  get keyFigures() {
	    return document.querySelectorAll('.o-key-figures');
	  },
	  get launcher() {
	    return document.querySelector('.o-launcher');
	  },
	  get launcherNavWrapper() {
	    return document.querySelector('.o-launcher__nav-wrapper');
	  },
	  get menuMain() {
	    return document.querySelector('.o-menu-main');
	  },
	  get menuMainNav() {
	    return document.querySelector('.o-menu-main__nav');
	  },
	  get menuMainBtnClose() {
	    return document.querySelector('.o-menu-main .a-btn-close');
	  },
	  get menuMainSections() {
	    return document.querySelectorAll('.o-menu-main__section');
	  },
	  get videoPlayers() {
	    return document.querySelectorAll('.o-video-player');
	  },
	  get bannerAnonymous() {
	    return document.querySelector('.m-banner-anonymous');
	  },
	  get bannerCookiesWrapper() {
	    return document.querySelector('.m-banner-cookies-wrapper');
	  },
	  get bannerCookies() {
	    return document.querySelector('.m-banner-cookies');
	  },
	  get customSelects() {
	    return document.querySelectorAll('.m-custom-select');
	  },
	  get notes() {
	    return document.querySelectorAll('a[role="doc-noteref"]');
	  },
	  get slidesets() {
	    return document.querySelectorAll('.mod-slideset .splide');
	  },
	  get slideshows() {
	    return document.querySelectorAll('.mod-slideshow .splide');
	  },
	  get summary() {
	    return document.querySelector('.mod-summary');
	  },
	  get lightboxs() {
	    return document.querySelectorAll('.lightbox');
	  },
	  get textareaCharsCounters() {
	    return document.querySelectorAll('textarea.has-charscounter');
	  },
	  get tooltips() {
	    return document.querySelectorAll('[data-tooltip]');
	  },
	  get datepickers() {
	    return document.querySelectorAll('.datepicker');
	  },
	  get glossary() {
	    return document.querySelector('.o-glossary');
	  },
	  get dataViz() {
	    return document.querySelectorAll('.mod-data-viz');
	  },
	  get perPageResults() {
	    return document.querySelector('.mod-results-perpage');
	  },
	  get togglers() {
	    return document.querySelectorAll('[data-toggle-container]');
	  },
	  get transportsSearchForm() {
	    return document.querySelector('.o-trans-search__form');
	  },
	  get selectDepartement() {
	    return document.querySelector('.mod-select-departement .o-select-dept');
	  },
	  get htmlFormsValidate() {
	    return document.querySelectorAll('form[data-validate]');
	  },
	  get rangeSliders() {
	    return document.querySelectorAll('.m-range-slider');
	  },
	  get formAidesSearch() {
	    return document.querySelector('.mod-hero--search');
	  },
	  get cardsFullText() {
	    return document.querySelectorAll('.mod-cards-full-text');
	  },
	  get aLaUne() {
	    return document.querySelector('.mod-a-la-une .splide');
	  },
	  get faqTransports() {
	    return document.querySelector('.mod-faq-transports');
	  },
	  get eventCards() {
	    return document.querySelectorAll('.m-card--event, .m-card--result--long');
	  },
	  get filters() {
	    return document.querySelectorAll('.o-filters');
	  },
	  get notifications() {
	    return document.querySelectorAll('.m-notification');
	  },
	  get leaflet() {
	    return document.querySelector('[data-map]');
	  }};
	const CLASS = {
	  MENU_MAIN_OPENED: 'menu-main-opened',
	  MENU_PROFILS_OPENED: 'menu-profils-opened',
	  NO_SCROLL: 'no-scroll',
	  IS_ACTIVE: 'is-active',
	  IS_CONNECTED: 'is-connected',
	  IS_FIRST_FOCUSABLE: 'is-first-focusable',
	  IS_LAST_FOCUSABLE: 'is-last-focusable',
	  IS_MAX_REACHED: 'is-maxreached',
	  IS_PREVIOUS: 'is-previous',
	  IS_STUCK: 'is-stuck',
	  VISUALLY_HIDDEN: 'sr-only'
	};
	const CONFIG = {
	  TOOLTIP_MARGIN_X: 8};

	// export const IS_NOT_PROD = (window.location.port >= 3000 || window.location.hostname === 'rna-int.test.net');
	const NOT_PROD_HOSTS = new Set(['localhost', '127.0.0.1', 'storybook-nouvelle-aquitaine.fr', 'www.storybook-nouvelle-aquitaine.fr']);
	const NOT_PROD_PORTS = new Set(['3000', '3001', '3002', '3003', '3004', '3005', '6006']);
	const IS_NOT_PROD = NOT_PROD_HOSTS.has(location.hostname) || NOT_PROD_PORTS.has(location.port);

	/* const NOT_PROD_HOSTS = new Set(['localhost', '127.0.0.1', 'storybook-nouvelle-aquitaine.fr', 'www.storybook-nouvelle-aquitaine.fr']);
	const NOT_PROD_PORTS = new Set(['3000','3001','3002','3003','3004','3005','6006']);
	export const IS_NOT_PROD =
	  NOT_PROD_HOSTS.has(location.hostname) ||
	  (location.port && NOT_PROD_PORTS.has(location.port)); */

	const LIGHTBOX_PARVUS_L10N = {
	  lightboxLabel: 'Fenêtre modale image agrandie. Utilisez la touche Échap pour fermer cette fenêtre',
	  lightboxLoadingIndicatorLabel: 'Chargement de l\'image en cours',
	  lightboxLoadingError: 'Erreur lors du chargement de l\'image',
	  controlsLabel: 'Contrôles',
	  previousButtonLabel: 'Image précédente',
	  nextButtonLabel: 'Image suivante',
	  closeButtonLabel: 'Fermer cette fenêtre modale',
	  sliderLabel: 'Images',
	  slideLabel: 'Image'
	};
	const SLIDER_OPTIONS_I18N_ALERTES = {
	  prev: 'Alerte précédente',
	  next: 'Alerte suivante',
	  first: 'Afficher la première alerte',
	  last: 'Afficher la dernière alerte',
	  slideX: 'Afficher l\'alerte %s',
	  pageX: 'Aller à la page %s des alertes',
	  select: 'Sélectionner une alerte',
	  slideLabel: 'Alerte %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_KEYFIGURES = {
	  prev: 'Chiffre clé précédent',
	  next: 'Chiffre clé suivant',
	  first: 'Aller au premièr chiffre clé',
	  last: 'Aller au dernier chiffre clé',
	  slideX: 'Aller au chiffre clé %s',
	  pageX: 'Aller à la page %s des chiffres clés',
	  select: 'Sélectionner un chiffre clé',
	  slideLabel: 'Chiffre clé %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_ACTUALITIES = {
	  prev: 'Actualité précédente',
	  next: 'Actualité suivante',
	  first: 'Afficher la première actualité',
	  last: 'Afficher la dernière actualité',
	  slideX: 'Afficher l\'actualité %s',
	  pageX: 'Aller à la page %s des actualités',
	  select: 'Sélectionner une actualité',
	  slideLabel: 'Actualité %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_EVENTS = {
	  prev: 'Événement précédent',
	  next: 'Événement suivant',
	  first: 'Afficher le premier événement',
	  last: 'Afficher le dernier événement',
	  slideX: 'Afficher l\'événement %s',
	  pageX: 'Aller à la page %s des événements',
	  select: 'Sélectionner un événement',
	  slideLabel: 'Événement %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_PROJETS = {
	  prev: 'Projet précédent',
	  next: 'Projet suivant',
	  first: 'Afficher le premier projet',
	  last: 'Afficher le dernier projet',
	  slideX: 'Afficher le projet %s',
	  pageX: 'Aller à la page %s des projets',
	  select: 'Sélectionner un projet',
	  slideLabel: 'Projet %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_IMAGES = {
	  prev: 'Image précédente',
	  next: 'Image suivante',
	  first: 'Afficher la première image',
	  last: 'Afficher la dernière image',
	  slideX: 'Afficher l\'image %s',
	  pageX: 'Aller à la page %s des images',
	  select: 'Sélectionner une image',
	  slideLabel: 'Image %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_PORTALS = {
	  prev: 'Site précédent',
	  next: 'Site suivant',
	  first: 'Afficher le premier site',
	  last: 'Afficher le dernier site',
	  slideX: 'Afficher le site %s',
	  pageX: 'Aller à la page %s des sites',
	  select: 'Sélectionner un site',
	  slideLabel: 'Site %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_NEO_MEDIAS = {
	  prev: 'Épisode précédent',
	  next: 'Épisode suivant',
	  first: 'Afficher le premier épisode',
	  last: 'Afficher le dernier épisode',
	  slideX: 'Afficher l\'épisode %s',
	  pageX: 'Aller à la page %s des épisodes',
	  select: 'Sélectionner un épisode',
	  slideLabel: 'Épisode %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_FILIERES = {
	  prev: 'Filière précédente',
	  next: 'Filière suivante',
	  first: 'Afficher la première filière',
	  last: 'Afficher la dernière filière',
	  slideX: 'Afficher la filière %s',
	  pageX: 'Aller à la page %s des filières',
	  select: 'Sélectionner une filière',
	  slideLabel: 'Filière %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_AIDES = {
	  prev: 'Aide précédente',
	  next: 'Aide suivante',
	  first: 'Afficher la première aide',
	  last: 'Afficher la dernière aide',
	  slideX: "Afficher l'aide %s",
	  pageX: 'Aller à la page %s des aides',
	  select: 'Sélectionner une aide',
	  slideLabel: 'Aide %s sur %s'
	};
	const SLIDER_OPTIONS_I18N_VOTES_DEBATS = {
	  prev: 'Vote/débat précédent',
	  next: 'Vote/débat suivant',
	  first: 'Afficher le premier vote/débat',
	  last: 'Afficher le dernier vote/débat',
	  slideX: 'Afficher le vote/débat %s',
	  pageX: 'Aller à la page %s des votes/débats',
	  select: 'Sélectionner un vote/débat',
	  slideLabel: 'Vote/débat %s sur %s'
	};

	/**! 
	 * hotkeys-js v3.13.15 
	 * A simple micro-library for defining and dispatching keyboard shortcuts. It has no dependencies. 
	 * 
	 * Copyright (c) 2025 kenny wong <wowohoo@qq.com> 
	 * https://github.com/jaywcjlove/hotkeys-js.git 
	 * 
	 * @website: https://jaywcjlove.github.io/hotkeys-js
	 
	 * Licensed under the MIT license 
	 */

	const isff = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase().indexOf('firefox') > 0 : false;

	/** Bind event */
	function addEvent(object, event, method, useCapture) {
	  if (object.addEventListener) {
	    object.addEventListener(event, method, useCapture);
	  } else if (object.attachEvent) {
	    object.attachEvent("on".concat(event), method);
	  }
	}
	function removeEvent(object, event, method, useCapture) {
	  if (object.removeEventListener) {
	    object.removeEventListener(event, method, useCapture);
	  } else if (object.detachEvent) {
	    object.detachEvent("on".concat(event), method);
	  }
	}

	/** Convert modifier keys to their corresponding key codes */
	function getMods(modifier, key) {
	  const mods = key.slice(0, key.length - 1);
	  for (let i = 0; i < mods.length; i++) mods[i] = modifier[mods[i].toLowerCase()];
	  return mods;
	}

	/** Process the input key string and convert it to an array */
	function getKeys(key) {
	  if (typeof key !== 'string') key = '';
	  key = key.replace(/\s/g, ''); // Match any whitespace character, including spaces, tabs, form feeds, etc.
	  const keys = key.split(','); // Allow multiple shortcuts separated by ','
	  let index = keys.lastIndexOf('');

	  // Shortcut may include ',' — special handling needed
	  for (; index >= 0;) {
	    keys[index - 1] += ',';
	    keys.splice(index, 1);
	    index = keys.lastIndexOf('');
	  }
	  return keys;
	}

	/** Compare arrays of modifier keys */
	function compareArray(a1, a2) {
	  const arr1 = a1.length >= a2.length ? a1 : a2;
	  const arr2 = a1.length >= a2.length ? a2 : a1;
	  let isIndex = true;
	  for (let i = 0; i < arr1.length; i++) {
	    if (arr2.indexOf(arr1[i]) === -1) isIndex = false;
	  }
	  return isIndex;
	}

	// Special Keys
	const _keyMap = {
	  backspace: 8,
	  '⌫': 8,
	  tab: 9,
	  clear: 12,
	  enter: 13,
	  '↩': 13,
	  return: 13,
	  esc: 27,
	  escape: 27,
	  space: 32,
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  /// https://w3c.github.io/uievents/#events-keyboard-key-location
	  arrowup: 38,
	  arrowdown: 40,
	  arrowleft: 37,
	  arrowright: 39,
	  del: 46,
	  delete: 46,
	  ins: 45,
	  insert: 45,
	  home: 36,
	  end: 35,
	  pageup: 33,
	  pagedown: 34,
	  capslock: 20,
	  num_0: 96,
	  num_1: 97,
	  num_2: 98,
	  num_3: 99,
	  num_4: 100,
	  num_5: 101,
	  num_6: 102,
	  num_7: 103,
	  num_8: 104,
	  num_9: 105,
	  num_multiply: 106,
	  num_add: 107,
	  num_enter: 108,
	  num_subtract: 109,
	  num_decimal: 110,
	  num_divide: 111,
	  '⇪': 20,
	  ',': 188,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '-': isff ? 173 : 189,
	  '=': isff ? 61 : 187,
	  ';': isff ? 59 : 186,
	  '\'': 222,
	  '{': 219,
	  '}': 221,
	  '[': 219,
	  ']': 221,
	  '\\': 220
	};

	// Modifier Keys
	const _modifier = {
	  // shiftKey
	  '⇧': 16,
	  shift: 16,
	  // altKey
	  '⌥': 18,
	  alt: 18,
	  option: 18,
	  // ctrlKey
	  '⌃': 17,
	  ctrl: 17,
	  control: 17,
	  // metaKey
	  '⌘': 91,
	  cmd: 91,
	  meta: 91,
	  command: 91
	};
	const modifierMap = {
	  16: 'shiftKey',
	  18: 'altKey',
	  17: 'ctrlKey',
	  91: 'metaKey',
	  shiftKey: 16,
	  ctrlKey: 17,
	  altKey: 18,
	  metaKey: 91
	};
	const _mods = {
	  16: false,
	  18: false,
	  17: false,
	  91: false
	};
	const _handlers = {};

	// F1~F12 special key
	for (let k = 1; k < 20; k++) {
	  _keyMap["f".concat(k)] = 111 + k;
	}

	/** Record the pressed keys */
	let _downKeys = [];
	/** Whether the window has already listened to the focus event */
	let winListendFocus = null;
	/** Default hotkey scope */
	let _scope = 'all';
	/** Map to record elements with bound events */
	const elementEventMap = new Map();

	/** Return key code */
	const code = x => _keyMap[x.toLowerCase()] || _modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
	const getKey = x => Object.keys(_keyMap).find(k => _keyMap[k] === x);
	const getModifier = x => Object.keys(_modifier).find(k => _modifier[k] === x);

	/** Set or get the current scope (defaults to 'all') */
	function setScope(scope) {
	  _scope = scope || 'all';
	}
	/** Get the current scope */
	function getScope() {
	  return _scope || 'all';
	}
	/** Get the key codes of the currently pressed keys */
	function getPressedKeyCodes() {
	  return _downKeys.slice(0);
	}
	function getPressedKeyString() {
	  return _downKeys.map(c => getKey(c) || getModifier(c) || String.fromCharCode(c));
	}
	function getAllKeyCodes() {
	  const result = [];
	  Object.keys(_handlers).forEach(k => {
	    _handlers[k].forEach(_ref => {
	      let {
	        key,
	        scope,
	        mods,
	        shortcut
	      } = _ref;
	      result.push({
	        scope,
	        shortcut,
	        mods,
	        keys: key.split('+').map(v => code(v))
	      });
	    });
	  });
	  return result;
	}

	/** hotkey is effective only when filter return true */
	function filter(event) {
	  const target = event.target || event.srcElement;
	  const {
	    tagName
	  } = target;
	  let flag = true;
	  const isInput = tagName === 'INPUT' && !['checkbox', 'radio', 'range', 'button', 'file', 'reset', 'submit', 'color'].includes(target.type);
	  // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>
	  if (target.isContentEditable || (isInput || tagName === 'TEXTAREA' || tagName === 'SELECT') && !target.readOnly) {
	    flag = false;
	  }
	  return flag;
	}

	/** Determine whether the pressed key matches a specific key, returns true or false */
	function isPressed(keyCode) {
	  if (typeof keyCode === 'string') {
	    keyCode = code(keyCode); // Convert to key code
	  }
	  return _downKeys.indexOf(keyCode) !== -1;
	}

	/** Loop through and delete all handlers with the specified scope */
	function deleteScope(scope, newScope) {
	  let handlers;
	  let i;

	  // If no scope is specified, get the current scope
	  if (!scope) scope = getScope();
	  for (const key in _handlers) {
	    if (Object.prototype.hasOwnProperty.call(_handlers, key)) {
	      handlers = _handlers[key];
	      for (i = 0; i < handlers.length;) {
	        if (handlers[i].scope === scope) {
	          const deleteItems = handlers.splice(i, 1);
	          deleteItems.forEach(_ref2 => {
	            let {
	              element
	            } = _ref2;
	            return removeKeyEvent(element);
	          });
	        } else {
	          i++;
	        }
	      }
	    }
	  }

	  // If the current scope has been deleted, reset the scope to 'all'
	  if (getScope() === scope) setScope(newScope || 'all');
	}

	/** Clear modifier keys */
	function clearModifier(event) {
	  let key = event.keyCode || event.which || event.charCode;
	  if (event.key && event.key.toLowerCase() === 'capslock') {
	    // Ensure that when capturing keystrokes in modern browsers,
	    // uppercase and lowercase letters (such as R and r) return the same key value.
	    // https://github.com/jaywcjlove/hotkeys-js/pull/514
	    // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
	    key = code(event.key);
	  }
	  const i = _downKeys.indexOf(key);

	  // Remove the pressed key from the list
	  if (i >= 0) {
	    _downKeys.splice(i, 1);
	  }
	  // Special handling for the command key: fix the issue where keyup only triggers once for command combos
	  if (event.key && event.key.toLowerCase() === 'meta') {
	    _downKeys.splice(0, _downKeys.length);
	  }

	  // Clear modifier keys: shiftKey, altKey, ctrlKey, (command || metaKey)
	  if (key === 93 || key === 224) key = 91;
	  if (key in _mods) {
	    _mods[key] = false;

	    // Reset the modifier key status to false
	    for (const k in _modifier) if (_modifier[k] === key) hotkeys[k] = false;
	  }
	}
	function unbind(keysInfo) {
	  // unbind(), unbind all keys
	  if (typeof keysInfo === 'undefined') {
	    Object.keys(_handlers).forEach(key => {
	      Array.isArray(_handlers[key]) && _handlers[key].forEach(info => eachUnbind(info));
	      delete _handlers[key];
	    });
	    removeKeyEvent(null);
	  } else if (Array.isArray(keysInfo)) {
	    // support like : unbind([{key: 'ctrl+a', scope: 's1'}, {key: 'ctrl-a', scope: 's2', splitKey: '-'}])
	    keysInfo.forEach(info => {
	      if (info.key) eachUnbind(info);
	    });
	  } else if (typeof keysInfo === 'object') {
	    // support like unbind({key: 'ctrl+a, ctrl+b', scope:'abc'})
	    if (keysInfo.key) eachUnbind(keysInfo);
	  } else if (typeof keysInfo === 'string') {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	    // support old method
	    // eslint-disable-line
	    let [scope, method] = args;
	    if (typeof scope === 'function') {
	      method = scope;
	      scope = '';
	    }
	    eachUnbind({
	      key: keysInfo,
	      scope,
	      method,
	      splitKey: '+'
	    });
	  }
	}

	/** Unbind hotkeys for a specific scope */
	const eachUnbind = _ref3 => {
	  let {
	    key,
	    scope,
	    method,
	    splitKey = '+'
	  } = _ref3;
	  const multipleKeys = getKeys(key);
	  multipleKeys.forEach(originKey => {
	    const unbindKeys = originKey.split(splitKey);
	    const len = unbindKeys.length;
	    const lastKey = unbindKeys[len - 1];
	    const keyCode = lastKey === '*' ? '*' : code(lastKey);
	    if (!_handlers[keyCode]) return;
	    // If scope is not provided, get the current scope
	    if (!scope) scope = getScope();
	    const mods = len > 1 ? getMods(_modifier, unbindKeys) : [];
	    const unbindElements = [];
	    _handlers[keyCode] = _handlers[keyCode].filter(record => {
	      // Check if the method matches; if method is provided, must be equal to unbind
	      const isMatchingMethod = method ? record.method === method : true;
	      const isUnbind = isMatchingMethod && record.scope === scope && compareArray(record.mods, mods);
	      if (isUnbind) unbindElements.push(record.element);
	      return !isUnbind;
	    });
	    unbindElements.forEach(element => removeKeyEvent(element));
	  });
	};

	/** Handle the callback function for the corresponding hotkey */
	function eventHandler(event, handler, scope, element) {
	  if (handler.element !== element) {
	    return;
	  }
	  let modifiersMatch;

	  // Check if it is within the current scope
	  if (handler.scope === scope || handler.scope === 'all') {
	    // Check whether modifier keys match (returns true if they do)
	    modifiersMatch = handler.mods.length > 0;
	    for (const y in _mods) {
	      if (Object.prototype.hasOwnProperty.call(_mods, y)) {
	        if (!_mods[y] && handler.mods.indexOf(+y) > -1 || _mods[y] && handler.mods.indexOf(+y) === -1) {
	          modifiersMatch = false;
	        }
	      }
	    }

	    // Call the handler function; ignore if it's only a modifier key
	    if (handler.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || modifiersMatch || handler.shortcut === '*') {
	      handler.keys = [];
	      handler.keys = handler.keys.concat(_downKeys);
	      if (handler.method(event, handler) === false) {
	        if (event.preventDefault) event.preventDefault();else event.returnValue = false;
	        if (event.stopPropagation) event.stopPropagation();
	        if (event.cancelBubble) event.cancelBubble = true;
	      }
	    }
	  }
	}

	/** Handle the keydown event */
	function dispatch(event, element) {
	  const asterisk = _handlers['*'];
	  let key = event.keyCode || event.which || event.charCode;
	  // Ensure that when capturing keystrokes in modern browsers,
	  // uppercase and lowercase letters (such as R and r) return the same key value.
	  // https://github.com/jaywcjlove/hotkeys-js/pull/514
	  // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
	  // CapsLock key
	  // There's an issue where `keydown` and `keyup` events are not triggered after CapsLock is enabled to activate uppercase.
	  if (event.key && event.key.toLowerCase() === 'capslock') {
	    return;
	  }
	  // Form control filter: by default, shortcut keys are not triggered in form elements
	  if (!hotkeys.filter.call(this, event)) return;

	  // In Gecko (Firefox), the command key code is 224; unify it with WebKit (Chrome)
	  // In WebKit, left and right command keys have different codes
	  if (key === 93 || key === 224) key = 91;

	  /**
	   * Collect bound keys
	   * If an Input Method Editor is processing key input and the event is keydown, return 229.
	   * https://stackoverflow.com/questions/25043934/is-it-ok-to-ignore-keydown-events-with-keycode-229
	   * http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
	   */
	  if (_downKeys.indexOf(key) === -1 && key !== 229) _downKeys.push(key);
	  /**
	   * Jest test cases are required.
	   * ===============================
	   */
	  ['metaKey', 'ctrlKey', 'altKey', 'shiftKey'].forEach(keyName => {
	    const keyNum = modifierMap[keyName];
	    if (event[keyName] && _downKeys.indexOf(keyNum) === -1) {
	      _downKeys.push(keyNum);
	    } else if (!event[keyName] && _downKeys.indexOf(keyNum) > -1) {
	      _downKeys.splice(_downKeys.indexOf(keyNum), 1);
	    } else if (keyName === 'metaKey' && event[keyName]) {
	      // If the command key is pressed, clear all non-modifier keys except the current event key.
	      // This is because keyup for non-modifier keys will NEVER be triggered when command is pressed.
	      // This is a known browser limitation.
	      _downKeys = _downKeys.filter(k => k in modifierMap || k === key);
	    }
	  });
	  /**
	   * -------------------------------
	   */
	  if (key in _mods) {
	    _mods[key] = true;
	    // Register special modifier keys to the `hotkeys` object
	    for (const k in _modifier) {
	      if (Object.prototype.hasOwnProperty.call(_modifier, k)) {
	        const eventKey = modifierMap[_modifier[k]];
	        hotkeys[k] = event[eventKey];
	      }
	    }
	    if (!asterisk) return;
	  }

	  // Bind the modifier keys in modifierMap to the event
	  for (const e in _mods) {
	    if (Object.prototype.hasOwnProperty.call(_mods, e)) {
	      _mods[e] = event[modifierMap[e]];
	    }
	  }
	  /**
	   * https://github.com/jaywcjlove/hotkeys/pull/129
	   * This solves the issue in Firefox on Windows where hotkeys corresponding to special characters would not trigger.
	   * An example of this is ctrl+alt+m on a Swedish keyboard which is used to type μ.
	   * Browser support: https://caniuse.com/#feat=keyboardevent-getmodifierstate
	   */
	  if (event.getModifierState && !(event.altKey && !event.ctrlKey) && event.getModifierState('AltGraph')) {
	    if (_downKeys.indexOf(17) === -1) {
	      _downKeys.push(17);
	    }
	    if (_downKeys.indexOf(18) === -1) {
	      _downKeys.push(18);
	    }
	    _mods[17] = true;
	    _mods[18] = true;
	  }

	  // Get the current scope (defaults to 'all')
	  const scope = getScope();
	  // Handle any hotkeys registered as '*'
	  if (asterisk) {
	    for (let i = 0; i < asterisk.length; i++) {
	      if (asterisk[i].scope === scope && (event.type === 'keydown' && asterisk[i].keydown || event.type === 'keyup' && asterisk[i].keyup)) {
	        eventHandler(event, asterisk[i], scope, element);
	      }
	    }
	  }
	  // If the key is not registered, return
	  if (!(key in _handlers)) return;
	  const handlerKey = _handlers[key];
	  const keyLen = handlerKey.length;
	  for (let i = 0; i < keyLen; i++) {
	    if (event.type === 'keydown' && handlerKey[i].keydown || event.type === 'keyup' && handlerKey[i].keyup) {
	      if (handlerKey[i].key) {
	        const record = handlerKey[i];
	        const {
	          splitKey
	        } = record;
	        const keyShortcut = record.key.split(splitKey);
	        const _downKeysCurrent = []; // Store the current key codes
	        for (let a = 0; a < keyShortcut.length; a++) {
	          _downKeysCurrent.push(code(keyShortcut[a]));
	        }
	        if (_downKeysCurrent.sort().join('') === _downKeys.sort().join('')) {
	          // Match found, call the handler
	          eventHandler(event, record, scope, element);
	        }
	      }
	    }
	  }
	}
	function hotkeys(key, option, method) {
	  _downKeys = [];
	  /** List of hotkeys to handle */
	  const keys = getKeys(key);
	  let mods = [];
	  /** Default scope is 'all', meaning effective in all scopes */
	  let scope = 'all';
	  /** Element to which the hotkey events are bound */
	  let element = document;
	  let i = 0;
	  let keyup = false;
	  let keydown = true;
	  let splitKey = '+';
	  let capture = false;
	  /** Allow only a single callback */
	  let single = false;

	  // Determine if the second argument is a function (no options provided)
	  if (method === undefined && typeof option === 'function') {
	    method = option;
	  }

	  // Parse options object
	  if (Object.prototype.toString.call(option) === '[object Object]') {
	    if (option.scope) scope = option.scope; // Set scope
	    if (option.element) element = option.element; // Set binding element
	    if (option.keyup) keyup = option.keyup;
	    if (option.keydown !== undefined) keydown = option.keydown;
	    if (option.capture !== undefined) capture = option.capture;
	    if (typeof option.splitKey === 'string') splitKey = option.splitKey;
	    if (option.single === true) single = true;
	  }
	  if (typeof option === 'string') scope = option;

	  // If only one callback is allowed, unbind the existing one first
	  if (single) unbind(key, scope);

	  // Handle each hotkey
	  for (; i < keys.length; i++) {
	    key = keys[i].split(splitKey); // Split into individual keys
	    mods = [];

	    // If it's a combination, extract modifier keys
	    if (key.length > 1) mods = getMods(_modifier, key);

	    // Convert non-modifier key to key code
	    key = key[key.length - 1];
	    key = key === '*' ? '*' : code(key); // '*' means match all hotkeys

	    // Initialize handler array if this key has no handlers yet
	    if (!(key in _handlers)) _handlers[key] = [];
	    _handlers[key].push({
	      keyup,
	      keydown,
	      scope,
	      mods,
	      shortcut: keys[i],
	      method,
	      key: keys[i],
	      splitKey,
	      element
	    });
	  }
	  // Register hotkey event listeners on the global document
	  if (typeof element !== 'undefined' && window) {
	    if (!elementEventMap.has(element)) {
	      const keydownListener = function () {
	        let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
	        return dispatch(event, element);
	      };
	      const keyupListenr = function () {
	        let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
	        dispatch(event, element);
	        clearModifier(event);
	      };
	      elementEventMap.set(element, {
	        keydownListener,
	        keyupListenr,
	        capture
	      });
	      addEvent(element, 'keydown', keydownListener, capture);
	      addEvent(element, 'keyup', keyupListenr, capture);
	    }
	    // Register focus event listener once to clear pressed keys on window focus
	    if (!winListendFocus) {
	      const listener = () => {
	        _downKeys = [];
	      };
	      winListendFocus = {
	        listener,
	        capture
	      };
	      addEvent(window, 'focus', listener, capture);
	    }
	  }
	}
	function trigger(shortcut) {
	  let scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	  Object.keys(_handlers).forEach(key => {
	    const dataList = _handlers[key].filter(item => item.scope === scope && item.shortcut === shortcut);
	    dataList.forEach(data => {
	      if (data && data.method) {
	        data.method();
	      }
	    });
	  });
	}

	/** Clean up event listeners. After unbinding, check whether the element still has any hotkeys bound. If not, remove its event listeners. */
	function removeKeyEvent(element) {
	  const values = Object.values(_handlers).flat();
	  const findindex = values.findIndex(_ref4 => {
	    let {
	      element: el
	    } = _ref4;
	    return el === element;
	  });
	  if (findindex < 0) {
	    const {
	      keydownListener,
	      keyupListenr,
	      capture
	    } = elementEventMap.get(element) || {};
	    if (keydownListener && keyupListenr) {
	      removeEvent(element, 'keyup', keyupListenr, capture);
	      removeEvent(element, 'keydown', keydownListener, capture);
	      elementEventMap.delete(element);
	    }
	  }
	  if (values.length <= 0 || elementEventMap.size <= 0) {
	    // Remove all event listeners from all elements
	    const eventKeys = Object.keys(elementEventMap);
	    eventKeys.forEach(el => {
	      const {
	        keydownListener,
	        keyupListenr,
	        capture
	      } = elementEventMap.get(el) || {};
	      if (keydownListener && keyupListenr) {
	        removeEvent(el, 'keyup', keyupListenr, capture);
	        removeEvent(el, 'keydown', keydownListener, capture);
	        elementEventMap.delete(el);
	      }
	    });
	    // Clear the elementEventMap
	    elementEventMap.clear();
	    // Clear all handlers
	    Object.keys(_handlers).forEach(key => delete _handlers[key]);
	    // Remove the global window focus event listener
	    if (winListendFocus) {
	      const {
	        listener,
	        capture
	      } = winListendFocus;
	      removeEvent(window, 'focus', listener, capture);
	      winListendFocus = null;
	    }
	  }
	}
	const _api = {
	  getPressedKeyString,
	  setScope,
	  getScope,
	  deleteScope,
	  getPressedKeyCodes,
	  getAllKeyCodes,
	  isPressed,
	  filter,
	  trigger,
	  unbind,
	  keyMap: _keyMap,
	  modifier: _modifier,
	  modifierMap
	};
	for (const a in _api) {
	  if (Object.prototype.hasOwnProperty.call(_api, a)) {
	    hotkeys[a] = _api[a];
	  }
	}
	if (typeof window !== 'undefined') {
	  const _hotkeys = window.hotkeys;
	  hotkeys.noConflict = deep => {
	    if (deep && window.hotkeys === hotkeys) {
	      window.hotkeys = _hotkeys;
	    }
	    return hotkeys;
	  };
	  window.hotkeys = hotkeys;
	}

	let currentBreakpoint = '';
	const oBreakpoints = {
	  xxl: '1920',
	  xl: '1440',
	  lg: '1024',
	  md: '768',
	  sm: '576',
	  xs: '360'};

	/**
	 Ckeck & store current @media breakpoint in body tag
	 */
	function mediaBreakpoint() {
	  // XXS
	  if (window.matchMedia(`(min-width: ${1}px)`).matches && window.matchMedia(`(max-width: ${oBreakpoints.xs - 0.2}px)`).matches) {
	    currentBreakpoint = 'xxs';
	    // this.is_Phone = true;
	    // XS
	  } else if (window.matchMedia(`(max-width: ${oBreakpoints.sm - 0.2}px)`).matches) {
	    currentBreakpoint = 'xs';
	    // this.is_Phone = true;
	    // SM
	  } else if (window.matchMedia(`(max-width: ${oBreakpoints.md - 0.2}px)`).matches) {
	    currentBreakpoint = 'sm';
	    // this.is_Phone = true;
	    // MD
	  } else if (window.matchMedia(`(max-width: ${oBreakpoints.lg - 0.2}px)`).matches) {
	    currentBreakpoint = 'md';
	    // this.is_Tablet = true;
	    // this.is_Phone = false;
	    // LG
	  } else if (window.matchMedia(`(max-width: ${oBreakpoints.xl - 0.2}px)`).matches) {
	    currentBreakpoint = 'lg';
	    // this.is_Mobile = false;
	    // this.is_Lg = true;
	    // XL
	  } else if (window.matchMedia(`(max-width: ${oBreakpoints.xxl - 0.2}px)`).matches) {
	    currentBreakpoint = 'xl';
	    // this.is_Mobile = false;
	    // this.is_Lg = false;
	    // this.is_Xl = true;
	    // this.is_Xxl = false
	    // XXL
	  } else if (window.matchMedia(`(min-width: ${oBreakpoints.xxl - 0.2}px)`).matches) {
	    currentBreakpoint = 'xxl';
	    // this.is_Mobile = false;
	    // this.is_Lg = false;
	    // this.is_Xl = false;
	    // this.is_Xxl = true;
	  }

	  // Store
	  document.querySelector('body').setAttribute('data-breakpoint', currentBreakpoint);
	}

	/**
	 Current breakpoint is mobile, phone, tablette, desktop ?
	 */

	// SM < ?
	function isPhone() {
	  const body = document.querySelector('body');
	  if (body.getAttribute('data-breakpoint') === 'xxs' || body.getAttribute('data-breakpoint') === 'xs' || body.getAttribute('data-breakpoint') === 'sm') {
	    return true;
	  }
	  return false;
	}

	// MD ?
	function isTablet() {
	  // return document.querySelector('body').getAttribute('data-breakpoint') === 'md';
	  return document.body.getAttribute('data-breakpoint') === 'md';
	}

	// LG > ?
	function isMobile() {
	  // return this.is_Mobile;
	  if (document.body.getAttribute('data-breakpoint') === 'xxs' || document.body.getAttribute('data-breakpoint') === 'xs' || document.body.getAttribute('data-breakpoint') === 'sm' || document.body.getAttribute('data-breakpoint') === 'md') {
	    return true;
	  }
	  return false;
	}

	// XL ?
	function isLg() {
	  // return document.querySelector('body').getAttribute('data-breakpoint') === 'lg';
	  return document.body.getAttribute('data-breakpoint') === 'lg';
	}

	/**
	 * Set an element as active (.is-active)
	 * @param elt
	 */
	function setActive(elt) {
	  elt.classList.add(CLASS.IS_ACTIVE);
	}

	/**
	 * Set an element as not active
	 * @param elt
	 */
	function setNotActive(elt) {
	  elt.classList.remove(CLASS.IS_ACTIVE);
	}

	/**
	 * Get window height
	 * @returns {number}
	 */
	function getWindowHeight() {
	  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	}

	/**
	 * Set aria-expanded button true/false
	 * @param elt
	 * @param bool
	 */
	function setAriaExpanded(elt, bool) {
	  // btn.attr('aria-expanded', bool);
	  elt.setAttribute('aria-expanded', bool);
	}

	/**
	 * Set aria pressed button true/false
	 * @param elt
	 * @param bool
	 */
	function setAriaHidden(elt, bool) {
	  // btn.attr('aria-expanded', bool);
	  elt.setAttribute('aria-hidden', bool);
	}

	/**
	 * Get aria-controls attribute
	 * @param elt
	 * @returns {*}
	 */
	function getAriaControls(elt) {
	  return elt.getAttribute('aria-controls');
	}

	/**
	 Window disable scroll (CSS)
	 */
	function stopScroll(elt) {
	  document.querySelector(elt).classList.add(CLASS.NO_SCROLL);
	}

	/**
	 Window active scroll (CSS)
	 */
	function activeScroll(elt) {
	  document.querySelector(elt).classList.remove(CLASS.NO_SCROLL);
	}

	/**
	 * Disable keyboard events
	 */
	function disableKeyboardEvents() {
	  document.onkeydown = () => false;
	}

	/**
	 * Enable keyboard events
	 */
	function enableKeyboardEvents() {
	  document.onkeydown = () => true;
	}

	/**
	 * Get element siblings
	 * @param elt
	 * @returns {*[]}
	 */
	/* export function getSiblings(elt) {
	  // for collecting siblings
	  const siblings = [];
	  // if no parent, return no sibling
	  if (!elt.parentNode) {
	    return siblings;
	  }
	  // first child of the parent node
	  let sibling = elt.parentNode.firstChild;

	  // collecting siblings
	  while (sibling) {
	    if (sibling.nodeType === 1 && sibling !== elt) {
	      siblings.push(sibling);
	    }
	    sibling = sibling.nextSibling;
	  }
	  return siblings;
	} */

	/**
	 * Set focus on element
	 * @param element
	 */
	function setElementFocus(element, timeBetween = 10) {
	  /* var focusInterval = 10; // ms, time between function calls
	     var focusTotalRepetitions = 10; // number of repetitions */

	  const focusInterval = timeBetween; // ms, time between function calls
	  let focusTotalRepetitions = 2;
	  if (timeBetween <= 10) {
	    focusTotalRepetitions = 10;
	  }

	  // element.setAttribute('tabindex', '0');
	  element.blur();
	  let focusRepetitions = 0;
	  const interval = window.setInterval(() => {
	    element.focus();
	    focusRepetitions += 1;
	    if (focusRepetitions >= focusTotalRepetitions) {
	      window.clearInterval(interval);
	    }
	  }, focusInterval);
	}

	/**
	 * Get elt width without margin/padding
	 * @param elt
	 * @returns {*|number|number}
	 */
	function getInnerWidth(elt) {
	  const computedStyle = getComputedStyle(elt);
	  let elementWidth = elt.clientWidth; // width with padding
	  elementWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
	  return elementWidth;
	}

	/**
	 Check if element is visible
	 */
	function isVisible(elt) {
	  return !!(elt.offsetWidth || elt.offsetHeight || elt.getClientRects().length);
	}

	/**
	 * Génère un id unique
	 * @constructor
	 */
	function uniqueID(idLength = 10) {
	  const length = idLength;
	  const timestamp = +new Date();
	  const getRandomInt = (min, max) => {
	    return Math.floor(Math.random() * (max - min + 1)) + min;
	  };
	  const ts = timestamp.toString();
	  const parts = ts.split('').reverse();
	  let id = '';
	  for (let i = 0; i < length; ++i) {
	    const index = getRandomInt(0, parts.length - 1);
	    id += parts[index];
	  }
	  return id;
	}

	/**
	 * Detect end of css keyframed animation
	 * @returns {*}
	 */
	function whichAnimationEvent() {
	  const el = document.createElement('fakeelement');
	  const animations = {
	    animation: 'animationend',
	    OAnimation: 'oAnimationEnd',
	    MozAnimation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd'
	  };
	  for (const t of Object.keys(animations)) {
	    if (el.style[t] !== undefined) {
	      return animations[t];
	    }
	  }
	  return null;
	}

	/**
	 Set cookie
	 */
	function setCookie(cname, cvalue, exdays = 30) {
	  const d = new Date();
	  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	  const expires = `expires=${d.toUTCString()}`;
	  document.cookie = `${cname}=${cvalue};${expires};path=/`;
	}

	/**
	 Read cookie
	 */
	function readCookie(key) {
	  const result = new RegExp(`(^|; )${encodeURIComponent(key)}=([^;]*)`).exec(document.cookie);
	  if (result) return result[2];
	  return null;
	}

	/**
	 * Detects if current browser supports localStorage
	 * @returns {boolean}
	 */
	function supportsLocalStorage() {
	  try {
	    if (typeof window === 'undefined' || !('localStorage' in window)) return false;
	    const t = '__ls_test__';
	    window.localStorage.setItem(t, '1');
	    window.localStorage.removeItem(t);
	    return true;
	  } catch {
	    return false;
	  }
	}

	/**
	 * Count user visits
	 * @returns {number}
	 */
	function setUserVisitLocalStorage() {
	  let userVisit;
	  userVisit = localStorage.getItem('user_visit') == null ? 0 : localStorage.getItem('user_visit');
	  userVisit = parseInt(userVisit, 10);
	  userVisit += 1;
	  localStorage.setItem('user_visit', userVisit.toString());
	  return userVisit;
	}

	/**
	 * Optimized resize event method
	 */
	(function atResize() {
	  const throttle = (type, name, obj = window) => {
	    let running = false;
	    const func = () => {
	      if (running) {
	        return;
	      }
	      running = true;
	      requestAnimationFrame(() => {
	        obj.dispatchEvent(new CustomEvent(name));
	        running = false;
	      });
	    };
	    obj.addEventListener(type, func);
	  };

	  /* init - you can init any event */
	  throttle('resize', 'optimizedResize');
	  return atResize;
	})();

	/**
	 * Splide destroy completely and remove navigation elements markup, when slide number is 1
	 */
	function destroyableCompletely(splideObj, splideSliderElt) {
	  // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	  if (splideObj.length === 1) {
	    // Destroy completely
	    splideObj.destroy('completely');
	    // Remove controls
	    const pagination = splideSliderElt.querySelector('.splide__pagination');
	    if (pagination) pagination.remove();
	    // pagination ? pagination.remove() : '';
	    const arrows = splideSliderElt.querySelectorAll('.splide__arrows');
	    arrows.forEach(elt => {
	      elt.remove();
	    });
	  }
	}

	/**
	 * Splide on mount
	 */
	function onSplideMounted(splideObj, splideSliderElt) {
	  enableSplideControls(splideSliderElt);

	  // Toggle no-arrows class, option arrow : true/false
	  toggleSplideArrowsVisibility(splideSliderElt, splideObj.options.arrows);

	  // Toggle no-arrows class, option arrow : true/false, when updated
	  splideObj.on('updated', () => {
	    toggleSplideArrowsVisibility(splideSliderElt, splideObj.options.arrows);
	  });

	  // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	  destroyableCompletely(splideObj, splideSliderElt);

	  // If less than 2 slides, hide pagination
	  const pagination = splideSliderElt.querySelector('.splide__pagination');
	  if (splideObj.length < 2) {
	    if (pagination) pagination.style.display = 'none';
	    splideSliderElt.classList.add('no-pagination');
	  }
	}

	/**
	 * updateTabIndex
	 * Make all slides inside viewport visible and focusable
	 * @param splideObj
	 */
	function updateTabIndex(splideObj) {
	  if (splideObj.options.traversing === true) {
	    // Iterate trough slides, search for items fully in viewport
	    const slides = splideObj.Components.Slides.get();
	    slides.forEach((slide, index) => {
	      const slideEl = slide.slide;
	      const slideElOffset = slideEl.getBoundingClientRect();

	      // Slide is inside viewport ?
	      // if (Math.floor(slideElOffset.left) >= 0 && Math.floor(slideElOffset.right) <= DOM.generalWrapper.getBoundingClientRect().right) {
	      if (Math.floor(slideElOffset.left) >= 0 && Math.floor(slideElOffset.right) <= document.body.getBoundingClientRect().right) {
	        slideEl.classList.add('is-visible');
	        slideEl.setAttribute('aria-hidden', false);
	        const linkA = slideEl.querySelector('a');
	        if (linkA) {
	          linkA.removeAttribute('tabindex');
	        }
	      }
	    });
	  }
	}

	/**
	 * Add/remove class no-arrows based on splideObj options arrows value
	 * Splide sets arrows: true by default, if not manually setted
	 * @param splideSliderElt
	 * @param bool
	 */
	function toggleSplideArrowsVisibility(splideSliderElt, bool) {
	  if (bool === false) {
	    splideSliderElt.classList.add('no-arrows');
	  } else {
	    splideSliderElt.classList.remove('no-arrows');
	    splideSliderElt.classList.remove('no-splide');
	  }
	}

	/**
	 * On Splide destroy
	 * @param splideObj
	 * @param sliderElt
	 */
	function onSplideDestroy(splideObj, splideSliderElt) {
	  // Keep aria-label on parent
	  if (splideObj.options.label) {
	    window.setTimeout(() => {
	      splideSliderElt.querySelector('.splide__list').setAttribute('aria-label', splideObj.options.label);
	    }, 500);
	  }

	  // Keep aria-labelledby on parent
	  if (splideObj.options.labelledby) {
	    window.setTimeout(() => {
	      splideSliderElt.setAttribute('aria-labelledby', splideObj.options.labelledby);
	    }, 500);
	  }

	  // Add class when only one slide (no slider)
	  splideSliderElt.classList.add('no-splide');

	  // Disable controls
	  disableSplideControls(splideSliderElt);
	}

	/**
	 ********************************************************************
	 * Splide hide & disable controls for screen & screen readers
	 ********************************************************************
	 */
	function disableSplideControls(splideSliderElt) {
	  // Disable controls
	  splideSliderElt.querySelectorAll('.splide__pagination, .splide__arrows').forEach(elt => {
	    elt.style.display = 'none';
	  });
	  splideSliderElt.classList.add('no-splide');
	  splideSliderElt.querySelectorAll('a').forEach(link => {
	    link.removeAttribute('tabindex');
	  });
	}

	/**
	 ********************************************************************
	 * Splide enable controls
	 ********************************************************************
	 */
	function enableSplideControls(splideSliderElt) {
	  // Enable controls
	  splideSliderElt.querySelectorAll('.splide__pagination, .splide__arrows').forEach(elt => {
	    // elt.style.display = '';
	    elt.style.removeProperty('display');
	  });
	  splideSliderElt.classList.remove('no-splide');
	}

	/**
	 * Check if bannner alert/info exists in DOM
	 * true : add class has-bandeauAlert to <body>
	 * @returns {boolean}
	 */
	function hasBannerAlert() {
	  const bannerAlert = document.querySelector('.o-banner-alert');
	  if (!!bannerAlert && !!bannerAlert.querySelector('.splide__list') && isVisible(bannerAlert)) {
	    return true;
	  }
	  return false;
	}
	function showGrid() {
	  const main = document.querySelector('main');
	  hotkeys('shift+ctrl+g', () => {
	    if (main.querySelector('.u-show-grid')) {
	      document.querySelector('.u-show-grid').remove();
	    } else {
	      const gridWrapper = document.createElement('div');
	      gridWrapper.classList.add('u-show-grid');
	      const rowGrid = document.createElement('div');
	      rowGrid.classList.add('_row');
	      for (let i = 0; i < 12; i++) {
	        const colGrid = document.createElement('div');
	        colGrid.classList.add('_col');
	        rowGrid.append(colGrid);
	      }
	      gridWrapper.append(rowGrid);

	      // Append to main
	      main.append(gridWrapper);
	    }
	  });
	}
	function switchColorMode() {
	  hotkeys('shift+ctrl+c', () => {
	    const html = document.querySelector('html');
	    const selectedTheme = html.getAttribute('data-ds-theme');
	    document.querySelector('html').setAttribute('data-ds-theme', selectedTheme === 'dark' ? 'light' : 'dark');
	  });
	}

	/**
	 * Cookie status values:
	 * 0 = Declined (show anonymous banner)
	 * 2 = Accepted (hide anonymous banner)
	 */

	const COOKIE_STATUS$1 = {
	  DECLINED: 0};
	let isInitialLoad = true;

	/**
	 * Initialize anonymous banner based on cookie status
	 */
	function initBannerAnonymous() {
	  if (!DOM.bannerAnonymous) {
	    // console.warn('Anonymous banner element not found');
	    return;
	  }

	  // Check if user is anonymous (not connected)
	  const isAnonymous = checkAnonymousUser();
	  if (!isAnonymous) {
	    // User is connected, always hide anonymous banner
	    hideAnonymousBanner();
	    return;
	  }

	  // User is anonymous, show/hide based on cookie consent
	  updateAnonymousBannerVisibility();

	  // After initial load, enable animations for future interactions
	  isInitialLoad = false;
	}

	/**
	 * Check if user is anonymous (not connected)
	 * @returns {boolean} True if user is anonymous
	 */
	function checkAnonymousUser() {
	  if (IS_NOT_PROD) {
	    // In dev mode, check for .is-connected class
	    return !document.body.classList.contains(CLASS.IS_CONNECTED);
	  }

	  // In production, could use Drupal status or other method
	  // return !Drupal.isUserLoggedIn();
	  return true; // Default to anonymous
	}

	/**
	 * Update anonymous banner visibility based on cookie consent
	 * This is the main function called by banner-cookies.js
	 */
	function updateAnonymousBannerVisibility() {
	  if (!DOM.bannerAnonymous) return;
	  const cookieStatus = getCookieConsentStatus();
	  if (cookieStatus === COOKIE_STATUS$1.DECLINED) {
	    // User declined cookies - show anonymous banner
	    showAnonymousBanner();
	    setBodyClass('b-anonymous-open', 'b-anonymous-close');
	  } else {
	    // User accepted cookies or no choice yet - hide anonymous banner
	    hideAnonymousBanner();
	    setBodyClass('b-anonymous-close', 'b-anonymous-open');
	  }
	}

	/**
	 * Show anonymous banner with CSS animation
	 */
	function showAnonymousBanner() {
	  if (!DOM.bannerAnonymous) return;

	  // If it's the initial load, disable transitions temporarily
	  if (isInitialLoad) {
	    DOM.bannerAnonymous.classList.add('no-transition');
	  }

	  // Remove inert attribute to allow interaction
	  DOM.bannerAnonymous.removeAttribute('inert');

	  // Update ARIA
	  setAriaHidden(DOM.bannerAnonymous, false);

	  // Remove visually hidden class
	  DOM.bannerAnonymous.classList.remove(CLASS.VISUALLY_HIDDEN);

	  // Trigger reflow to ensure CSS transition works
	  void DOM.bannerAnonymous.offsetHeight;

	  // Add active class for CSS animation
	  DOM.bannerAnonymous.classList.add(CLASS.IS_ACTIVE);

	  // Remove no-transition class after a brief delay
	  if (isInitialLoad) {
	    // Use requestAnimationFrame to ensure styles are applied
	    requestAnimationFrame(() => {
	      requestAnimationFrame(() => {
	        DOM.bannerAnonymous.classList.remove('no-transition');
	      });
	    });
	  }
	}

	/**
	 * Hide anonymous banner with CSS animation
	 */
	function hideAnonymousBanner() {
	  if (!DOM.bannerAnonymous) return;

	  // Remove active class to trigger CSS hide animation
	  DOM.bannerAnonymous.classList.remove(CLASS.IS_ACTIVE);

	  // Wait for CSS transition to complete before hiding completely
	  const handleTransitionEnd = e => {
	    if (e.target === DOM.bannerAnonymous) {
	      completeHiding();
	      DOM.bannerAnonymous.removeEventListener('transitionend', handleTransitionEnd);
	    }
	  };
	  DOM.bannerAnonymous.addEventListener('transitionend', handleTransitionEnd);

	  // Fallback timeout if transitionend doesn't fire
	  setTimeout(() => {
	    completeHiding();
	    DOM.bannerAnonymous.removeEventListener('transitionend', handleTransitionEnd);
	  }, 1000);
	}

	/**
	 * Complete the hiding process
	 */
	function completeHiding() {
	  if (!DOM.bannerAnonymous) return;

	  // Add visually hidden class (sr-only equivalent)
	  DOM.bannerAnonymous.classList.add(CLASS.VISUALLY_HIDDEN);

	  // Update ARIA
	  setAriaHidden(DOM.bannerAnonymous, true);

	  // Add inert attribute to prevent interaction
	  DOM.bannerAnonymous.setAttribute('inert', '');
	}

	/**
	 * Set body class for anonymous banner state
	 * @param {string} classToAdd - Class to add
	 * @param {string} classToRemove - Class to remove
	 */
	function setBodyClass(classToAdd, classToRemove) {
	  document.body.classList.add(classToAdd);
	  document.body.classList.remove(classToRemove);
	}

	/**
	 * Get cookie consent status
	 * @returns {number|null} Cookie status
	 */
	function getCookieConsentStatus() {
	  const cookieValue = readCookie('cookie-agreed');
	  const parsedValue = parseInt(cookieValue, 10);
	  return Number.isNaN(parsedValue) ? null : parsedValue;
	}

	/**
	 * Cookie consent statuses:
	 *  null/NaN: Not yet agreed, show popup
	 *  0: Declined, show anonymous banner
	 *  2: Accepted, hide all banners
	 */

	const COOKIE_STATUS = {
	  DECLINED: 0,
	  ACCEPTED: 2
	};
	const FOCUS_DELAY$1 = 150;
	let focusBackOnElt = null;
	let listenersInitialized = false;

	/**
	 * Initialize cookie consent banner
	 */
	function initBannerCookies() {
	  if (!DOM.bannerCookies || !DOM.bannerCookiesWrapper) {
	    // console.warn('Cookie banner elements not found');
	    return;
	  }
	  const cookieStatus = getCookieStatus();
	  if (cookieStatus === null) {
	    // User hasn't made a choice yet - show consent popup
	    showBannerCookies();
	    setupEventListeners();
	  } else {
	    // User has already made a choice - hide consent popup
	    setAriaHidden(DOM.bannerCookiesWrapper, true);
	  }

	  // Always setup "Manage cookies" button
	  setupManageCookiesButton();
	}

	/**
	 * Setup all event listeners (only once)
	 */
	function setupEventListeners() {
	  if (listenersInitialized) return;
	  setupAgreeDeclineListeners();
	  listenersInitialized = true;
	}

	/**
	 * Setup agree/decline button listeners
	 */
	function setupAgreeDeclineListeners() {
	  const btnDecline = document.getElementById('btn-cookie-decline');
	  const btnAgree = document.getElementById('btn-cookie-agree');
	  if (!btnDecline || !btnAgree) {
	    // console.warn('Cookie agree/decline buttons not found');
	    return;
	  }
	  btnDecline.addEventListener('click', () => {
	    setCookieConsent(COOKIE_STATUS.DECLINED);
	    hideBannerCookies();
	  });
	  btnAgree.addEventListener('click', () => {
	    setCookieConsent(COOKIE_STATUS.ACCEPTED);
	    hideBannerCookies();
	  });
	}

	/**
	 * Set cookie consent and update anonymous banner
	 * @param {number} status - Cookie status (0 = declined, 2 = accepted)
	 */
	function setCookieConsent(status) {
	  // Save cookie
	  setCookie('cookie-agreed', status);

	  // Update anonymous banner visibility
	  updateAnonymousBannerVisibility();
	}

	/**
	 * Setup "Manage cookies" button in footer
	 */
	function setupManageCookiesButton() {
	  const manageCookiesBtn = document.getElementById('manage-cookies');
	  if (!manageCookiesBtn) return;
	  manageCookiesBtn.addEventListener('click', e => {
	    e.preventDefault();

	    // Store clicked element for focus restoration
	    focusBackOnElt = e.target;

	    // Set aria-expanded state
	    setAriaExpanded(e.target, true);

	    // Setup listeners if not already done
	    setupEventListeners();

	    // Remove opening delay when triggered manually
	    DOM.bannerCookiesWrapper.classList.add('has-no-delay');

	    // Show banner
	    showBannerCookies();

	    // Focus on decline button
	    const btnDecline = document.getElementById('btn-cookie-decline');
	    if (btnDecline) {
	      setElementFocus(btnDecline, FOCUS_DELAY$1);
	    }
	  });
	}

	/**
	 * Show cookie consent banner
	 */
	function showBannerCookies() {
	  if (!DOM.bannerCookies || !DOM.bannerCookiesWrapper) return;

	  // Enable focus on interactive elements
	  const interactiveElements = DOM.bannerCookies.querySelectorAll('button, a');
	  interactiveElements.forEach(elt => {
	    elt.tabIndex = 0;
	  });

	  // Remove inert attribute
	  DOM.bannerCookies.removeAttribute('inert');

	  // Update ARIA and visibility
	  setAriaHidden(DOM.bannerCookiesWrapper, false);
	  DOM.bannerCookiesWrapper.classList.remove(CLASS.VISUALLY_HIDDEN);

	  // Trigger reflow
	  void DOM.bannerCookiesWrapper.offsetHeight;

	  // Add active class for CSS animation
	  DOM.bannerCookiesWrapper.classList.add(CLASS.IS_ACTIVE);
	}

	/**
	 * Hide cookie consent banner
	 */
	function hideBannerCookies() {
	  if (!DOM.bannerCookies || !DOM.bannerCookiesWrapper) return;

	  // Remove active class to trigger CSS hide animation
	  DOM.bannerCookiesWrapper.classList.remove(CLASS.IS_ACTIVE);

	  // Wait for animation to complete
	  const handleTransitionEnd = e => {
	    if (e.target === DOM.bannerCookiesWrapper || e.target === DOM.bannerCookies) {
	      completeBannerHiding();
	      DOM.bannerCookiesWrapper.removeEventListener('transitionend', handleTransitionEnd);
	    }
	  };
	  DOM.bannerCookiesWrapper.addEventListener('transitionend', handleTransitionEnd);

	  // Fallback timeout if transitionend doesn't fire
	  setTimeout(() => {
	    if (!DOM.bannerCookiesWrapper.classList.contains(CLASS.VISUALLY_HIDDEN)) {
	      completeBannerHiding();
	      DOM.bannerCookiesWrapper.removeEventListener('transitionend', handleTransitionEnd);
	    }
	  }, 1000);
	}

	/**
	 * Complete banner hiding process
	 */
	function completeBannerHiding() {
	  if (!DOM.bannerCookies || !DOM.bannerCookiesWrapper) return;

	  // Hide and update ARIA
	  DOM.bannerCookiesWrapper.classList.add(CLASS.VISUALLY_HIDDEN);
	  setAriaHidden(DOM.bannerCookiesWrapper, true);

	  // Add inert attribute
	  DOM.bannerCookies.setAttribute('inert', '');

	  // Reset aria-expanded on all "manage cookies" links
	  const manageCookiesLinks = document.querySelectorAll('[id*="manage-cookies"]');
	  manageCookiesLinks.forEach(elt => {
	    setAriaExpanded(elt, false);
	  });

	  // Disable focus on interactive elements
	  const interactiveElements = DOM.bannerCookies.querySelectorAll('button, a');
	  interactiveElements.forEach(elt => {
	    elt.tabIndex = -1;
	  });

	  // Restore focus
	  restoreFocus();
	}

	/**
	 * Restore focus to trigger element
	 */
	function restoreFocus() {
	  if (focusBackOnElt) {
	    setElementFocus(focusBackOnElt);
	    focusBackOnElt = null;
	  }
	}

	/**
	 * Get current cookie consent status
	 * @returns {number|null} Cookie status (null, 0, or 2)
	 */
	function getCookieStatus() {
	  const cookieStatus = readCookie('cookie-agreed');
	  const parsedStatus = parseInt(cookieStatus, 10);
	  return Number.isNaN(parsedStatus) ? null : parsedStatus;
	}

	/**
	 * Onboarding workflow:
	 * - Sets 'onboarding' or 'no-onboarding' class on body based on visit count
	 * - Initializes cookie consent banner
	 * - Initializes anonymous banner
	 *
	 * The body class controls CSS animations for the cookie banner:
	 * - 'onboarding': First 2 visits, show animated entrance
	 * - 'no-onboarding': Subsequent visits, no animation
	 */
	function initOnboarding() {
	  // Check localStorage support
	  const browserSupportsLocalStorage = supportsLocalStorage();
	  let userVisit = 0;
	  if (browserSupportsLocalStorage) {
	    userVisit = setUserVisitLocalStorage();
	  }

	  // Set onboarding class based on visit count
	  // First 2 visits: 'onboarding' (with animations)
	  // Visit 3+: 'no-onboarding' (no animations)
	  const onboardingClass = userVisit > 2 ? 'no-onboarding' : 'onboarding';
	  document.body.classList.add(onboardingClass);

	  // Initialize banners in correct order:
	  // 1. Anonymous banner reads cookie and sets initial state
	  // 2. Cookie consent banner may show popup if needed
	  initBannerAnonymous();
	  initBannerCookies();
	}

	/**
	 * Skip links - accessibility
	 * @type {{init: skipLinks.init}}
	 */

	function initSkipLinks() {
	  if (document.querySelector('.m-skip-links')) {
	    const anchorContent = document.getElementById('go-content');
	    if (anchorContent) {
	      const mainContentId = document.querySelector(anchorContent.getAttribute('href'));

	      // Click on #go-content link => go smoothly to <main id="naq-content">
	      if (anchorContent && mainContentId) {
	        anchorContent.addEventListener('click', () => {
	          mainContentId.scrollIntoView({
	            behavior: 'smooth'
	          });
	        });
	      }
	    }

	    // Click on #go-menu button => open menu
	    const launcherBurger = document.querySelector('.o-launcher__nav__item__link--burger');
	    if (launcherBurger) {
	      document.getElementById('go-menu').addEventListener('click', () => {
	        launcherBurger.click();
	      });
	    }
	  }
	}

	(() => {
	  // Theme portal
	  const getStoredPortal = () => localStorage.getItem('portal');
	  const setStoredPortal = portal => localStorage.setItem('portal', portal);
	  const getPreferredPortal = () => {
	    const storedPortal = getStoredPortal();
	    if (storedPortal) {
	      return storedPortal;
	    }
	  };

	  // Dark mode is disabled at the design-system level: always force light,
	  // regardless of OS / browser `prefers-color-scheme` and any previously
	  // stored value.
	  // document.documentElement.setAttribute('data-ds-theme', 'light');

	  const setPortal = portal => {
	    document.documentElement.setAttribute('data-ds-portal', portal);
	  };
	  const showActivePortal = portal => {
	    const btnToActive = document.querySelector(`[data-ds-portal-value="${portal}"]`);
	    if (btnToActive) {
	      document.querySelectorAll('[data-ds-portal-value]').forEach(element => {
	        element.classList.remove('is-active');
	        element.setAttribute('aria-pressed', 'false');
	      });
	      btnToActive.classList.add('is-active');
	      btnToActive.setAttribute('aria-pressed', 'true');
	    }
	  };
	  window.addEventListener('DOMContentLoaded', () => {
	    showActivePortal(getPreferredPortal());
	    document.querySelectorAll('[data-ds-portal-value]').forEach(togglePortal => {
	      togglePortal.addEventListener('click', () => {
	        const portal = togglePortal.getAttribute('data-ds-portal-value');
	        setStoredPortal(portal);
	        setPortal(portal);
	        showActivePortal(portal);
	      });
	    });
	  });
	})();

	// Vendors import

	/**
	 * Splide default conf.
	 * @type {{i18n: {play: string, slideLabel: string, pause: string}}}
	 */
	Splide.defaults = {
	  i18n: {
	    slideLabel: '%s de %s',
	    play: 'Relancer le défilement du carrousel',
	    pause: 'Arrêter le défilement du carrousel'
	  }
	};

	/**
	 /**
	 * Event DOM ready
	 */
	document.addEventListener('DOMContentLoaded', () => {
	  // Store current breakpoint
	  mediaBreakpoint();

	  /**
	   * Onboarding
	   */
	  initOnboarding();

	  /**
	   * Skip links
	   */
	  initSkipLinks();

	  /**
	   * Show grid on keyboard event ctrl+shift+g
	   * Switch to dark mode on keyboard event ctrl+shift+c
	   */
	  showGrid();
	  switchColorMode();

	  /**
	   *  Menu main
	   */
	  if (DOM.menuMain) {
	    Promise.resolve().then(function () { return menuMain$1; }).then(menuMain => {
	      menuMain.default();
	    });
	  }

	  /**
	   *  Menu launcher
	   */
	  if (DOM.launcher) {
	    Promise.resolve().then(function () { return menuLauncher; }).then(launcher => {
	      launcher.default();
	    });
	  }

	  /**
	   *  Footer
	   */
	  if (DOM.footerMain) {
	    Promise.resolve().then(function () { return footer; }).then(footer => {
	      footer.default();
	    });
	  }

	  /**
	   * Banner alerts
	   */
	  if (hasBannerAlert()) {
	    Promise.resolve().then(function () { return bannerAlert; }).then(bannerAlerts => {
	      bannerAlerts.default();
	    });
	  }

	  /**
	   * Custom <select>
	   */
	  if (DOM.customSelects.length) {
	    Promise.resolve().then(function () { return customSelect; }).then(customSelects => {
	      customSelects.enhanceAll();
	    });
	  }

	  /**
	   * Form filters (eg. list page)
	   */
	  if (DOM.formFilters.length) {
	    Promise.resolve().then(function () { return formFilters; }).then(formsFilters => {
	      formsFilters.initAll();
	    });
	  }

	  /**
	   * Perpage results list page
	   */
	  if (DOM.perPageResults) {
	    Promise.resolve().then(function () { return filtersPerpage; }).then(filtersPerPage => {
	      filtersPerPage.default();
	    });
	  }

	  /**
	   * Filters list - FAQ and others
	   */
	  if (DOM.filters.length) {
	    Promise.resolve().then(function () { return filters$1; }).then(listFilters => {
	      listFilters.default();
	    });
	  }

	  /**
	   * Key numbers slider
	   */
	  if (DOM.keyFigures.length) {
	    Promise.resolve().then(function () { return keyFigures; }).then(keyFigures => {
	      keyFigures.default();
	    });
	  }

	  /**
	   * Cards slider(s)
	   */
	  if (DOM.cardsSlider.length) {
	    Promise.resolve().then(function () { return slidersCardsList; }).then(cardsSlider => {
	      cardsSlider.default();
	    });
	  }

	  /**
	   * Summary
	   */
	  if (DOM.summary) {
	    Promise.resolve().then(function () { return summary; }).then(({
	      default: SummaryA11y
	    }) => {
	      new SummaryA11y({});
	    });
	  }

	  /**
	   * Lightbox (Parvus)
	   */
	  if (DOM.lightboxs.length) {
	    Promise.resolve().then(function () { return lightbox; }).then(parvusLightbox => {
	      parvusLightbox.default();
	    });
	  }

	  /**
	   * Video players
	   */
	  if (DOM.videoPlayers.length) {
	    Promise.resolve().then(function () { return video; }).then(videosPlayers => {
	      videosPlayers.default();
	    });
	  }

	  /**
	   * Tooltips
	   */
	  if (DOM.tooltips.length) {
	    Promise.resolve().then(function () { return tooltip; }).then(tooltips => {
	      tooltips.default();
	    });
	  }

	  /**
	   * Notes
	   */
	  if (DOM.notes.length) {
	    Promise.resolve().then(function () { return notes; }).then(notes => {
	      notes.default();
	    });
	  }

	  /**
	   * Slider slideset
	   */
	  if (DOM.slidesets.length) {
	    Promise.resolve().then(function () { return slideset; }).then(slidesets => {
	      slidesets.default();
	    });
	  }

	  /**
	   * Slider slideshow
	   */
	  if (DOM.slideshows.length) {
	    Promise.resolve().then(function () { return slideshow; }).then(slideshows => {
	      slideshows.default();
	    });
	  }

	  /**
	   * Slider A la Une
	   */
	  if (DOM.aLaUne) {
	    Promise.resolve().then(function () { return aLaUne; }).then(aLaUne => {
	      aLaUne.default();
	    });
	  }

	  /**
	   * Textarea chars counter
	   */
	  if (DOM.textareaCharsCounters.length) {
	    Promise.resolve().then(function () { return charsCounter; }).then(charsCounter => {
	      charsCounter.default();
	    });
	  }

	  /**
	   * Glossary
	   */
	  if (DOM.glossary) {
	    Promise.resolve().then(function () { return glossary; }).then(glossary => {
	      glossary.default();
	    });
	  }

	  /**
	   * Datepickers
	   */
	  if (DOM.datepickers.length) {
	    Promise.resolve().then(function () { return datepicker; }).then(datepicker => {
	      datepicker.default();
	    });
	  }

	  /**
	   * Transports search form
	   */
	  if (DOM.transportsSearchForm) {
	    Promise.resolve().then(function () { return transportsSearchForm; }).then(transportsSearchForm => {
	      transportsSearchForm.default();
	    });
	  }

	  /**
	   *  Init Form Aides Search
	   */
	  if (DOM.formAidesSearch) {
	    Promise.resolve().then(function () { return formSearchFilters; }).then(formAidesSearch => {
	      formAidesSearch.default();
	    });
	  }
	  /**
	   *  Init Cards List Full Text
	   */
	  if (DOM.cardsFullText.length) {
	    Promise.resolve().then(function () { return cardsFullText; }).then(cardsFText => {
	      cardsFText.default();
	    });
	  }
	  /**
	   *  Init FAQ Transports
	   */
	  if (DOM.faqTransports) {
	    Promise.resolve().then(function () { return formSearchFilters; }).then(faqTransports => {
	      faqTransports.default();
	    });
	  }
	  /**
	   * Init Faq Responses
	   */
	  const faqResponsesContainers = document.querySelectorAll('.mod-faq-transports');
	  if (faqResponsesContainers.length) {
	    Promise.resolve().then(function () { return searchResponses; }).then(faqResponses => {
	      faqResponsesContainers.forEach(container => {
	        faqResponses.default(container);
	      });
	    });
	  }
	  /**
	   *  Init Lib Leaflet
	   */
	  if (DOM.leaflet) {
	    Promise.resolve().then(function () { return leaflet; }).then(({
	      default: initLeaflet
	    }) => {
	      initLeaflet();
	    });
	  }

	  /**
	   * Init notifications
	   */
	  if (DOM.notifications.length) {
	    Promise.resolve().then(function () { return notification; }).then(notification => {
	      notification.default();
	    });
	  }

	  /**
	   * Autocomplete input field
	   * Handled in Drupal
	   */

	  // if (DOM.autoCompleteFields) {
	  //   import('./modules/autocomplete').then((autocomplete) => {
	  //     autocomplete.default();
	  //   });
	  // }

	  // if (DOM.autoCompleteFields) {
	  //   import('./modules/autocomplete-ajax').then((autocomplete) => {
	  //     autocomplete.default();
	  //   });
	  // }

	  /**
	   * Module data-visualisation
	   */
	  if (DOM.dataViz.length) {
	    Promise.resolve().then(function () { return dataViz$1; }).then(dataViz => {
	      dataViz.default();
	    });
	  }

	  /**
	   * Toggle/accordion expand/collapse
	   */
	  if (DOM.togglers.length) {
	    Promise.resolve().then(function () { return toggle; }).then(toggle => {
	      toggle.default();
	    });
	  }

	  /**
	   * Module select departement (transports)
	   */
	  if (DOM.selectDepartement) {
	    Promise.resolve().then(function () { return selectDepartement; }).then(selectDepartement => {
	      selectDepartement.default();
	    });
	  }

	  /**
	   * Form validator
	   */
	  if (DOM.htmlFormsValidate) {
	    Promise.resolve().then(function () { return formValidator; }).then(formValidate => {
	      formValidate.default();
	    });
	  }

	  /**
	   * Range sliders
	   */
	  if (DOM.rangeSliders.length) {
	    Promise.resolve().then(function () { return rangeSliders; }).then(rangeSliders => {
	      rangeSliders.default();
	    });
	  }

	  /**
	   * Event cards — apply is-coming / is-current / is-past status classes
	   */
	  if (DOM.eventCards.length) {
	    Promise.resolve().then(function () { return eventCards; }).then(eventCards => {
	      eventCards.default();
	    });
	  }
	});

	/**
	 * Event resize
	 */

	window.addEventListener('optimizedResize', () => {
	  mediaBreakpoint();
	  // picturefill({
	  //       reevaluate: true
	  //   });
	});

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function () {
	  return root.Date.now();
	};

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;

	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}

	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;

	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
	}

	/** Built-in value references. */
	var Symbol$1 = root.Symbol;

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto$1.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString$1 = objectProto$1.toString;

	/** Built-in value references. */
	var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
	    tag = value[symToStringTag$1];
	  try {
	    value[symToStringTag$1] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	  var result = nativeObjectToString$1.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag$1] = tag;
	    } else {
	      delete value[symToStringTag$1];
	    }
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	  undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
	}

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? other + '' : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
	}

	/** Error message constants. */
	var FUNC_ERROR_TEXT$1 = 'Expected a function';

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	  nativeMin = Math.min;

	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	    lastThis,
	    maxWait,
	    result,
	    timerId,
	    lastCallTime,
	    lastInvokeTime = 0,
	    leading = false,
	    maxing = false,
	    trailing = true;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT$1);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  function invokeFunc(time) {
	    var args = lastArgs,
	      thisArg = lastThis;
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	      timeSinceLastInvoke = time - lastInvokeTime,
	      timeWaiting = wait - timeSinceLastCall;
	    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
	  }
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	      timeSinceLastInvoke = time - lastInvokeTime;

	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	  function trailingEdge(time) {
	    timerId = undefined;

	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	  function debounced() {
	    var time = now(),
	      isInvoking = shouldInvoke(time);
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle$1(func, wait, options) {
	  var leading = true,
	    trailing = true;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}

	/**
	 * simplebar-core - v1.3.2
	 * Scrollbars, simpler.
	 * https://grsmto.github.io/simplebar/
	 *
	 * Made by Adrien Denat from a fork by Jonathan Nicol
	 * Under MIT License
	 */


	/******************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	var __assign = function () {
	  __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	      s = arguments[i];
	      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	  };
	  return __assign.apply(this, arguments);
	};
	function getElementWindow$1(element) {
	  if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) {
	    return window;
	  }
	  return element.ownerDocument.defaultView;
	}
	function getElementDocument$1(element) {
	  if (!element || !element.ownerDocument) {
	    return document;
	  }
	  return element.ownerDocument;
	}
	// Helper function to retrieve options from element attributes
	var getOptions$1 = function (obj) {
	  var initialObj = {};
	  var options = Array.prototype.reduce.call(obj, function (acc, attribute) {
	    var option = attribute.name.match(/data-simplebar-(.+)/);
	    if (option) {
	      var key = option[1].replace(/\W+(.)/g, function (_, chr) {
	        return chr.toUpperCase();
	      });
	      switch (attribute.value) {
	        case 'true':
	          acc[key] = true;
	          break;
	        case 'false':
	          acc[key] = false;
	          break;
	        case undefined:
	          acc[key] = true;
	          break;
	        default:
	          acc[key] = attribute.value;
	      }
	    }
	    return acc;
	  }, initialObj);
	  return options;
	};
	function addClasses$1(el, classes) {
	  var _a;
	  if (!el) return;
	  (_a = el.classList).add.apply(_a, classes.split(' '));
	}
	function removeClasses$1(el, classes) {
	  if (!el) return;
	  classes.split(' ').forEach(function (className) {
	    el.classList.remove(className);
	  });
	}
	function classNamesToQuery$1(classNames) {
	  return ".".concat(classNames.split(' ').join('.'));
	}
	var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var helpers = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  addClasses: addClasses$1,
	  canUseDOM: canUseDOM$1,
	  classNamesToQuery: classNamesToQuery$1,
	  getElementDocument: getElementDocument$1,
	  getElementWindow: getElementWindow$1,
	  getOptions: getOptions$1,
	  removeClasses: removeClasses$1
	});
	var cachedScrollbarWidth = null;
	var cachedDevicePixelRatio = null;
	if (canUseDOM$1) {
	  window.addEventListener('resize', function () {
	    if (cachedDevicePixelRatio !== window.devicePixelRatio) {
	      cachedDevicePixelRatio = window.devicePixelRatio;
	      cachedScrollbarWidth = null;
	    }
	  });
	}
	function scrollbarWidth() {
	  if (cachedScrollbarWidth === null) {
	    if (typeof document === 'undefined') {
	      cachedScrollbarWidth = 0;
	      return cachedScrollbarWidth;
	    }
	    var body = document.body;
	    var box = document.createElement('div');
	    box.classList.add('simplebar-hide-scrollbar');
	    body.appendChild(box);
	    var width = box.getBoundingClientRect().right;
	    body.removeChild(box);
	    cachedScrollbarWidth = width;
	  }
	  return cachedScrollbarWidth;
	}
	var getElementWindow = getElementWindow$1,
	  getElementDocument = getElementDocument$1,
	  getOptions$2 = getOptions$1,
	  addClasses$2 = addClasses$1,
	  removeClasses = removeClasses$1,
	  classNamesToQuery = classNamesToQuery$1;
	var SimpleBarCore = /** @class */function () {
	  function SimpleBarCore(element, options) {
	    if (options === void 0) {
	      options = {};
	    }
	    var _this = this;
	    this.removePreventClickId = null;
	    this.minScrollbarWidth = 20;
	    this.stopScrollDelay = 175;
	    this.isScrolling = false;
	    this.isMouseEntering = false;
	    this.isDragging = false;
	    this.scrollXTicking = false;
	    this.scrollYTicking = false;
	    this.wrapperEl = null;
	    this.contentWrapperEl = null;
	    this.contentEl = null;
	    this.offsetEl = null;
	    this.maskEl = null;
	    this.placeholderEl = null;
	    this.heightAutoObserverWrapperEl = null;
	    this.heightAutoObserverEl = null;
	    this.rtlHelpers = null;
	    this.scrollbarWidth = 0;
	    this.resizeObserver = null;
	    this.mutationObserver = null;
	    this.elStyles = null;
	    this.isRtl = null;
	    this.mouseX = 0;
	    this.mouseY = 0;
	    this.onMouseMove = function () {};
	    this.onWindowResize = function () {};
	    this.onStopScrolling = function () {};
	    this.onMouseEntered = function () {};
	    /**
	     * On scroll event handling
	     */
	    this.onScroll = function () {
	      var elWindow = getElementWindow(_this.el);
	      if (!_this.scrollXTicking) {
	        elWindow.requestAnimationFrame(_this.scrollX);
	        _this.scrollXTicking = true;
	      }
	      if (!_this.scrollYTicking) {
	        elWindow.requestAnimationFrame(_this.scrollY);
	        _this.scrollYTicking = true;
	      }
	      if (!_this.isScrolling) {
	        _this.isScrolling = true;
	        addClasses$2(_this.el, _this.classNames.scrolling);
	      }
	      _this.showScrollbar('x');
	      _this.showScrollbar('y');
	      _this.onStopScrolling();
	    };
	    this.scrollX = function () {
	      if (_this.axis.x.isOverflowing) {
	        _this.positionScrollbar('x');
	      }
	      _this.scrollXTicking = false;
	    };
	    this.scrollY = function () {
	      if (_this.axis.y.isOverflowing) {
	        _this.positionScrollbar('y');
	      }
	      _this.scrollYTicking = false;
	    };
	    this._onStopScrolling = function () {
	      removeClasses(_this.el, _this.classNames.scrolling);
	      if (_this.options.autoHide) {
	        _this.hideScrollbar('x');
	        _this.hideScrollbar('y');
	      }
	      _this.isScrolling = false;
	    };
	    this.onMouseEnter = function () {
	      if (!_this.isMouseEntering) {
	        addClasses$2(_this.el, _this.classNames.mouseEntered);
	        _this.showScrollbar('x');
	        _this.showScrollbar('y');
	        _this.isMouseEntering = true;
	      }
	      _this.onMouseEntered();
	    };
	    this._onMouseEntered = function () {
	      removeClasses(_this.el, _this.classNames.mouseEntered);
	      if (_this.options.autoHide) {
	        _this.hideScrollbar('x');
	        _this.hideScrollbar('y');
	      }
	      _this.isMouseEntering = false;
	    };
	    this._onMouseMove = function (e) {
	      _this.mouseX = e.clientX;
	      _this.mouseY = e.clientY;
	      if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
	        _this.onMouseMoveForAxis('x');
	      }
	      if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
	        _this.onMouseMoveForAxis('y');
	      }
	    };
	    this.onMouseLeave = function () {
	      _this.onMouseMove.cancel();
	      if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
	        _this.onMouseLeaveForAxis('x');
	      }
	      if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
	        _this.onMouseLeaveForAxis('y');
	      }
	      _this.mouseX = -1;
	      _this.mouseY = -1;
	    };
	    this._onWindowResize = function () {
	      // Recalculate scrollbarWidth in case it's a zoom
	      _this.scrollbarWidth = _this.getScrollbarWidth();
	      _this.hideNativeScrollbar();
	    };
	    this.onPointerEvent = function (e) {
	      if (!_this.axis.x.track.el || !_this.axis.y.track.el || !_this.axis.x.scrollbar.el || !_this.axis.y.scrollbar.el) return;
	      var isWithinTrackXBounds, isWithinTrackYBounds;
	      _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
	      _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
	      if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
	        isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
	      }
	      if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
	        isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
	      }
	      // If any pointer event is called on the scrollbar
	      if (isWithinTrackXBounds || isWithinTrackYBounds) {
	        // Prevent event leaking
	        e.stopPropagation();
	        if (e.type === 'pointerdown' && e.pointerType !== 'touch') {
	          if (isWithinTrackXBounds) {
	            _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
	            if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) {
	              _this.onDragStart(e, 'x');
	            } else {
	              _this.onTrackClick(e, 'x');
	            }
	          }
	          if (isWithinTrackYBounds) {
	            _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
	            if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) {
	              _this.onDragStart(e, 'y');
	            } else {
	              _this.onTrackClick(e, 'y');
	            }
	          }
	        }
	      }
	    };
	    /**
	     * Drag scrollbar handle
	     */
	    this.drag = function (e) {
	      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	      if (!_this.draggedAxis || !_this.contentWrapperEl) return;
	      var eventOffset;
	      var track = _this.axis[_this.draggedAxis].track;
	      var trackSize = (_b = (_a = track.rect) === null || _a === void 0 ? void 0 : _a[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _b !== void 0 ? _b : 0;
	      var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
	      var contentSize = (_d = (_c = _this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c[_this.axis[_this.draggedAxis].scrollSizeAttr]) !== null && _d !== void 0 ? _d : 0;
	      var hostSize = parseInt((_f = (_e = _this.elStyles) === null || _e === void 0 ? void 0 : _e[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _f !== void 0 ? _f : '0px', 10);
	      e.preventDefault();
	      e.stopPropagation();
	      if (_this.draggedAxis === 'y') {
	        eventOffset = e.pageY;
	      } else {
	        eventOffset = e.pageX;
	      }
	      // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
	      var dragPos = eventOffset - ((_h = (_g = track.rect) === null || _g === void 0 ? void 0 : _g[_this.axis[_this.draggedAxis].offsetAttr]) !== null && _h !== void 0 ? _h : 0) - _this.axis[_this.draggedAxis].dragOffset;
	      dragPos = _this.draggedAxis === 'x' && _this.isRtl ? ((_k = (_j = track.rect) === null || _j === void 0 ? void 0 : _j[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _k !== void 0 ? _k : 0) - scrollbar.size - dragPos : dragPos;
	      // Convert the mouse position into a percentage of the scrollbar height/width.
	      var dragPerc = dragPos / (trackSize - scrollbar.size);
	      // Scroll the content by the same percentage.
	      var scrollPos = dragPerc * (contentSize - hostSize);
	      // Fix browsers inconsistency on RTL
	      if (_this.draggedAxis === 'x' && _this.isRtl) {
	        scrollPos = ((_l = SimpleBarCore.getRtlHelpers()) === null || _l === void 0 ? void 0 : _l.isScrollingToNegative) ? -scrollPos : scrollPos;
	      }
	      _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
	    };
	    /**
	     * End scroll handle drag
	     */
	    this.onEndDrag = function (e) {
	      _this.isDragging = false;
	      var elDocument = getElementDocument(_this.el);
	      var elWindow = getElementWindow(_this.el);
	      e.preventDefault();
	      e.stopPropagation();
	      removeClasses(_this.el, _this.classNames.dragging);
	      _this.onStopScrolling();
	      elDocument.removeEventListener('mousemove', _this.drag, true);
	      elDocument.removeEventListener('mouseup', _this.onEndDrag, true);
	      _this.removePreventClickId = elWindow.setTimeout(function () {
	        // Remove these asynchronously so we still suppress click events
	        // generated simultaneously with mouseup.
	        elDocument.removeEventListener('click', _this.preventClick, true);
	        elDocument.removeEventListener('dblclick', _this.preventClick, true);
	        _this.removePreventClickId = null;
	      });
	    };
	    /**
	     * Handler to ignore click events during drag
	     */
	    this.preventClick = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	    };
	    this.el = element;
	    this.options = __assign(__assign({}, SimpleBarCore.defaultOptions), options);
	    this.classNames = __assign(__assign({}, SimpleBarCore.defaultOptions.classNames), options.classNames);
	    this.axis = {
	      x: {
	        scrollOffsetAttr: 'scrollLeft',
	        sizeAttr: 'width',
	        scrollSizeAttr: 'scrollWidth',
	        offsetSizeAttr: 'offsetWidth',
	        offsetAttr: 'left',
	        overflowAttr: 'overflowX',
	        dragOffset: 0,
	        isOverflowing: true,
	        forceVisible: false,
	        track: {
	          size: null,
	          el: null,
	          rect: null,
	          isVisible: false
	        },
	        scrollbar: {
	          size: null,
	          el: null,
	          rect: null,
	          isVisible: false
	        }
	      },
	      y: {
	        scrollOffsetAttr: 'scrollTop',
	        sizeAttr: 'height',
	        scrollSizeAttr: 'scrollHeight',
	        offsetSizeAttr: 'offsetHeight',
	        offsetAttr: 'top',
	        overflowAttr: 'overflowY',
	        dragOffset: 0,
	        isOverflowing: true,
	        forceVisible: false,
	        track: {
	          size: null,
	          el: null,
	          rect: null,
	          isVisible: false
	        },
	        scrollbar: {
	          size: null,
	          el: null,
	          rect: null,
	          isVisible: false
	        }
	      }
	    };
	    if (typeof this.el !== 'object' || !this.el.nodeName) {
	      throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));
	    }
	    this.onMouseMove = throttle$1(this._onMouseMove, 64);
	    this.onWindowResize = debounce(this._onWindowResize, 64, {
	      leading: true
	    });
	    this.onStopScrolling = debounce(this._onStopScrolling, this.stopScrollDelay);
	    this.onMouseEntered = debounce(this._onMouseEntered, this.stopScrollDelay);
	    this.init();
	  }
	  /**
	   * Helper to fix browsers inconsistency on RTL:
	   *  - Firefox inverts the scrollbar initial position
	   *  - IE11 inverts both scrollbar position and scrolling offset
	   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
	   */
	  SimpleBarCore.getRtlHelpers = function () {
	    if (SimpleBarCore.rtlHelpers) {
	      return SimpleBarCore.rtlHelpers;
	    }
	    var dummyDiv = document.createElement('div');
	    dummyDiv.innerHTML = '<div class="simplebar-dummy-scrollbar-size"><div></div></div>';
	    var scrollbarDummyEl = dummyDiv.firstElementChild;
	    var dummyChild = scrollbarDummyEl === null || scrollbarDummyEl === void 0 ? void 0 : scrollbarDummyEl.firstElementChild;
	    if (!dummyChild) return null;
	    document.body.appendChild(scrollbarDummyEl);
	    scrollbarDummyEl.scrollLeft = 0;
	    var dummyContainerOffset = SimpleBarCore.getOffset(scrollbarDummyEl);
	    var dummyChildOffset = SimpleBarCore.getOffset(dummyChild);
	    scrollbarDummyEl.scrollLeft = -999;
	    var dummyChildOffsetAfterScroll = SimpleBarCore.getOffset(dummyChild);
	    document.body.removeChild(scrollbarDummyEl);
	    SimpleBarCore.rtlHelpers = {
	      // determines if the scrolling is responding with negative values
	      isScrollOriginAtZero: dummyContainerOffset.left !== dummyChildOffset.left,
	      // determines if the origin scrollbar position is inverted or not (positioned on left or right)
	      isScrollingToNegative: dummyChildOffset.left !== dummyChildOffsetAfterScroll.left
	    };
	    return SimpleBarCore.rtlHelpers;
	  };
	  SimpleBarCore.prototype.getScrollbarWidth = function () {
	    // Try/catch for FF 56 throwing on undefined computedStyles
	    try {
	      // Detect browsers supporting CSS scrollbar styling and do not calculate
	      if (this.contentWrapperEl && getComputedStyle(this.contentWrapperEl, '::-webkit-scrollbar').display === 'none' || 'scrollbarWidth' in document.documentElement.style || '-ms-overflow-style' in document.documentElement.style) {
	        return 0;
	      } else {
	        return scrollbarWidth();
	      }
	    } catch (e) {
	      return scrollbarWidth();
	    }
	  };
	  SimpleBarCore.getOffset = function (el) {
	    var rect = el.getBoundingClientRect();
	    var elDocument = getElementDocument(el);
	    var elWindow = getElementWindow(el);
	    return {
	      top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
	      left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
	    };
	  };
	  SimpleBarCore.prototype.init = function () {
	    // We stop here on server-side
	    if (canUseDOM$1) {
	      this.initDOM();
	      this.rtlHelpers = SimpleBarCore.getRtlHelpers();
	      this.scrollbarWidth = this.getScrollbarWidth();
	      this.recalculate();
	      this.initListeners();
	    }
	  };
	  SimpleBarCore.prototype.initDOM = function () {
	    var _a, _b;
	    // assume that element has his DOM already initiated
	    this.wrapperEl = this.el.querySelector(classNamesToQuery(this.classNames.wrapper));
	    this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector(classNamesToQuery(this.classNames.contentWrapper));
	    this.contentEl = this.options.contentNode || this.el.querySelector(classNamesToQuery(this.classNames.contentEl));
	    this.offsetEl = this.el.querySelector(classNamesToQuery(this.classNames.offset));
	    this.maskEl = this.el.querySelector(classNamesToQuery(this.classNames.mask));
	    this.placeholderEl = this.findChild(this.wrapperEl, classNamesToQuery(this.classNames.placeholder));
	    this.heightAutoObserverWrapperEl = this.el.querySelector(classNamesToQuery(this.classNames.heightAutoObserverWrapperEl));
	    this.heightAutoObserverEl = this.el.querySelector(classNamesToQuery(this.classNames.heightAutoObserverEl));
	    this.axis.x.track.el = this.findChild(this.el, "".concat(classNamesToQuery(this.classNames.track)).concat(classNamesToQuery(this.classNames.horizontal)));
	    this.axis.y.track.el = this.findChild(this.el, "".concat(classNamesToQuery(this.classNames.track)).concat(classNamesToQuery(this.classNames.vertical)));
	    this.axis.x.scrollbar.el = ((_a = this.axis.x.track.el) === null || _a === void 0 ? void 0 : _a.querySelector(classNamesToQuery(this.classNames.scrollbar))) || null;
	    this.axis.y.scrollbar.el = ((_b = this.axis.y.track.el) === null || _b === void 0 ? void 0 : _b.querySelector(classNamesToQuery(this.classNames.scrollbar))) || null;
	    if (!this.options.autoHide) {
	      addClasses$2(this.axis.x.scrollbar.el, this.classNames.visible);
	      addClasses$2(this.axis.y.scrollbar.el, this.classNames.visible);
	    }
	  };
	  SimpleBarCore.prototype.initListeners = function () {
	    var _this = this;
	    var _a;
	    var elWindow = getElementWindow(this.el);
	    // Event listeners
	    this.el.addEventListener('mouseenter', this.onMouseEnter);
	    this.el.addEventListener('pointerdown', this.onPointerEvent, true);
	    this.el.addEventListener('mousemove', this.onMouseMove);
	    this.el.addEventListener('mouseleave', this.onMouseLeave);
	    (_a = this.contentWrapperEl) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', this.onScroll);
	    // Browser zoom triggers a window resize
	    elWindow.addEventListener('resize', this.onWindowResize);
	    if (!this.contentEl) return;
	    if (window.ResizeObserver) {
	      // Hack for https://github.com/WICG/ResizeObserver/issues/38
	      var resizeObserverStarted_1 = false;
	      var resizeObserver = elWindow.ResizeObserver || ResizeObserver;
	      this.resizeObserver = new resizeObserver(function () {
	        if (!resizeObserverStarted_1) return;
	        elWindow.requestAnimationFrame(function () {
	          _this.recalculate();
	        });
	      });
	      this.resizeObserver.observe(this.el);
	      this.resizeObserver.observe(this.contentEl);
	      elWindow.requestAnimationFrame(function () {
	        resizeObserverStarted_1 = true;
	      });
	    }
	    // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
	    this.mutationObserver = new elWindow.MutationObserver(function () {
	      elWindow.requestAnimationFrame(function () {
	        _this.recalculate();
	      });
	    });
	    this.mutationObserver.observe(this.contentEl, {
	      childList: true,
	      subtree: true,
	      characterData: true
	    });
	  };
	  SimpleBarCore.prototype.recalculate = function () {
	    if (!this.heightAutoObserverEl || !this.contentEl || !this.contentWrapperEl || !this.wrapperEl || !this.placeholderEl) return;
	    var elWindow = getElementWindow(this.el);
	    this.elStyles = elWindow.getComputedStyle(this.el);
	    this.isRtl = this.elStyles.direction === 'rtl';
	    var contentElOffsetWidth = this.contentEl.offsetWidth;
	    var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
	    var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1 || contentElOffsetWidth > 0;
	    var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
	    var elOverflowX = this.elStyles.overflowX;
	    var elOverflowY = this.elStyles.overflowY;
	    this.contentEl.style.padding = "".concat(this.elStyles.paddingTop, " ").concat(this.elStyles.paddingRight, " ").concat(this.elStyles.paddingBottom, " ").concat(this.elStyles.paddingLeft);
	    this.wrapperEl.style.margin = "-".concat(this.elStyles.paddingTop, " -").concat(this.elStyles.paddingRight, " -").concat(this.elStyles.paddingBottom, " -").concat(this.elStyles.paddingLeft);
	    var contentElScrollHeight = this.contentEl.scrollHeight;
	    var contentElScrollWidth = this.contentEl.scrollWidth;
	    this.contentWrapperEl.style.height = isHeightAuto ? 'auto' : '100%';
	    // Determine placeholder size
	    this.placeholderEl.style.width = isWidthAuto ? "".concat(contentElOffsetWidth || contentElScrollWidth, "px") : 'auto';
	    this.placeholderEl.style.height = "".concat(contentElScrollHeight, "px");
	    var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
	    this.axis.x.isOverflowing = contentElOffsetWidth !== 0 && contentElScrollWidth > contentElOffsetWidth;
	    this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight;
	    // Set isOverflowing to false if user explicitely set hidden overflow
	    this.axis.x.isOverflowing = elOverflowX === 'hidden' ? false : this.axis.x.isOverflowing;
	    this.axis.y.isOverflowing = elOverflowY === 'hidden' ? false : this.axis.y.isOverflowing;
	    this.axis.x.forceVisible = this.options.forceVisible === 'x' || this.options.forceVisible === true;
	    this.axis.y.forceVisible = this.options.forceVisible === 'y' || this.options.forceVisible === true;
	    this.hideNativeScrollbar();
	    // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
	    var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
	    var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
	    this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
	    this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
	    this.axis.x.scrollbar.size = this.getScrollbarSize('x');
	    this.axis.y.scrollbar.size = this.getScrollbarSize('y');
	    if (this.axis.x.scrollbar.el) this.axis.x.scrollbar.el.style.width = "".concat(this.axis.x.scrollbar.size, "px");
	    if (this.axis.y.scrollbar.el) this.axis.y.scrollbar.el.style.height = "".concat(this.axis.y.scrollbar.size, "px");
	    this.positionScrollbar('x');
	    this.positionScrollbar('y');
	    this.toggleTrackVisibility('x');
	    this.toggleTrackVisibility('y');
	  };
	  /**
	   * Calculate scrollbar size
	   */
	  SimpleBarCore.prototype.getScrollbarSize = function (axis) {
	    var _a, _b;
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    if (!this.axis[axis].isOverflowing || !this.contentEl) {
	      return 0;
	    }
	    var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
	    var trackSize = (_b = (_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) !== null && _b !== void 0 ? _b : 0;
	    var scrollbarRatio = trackSize / contentSize;
	    var scrollbarSize;
	    // Calculate new height/position of drag handle.
	    scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
	    if (this.options.scrollbarMaxSize) {
	      scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
	    }
	    return scrollbarSize;
	  };
	  SimpleBarCore.prototype.positionScrollbar = function (axis) {
	    var _a, _b, _c;
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    var scrollbar = this.axis[axis].scrollbar;
	    if (!this.axis[axis].isOverflowing || !this.contentWrapperEl || !scrollbar.el || !this.elStyles) {
	      return;
	    }
	    var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
	    var trackSize = ((_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) || 0;
	    var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
	    var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
	    scrollOffset = axis === 'x' && this.isRtl && ((_b = SimpleBarCore.getRtlHelpers()) === null || _b === void 0 ? void 0 : _b.isScrollOriginAtZero) ? -scrollOffset : scrollOffset;
	    if (axis === 'x' && this.isRtl) {
	      scrollOffset = ((_c = SimpleBarCore.getRtlHelpers()) === null || _c === void 0 ? void 0 : _c.isScrollingToNegative) ? scrollOffset : -scrollOffset;
	    }
	    var scrollPourcent = scrollOffset / (contentSize - hostSize);
	    var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
	    handleOffset = axis === 'x' && this.isRtl ? -handleOffset + (trackSize - scrollbar.size) : handleOffset;
	    scrollbar.el.style.transform = axis === 'x' ? "translate3d(".concat(handleOffset, "px, 0, 0)") : "translate3d(0, ".concat(handleOffset, "px, 0)");
	  };
	  SimpleBarCore.prototype.toggleTrackVisibility = function (axis) {
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    var track = this.axis[axis].track.el;
	    var scrollbar = this.axis[axis].scrollbar.el;
	    if (!track || !scrollbar || !this.contentWrapperEl) return;
	    if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
	      track.style.visibility = 'visible';
	      this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'scroll';
	      this.el.classList.add("".concat(this.classNames.scrollable, "-").concat(axis));
	    } else {
	      track.style.visibility = 'hidden';
	      this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'hidden';
	      this.el.classList.remove("".concat(this.classNames.scrollable, "-").concat(axis));
	    }
	    // Even if forceVisible is enabled, scrollbar itself should be hidden
	    if (this.axis[axis].isOverflowing) {
	      scrollbar.style.display = 'block';
	    } else {
	      scrollbar.style.display = 'none';
	    }
	  };
	  SimpleBarCore.prototype.showScrollbar = function (axis) {
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    if (this.axis[axis].isOverflowing && !this.axis[axis].scrollbar.isVisible) {
	      addClasses$2(this.axis[axis].scrollbar.el, this.classNames.visible);
	      this.axis[axis].scrollbar.isVisible = true;
	    }
	  };
	  SimpleBarCore.prototype.hideScrollbar = function (axis) {
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    if (this.isDragging) return;
	    if (this.axis[axis].isOverflowing && this.axis[axis].scrollbar.isVisible) {
	      removeClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
	      this.axis[axis].scrollbar.isVisible = false;
	    }
	  };
	  SimpleBarCore.prototype.hideNativeScrollbar = function () {
	    if (!this.offsetEl) return;
	    this.offsetEl.style[this.isRtl ? 'left' : 'right'] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-".concat(this.scrollbarWidth, "px") : '0px';
	    this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-".concat(this.scrollbarWidth, "px") : '0px';
	  };
	  SimpleBarCore.prototype.onMouseMoveForAxis = function (axis) {
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    var currentAxis = this.axis[axis];
	    if (!currentAxis.track.el || !currentAxis.scrollbar.el) return;
	    currentAxis.track.rect = currentAxis.track.el.getBoundingClientRect();
	    currentAxis.scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
	    if (this.isWithinBounds(currentAxis.track.rect)) {
	      this.showScrollbar(axis);
	      addClasses$2(currentAxis.track.el, this.classNames.hover);
	      if (this.isWithinBounds(currentAxis.scrollbar.rect)) {
	        addClasses$2(currentAxis.scrollbar.el, this.classNames.hover);
	      } else {
	        removeClasses(currentAxis.scrollbar.el, this.classNames.hover);
	      }
	    } else {
	      removeClasses(currentAxis.track.el, this.classNames.hover);
	      if (this.options.autoHide) {
	        this.hideScrollbar(axis);
	      }
	    }
	  };
	  SimpleBarCore.prototype.onMouseLeaveForAxis = function (axis) {
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    removeClasses(this.axis[axis].track.el, this.classNames.hover);
	    removeClasses(this.axis[axis].scrollbar.el, this.classNames.hover);
	    if (this.options.autoHide) {
	      this.hideScrollbar(axis);
	    }
	  };
	  /**
	   * on scrollbar handle drag movement starts
	   */
	  SimpleBarCore.prototype.onDragStart = function (e, axis) {
	    var _a;
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    this.isDragging = true;
	    var elDocument = getElementDocument(this.el);
	    var elWindow = getElementWindow(this.el);
	    var scrollbar = this.axis[axis].scrollbar;
	    // Measure how far the user's mouse is from the top of the scrollbar drag handle.
	    var eventOffset = axis === 'y' ? e.pageY : e.pageX;
	    this.axis[axis].dragOffset = eventOffset - (((_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) || 0);
	    this.draggedAxis = axis;
	    addClasses$2(this.el, this.classNames.dragging);
	    elDocument.addEventListener('mousemove', this.drag, true);
	    elDocument.addEventListener('mouseup', this.onEndDrag, true);
	    if (this.removePreventClickId === null) {
	      elDocument.addEventListener('click', this.preventClick, true);
	      elDocument.addEventListener('dblclick', this.preventClick, true);
	    } else {
	      elWindow.clearTimeout(this.removePreventClickId);
	      this.removePreventClickId = null;
	    }
	  };
	  SimpleBarCore.prototype.onTrackClick = function (e, axis) {
	    var _this = this;
	    var _a, _b, _c, _d;
	    if (axis === void 0) {
	      axis = 'y';
	    }
	    var currentAxis = this.axis[axis];
	    if (!this.options.clickOnTrack || !currentAxis.scrollbar.el || !this.contentWrapperEl) return;
	    // Preventing the event's default to trigger click underneath
	    e.preventDefault();
	    var elWindow = getElementWindow(this.el);
	    this.axis[axis].scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
	    var scrollbar = this.axis[axis].scrollbar;
	    var scrollbarOffset = (_b = (_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) !== null && _b !== void 0 ? _b : 0;
	    var hostSize = parseInt((_d = (_c = this.elStyles) === null || _c === void 0 ? void 0 : _c[this.axis[axis].sizeAttr]) !== null && _d !== void 0 ? _d : '0px', 10);
	    var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
	    var t = axis === 'y' ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
	    var dir = t < 0 ? -1 : 1;
	    var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
	    var speed = 40;
	    var scrollTo = function () {
	      if (!_this.contentWrapperEl) return;
	      if (dir === -1) {
	        if (scrolled > scrollSize) {
	          scrolled -= speed;
	          _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
	          elWindow.requestAnimationFrame(scrollTo);
	        }
	      } else {
	        if (scrolled < scrollSize) {
	          scrolled += speed;
	          _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
	          elWindow.requestAnimationFrame(scrollTo);
	        }
	      }
	    };
	    scrollTo();
	  };
	  /**
	   * Getter for content element
	   */
	  SimpleBarCore.prototype.getContentElement = function () {
	    return this.contentEl;
	  };
	  /**
	   * Getter for original scrolling element
	   */
	  SimpleBarCore.prototype.getScrollElement = function () {
	    return this.contentWrapperEl;
	  };
	  SimpleBarCore.prototype.removeListeners = function () {
	    var elWindow = getElementWindow(this.el);
	    // Event listeners
	    this.el.removeEventListener('mouseenter', this.onMouseEnter);
	    this.el.removeEventListener('pointerdown', this.onPointerEvent, true);
	    this.el.removeEventListener('mousemove', this.onMouseMove);
	    this.el.removeEventListener('mouseleave', this.onMouseLeave);
	    if (this.contentWrapperEl) {
	      this.contentWrapperEl.removeEventListener('scroll', this.onScroll);
	    }
	    elWindow.removeEventListener('resize', this.onWindowResize);
	    if (this.mutationObserver) {
	      this.mutationObserver.disconnect();
	    }
	    if (this.resizeObserver) {
	      this.resizeObserver.disconnect();
	    }
	    // Cancel all debounced functions
	    this.onMouseMove.cancel();
	    this.onWindowResize.cancel();
	    this.onStopScrolling.cancel();
	    this.onMouseEntered.cancel();
	  };
	  /**
	   * Remove all listeners from DOM nodes
	   */
	  SimpleBarCore.prototype.unMount = function () {
	    this.removeListeners();
	  };
	  /**
	   * Check if mouse is within bounds
	   */
	  SimpleBarCore.prototype.isWithinBounds = function (bbox) {
	    return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
	  };
	  /**
	   * Find element children matches query
	   */
	  SimpleBarCore.prototype.findChild = function (el, query) {
	    var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
	    return Array.prototype.filter.call(el.children, function (child) {
	      return matches.call(child, query);
	    })[0];
	  };
	  SimpleBarCore.rtlHelpers = null;
	  SimpleBarCore.defaultOptions = {
	    forceVisible: false,
	    clickOnTrack: true,
	    scrollbarMinSize: 25,
	    scrollbarMaxSize: 0,
	    ariaLabel: 'scrollable content',
	    tabIndex: 0,
	    classNames: {
	      contentEl: 'simplebar-content',
	      contentWrapper: 'simplebar-content-wrapper',
	      offset: 'simplebar-offset',
	      mask: 'simplebar-mask',
	      wrapper: 'simplebar-wrapper',
	      placeholder: 'simplebar-placeholder',
	      scrollbar: 'simplebar-scrollbar',
	      track: 'simplebar-track',
	      heightAutoObserverWrapperEl: 'simplebar-height-auto-observer-wrapper',
	      heightAutoObserverEl: 'simplebar-height-auto-observer',
	      visible: 'simplebar-visible',
	      horizontal: 'simplebar-horizontal',
	      vertical: 'simplebar-vertical',
	      hover: 'simplebar-hover',
	      dragging: 'simplebar-dragging',
	      scrolling: 'simplebar-scrolling',
	      scrollable: 'simplebar-scrollable',
	      mouseEntered: 'simplebar-mouse-entered'
	    },
	    scrollableNode: null,
	    contentNode: null,
	    autoHide: true
	  };
	  /**
	   * Static functions
	   */
	  SimpleBarCore.getOptions = getOptions$2;
	  SimpleBarCore.helpers = helpers;
	  return SimpleBarCore;
	}();

	/**
	 * simplebar - v6.3.3
	 * Scrollbars, simpler.
	 * https://grsmto.github.io/simplebar/
	 *
	 * Made by Adrien Denat from a fork by Jonathan Nicol
	 * Under MIT License
	 */


	/******************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics = function (d, b) {
	  extendStatics = Object.setPrototypeOf || {
	    __proto__: []
	  } instanceof Array && function (d, b) {
	    d.__proto__ = b;
	  } || function (d, b) {
	    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
	  };
	  return extendStatics(d, b);
	};
	function __extends(d, b) {
	  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	  extendStatics(d, b);
	  function __() {
	    this.constructor = d;
	  }
	  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	var _a = SimpleBarCore.helpers,
	  getOptions = _a.getOptions,
	  addClasses = _a.addClasses,
	  canUseDOM = _a.canUseDOM;
	var SimpleBar = /** @class */function (_super) {
	  __extends(SimpleBar, _super);
	  function SimpleBar() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	      args[_i] = arguments[_i];
	    }
	    var _this = _super.apply(this, args) || this;
	    // // Save a reference to the instance, so we know this DOM node has already been instancied
	    SimpleBar.instances.set(args[0], _this);
	    return _this;
	  }
	  SimpleBar.initDOMLoadedElements = function () {
	    document.removeEventListener('DOMContentLoaded', this.initDOMLoadedElements);
	    window.removeEventListener('load', this.initDOMLoadedElements);
	    Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]'), function (el) {
	      if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el)) new SimpleBar(el, getOptions(el.attributes));
	    });
	  };
	  SimpleBar.removeObserver = function () {
	    var _a;
	    (_a = SimpleBar.globalObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
	  };
	  SimpleBar.prototype.initDOM = function () {
	    var _this = this;
	    var _a, _b, _c;
	    // make sure this element doesn't have the elements yet
	    if (!Array.prototype.filter.call(this.el.children, function (child) {
	      return child.classList.contains(_this.classNames.wrapper);
	    }).length) {
	      // Prepare DOM
	      this.wrapperEl = document.createElement('div');
	      this.contentWrapperEl = document.createElement('div');
	      this.offsetEl = document.createElement('div');
	      this.maskEl = document.createElement('div');
	      this.contentEl = document.createElement('div');
	      this.placeholderEl = document.createElement('div');
	      this.heightAutoObserverWrapperEl = document.createElement('div');
	      this.heightAutoObserverEl = document.createElement('div');
	      addClasses(this.wrapperEl, this.classNames.wrapper);
	      addClasses(this.contentWrapperEl, this.classNames.contentWrapper);
	      addClasses(this.offsetEl, this.classNames.offset);
	      addClasses(this.maskEl, this.classNames.mask);
	      addClasses(this.contentEl, this.classNames.contentEl);
	      addClasses(this.placeholderEl, this.classNames.placeholder);
	      addClasses(this.heightAutoObserverWrapperEl, this.classNames.heightAutoObserverWrapperEl);
	      addClasses(this.heightAutoObserverEl, this.classNames.heightAutoObserverEl);
	      while (this.el.firstChild) {
	        this.contentEl.appendChild(this.el.firstChild);
	      }
	      this.contentWrapperEl.appendChild(this.contentEl);
	      this.offsetEl.appendChild(this.contentWrapperEl);
	      this.maskEl.appendChild(this.offsetEl);
	      this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
	      this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
	      this.wrapperEl.appendChild(this.maskEl);
	      this.wrapperEl.appendChild(this.placeholderEl);
	      this.el.appendChild(this.wrapperEl);
	      (_a = this.contentWrapperEl) === null || _a === void 0 ? void 0 : _a.setAttribute('tabindex', this.options.tabIndex.toString());
	      (_b = this.contentWrapperEl) === null || _b === void 0 ? void 0 : _b.setAttribute('role', 'region');
	      (_c = this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c.setAttribute('aria-label', this.options.ariaLabel);
	    }
	    if (!this.axis.x.track.el || !this.axis.y.track.el) {
	      var track = document.createElement('div');
	      var scrollbar = document.createElement('div');
	      addClasses(track, this.classNames.track);
	      addClasses(scrollbar, this.classNames.scrollbar);
	      track.appendChild(scrollbar);
	      this.axis.x.track.el = track.cloneNode(true);
	      addClasses(this.axis.x.track.el, this.classNames.horizontal);
	      this.axis.y.track.el = track.cloneNode(true);
	      addClasses(this.axis.y.track.el, this.classNames.vertical);
	      this.el.appendChild(this.axis.x.track.el);
	      this.el.appendChild(this.axis.y.track.el);
	    }
	    SimpleBarCore.prototype.initDOM.call(this);
	    this.el.setAttribute('data-simplebar', 'init');
	  };
	  SimpleBar.prototype.unMount = function () {
	    SimpleBarCore.prototype.unMount.call(this);
	    SimpleBar.instances["delete"](this.el);
	  };
	  SimpleBar.initHtmlApi = function () {
	    this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this);
	    // MutationObserver is IE11+
	    if (typeof MutationObserver !== 'undefined') {
	      // Mutation observer to observe dynamically added elements
	      this.globalObserver = new MutationObserver(SimpleBar.handleMutations);
	      this.globalObserver.observe(document, {
	        childList: true,
	        subtree: true
	      });
	    }
	    // Taken from jQuery `ready` function
	    // Instantiate elements already present on the page
	    if (document.readyState === 'complete' ||
	    // @ts-ignore: IE specific
	    document.readyState !== 'loading' && !document.documentElement.doScroll) {
	      // Handle it asynchronously to allow scripts the opportunity to delay init
	      window.setTimeout(this.initDOMLoadedElements);
	    } else {
	      document.addEventListener('DOMContentLoaded', this.initDOMLoadedElements);
	      window.addEventListener('load', this.initDOMLoadedElements);
	    }
	  };
	  SimpleBar.handleMutations = function (mutations) {
	    mutations.forEach(function (mutation) {
	      mutation.addedNodes.forEach(function (addedNode) {
	        if (addedNode.nodeType === 1) {
	          if (addedNode.hasAttribute('data-simplebar')) {
	            !SimpleBar.instances.has(addedNode) && document.documentElement.contains(addedNode) && new SimpleBar(addedNode, getOptions(addedNode.attributes));
	          } else {
	            addedNode.querySelectorAll('[data-simplebar]').forEach(function (el) {
	              if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el) && document.documentElement.contains(el)) new SimpleBar(el, getOptions(el.attributes));
	            });
	          }
	        }
	      });
	      mutation.removedNodes.forEach(function (removedNode) {
	        var _a;
	        if (removedNode.nodeType === 1) {
	          if (removedNode.getAttribute('data-simplebar') === 'init') {
	            !document.documentElement.contains(removedNode) && ((_a = SimpleBar.instances.get(removedNode)) === null || _a === void 0 ? void 0 : _a.unMount());
	          } else {
	            Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function (el) {
	              var _a;
	              !document.documentElement.contains(el) && ((_a = SimpleBar.instances.get(el)) === null || _a === void 0 ? void 0 : _a.unMount());
	            });
	          }
	        }
	      });
	    });
	  };
	  SimpleBar.instances = new WeakMap();
	  return SimpleBar;
	}(SimpleBarCore);
	/**
	 * HTML API
	 * Called only in a browser env.
	 */
	if (canUseDOM) {
	  SimpleBar.initHtmlApi();
	}

	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = function () {
	  if (typeof Map !== 'undefined') {
	    return Map;
	  }
	  /**
	   * Returns index in provided array that matches the specified key.
	   *
	   * @param {Array<Array>} arr
	   * @param {*} key
	   * @returns {number}
	   */
	  function getIndex(arr, key) {
	    var result = -1;
	    arr.some(function (entry, index) {
	      if (entry[0] === key) {
	        result = index;
	        return true;
	      }
	      return false;
	    });
	    return result;
	  }
	  return /** @class */function () {
	    function class_1() {
	      this.__entries__ = [];
	    }
	    Object.defineProperty(class_1.prototype, "size", {
	      /**
	       * @returns {boolean}
	       */
	      get: function () {
	        return this.__entries__.length;
	      },
	      enumerable: true,
	      configurable: true
	    });
	    /**
	     * @param {*} key
	     * @returns {*}
	     */
	    class_1.prototype.get = function (key) {
	      var index = getIndex(this.__entries__, key);
	      var entry = this.__entries__[index];
	      return entry && entry[1];
	    };
	    /**
	     * @param {*} key
	     * @param {*} value
	     * @returns {void}
	     */
	    class_1.prototype.set = function (key, value) {
	      var index = getIndex(this.__entries__, key);
	      if (~index) {
	        this.__entries__[index][1] = value;
	      } else {
	        this.__entries__.push([key, value]);
	      }
	    };
	    /**
	     * @param {*} key
	     * @returns {void}
	     */
	    class_1.prototype.delete = function (key) {
	      var entries = this.__entries__;
	      var index = getIndex(entries, key);
	      if (~index) {
	        entries.splice(index, 1);
	      }
	    };
	    /**
	     * @param {*} key
	     * @returns {void}
	     */
	    class_1.prototype.has = function (key) {
	      return !!~getIndex(this.__entries__, key);
	    };
	    /**
	     * @returns {void}
	     */
	    class_1.prototype.clear = function () {
	      this.__entries__.splice(0);
	    };
	    /**
	     * @param {Function} callback
	     * @param {*} [ctx=null]
	     * @returns {void}
	     */
	    class_1.prototype.forEach = function (callback, ctx) {
	      if (ctx === void 0) {
	        ctx = null;
	      }
	      for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	        var entry = _a[_i];
	        callback.call(ctx, entry[1], entry[0]);
	      }
	    };
	    return class_1;
	  }();
	}();

	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

	// Returns global object of a current environment.
	var global$1 = function () {
	  if (typeof global !== 'undefined' && global.Math === Math) {
	    return global;
	  }
	  if (typeof self !== 'undefined' && self.Math === Math) {
	    return self;
	  }
	  if (typeof window !== 'undefined' && window.Math === Math) {
	    return window;
	  }
	  // eslint-disable-next-line no-new-func
	  return Function('return this')();
	}();

	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = function () {
	  if (typeof requestAnimationFrame === 'function') {
	    // It's required to use a bounded function because IE sometimes throws
	    // an "Invalid calling object" error if rAF is invoked without the global
	    // object on the left hand side.
	    return requestAnimationFrame.bind(global$1);
	  }
	  return function (callback) {
	    return setTimeout(function () {
	      return callback(Date.now());
	    }, 1000 / 60);
	  };
	}();

	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	function throttle(callback, delay) {
	  var leadingCall = false,
	    trailingCall = false,
	    lastCallTime = 0;
	  /**
	   * Invokes the original callback function and schedules new invocation if
	   * the "proxy" was called during current request.
	   *
	   * @returns {void}
	   */
	  function resolvePending() {
	    if (leadingCall) {
	      leadingCall = false;
	      callback();
	    }
	    if (trailingCall) {
	      proxy();
	    }
	  }
	  /**
	   * Callback invoked after the specified delay. It will further postpone
	   * invocation of the original function delegating it to the
	   * requestAnimationFrame.
	   *
	   * @returns {void}
	   */
	  function timeoutCallback() {
	    requestAnimationFrame$1(resolvePending);
	  }
	  /**
	   * Schedules invocation of the original function.
	   *
	   * @returns {void}
	   */
	  function proxy() {
	    var timeStamp = Date.now();
	    if (leadingCall) {
	      // Reject immediately following calls.
	      if (timeStamp - lastCallTime < trailingTimeout) {
	        return;
	      }
	      // Schedule new call to be in invoked when the pending one is resolved.
	      // This is important for "transitions" which never actually start
	      // immediately so there is a chance that we might miss one if change
	      // happens amids the pending invocation.
	      trailingCall = true;
	    } else {
	      leadingCall = true;
	      trailingCall = false;
	      setTimeout(timeoutCallback, delay);
	    }
	    lastCallTime = timeStamp;
	  }
	  return proxy;
	}

	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = /** @class */function () {
	  /**
	   * Creates a new instance of ResizeObserverController.
	   *
	   * @private
	   */
	  function ResizeObserverController() {
	    /**
	     * Indicates whether DOM listeners have been added.
	     *
	     * @private {boolean}
	     */
	    this.connected_ = false;
	    /**
	     * Tells that controller has subscribed for Mutation Events.
	     *
	     * @private {boolean}
	     */
	    this.mutationEventsAdded_ = false;
	    /**
	     * Keeps reference to the instance of MutationObserver.
	     *
	     * @private {MutationObserver}
	     */
	    this.mutationsObserver_ = null;
	    /**
	     * A list of connected observers.
	     *
	     * @private {Array<ResizeObserverSPI>}
	     */
	    this.observers_ = [];
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	  }
	  /**
	   * Adds observer to observers list.
	   *
	   * @param {ResizeObserverSPI} observer - Observer to be added.
	   * @returns {void}
	   */
	  ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	      this.observers_.push(observer);
	    }
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	      this.connect_();
	    }
	  };
	  /**
	   * Removes observer from observers list.
	   *
	   * @param {ResizeObserverSPI} observer - Observer to be removed.
	   * @returns {void}
	   */
	  ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	    // Remove observer if it's present in registry.
	    if (~index) {
	      observers.splice(index, 1);
	    }
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	      this.disconnect_();
	    }
	  };
	  /**
	   * Invokes the update of observers. It will continue running updates insofar
	   * it detects changes.
	   *
	   * @returns {void}
	   */
	  ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	      this.refresh();
	    }
	  };
	  /**
	   * Updates every observer from observers list and notifies them of queued
	   * entries.
	   *
	   * @private
	   * @returns {boolean} Returns "true" if any observer has detected changes in
	   *      dimensions of it's elements.
	   */
	  ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	      return observer.gatherActive(), observer.hasActive();
	    });
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) {
	      return observer.broadcastActive();
	    });
	    return activeObservers.length > 0;
	  };
	  /**
	   * Initializes DOM listeners.
	   *
	   * @private
	   * @returns {void}
	   */
	  ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	      return;
	    }
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	    window.addEventListener('resize', this.refresh);
	    if (mutationObserverSupported) {
	      this.mutationsObserver_ = new MutationObserver(this.refresh);
	      this.mutationsObserver_.observe(document, {
	        attributes: true,
	        childList: true,
	        characterData: true,
	        subtree: true
	      });
	    } else {
	      document.addEventListener('DOMSubtreeModified', this.refresh);
	      this.mutationEventsAdded_ = true;
	    }
	    this.connected_ = true;
	  };
	  /**
	   * Removes DOM listeners.
	   *
	   * @private
	   * @returns {void}
	   */
	  ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	      return;
	    }
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	    if (this.mutationsObserver_) {
	      this.mutationsObserver_.disconnect();
	    }
	    if (this.mutationEventsAdded_) {
	      document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	  };
	  /**
	   * "Transitionend" event handler.
	   *
	   * @private
	   * @param {TransitionEvent} event
	   * @returns {void}
	   */
	  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	    var _b = _a.propertyName,
	      propertyName = _b === void 0 ? '' : _b;
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	      return !!~propertyName.indexOf(key);
	    });
	    if (isReflowProperty) {
	      this.refresh();
	    }
	  };
	  /**
	   * Returns instance of the ResizeObserverController.
	   *
	   * @returns {ResizeObserverController}
	   */
	  ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	      this.instance_ = new ResizeObserverController();
	    }
	    return this.instance_;
	  };
	  /**
	   * Holds reference to the controller's instance.
	   *
	   * @private {ResizeObserverController}
	   */
	  ResizeObserverController.instance_ = null;
	  return ResizeObserverController;
	}();

	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = function (target, props) {
	  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	    var key = _a[_i];
	    Object.defineProperty(target, key, {
	      value: props[key],
	      enumerable: false,
	      writable: false,
	      configurable: true
	    });
	  }
	  return target;
	};

	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = function (target) {
	  // Assume that the element is an instance of Node, which means that it
	  // has the "ownerDocument" property from which we can retrieve a
	  // corresponding global object.
	  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	  // Return the local global object if it's not possible extract one from
	  // provided element.
	  return ownerGlobal || global$1;
	};

	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	  return parseFloat(value) || 0;
	}
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	  var positions = [];
	  for (var _i = 1; _i < arguments.length; _i++) {
	    positions[_i - 1] = arguments[_i];
	  }
	  return positions.reduce(function (size, position) {
	    var value = styles['border-' + position + '-width'];
	    return size + toFloat(value);
	  }, 0);
	}
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	  var positions = ['top', 'right', 'bottom', 'left'];
	  var paddings = {};
	  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	    var position = positions_1[_i];
	    var value = styles['padding-' + position];
	    paddings[position] = toFloat(value);
	  }
	  return paddings;
	}
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	  var bbox = target.getBBox();
	  return createRectInit(0, 0, bbox.width, bbox.height);
	}
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	  // Client width & height properties can't be
	  // used exclusively as they provide rounded values.
	  var clientWidth = target.clientWidth,
	    clientHeight = target.clientHeight;
	  // By this condition we can catch all non-replaced inline, hidden and
	  // detached elements. Though elements with width & height properties less
	  // than 0.5 will be discarded as well.
	  //
	  // Without it we would need to implement separate methods for each of
	  // those cases and it's not possible to perform a precise and performance
	  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	  // gives wrong results for elements with width & height less than 0.5.
	  if (!clientWidth && !clientHeight) {
	    return emptyRect;
	  }
	  var styles = getWindowOf(target).getComputedStyle(target);
	  var paddings = getPaddings(styles);
	  var horizPad = paddings.left + paddings.right;
	  var vertPad = paddings.top + paddings.bottom;
	  // Computed styles of width & height are being used because they are the
	  // only dimensions available to JS that contain non-rounded values. It could
	  // be possible to utilize the getBoundingClientRect if only it's data wasn't
	  // affected by CSS transformations let alone paddings, borders and scroll bars.
	  var width = toFloat(styles.width),
	    height = toFloat(styles.height);
	  // Width & height include paddings and borders when the 'border-box' box
	  // model is applied (except for IE).
	  if (styles.boxSizing === 'border-box') {
	    // Following conditions are required to handle Internet Explorer which
	    // doesn't include paddings and borders to computed CSS dimensions.
	    //
	    // We can say that if CSS dimensions + paddings are equal to the "client"
	    // properties then it's either IE, and thus we don't need to subtract
	    // anything, or an element merely doesn't have paddings/borders styles.
	    if (Math.round(width + horizPad) !== clientWidth) {
	      width -= getBordersSize(styles, 'left', 'right') + horizPad;
	    }
	    if (Math.round(height + vertPad) !== clientHeight) {
	      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	    }
	  }
	  // Following steps can't be applied to the document's root element as its
	  // client[Width/Height] properties represent viewport area of the window.
	  // Besides, it's as well not necessary as the <html> itself neither has
	  // rendered scroll bars nor it can be clipped.
	  if (!isDocumentElement(target)) {
	    // In some browsers (only in Firefox, actually) CSS width & height
	    // include scroll bars size which can be removed at this step as scroll
	    // bars are the only difference between rounded dimensions + paddings
	    // and "client" properties, though that is not always true in Chrome.
	    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	    // Chrome has a rather weird rounding of "client" properties.
	    // E.g. for an element with content width of 314.2px it sometimes gives
	    // the client width of 315px and for the width of 314.7px it may give
	    // 314px. And it doesn't happen all the time. So just ignore this delta
	    // as a non-relevant.
	    if (Math.abs(vertScrollbar) !== 1) {
	      width -= vertScrollbar;
	    }
	    if (Math.abs(horizScrollbar) !== 1) {
	      height -= horizScrollbar;
	    }
	  }
	  return createRectInit(paddings.left, paddings.top, width, height);
	}
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = function () {
	  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	  // interface.
	  if (typeof SVGGraphicsElement !== 'undefined') {
	    return function (target) {
	      return target instanceof getWindowOf(target).SVGGraphicsElement;
	    };
	  }
	  // If it's so, then check that element is at least an instance of the
	  // SVGElement and that it has the "getBBox" method.
	  // eslint-disable-next-line no-extra-parens
	  return function (target) {
	    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
	  };
	}();
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	  return target === getWindowOf(target).document.documentElement;
	}
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	  if (!isBrowser) {
	    return emptyRect;
	  }
	  if (isSVGGraphicsElement(target)) {
	    return getSVGContentRect(target);
	  }
	  return getHTMLElementContentRect(target);
	}
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(_a) {
	  var x = _a.x,
	    y = _a.y,
	    width = _a.width,
	    height = _a.height;
	  // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	  var rect = Object.create(Constr.prototype);
	  // Rectangle's properties are not writable and non-enumerable.
	  defineConfigurable(rect, {
	    x: x,
	    y: y,
	    width: width,
	    height: height,
	    top: y,
	    right: x + width,
	    bottom: height + y,
	    left: x
	  });
	  return rect;
	}
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	  return {
	    x: x,
	    y: y,
	    width: width,
	    height: height
	  };
	}

	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = /** @class */function () {
	  /**
	   * Creates an instance of ResizeObservation.
	   *
	   * @param {Element} target - Element to be observed.
	   */
	  function ResizeObservation(target) {
	    /**
	     * Broadcasted width of content rectangle.
	     *
	     * @type {number}
	     */
	    this.broadcastWidth = 0;
	    /**
	     * Broadcasted height of content rectangle.
	     *
	     * @type {number}
	     */
	    this.broadcastHeight = 0;
	    /**
	     * Reference to the last observed content rectangle.
	     *
	     * @private {DOMRectInit}
	     */
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	    this.target = target;
	  }
	  /**
	   * Updates content rectangle and tells whether it's width or height properties
	   * have changed since the last broadcast.
	   *
	   * @returns {boolean}
	   */
	  ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	    this.contentRect_ = rect;
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	  };
	  /**
	   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	   * from the corresponding properties of the last observed content rectangle.
	   *
	   * @returns {DOMRectInit} Last observed content rectangle.
	   */
	  ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	    return rect;
	  };
	  return ResizeObservation;
	}();
	var ResizeObserverEntry = /** @class */function () {
	  /**
	   * Creates an instance of ResizeObserverEntry.
	   *
	   * @param {Element} target - Element that is being observed.
	   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	   */
	  function ResizeObserverEntry(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, {
	      target: target,
	      contentRect: contentRect
	    });
	  }
	  return ResizeObserverEntry;
	}();
	var ResizeObserverSPI = /** @class */function () {
	  /**
	   * Creates a new instance of ResizeObserver.
	   *
	   * @param {ResizeObserverCallback} callback - Callback function that is invoked
	   *      when one of the observed elements changes it's content dimensions.
	   * @param {ResizeObserverController} controller - Controller instance which
	   *      is responsible for the updates of observer.
	   * @param {ResizeObserver} callbackCtx - Reference to the public
	   *      ResizeObserver instance which will be passed to callback function.
	   */
	  function ResizeObserverSPI(callback, controller, callbackCtx) {
	    /**
	     * Collection of resize observations that have detected changes in dimensions
	     * of elements.
	     *
	     * @private {Array<ResizeObservation>}
	     */
	    this.activeObservations_ = [];
	    /**
	     * Registry of the ResizeObservation instances.
	     *
	     * @private {Map<Element, ResizeObservation>}
	     */
	    this.observations_ = new MapShim();
	    if (typeof callback !== 'function') {
	      throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	  }
	  /**
	   * Starts observing provided element.
	   *
	   * @param {Element} target - Element to be observed.
	   * @returns {void}
	   */
	  ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	      throw new TypeError('1 argument required, but only 0 present.');
	    }
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	      return;
	    }
	    if (!(target instanceof getWindowOf(target).Element)) {
	      throw new TypeError('parameter 1 is not of type "Element".');
	    }
	    var observations = this.observations_;
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	      return;
	    }
	    observations.set(target, new ResizeObservation(target));
	    this.controller_.addObserver(this);
	    // Force the update of observations.
	    this.controller_.refresh();
	  };
	  /**
	   * Stops observing provided element.
	   *
	   * @param {Element} target - Element to stop observing.
	   * @returns {void}
	   */
	  ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	      throw new TypeError('1 argument required, but only 0 present.');
	    }
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	      return;
	    }
	    if (!(target instanceof getWindowOf(target).Element)) {
	      throw new TypeError('parameter 1 is not of type "Element".');
	    }
	    var observations = this.observations_;
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	      return;
	    }
	    observations.delete(target);
	    if (!observations.size) {
	      this.controller_.removeObserver(this);
	    }
	  };
	  /**
	   * Stops observing all elements.
	   *
	   * @returns {void}
	   */
	  ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	  };
	  /**
	   * Collects observation instances the associated element of which has changed
	   * it's content rectangle.
	   *
	   * @returns {void}
	   */
	  ResizeObserverSPI.prototype.gatherActive = function () {
	    var _this = this;
	    this.clearActive();
	    this.observations_.forEach(function (observation) {
	      if (observation.isActive()) {
	        _this.activeObservations_.push(observation);
	      }
	    });
	  };
	  /**
	   * Invokes initial callback function with a list of ResizeObserverEntry
	   * instances collected from active resize observations.
	   *
	   * @returns {void}
	   */
	  ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	      return;
	    }
	    var ctx = this.callbackCtx_;
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	  };
	  /**
	   * Clears the collection of active observations.
	   *
	   * @returns {void}
	   */
	  ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	  };
	  /**
	   * Tells whether observer has active observations.
	   *
	   * @returns {boolean}
	   */
	  ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	  };
	  return ResizeObserverSPI;
	}();

	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver$1 = /** @class */function () {
	  /**
	   * Creates a new instance of ResizeObserver.
	   *
	   * @param {ResizeObserverCallback} callback - Callback that is invoked when
	   *      dimensions of the observed elements change.
	   */
	  function ResizeObserver(callback) {
	    if (!(this instanceof ResizeObserver)) {
	      throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	      throw new TypeError('1 argument required, but only 0 present.');
	    }
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	    observers.set(this, observer);
	  }
	  return ResizeObserver;
	}();
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	  ResizeObserver$1.prototype[method] = function () {
	    var _a;
	    return (_a = observers.get(this))[method].apply(_a, arguments);
	  };
	});
	var index = function () {
	  // Export existing implementation if available.
	  if (typeof global$1.ResizeObserver !== 'undefined') {
	    return global$1.ResizeObserver;
	  }
	  return ResizeObserver$1;
	}();

	// import { disableScroll, enableScroll } from './scroll-lock';

	window.ResizeObserver = index;

	// DOM Elements Cache
	const menuMain = DOM.menuMain;
	const menuMainNav = DOM.menuMainNav;
	const btnClose = DOM.menuMainBtnClose;
	const menuSections = DOM.menuMainSections;
	const launcher = DOM.launcher;
	const bannerAlert$1 = DOM.bannerAlerts;

	// Selectors for initialization
	const arrEltsToInit = ['.o-menu-main__nav__level .a-btn', '.o-menu-main__nav__level .a-link', '.o-menu-main__nav__level__title', '.a-ul__item--bottom .a-ul'];

	// Constants
	const SECTION_MAIN_NAV = 'panel_main_nav';
	const ANIMATION_DELAY = 350;
	const FOCUS_DELAY = 150;
	const LEVEL_TRANSITION_DELAY = 125;
	const FOCUS_HOME_DELAY = 0;
	const BACK_BUTTON_FOCUS_DELAY = 300;

	// State
	let menuClassModifier = '';
	let launcherOpenerItem = '';
	let isMenuOpened = false;
	let currentMenuSection = '';
	let currentMenuLevel = '';
	let openingNavAnimPlayed = false;

	// Cached selectors
	let cachedLevel1 = null;
	const animationEvent = whichAnimationEvent();

	/**
	 * Initialize main menu
	 */
	function initMenuMain() {
	  cachedLevel1 = document.querySelector('.o-menu-main__nav__level[data-menu_level="1"]');
	  ariaHideSections();

	  // Configuration des aria-controls
	  setupAriaControls();
	  eventsLauncher();
	  setupCloseButton();
	  setupResizeHandler();
	  setupOutsideClickHandler();
	}

	/**
	 * Setup close button event
	 */
	function setupCloseButton() {
	  btnClose.addEventListener('click', () => {
	    if (isMenuOpened && !freezer.KeyboardEvents) {
	      closeMenu();
	    }
	  });
	}

	/**
	 * Setup resize handler
	 */
	function setupResizeHandler() {
	  window.addEventListener('optimizedResize', () => {
	    setMenuMainHeight();
	  });
	}

	/**
	 * Setup outside click handler
	 */
	function setupOutsideClickHandler() {
	  document.addEventListener('click', event => {
	    if (isMenuOpened && !freezer.KeyboardEvents) {
	      if (!event.target.closest('.o-menu-main') && !event.target.closest('.o-launcher')) {
	        event.preventDefault();
	        closeMenu();
	      }
	    }
	    return true;
	  });
	}

	/**
	 * Ensure SimpleBar instance (singleton pattern)
	 * @param {HTMLElement} el - Element to apply SimpleBar
	 * @param {Object} options - SimpleBar options
	 * @returns {SimpleBar}
	 */
	function ensureSimpleBar(el, options) {
	  if (el._simplebar) return el._simplebar;
	  const instance = new SimpleBar(el, options);
	  el._simplebar = instance;
	  return instance;
	}

	/**
	 * Set aria-hidden true on all menu sections
	 */
	function ariaHideSections() {
	  menuSections.forEach(section => {
	    setAriaHidden(section, true);
	  });
	}

	/**
	 * Setup events on menu launcher
	 */
	function eventsLauncher() {
	  const launcherButtons = launcher.querySelectorAll('button.o-launcher__nav__item__link');
	  launcherButtons.forEach(elt => {
	    elt.addEventListener('click', () => handleLauncherClick(elt));
	  });
	}

	/**
	 * Handle launcher button click
	 * @param {HTMLElement} elt - Clicked launcher element
	 */
	function handleLauncherClick(elt) {
	  launcherOpenerItem = elt;
	  const sectionTargetId = getAriaControls(elt);
	  const sectionTargetNode = document.getElementById(sectionTargetId);
	  const sectionMenuClassModifier = sectionTargetNode.getAttribute('data-menu_class_modifier');
	  removeMenuClassModifier();
	  menuSections.forEach(section => {
	    setNotActive(section);
	  });
	  if (!isMenuOpened) {
	    handleMenuOpen(sectionTargetNode, sectionTargetId, sectionMenuClassModifier);
	  } else if (currentMenuSection === sectionTargetId) {
	    closeMenu();
	  } else {
	    handleSectionSwitch(sectionTargetNode, sectionTargetId, sectionMenuClassModifier);
	  }
	  toggleLauncherActiveItem(elt);
	  if (currentMenuSection === SECTION_MAIN_NAV) {
	    eventsNavigationMenu();
	    animationNavigationLevel1();
	  }
	  setSectionLastFocusable(currentMenuSection);
	  ariaHideSections();
	  setAriaHidden(sectionTargetNode, false);
	}

	/**
	 * Handle menu opening
	 * @param {HTMLElement} sectionNode - Section to display
	 * @param {string} sectionId - Section ID
	 * @param {string} classModifier - Class modifier to add
	 */
	function handleMenuOpen(sectionNode, sectionId, classModifier) {
	  if (classModifier) {
	    addMenuClassModifier(classModifier);
	  }
	  openMenu();
	  setActive(sectionNode);
	  currentMenuSection = sectionId;
	}

	/**
	 * Handle section switch (when menu is already open)
	 * @param {HTMLElement} sectionNode - Section to display
	 * @param {string} sectionId - Section ID
	 * @param {string} classModifier - Class modifier to add
	 */
	function handleSectionSwitch(sectionNode, sectionId, classModifier) {
	  setActive(sectionNode);
	  currentMenuSection = sectionId;
	  if (classModifier) {
	    addMenuClassModifier(classModifier);
	  }
	  setElementFocus(btnClose);
	}

	/**
	 * Setup navigation menu events
	 */
	function eventsNavigationMenu() {
	  setupSubNavButtons();
	  setupBackButtons();
	}

	/**
	 * Setup sub-navigation buttons
	 */
	function setupSubNavButtons() {
	  const subNavButtons = document.querySelectorAll('.o-menu-main__nav .a-btn[aria-haspopup="true"]');
	  subNavButtons.forEach(btn => {
	    btn.addEventListener('click', () => {
	      openNavLevel(btn);
	    });
	  });
	}

	/**
	 * Setup back buttons
	 */
	function setupBackButtons() {
	  const backButtons = document.querySelectorAll('.o-menu-main__nav__level__back');
	  backButtons.forEach(btnBack => {
	    btnBack.addEventListener('click', () => handleBackButton(btnBack));
	  });
	}

	/**
	 * Handle back button click
	 * @param {HTMLElement} btnBack - Back button element
	 */
	function handleBackButton(btnBack) {
	  resetLevelLastFocusable();
	  const currentLevel = getCurrentLevel(btnBack);
	  if (currentLevel >= 2) {
	    const previousLevel = currentLevel - 1;
	    navigateToPreviousLevel(previousLevel, btnBack);
	  } else {
	    setCurrentMenuLevel(1);
	  }
	}

	/**
	 * Navigate to previous level
	 * @param {number} previousLevel - Level number to navigate to
	 * @param {HTMLElement} btnBack - Back button element
	 */
	function navigateToPreviousLevel(previousLevel, btnBack) {
	  setCurrentMenuLevel(previousLevel);

	  // Masquer le niveau actuel
	  const currentLevelPanel = btnBack.closest('.o-menu-main__nav__level');
	  if (currentLevelPanel) {
	    currentLevelPanel.setAttribute('aria-hidden', 'true');
	  }
	  document.querySelectorAll(`.nav-level-${previousLevel}`).forEach(eltPrev => {
	    eltPrev.classList.remove(CLASS.IS_PREVIOUS);
	    eltPrev.removeAttribute('tabindex');
	    if (eltPrev.getAttribute('aria-expanded')) {
	      setAriaExpanded(eltPrev, false);
	    }
	  });
	  updateLevelHeight(previousLevel, btnBack);
	  focusOnPreviousLevelButton(btnBack);
	}

	/**
	 * Update level height
	 * @param {number} previousLevel - Previous level number
	 * @param {HTMLElement} btnBack - Back button element
	 */
	function updateLevelHeight(previousLevel, btnBack) {
	  if (previousLevel === 1) {
	    cachedLevel1.style.height = 'initial';
	  } else {
	    const levelNodeContent = btnBack.closest(`.o-menu-main__nav__level[data-menu_level="${previousLevel}"]`);
	    const levelHeight = levelNodeContent.offsetHeight;
	    cachedLevel1.style.height = `${levelHeight}px`;
	    setLevelLastFocusable(levelNodeContent, previousLevel);
	  }
	}

	/**
	 * Focus on previous level button
	 * @param {HTMLElement} btnBack - Back button element
	 */
	function focusOnPreviousLevelButton(btnBack) {
	  window.setTimeout(() => {
	    setElementFocus(btnBack.closest('.a-ul__item').querySelector('.a-btn[aria-haspopup]'));
	  }, BACK_BUTTON_FOCUS_DELAY);
	}

	/**
	 * Play level 1 opening animation
	 */
	function animationNavigationLevel1() {
	  if (openingNavAnimPlayed) return;
	  const level1Items = menuMain.querySelectorAll('[data-menu_level="1"] > .a-ul > .a-ul__item');
	  level1Items.forEach(elt => {
	    elt.classList.add('anim-open');
	  });
	  menuMainNav.classList.add('play-anim-level-1');
	  const animOpenItems = document.querySelectorAll('.anim-open');
	  const lastAnimatedItem = animOpenItems[animOpenItems.length - 1];
	  lastAnimatedItem.addEventListener(animationEvent, () => {
	    animOpenItems.forEach(elt => {
	      elt.classList.remove('anim-open');
	    });
	  }, {
	    once: true
	  });
	  openingNavAnimPlayed = true;
	}

	/**
	 * Add class modifier to menu
	 * @param {string} className - Class name to add
	 */
	function addMenuClassModifier(className) {
	  menuMain.classList.add(className);
	  menuClassModifier = className;
	}

	/**
	 * Remove class modifier from menu
	 */
	function removeMenuClassModifier() {
	  if (menuClassModifier) {
	    menuMain.classList.remove(menuClassModifier);
	    menuClassModifier = '';
	  }
	}

	/**
	 * Open menu
	 */
	function openMenu() {
	  if (isMenuOpened) return;
	  isMenuOpened = true;
	  freezer.KeyboardEvents = true;
	  disableKeyboardEvents();
	  document.body.classList.remove(CLASS.MENU_PROFILS_OPENED);
	  document.body.classList.add(CLASS.MENU_MAIN_OPENED);
	  setMenuMainHeight();
	  stopScroll('html');
	  // Désactiver le scroll de la page
	  // disableScroll();

	  btnClose.classList.add(CLASS.IS_FIRST_FOCUSABLE);
	  window.setTimeout(() => {
	    setElementFocus(btnClose);
	    enableKeyboardEvents();
	    freezer.KeyboardEvents = false;
	  }, ANIMATION_DELAY);
	  keyboardMenuEvents();
	  ensureSimpleBar(document.querySelector('.o-menu-main__scroller'), {
	    autoHide: false,
	    ariaLabel: 'Contenu scrollable'
	  });
	}

	/**
	 * Close menu
	 */
	function closeMenu() {
	  if (!isMenuOpened) return;
	  document.body.classList.remove(CLASS.MENU_MAIN_OPENED);
	  intiAllNavLevels();
	  activeScroll('html');
	  // Réactiver le scroll de la page
	  // enableScroll();

	  setElementFocus(document.querySelector('.m-header-main a'), FOCUS_HOME_DELAY);
	  setElementFocus(launcherOpenerItem, FOCUS_DELAY);
	  toggleLauncherActiveItem();
	  isMenuOpened = false;
	  menuSections.forEach(section => {
	    setNotActive(section);
	  });
	  resetLastFocusable();
	  resetLevelLastFocusable();
	  btnClose.classList.remove(CLASS.IS_FIRST_FOCUSABLE);
	  ariaHideSections();
	  hotkeys.deleteScope('menu');
	}

	/**
	 * Reset all navigation levels
	 */
	function intiAllNavLevels() {
	  document.querySelectorAll(arrEltsToInit).forEach(elt => {
	    if (elt.classList.contains('a-btn') && elt.getAttribute('aria-haspopup') === 'true') {
	      setAriaExpanded(elt, false);
	    }
	    elt.classList.remove(CLASS.IS_PREVIOUS);
	    elt.removeAttribute('tabindex');
	  });
	  cachedLevel1.style.height = 'initial';
	  removeMenuClassModifier();
	  setCurrentMenuLevel(1);
	}

	/**
	 * Set menu height based on viewport and banners
	 */
	function setMenuMainHeight() {
	  let bandeauAlertHeight = 0;
	  if (bannerAlert$1 && bannerAlert$1.style.display !== 'none' && typeof bannerAlert$1 !== 'undefined') {
	    bandeauAlertHeight = bannerAlert$1.offsetHeight;
	  }
	  const bandeauAnonyme = document.querySelector('.m-banner-anonymous');
	  let bandeauAnonymeHeight = 0;
	  if (bandeauAnonyme && bandeauAnonyme.style.display !== 'none' && typeof bandeauAnonyme !== 'undefined') {
	    bandeauAnonymeHeight = bandeauAnonyme.offsetHeight;
	  }
	  if (isMobile()) {
	    const launcherHeight = launcher.offsetHeight;
	    if (isTablet()) {
	      menuMain.style.height = `${getWindowHeight() - launcherHeight - bandeauAlertHeight - bandeauAnonymeHeight}px`;
	    } else {
	      menuMain.style.height = `${getWindowHeight()}px`;
	    }
	  } else {
	    menuMain.style.height = `${getWindowHeight() - bandeauAlertHeight - bandeauAnonymeHeight}px`;
	  }
	}

	/**
	 * Setup keyboard event handlers
	 */
	function keyboardMenuEvents() {
	  hotkeys.filter = event => {
	    const tagName = (event.target || event.srcElement).tagName;
	    hotkeys.setScope(/^(BUTTON|A|INPUT|TEXTAREA|SELECT)$/.test(tagName) ? 'menu' : 'other');
	    return true;
	  };
	  setupEscapeKey();
	  setupTabKey();
	  setupShiftTabKey();
	  setupArrowDownKey();
	  setupArrowUpKey();
	  hotkeys.setScope('menu');
	}

	/**
	 * Setup Escape key handler
	 */
	function setupEscapeKey() {
	  hotkeys('escape', {
	    keyup: true,
	    scope: 'menu'
	  }, event => {
	    if (event.type === 'keyup' && !freezer.KeyboardEvents && isMenuOpened) {
	      closeMenu();
	    }
	  });
	}

	/**
	 * Setup Tab key handler
	 */
	function setupTabKey() {
	  hotkeys('tab', {
	    keyup: true,
	    scope: 'menu'
	  }, event => {
	    if (event.type !== 'keydown') return true;
	    if (event.target === document.querySelector(`.o-menu-main .${CLASS.IS_LAST_FOCUSABLE}`)) {
	      closeMenu();
	      return false;
	    }
	    if (event.target === document.querySelector('.o-menu-main .is-level-last-focusable:last-of-type')) {
	      const btnBack = event.target.closest('.o-menu-main__nav__level').querySelector('.a-btn-back.o-menu-main__nav__level__back:first-of-type');
	      setElementFocus(btnBack);
	    }
	    return true;
	  });
	}

	/**
	 * Setup Shift+Tab key handler
	 */
	function setupShiftTabKey() {
	  hotkeys('shift+tab', {
	    keyup: true,
	    scope: 'menu'
	  }, event => {
	    if (event.type !== 'keydown') return;
	    if (event.target === document.querySelector(`.${CLASS.IS_FIRST_FOCUSABLE}`)) {
	      closeMenu();
	    }
	    if (event.target.classList.contains('o-menu-main__nav__level__back')) {
	      setElementFocus(event.target);
	    }
	  });
	}

	/**
	 * Setup Arrow Down key handler
	 */
	function setupArrowDownKey() {
	  hotkeys('down', {
	    keyup: true,
	    scope: 'menu'
	  }, event => {
	    if (event.type !== 'keyup') return;
	    const currentFocused = document.activeElement;
	    currentMenuLevel = menuMainNav.getAttribute('data-current_menu_level');
	    if (currentFocused.classList.contains(`nav-level-${currentMenuLevel}`) && currentFocused.parentElement.classList.contains('a-ul__item')) {
	      if (currentFocused.parentElement.nextElementSibling) {
	        const nextFocusable = currentFocused.parentElement.nextElementSibling.querySelector('a[href], button');
	        if (nextFocusable) {
	          setElementFocus(nextFocusable);
	        }
	      }
	    }
	  });
	}

	/**
	 * Setup Arrow Up key handler
	 */
	function setupArrowUpKey() {
	  hotkeys('up', {
	    keyup: true,
	    scope: 'menu'
	  }, event => {
	    if (event.type !== 'keyup') return;
	    const currentFocused = document.activeElement;
	    currentMenuLevel = menuMainNav.getAttribute('data-current_menu_level');
	    if (currentFocused.classList.contains(`nav-level-${currentMenuLevel}`) && currentFocused.parentElement.classList.contains('a-ul__item')) {
	      if (currentFocused.parentElement.previousElementSibling) {
	        const prevFocusable = currentFocused.parentElement.previousElementSibling.querySelector('a[href], button');
	        if (prevFocusable) {
	          setElementFocus(prevFocusable);
	        }
	      }
	    }
	  });
	}

	/**
	 * Get current level from element
	 * @param {HTMLElement} elt - Element to get level from
	 * @returns {number}
	 */
	function getCurrentLevel(elt) {
	  return Number(elt.closest('.o-menu-main__nav__level').getAttribute('data-menu_level'));
	}

	/**
	 * Set current menu level
	 * @param {number} level - Level number
	 */
	function setCurrentMenuLevel(level) {
	  document.querySelector('nav.o-menu-main__nav').setAttribute('data-current_menu_level', level);
	}

	/**
	 * Toggle launcher active item
	 * @param {HTMLElement|boolean} item - Launcher item element or false
	 */
	function toggleLauncherActiveItem(item = false) {
	  launcher.querySelectorAll('.o-launcher__nav__item__link').forEach(elt => {
	    setNotActive(elt);
	    setAriaExpanded(elt, false);
	  });
	  if (item && isMenuOpened) {
	    setActive(item);
	    setAriaExpanded(item, true);
	  }
	}

	/**
	 * Reset section last focusable elements
	 */
	function resetLastFocusable() {
	  document.querySelectorAll(`.o-menu-main__section .${CLASS.IS_LAST_FOCUSABLE}`).forEach(elt => {
	    elt.classList.remove(CLASS.IS_LAST_FOCUSABLE);
	  });
	}

	/**
	 * Set level last focusable item
	 * @param {HTMLElement} parentnode - Parent node
	 * @param {number} levelNum - Level number
	 */
	function setLevelLastFocusable(parentnode, levelNum) {
	  const focusable = parentnode.querySelectorAll(`.a-link.nav-level-${levelNum}, .a-btn.nav-level-${levelNum}`);
	  const lastFocusable = focusable[focusable.length - 1];
	  lastFocusable.classList.add('is-level-last-focusable');
	}

	/**
	 * Reset level last focusable elements
	 */
	function resetLevelLastFocusable() {
	  document.querySelectorAll('.o-menu-main__section .is-level-last-focusable').forEach(elt => {
	    elt.classList.remove('is-level-last-focusable');
	  });
	}

	/**
	 * Set section last focusable element
	 * @param {string} section - Section ID
	 */
	function setSectionLastFocusable(section) {
	  let veryLast = '';
	  resetLastFocusable();
	  if (section === SECTION_MAIN_NAV) {
	    const last = document.querySelector('.o-menu-main__nav > .o-menu-main__nav__level > .a-ul > .a-ul__item:last-of-type');
	    if (last) {
	      if (last.querySelectorAll('.a-btn')[0]) {
	        veryLast = last.querySelector('.a-btn');
	      } else if (last.querySelectorAll('.a-link')[0]) {
	        veryLast = last.querySelector('.a-link');
	      }
	      veryLast.classList.add(CLASS.IS_LAST_FOCUSABLE);
	    }
	  } else {
	    const eltSection = document.getElementById(section);
	    const focusable = eltSection.querySelectorAll('[href], button, input');
	    const last = focusable[focusable.length - 1];
	    last.classList.add(CLASS.IS_LAST_FOCUSABLE);
	  }
	}

	/**
	 * Open navigation level
	 * @param {HTMLElement} btn - Button element
	 */
	function openNavLevel(btn) {
	  currentMenuLevel = Number(getCurrentLevel(btn));
	  document.querySelectorAll(`.nav-level-${currentMenuLevel}`).forEach(elt => {
	    elt.classList.add(CLASS.IS_PREVIOUS);
	    elt.tabIndex = -1;
	  });
	  const newLevelNum = currentMenuLevel + 1;
	  setCurrentMenuLevel(newLevelNum);
	  const newLevelNodeContent = btn.closest('.a-ul__item').querySelector(`.o-menu-main__nav__level[data-menu_level="${newLevelNum}"]`);

	  // Gérer aria-hidden lors de l'ouverture
	  if (newLevelNodeContent) {
	    newLevelNodeContent.setAttribute('aria-hidden', 'false');
	  }
	  window.setTimeout(() => {
	    cachedLevel1.style.height = `${newLevelNodeContent.offsetHeight}px`;
	  }, LEVEL_TRANSITION_DELAY);
	  setAriaExpanded(btn, true);
	  const backBtn = newLevelNodeContent.querySelector('.a-btn-back.o-menu-main__nav__level__back');
	  const firstLi = newLevelNodeContent.querySelector(`.o-menu-main__nav__level[data-menu_level="${newLevelNum}"] .a-ul .a-ul__item [class*="nav-level-${newLevelNum}"]`);
	  setElementFocus(firstLi, FOCUS_DELAY);
	  updateBackButtonText(backBtn, currentMenuLevel);
	  resetLevelLastFocusable();
	  setLevelLastFocusable(newLevelNodeContent, newLevelNum);
	}

	/**
	 * Update back button text with section name
	 * @param {HTMLElement} backBtn - Back button element
	 * @param {number} currentLevel - Current menu level
	 */
	function updateBackButtonText(backBtn, currentLevel) {
	  if (currentLevel >= 2) {
	    const titlePrevious = document.querySelector(`.o-menu-main__nav__level__title.nav-level-${currentLevel}`).textContent;
	    if (titlePrevious) {
	      if (backBtn.querySelector('span.sr-only span')) {
	        backBtn.querySelector('span.sr-only span').remove();
	      }
	      backBtn.querySelector('span.sr-only').insertAdjacentHTML('beforeend', `<span> (${titlePrevious}) </span>`);
	    }
	  }
	}

	/**
	 * Setup aria-controls on all navigation buttons with submenus
	 * Generates unique IDs for panels and links them to buttons
	 * Uses data-menu_level attributes for robustness
	 */
	function setupAriaControls() {
	  const buttonsWithSubmenu = document.querySelectorAll('.o-menu-main__nav .a-btn[aria-haspopup="true"]');
	  buttonsWithSubmenu.forEach((btn, index) => {
	    // Trouver le niveau actuel depuis le parent .o-menu-main__nav__level
	    const currentLevelContainer = btn.closest('.o-menu-main__nav__level');
	    if (currentLevelContainer) {
	      const currentLevel = parseInt(currentLevelContainer.getAttribute('data-menu_level'), 10);
	      const nextLevel = currentLevel + 1;

	      // Trouver le panneau contrôlé dans le parent direct (li)
	      const parentLi = btn.closest('.a-ul__item');
	      const controlledPanel = parentLi ? parentLi.querySelector(`.o-menu-main__nav__level[data-menu_level="${nextLevel}"]`) : null;
	      if (controlledPanel) {
	        // Générer un ID unique pour le panneau s'il n'en a pas
	        let panelId = controlledPanel.id;
	        if (!panelId) {
	          // Format : menu-panel-L{current}-to-L{next}-{index}
	          panelId = `menu-panel-L${currentLevel}-to-L${nextLevel}-${index}`;
	          controlledPanel.id = panelId;
	        }

	        // Ajouter aria-controls au bouton
	        btn.setAttribute('aria-controls', panelId);

	        // Ajouter aria-hidden initial sur les panneaux non visibles
	        if (!controlledPanel.classList.contains('is-active')) {
	          controlledPanel.setAttribute('aria-hidden', 'true');
	        }
	      }
	    }
	  });
	}

	var menuMain$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		closeMenu: closeMenu,
		default: initMenuMain
	});

	var ScrollTrigger$1 = {exports: {}};

	(function (module, exports$1) {
	  (function webpackUniversalModuleDefinition(root, factory) {
	    module.exports = factory();
	  })(window, function () {
	    return /******/function (modules) {
	      // webpackBootstrap
	      /******/ // The module cache
	      /******/
	      var installedModules = {};
	      /******/
	      /******/ // The require function
	      /******/
	      function __webpack_require__(moduleId) {
	        /******/
	        /******/ // Check if module is in cache
	        /******/if (installedModules[moduleId]) {
	          /******/return installedModules[moduleId].exports;
	          /******/
	        }
	        /******/ // Create a new module (and put it into the cache)
	        /******/
	        var module = installedModules[moduleId] = {
	          /******/i: moduleId,
	          /******/l: false,
	          /******/exports: {}
	          /******/
	        };
	        /******/
	        /******/ // Execute the module function
	        /******/
	        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	        /******/
	        /******/ // Flag the module as loaded
	        /******/
	        module.l = true;
	        /******/
	        /******/ // Return the exports of the module
	        /******/
	        return module.exports;
	        /******/
	      }
	      /******/
	      /******/
	      /******/ // expose the modules object (__webpack_modules__)
	      /******/
	      __webpack_require__.m = modules;
	      /******/
	      /******/ // expose the module cache
	      /******/
	      __webpack_require__.c = installedModules;
	      /******/
	      /******/ // define getter function for harmony exports
	      /******/
	      __webpack_require__.d = function (exports$1, name, getter) {
	        /******/if (!__webpack_require__.o(exports$1, name)) {
	          /******/Object.defineProperty(exports$1, name, {
	            enumerable: true,
	            get: getter
	          });
	          /******/
	        }
	        /******/
	      };
	      /******/
	      /******/ // define __esModule on exports
	      /******/
	      __webpack_require__.r = function (exports$1) {
	        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	          /******/Object.defineProperty(exports$1, Symbol.toStringTag, {
	            value: 'Module'
	          });
	          /******/
	        }
	        /******/
	        Object.defineProperty(exports$1, '__esModule', {
	          value: true
	        });
	        /******/
	      };
	      /******/
	      /******/ // create a fake namespace object
	      /******/ // mode & 1: value is a module id, require it
	      /******/ // mode & 2: merge all properties of value into the ns
	      /******/ // mode & 4: return value when already ns object
	      /******/ // mode & 8|1: behave like require
	      /******/
	      __webpack_require__.t = function (value, mode) {
	        /******/if (mode & 1) value = __webpack_require__(value);
	        /******/
	        if (mode & 8) return value;
	        /******/
	        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
	        /******/
	        var ns = Object.create(null);
	        /******/
	        __webpack_require__.r(ns);
	        /******/
	        Object.defineProperty(ns, 'default', {
	          enumerable: true,
	          value: value
	        });
	        /******/
	        if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
	          return value[key];
	        }.bind(null, key));
	        /******/
	        return ns;
	        /******/
	      };
	      /******/
	      /******/ // getDefaultExport function for compatibility with non-harmony modules
	      /******/
	      __webpack_require__.n = function (module) {
	        /******/var getter = module && module.__esModule ? /******/function getDefault() {
	          return module['default'];
	        } : /******/function getModuleExports() {
	          return module;
	        };
	        /******/
	        __webpack_require__.d(getter, 'a', getter);
	        /******/
	        return getter;
	        /******/
	      };
	      /******/
	      /******/ // Object.prototype.hasOwnProperty.call
	      /******/
	      __webpack_require__.o = function (object, property) {
	        return Object.prototype.hasOwnProperty.call(object, property);
	      };
	      /******/
	      /******/ // __webpack_public_path__
	      /******/
	      __webpack_require__.p = "";
	      /******/
	      /******/
	      /******/ // Load entry module and return exports
	      /******/
	      return __webpack_require__(__webpack_require__.s = 2);
	      /******/
	    }
	    /************************************************************************/
	    /******/([(/* 0 */
	    /***/function (module, exports$1) {
	      /*!
	       * object-extend
	       * A well-tested function to deep extend (or merge) JavaScript objects without further dependencies.
	       *
	       * http://github.com/bernhardw
	       *
	       * Copyright 2013, Bernhard Wanger <mail@bernhardwanger.com>
	       * Released under the MIT license.
	       *
	       * Date: 2013-04-10
	       */

	      /**
	       * Extend object a with object b.
	       *
	       * @param {Object} a Source object.
	       * @param {Object} b Object to extend with.
	       * @returns {Object} a Extended object.
	       */
	      module.exports = function extend(a, b) {
	        // Don't touch 'null' or 'undefined' objects.
	        if (a == null || b == null) {
	          return a;
	        }

	        // TODO: Refactor to use for-loop for performance reasons.
	        Object.keys(b).forEach(function (key) {
	          // Detect object without array, date or null.
	          // TODO: Performance test:
	          // a) b.constructor === Object.prototype.constructor
	          // b) Object.prototype.toString.call(b) == '[object Object]'
	          if (Object.prototype.toString.call(b[key]) == '[object Object]') {
	            if (Object.prototype.toString.call(a[key]) != '[object Object]') {
	              a[key] = b[key];
	            } else {
	              a[key] = extend(a[key], b[key]);
	            }
	          } else {
	            a[key] = b[key];
	          }
	        });
	        return a;
	      };

	      /***/
	    }), (/* 1 */
	    /***/function (module, exports$1) {
	      /**
	       * Faster than .forEach
	       * @param {(function())} fn The function to call
	       */
	      Array.prototype.each = function (fn) {
	        var l = this.length;
	        for (var i = 0; i < l; i++) {
	          var e = this[i];
	          if (e) {
	            fn(e, i);
	          }
	        }
	      };
	      /**
	       * Give NodeList some Array functions
	       */

	      NodeList.prototype.each = Array.prototype.each;
	      NodeList.prototype.filter = Array.prototype.filter;

	      /***/
	    }), (/* 2 */
	    /***/function (module, __webpack_exports__, __webpack_require__) {

	      __webpack_require__.r(__webpack_exports__);

	      // CONCATENATED MODULE: ./src/config/DefaultOptions.js
	      /**
	       * Default options for ScrollTrigger
	       */
	      /* harmony default export */
	      var DefaultOptions = function () {
	        /**
	         * The default options for a trigger
	         *
	         * @type {
	         * {
	         *  once: boolean,
	         *  offset: {
	         *    viewport: {
	         *      x: number|(function(frame, direction)),
	         *      y: number|(function(frame, direction))
	         *    },
	         *    element: {
	         *      x: number|(function(rect, direction)),
	         *      y: number|(function(rect, direction))
	         *    }
	         *  },
	         *  toggle: {
	         *    class: {
	         *      in: string|string[],
	         *      out: string|string[]
	         *    },
	         *  callback: {
	         *    in: {TriggerInCallback},
	            *    visible: (function()),
	         *    out: (function())
	         *  }
	         * }
	         * }}
	         */
	        this.trigger = {
	          once: false,
	          offset: {
	            viewport: {
	              x: 0,
	              y: 0
	            },
	            element: {
	              x: 0,
	              y: 0
	            }
	          },
	          toggle: {
	            "class": {
	              "in": 'visible',
	              out: 'invisible'
	            },
	            callback: {
	              "in": null,
	              visible: null,
	              out: null
	            }
	          }
	        };
	        /**
	         * The `in` callback is called when the element enters the viewport
	         * @callback TriggerInCallback
	         * @param {{x: Number, y: Number}} position
	         * @param {string} direction
	         */

	        /**
	         * The default options for the scroll behaviour
	         * @type {
	         * {
	         *  sustain: number,
	         *  element: Window|HTMLDocument|HTMLElement,
	         *  callback: {ScrollCallback},
	         *  start: (function()),
	         *  stop: (function()),
	         *  directionChange: (function(direction: {string}))
	         * }
	         * }
	         */

	        this.scroll = {
	          sustain: 300,
	          element: window,
	          callback: function callback() {},
	          start: function start() {},
	          stop: function stop() {},
	          directionChange: function directionChange() {}
	        };
	        /**
	         * The scroll callback is called when the user scrolls
	         * @callback ScrollCallback
	         * @param {{x: Number, y: Number}} position
	         * @param {string} direction
	         */
	      };
	      // EXTERNAL MODULE: ./node_modules/object-extend/lib/extend.js
	      var extend = __webpack_require__(0);
	      var extend_default = /*#__PURE__*/__webpack_require__.n(extend);

	      // EXTERNAL MODULE: ./src/extensions/Array.js
	      __webpack_require__(1);

	      // CONCATENATED MODULE: ./src/scripts/Trigger.js
	      function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	          throw new TypeError("Cannot call a class as a function");
	        }
	      }
	      function _defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	      function _createClass(Constructor, protoProps, staticProps) {
	        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	        return Constructor;
	      }
	      function isInt(n) {
	        return Number(n) === n && n % 1 === 0;
	      }
	      function isFloat(n) {
	        return Number(n) === n && n % 1 !== 0;
	      }
	      var Trigger_Trigger = /*#__PURE__*/
	      function () {
	        /**
	         * Creates a new Trigger from the given element and options
	         *
	         * @param {Element|HTMLElement} element
	         * @param {DefaultOptions.trigger} [options=DefaultOptions.trigger] options
	         */
	        function Trigger(element, options) {
	          _classCallCheck(this, Trigger);
	          this.element = element;
	          options = extend_default()(new DefaultOptions().trigger, options);
	          this.offset = options.offset;
	          this.toggle = options.toggle;
	          this.once = options.once;
	          this.visible = null;
	          this.active = true;
	        }
	        /**
	         * Checks if the Trigger is in the viewport, calls the callbacks and toggles the classes
	         * @param {HTMLElement|HTMLDocument|Window} parent
	         * @param {string} direction top, bottom, left, right
	         * @returns {boolean} If the element is visible
	         */

	        _createClass(Trigger, [{
	          key: "checkVisibility",
	          value: function checkVisibility(parent, direction) {
	            if (!this.active) {
	              return this.visible;
	            }
	            var parentWidth = parent.offsetWidth || parent.innerWidth || 0;
	            var parentHeight = parent.offsetHeight || parent.innerHeight || 0;
	            var parentFrame = {
	              w: parentWidth,
	              h: parentHeight
	            };
	            var rect = this.getBounds();
	            var visible = this._checkVisibility(rect, parentFrame, direction);
	            if (visible !== this.visible) {
	              this.visible = visible;
	              var response = this._toggleCallback();
	              if (response instanceof Promise) {
	                response.then(this._toggleClass.bind(this))["catch"](function (e) {
	                  console.error('Trigger promise failed');
	                  console.error(e);
	                });
	              } else {
	                this._toggleClass();
	              }
	              if (this.visible && this.once) {
	                this.active = false;
	              }
	            } else if (visible) {
	              if (typeof this.toggle.callback.visible == 'function') {
	                return this.toggle.callback.visible.call(this.element, this);
	              }
	            }
	            return visible;
	          }
	          /**
	           * Get the bounds of this element
	           * @return {ClientRect | DOMRect}
	           */
	        }, {
	          key: "getBounds",
	          value: function getBounds() {
	            return this.element.getBoundingClientRect();
	          }
	          /**
	           * Get the calculated offset to place on the element
	           * @param {ClientRect} rect
	           * @param {string} direction top, bottom, left, right
	           * @returns {{x: number, y: number}}
	           * @private
	           */
	        }, {
	          key: "_getElementOffset",
	          value: function _getElementOffset(rect, direction) {
	            var offset = {
	              x: 0,
	              y: 0
	            };
	            if (typeof this.offset.element.x === 'function') {
	              offset.x = rect.width * this.offset.element.x(this, rect, direction);
	            } else if (isFloat(this.offset.element.x)) {
	              offset.x = rect.width * this.offset.element.x;
	            } else if (isInt(this.offset.element.x)) {
	              offset.x = this.offset.element.x;
	            }
	            if (typeof this.offset.element.y === 'function') {
	              offset.y = rect.height * this.offset.element.y(this, rect, direction);
	            } else if (isFloat(this.offset.element.y)) {
	              offset.y = rect.height * this.offset.element.y;
	            } else if (isInt(this.offset.element.y)) {
	              offset.y = this.offset.element.y;
	            }
	            return offset;
	          }
	          /**
	           * Get the calculated offset to place on the viewport
	           * @param {{w: number, h: number}} parent
	           * @param {string} direction top, bottom, left, right
	           * @returns {{x: number, y: number}}
	           * @private
	           */
	        }, {
	          key: "_getViewportOffset",
	          value: function _getViewportOffset(parent, direction) {
	            var offset = {
	              x: 0,
	              y: 0
	            };
	            if (typeof this.offset.viewport.x === 'function') {
	              offset.x = parent.w * this.offset.viewport.x(this, parent, direction);
	            } else if (isFloat(this.offset.viewport.x)) {
	              offset.x = parent.w * this.offset.viewport.x;
	            } else if (isInt(this.offset.viewport.x)) {
	              offset.x = this.offset.viewport.x;
	            }
	            if (typeof this.offset.viewport.y === 'function') {
	              offset.y = parent.h * this.offset.viewport.y(this, parent, direction);
	            } else if (isFloat(this.offset.viewport.y)) {
	              offset.y = parent.h * this.offset.viewport.y;
	            } else if (isInt(this.offset.viewport.y)) {
	              offset.y = this.offset.viewport.y;
	            }
	            return offset;
	          }
	          /**
	           * Check the visibility of the trigger in the viewport, with offsets applied
	           * @param {ClientRect} rect
	           * @param {{w: number, h: number}} parent
	           * @param {string} direction top, bottom, left, right
	           * @returns {boolean}
	           * @private
	           */
	        }, {
	          key: "_checkVisibility",
	          value: function _checkVisibility(rect, parent, direction) {
	            var elementOffset = this._getElementOffset(rect, direction);
	            var viewportOffset = this._getViewportOffset(parent, direction);
	            var visible = true;
	            if (rect.left - viewportOffset.x < -(rect.width - elementOffset.x)) {
	              visible = false;
	            }
	            if (rect.left + viewportOffset.x > parent.w - elementOffset.x) {
	              visible = false;
	            }
	            if (rect.top - viewportOffset.y < -(rect.height - elementOffset.y)) {
	              visible = false;
	            }
	            if (rect.top + viewportOffset.y > parent.h - elementOffset.y) {
	              visible = false;
	            }
	            return visible;
	          }
	          /**
	           * Toggles the classes
	           * @private
	           */
	        }, {
	          key: "_toggleClass",
	          value: function _toggleClass() {
	            var _this = this;
	            if (this.visible) {
	              if (Array.isArray(this.toggle["class"]["in"])) {
	                this.toggle["class"]["in"].each(function (className) {
	                  _this.element.classList.add(className);
	                });
	              } else {
	                this.element.classList.add(this.toggle["class"]["in"]);
	              }
	              if (Array.isArray(this.toggle["class"].out)) {
	                this.toggle["class"].out.each(function (className) {
	                  _this.element.classList.remove(className);
	                });
	              } else {
	                this.element.classList.remove(this.toggle["class"].out);
	              }
	              return;
	            }
	            if (Array.isArray(this.toggle["class"]["in"])) {
	              this.toggle["class"]["in"].each(function (className) {
	                _this.element.classList.remove(className);
	              });
	            } else {
	              this.element.classList.remove(this.toggle["class"]["in"]);
	            }
	            if (Array.isArray(this.toggle["class"].out)) {
	              this.toggle["class"].out.each(function (className) {
	                _this.element.classList.add(className);
	              });
	            } else {
	              this.element.classList.add(this.toggle["class"].out);
	            }
	          }
	          /**
	           * Toggles the callback
	           * @private
	           * @return null|Promise
	           */
	        }, {
	          key: "_toggleCallback",
	          value: function _toggleCallback() {
	            if (this.visible) {
	              if (typeof this.toggle.callback["in"] == 'function') {
	                return this.toggle.callback["in"].call(this.element, this);
	              }
	            } else {
	              if (typeof this.toggle.callback.out == 'function') {
	                return this.toggle.callback.out.call(this.element, this);
	              }
	            }
	          }
	        }]);
	        return Trigger;
	      }();

	      // CONCATENATED MODULE: ./src/scripts/TriggerCollection.js
	      function TriggerCollection_classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	          throw new TypeError("Cannot call a class as a function");
	        }
	      }
	      function TriggerCollection_defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	      function TriggerCollection_createClass(Constructor, protoProps, staticProps) {
	        if (protoProps) TriggerCollection_defineProperties(Constructor.prototype, protoProps);
	        return Constructor;
	      }
	      var TriggerCollection_TriggerCollection = /*#__PURE__*/
	      function () {
	        /**
	         * Initializes the collection
	         * @param {Trigger[]} [triggers=[]] triggers A set of triggers to init with, optional
	         */
	        function TriggerCollection(triggers) {
	          TriggerCollection_classCallCheck(this, TriggerCollection);

	          /**
	           * @member {Trigger[]}
	           */
	          this.triggers = triggers instanceof Array ? triggers : [];
	        }
	        /**
	         * Adds one or multiple Trigger objects
	         * @param {Trigger|Trigger[]} objects
	         */

	        TriggerCollection_createClass(TriggerCollection, [{
	          key: "add",
	          value: function add(objects) {
	            var _this = this;
	            if (objects instanceof Trigger_Trigger) {
	              // single
	              return this.triggers.push(objects);
	            }
	            objects.each(function (trigger) {
	              if (trigger instanceof Trigger_Trigger) {
	                _this.triggers.push(trigger);
	              } else {
	                console.error('Object added to TriggerCollection is not a Trigger. Object: ', trigger);
	              }
	            });
	          }
	          /**
	           * Removes one or multiple Trigger objects
	           * @param {Trigger|Trigger[]} objects
	           */
	        }, {
	          key: "remove",
	          value: function remove(objects) {
	            if (objects instanceof Trigger_Trigger) {
	              objects = [objects];
	            }
	            this.triggers = this.triggers.filter(function (trigger) {
	              var hit = false;
	              objects.each(function (object) {
	                if (object == trigger) {
	                  hit = true;
	                }
	              });
	              return !hit;
	            });
	          }
	          /**
	           * Lookup one or multiple triggers by a query string
	           * @param {string} selector
	           * @returns {Trigger[]}
	           */
	        }, {
	          key: "query",
	          value: function query(selector) {
	            return this.triggers.filter(function (trigger) {
	              var element = trigger.element;
	              var parent = element.parentNode;
	              var nodes = [].slice.call(parent.querySelectorAll(selector));
	              return nodes.indexOf(element) > -1;
	            });
	          }
	          /**
	           * Lookup one or multiple triggers by a certain HTMLElement or NodeList
	           * @param {HTMLElement|HTMLElement[]|NodeList} element
	           * @returns {Trigger|Trigger[]|null}
	           */
	        }, {
	          key: "search",
	          value: function search(element) {
	            var found = this.triggers.filter(function (trigger) {
	              if (element instanceof NodeList || Array.isArray(element)) {
	                var hit = false;
	                element.each(function (el) {
	                  if (trigger.element == el) {
	                    hit = true;
	                  }
	                });
	                return hit;
	              }
	              return trigger.element == element;
	            });
	            return found.length == 0 ? null : found.length > 1 ? found : found[0];
	          }
	          /**
	           * Calls a function on all triggers
	           * @param {(function())} callback
	           */
	        }, {
	          key: "call",
	          value: function call(callback) {
	            this.triggers.each(callback);
	          }
	        }]);
	        return TriggerCollection;
	      }();

	      // CONCATENATED MODULE: ./src/scripts/ScrollAnimationLoop.js
	      function ScrollAnimationLoop_classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	          throw new TypeError("Cannot call a class as a function");
	        }
	      }
	      function ScrollAnimationLoop_defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	      function ScrollAnimationLoop_createClass(Constructor, protoProps, staticProps) {
	        if (protoProps) ScrollAnimationLoop_defineProperties(Constructor.prototype, protoProps);
	        return Constructor;
	      }
	      var ScrollAnimationLoop_ScrollAnimationLoop = /*#__PURE__*/
	      function () {
	        /**
	         * ScrollAnimationLoop constructor.
	         * Starts a requestAnimationFrame loop as long as the user has scrolled the scrollElement. Stops after a certain time.
	         *
	         * @param {DefaultOptions.scroll} [options=DefaultOptions.scroll] options The options for the loop
	         * @param {ScrollCallback} callback [loop=null] The loop callback
	         */
	        function ScrollAnimationLoop(options, callback) {
	          ScrollAnimationLoop_classCallCheck(this, ScrollAnimationLoop);
	          this._parseOptions(options);
	          if (typeof callback === 'function') {
	            this.callback = callback;
	          }
	          this.direction = 'none';
	          this.position = this.getPosition();
	          this.lastAction = this._getTimestamp();
	          this._startRun();
	          this._boundListener = this._didScroll.bind(this);
	          this.element.addEventListener('scroll', this._boundListener);
	        }
	        /**
	         * Parses the options
	         *
	         * @param {DefaultOptions.scroll} [options=DefaultOptions.scroll] options The options for the loop
	         * @private
	         */

	        ScrollAnimationLoop_createClass(ScrollAnimationLoop, [{
	          key: "_parseOptions",
	          value: function _parseOptions(options) {
	            var defaults = new DefaultOptions().scroll;
	            if (typeof options != 'function') {
	              defaults.callback = function () {};
	              defaults = extend_default()(defaults, options);
	            } else {
	              defaults.callback = options;
	            }
	            this.element = defaults.element;
	            this.sustain = defaults.sustain;
	            this.callback = defaults.callback;
	            this.startCallback = defaults.start;
	            this.stopCallback = defaults.stop;
	            this.directionChange = defaults.directionChange;
	          }
	          /**
	           * Callback when the user scrolled the element
	           * @private
	           */
	        }, {
	          key: "_didScroll",
	          value: function _didScroll() {
	            var newPosition = this.getPosition();
	            if (this.position !== newPosition) {
	              var newDirection = this.direction;
	              if (newPosition.x !== this.position.x) {
	                newDirection = newPosition.x > this.position.x ? 'right' : 'left';
	              } else if (newPosition.y !== this.position.y) {
	                newDirection = newPosition.y > this.position.y ? 'bottom' : 'top';
	              } else {
	                newDirection = 'none';
	              }
	              if (newDirection !== this.direction) {
	                this.direction = newDirection;
	                if (typeof this.directionChange === 'function') {
	                  this.directionChange(this.direction);
	                }
	              }
	              this.position = newPosition;
	              this.lastAction = this._getTimestamp();
	            } else {
	              this.direction = 'none';
	            }
	            if (!this.running) {
	              this._startRun();
	            }
	          }
	          /**
	           * Starts the loop, calls the start callback
	           * @private
	           */
	        }, {
	          key: "_startRun",
	          value: function _startRun() {
	            this.running = true;
	            if (typeof this.startCallback === 'function') {
	              this.startCallback();
	            }
	            this._loop();
	          }
	          /**
	           * Stops the loop, calls the stop callback
	           * @private
	           */
	        }, {
	          key: "_stopRun",
	          value: function _stopRun() {
	            this.running = false;
	            if (typeof this.stopCallback === 'function') {
	              this.stopCallback();
	            }
	          }
	          /**
	           * The current position of the element
	           * @returns {{x: number, y: number}}
	           */
	        }, {
	          key: "getPosition",
	          value: function getPosition() {
	            var left = this.element.pageXOffset || this.element.scrollLeft || document.documentElement.scrollLeft || 0;
	            var top = this.element.pageYOffset || this.element.scrollTop || document.documentElement.scrollTop || 0;
	            return {
	              x: left,
	              y: top
	            };
	          }
	          /**
	           * The current timestamp in ms
	           * @returns {number}
	           * @private
	           */
	        }, {
	          key: "_getTimestamp",
	          value: function _getTimestamp() {
	            return Number(Date.now());
	          }
	          /**
	           * One single tick of the animation
	           * @private
	           */
	        }, {
	          key: "_tick",
	          value: function _tick() {
	            this.callback(this.position, this.direction);
	            var now = this._getTimestamp();
	            if (now - this.lastAction > this.sustain) {
	              this._stopRun();
	            }
	            if (this.running) {
	              this._loop();
	            }
	          }
	          /**
	           * Requests an animation frame
	           * @private
	           */
	        }, {
	          key: "_loop",
	          value: function _loop() {
	            var frame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function (callback) {
	              setTimeout(callback, 1000 / 60);
	            };
	            frame(this._tick.bind(this));
	          }
	          /**
	           * Kills the loop forever
	           */
	        }, {
	          key: "kill",
	          value: function kill() {
	            this.running = false;
	            this.element.removeEventListener('scroll', this._boundListener);
	          }
	        }]);
	        return ScrollAnimationLoop;
	      }();

	      // CONCATENATED MODULE: ./src/ScrollTrigger.js
	      /* harmony export (binding) */
	      __webpack_require__.d(__webpack_exports__, "Trigger", function () {
	        return ScrollTrigger_Trigger;
	      });
	      /* harmony export (binding) */
	      __webpack_require__.d(__webpack_exports__, "TriggerCollection", function () {
	        return ScrollTrigger_TriggerCollection;
	      });
	      /* harmony export (binding) */
	      __webpack_require__.d(__webpack_exports__, "ScrollAnimationLoop", function () {
	        return ScrollTrigger_ScrollAnimationLoop;
	      });
	      /* harmony export (binding) */
	      __webpack_require__.d(__webpack_exports__, "default", function () {
	        return ScrollTrigger_ScrollTrigger;
	      });
	      function ScrollTrigger_classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	          throw new TypeError("Cannot call a class as a function");
	        }
	      }
	      function ScrollTrigger_defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	          var descriptor = props[i];
	          descriptor.enumerable = descriptor.enumerable || false;
	          descriptor.configurable = true;
	          if ("value" in descriptor) descriptor.writable = true;
	          Object.defineProperty(target, descriptor.key, descriptor);
	        }
	      }
	      function ScrollTrigger_createClass(Constructor, protoProps, staticProps) {
	        if (protoProps) ScrollTrigger_defineProperties(Constructor.prototype, protoProps);
	        return Constructor;
	      }

	      /*!
	       * ScrollTrigger
	       *
	       *
	       * http://github.com/terwanerik
	       *
	       * Copyright 2017, Erik Terwan <erik@erikterwan.com>
	       * Released under the MIT license.
	       *
	       * Date: 2017-07-09
	       */

	      /**
	       * Created by Erik on 09/07/2017.
	       */

	      var ScrollTrigger_Trigger = Trigger_Trigger;
	      var ScrollTrigger_TriggerCollection = TriggerCollection_TriggerCollection;
	      var ScrollTrigger_ScrollAnimationLoop = ScrollAnimationLoop_ScrollAnimationLoop;
	      var ScrollTrigger_ScrollTrigger = /*#__PURE__*/
	      function () {
	        /**
	         * Constructor for the scroll trigger
	         * @param {DefaultOptions} [options=DefaultOptions] options
	         */
	        function ScrollTrigger(options) {
	          ScrollTrigger_classCallCheck(this, ScrollTrigger);
	          this._parseOptions(options);
	          this._initCollection();
	          this._initLoop();
	        }
	        /**
	         * Parses the options
	         * @param {DefaultOptions} [options=DefaultOptions] options
	         * @private
	         */

	        ScrollTrigger_createClass(ScrollTrigger, [{
	          key: "_parseOptions",
	          value: function _parseOptions(options) {
	            options = extend_default()(new DefaultOptions(), options);
	            this.defaultTrigger = options.trigger;
	            this.scrollOptions = options.scroll;
	          }
	          /**
	           * Initializes the collection, picks all [data-scroll] elements as initial elements
	           * @private
	           */
	        }, {
	          key: "_initCollection",
	          value: function _initCollection() {
	            var scrollAttributes = document.querySelectorAll('[data-scroll]');
	            var elements = [];
	            if (scrollAttributes.length > 0) {
	              elements = this.createTriggers(scrollAttributes);
	            }
	            this.collection = new ScrollTrigger_TriggerCollection(elements);
	          }
	          /**
	           * Initializes the scroll loop
	           * @private
	           */
	        }, {
	          key: "_initLoop",
	          value: function _initLoop() {
	            var _this = this;
	            this.loop = new ScrollTrigger_ScrollAnimationLoop({
	              sustain: this.scrollOptions.sustain,
	              element: this.scrollOptions.element,
	              callback: function callback(position, direction) {
	                _this._scrollCallback(position, direction);
	              },
	              start: function start() {
	                _this._scrollStart();
	              },
	              stop: function stop() {
	                _this._scrollStop();
	              },
	              directionChange: function directionChange(direction) {
	                _this._scrollDirectionChange(direction);
	              }
	            });
	          }
	          /**
	           * Callback for checking triggers
	           * @param {{x: number, y: number}} position
	           * @param {string} direction
	           * @private
	           */
	        }, {
	          key: "_scrollCallback",
	          value: function _scrollCallback(position, direction) {
	            var _this2 = this;
	            this.collection.call(function (trigger) {
	              trigger.checkVisibility(_this2.scrollOptions.element, direction);
	            });
	            this.scrollOptions.callback(position, direction);
	          }
	          /**
	           * When the scrolling started
	           * @private
	           */
	        }, {
	          key: "_scrollStart",
	          value: function _scrollStart() {
	            this.scrollOptions.start();
	          }
	          /**
	           * When the scrolling stopped
	           * @private
	           */
	        }, {
	          key: "_scrollStop",
	          value: function _scrollStop() {
	            this.scrollOptions.stop();
	          }
	          /**
	           * When the direction changes
	           * @param {string} direction
	           * @private
	           */
	        }, {
	          key: "_scrollDirectionChange",
	          value: function _scrollDirectionChange(direction) {
	            this.scrollOptions.directionChange(direction);
	          }
	          /**
	           * Creates a Trigger object from a given element and optional option set
	           * @param {HTMLElement} element
	           * @param {DefaultOptions.trigger} [options=DefaultOptions.trigger] options
	           * @returns Trigger
	           */
	        }, {
	          key: "createTrigger",
	          value: function createTrigger(element, options) {
	            return new ScrollTrigger_Trigger(element, extend_default()(this.defaultTrigger, options));
	          }
	          /**
	           * Creates an array of triggers
	           * @param {HTMLElement[]|NodeList} elements
	           * @param {Object} [options=null] options
	           * @returns {Trigger[]} Array of triggers
	           */
	        }, {
	          key: "createTriggers",
	          value: function createTriggers(elements, options) {
	            var _this3 = this;
	            var triggers = [];
	            elements.each(function (element) {
	              triggers.push(_this3.createTrigger(element, options));
	            });
	            return triggers;
	          }
	          /**
	           * Adds triggers
	           * @param {string|HTMLElement|NodeList|Trigger|Trigger[]} objects A list of objects or a query
	           * @param {Object} [options=null] options
	           * @returns {ScrollTrigger}
	           */
	        }, {
	          key: "add",
	          value: function add(objects, options) {
	            if (objects instanceof HTMLElement) {
	              this.collection.add(this.createTrigger(objects, options));
	              return this;
	            }
	            if (objects instanceof ScrollTrigger_Trigger) {
	              this.collection.add(objects);
	              return this;
	            }
	            if (objects instanceof NodeList) {
	              this.collection.add(this.createTriggers(objects, options));
	              return this;
	            }
	            if (Array.isArray(objects) && objects.length && objects[0] instanceof ScrollTrigger_Trigger) {
	              this.collection.add(objects);
	              return this;
	            }
	            if (Array.isArray(objects) && objects.length && objects[0] instanceof HTMLElement) {
	              this.collection.add(this.createTriggers(objects, options));
	              return this;
	            } // assume it's a query string

	            this.collection.add(this.createTriggers(document.querySelectorAll(objects), options));
	            return this;
	          }
	          /**
	           * Removes triggers
	           * @param {string|HTMLElement|NodeList|Trigger|Trigger[]} objects A list of objects or a query
	           * @returns {ScrollTrigger}
	           */
	        }, {
	          key: "remove",
	          value: function remove(objects) {
	            if (objects instanceof ScrollTrigger_Trigger) {
	              this.collection.remove(objects);
	              return this;
	            }
	            if (Array.isArray(objects) && objects.length && objects[0] instanceof ScrollTrigger_Trigger) {
	              this.collection.remove(objects);
	              return this;
	            }
	            if (objects instanceof HTMLElement) {
	              this.collection.remove(this.search(objects));
	              return this;
	            }
	            if (Array.isArray(objects) && objects.length && objects[0] instanceof HTMLElement) {
	              this.collection.remove(this.search(objects));
	              return this;
	            }
	            if (objects instanceof NodeList) {
	              this.collection.remove(this.search(objects));
	              return this;
	            }
	            if (Array.isArray(objects) && objects.length && objects[0] instanceof ScrollTrigger_Trigger) {
	              this.collection.remove(objects);
	              return this;
	            } // assume it's a query string

	            this.collection.remove(this.query(objects.toString()));
	            return this;
	          }
	          /**
	           * Lookup one or multiple triggers by a query string
	           * @param {string} selector
	           * @returns {Trigger[]}
	           */
	        }, {
	          key: "query",
	          value: function query(selector) {
	            return this.collection.query(selector);
	          }
	          /**
	           * Lookup one or multiple triggers by a certain HTMLElement or NodeList
	           * @param {HTMLElement|HTMLElement[]|NodeList} element
	           * @returns {Trigger|Trigger[]|null}
	           */
	        }, {
	          key: "search",
	          value: function search(element) {
	            return this.collection.search(element);
	          }
	          /**
	           * Reattaches the scroll listener
	           */
	        }, {
	          key: "listen",
	          value: function listen() {
	            if (this.loop) {
	              return;
	            }
	            this._initLoop();
	          }
	          /**
	           * Kills the scroll listener
	           */
	        }, {
	          key: "kill",
	          value: function kill() {
	            this.loop.kill();
	            this.loop = null;
	          }
	        }]);
	        return ScrollTrigger;
	      }();

	      /***/
	    }
	    /******/)]);
	  });
	})(ScrollTrigger$1);
	var ScrollTriggerExports = ScrollTrigger$1.exports;
	var ScrollTrigger = /*@__PURE__*/getDefaultExportFromCjs(ScrollTriggerExports);

	let scrollTriggerInstance = null;
	let resizeHandler = null;

	/**
	 * Init launcher with scroll behavior
	 */
	function init$5() {
	  // Validate required DOM elements
	  if (!DOM.launcherNavWrapper) {
	    // console.warn('Launcher: launcherNavWrapper not found');
	    return;
	  }

	  // Cleanup previous instance
	  destroy();
	  try {
	    scrollTriggerInstance = new ScrollTrigger();
	    scrollTriggerInstance.add('.m-header-main', {
	      once: false,
	      offset: {
	        element: {
	          x: 0,
	          y: () => 1 // Element has fully scrolled past
	        }
	      },
	      toggle: {
	        class: {
	          in: 'in',
	          out: 'out'
	        },
	        callback: {
	          // in - When .m-header-main re-enters the viewport (scrolling up)
	          in: handleScrollIn,
	          // out - When .m-header-main leaves the viewport (scrolling down)
	          out: handleScrollOut
	        }
	      }
	    });

	    // Setup resize listener
	    resizeHandler = handleResize;
	    window.addEventListener('optimizedResize', resizeHandler);
	  } catch (error) {
	    // console.error('Launcher initialization failed:', error);
	  }
	}

	/**
	 * Cleanup event listeners and instances
	 */
	function destroy() {
	  if (scrollTriggerInstance?.destroy) {
	    scrollTriggerInstance.destroy();
	    scrollTriggerInstance = null;
	  }
	  if (resizeHandler) {
	    window.removeEventListener('optimizedResize', resizeHandler);
	    resizeHandler = null;
	  }
	}

	/**
	 * Handle scroll in callback
	 */
	function handleScrollIn() {
	  DOM.launcherNavWrapper.classList.remove(CLASS.IS_STUCK);
	}

	/**
	 * Handle scroll out callback
	 */
	function handleScrollOut() {
	  if (!isMobile()) {
	    DOM.launcherNavWrapper.classList.add(CLASS.IS_STUCK);
	    setLauncherRightPosition();
	  }
	}

	/**
	 * Handle window resize
	 */
	function handleResize() {
	  if (!isMobile()) {
	    if (DOM.launcherNavWrapper.classList.contains(CLASS.IS_STUCK)) {
	      setLauncherRightPosition();
	    }
	  } else {
	    // Reset inline style on mobile
	    DOM.launcherNavWrapper.style.right = '';
	  }
	}

	/**
	 * Center launcher with general wrapper
	 */
	function setLauncherRightPosition() {
	  if (!DOM.generalWrapper || !DOM.launcherNavWrapper) return;
	  const viewportWidth = document.documentElement.clientWidth;
	  const wrapperWidth = DOM.generalWrapper.offsetWidth;
	  const rightOffset = Math.max(0, (viewportWidth - wrapperWidth) / 2);
	  DOM.launcherNavWrapper.style.right = `${rightOffset}px`;
	}

	var menuLauncher = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: init$5,
		destroy: destroy
	});

	function init$4() {
	  const togglerLinksButton = DOM.footerMain.querySelectorAll('.o-footer-main .links h2 > button');

	  // Initialiser l'état des boutons au chargement
	  // Ajouter un délai pour Storybook
	  const initButtons = () => {
	    togglerLinksButton.forEach(btn => {
	      syncButtonState(btn);
	    });
	  };

	  // Exécution immédiate
	  initButtons();

	  // Deuxième exécution après un court délai pour Storybook
	  setTimeout(initButtons, 100);

	  // Gestionnaire de clic
	  function handleClick(e) {
	    // Ne toggle que si on est sur mobile
	    if (isPhone()) {
	      const button = e.currentTarget;
	      const targetId = button.getAttribute('aria-controls');
	      const targetElement = document.getElementById(targetId);
	      if (targetElement) {
	        const isExpanded = button.getAttribute('aria-expanded') === 'true';
	        button.setAttribute('aria-expanded', !isExpanded);

	        // Toggle la visibilité de l'élément ciblé
	        if (!isExpanded) {
	          targetElement.style.display = '';
	        } else {
	          targetElement.style.display = 'none';
	        }
	      }
	    }
	  }

	  // Gestionnaire de resize
	  function handleResize() {
	    togglerLinksButton.forEach(btn => {
	      syncButtonState(btn);
	    });
	  }

	  // Event listener
	  togglerLinksButton.forEach(btn => {
	    btn.addEventListener('click', handleClick);
	  });
	  window.addEventListener('optimizedResize', handleResize);

	  // Écouter aussi le resize standard pour Storybook
	  window.addEventListener('resize', handleResize);

	  // Clean listener
	  return function cleanup() {
	    togglerLinksButton.forEach(btn => {
	      btn.removeEventListener('click', handleClick);
	    });
	    window.removeEventListener('optimizedResize', handleResize);
	    window.removeEventListener('resize', handleResize);
	  };
	}

	/**
	 * Synchronise l'état du bouton selon le breakpoint
	 * @param {HTMLElement} btn - Le bouton à synchroniser
	 */
	function syncButtonState(btn) {
	  const targetId = btn.getAttribute('aria-controls');
	  const targetElement = document.getElementById(targetId);
	  if (isPhone()) {
	    // Mobile : accordéon interactif, fermé par défaut
	    btn.setAttribute('aria-expanded', 'false');
	    if (targetElement) {
	      targetElement.style.display = 'none';
	    }
	  } else {
	    // Desktop : toujours ouvert, non interactif visuellement
	    btn.setAttribute('aria-expanded', 'true');
	    if (targetElement) {
	      targetElement.style.display = '';
	    }
	  }
	}

	var footer = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: init$4
	});

	/**
	 ********************************************************************
	 * Banner alert
	 ********************************************************************
	 */

	/**
	 * Mount Splide
	 */
	function buildBannerAlert() {
	  const splideAlertsElt = DOM.bannerAlerts;
	  const splideAlertsOptions = {
	    type: 'loop',
	    pagination: false,
	    autoplay: true,
	    drag: true,
	    role: 'group',
	    i18n: SLIDER_OPTIONS_I18N_ALERTES,
	    label: splideAlertsElt.getAttribute('aria-label'),
	    labelledby: splideAlertsElt.getAttribute('aria-labelledby')
	  };
	  const splideAlertObj = new Splide(splideAlertsElt, splideAlertsOptions);
	  splideAlertObj.on('mounted', () => {
	    // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	    onSplideMounted(splideAlertObj, splideAlertsElt);

	    // Replace default role="presentation" on <ul> to keep children semantic
	    const list = splideAlertObj.Components.Elements.list;
	    // list.setAttribute('role', 'list');
	    list.removeAttribute('role');
	  });

	  // Destroy
	  splideAlertObj.on('destroy', () => {
	    onSplideDestroy(splideAlertObj, splideAlertsElt);
	  });

	  // Mount slider
	  splideAlertObj.mount();
	}

	var bannerAlert = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildBannerAlert
	});

	/**
	 * Custom Select (vanilla, accessible) – ESM Refactorisé
	 * - Bouton + popup listbox (role=listbox, role=option)
	 * - Label natif réutilisé (aria-labelledby)
	 * - Aide SR attachée à la listbox (aria-describedby) + rappel via aria-live au 1er open
	 * - Placeholder: état visuel .is-placeholder et data-placeholder
	 * - MULTIPLE: placeholder désactivé (disabled) pour éviter une fausse sélection
	 * - Annonce "sélectionné" au focus (aria-describedby → span caché)
	 * - Annonce selection/deselection via aria-live (role=status)
	 * - SimpleBar sans duplication + classe overflow sur le wrapper
	 */

	window.ResizeObserver = window.ResizeObserver || index;

	// --- Helpers ---------------------------------------------------------------

	function makeId(prefix) {
	  return `${prefix}-${Math.random().toString(36).slice(2, 9)}`;
	}

	/** Récupère le <label> associé via for= ou le 1er label du wrapper .m-custom-select */
	function getLabelForControl(ctrl) {
	  if (!(ctrl instanceof HTMLElement)) return null;
	  if (ctrl.id) {
	    const byFor = document.querySelector(`label[for="${CSS.escape(ctrl.id)}"]`);
	    if (byFor) return byFor;
	  }
	  return ctrl.closest('.m-custom-select')?.querySelector('label') || null;
	}
	function clamp(n, min, max) {
	  return Math.max(min, Math.min(max, n));
	}
	function getIndexByTypeahead(texts, buffer, startIndex = 0) {
	  const n = texts.length;
	  const lowerBuffer = buffer.toLowerCase();
	  for (let i = 1; i <= n; i++) {
	    const idx = (startIndex + i) % n;
	    if ((texts[idx] || '').toLowerCase().startsWith(lowerBuffer)) return idx;
	  }
	  return -1;
	}

	// --- Module ----------------------------------------------------------------

	const CustomSelectEnhancer = (() => {
	  const CLS = {
	    root: 'cs',
	    button: 'cs__button',
	    buttonText: 'cs__button__text',
	    popup: 'cs__popup',
	    listbox: 'cs__listbox',
	    option: 'cs__option',
	    optionCurrent: 'is-current',
	    optionSelected: 'is-selected',
	    open: 'is-open',
	    vh: 'visually-hidden',
	    group: 'cs__group',
	    groupLabel: 'cs__group-label',
	    wrapper: 'm-custom-select',
	    wrapperOverflow: 'm-custom-select--sb-overflow',
	    buttonPlaceholder: 'is-placeholder'
	  };
	  const KEY = {
	    Enter: 'Enter',
	    Space: ' ',
	    Escape: 'Escape',
	    ArrowUp: 'ArrowUp',
	    ArrowDown: 'ArrowDown',
	    Home: 'Home',
	    End: 'End',
	    PageUp: 'PageUp',
	    PageDown: 'PageDown',
	    Tab: 'Tab'
	  };
	  const pageSize = 10;
	  function visuallyHide(el) {
	    el.classList.add(CLS.vh);
	    el.setAttribute('aria-hidden', 'true');
	    el.tabIndex = -1;
	  }

	  // Helper pour détecter si une option est un placeholder
	  function isPlaceholderOption(opt) {
	    return opt.hasAttribute('data-placeholder') || opt.value === '-1' || opt.value === '';
	  }
	  function build(selectEl) {
	    const multiple = selectEl.multiple === true;

	    // Références wrapper/label pour l'accessibilité
	    const wrapper = selectEl.closest(`.${CLS.wrapper}`) || selectEl.parentElement;
	    const labelEl = getLabelForControl(selectEl);

	    // Options natives + placeholder (optimisé)
	    const nativeOptionsArr = [...selectEl.options];
	    const placeholderOption = nativeOptionsArr.find(isPlaceholderOption);
	    const placeholderNativeIndex = placeholderOption ? nativeOptionsArr.indexOf(placeholderOption) : -1;
	    const placeholderLabel = selectEl.getAttribute('data-placeholder') || placeholderOption?.getAttribute('data-placeholder') || placeholderOption?.textContent?.trim() || 'Choisir…';

	    // MULTIPLE: désactiver la pseudo-option placeholder côté natif
	    if (multiple && placeholderOption) {
	      placeholderOption.disabled = true;
	    }

	    // Conteneur UI
	    const root = document.createElement('div');
	    root.className = CLS.root;

	    // Bouton
	    const btn = document.createElement('button');
	    btn.type = 'button';
	    btn.className = CLS.button;
	    btn.setAttribute('aria-haspopup', 'listbox');
	    btn.setAttribute('aria-expanded', 'false');

	    // Span interne pour le texte (permet line-clamp sans conflit avec padding)
	    const btnText = document.createElement('span');
	    btnText.className = CLS.buttonText;
	    btn.appendChild(btnText);

	    // Popup + listbox
	    const popup = document.createElement('div');
	    popup.className = CLS.popup;
	    popup.hidden = true;
	    const listbox = document.createElement('div');
	    listbox.className = CLS.listbox;
	    listbox.setAttribute('role', 'listbox');
	    if (multiple) listbox.setAttribute('aria-multiselectable', 'true');
	    listbox.setAttribute('data-simplebar', '');
	    let simpleBarInstance = null;

	    // IDs
	    const baseId = makeId('cs');
	    const listboxId = `${baseId}-listbox`;
	    const btnId = `${baseId}-button`;
	    listbox.id = listboxId;
	    btn.id = btnId;
	    btn.setAttribute('aria-controls', listboxId);

	    // Insertion
	    selectEl.after(root);
	    root.appendChild(selectEl);
	    visuallyHide(selectEl);
	    selectEl.removeAttribute('aria-labelledby');
	    selectEl.removeAttribute('aria-describedby');

	    // --- Aides SR & live regions ------------------------------------------

	    // 1) Aide SR (attachée à la listbox via aria-describedby)
	    const srHelpId = `${baseId}-sr-help`;
	    const srHelp = document.createElement('div');
	    srHelp.id = srHelpId;
	    srHelp.className = CLS.vh;
	    srHelp.textContent = multiple ? 'Liste multisélection. Utilisez les flèches pour parcourir, Espace pour sélectionner ou désélectionner, Échap pour fermer, Tab pour sortir.' : 'Liste de sélection. Utilisez les flèches pour parcourir, Entrée ou Espace pour sélectionner et fermer, Échap pour fermer, Tab pour sortir.';
	    root.appendChild(srHelp);
	    listbox.setAttribute('aria-describedby', srHelpId);

	    // 2) Descripteur "sélectionné" lu au focus d'une option sélectionnée
	    const srSelectedId = `${baseId}-sr-selected`;
	    const srSelected = document.createElement('span');
	    srSelected.id = srSelectedId;
	    srSelected.className = CLS.vh;
	    srSelected.textContent = 'sélectionné';
	    root.appendChild(srSelected);

	    // Helper optimisé pour gérer aria-describedby
	    function updateSelectedDescriptor(el, isSelected) {
	      const ids = new Set((el.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
	      isSelected ? ids.add(srSelectedId) : ids.delete(srSelectedId);
	      if (ids.size) {
	        el.setAttribute('aria-describedby', Array.from(ids).join(' '));
	      } else {
	        el.removeAttribute('aria-describedby');
	      }
	    }

	    // 3) Live region "status" pour annoncer sélection/désélection
	    const srLive = document.createElement('div');
	    srLive.setAttribute('role', 'status');
	    srLive.setAttribute('aria-atomic', 'true');
	    srLive.className = CLS.vh;
	    root.appendChild(srLive);
	    function live(msg) {
	      srLive.textContent = '';
	      Promise.resolve().then(() => {
	        srLive.textContent = msg;
	      });
	    }
	    let helpAnnounced = false;

	    // --- Association Label → Bouton ----------------------------------------

	    let labelClickHandler = null;
	    if (labelEl) {
	      if (!labelEl.id) {
	        labelEl.id = selectEl.id ? `${selectEl.id}-label` : `${baseId}-label`;
	      }
	      btn.setAttribute('aria-labelledby', `${labelEl.id} ${btnId}`);
	      labelClickHandler = ev => {
	        ev.preventDefault();
	        btn.focus();
	        openPopup();
	      };
	      labelEl.addEventListener('click', labelClickHandler);
	    }

	    // Propage les attributs d'état/description du <select> → bouton
	    const describedbyBtn = selectEl.getAttribute('aria-describedby');
	    if (describedbyBtn) btn.setAttribute('aria-describedby', describedbyBtn);
	    if (selectEl.required) listbox.setAttribute('aria-required', 'true');
	    if (selectEl.getAttribute('aria-invalid') === 'true') btn.setAttribute('aria-invalid', 'true');
	    btn.disabled = !!selectEl.disabled;
	    if (selectEl.disabled) btn.setAttribute('aria-disabled', 'true');

	    // --- Sélections : miroir robuste ---------------------------------------

	    const selectedSet = new Set(nativeOptionsArr.map((o, i) => o.selected ? i : -1).filter(i => i >= 0));
	    function applySelectedSetToNative() {
	      for (let i = 0; i < selectEl.options.length; i++) {
	        const shouldBeSelected = selectedSet.has(i);
	        if (selectEl.options[i].selected !== shouldBeSelected) {
	          selectEl.options[i].selected = shouldBeSelected;
	        }
	      }
	    }
	    function labelForNativeIndex(i) {
	      return selectEl.options[i]?.textContent?.trim() || '';
	    }
	    function selectOnly(index) {
	      selectedSet.clear();
	      if (index >= 0) selectedSet.add(index);
	      applySelectedSetToNative();
	      syncFromNative();
	      announceValue();
	      selectEl.dispatchEvent(new Event('change', {
	        bubbles: true
	      }));
	      if (index >= 0) {
	        live(`Sélectionné : ${labelForNativeIndex(index)}`);
	      } else {
	        live('Aucune sélection');
	      }
	    }
	    function toggleInSet(index) {
	      const wasSelected = selectedSet.has(index);
	      wasSelected ? selectedSet.delete(index) : selectedSet.add(index);
	      applySelectedSetToNative();
	      syncFromNative();
	      announceValue();
	      selectEl.dispatchEvent(new Event('change', {
	        bubbles: true
	      }));
	      const label = labelForNativeIndex(index);
	      live(wasSelected ? `Désélectionné : ${label}` : `Sélectionné : ${label}`);
	    }
	    function clearSet() {
	      const had = selectedSet.size > 0;
	      selectedSet.clear();
	      applySelectedSetToNative();
	      syncFromNative();
	      selectEl.dispatchEvent(new Event('change', {
	        bubbles: true
	      }));
	      if (had) live('Sélections effacées');
	    }
	    function deselectIndex(index) {
	      if (selectedSet.has(index)) {
	        selectedSet.delete(index);
	        applySelectedSetToNative();
	        syncFromNative();
	        announceValue();
	        selectEl.dispatchEvent(new Event('change', {
	          bubbles: true
	        }));
	        live(`Désélectionné : ${labelForNativeIndex(index)}`);
	      }
	    }
	    function selectPlaceholder({
	      close = true,
	      moveFocusButton = true
	    } = {}) {
	      if (placeholderNativeIndex >= 0) {
	        if (multiple) {
	          clearSet();
	        } else {
	          selectOnly(placeholderNativeIndex);
	        }
	        if (close) closePopup({
	          moveFocusButton
	        });
	      }
	    }

	    // --- Options & optgroups ------------------------------------------------

	    const optionEls = [];
	    const texts = [];
	    let activeIndex = 0;
	    function focusActiveOption({
	      moveFocus = true
	    } = {}) {
	      const clamped = clamp(activeIndex, 0, optionEls.length - 1);
	      const opt = optionEls[clamped];
	      optionEls.forEach(el => {
	        el.classList.remove(CLS.optionCurrent);
	        el.tabIndex = -1;
	      });
	      if (opt) {
	        opt.classList.add(CLS.optionCurrent);
	        opt.tabIndex = 0;
	        if (moveFocus) opt.focus();
	        opt.scrollIntoView({
	          block: 'nearest'
	        });
	      }
	    }
	    function createOption(opt, nativeIndex) {
	      const listIndex = optionEls.length;
	      const optDiv = document.createElement('div');
	      optDiv.className = CLS.option;
	      optDiv.setAttribute('role', 'option');
	      optDiv.setAttribute('data-value', opt.value);
	      optDiv.setAttribute('data-index', String(nativeIndex));
	      optDiv.textContent = opt.textContent || '';
	      optDiv.id = `${listbox.id}-opt-${nativeIndex}`;
	      optDiv.tabIndex = -1;
	      texts.push(opt.textContent || '');
	      const isSel = opt.selected;
	      optDiv.setAttribute('aria-selected', isSel ? 'true' : 'false');
	      if (isSel) {
	        optDiv.classList.add(CLS.optionSelected);
	        updateSelectedDescriptor(optDiv, true);
	      }

	      // Événements souris
	      optDiv.addEventListener('mousedown', () => {
	        pointerDownInside = true;
	      });
	      optDiv.addEventListener('click', ev => {
	        ev.stopPropagation();
	        activeIndex = listIndex;
	        const nativeIdx = nativeIndex;
	        if (multiple) {
	          toggleInSet(nativeIdx);
	          focusActiveOption({
	            moveFocus: true
	          });
	        } else {
	          selectOnly(nativeIdx);
	          closePopup({
	            moveFocusButton: true
	          });
	        }
	      });

	      // Événements clavier sur l'option
	      optDiv.addEventListener('keydown', e => handleOptionKeydown(e, listIndex, nativeIndex));
	      optionEls.push(optDiv);
	      return optDiv;
	    }

	    // Construction des options
	    let flat = 0;
	    Array.from(selectEl.children).forEach(child => {
	      if (child.tagName === 'OPTGROUP') {
	        const group = document.createElement('div');
	        group.setAttribute('role', 'group');
	        group.className = CLS.group;
	        const groupLabel = child.label || '';
	        if (groupLabel) {
	          group.setAttribute('aria-label', groupLabel);
	          const glabel = document.createElement('div');
	          glabel.className = CLS.groupLabel;
	          glabel.textContent = groupLabel;
	          glabel.setAttribute('aria-hidden', 'true');
	          group.appendChild(glabel);
	        }
	        Array.from(child.children).forEach(opt => {
	          if (opt.tagName !== 'OPTION') return;
	          const isPlaceholder = placeholderNativeIndex >= 0 && nativeOptionsArr.indexOf(opt) === placeholderNativeIndex;
	          if (multiple && isPlaceholder) {
	            flat += 1;
	          } else {
	            const optDiv = createOption(opt, flat);
	            group.appendChild(optDiv);
	            flat += 1;
	          }
	        });
	        listbox.appendChild(group);
	      } else if (child.tagName === 'OPTION') {
	        const isPlaceholder = placeholderNativeIndex >= 0 && nativeOptionsArr.indexOf(child) === placeholderNativeIndex;
	        if (multiple && isPlaceholder) {
	          flat += 1;
	        } else {
	          const optDiv = createOption(child, flat);
	          listbox.appendChild(optDiv);
	          flat += 1;
	        }
	      }
	    });
	    popup.appendChild(listbox);
	    root.appendChild(btn);
	    root.appendChild(popup);

	    // --- SimpleBar : init + overflow wrapper --------------------------------
	    simpleBarInstance = new SimpleBar(listbox, {
	      autoHide: false,
	      clickOnTrack: true
	    });
	    const sbScrollEl = simpleBarInstance.getScrollElement();
	    const sbContentEl = simpleBarInstance.getContentElement();
	    function isOverflowingY(node) {
	      return node.scrollHeight > Math.ceil(node.clientHeight + 1);
	    }
	    function updateOverflowClass() {
	      if (!wrapper) return;
	      wrapper.classList.toggle(CLS.wrapperOverflow, isOverflowingY(sbScrollEl));
	    }
	    const roList = new index(() => {
	      simpleBarInstance.recalculate();
	      updateOverflowClass();
	    });
	    roList.observe(listbox);
	    roList.observe(sbContentEl);

	    // --- Gestion focus sortant / pointer guard --------------------------------
	    let pointerDownInside = false;
	    root.addEventListener('focusout', () => {
	      if (popup.hidden) return;
	      requestAnimationFrame(() => {
	        if (pointerDownInside) return;
	        const a = document.activeElement;
	        if (!root.contains(a)) closePopup({
	          moveFocusButton: false
	        });
	      });
	    });
	    root.addEventListener('pointerdown', e => {
	      if (root.contains(e.target)) pointerDownInside = true;
	    }, true);
	    window.addEventListener('pointerup', () => {
	      pointerDownInside = false;
	    }, true);

	    // --- UI : label bouton + état placeholder --------------------------------

	    function getButtonLabel() {
	      const selected = [...selectEl.selectedOptions].filter(o => !isPlaceholderOption(o));
	      if (!selected.length) return placeholderLabel;
	      if (!multiple) return selected[0].textContent || '';
	      return selected.map(o => o.textContent || '').join(', ');
	    }
	    function isPlaceholderMode() {
	      if (multiple) {
	        return ![...selectEl.selectedOptions].some(o => !isPlaceholderOption(o));
	      }
	      if (placeholderNativeIndex >= 0) {
	        return !!selectEl.options[placeholderNativeIndex]?.selected;
	      }
	      const sel = selectEl.selectedOptions[0];
	      return !sel || isPlaceholderOption(sel);
	    }
	    function updateButtonState() {
	      const isPH = isPlaceholderMode();
	      btn.classList.toggle(CLS.buttonPlaceholder, isPH);
	      btn.setAttribute('data-placeholder', isPH ? 'true' : 'false');
	    }

	    /*  function updateButtonUI() {
	      btn.textContent = getButtonLabel();
	      updateButtonState();
	    } */
	    function updateButtonUI() {
	      btnText.textContent = getButtonLabel();
	      updateButtonState();
	    }
	    updateButtonUI();
	    function syncFromNative() {
	      // Optimisation: Map pour éviter les recherches répétées
	      const optionsByIndex = new Map(optionEls.map(el => [Number(el.dataset.index), el]));
	      nativeOptionsArr.forEach((opt, i) => {
	        const el = optionsByIndex.get(i);
	        if (!el) return;
	        const isSelected = opt.selected;
	        el.setAttribute('aria-selected', isSelected ? 'true' : 'false');
	        el.classList.toggle(CLS.optionSelected, isSelected);
	        updateSelectedDescriptor(el, isSelected);
	      });
	      updateButtonUI();
	    }
	    function nativeToListIndex(nativeIdx) {
	      if (nativeIdx < 0) return -1;
	      return optionEls.findIndex(el => Number(el.dataset.index) === nativeIdx);
	    }

	    // --- Navigation clavier (factorisation) ----------------------------------

	    function handleNavigation(e, fromButton = false) {
	      const {
	        key
	      } = e;
	      const navActions = {
	        [KEY.ArrowDown]: () => activeIndex = clamp(activeIndex + 1, 0, optionEls.length - 1),
	        [KEY.ArrowUp]: () => activeIndex = clamp(activeIndex - 1, 0, optionEls.length - 1),
	        [KEY.Home]: () => activeIndex = 0,
	        [KEY.End]: () => activeIndex = optionEls.length - 1,
	        [KEY.PageDown]: () => activeIndex = clamp(activeIndex + pageSize, 0, optionEls.length - 1),
	        [KEY.PageUp]: () => activeIndex = clamp(activeIndex - pageSize, 0, optionEls.length - 1)
	      };
	      if (navActions[key]) {
	        e.preventDefault();
	        if (fromButton && popup.hidden) openPopup();
	        navActions[key]();
	        focusActiveOption({
	          moveFocus: true
	        });
	        return true;
	      }
	      return false;
	    }
	    function handleSelectionKey(e, nativeIdx) {
	      const {
	        key
	      } = e;
	      if (key === KEY.Enter || key === KEY.Space) {
	        e.preventDefault();
	        e.stopPropagation();

	        // Gestion du placeholder en mode simple
	        if (!multiple && placeholderNativeIndex >= 0 && nativeIdx === placeholderNativeIndex) {
	          selectPlaceholder({
	            close: true
	          });
	          return true;
	        }
	        if (nativeIdx >= 0) {
	          if (multiple) {
	            toggleInSet(nativeIdx);
	            focusActiveOption({
	              moveFocus: true
	            });
	          } else {
	            selectOnly(nativeIdx);
	            closePopup({
	              moveFocusButton: true
	            });
	          }
	        }
	        return true;
	      }
	      return false;
	    }

	    // --- Open / Close --------------------------------------------------------

	    function openPopup() {
	      if (!popup.hidden) return;
	      popup.hidden = false;
	      root.classList.add(CLS.open);
	      btn.setAttribute('aria-expanded', 'true');
	      if (simpleBarInstance) {
	        simpleBarInstance.recalculate();
	        updateOverflowClass();
	      }
	      const lastSelNative = nativeOptionsArr.findIndex(o => o.selected);
	      let nextListIdx = nativeToListIndex(lastSelNative);
	      if (nextListIdx < 0) nextListIdx = 0;
	      activeIndex = clamp(nextListIdx, 0, optionEls.length - 1);
	      if (!helpAnnounced) {
	        helpAnnounced = true;
	        live(srHelp.textContent || '');
	      }
	      focusActiveOption({
	        moveFocus: true
	      });
	      document.addEventListener('pointerdown', onDocPointerDown, true);
	      document.addEventListener('keydown', onDocKeyDown, true);
	    }
	    function closePopup({
	      moveFocusButton = true
	    } = {}) {
	      if (popup.hidden) return;
	      popup.hidden = true;
	      root.classList.remove(CLS.open);
	      btn.setAttribute('aria-expanded', 'false');
	      document.removeEventListener('pointerdown', onDocPointerDown, true);
	      document.removeEventListener('keydown', onDocKeyDown, true);
	      if (moveFocusButton) btn.focus();
	    }
	    function onDocPointerDown(e) {
	      if (!root.contains(e.target)) closePopup({
	        moveFocusButton: false
	      });
	    }
	    function onDocKeyDown(e) {
	      if (e.key === KEY.Escape) {
	        e.preventDefault();
	        closePopup();
	      }
	    }

	    // --- Handlers clavier (refactorisés) -------------------------------------

	    function handleOptionKeydown(e, listIndex, nativeIndex) {
	      const {
	        key,
	        altKey,
	        ctrlKey,
	        metaKey
	      } = e;
	      const printable = key.length === 1 && !altKey && !ctrlKey && !metaKey;
	      activeIndex = listIndex;
	      if (handleSelectionKey(e, nativeIndex)) return;
	      if (handleNavigation(e)) return;
	      if (key === KEY.Escape) {
	        e.preventDefault();
	        e.stopPropagation();
	        closePopup();
	        return;
	      }
	      if (key === KEY.Tab) {
	        if (!popup.hidden) closePopup({
	          moveFocusButton: false
	        });
	        return;
	      }
	      if (printable) {
	        e.stopPropagation();
	        scheduleTypeahead(key);
	        focusActiveOption({
	          moveFocus: true
	        });
	      }
	    }
	    btn.addEventListener('click', () => {
	      popup.hidden ? openPopup() : closePopup();
	    });
	    btn.addEventListener('keydown', e => {
	      const {
	        key,
	        altKey,
	        ctrlKey,
	        metaKey
	      } = e;
	      const printable = key.length === 1 && !altKey && !ctrlKey && !metaKey;
	      if (key === KEY.Tab) {
	        if (!popup.hidden) closePopup({
	          moveFocusButton: false
	        });
	        return;
	      }
	      if (handleNavigation(e, true)) return;
	      if (key === KEY.Enter || key === KEY.Space) {
	        e.preventDefault();
	        if (popup.hidden) {
	          openPopup();
	          focusActiveOption({
	            moveFocus: true
	          });
	        } else {
	          const nativeIdx = Number(optionEls[activeIndex]?.dataset.index);
	          handleSelectionKey(e, nativeIdx);
	        }
	        return;
	      }
	      if (key === KEY.Escape) {
	        if (!popup.hidden) {
	          e.preventDefault();
	          closePopup();
	        }
	        return;
	      }
	      if (printable) {
	        if (popup.hidden) openPopup();
	        scheduleTypeahead(key);
	        focusActiveOption({
	          moveFocus: true
	        });
	      }
	    });

	    // Listbox: fallback si focus tombe sur listbox
	    listbox.addEventListener('keydown', e => {
	      if (e.target !== listbox) return;
	      const {
	        key,
	        altKey,
	        ctrlKey,
	        metaKey
	      } = e;
	      const printable = key.length === 1 && !altKey && !ctrlKey && !metaKey;
	      if (key === KEY.Tab) {
	        if (!popup.hidden) closePopup({
	          moveFocusButton: false
	        });
	        return;
	      }
	      if (handleNavigation(e)) return;
	      if (key === KEY.Enter || key === KEY.Space) {
	        e.preventDefault();
	        const nativeIdx = Number(optionEls[activeIndex]?.dataset.index);
	        handleSelectionKey(e, nativeIdx);
	        return;
	      }
	      if (key === KEY.Escape) {
	        e.preventDefault();
	        closePopup();
	        return;
	      }
	      if (printable) {
	        scheduleTypeahead(key);
	        focusActiveOption({
	          moveFocus: true
	        });
	      }
	    });

	    // --- Typeahead -----------------------------------------------------------

	    let typeBuffer = '';
	    let typeTimer = 0;
	    function scheduleTypeahead(char) {
	      window.clearTimeout(typeTimer);
	      typeBuffer += char;
	      const idx = getIndexByTypeahead(texts, typeBuffer, activeIndex);
	      if (idx >= 0) activeIndex = idx;
	      focusActiveOption({
	        moveFocus: true
	      });
	      typeTimer = window.setTimeout(() => typeBuffer = '', 700);
	    }

	    // --- Observer pour changements externes ----------------------------------

	    const selectObserver = new MutationObserver(mutations => {
	      let needsSync = false;
	      for (const mutation of mutations) {
	        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
	          btn.disabled = selectEl.disabled;
	          btn.toggleAttribute('aria-disabled', selectEl.disabled);
	          needsSync = true;
	        }
	        if (mutation.type === 'childList') {
	          needsSync = true;
	        }
	      }
	      if (needsSync) {
	        syncFromNative();
	      }
	    });
	    selectObserver.observe(selectEl, {
	      attributes: true,
	      attributeFilter: ['disabled'],
	      childList: true,
	      subtree: true
	    });

	    // --- API interne ---------------------------------------------------------

	    function announceValue() {
	      updateButtonUI();
	    }
	    function clearAll() {
	      clearSet();
	    }

	    // --- Destroy -------------------------------------------------------------

	    function destroy() {
	      closePopup({
	        moveFocusButton: false
	      });
	      if (labelEl && labelClickHandler) {
	        labelEl.removeEventListener('click', labelClickHandler);
	      }
	      roList.disconnect();
	      selectObserver.disconnect();
	      if (simpleBarInstance) {
	        simpleBarInstance.unMount();
	      }
	      root.replaceWith(selectEl);
	      selectEl.classList.remove(CLS.vh);
	      selectEl.removeAttribute('aria-hidden');
	      selectEl.tabIndex = 0;
	      delete selectEl.__csEnhanced;
	    }

	    // --- API publique --------------------------------------------------------

	    return {
	      root,
	      button: btn,
	      popup,
	      listbox,
	      select: selectEl,
	      destroy,
	      open: openPopup,
	      close: closePopup,
	      syncFromNative,
	      clearAll,
	      deselectByIndex: deselectIndex,
	      isPlaceholderOption,
	      get nativeOptions() {
	        return nativeOptionsArr;
	      },
	      get selectedIndices() {
	        return Array.from(selectedSet);
	      }
	    };
	  }
	  function enhance(selectEl) {
	    if (!(selectEl instanceof HTMLSelectElement)) return null;
	    if (selectEl.__csEnhanced) return selectEl.__csEnhanced;
	    const instance = build(selectEl);
	    selectEl.__csEnhanced = instance;
	    return instance;
	  }
	  function enhanceAll(selector = 'select.a-select, select.js-custom-select') {
	    return Array.from(document.querySelectorAll(selector)).map(s => enhance(s)).filter(Boolean);
	  }
	  return {
	    enhance,
	    enhanceAll
	  };
	})();

	// ESM exports
	const {
	  enhance,
	  enhanceAll
	} = CustomSelectEnhancer;

	var customSelect = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: CustomSelectEnhancer,
		enhance: enhance,
		enhanceAll: enhanceAll
	});

	/**
	 * Form Filters Manager
	 * Gère les chips et la réinitialisation des formulaires avec custom selects et datepickers
	 * - Détection automatique des forms avec .form-has-chips ou .js-form-has-chips
	 * - Création/suppression de chips pour les sélections
	 * - Bouton reset conditionnel (.init-filters)
	 * - Support des datepickers
	 */

	// Helper pour détecter si une option est un placeholder
	function isPlaceholderOption(opt) {
	  return opt.hasAttribute('data-placeholder') || opt.value === '-1' || opt.value === '';
	}
	const FormFiltersManager = (() => {
	  const CLS = {
	    formWithChips: 'form-has-chips',
	    formWithChipsAlt: 'js-form-has-chips',
	    chipsContainer: 'u-group.chips',
	    chip: 'a-chip',
	    resetBtn: 'init-filters',
	    datepicker: 'datepicker',
	    select: 'select.a-select, select.js-custom-select'
	  };
	  class FormFiltersInstance {
	    constructor(form) {
	      this.form = form;
	      this.chipsContainer = form.querySelector(`.${CLS.chipsContainer}`);
	      this.resetBtn = form.querySelector(`.${CLS.resetBtn}`);
	      this.selects = new Map(); // Map<selectElement, chipsRel>
	      this.datepickers = new Set();
	      this._init();
	    }
	    _init() {
	      // Collecter les selects et leur relation chips
	      const selectEls = [...this.form.querySelectorAll(CLS.select)];
	      selectEls.forEach(selectEl => {
	        const chipsRel = this._getChipsRel(selectEl);
	        this.selects.set(selectEl, chipsRel);

	        // Écouter les changements
	        selectEl.addEventListener('change', () => {
	          this.syncChipsForSelect(selectEl);
	          this.updateResetVisibility();
	        });
	      });

	      // Collecter les datepickers
	      const datepickerEls = [...this.form.querySelectorAll(`input.${CLS.datepicker}`)];
	      datepickerEls.forEach(dp => {
	        this.datepickers.add(dp);

	        // Écouter les changements
	        dp.addEventListener('change', () => {
	          this.updateResetVisibility();
	        });
	      });

	      // Setup reset button
	      if (this.resetBtn) {
	        this.resetBtn.addEventListener('click', () => this.resetAll());
	      }

	      // Sync initial
	      this.syncAllChips();
	      this.updateResetVisibility();
	    }
	    _getChipsRel(selectEl) {
	      return selectEl.getAttribute('data-chips-rel') || this.form.getAttribute('data-chips-rel') || (selectEl.name ? `cs-${selectEl.name}` : '') || (selectEl.id ? `cs-${selectEl.id}` : '') || `cs-${Math.random().toString(36).slice(2, 9)}`;
	    }
	    _createChip(label, value, chipsRel, selectEl) {
	      if (!this.chipsContainer) return null;
	      const btnChip = document.createElement('button');
	      btnChip.type = 'button';
	      btnChip.className = CLS.chip;
	      btnChip.setAttribute('rel', chipsRel);
	      btnChip.setAttribute('data-option_val', String(value));
	      const span = document.createElement('span');
	      span.className = 'sr-only';
	      span.textContent = 'Supprimer le filtre';
	      btnChip.textContent = label;
	      btnChip.appendChild(span);
	      btnChip.addEventListener('click', () => {
	        this._removeChipAndDeselect(btnChip, selectEl);
	      });
	      return btnChip;
	    }
	    _removeChipAndDeselect(chip, selectEl) {
	      const value = chip.getAttribute('data-option_val');

	      // Désélectionner l'option native
	      const optIndex = [...selectEl.options].findIndex(o => o.value === String(value));
	      if (optIndex >= 0) {
	        selectEl.options[optIndex].selected = false;

	        // Si le select a une instance custom, la synchroniser
	        const csInstance = selectEl.__csEnhanced;
	        if (csInstance && typeof csInstance.deselectByIndex === 'function') {
	          csInstance.deselectByIndex(optIndex);
	        } else {
	          selectEl.dispatchEvent(new Event('change', {
	            bubbles: true
	          }));
	        }
	      }

	      // Retirer le chip
	      const next = chip.nextElementSibling || chip.previousElementSibling;
	      chip.remove();

	      // Focus sur le chip suivant ou le bouton du select
	      if (next instanceof HTMLButtonElement && next.classList.contains(CLS.chip)) {
	        next.focus();
	      } else {
	        const csInstance = selectEl.__csEnhanced;
	        if (csInstance?.button) {
	          csInstance.button.focus();
	        }
	      }
	      this.updateResetVisibility();
	    }
	    syncChipsForSelect(selectEl) {
	      if (!this.chipsContainer) return;
	      const chipsRel = this.selects.get(selectEl);
	      if (!chipsRel) return;
	      const selector = `.${CLS.chip}[rel="${CSS.escape(chipsRel)}"][data-option_val]`;
	      const existingChips = new Map([...this.chipsContainer.querySelectorAll(selector)].map(ch => [ch.getAttribute('data-option_val'), ch]));
	      const selected = [...selectEl.selectedOptions].filter(o => !isPlaceholderOption(o));
	      const selectedVals = new Set(selected.map(o => String(o.value)));

	      // Ajouter les chips manquantes
	      selected.forEach(opt => {
	        const val = String(opt.value);
	        if (!existingChips.has(val)) {
	          const chip = this._createChip(opt.textContent?.trim() || '', val, chipsRel, selectEl);
	          if (chip) this.chipsContainer.appendChild(chip);
	        }
	      });

	      // Retirer les chips obsolètes
	      existingChips.forEach((chip, val) => {
	        if (!selectedVals.has(val)) chip.remove();
	      });
	    }
	    syncAllChips() {
	      this.selects.forEach((chipsRel, selectEl) => {
	        this.syncChipsForSelect(selectEl);
	      });
	    }
	    hasAnySelection() {
	      // Vérifier les selects
	      const hasSelectSelection = [...this.selects.keys()].some(selectEl => [...selectEl.options].some(o => o.selected && !isPlaceholderOption(o)));

	      // Vérifier les datepickers
	      const hasDatepickerValue = [...this.datepickers].some(dp => dp.value && dp.value.trim() !== '');
	      return hasSelectSelection || hasDatepickerValue;
	    }
	    updateResetVisibility() {
	      if (!this.resetBtn) return;
	      this.resetBtn.hidden = !this.hasAnySelection();
	    }
	    resetAll() {
	      // Réinitialiser tous les selects
	      this.selects.forEach((chipsRel, selectEl) => {
	        const csInstance = selectEl.__csEnhanced;
	        if (csInstance && typeof csInstance.clearAll === 'function') {
	          csInstance.clearAll();
	          csInstance.close({
	            moveFocusButton: false
	          });
	        } else {
	          // Fallback: réinitialisation native
	          [...selectEl.options].forEach(opt => {
	            if (!isPlaceholderOption(opt)) {
	              opt.selected = false;
	            }
	          });
	          selectEl.dispatchEvent(new Event('change', {
	            bubbles: true
	          }));
	        }
	      });

	      // Réinitialiser tous les datepickers
	      this.datepickers.forEach(dp => {
	        dp.value = '';
	        dp.dispatchEvent(new Event('change', {
	          bubbles: true
	        }));
	      });

	      // Nettoyer tous les chips
	      if (this.chipsContainer) {
	        [...this.chipsContainer.querySelectorAll(`.${CLS.chip}`)].forEach(chip => chip.remove());
	      }
	      this.updateResetVisibility();

	      // Focus sur le premier élément
	      const firstSelect = [...this.selects.keys()][0];
	      const firstDatepicker = [...this.datepickers][0];
	      const firstInput = firstSelect || firstDatepicker;
	      if (firstInput) {
	        const csInstance = firstInput.__csEnhanced;
	        if (csInstance?.button) {
	          csInstance.button.focus();
	        } else {
	          firstInput.focus();
	        }
	      }
	    }
	    destroy() {
	      // Pas besoin de nettoyer les event listeners sur les selects/datepickers
	      // car ils seront garbage collected avec les éléments
	      this.selects.clear();
	      this.datepickers.clear();
	    }
	  }

	  // --- API publique ---

	  function init(form) {
	    if (!(form instanceof HTMLFormElement)) return null;
	    if (form.__formFilters) return form.__formFilters;

	    // Vérifier si le form a la classe nécessaire
	    if (!form.classList.contains(CLS.formWithChips) && !form.classList.contains(CLS.formWithChipsAlt)) {
	      return null;
	    }
	    const instance = new FormFiltersInstance(form);
	    form.__formFilters = instance;
	    return instance;
	  }
	  function initAll(selector = `.${CLS.formWithChips}, .${CLS.formWithChipsAlt}`) {
	    return Array.from(document.querySelectorAll(selector)).map(form => init(form)).filter(Boolean);
	  }
	  return {
	    init,
	    initAll
	  };
	})();

	// ESM exports
	const {
	  init: init$3,
	  initAll
	} = FormFiltersManager;

	var formFilters = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: FormFiltersManager,
		init: init$3,
		initAll: initAll
	});

	function filtersPerPageResults() {
	  const container = DOM?.perPageResults;
	  if (!container) return;
	  const nativeSelect = container.querySelector('select.a-select');
	  if (!nativeSelect) return;

	  // Appliquer le paramètre 'nb' de l'URL au select natif (sans déclencher de changement)
	  const url = new URL(window.location.href);
	  const nb = url.searchParams.get('nb');
	  if (nb !== null) {
	    const hasOption = Array.from(nativeSelect.options).some(o => o.value === nb);
	    if (hasOption && nativeSelect.value !== nb) {
	      nativeSelect.value = nb;
	      // Sync the custom select UI if already enhanced, without triggering a change event
	      nativeSelect.__csEnhanced?.syncFromNative();
	    }
	  }

	  // Quand l'utilisateur change manuellement, on met à jour l'URL et on recharge
	  nativeSelect.addEventListener('change', e => {
	    const value = e.target.value;
	    const newUrl = new URL(window.location.href);
	    if (value === '' || value === null) {
	      newUrl.searchParams.delete('nb');
	    } else {
	      newUrl.searchParams.set('nb', value);
	    }

	    // Utiliser replace pour éviter d'ajouter une entrée dans l'historique
	    window.location.replace(newUrl.toString());
	  });
	}

	var filtersPerpage = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: filtersPerPageResults
	});

	function filters() {
	  const filtersBlocks = DOM.filters;
	  if (!filtersBlocks.length) return;
	  filtersBlocks.forEach(block => {
	    const form = block.querySelector('.o-filters__form');
	    if (!form) return;
	    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
	    const btnInit = form.querySelector('.init-filters');
	    const btnAll = form.querySelector('.all-filters');
	    if (btnInit) {
	      btnInit.addEventListener('click', () => {
	        checkboxes.forEach(cb => cb.checked = false);
	      });
	    }
	    if (btnAll) {
	      btnAll.addEventListener('click', () => {
	        checkboxes.forEach(cb => cb.checked = true);
	      });
	    }
	  });
	}

	var filters$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: filters
	});

	/**
	 * Truncate HTML content while preserving tags
	 */
	function truncateHTML(html, maxLength) {
	  const tempDiv = document.createElement('div');
	  tempDiv.innerHTML = html;
	  let charCount = 0;
	  function truncateNode(node) {
	    if (charCount >= maxLength) {
	      return null;
	    }
	    if (node.nodeType === Node.TEXT_NODE) {
	      const remainingChars = maxLength - charCount;
	      const text = node.textContent;
	      if (text.length <= remainingChars) {
	        charCount += text.length;
	        return node.cloneNode(true);
	      }
	      charCount = maxLength;
	      return document.createTextNode(`${text.substring(0, remainingChars)}...`);
	    }
	    if (node.nodeType === Node.ELEMENT_NODE) {
	      const clone = node.cloneNode(false);
	      for (let i = 0; i < node.childNodes.length && charCount < maxLength; i++) {
	        const truncatedChild = truncateNode(node.childNodes[i]);
	        if (truncatedChild) {
	          clone.appendChild(truncatedChild);
	        }
	      }
	      return clone;
	    }
	    return null;
	  }
	  const resultDiv = document.createElement('div');
	  for (let i = 0; i < tempDiv.childNodes.length && charCount < maxLength; i++) {
	    const truncatedChild = truncateNode(tempDiv.childNodes[i]);
	    if (truncatedChild) {
	      resultDiv.appendChild(truncatedChild);
	    }
	  }
	  return resultDiv.innerHTML;
	}

	/**
	 * Get plain text length from HTML
	 */
	function getPlainTextLength(html) {
	  const tempDiv = document.createElement('div');
	  tempDiv.innerHTML = html;
	  return (tempDiv.textContent || tempDiv.innerText || '').trim().length;
	}

	/**
	 * Handle edito text truncation with HTML content
	 */
	function initEditoTextTruncation() {
	  const editoContainers = document.querySelectorAll('.o-wysiwyg.edito-container');
	  editoContainers.forEach(container => {
	    const btn = container.querySelector('.edito-expand-btn');
	    if (!btn) {
	      return;
	    }

	    // Check if already initialized
	    if (container.dataset.truncationInitialized === 'true') {
	      return;
	    }

	    // Get all content nodes except the h3 title and the button
	    const h3 = container.querySelector('h3');
	    const contentNodes = Array.from(container.children).filter(child => child !== h3 && child !== btn && !child.classList.contains('edito-content-wrapper'));
	    if (contentNodes.length === 0) {
	      return;
	    }

	    // Create a wrapper div to hold the content
	    const wrapper = document.createElement('div');
	    wrapper.className = 'edito-content-wrapper';

	    // Move all content nodes into the wrapper
	    contentNodes.forEach(node => {
	      wrapper.appendChild(node.cloneNode(true));
	    });
	    const fullHtml = wrapper.innerHTML.trim();
	    const truncateLength = parseInt(container.getAttribute('data-truncate-length')) || 400;
	    const plainTextLength = getPlainTextLength(fullHtml);

	    // Check if truncation is needed
	    if (plainTextLength > truncateLength) {
	      // Truncate on page load
	      wrapper.innerHTML = truncateHTML(fullHtml, truncateLength);

	      // Remove original content nodes
	      contentNodes.forEach(node => {
	        if (node.parentNode === container) {
	          container.removeChild(node);
	        }
	      });

	      // Insert wrapper after h3
	      if (h3 && h3.nextSibling) {
	        container.insertBefore(wrapper, h3.nextSibling);
	      } else if (h3) {
	        container.appendChild(wrapper);
	      } else {
	        container.insertBefore(wrapper, container.firstChild);
	      }

	      // Make sure button is at the end
	      if (btn.parentNode === container) {
	        container.removeChild(btn);
	      }
	      container.appendChild(btn);

	      // Store wrapper reference on button for later access
	      const wrapperId = 'edito-wrapper';
	      wrapper.id = wrapperId;

	      // Show the button
	      btn.classList.remove('is-hidden');

	      // Add click event listener
	      const clickHandler = e => {
	        e.preventDefault();
	        e.stopPropagation();
	        const currentWrapper = document.getElementById(wrapperId);
	        if (!currentWrapper) {
	          return;
	        }
	        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
	        if (isExpanded) {
	          // Collapse
	          currentWrapper.innerHTML = truncateHTML(fullHtml, truncateLength);
	          btn.querySelector('.expand-text').textContent = 'Lire la suite';
	          btn.setAttribute('aria-expanded', 'false');
	        } else {
	          // Expand
	          currentWrapper.innerHTML = fullHtml;
	          btn.querySelector('.expand-text').textContent = 'Lire moins';
	          btn.setAttribute('aria-expanded', 'true');
	        }
	      };
	      btn.addEventListener('click', clickHandler);

	      // Mark as initialized
	      container.dataset.truncationInitialized = 'true';
	    }
	  });
	}

	/**
	 * Mount Splide for key numbers
	 */
	function buildKeyNumbers() {
	  const keyfigureElts = DOM.keyFigures;
	  if (keyfigureElts.length) {
	    const splideOptions = {
	      type: 'slide',
	      autoplay: false,
	      drag: true,
	      role: 'group',
	      i18n: SLIDER_OPTIONS_I18N_KEYFIGURES,
	      traversing: true,
	      perPage: 1,
	      perMove: 1,
	      mediaQuery: 'min',
	      breakpoints: {
	        768: {
	          perPage: 2
	        },
	        1440: {
	          destroy: 'completely'
	        }
	      }
	    };
	    keyfigureElts.forEach(sliderElt => {
	      //  Détruire l'instance existante si elle existe
	      if (sliderElt.splide) {
	        try {
	          sliderElt.splide.destroy(true); // true = destruction complète avec nettoyage DOM
	        } catch (e) {
	          // console.warn('Erreur lors de la destruction de Splide:', e);
	        }
	        delete sliderElt.splide;
	      }
	      const splideObj = new Splide(sliderElt, splideOptions);

	      // Stocker la référence de l'instance
	      sliderElt.splide = splideObj;
	      splideObj.on('mounted', () => {
	        // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	        onSplideMounted(splideObj, sliderElt);

	        // Replace default role="presentation" on <ul> to keep children semantic
	        const list = splideObj.Components.Elements.list;
	        // list.setAttribute('role', 'list');
	        list.removeAttribute('role');
	      });

	      // If traversing option is set
	      // Make all slides inside viewport visible and focusable
	      if (typeof splideOptions.traversing !== 'undefined') {
	        splideObj.on('mounted move updated resized', () => {
	          window.setTimeout(() => {
	            updateTabIndex(splideObj);
	          }, 450);
	        });
	      }

	      // Destroy
	      splideObj.on('destroy', () => {
	        onSplideDestroy(splideObj, sliderElt);
	        // AJOUT : Nettoyer la référence
	        delete sliderElt.splide;
	      });

	      // Mount slider
	      splideObj.mount();

	      /**
	       * Event resize
	       */
	      window.addEventListener('optimizedResize', () => {
	        if ((isMobile() || isLg()) && !sliderElt.classList.contains(CLASS.IS_ACTIVE)) {
	          splideObj.destroy();
	          splideObj.mount();
	          enableSplideControls(sliderElt);
	        }
	        if (!isMobile() && !isLg()) {
	          splideObj.destroy();
	          disableSplideControls(sliderElt);
	        }
	      });
	    });
	  }

	  // Initialize edito text truncation
	  initEditoTextTruncation();
	}

	var keyFigures = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildKeyNumbers
	});

	/**
	 * Mount Splide for cards list (Article / Events / Region websites)
	 */
	function buildCardsSliders() {
	  const splideOptions = {
	    type: 'slide',
	    pagination: true,
	    autoplay: false,
	    drag: true,
	    role: 'group',
	    autoWidth: true,
	    perMove: 1,
	    perPage: 1,
	    accessibility: {
	      pagination: {
	        role: false,
	        // Ne pas ajouter role="tablist"
	        tab: false // Ne pas ajouter role="tab"
	      }
	    },
	    // gap: 0,
	    mediaQuery: 'min',
	    breakpoints: {
	      768: {
	        perPage: 2
	      },
	      1440: {
	        perPage: 3
	      }
	    }
	  };
	  DOM.cardsSlider.forEach(sliderElt => {
	    // Cards article, events, portal, ...
	    const sliderType = sliderElt.dataset.sliderType;
	    if (sliderType === 'projet') {
	      splideOptions.i18n = SLIDER_OPTIONS_I18N_PROJETS;
	    } else if (sliderElt.querySelector('.o-list-cards--article')) {
	      splideOptions.i18n = SLIDER_OPTIONS_I18N_ACTUALITIES;
	    } else if (sliderElt.querySelector('.o-list-cards--event')) {
	      splideOptions.i18n = SLIDER_OPTIONS_I18N_EVENTS;
	    } else if (sliderElt.querySelector('.o-list-cards--podcast')) {
	      splideOptions.i18n = SLIDER_OPTIONS_I18N_NEO_MEDIAS;
	    } else if (sliderElt.querySelector('.o-list-cards--filiere')) {
	      splideOptions.i18n = SLIDER_OPTIONS_I18N_FILIERES;
	    }

	    /** Custom slider options */
	    if (sliderElt.closest('.mod-list-cards').classList.contains('mod-list-cards--narrow')) {
	      splideOptions.perPage = 1;
	      splideOptions.animated = false;
	      splideOptions.breakpoints = {
	        1024: {
	          animated: true
	        }
	      };
	    }

	    // Filieres prioritaires
	    if (sliderElt.closest('.mod-list-cards').classList.contains('mod-list-cards--filiere')) {
	      splideOptions.traversing = true;
	    }

	    // Slider to cards 1 big on left / 3 rows on right
	    if (sliderElt.closest('.mod-list-cards').classList.contains('mod-list-cards--grid-1-3')) {
	      splideOptions.traversing = true;
	      splideOptions.breakpoints = {
	        0: {
	          perPage: 1
	        },
	        768: {
	          perPage: 2
	        },
	        1024: {
	          perPage: 3
	        },
	        1440: {
	          destroy: 'completely',
	          traversing: false
	        }
	      };
	    }

	    // Sites de la Région
	    if (sliderElt.closest('.mod-list-cards').classList.contains('mod-list-cards--portal')) {
	      splideOptions.i18n = SLIDER_OPTIONS_I18N_PORTALS;
	      // splideOptions.gap = 0;
	      splideOptions.autoWidth = true;
	      splideOptions.traversing = true;
	      splideOptions.perPage = 3;
	      splideOptions.breakpoints = {
	        0: {
	          perPage: 1
	        },
	        768: {
	          perPage: 2
	        },
	        1024: {
	          perPage: 3,
	          traversing: false
	        }
	      };
	    }
	    const splideObj = new Splide(sliderElt, splideOptions);
	    splideObj.on('mounted', () => {
	      // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	      onSplideMounted(splideObj, sliderElt);

	      // Replace default role="presentation" on <ul> to keep children semantic
	      const list = splideObj.Components.Elements.list;
	      // list.setAttribute('role', 'list');
	      list.removeAttribute('role');

	      // Associate list and its interactive elements with section heading for screen readers
	      const heading = sliderElt.parentElement.querySelector('h2[id]');
	      if (heading) {
	        list.setAttribute('aria-labelledby', heading.id);
	        list.querySelectorAll('.splide__slide a').forEach(link => {
	          link.setAttribute('aria-describedby', heading.id);
	        });
	      }
	    });

	    // If traversing option is set
	    // Make all slides inside viewport visible and focusable
	    if (typeof splideOptions.traversing !== 'undefined') {
	      splideObj.on('mounted move updated resized', () => {
	        window.setTimeout(() => {
	          updateTabIndex(splideObj);
	        }, 450);
	      });
	    }

	    // If animated option is true
	    // Play CSS animation on item move
	    if (typeof splideOptions.animated !== 'undefined') {
	      splideObj.on('move', newIndex => {
	        const slides = sliderElt.querySelectorAll('.splide__slide');
	        slides.forEach((slide, index) => {
	          if (index === newIndex) {
	            slide.classList.add('is-active');
	          } else {
	            slide.classList.remove('is-active');
	          }
	        });
	      });
	    }

	    // Destroy
	    splideObj.on('destroy', () => {
	      onSplideDestroy(splideObj, sliderElt);
	    });

	    // Mount slider
	    splideObj.mount();

	    /**
	     * Event resize
	     */
	    window.addEventListener('optimizedResize', () => {
	      // if (sliderElt.closest('.mod-list-cards').classList.contains('mod-list-cards--grid-1-3')) {

	      if ((isMobile() || isLg()) && !sliderElt.classList.contains(CLASS.IS_ACTIVE)) {
	        splideObj.destroy();
	        splideObj.mount();
	        enableSplideControls(sliderElt);
	      }
	      if (!isMobile() && !isLg()) {
	        splideObj.destroy();
	        disableSplideControls(sliderElt);
	      }
	      // }
	    });
	  });
	}

	var slidersCardsList = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildCardsSliders
	});

	// import ScrollTrigger from '@terwanerik/scrolltrigger';
	class SummaryA11y {
	  constructor({
	    summarySelector = '#summary-nav',
	    linkSelector = 'a[href^="#"]',
	    colSelector = '._col',
	    backLinkClass = 'summary-back',
	    backLinkText = 'Retour au sommaire',
	    offset = 0,
	    respectReducedMotion = true
	  } = {}) {
	    this.tableOfContent = document.querySelector(summarySelector);
	    if (!this.tableOfContent) return;

	    // Cible privilégiée pour le focus au retour : la <nav> interne si présente
	    this.tableOfContentNav = this.tableOfContent.querySelector('nav') || this.tableOfContent;

	    // Sémantique ARIA sur la vraie zone de navigation
	    this.tableOfContentNav.setAttribute('role', this.tableOfContentNav.getAttribute('role') || 'navigation');
	    // if (!this.tableOfContentNav.getAttribute('aria-label')) this.tableOfContentNav.setAttribute('aria-label', 'Sommaire');

	    this.options = {
	      summarySelector,
	      linkSelector,
	      colSelector,
	      backLinkClass,
	      backLinkText,
	      offset,
	      respectReducedMotion
	    };
	    this.links = Array.from(this.tableOfContent.querySelectorAll(linkSelector)).filter(a => a.getAttribute('href')?.startsWith('#') && a.getAttribute('href') !== '#');
	    this._onTocClick = this.onTocClick.bind(this);
	    this._onBackClick = this.onBackClick.bind(this);
	    this.bindEvents();
	    this.handleInitialHash();
	  }
	  bindEvents() {
	    this.tableOfContent.addEventListener('click', this._onTocClick);
	    document.addEventListener('click', this._onBackClick);
	  }
	  destroy() {
	    this.tableOfContent?.removeEventListener('click', this._onTocClick);
	    document.removeEventListener('click', this._onBackClick);
	  }
	  prefersReducedMotion() {
	    return this.options.respectReducedMotion && window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
	  }

	  /* ---------- NAV SOMMAIRE -> SECTION ---------- */
	  onTocClick(e) {
	    const link = e.target.closest('a');
	    if (!link || !this.links.includes(link)) return;
	    const hash = link.getAttribute('href');
	    const id = hash.slice(1);
	    const target = document.getElementById(id);
	    if (!target) return;
	    e.preventDefault();
	    history.pushState(null, '', hash);
	    this.scrollTo(target).then(() => {
	      const col = this.getColContainer(target);
	      if (col) this.ensureBackLink(target, col);
	      this.focusTarget(col || target, {
	        silent: true
	      });
	    });
	  }

	  /* ---------- LIEN RETOUR -> SOMMAIRE ---------- */
	  onBackClick(e) {
	    const a = e.target.closest('a');
	    if (!a || !a.classList.contains(this.options.backLinkClass)) return;
	    e.preventDefault();

	    // Nettoie l’URL
	    const {
	      origin,
	      pathname,
	      search
	    } = window.location;
	    history.replaceState(null, '', origin + pathname + search);

	    // Scroll vers le conteneur, focus sur la <nav> interne
	    this.scrollTo(this.tableOfContent).then(() => {
	      this.focusTarget(this.tableOfContentNav, {
	        silent: true
	      });
	    });
	  }

	  /* ---------- CHARGEMENT AVEC HASH ---------- */
	  handleInitialHash() {
	    const hash = window.location.hash;
	    if (!hash || hash === '#') return;
	    const id = decodeURIComponent(hash.slice(1));
	    const target = document.getElementById(id);
	    if (!target) return;
	    requestAnimationFrame(() => {
	      this.scrollTo(target).then(() => {
	        const col = this.getColContainer(target);
	        if (col) this.ensureBackLink(target, col);
	        this.focusTarget(col || target, {
	          silent: true
	        });
	      });
	    });
	  }

	  /* ---------- OUTILS ---------- */
	  scrollTo(target) {
	    const top = target.getBoundingClientRect().top + window.pageYOffset - this.options.offset;
	    const behavior = this.prefersReducedMotion() ? 'auto' : 'smooth';
	    return new Promise(resolve => {
	      window.scrollTo({
	        top,
	        behavior
	      });
	      setTimeout(resolve, behavior === 'smooth' ? 150 : 0);
	    });
	  }

	  // Focus silencieux (anneau masqué au clic), visible au clavier
	  focusTarget(el, {
	    silent = true
	  } = {}) {
	    if (!el) return;
	    const hadTabIndex = el.hasAttribute('tabindex');
	    if (!hadTabIndex) el.setAttribute('tabindex', '-1');
	    el.classList.toggle('is-silent-focus', !!silent);
	    el.focus({
	      preventScroll: true
	    });
	    el.addEventListener('blur', () => {
	      if (!hadTabIndex) el.removeAttribute('tabindex');
	      el.classList.remove('is-silent-focus');
	    }, {
	      once: true
	    });
	  }
	  ensureBackLink(sectionEl, colContainer) {
	    if (colContainer.querySelector(`a.${this.options.backLinkClass}`)) return;
	    const backLink = document.createElement('a');
	    backLink.href = this.options.summarySelector; // intercepté pour retirer le hash
	    backLink.className = `a-link ${this.options.backLinkClass}`;
	    backLink.textContent = this.options.backLinkText;
	    backLink.setAttribute('aria-label', this.options.backLinkText);
	    colContainer.appendChild(backLink);
	  }
	  getColContainer(sectionEl) {
	    const cols = sectionEl.querySelectorAll(this.options.colSelector);
	    return cols.length ? cols[cols.length - 1] : sectionEl;
	  }
	}

	var summary = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: SummaryA11y
	});

	/**
	 * Parvus
	 *
	 * @author Benjamin de Oostfrees
	 * @version 2.6.0
	 * @url https://github.com/deoostfrees/parvus
	 *
	 * MIT license
	 */

	const FOCUSABLE_ELEMENTS = ['a:not([inert]):not([tabindex^="-"])', 'button:not([inert]):not([tabindex^="-"]):not(:disabled)', '[tabindex]:not([inert]):not([tabindex^="-"])'];

	/**
	 * Get the focusable children of the given element
	 *
	 * @return {Array<Element>} - An array of focusable children
	 */
	const getFocusableChildren = targetEl => {
	  return Array.from(targetEl.querySelectorAll(FOCUSABLE_ELEMENTS.join(', '))).filter(child => child.offsetParent !== null);
	};
	const BROWSER_WINDOW = window;

	/**
	 * Get scrollbar width
	 *
	 * @return {Number} - The scrollbar width
	 */
	const getScrollbarWidth = () => {
	  return BROWSER_WINDOW.innerWidth - document.documentElement.clientWidth;
	};

	/**
	 * Add zoom indicator to element
	 *
	 * @param {HTMLElement} el - The element to add the zoom indicator to
	 * @param {Object} config - Options object
	 */
	const addZoomIndicator = (el, config) => {
	  if (el.querySelector('img') && el.querySelector('.parvus-zoom__indicator') === null) {
	    const LIGHTBOX_INDICATOR_ICON = document.createElement('div');
	    LIGHTBOX_INDICATOR_ICON.className = 'parvus-zoom__indicator';
	    LIGHTBOX_INDICATOR_ICON.innerHTML = config.lightboxIndicatorIcon;
	    el.appendChild(LIGHTBOX_INDICATOR_ICON);
	  }
	};

	/**
	 * Remove zoom indicator for element
	 *
	 * @param {HTMLElement} el - The element to remove the zoom indicator to
	 */
	const removeZoomIndicator = el => {
	  if (el.querySelector('img') && el.querySelector('.parvus-zoom__indicator') !== null) {
	    const LIGHTBOX_INDICATOR_ICON = el.querySelector('.parvus-zoom__indicator');
	    el.removeChild(LIGHTBOX_INDICATOR_ICON);
	  }
	};
	var en = {
	  lightboxLabel: 'This is a dialog window that overlays the main content of the page. The modal displays the enlarged image. Pressing the Escape key will close the modal and bring you back to where you were on the page.',
	  lightboxLoadingIndicatorLabel: 'Image loading',
	  lightboxLoadingError: 'The requested image cannot be loaded.',
	  controlsLabel: 'Controls',
	  previousButtonLabel: 'Previous image',
	  nextButtonLabel: 'Next image',
	  closeButtonLabel: 'Close dialog window',
	  sliderLabel: 'Images',
	  slideLabel: 'Image'
	};
	function Parvus(userOptions) {
	  /**
	   * Global variables
	   *
	   */
	  const BROWSER_WINDOW = window;
	  const GROUP_ATTRIBUTES = {
	    triggerElements: [],
	    slider: null,
	    sliderElements: [],
	    contentElements: []
	  };
	  const GROUPS = {};
	  let groupIdCounter = 0;
	  let newGroup = null;
	  let activeGroup = null;
	  let currentIndex = 0;
	  let config = {};
	  let lightbox = null;
	  let lightboxOverlay = null;
	  let lightboxOverlayOpacity = 1;
	  let toolbar = null;
	  let toolbarLeft = null;
	  let toolbarRight = null;
	  let controls = null;
	  let previousButton = null;
	  let nextButton = null;
	  let closeButton = null;
	  let counter = null;
	  let drag = {};
	  let isDraggingX = false;
	  let isDraggingY = false;
	  let pointerDown = false;
	  let lastFocus = null;
	  let offset = null;
	  let offsetTmp = null;
	  let resizeTicking = false;
	  let transitionDuration = null;
	  let isReducedMotion = true;

	  /**
	   * Merge default options with user-provided options
	   *
	   * @param {Object} userOptions - User-provided options
	   * @returns {Object} - Merged options object
	   */
	  const mergeOptions = userOptions => {
	    // Default options
	    const DEFAULT_OPTIONS = {
	      loadEmpty: false,
	      selector: '.lightbox',
	      gallerySelector: null,
	      captions: true,
	      captionsSelector: 'self',
	      captionsAttribute: 'data-caption',
	      docClose: true,
	      swipeClose: true,
	      simulateTouch: true,
	      threshold: 50,
	      backFocus: true,
	      hideScrollbar: true,
	      transitionDuration: 300,
	      transitionTimingFunction: 'cubic-bezier(0.62, 0.16, 0.13, 1.01)',
	      lightboxIndicatorIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" stroke="currentColor"><path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"/></svg>',
	      previousButtonIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" stroke="currentColor"><path stroke="none" d="M0 0h24v24H0z"/><polyline points="15 6 9 12 15 18" /></svg>',
	      nextButtonIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" stroke="currentColor"><path stroke="none" d="M0 0h24v24H0z"/><polyline points="9 6 15 12 9 18" /></svg>',
	      closeButtonIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" stroke="currentColor"><path d="M18 6L6 18M6 6l12 12"/></svg>',
	      l10n: en
	    };
	    const MERGED_OPTIONS = {
	      ...DEFAULT_OPTIONS,
	      ...userOptions
	    };
	    if (userOptions && userOptions.l10n) {
	      MERGED_OPTIONS.l10n = {
	        ...DEFAULT_OPTIONS.l10n,
	        ...userOptions.l10n
	      };
	    }
	    return MERGED_OPTIONS;
	  };

	  /**
	   * Check prefers reduced motion
	   * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
	   *
	   */
	  const MOTIONQUERY = BROWSER_WINDOW.matchMedia('(prefers-reduced-motion)');
	  const reducedMotionCheck = () => {
	    if (MOTIONQUERY.matches) {
	      isReducedMotion = true;
	      transitionDuration = 0.1;
	    } else {
	      isReducedMotion = false;
	      transitionDuration = config.transitionDuration;
	    }
	  };

	  /**
	   * Get the group from element
	   *
	   * @param {HTMLElement} el - The element to retrieve the group from
	   * @return {String} - The group of the element
	   */
	  const getGroup = el => {
	    // Check if the data attribute "group" exists or set an alternative value
	    const EL_GROUP = el.dataset.group || `default-${groupIdCounter}`;
	    ++groupIdCounter;

	    // Set the "group" data attribute if it doesn't exist
	    if (!el.hasAttribute('data-group')) {
	      el.setAttribute('data-group', EL_GROUP);
	    }
	    return EL_GROUP;
	  };

	  /**
	   * Add an element
	   *
	   * @param {HTMLElement} el - The element to be added
	   */
	  const add = el => {
	    if (!lightbox) {
	      return;
	    }
	    if (!(el.tagName === 'A' && el.hasAttribute('href') || el.tagName === 'BUTTON' && el.hasAttribute('data-target'))) {
	      throw new Error('Use a link with the \'href\' attribute or a button with the \'data-target\' attribute. Both attributes must contain a path to the image file.');
	    }
	    newGroup = getGroup(el);
	    if (!GROUPS[newGroup]) {
	      GROUPS[newGroup] = structuredClone(GROUP_ATTRIBUTES);
	    }
	    if (GROUPS[newGroup].triggerElements.includes(el)) {
	      throw new Error('Ups, element already added.');
	    }
	    GROUPS[newGroup].triggerElements.push(el);
	    addZoomIndicator(el, config);
	    el.classList.add('parvus-trigger');
	    el.addEventListener('click', triggerParvus);
	    if (isOpen() && newGroup === activeGroup) {
	      const EL_INDEX = GROUPS[newGroup].triggerElements.indexOf(el);
	      createSlide(EL_INDEX);
	      createImage(el, EL_INDEX, () => {
	        loadImage(EL_INDEX);
	      });
	      updateAttributes();
	      updateSliderNavigationStatus();
	      updateCounter();
	    }
	  };

	  /**
	   * Remove an element
	   *
	   * @param {HTMLElement} el - The element to be removed
	   */
	  const remove = el => {
	    if (!el || !el.hasAttribute('data-group')) {
	      return;
	    }
	    const EL_GROUP = getGroup(el);

	    // Check if element exists
	    if (!GROUPS[EL_GROUP] || !GROUPS[EL_GROUP].triggerElements.includes(el)) {
	      return;
	    }
	    const EL_INDEX = GROUPS[EL_GROUP].triggerElements.indexOf(el);
	    GROUPS[EL_GROUP].triggerElements.splice(EL_INDEX, 1);
	    GROUPS[EL_GROUP].sliderElements.splice(EL_INDEX, 1);

	    // Remove lightbox indicator icon
	    removeZoomIndicator(el);
	    if (isOpen() && EL_GROUP === activeGroup) {
	      updateAttributes();
	      updateSliderNavigationStatus();
	      updateCounter();
	    }

	    // Unbind click event handler
	    el.removeEventListener('click', triggerParvus);
	    el.classList.remove('parvus-trigger');
	  };

	  /**
	   * Create the lightbox
	   *
	   */
	  const createLightbox = () => {
	    // Create the lightbox container
	    lightbox = document.createElement('div');
	    lightbox.setAttribute('role', 'dialog');
	    lightbox.setAttribute('aria-modal', 'true');
	    lightbox.setAttribute('aria-hidden', 'true');
	    lightbox.setAttribute('tabindex', '-1');
	    lightbox.setAttribute('aria-label', config.l10n.lightboxLabel);
	    lightbox.classList.add('parvus');

	    // Create the lightbox overlay container
	    lightboxOverlay = document.createElement('div');
	    lightboxOverlay.classList.add('parvus__overlay');

	    // Add the lightbox overlay container to the lightbox container
	    lightbox.appendChild(lightboxOverlay);

	    // Create the toolbar
	    toolbar = document.createElement('div');
	    toolbar.className = 'parvus__toolbar';

	    // Create the toolbar items
	    toolbarLeft = document.createElement('div');
	    toolbarRight = document.createElement('div');

	    // Create the controls
	    controls = document.createElement('div');
	    controls.className = 'parvus__controls';
	    controls.setAttribute('role', 'group');
	    controls.setAttribute('aria-label', config.l10n.controlsLabel);

	    // Add the controls to the right toolbar item
	    toolbarRight.appendChild(controls);

	    // Create the close button
	    closeButton = document.createElement('button');
	    closeButton.className = 'parvus__btn parvus__btn--close';
	    closeButton.setAttribute('type', 'button');
	    closeButton.setAttribute('aria-label', config.l10n.closeButtonLabel);
	    closeButton.innerHTML = config.closeButtonIcon;

	    // Add the close button to the controls
	    controls.appendChild(closeButton);

	    // Create the previous button
	    previousButton = document.createElement('button');
	    previousButton.className = 'parvus__btn parvus__btn--previous';
	    previousButton.setAttribute('type', 'button');
	    previousButton.setAttribute('aria-label', config.l10n.previousButtonLabel);
	    previousButton.innerHTML = config.previousButtonIcon;

	    // Add the previous button to the controls
	    controls.appendChild(previousButton);

	    // Create the next button
	    nextButton = document.createElement('button');
	    nextButton.className = 'parvus__btn parvus__btn--next';
	    nextButton.setAttribute('type', 'button');
	    nextButton.setAttribute('aria-label', config.l10n.nextButtonLabel);
	    nextButton.innerHTML = config.nextButtonIcon;

	    // Add the next button to the controls
	    controls.appendChild(nextButton);

	    // Create the counter
	    counter = document.createElement('div');
	    counter.className = 'parvus__counter';

	    // Add the counter to the left toolbar item
	    toolbarLeft.appendChild(counter);

	    // Add the toolbar items to the toolbar
	    toolbar.appendChild(toolbarLeft);
	    toolbar.appendChild(toolbarRight);

	    // Add the toolbar to the lightbox container
	    lightbox.appendChild(toolbar);

	    // Add the lightbox container to the body
	    document.body.appendChild(lightbox);
	  };

	  /**
	   * Create a slider
	   *
	   */
	  const createSlider = () => {
	    const SLIDER = document.createElement('div');
	    SLIDER.className = 'parvus__slider';

	    // Hide the slider
	    SLIDER.setAttribute('aria-hidden', 'true');

	    // Update the slider reference in GROUPS
	    GROUPS[activeGroup].slider = SLIDER;

	    // Add the slider to the lightbox container
	    lightbox.appendChild(SLIDER);
	  };

	  /**
	   * Get next slide index
	   *
	   * @param {Number} index
	   */
	  const getNextSlideIndex = currentIndex => {
	    const SLIDE_ELEMENTS = GROUPS[activeGroup].sliderElements;
	    const TOTAL_SLIDE_ELEMENTS = SLIDE_ELEMENTS.length;
	    for (let i = currentIndex + 1; i < TOTAL_SLIDE_ELEMENTS; i++) {
	      if (SLIDE_ELEMENTS[i] !== undefined) {
	        return i;
	      }
	    }
	    return -1;
	  };

	  /**
	   * Get previous slide index
	   *
	   * @param {number} index - The current slide index
	   * @returns {number} - The index of the previous slide, or -1 if there is no previous slide
	   */
	  const getPreviousSlideIndex = currentIndex => {
	    const SLIDE_ELEMENTS = GROUPS[activeGroup].sliderElements;
	    for (let i = currentIndex - 1; i >= 0; i--) {
	      if (SLIDE_ELEMENTS[i] !== undefined) {
	        return i;
	      }
	    }
	    return -1;
	  };

	  /**
	   * Create a slide
	   *
	   * @param {Number} index - The index of the slide
	   */
	  const createSlide = index => {
	    if (GROUPS[activeGroup].sliderElements[index] !== undefined) {
	      return;
	    }
	    const SLIDER_ELEMENT = document.createElement('div');
	    const SLIDER_ELEMENT_CONTENT = document.createElement('div');
	    const TRIGGER_ELEMENTS = GROUPS[activeGroup].triggerElements;
	    const TOTAL_TRIGGER_ELEMENTS = TRIGGER_ELEMENTS.length;
	    SLIDER_ELEMENT.className = 'parvus__slide';
	    SLIDER_ELEMENT.style.position = 'absolute';
	    SLIDER_ELEMENT.style.left = `${index * 100}%`;
	    SLIDER_ELEMENT.setAttribute('aria-hidden', 'true');
	    SLIDER_ELEMENT.appendChild(SLIDER_ELEMENT_CONTENT);

	    // Add extra output for screen reader if there is more than one slide
	    if (TOTAL_TRIGGER_ELEMENTS > 1) {
	      SLIDER_ELEMENT.setAttribute('role', 'group');
	      SLIDER_ELEMENT.setAttribute('aria-label', `${config.l10n.slideLabel} ${index + 1}/${TOTAL_TRIGGER_ELEMENTS}`);
	    }
	    GROUPS[activeGroup].sliderElements[index] = SLIDER_ELEMENT;
	    if (index >= currentIndex) {
	      const NEXT_SLIDE_INDEX = getNextSlideIndex(index);
	      if (NEXT_SLIDE_INDEX !== -1) {
	        GROUPS[activeGroup].sliderElements[NEXT_SLIDE_INDEX].before(SLIDER_ELEMENT);
	      } else {
	        GROUPS[activeGroup].slider.appendChild(SLIDER_ELEMENT);
	      }
	    } else {
	      const PREVIOUS_SLIDE_INDEX = getPreviousSlideIndex(index);
	      if (PREVIOUS_SLIDE_INDEX !== -1) {
	        GROUPS[activeGroup].sliderElements[PREVIOUS_SLIDE_INDEX].after(SLIDER_ELEMENT);
	      } else {
	        GROUPS[activeGroup].slider.prepend(SLIDER_ELEMENT);
	      }
	    }
	  };

	  /**
	   * Open Parvus
	   *
	   * @param {HTMLElement} el
	   */
	  const open = el => {
	    if (!lightbox || !el || !el.classList.contains('parvus-trigger') || isOpen()) {
	      return;
	    }
	    activeGroup = getGroup(el);
	    if (!GROUPS[activeGroup].triggerElements.includes(el)) {
	      throw new Error('Ups, I can\'t find the element.');
	    }
	    currentIndex = GROUPS[activeGroup].triggerElements.indexOf(el);
	    lastFocus = document.activeElement;
	    history.pushState({
	      parvus: 'close'
	    }, 'Image', window.location.href);
	    bindEvents();
	    const NON_LIGHTBOX_ELEMENTS = document.querySelectorAll('body > *:not([aria-hidden="true"])');
	    NON_LIGHTBOX_ELEMENTS.forEach(nonLightboxEl => {
	      nonLightboxEl.setAttribute('aria-hidden', 'true');
	      nonLightboxEl.classList.add('parvus-hidden');
	    });
	    if (config.hideScrollbar) {
	      document.body.style.marginInlineEnd = `${getScrollbarWidth()}px`;
	      document.body.style.overflow = 'hidden';
	    }
	    lightbox.classList.add('parvus--is-opening');
	    lightbox.setAttribute('aria-hidden', 'false');
	    createSlider();
	    createSlide(currentIndex);
	    GROUPS[activeGroup].slider.setAttribute('aria-hidden', 'false');
	    updateOffset();
	    updateAttributes();
	    updateSliderNavigationStatus();
	    updateCounter();
	    setFocusToFirstItem();
	    loadSlide(currentIndex);
	    createImage(el, currentIndex, () => {
	      loadImage(currentIndex, true);
	      lightbox.classList.remove('parvus--is-opening');
	      GROUPS[activeGroup].slider.classList.add('parvus__slider--animate');
	    });
	    preload(currentIndex + 1);
	    preload(currentIndex - 1);

	    // Create and dispatch a new event
	    fire('open', {
	      source: el
	    });
	  };

	  /**
	   * Close Parvus
	   *
	   */
	  const close = () => {
	    if (!isOpen()) {
	      throw new Error('Ups, I\'m already closed.');
	    }
	    const IMAGE = GROUPS[activeGroup].contentElements[currentIndex];
	    const THUMBNAIL = GROUPS[activeGroup].triggerElements[currentIndex];
	    unbindEvents();
	    clearDrag();
	    if (history.state?.parvus === 'close') {
	      history.back();
	    }
	    const NON_LIGHTBOX_ELEMENTS = document.querySelectorAll('.parvus-hidden');
	    NON_LIGHTBOX_ELEMENTS.forEach(nonLightboxEl => {
	      nonLightboxEl.removeAttribute('aria-hidden');
	      nonLightboxEl.classList.remove('parvus-hidden');
	    });
	    lightbox.classList.add('parvus--is-closing');
	    requestAnimationFrame(() => {
	      const THUMBNAIL_SIZE = THUMBNAIL.getBoundingClientRect();
	      if (IMAGE && IMAGE.tagName === 'IMG') {
	        const IMAGE_SIZE = IMAGE.getBoundingClientRect();
	        const WIDTH_DIFFERENCE = THUMBNAIL_SIZE.width / IMAGE_SIZE.width;
	        const HEIGHT_DIFFERENCE = THUMBNAIL_SIZE.height / IMAGE_SIZE.height;
	        const X_DIFFERENCE = THUMBNAIL_SIZE.left - IMAGE_SIZE.left;
	        const Y_DIFFERENCE = THUMBNAIL_SIZE.top - IMAGE_SIZE.top;
	        IMAGE.style.transform = `translate(${X_DIFFERENCE}px, ${Y_DIFFERENCE}px) scale(${WIDTH_DIFFERENCE}, ${HEIGHT_DIFFERENCE})`;
	      }
	      IMAGE.style.opacity = 0;
	      IMAGE.style.transition = `transform ${transitionDuration}ms ${config.transitionTimingFunction}, opacity ${transitionDuration}ms ${config.transitionTimingFunction} ${transitionDuration / 2}ms`;
	    });
	    const transitionendHandler = () => {
	      leaveSlide(currentIndex);
	      lastFocus = config.backFocus ? lastFocus : GROUPS[activeGroup].triggerElements[currentIndex];
	      lastFocus.focus({
	        preventScroll: true
	      });
	      lightbox.setAttribute('aria-hidden', 'true');
	      lightbox.classList.remove('parvus--is-closing');
	      lightbox.classList.remove('parvus--is-vertical-closing');
	      IMAGE.style.transform = '';
	      IMAGE.removeEventListener('transitionend', transitionendHandler);
	      GROUPS[activeGroup].slider.remove();
	      GROUPS[activeGroup].slider = null;
	      GROUPS[activeGroup].sliderElements = [];
	      GROUPS[activeGroup].contentElements = [];
	      counter.removeAttribute('aria-hidden');
	      previousButton.removeAttribute('aria-hidden');
	      previousButton.removeAttribute('aria-disabled');
	      nextButton.removeAttribute('aria-hidden');
	      nextButton.removeAttribute('aria-disabled');
	      if (config.hideScrollbar) {
	        document.body.style.marginInlineEnd = '';
	        document.body.style.overflow = '';
	      }
	    };
	    IMAGE.addEventListener('transitionend', transitionendHandler, {
	      once: true
	    });

	    // Create and dispatch a new event
	    fire('close', {
	      detail: {
	        source: GROUPS[activeGroup].triggerElements[currentIndex]
	      }
	    });
	  };

	  /**
	   * Preload slide with the specified index
	   *
	   * @param {Number} index - The index of the slide to be preloaded
	   */
	  const preload = index => {
	    if (index < 0 || index >= GROUPS[activeGroup].triggerElements.length || GROUPS[activeGroup].sliderElements[index] !== undefined) {
	      return;
	    }
	    createSlide(index);
	    createImage(GROUPS[activeGroup].triggerElements[index], index, () => {
	      loadImage(index);
	    });
	  };

	  /**
	   * Load slide with the specified index
	   *
	   * @param {Number} index - The index of the slide to be loaded
	   */
	  const loadSlide = index => {
	    GROUPS[activeGroup].sliderElements[index].setAttribute('aria-hidden', 'false');
	  };

	  /**
	   * Add caption to the container element
	   *
	   * @param {HTMLElement} containerEl - The container element to which the caption will be added
	   * @param {HTMLElement} imageEl - The image the caption is linked to
	   * @param {HTMLElement} el - The trigger element associated with the caption
	   * @param {Number} index - The index of the caption
	   */
	  const addCaption = (containerEl, imageEl, el, index) => {
	    const CAPTION_CONTAINER = document.createElement('div');
	    let captionData = null;
	    CAPTION_CONTAINER.className = 'parvus__caption';
	    if (config.captionsSelector === 'self') {
	      if (el.hasAttribute(config.captionsAttribute) && el.getAttribute(config.captionsAttribute) !== '') {
	        captionData = el.getAttribute(config.captionsAttribute);
	      }
	    } else {
	      const CAPTION_SELECTOR = el.querySelector(config.captionsSelector);
	      if (CAPTION_SELECTOR !== null) {
	        if (CAPTION_SELECTOR.hasAttribute(config.captionsAttribute) && CAPTION_SELECTOR.getAttribute(config.captionsAttribute) !== '') {
	          captionData = CAPTION_SELECTOR.getAttribute(config.captionsAttribute);
	        } else {
	          captionData = CAPTION_SELECTOR.innerHTML;
	        }
	      }
	    }
	    if (captionData !== null) {
	      const CAPTION_ID = `parvus__caption-${index}`;
	      CAPTION_CONTAINER.id = CAPTION_ID;
	      CAPTION_CONTAINER.innerHTML = `<p>${captionData}</p>`;
	      containerEl.appendChild(CAPTION_CONTAINER);
	      imageEl.setAttribute('aria-describedby', CAPTION_ID);
	    }
	  };
	  const createImage = (el, index, callback) => {
	    const {
	      contentElements,
	      sliderElements
	    } = GROUPS[activeGroup];
	    if (contentElements[index] !== undefined) {
	      if (callback && typeof callback === 'function') {
	        callback();
	      }
	      return;
	    }
	    const CONTENT_CONTAINER_EL = sliderElements[index].querySelector('div');
	    const IMAGE = new Image();
	    const IMAGE_CONTAINER = document.createElement('div');
	    const THUMBNAIL = el.querySelector('img');
	    const LOADING_INDICATOR = document.createElement('div');
	    IMAGE_CONTAINER.className = 'parvus__content';

	    // Create loading indicator
	    LOADING_INDICATOR.className = 'parvus__loader';
	    LOADING_INDICATOR.setAttribute('role', 'progressbar');
	    LOADING_INDICATOR.setAttribute('aria-label', config.l10n.lightboxLoadingIndicatorLabel);

	    // Add loading indicator to content container
	    CONTENT_CONTAINER_EL.appendChild(LOADING_INDICATOR);
	    const checkImagePromise = new Promise((resolve, reject) => {
	      IMAGE.onload = () => resolve(IMAGE);
	      IMAGE.onerror = error => reject(error);
	    });
	    checkImagePromise.then(loadedImage => {
	      loadedImage.style.opacity = 0;
	      IMAGE_CONTAINER.appendChild(loadedImage);
	      CONTENT_CONTAINER_EL.appendChild(IMAGE_CONTAINER);

	      // Add caption if available
	      if (config.captions) {
	        addCaption(CONTENT_CONTAINER_EL, IMAGE, el, index);
	      }
	      contentElements[index] = loadedImage;

	      // Set image width and height
	      loadedImage.setAttribute('width', loadedImage.naturalWidth);
	      loadedImage.setAttribute('height', loadedImage.naturalHeight);

	      // Set image dimension
	      setImageDimension(sliderElements[index], loadedImage);
	    }).catch(() => {
	      const ERROR_CONTAINER = document.createElement('div');
	      ERROR_CONTAINER.classList.add('parvus__content');
	      ERROR_CONTAINER.classList.add('parvus__content--error');
	      ERROR_CONTAINER.innerHTML = `${config.l10n.lightboxLoadingError}`;
	      CONTENT_CONTAINER_EL.appendChild(ERROR_CONTAINER);
	      contentElements[index] = ERROR_CONTAINER;
	    }).finally(() => {
	      CONTENT_CONTAINER_EL.removeChild(LOADING_INDICATOR);
	      if (callback && typeof callback === 'function') {
	        callback();
	      }
	    });

	    // Add `sizes` attribute
	    if (el.hasAttribute('data-sizes') && el.getAttribute('data-sizes') !== '') {
	      IMAGE.setAttribute('sizes', el.getAttribute('data-sizes'));
	    }

	    // Add `srcset` attribute
	    if (el.hasAttribute('data-srcset') && el.getAttribute('data-srcset') !== '') {
	      IMAGE.setAttribute('srcset', el.getAttribute('data-srcset'));
	    }

	    // Add `src` attribute
	    if (el.tagName === 'A') {
	      IMAGE.setAttribute('src', el.href);
	    } else {
	      IMAGE.setAttribute('src', el.getAttribute('data-target'));
	    }

	    // `alt` attribute
	    if (THUMBNAIL && THUMBNAIL.hasAttribute('alt') && THUMBNAIL.getAttribute('alt') !== '') {
	      IMAGE.alt = THUMBNAIL.alt;
	    } else if (el.hasAttribute('data-alt') && el.getAttribute('data-alt') !== '') {
	      IMAGE.alt = el.getAttribute('data-alt');
	    } else {
	      IMAGE.alt = '';
	    }
	  };

	  /**
	   * Load Image
	   *
	   * @param {Number} index - The index of the image to load
	   */
	  const loadImage = (index, animate) => {
	    const IMAGE = GROUPS[activeGroup].contentElements[index];
	    if (IMAGE && IMAGE.tagName === 'IMG') {
	      const THUMBNAIL = GROUPS[activeGroup].triggerElements[index];
	      if (animate) {
	        const IMAGE_SIZE = IMAGE.getBoundingClientRect();
	        const THUMBNAIL_SIZE = THUMBNAIL.getBoundingClientRect();
	        const WIDTH_DIFFERENCE = THUMBNAIL_SIZE.width / IMAGE_SIZE.width;
	        const HEIGHT_DIFFERENCE = THUMBNAIL_SIZE.height / IMAGE_SIZE.height;
	        const X_DIFFERENCE = THUMBNAIL_SIZE.left - IMAGE_SIZE.left;
	        const Y_DIFFERENCE = THUMBNAIL_SIZE.top - IMAGE_SIZE.top;
	        requestAnimationFrame(() => {
	          IMAGE.style.transform = `translate(${X_DIFFERENCE}px, ${Y_DIFFERENCE}px) scale(${WIDTH_DIFFERENCE}, ${HEIGHT_DIFFERENCE})`;
	          IMAGE.style.transition = 'transform 0s, opacity 0s';

	          // Animate the difference reversal on the next tick
	          requestAnimationFrame(() => {
	            IMAGE.style.transform = '';
	            IMAGE.style.opacity = '';
	            IMAGE.style.transition = `transform ${transitionDuration}ms ${config.transitionTimingFunction}, opacity ${transitionDuration / 2}ms ${config.transitionTimingFunction}`;
	          });
	        });
	      } else {
	        IMAGE.style.opacity = '';
	      }
	    } else {
	      IMAGE.style.opacity = '';
	    }
	  };
	  const select = index => {
	    const OLD_INDEX = currentIndex;
	    if (!isOpen()) {
	      throw new Error("Oops, I'm closed.");
	    } else {
	      if (typeof index !== 'number' || isNaN(index)) {
	        throw new Error('Oops, no slide specified.');
	      }
	      const triggerElements = GROUPS[activeGroup].triggerElements;
	      if (index === currentIndex) {
	        throw new Error(`Oops, slide ${index} is already selected.`);
	      }
	      if (index < -1 || index >= triggerElements.length) {
	        throw new Error(`Oops, I can't find slide ${index}.`);
	      }
	    }
	    if (GROUPS[activeGroup].sliderElements[index] !== undefined) {
	      loadSlide(index);
	    } else {
	      createSlide(index);
	      createImage(GROUPS[activeGroup].triggerElements[index], index, () => {
	        loadImage(index);
	      });
	      loadSlide(index);
	    }
	    currentIndex = index;
	    updateOffset();
	    if (index < OLD_INDEX) {
	      updateSliderNavigationStatus();
	      preload(index - 1);
	    } else if (index > OLD_INDEX) {
	      updateSliderNavigationStatus();
	      preload(index + 1);
	    }
	    leaveSlide(OLD_INDEX);
	    updateCounter();

	    // Create and dispatch a new event
	    fire('select', {
	      detail: {
	        source: GROUPS[activeGroup].triggerElements[currentIndex]
	      }
	    });
	  };

	  /**
	   * Select the previous slide
	   *
	   */
	  const previous = () => {
	    if (currentIndex > 0) {
	      select(currentIndex - 1);
	    }
	  };

	  /**
	   * Select the next slide
	   *
	   */
	  const next = () => {
	    const {
	      triggerElements
	    } = GROUPS[activeGroup];
	    if (currentIndex < triggerElements.length - 1) {
	      select(currentIndex + 1);
	    }
	  };

	  /**
	   * Leave slide
	   *
	   * This function is called after moving the index to a new slide.
	   *
	   * @param {Number} index - The index of the slide to leave.
	   */
	  const leaveSlide = index => {
	    if (GROUPS[activeGroup].sliderElements[index] !== undefined) {
	      GROUPS[activeGroup].sliderElements[index].setAttribute('aria-hidden', 'true');
	    }
	  };

	  /**
	   * Update offset
	   *
	   */
	  const updateOffset = () => {
	    activeGroup = activeGroup !== null ? activeGroup : newGroup;
	    offset = -currentIndex * lightbox.offsetWidth;
	    GROUPS[activeGroup].slider.style.transform = `translate3d(${offset}px, 0, 0)`;
	    offsetTmp = offset;
	  };

	  /**
	   * Update slider navigation status
	   *
	   * This function updates the disabled status of the slider navigation buttons
	   * based on the current slide position.
	   *
	   */
	  const updateSliderNavigationStatus = () => {
	    const {
	      triggerElements
	    } = GROUPS[activeGroup];
	    const TOTAL_TRIGGER_ELEMENTS = triggerElements.length;
	    const FIRST_SLIDE = currentIndex === 0;
	    const LAST_SLIDE = currentIndex === TOTAL_TRIGGER_ELEMENTS - 1;
	    if (TOTAL_TRIGGER_ELEMENTS > 1) {
	      if (FIRST_SLIDE) {
	        previousButton.setAttribute('aria-disabled', 'true');
	        nextButton.removeAttribute('aria-disabled');
	      } else if (LAST_SLIDE) {
	        previousButton.removeAttribute('aria-disabled');
	        nextButton.setAttribute('aria-disabled', 'true');
	      } else {
	        previousButton.removeAttribute('aria-disabled');
	        nextButton.removeAttribute('aria-disabled');
	      }
	    }
	  };

	  /**
	   * Update counter
	   *
	   * This function updates the counter display based on the current slide index.
	   */
	  const updateCounter = () => {
	    counter.textContent = `${currentIndex + 1}/${GROUPS[activeGroup].triggerElements.length}`;
	  };

	  /**
	   * Clear drag after touchend event
	   *
	   * This function clears the drag state after the touchend event is triggered.
	   */
	  const clearDrag = () => {
	    drag = {
	      startX: 0,
	      endX: 0,
	      startY: 0,
	      endY: 0
	    };
	  };

	  /**
	   * Recalculate drag/swipe event
	   *
	   */
	  const updateAfterDrag = () => {
	    const {
	      startX,
	      startY,
	      endX,
	      endY
	    } = drag;
	    const MOVEMENT_X = endX - startX;
	    const MOVEMENT_Y = endY - startY;
	    const MOVEMENT_X_DISTANCE = Math.abs(MOVEMENT_X);
	    const MOVEMENT_Y_DISTANCE = Math.abs(MOVEMENT_Y);
	    const {
	      triggerElements
	    } = GROUPS[activeGroup];
	    const TOTAL_TRIGGER_ELEMENTS = triggerElements.length;
	    if (isDraggingX) {
	      if (MOVEMENT_X > 2 && MOVEMENT_X_DISTANCE >= config.threshold && currentIndex > 0) {
	        previous();
	      } else if (MOVEMENT_X < 2 && MOVEMENT_X_DISTANCE >= config.threshold && currentIndex !== TOTAL_TRIGGER_ELEMENTS - 1) {
	        next();
	      } else {
	        updateOffset();
	      }
	    } else if (isDraggingY) {
	      if (MOVEMENT_Y_DISTANCE > 2 && config.swipeClose && MOVEMENT_Y_DISTANCE >= config.threshold) {
	        close();
	      } else {
	        lightbox.classList.remove('parvus--is-vertical-closing');
	        updateOffset();
	      }
	      lightboxOverlay.style.opacity = '';
	    } else {
	      updateOffset();
	    }
	  };

	  /**
	   * Update Attributes
	   *
	   */
	  const updateAttributes = () => {
	    const TRIGGER_ELEMENTS = GROUPS[activeGroup].triggerElements;
	    const TOTAL_TRIGGER_ELEMENTS = TRIGGER_ELEMENTS.length;
	    const SLIDER = GROUPS[activeGroup].slider;
	    const SLIDER_ELEMENTS = GROUPS[activeGroup].sliderElements;
	    const IS_TOUCH = config.simulateTouch || isTouchDevice();
	    const IS_DRAGGABLE = SLIDER.classList.contains('parvus__slider--is-draggable');

	    // Add draggable class if neccesary
	    if (IS_TOUCH && config.swipeClose && !IS_DRAGGABLE || IS_TOUCH && TOTAL_TRIGGER_ELEMENTS > 1 && !IS_DRAGGABLE) {
	      SLIDER.classList.add('parvus__slider--is-draggable');
	    } else {
	      SLIDER.classList.remove('parvus__slider--is-draggable');
	    }

	    // Add extra output for screen reader if there is more than one slide
	    if (TOTAL_TRIGGER_ELEMENTS > 1) {
	      SLIDER.setAttribute('role', 'region');
	      SLIDER.setAttribute('aria-roledescription', 'carousel');
	      SLIDER.setAttribute('aria-label', config.l10n.sliderLabel);
	      SLIDER_ELEMENTS.forEach((sliderElement, index) => {
	        sliderElement.setAttribute('role', 'group');
	        sliderElement.setAttribute('aria-label', `${config.l10n.slideLabel} ${index + 1}/${TOTAL_TRIGGER_ELEMENTS}`);
	      });
	    } else {
	      SLIDER.removeAttribute('role');
	      SLIDER.removeAttribute('aria-roledescription');
	      SLIDER.removeAttribute('aria-label');
	      SLIDER_ELEMENTS.forEach(sliderElement => {
	        sliderElement.removeAttribute('role');
	        sliderElement.removeAttribute('aria-label');
	      });
	    }

	    // Show or hide buttons
	    if (TOTAL_TRIGGER_ELEMENTS === 1) {
	      counter.setAttribute('aria-hidden', 'true');
	      previousButton.setAttribute('aria-hidden', 'true');
	      nextButton.setAttribute('aria-hidden', 'true');
	    } else {
	      counter.removeAttribute('aria-hidden');
	      previousButton.removeAttribute('aria-hidden');
	      nextButton.removeAttribute('aria-hidden');
	    }
	  };

	  /**
	   * Resize event handler
	   *
	   */
	  const resizeHandler = () => {
	    if (!resizeTicking) {
	      resizeTicking = true;
	      BROWSER_WINDOW.requestAnimationFrame(() => {
	        GROUPS[activeGroup].sliderElements.forEach((slide, index) => {
	          setImageDimension(slide, GROUPS[activeGroup].contentElements[index]);
	        });
	        updateOffset();
	        resizeTicking = false;
	      });
	    }
	  };

	  /**
	   * Set image dimension
	   *
	   * @param {HTMLElement} slideEl - The slide element
	   * @param {HTMLElement} contentEl - The content element
	   */
	  const setImageDimension = (slideEl, contentEl) => {
	    if (contentEl.tagName !== 'IMG') {
	      return;
	    }
	    const SLIDE_EL_STYLES = getComputedStyle(slideEl);
	    const CAPTION_EL = slideEl.querySelector('.parvus__caption');
	    const CAPTION_REC = CAPTION_EL ? CAPTION_EL.getBoundingClientRect().height : 0;
	    const SRC_HEIGHT = contentEl.getAttribute('height');
	    const SRC_WIDTH = contentEl.getAttribute('width');
	    let maxHeight = slideEl.offsetHeight;
	    let maxWidth = slideEl.offsetWidth;
	    maxHeight -= parseFloat(SLIDE_EL_STYLES.paddingTop) + parseFloat(SLIDE_EL_STYLES.paddingBottom) + parseFloat(CAPTION_REC);
	    maxWidth -= parseFloat(SLIDE_EL_STYLES.paddingLeft) + parseFloat(SLIDE_EL_STYLES.paddingRight);
	    const RATIO = Math.min(maxWidth / SRC_WIDTH || 0, maxHeight / SRC_HEIGHT);
	    const NEW_WIDTH = SRC_WIDTH * RATIO || 0;
	    const NEW_HEIGHT = SRC_HEIGHT * RATIO || 0;
	    if (SRC_HEIGHT > NEW_HEIGHT && SRC_HEIGHT < maxHeight && SRC_WIDTH > NEW_WIDTH && SRC_WIDTH < maxWidth || SRC_HEIGHT < NEW_HEIGHT && SRC_HEIGHT < maxHeight && SRC_WIDTH < NEW_WIDTH && SRC_WIDTH < maxWidth) {
	      contentEl.style.width = '';
	      contentEl.style.height = '';
	    } else {
	      contentEl.style.width = `${NEW_WIDTH}px`;
	      contentEl.style.height = `${NEW_HEIGHT}px`;
	    }
	  };

	  /**
	   * Click event handler to trigger Parvus
	   *
	   * @param {Event} event - The click event object
	   */
	  const triggerParvus = function triggerParvus(event) {
	    event.preventDefault();
	    open(this);
	  };

	  /**
	   * Event handler for click events
	   *
	   * @param {Event} event - The click event object
	   */
	  const clickHandler = event => {
	    const {
	      target
	    } = event;
	    if (target === previousButton) {
	      previous();
	    } else if (target === nextButton) {
	      next();
	    } else if (target === closeButton || config.docClose && !isDraggingY && !isDraggingX && target.classList.contains('parvus__slide')) {
	      close();
	    }
	    event.stopPropagation();
	  };

	  /**
	   * Set focus to the first item in the list
	   *
	   */
	  const setFocusToFirstItem = () => {
	    const FOCUSABLE_CHILDREN = getFocusableChildren(lightbox);
	    FOCUSABLE_CHILDREN[0].focus();
	  };

	  /**
	   * Event handler for the keydown event
	   *
	   * @param {Event} event - The keydown event object
	   */
	  const keydownHandler = event => {
	    const FOCUSABLE_CHILDREN = getFocusableChildren(lightbox);
	    const FOCUSED_ITEM_INDEX = FOCUSABLE_CHILDREN.indexOf(document.activeElement);
	    const lastIndex = FOCUSABLE_CHILDREN.length - 1;
	    switch (event.code) {
	      case 'Tab':
	        {
	          // Use the TAB key to navigate backwards and forwards
	          if (event.shiftKey) {
	            // Navigate backwards
	            if (FOCUSED_ITEM_INDEX === 0) {
	              FOCUSABLE_CHILDREN[lastIndex].focus();
	              event.preventDefault();
	            }
	          } else {
	            // Navigate forwards
	            if (FOCUSED_ITEM_INDEX === lastIndex) {
	              FOCUSABLE_CHILDREN[0].focus();
	              event.preventDefault();
	            }
	          }
	          break;
	        }
	      case 'Escape':
	        {
	          // Close Parvus when the ESC key is pressed
	          close();
	          event.preventDefault();
	          break;
	        }
	      case 'ArrowLeft':
	        {
	          // Show the previous slide when the PREV key is pressed
	          previous();
	          event.preventDefault();
	          break;
	        }
	      case 'ArrowRight':
	        {
	          // Show the next slide when the NEXT key is pressed
	          next();
	          event.preventDefault();
	          break;
	        }
	    }
	  };

	  /**
	   * Event handler for the mousedown event.
	   *
	   * This function is called when the mouse button is pressed down.
	   * It handles the necessary actions and logic related to the mousedown event.
	   *
	   * @param {Event} event - The mousedown event object
	   */
	  const mousedownHandler = event => {
	    event.preventDefault();
	    event.stopPropagation();
	    isDraggingX = false;
	    isDraggingY = false;
	    pointerDown = true;
	    const {
	      pageX,
	      pageY
	    } = event;
	    drag.startX = pageX;
	    drag.startY = pageY;
	    const {
	      slider
	    } = GROUPS[activeGroup];
	    slider.classList.add('parvus__slider--is-dragging');
	    slider.style.willChange = 'transform';
	    lightboxOverlayOpacity = getComputedStyle(lightboxOverlay).opacity;
	  };

	  /**
	   * Event handler for the mousemove event.
	   *
	   * This function is called when the mouse is moved.
	   * It handles the necessary actions and logic related to the mousemove event.
	   *
	   * @param {Event} event - The mousemove event object
	   */
	  const mousemoveHandler = event => {
	    event.preventDefault();
	    if (pointerDown) {
	      const {
	        pageX,
	        pageY
	      } = event;
	      drag.endX = pageX;
	      drag.endY = pageY;
	      doSwipe();
	    }
	  };

	  /**
	   * Event handler for the mouseup event.
	   *
	   * This function is called when a mouse button is released.
	   * It handles the necessary actions and logic related to the mouseup event.
	   */
	  const mouseupHandler = event => {
	    event.stopPropagation();
	    pointerDown = false;
	    const {
	      slider
	    } = GROUPS[activeGroup];
	    slider.classList.remove('parvus__slider--is-dragging');
	    slider.style.willChange = '';
	    if (drag.endX || drag.endY) {
	      updateAfterDrag();
	    }
	    clearDrag();
	  };

	  /**
	   * Event handler for the touchstart event.
	   *
	   * This function is called when a touch interaction begins.
	   * It handles the necessary actions and logic related to the touchstart event.
	   *
	   * @param {Event} event - The touchstart event object
	   */
	  const touchstartHandler = event => {
	    event.stopPropagation();
	    isDraggingX = false;
	    isDraggingY = false;
	    const {
	      clientX,
	      clientY
	    } = event.changedTouches[0];
	    drag.startX = parseInt(clientX, 10);
	    drag.startY = parseInt(clientY, 10);
	    const {
	      slider
	    } = GROUPS[activeGroup];
	    slider.classList.add('parvus__slider--is-dragging');
	    slider.style.willChange = 'transform';
	    lightboxOverlayOpacity = getComputedStyle(lightboxOverlay).opacity;
	  };

	  /**
	   * Event handler for the touchmove event.
	   *
	   * This function is called when the touch position changes during a touch interaction.
	   * It handles the necessary actions and logic related to the touchmove event.
	   *
	   * @param {Event} event - The touchmove event object
	   */
	  const touchmoveHandler = event => {
	    event.preventDefault();
	    event.stopPropagation();
	    const {
	      clientX,
	      clientY
	    } = event.changedTouches[0];
	    drag.endX = parseInt(clientX, 10);
	    drag.endY = parseInt(clientY, 10);
	    doSwipe();
	  };

	  /**
	   * Event handler for the touchend event.
	   *
	   * This function is called when the touch interaction ends. It handles the necessary
	   * actions and logic related to the touchend event.
	   */
	  const touchendHandler = event => {
	    event.stopPropagation();
	    const {
	      slider
	    } = GROUPS[activeGroup];
	    slider.classList.remove('parvus__slider--is-dragging');
	    slider.style.willChange = '';
	    if (drag.endX || drag.endY) {
	      updateAfterDrag();
	    }
	    clearDrag();
	  };

	  /**
	   * Determine the swipe direction (horizontal or vertical).
	   *
	   * This function analyzes the swipe gesture and decides whether it is a horizontal
	   * or vertical swipe based on the direction and angle of the swipe.
	   */
	  const doSwipe = () => {
	    const {
	      startX,
	      endX,
	      startY,
	      endY
	    } = drag;
	    const MOVEMENT_X = startX - endX;
	    const MOVEMENT_Y = endY - startY;
	    const MOVEMENT_Y_DISTANCE = Math.abs(MOVEMENT_Y);
	    if (Math.abs(MOVEMENT_X) > 2 && !isDraggingY && GROUPS[activeGroup].triggerElements.length > 1) {
	      // Horizontal swipe
	      GROUPS[activeGroup].slider.style.transform = `translate3d(${offsetTmp - Math.round(MOVEMENT_X)}px, 0, 0)`;
	      isDraggingX = true;
	      isDraggingY = false;
	    } else if (Math.abs(MOVEMENT_Y) > 2 && !isDraggingX && config.swipeClose) {
	      // Vertical swipe
	      if (!isReducedMotion && MOVEMENT_Y_DISTANCE <= 100) {
	        lightboxOverlay.style.opacity = lightboxOverlayOpacity - MOVEMENT_Y_DISTANCE / 100;
	      }
	      lightbox.classList.add('parvus--is-vertical-closing');
	      GROUPS[activeGroup].slider.style.transform = `translate3d(${offsetTmp}px, ${Math.round(MOVEMENT_Y)}px, 0)`;
	      isDraggingX = false;
	      isDraggingY = true;
	    }
	  };

	  /**
	   * Bind specified events
	   *
	   */
	  const bindEvents = () => {
	    BROWSER_WINDOW.addEventListener('keydown', keydownHandler);
	    BROWSER_WINDOW.addEventListener('resize', resizeHandler);

	    // Popstate event
	    BROWSER_WINDOW.addEventListener('popstate', close);

	    // Check for any OS level changes to the prefers reduced motion preference
	    MOTIONQUERY.addEventListener('change', reducedMotionCheck);

	    // Click event
	    lightbox.addEventListener('click', clickHandler);

	    // Touch events
	    if (isTouchDevice()) {
	      lightbox.addEventListener('touchstart', touchstartHandler);
	      lightbox.addEventListener('touchmove', touchmoveHandler);
	      lightbox.addEventListener('touchend', touchendHandler);
	    }

	    // Mouse events
	    if (config.simulateTouch) {
	      lightbox.addEventListener('mousedown', mousedownHandler);
	      lightbox.addEventListener('mouseup', mouseupHandler);
	      lightbox.addEventListener('mousemove', mousemoveHandler);
	    }
	  };

	  /**
	   * Unbind specified events
	   *
	   */
	  const unbindEvents = () => {
	    BROWSER_WINDOW.removeEventListener('keydown', keydownHandler);
	    BROWSER_WINDOW.removeEventListener('resize', resizeHandler);

	    // Popstate event
	    BROWSER_WINDOW.removeEventListener('popstate', close);

	    // Check for any OS level changes to the prefers reduced motion preference
	    MOTIONQUERY.removeEventListener('change', reducedMotionCheck);

	    // Click event
	    lightbox.removeEventListener('click', clickHandler);

	    // Touch events
	    if (isTouchDevice()) {
	      lightbox.removeEventListener('touchstart', touchstartHandler);
	      lightbox.removeEventListener('touchmove', touchmoveHandler);
	      lightbox.removeEventListener('touchend', touchendHandler);
	    }

	    // Mouse events
	    if (config.simulateTouch) {
	      lightbox.removeEventListener('mousedown', mousedownHandler);
	      lightbox.removeEventListener('mouseup', mouseupHandler);
	      lightbox.removeEventListener('mousemove', mousemoveHandler);
	    }
	  };

	  /**
	   * Destroy Parvus
	   *
	   */
	  const destroy = () => {
	    if (!lightbox) {
	      return;
	    }
	    if (isOpen()) {
	      close();
	    }
	    lightbox.remove();
	    const LIGHTBOX_TRIGGER_ELS = document.querySelectorAll('.parvus-trigger');
	    LIGHTBOX_TRIGGER_ELS.forEach(remove);

	    // Create and dispatch a new event
	    fire('destroy');
	  };

	  /**
	   * Check if Parvus is open
	   *
	   * @returns {boolean} - True if Parvus is open, otherwise false
	   */
	  const isOpen = () => {
	    return lightbox.getAttribute('aria-hidden') === 'false';
	  };

	  /**
	   * Check if the device supports touch events
	   *
	   * @returns {boolean} - True if the device is touch capable, otherwise false
	   */
	  const isTouchDevice = () => {
	    return 'ontouchstart' in window;
	  };

	  /**
	   * Get the current index
	   *
	   * @returns {number} - The current index
	   */
	  const getCurrentIndex = () => {
	    return currentIndex;
	  };

	  /**
	   * Dispatch a custom event
	   *
	   * @param {String} type - The type of the event to dispatch
	   * @param {Function} event - The event object
	   */
	  const fire = (type, event = {}) => {
	    const CUSTOM_EVENT = new CustomEvent(type, {
	      detail: event,
	      cancelable: true
	    });
	    lightbox.dispatchEvent(CUSTOM_EVENT);
	  };

	  /**
	   * Bind a specific event listener
	   *
	   * @param {String} eventName - The name of the event to Bind
	   * @param {Function} callback - The callback function
	   */
	  const on = (eventName, callback) => {
	    if (lightbox) {
	      lightbox.addEventListener(eventName, callback);
	    }
	  };

	  /**
	   * Unbind a specific event listener
	   *
	   * @param {String} eventName - The name of the event to unbind
	   * @param {Function} callback - The callback function
	   */
	  const off = (eventName, callback) => {
	    if (lightbox) {
	      lightbox.removeEventListener(eventName, callback);
	    }
	  };

	  /**
	   * Init
	   *
	   */
	  const init = () => {
	    // Merge user options into defaults
	    config = mergeOptions(userOptions);

	    // Check if the lightbox should be loaded empty or if there are elements for the lightbox.
	    if (!config.loadEmpty && !document.querySelectorAll(config.selector).length) {
	      return;
	    }
	    reducedMotionCheck();

	    // Check if the lightbox already exists
	    if (!lightbox) {
	      createLightbox();
	    }
	    if (config.gallerySelector !== null) {
	      // Get a list of all `gallerySelector` elements within the document
	      const GALLERY_ELS = document.querySelectorAll(config.gallerySelector);

	      // Execute a few things once per element
	      GALLERY_ELS.forEach((galleryEl, index) => {
	        const GALLERY_INDEX = index;
	        // Get a list of all `selector` elements within the `gallerySelector`
	        const LIGHTBOX_TRIGGER_GALLERY_ELS = galleryEl.querySelectorAll(config.selector);

	        // Execute a few things once per element
	        LIGHTBOX_TRIGGER_GALLERY_ELS.forEach(lightboxTriggerEl => {
	          lightboxTriggerEl.setAttribute('data-group', `parvus-gallery-${GALLERY_INDEX}`);
	          add(lightboxTriggerEl);
	        });
	      });
	    }

	    // Get a list of all `selector` elements outside or without the `gallerySelector`
	    const LIGHTBOX_TRIGGER_ELS = document.querySelectorAll(`${config.selector}:not(.parvus-trigger)`);
	    LIGHTBOX_TRIGGER_ELS.forEach(add);
	  };
	  init();
	  return {
	    init,
	    open,
	    close,
	    select,
	    previous,
	    next,
	    currentIndex: getCurrentIndex,
	    add,
	    remove,
	    destroy,
	    isOpen,
	    on,
	    off
	  };
	}

	function init$2() {
	  new Parvus({
	    simulateTouch: false,
	    l10n: LIGHTBOX_PARVUS_L10N
	  });
	}

	var lightbox = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: init$2
	});

	// Track loaded scripts
	let youtubeApiLoaded = false;
	let youtubeApiLoading = false;
	let vimeoApiLoaded = false;
	let vimeoApiLoading = false;

	// Queue for pending players
	const youtubeQueue = [];
	const vimeoQueue = [];

	// Store player instances
	const playerInstances = new WeakMap();

	/**
	 * Initialize video players (YouTube / Vimeo)
	 */
	function buildVideoPlayer() {
	  const playersVideo = DOM.videoPlayers;
	  if (!playersVideo || !playersVideo.length) return;
	  const youtubeVideos = [];
	  const vimeoVideos = [];
	  playersVideo.forEach(player => {
	    const playerIframeContainerElt = player.querySelector('.o-video-player__iframe');
	    if (!playerIframeContainerElt) {
	      // console.warn('Video player missing .o-video-player__iframe container:', player);
	      return;
	    }
	    const youtubeId = playerIframeContainerElt.getAttribute('data-youtube_id');
	    const vimeoId = playerIframeContainerElt.getAttribute('data-vimeo_id');

	    // Don't initialize if already has a player instance
	    if (playerInstances.has(playerIframeContainerElt)) {
	      return;
	    }
	    if (youtubeId) {
	      youtubeVideos.push({
	        nodeIframeContainer: playerIframeContainerElt,
	        idVideo: youtubeId,
	        parentPlayer: player
	      });
	    } else if (vimeoId) {
	      vimeoVideos.push({
	        nodeIframeContainer: playerIframeContainerElt,
	        idVideo: vimeoId,
	        parentPlayer: player
	      });
	    } else ;
	  });
	  if (youtubeVideos.length) {
	    initYoutubePlayers(youtubeVideos);
	  }
	  if (vimeoVideos.length) {
	    initVimeoPlayers(vimeoVideos);
	  }
	}

	/**
	 * Initialize YouTube players
	 * @param {Array} videos - Array of video configurations
	 */
	function initYoutubePlayers(videos) {
	  // Add to queue
	  youtubeQueue.push(...videos);

	  // Load API if not already loaded/loading
	  if (!youtubeApiLoaded && !youtubeApiLoading) {
	    loadYoutubeAPI();
	  } else if (youtubeApiLoaded) {
	    // API already loaded, create players immediately
	    processYoutubeQueue();
	  }
	}

	/**
	 * Load YouTube IFrame API
	 */
	function loadYoutubeAPI() {
	  // Check if script already exists
	  if (document.querySelector('script[src*="youtube.com/iframe_api"]')) {
	    youtubeApiLoaded = true;
	    processYoutubeQueue();
	    return;
	  }
	  youtubeApiLoading = true;
	  const tag = document.createElement('script');
	  tag.src = 'https://www.youtube.com/iframe_api';
	  tag.async = true;
	  tag.onerror = () => {
	    // console.error('Failed to load YouTube IFrame API');
	    youtubeApiLoading = false;
	  };
	  const firstScriptTag = document.getElementsByTagName('script')[0];
	  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	  // Setup global callback (only once)
	  if (!window.onYouTubeIframeAPIReady) {
	    window.onYouTubeIframeAPIReady = () => {
	      youtubeApiLoaded = true;
	      youtubeApiLoading = false;
	      processYoutubeQueue();
	    };
	  }
	}

	/**
	 * Process queued YouTube players
	 */
	function processYoutubeQueue() {
	  if (!window.YT || !window.YT.Player) {
	    // console.error('YouTube API not available');
	    return;
	  }
	  while (youtubeQueue.length > 0) {
	    const video = youtubeQueue.shift();
	    createYoutubePlayer(video);
	  }
	}

	/**
	 * Create a single YouTube player
	 * @param {Object} video - Video configuration
	 */
	function createYoutubePlayer(video) {
	  try {
	    const player = new YT.Player(video.nodeIframeContainer, {
	      height: '360',
	      width: '100%',
	      videoId: video.idVideo,
	      playerVars: {
	        autoplay: 0,
	        rel: 0,
	        origin: window.location.origin,
	        wmode: 'transparent',
	        modestbranding: 1
	      },
	      events: {
	        onReady: () => {
	          video.parentPlayer.classList.add('is-ready');
	        },
	        onError: () => {
	          // console.error('YouTube player error:', event.data);
	          video.parentPlayer.classList.add('has-error');
	        }
	      }
	    });

	    // Store instance
	    playerInstances.set(video.nodeIframeContainer, {
	      type: 'youtube',
	      player
	    });
	  } catch (error) {
	    // console.error('Error creating YouTube player:', error);
	  }
	}

	/**
	 * Initialize Vimeo players
	 * @param {Array} videos - Array of video configurations
	 */
	function initVimeoPlayers(videos) {
	  // Add to queue
	  vimeoQueue.push(...videos);

	  // Load API if not already loaded/loading
	  if (!vimeoApiLoaded && !vimeoApiLoading) {
	    loadVimeoAPI();
	  } else if (vimeoApiLoaded) {
	    // API already loaded, create players immediately
	    processVimeoQueue();
	  }
	}

	/**
	 * Load Vimeo Player API
	 */
	function loadVimeoAPI() {
	  // Check if script already exists
	  if (document.querySelector('script[src*="player.vimeo.com"]')) {
	    vimeoApiLoaded = true;
	    processVimeoQueue();
	    return;
	  }

	  // Check if Vimeo is already available globally
	  if (window.Vimeo && window.Vimeo.Player) {
	    vimeoApiLoaded = true;
	    processVimeoQueue();
	    return;
	  }
	  vimeoApiLoading = true;
	  const script = document.createElement('script');
	  script.src = 'https://player.vimeo.com/api/player.js';
	  script.async = true;
	  script.onload = () => {
	    vimeoApiLoaded = true;
	    vimeoApiLoading = false;
	    processVimeoQueue();
	  };
	  script.onerror = () => {
	    // console.error('Failed to load Vimeo Player API');
	    vimeoApiLoading = false;
	  };
	  const firstScriptTag = document.getElementsByTagName('script')[0];
	  firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
	}

	/**
	 * Process queued Vimeo players
	 */
	function processVimeoQueue() {
	  if (!window.Vimeo || !window.Vimeo.Player) {
	    // console.error('Vimeo API not available');
	    return;
	  }
	  while (vimeoQueue.length > 0) {
	    const video = vimeoQueue.shift();
	    createVimeoPlayer(video);
	  }
	}

	/**
	 * Create a single Vimeo player
	 * @param {Object} video - Video configuration
	 */
	function createVimeoPlayer(video) {
	  try {
	    const options = {
	      id: video.idVideo,
	      loop: false,
	      responsive: true,
	      transparent: true,
	      dnt: true // Do Not Track
	    };
	    const player = new Vimeo.Player(video.nodeIframeContainer, options);

	    // Handle events
	    player.ready().then(() => {
	      video.parentPlayer.classList.add('is-ready');
	    }).catch(() => {
	      // console.error('Vimeo player error:', error);
	      video.parentPlayer.classList.add('has-error');
	    });

	    // Store instance
	    playerInstances.set(video.nodeIframeContainer, {
	      type: 'vimeo',
	      player
	    });
	  } catch (error) {
	    // console.error('Error creating Vimeo player:', error);
	  }
	}

	/**
	 * Get player instance for a container
	 * @param {HTMLElement} container - Container element
	 * @returns {Object|null} Player instance
	 */
	function getPlayerInstance(container) {
	  return playerInstances.get(container) || null;
	}

	/**
	 * Destroy a player instance
	 * @param {HTMLElement} container - Container element
	 */
	function destroyPlayer(container) {
	  const instance = playerInstances.get(container);
	  if (!instance) return;
	  try {
	    if (instance.type === 'youtube' && instance.player.destroy) {
	      instance.player.destroy();
	    } else if (instance.type === 'vimeo' && instance.player.destroy) {
	      instance.player.destroy();
	    }
	    playerInstances.delete(container);
	  } catch (error) {
	    // console.error('Error destroying player:', error);
	  }
	}

	/**
	 * Destroy all player instances
	 */
	function destroyAllPlayers() {
	  const containers = DOM.videoPlayers;
	  if (!containers || !containers.length) return;
	  containers.forEach(player => {
	    const container = player.querySelector('.o-video-player__iframe');
	    if (container) {
	      destroyPlayer(container);
	    }
	  });
	}

	/**
	 * Play a video
	 * @param {HTMLElement} container - Container element
	 */
	function playVideo(container) {
	  const instance = playerInstances.get(container);
	  if (!instance) return;
	  try {
	    if (instance.type === 'youtube') {
	      instance.player.playVideo();
	    } else if (instance.type === 'vimeo') {
	      instance.player.play();
	    }
	  } catch (error) {
	    // console.error('Error playing video:', error);
	  }
	}

	/**
	 * Pause a video
	 * @param {HTMLElement} container - Container element
	 */
	function pauseVideo(container) {
	  const instance = playerInstances.get(container);
	  if (!instance) return;
	  try {
	    if (instance.type === 'youtube') {
	      instance.player.pauseVideo();
	    } else if (instance.type === 'vimeo') {
	      instance.player.pause();
	    }
	  } catch (error) {
	    // console.error('Error pausing video:', error);
	  }
	}

	var video = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildVideoPlayer,
		destroyAllPlayers: destroyAllPlayers,
		destroyPlayer: destroyPlayer,
		getPlayerInstance: getPlayerInstance,
		pauseVideo: pauseVideo,
		playVideo: playVideo
	});

	// Store active tooltip and trigger
	let activeTooltip = null;
	let activeTrigger = null;

	// Track if global listeners are setup
	let globalListenersSetup = false;

	/**
	 * Initialize all tooltips
	 */
	function buildTooltips() {
	  if (!DOM.tooltips || !DOM.tooltips.length) return;
	  DOM.tooltips.forEach(tooltipTrigger => {
	    initTooltip(tooltipTrigger);
	  });

	  // Setup global listeners only once
	  if (!globalListenersSetup) {
	    setupGlobalListeners();
	    globalListenersSetup = true;
	  }
	}

	/**
	 * Initialize a single tooltip
	 * @param {HTMLElement} tooltipTrigger - Trigger element
	 */
	function initTooltip(tooltipTrigger) {
	  const idTooltip = tooltipTrigger.getAttribute('aria-describedby');
	  const tooltipContent = tooltipTrigger.getAttribute('data-content');

	  // Validate required attributes
	  if (!idTooltip || !tooltipContent) {
	    // console.warn('Tooltip trigger missing required attributes:', tooltipTrigger);
	    return;
	  }

	  // Make non-interactive elements focusable
	  const tabindexAble = ['DIV', 'SPAN', 'STRONG', 'P'];
	  if (tabindexAble.includes(tooltipTrigger.tagName) && !tooltipTrigger.hasAttribute('tabindex')) {
	    tooltipTrigger.setAttribute('tabindex', '0');
	  }

	  // Show tooltip on interaction
	  const showHandler = e => {
	    showTooltip(tooltipTrigger, idTooltip);
	  };
	  tooltipTrigger.addEventListener('mouseenter', showHandler);
	  tooltipTrigger.addEventListener('focus', showHandler);

	  // Hide tooltip on leave
	  const hideHandler = e => {
	    // Small delay to allow moving to tooltip
	    setTimeout(() => {
	      if (!isHoveringTooltipOrTrigger(tooltipTrigger)) {
	        hideTooltip();
	      }
	    }, 100);
	  };
	  tooltipTrigger.addEventListener('mouseleave', hideHandler);
	  tooltipTrigger.addEventListener('blur', hideHandler);

	  // Store cleanup function
	  tooltipTrigger._tooltipCleanup = () => {
	    tooltipTrigger.removeEventListener('mouseenter', showHandler);
	    tooltipTrigger.removeEventListener('focus', showHandler);
	    tooltipTrigger.removeEventListener('mouseleave', hideHandler);
	    tooltipTrigger.removeEventListener('blur', hideHandler);
	  };
	}

	/**
	 * Setup global event listeners (once)
	 */
	function setupGlobalListeners() {
	  // Close tooltip on escape
	  hotkeys('escape', {
	    keyup: true,
	    scope: 'tooltip'
	  }, event => {
	    if (event.type === 'keyup') {
	      hideTooltip();
	      if (activeTrigger) {
	        activeTrigger.focus();
	      }
	    }
	  });

	  // Close tooltip when clicking outside
	  document.addEventListener('click', event => {
	    if (activeTooltip && activeTrigger) {
	      if (!event.target.closest('[data-tooltip]') && !event.target.closest('.a-tooltip-message')) {
	        hideTooltip();
	      }
	    }
	  });

	  // Update position on scroll
	  window.addEventListener('scroll', () => {
	    if (activeTooltip && activeTrigger) {
	      setTooltipPosition(activeTrigger, activeTooltip);
	    }
	  }, {
	    passive: true
	  });

	  // Update position on resize
	  window.addEventListener('optimizedResize', () => {
	    if (activeTooltip && activeTrigger) {
	      setTooltipPosition(activeTrigger, activeTooltip);
	    }
	  });
	  hotkeys.setScope('tooltip');
	}

	/**
	 * Check if mouse is over tooltip or trigger
	 * @param {HTMLElement} trigger - Trigger element
	 * @returns {boolean}
	 */
	function isHoveringTooltipOrTrigger(trigger) {
	  const hoveredElement = document.querySelector(':hover');
	  if (!hoveredElement) return false;
	  return hoveredElement === trigger || hoveredElement === activeTooltip || hoveredElement.closest('.a-tooltip-message') === activeTooltip || hoveredElement.closest('[data-tooltip]') === trigger;
	}

	/**
	 * Show tooltip
	 * @param {HTMLElement} trigger - Trigger element
	 * @param {string} idTooltip - Tooltip ID
	 */
	function showTooltip(trigger, idTooltip) {
	  // Hide any existing tooltip first
	  hideTooltip();
	  const tooltipContent = trigger.getAttribute('data-content');
	  if (!tooltipContent) return;

	  // Create tooltip
	  const tooltip = createTooltip(trigger, idTooltip, tooltipContent);

	  // Store active references
	  activeTooltip = tooltip;
	  activeTrigger = trigger;
	  trigger.classList.add('is-active');

	  // Position tooltip
	  requestAnimationFrame(() => {
	    setTooltipPosition(trigger, tooltip);
	  });

	  // Allow hovering over tooltip
	  tooltip.addEventListener('mouseenter', () => {
	    // Keep tooltip visible when hovering it
	  });
	  tooltip.addEventListener('mouseleave', () => {
	    setTimeout(() => {
	      if (!isHoveringTooltipOrTrigger(trigger)) {
	        hideTooltip();
	      }
	    }, 100);
	  });
	}

	/**
	 * Hide active tooltip
	 */
	function hideTooltip() {
	  if (activeTooltip) {
	    activeTooltip.remove();
	    activeTooltip = null;
	  }
	  if (activeTrigger) {
	    activeTrigger.classList.remove('is-active');
	    activeTrigger = null;
	  }
	}

	/**
	 * Get trigger position information
	 * @param {HTMLElement} trigger - Trigger element
	 * @returns {Object} Position data
	 */
	function getTriggerPosition(trigger) {
	  const rect = trigger.getBoundingClientRect();
	  return {
	    top: Math.round(rect.top) + window.scrollY,
	    left: Math.round(rect.left),
	    center: Math.round(rect.width / 2),
	    width: Math.round(rect.width),
	    height: Math.round(rect.height)
	  };
	}

	/**
	 * Set tooltip position
	 * @param {HTMLElement} trigger - Trigger element
	 * @param {HTMLElement} tooltip - Tooltip element
	 */
	function setTooltipPosition(trigger, tooltip) {
	  const documentWidth = document.documentElement.clientWidth || document.body.clientWidth;
	  const triggerPos = getTriggerPosition(trigger);

	  // Get/set tooltip dimensions
	  let tooltipWidth = Math.round(tooltip.getBoundingClientRect().width);

	  // Limit tooltip width to 95% of viewport
	  if (tooltipWidth > documentWidth * 0.95) {
	    tooltip.style.width = `${Math.round(documentWidth * 0.95)}px`;
	    tooltipWidth = Math.round(tooltip.getBoundingClientRect().width);
	  } else {
	    tooltip.style.width = '';
	  }
	  const tooltipHeight = Math.round(tooltip.getBoundingClientRect().height);

	  // Calculate initial position (centered above trigger)
	  const triggerCenterX = triggerPos.left + triggerPos.center;
	  let posLeft = triggerCenterX - tooltipWidth / 2;
	  const posTop = triggerPos.top - tooltipHeight; // - 8 (8px gap)

	  // Set initial position
	  tooltip.style.top = `${posTop}px`;
	  tooltip.style.left = `${posLeft}px`;

	  // Check for collisions
	  const tooltipRect = tooltip.getBoundingClientRect();
	  const margin = CONFIG.TOOLTIP_MARGIN_X;
	  let collisionLeft = false;
	  let collisionRight = false;

	  // Collision with right edge
	  if (tooltipRect.right > documentWidth - margin) {
	    collisionRight = true;
	    posLeft = posLeft - (tooltipRect.right - documentWidth) - margin;
	  }

	  // Collision with left edge
	  if (tooltipRect.left < margin) {
	    collisionLeft = true;
	    posLeft = posLeft + margin - tooltipRect.left;
	  }

	  // Update position if collision detected
	  if (collisionLeft || collisionRight) {
	    tooltip.style.left = `${posLeft}px`;
	    positionTooltipMarker(trigger, tooltip, triggerCenterX);
	  } else {
	    // Reset marker to center
	    tooltip.style.setProperty('--tooltip-marker-position-x', '50%');
	  }
	}

	/**
	 * Position tooltip marker (arrow)
	 * @param {HTMLElement} trigger - Trigger element
	 * @param {HTMLElement} tooltip - Tooltip element
	 * @param {number} triggerCenterX - Trigger center X position
	 */
	function positionTooltipMarker(trigger, tooltip, triggerCenterX) {
	  const tooltipRect = tooltip.getBoundingClientRect();
	  const markerPosition = triggerCenterX - tooltipRect.left;

	  // Ensure marker stays within tooltip bounds
	  const minMarkerPos = 20; // 20px from edge
	  const maxMarkerPos = tooltipRect.width - 20;
	  const clampedPosition = Math.max(minMarkerPos, Math.min(maxMarkerPos, markerPosition));
	  tooltip.style.setProperty('--tooltip-marker-position-x', `${clampedPosition}px`);
	}

	/**
	 * Create tooltip element
	 * @param {HTMLElement} trigger - Trigger element
	 * @param {string} idTooltip - Tooltip ID
	 * @param {string} content - Tooltip content
	 * @returns {HTMLElement} Tooltip element
	 */
	function createTooltip(trigger, idTooltip, content) {
	  const tooltip = document.createElement('div');
	  tooltip.classList.add('a-tooltip-message');
	  tooltip.setAttribute('role', 'tooltip');
	  tooltip.setAttribute('id', idTooltip);
	  tooltip.innerHTML = content;
	  document.body.appendChild(tooltip);
	  return tooltip;
	}

	/**
	 * Destroy tooltip instance
	 * @param {HTMLElement} trigger - Trigger element
	 */
	function destroyTooltip(trigger) {
	  if (trigger._tooltipCleanup) {
	    trigger._tooltipCleanup();
	    delete trigger._tooltipCleanup;
	  }
	  if (activeTrigger === trigger) {
	    hideTooltip();
	  }
	}

	/**
	 * Destroy all tooltips
	 */
	function destroyAllTooltips() {
	  DOM.tooltips.forEach(trigger => {
	    destroyTooltip(trigger);
	  });
	  hotkeys.deleteScope('tooltip');
	  globalListenersSetup = false;
	  hideTooltip();
	}

	var tooltip = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildTooltips,
		destroyAllTooltips: destroyAllTooltips,
		destroyTooltip: destroyTooltip
	});

	function initNotes() {
	  // Focus sur la note après navigation
	  DOM.notes.forEach(link => {
	    link.addEventListener('click', e => {
	      setTimeout(() => {
	        const targetId = link.getAttribute('href').substring(1);
	        const target = document.getElementById(targetId);
	        if (target) {
	          target.setAttribute('tabindex', '-1');
	          target.focus();
	          // Retirer tabindex après pour ne pas perturber la navigation
	          target.addEventListener('blur', () => {
	            target.removeAttribute('tabindex');
	          }, {
	            once: true
	          });
	        }
	      }, 100);
	    });
	  });

	  // Focus sur l'appel après retour
	  document.querySelectorAll('.back-to-text').forEach(link => {
	    link.addEventListener('click', e => {
	      setTimeout(() => {
	        const targetId = link.getAttribute('href').substring(1);
	        const target = document.getElementById(targetId);
	        if (target) {
	          target.focus();
	        }
	      }, 100);
	    });
	  });
	}

	var notes = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: initNotes
	});

	/**
	 * Mount Splide for module slideset
	 */
	function buildSlideset() {
	  const slidesetsElt = DOM.slidesets;
	  if (slidesetsElt.length) {
	    const splideOptions = {
	      type: 'slide',
	      autoplay: false,
	      pagination: true,
	      drag: true,
	      role: 'group',
	      i18n: SLIDER_OPTIONS_I18N_IMAGES,
	      perMove: 1,
	      traversing: true,
	      mediaQuery: 'min',
	      breakpoints: {
	        768: {
	          perPage: 2
	        }
	      }
	    };
	    slidesetsElt.forEach(sliderElt => {
	      const splideObj = new Splide(sliderElt, splideOptions);
	      splideObj.on('mounted', () => {
	        // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	        onSplideMounted(splideObj, sliderElt);

	        // Replace default role="presentation" on <ul> to keep children semantic
	        const list = splideObj.Components.Elements.list;
	        list.setAttribute('role', 'list');
	      });

	      // If traversing option is set
	      // Make all slides inside viewport visible and focusable
	      if (typeof splideOptions.traversing !== 'undefined') {
	        splideObj.on('mounted move updated resized', () => {
	          window.setTimeout(() => {
	            updateTabIndex(splideObj);
	          }, 450);
	        });
	      }

	      // Destroy
	      splideObj.on('destroy', () => {
	        onSplideDestroy(splideObj, sliderElt);
	      });

	      // Mount slider
	      splideObj.mount();
	    });
	  }
	}

	var slideset = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildSlideset
	});

	/**
	 * Mount Splide for module slideshow
	 */
	function buildSlideshow() {
	  const slideshowsElt = DOM.slideshows;
	  if (slideshowsElt.length) {
	    const splideOptions = {
	      type: 'slide',
	      autoplay: false,
	      pagination: true,
	      drag: true,
	      role: 'group',
	      i18n: SLIDER_OPTIONS_I18N_IMAGES,
	      perMove: 1
	    };
	    slideshowsElt.forEach(sliderElt => {
	      const splideObj = new Splide(sliderElt, splideOptions);
	      splideObj.on('mounted', () => {
	        // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	        onSplideMounted(splideObj, sliderElt);
	      });

	      // Destroy
	      splideObj.on('destroy', () => {
	        onSplideDestroy(splideObj, sliderElt);
	      });

	      // Mount slider
	      splideObj.mount();
	    });
	  }
	}

	var slideshow = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildSlideshow
	});

	/**
	 * Mount Splide for A la Une
	 */
	function buildAlaUneSlider() {
	  const splideAlaUneElt = DOM.aLaUne;

	  // ✅ Guard clause
	  if (!splideAlaUneElt) {
	    return;
	  }
	  const splideOptions = {
	    type: 'slide',
	    pagination: true,
	    autoplay: false,
	    drag: true,
	    role: 'group',
	    autoWidth: false,
	    perMove: 1,
	    perPage: 1,
	    i18n: SLIDER_OPTIONS_I18N_ACTUALITIES,
	    accessibility: {
	      pagination: {
	        role: false,
	        // Ne pas ajouter role="tablist"
	        tab: false // Ne pas ajouter role="tab"
	      }
	    },
	    mediaQuery: 'min',
	    breakpoints: {
	      768: {
	        perPage: 2
	      },
	      1024: {
	        perPage: 1
	      }
	    }
	  };
	  const splideAlaUneObj = new Splide(splideAlaUneElt, splideOptions);
	  splideAlaUneObj.on('mounted', () => {
	    // if only one slide : destroy splide completely & remove unecessary buttons/pagination markup
	    onSplideMounted(splideAlaUneObj, splideAlaUneElt);

	    // Replace default role="presentation" on <ul> to keep children semantic
	    const list = splideAlaUneObj.Components.Elements.list;
	    // list.setAttribute('role', 'list');
	    list.removeAttribute('role');
	  });

	  // Destroy
	  splideAlaUneObj.on('destroy', () => {
	    onSplideDestroy(splideAlaUneObj, splideAlaUneElt);
	  });

	  // Mount slider
	  splideAlaUneObj.mount();
	}

	var aLaUne = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: buildAlaUneSlider
	});

	// Map pour stocker les timers par textarea
	const timers = new WeakMap();
	function initCharsCounter() {
	  const textareasCounter = DOM.textareaCharsCounters;
	  if (textareasCounter.length) {
	    textareasCounter.forEach(elt => {
	      if (createCharsCounter(elt)) {
	        events(elt);
	      }
	    });
	  }
	}

	/**
	 * Setup event listeners for textarea
	 * @param {HTMLElement} elt - Textarea element
	 */
	function events(elt) {
	  const textareaParent = elt.closest('.m-label-field');
	  if (!textareaParent) return;
	  const counter = textareaParent.querySelector('.a-charscounter');
	  if (!counter) return;

	  // Show counter on initial load
	  showCharsCounter(elt, elt.value.length, counter);

	  // Update counter on input (captures keyup, paste, cut, etc.)
	  const handleInput = e => {
	    showCharsCounter(elt, e.target.value.length, counter);
	  };
	  elt.addEventListener('input', handleInput);

	  // Update position on resize
	  const handleResize = () => {
	    positionCharsCounter(elt);
	  };
	  window.addEventListener('optimizedResize', handleResize);

	  // Store cleanup function for potential future use
	  elt._charsCounterCleanup = () => {
	    elt.removeEventListener('input', handleInput);
	    window.removeEventListener('optimizedResize', handleResize);
	    const timer = timers.get(elt);
	    if (timer) {
	      clearTimeout(timer);
	      timers.delete(elt);
	    }
	  };
	}

	/**
	 * Create a character counter for textarea
	 * @param {HTMLElement} elt - Textarea element
	 * @returns {boolean} - Success status
	 */
	function createCharsCounter(elt) {
	  const textareaParent = elt.closest('.m-label-field');
	  if (!textareaParent) return false;

	  // Check if counter already exists
	  if (textareaParent.querySelector('.a-charscounter')) return true;
	  const counterNode = document.createElement('p');
	  counterNode.classList.add('a-charscounter');
	  const counterScreenOnly = document.createElement('span');
	  counterScreenOnly.setAttribute('aria-hidden', 'true');
	  counterScreenOnly.classList.add('screen-only');
	  counterNode.appendChild(counterScreenOnly);
	  const counterScreenReaderOnly = document.createElement('span');
	  const counterId = `counter-${uniqueID()}`;
	  counterScreenReaderOnly.classList.add(CLASS.VISUALLY_HIDDEN);
	  counterScreenReaderOnly.setAttribute('id', counterId);
	  counterScreenReaderOnly.setAttribute('aria-live', 'polite');
	  counterNode.appendChild(counterScreenReaderOnly);
	  textareaParent.appendChild(counterNode);

	  // Position after adding to DOM
	  requestAnimationFrame(() => {
	    positionCharsCounter(elt);
	  });
	  elt.setAttribute('aria-describedby', counterId);
	  return true;
	}

	/**
	 * Position counter relative to textarea
	 * @param {HTMLElement} elt - Textarea element
	 */
	function positionCharsCounter(elt) {
	  const textareaParent = elt.closest('.m-label-field');
	  if (!textareaParent) return;
	  const counter = textareaParent.querySelector('.a-charscounter');
	  if (!counter) return;
	  counter.style.top = `${elt.offsetTop + elt.offsetHeight}px`;
	  counter.style.left = `${getInnerWidth(elt) / 2 - getInnerWidth(counter) / 2}px`;
	}

	/**
	 * Show and update character counter
	 * @param {HTMLElement} elt - Textarea element
	 * @param {number} length - Current text length
	 * @param {HTMLElement} counter - Counter element
	 */
	function showCharsCounter(elt, length, counter) {
	  const maxlength = parseInt(elt.getAttribute('maxlength'), 10);
	  if (!maxlength || isNaN(maxlength)) return;
	  const limit = maxlength - length;
	  counter.classList.add(CLASS.IS_ACTIVE);
	  counter.querySelector('.screen-only').textContent = `${length}/${maxlength}`;

	  // Clear previous timer for this textarea
	  const existingTimer = timers.get(elt);
	  if (existingTimer) {
	    clearTimeout(existingTimer);
	  }

	  // Toggle max reached state
	  if (limit <= 0) {
	    counter.classList.add(CLASS.IS_MAX_REACHED);
	  } else {
	    counter.classList.remove(CLASS.IS_MAX_REACHED);
	  }

	  // Announce remaining characters for screen readers
	  const timer = window.setTimeout(() => {
	    const srElement = counter.querySelector(`.${CLASS.VISUALLY_HIDDEN}`);
	    if (!srElement) return;
	    if (limit <= maxlength * 0.1 && limit <= 15 && limit > 0) {
	      const plural = limit !== 1;
	      srElement.textContent = `${limit} caractère${plural ? 's' : ''} restant${plural ? 's' : ''}`;
	    } else if (limit === 0) {
	      srElement.textContent = 'Limite de caractères atteinte';
	    } else {
	      srElement.textContent = '';
	    }
	  }, 1500);
	  timers.set(elt, timer);
	}

	/**
	 * Cleanup function to remove all event listeners and timers
	 * @param {HTMLElement} elt - Textarea element
	 */
	function destroyCharsCounter(elt) {
	  if (elt._charsCounterCleanup) {
	    elt._charsCounterCleanup();
	    delete elt._charsCounterCleanup;
	  }
	}

	var charsCounter = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: initCharsCounter,
		destroyCharsCounter: destroyCharsCounter
	});

	// Store event handlers for proper cleanup
	const eventHandlers = new Map();
	function init$1() {
	  DOM.glossary.querySelectorAll('.o-glossary__letters button').forEach(letterBtn => {
	    letterBtn.addEventListener('click', e => {
	      switchOffCurrentLetter();
	      switchOnLetter(e.target.getAttribute('data-alpha-letter'));
	    });
	  });

	  // Add live region for screen reader announcements if not exists
	  if (!document.getElementById('glossary-live-region')) {
	    const liveRegion = document.createElement('div');
	    liveRegion.id = 'glossary-live-region';
	    liveRegion.className = 'sr-only';
	    liveRegion.setAttribute('aria-live', 'polite');
	    liveRegion.setAttribute('aria-atomic', 'true');
	    DOM.glossary.appendChild(liveRegion);
	  }
	}

	/**
	 * Announce changes to screen readers
	 * @param {string} message
	 */
	function announceToScreenReader$1(message) {
	  const liveRegion = document.getElementById('glossary-live-region');
	  if (liveRegion) {
	    liveRegion.textContent = message;
	  }
	}

	/**
	 * Switch off current selected letter in alphabet
	 */
	function switchOffCurrentLetter() {
	  const currentActiveLetterElt = DOM.glossary.querySelector(`.letter.${CLASS.IS_ACTIVE}`);
	  if (currentActiveLetterElt) {
	    const currentActiveLetterName = currentActiveLetterElt.getAttribute('data-alpha-letter');

	    // Deactivate letter in alphabet
	    currentActiveLetterElt.classList.remove(CLASS.IS_ACTIVE);
	    currentActiveLetterElt.removeAttribute('aria-current');

	    // Deactivate letter in definition terms block
	    deactivateLetterDefinitions(currentActiveLetterName);
	  }
	}

	/**
	 * Switch off current selected letter in definitions
	 * @param {string} currentActiveLetterName
	 */
	function deactivateLetterDefinitions(currentActiveLetterName) {
	  const definitionsLetterContainerElt = document.getElementById(`dfn-letter-${currentActiveLetterName}`);
	  const currentActiveDefinitionsLetterTitle = document.getElementById(`lettre-${currentActiveLetterName}`);
	  if (currentActiveDefinitionsLetterTitle) {
	    // Title h2 attributes
	    setAriaHidden(currentActiveDefinitionsLetterTitle, true);
	    currentActiveDefinitionsLetterTitle.classList.remove(CLASS.IS_ACTIVE);

	    // Masquer le bouton "go-next" de la lettre précédente
	    const goNextLetterBtn = definitionsLetterContainerElt?.querySelector('.go-next');
	    if (goNextLetterBtn) {
	      goNextLetterBtn.hidden = true;
	    }

	    // Clean up event listeners
	    cleanupEventListeners(currentActiveLetterName);
	  }
	}

	/**
	 * Clean up event listeners for a letter
	 * @param {string} letterName
	 */
	function cleanupEventListeners(letterName) {
	  // Remove next button listener
	  const nextKey = `next-${letterName}`;
	  if (eventHandlers.has(nextKey)) {
	    const {
	      element,
	      handler
	    } = eventHandlers.get(nextKey);
	    element.removeEventListener('click', handler);
	    eventHandlers.delete(nextKey);
	  }

	  // Remove back button listener
	  const backKey = `back-${letterName}`;
	  if (eventHandlers.has(backKey)) {
	    const {
	      element,
	      handler
	    } = eventHandlers.get(backKey);
	    element.removeEventListener('click', handler);
	    element.classList.remove(CLASS.IS_ACTIVE);
	    eventHandlers.delete(backKey);
	  }
	}

	/**
	 * Switch to new letter in glossary definitions
	 * @param {string} newLetterName
	 */
	function switchOnLetter(newLetterName) {
	  // Update current selected letter in alphabet
	  const alphabetLetterElt = DOM.glossary.querySelector(`[data-alpha-letter="${newLetterName}"]`);
	  if (!alphabetLetterElt) return;
	  alphabetLetterElt.classList.add(CLASS.IS_ACTIVE);
	  alphabetLetterElt.setAttribute('aria-current', 'step');
	  const definitionsLetterContainerElt = document.getElementById(`dfn-letter-${newLetterName}`);
	  const letterToShowTitleElt = document.getElementById(`lettre-${newLetterName}`);
	  if (!letterToShowTitleElt || !definitionsLetterContainerElt) return;
	  letterToShowTitleElt.classList.add(CLASS.IS_ACTIVE);
	  setAriaHidden(letterToShowTitleElt, false);
	  setElementFocus(letterToShowTitleElt);

	  // Announce to screen readers
	  const letterUpperCase = newLetterName.toUpperCase();
	  announceToScreenReader$1(`Lettre ${letterUpperCase} sélectionnée`);

	  // Afficher le bouton "go-next" s'il existe
	  const goNextLetterBtn = definitionsLetterContainerElt.querySelector('.go-next');
	  if (goNextLetterBtn) {
	    goNextLetterBtn.hidden = false;
	    const nextHandler = e => {
	      const nextLetterToShowName = e.target.getAttribute('data-next-letter');
	      const nextLetterExists = document.getElementById(`dfn-letter-${nextLetterToShowName}`) && DOM.glossary.querySelector(`.letter[data-alpha-letter="${nextLetterToShowName}"]`);
	      if (nextLetterExists) {
	        switchOffCurrentLetter();
	        switchOnLetter(nextLetterToShowName);
	      }
	    };
	    goNextLetterBtn.addEventListener('click', nextHandler);
	    eventHandlers.set(`next-${newLetterName}`, {
	      element: goNextLetterBtn,
	      handler: nextHandler
	    });
	  }

	  // Setup back to top button
	  const goBackTopLetterBtn = definitionsLetterContainerElt.querySelector('.go-back-top');
	  if (goBackTopLetterBtn) {
	    goBackTopLetterBtn.classList.add(CLASS.IS_ACTIVE);
	    const backHandler = () => {
	      backToAlphabet(newLetterName);
	      deactivateLetterDefinitions(newLetterName);
	      announceToScreenReader$1('Retour à l\'alphabet');
	    };
	    goBackTopLetterBtn.addEventListener('click', backHandler);
	    eventHandlers.set(`back-${newLetterName}`, {
	      element: goBackTopLetterBtn,
	      handler: backHandler
	    });
	  }
	}

	/**
	 * Focus back to letter in glossary alphabet
	 * @param {string} letter
	 */
	function backToAlphabet(letter) {
	  const letterElt = DOM.glossary.querySelector(`.letter[data-alpha-letter="${letter}"]`);
	  if (letterElt) {
	    setElementFocus(letterElt);
	  }
	}

	var glossary = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: init$1
	});

	var TheDatepicker;
	(function (TheDatepicker) {
	  var ClassNameType;
	  (function (ClassNameType) {
	    ClassNameType[ClassNameType["Container"] = 0] = "Container";
	    ClassNameType[ClassNameType["ContainerOver"] = 1] = "ContainerOver";
	    ClassNameType[ClassNameType["ContainerLeft"] = 2] = "ContainerLeft";
	    ClassNameType[ClassNameType["ContainerResponsive"] = 3] = "ContainerResponsive";
	    ClassNameType[ClassNameType["Main"] = 4] = "Main";
	    ClassNameType[ClassNameType["Body"] = 5] = "Body";
	    ClassNameType[ClassNameType["BodySwipeable"] = 6] = "BodySwipeable";
	    ClassNameType[ClassNameType["Tables"] = 7] = "Tables";
	    ClassNameType[ClassNameType["Header"] = 8] = "Header";
	    ClassNameType[ClassNameType["HeaderTop"] = 9] = "HeaderTop";
	    ClassNameType[ClassNameType["HeaderControl"] = 10] = "HeaderControl";
	    ClassNameType[ClassNameType["HeaderNavigation"] = 11] = "HeaderNavigation";
	    ClassNameType[ClassNameType["HeaderState"] = 12] = "HeaderState";
	    ClassNameType[ClassNameType["HeaderMonth"] = 13] = "HeaderMonth";
	    ClassNameType[ClassNameType["HeaderYear"] = 14] = "HeaderYear";
	    ClassNameType[ClassNameType["HeaderMonthYear"] = 15] = "HeaderMonthYear";
	    ClassNameType[ClassNameType["HeaderYearsToggle"] = 16] = "HeaderYearsToggle";
	    ClassNameType[ClassNameType["Button"] = 17] = "Button";
	    ClassNameType[ClassNameType["ButtonContent"] = 18] = "ButtonContent";
	    ClassNameType[ClassNameType["SelectInput"] = 19] = "SelectInput";
	    ClassNameType[ClassNameType["Deselect"] = 20] = "Deselect";
	    ClassNameType[ClassNameType["DeselectButton"] = 21] = "DeselectButton";
	    ClassNameType[ClassNameType["HeaderTitle"] = 22] = "HeaderTitle";
	    ClassNameType[ClassNameType["HeaderTitleContent"] = 23] = "HeaderTitleContent";
	    ClassNameType[ClassNameType["Reset"] = 24] = "Reset";
	    ClassNameType[ClassNameType["Close"] = 25] = "Close";
	    ClassNameType[ClassNameType["Go"] = 26] = "Go";
	    ClassNameType[ClassNameType["GoNext"] = 27] = "GoNext";
	    ClassNameType[ClassNameType["GoPrevious"] = 28] = "GoPrevious";
	    ClassNameType[ClassNameType["Table"] = 29] = "Table";
	    ClassNameType[ClassNameType["TableRow"] = 30] = "TableRow";
	    ClassNameType[ClassNameType["TableCell"] = 31] = "TableCell";
	    ClassNameType[ClassNameType["TableCellUnavailable"] = 32] = "TableCellUnavailable";
	    ClassNameType[ClassNameType["TableCellHighlighted"] = 33] = "TableCellHighlighted";
	    ClassNameType[ClassNameType["TableCellSelected"] = 34] = "TableCellSelected";
	    ClassNameType[ClassNameType["CalendarTable"] = 35] = "CalendarTable";
	    ClassNameType[ClassNameType["CalendarTableHeader"] = 36] = "CalendarTableHeader";
	    ClassNameType[ClassNameType["CalendarTableHeaderCell"] = 37] = "CalendarTableHeaderCell";
	    ClassNameType[ClassNameType["CalendarTableBody"] = 38] = "CalendarTableBody";
	    ClassNameType[ClassNameType["YearsTable"] = 39] = "YearsTable";
	    ClassNameType[ClassNameType["YearsTableBody"] = 40] = "YearsTableBody";
	    ClassNameType[ClassNameType["WeekDayWeekend"] = 41] = "WeekDayWeekend";
	    ClassNameType[ClassNameType["Day"] = 42] = "Day";
	    ClassNameType[ClassNameType["DayToday"] = 43] = "DayToday";
	    ClassNameType[ClassNameType["DayPast"] = 44] = "DayPast";
	    ClassNameType[ClassNameType["DayWeekend"] = 45] = "DayWeekend";
	    ClassNameType[ClassNameType["DayUnavailable"] = 46] = "DayUnavailable";
	    ClassNameType[ClassNameType["DayOutside"] = 47] = "DayOutside";
	    ClassNameType[ClassNameType["DayHighlighted"] = 48] = "DayHighlighted";
	    ClassNameType[ClassNameType["DaySelected"] = 49] = "DaySelected";
	    ClassNameType[ClassNameType["DayButton"] = 50] = "DayButton";
	    ClassNameType[ClassNameType["DayButtonContent"] = 51] = "DayButtonContent";
	    ClassNameType[ClassNameType["YearCellButton"] = 52] = "YearCellButton";
	    ClassNameType[ClassNameType["YearCellButtonContent"] = 53] = "YearCellButtonContent";
	    ClassNameType[ClassNameType["Animated"] = 54] = "Animated";
	    ClassNameType[ClassNameType["AnimateFadeOutLeft"] = 55] = "AnimateFadeOutLeft";
	    ClassNameType[ClassNameType["AnimateFadeInRight"] = 56] = "AnimateFadeInRight";
	    ClassNameType[ClassNameType["AnimateFadeOutUp"] = 57] = "AnimateFadeOutUp";
	    ClassNameType[ClassNameType["AnimateFadeInDown"] = 58] = "AnimateFadeInDown";
	    ClassNameType[ClassNameType["AnimateFadeOutRight"] = 59] = "AnimateFadeOutRight";
	    ClassNameType[ClassNameType["AnimateFadeInLeft"] = 60] = "AnimateFadeInLeft";
	    ClassNameType[ClassNameType["AnimateFadeOutDown"] = 61] = "AnimateFadeOutDown";
	    ClassNameType[ClassNameType["AnimateFadeInUp"] = 62] = "AnimateFadeInUp";
	    ClassNameType[ClassNameType["ContainerDarkMode"] = 63] = "ContainerDarkMode";
	    ClassNameType[ClassNameType["MainDarkMode"] = 64] = "MainDarkMode";
	  })(ClassNameType = TheDatepicker.ClassNameType || (TheDatepicker.ClassNameType = {}));
	  var ClassNames = function () {
	    function ClassNames() {
	      this.classNames_ = [['container'], ['container--over'], ['container--left'], ['container--responsive'], ['main'], ['body'], ['body--swipeable'], ['tables'], ['header'], ['top'], ['control'], ['navigation'], ['state'], ['month'], ['year'], ['month-year'], ['year-button'], ['button'], ['button-content'], ['select'], ['deselect'], ['deselect-button'], ['title'], ['title-content'], ['reset'], ['close'], ['go'], ['go-next'], ['go-previous'], ['table'], ['row'], ['cell'], ['cell--unavailable'], ['cell--highlighted'], ['cell--selected'], ['calendar'], ['calendar-header'], ['week-day'], ['calendar-body'], ['years'], ['years-body'], ['week-day--weekend'], ['day'], ['day--today'], ['day--past'], ['day--weekend'], ['day--unavailable'], ['day--outside'], ['day--highlighted'], ['day--selected'], ['day--button'], ['day-content'], ['year-cell-button'], ['year-cell-content'], ['animated'], ['fade-out-left'], ['fade-in-right'], ['fade-out-up'], ['fade-in-down'], ['fade-out-right'], ['fade-in-left'], ['fade-out-down'], ['fade-in-up'], ['container--darkmode'], ['main--darkmode']];
	    }
	    ClassNames.prototype.clone = function () {
	      var classNames = new ClassNames();
	      var index;
	      for (index = 0; index < this.classNames_.length; index++) {
	        classNames.classNames_ = this.classNames_.slice(0);
	      }
	      return classNames;
	    };
	    ClassNames.prototype.setClassName = function (type, className) {
	      if (type === ClassNameType.ContainerDarkMode) {
	        TheDatepicker.Helper_.warnDeprecatedUsage_('ClassNameType.ContainerDarkMode', ['ClassNameType.MainDarkMode']);
	        this.setClassName(ClassNameType.MainDarkMode, className);
	      }
	      this.classNames_[this.checkType_(type)] = this.normalizeClassName_(className);
	    };
	    ClassNames.prototype.addClassName = function (type, className) {
	      this.classNames_[this.checkType_(type)].concat(this.normalizeClassName_(className));
	    };
	    ClassNames.prototype.getClassName = function (type) {
	      return this.classNames_[type].slice(0);
	    };
	    ClassNames.prototype.checkType_ = function (type) {
	      return TheDatepicker.Helper_.checkNumber_('Class name type', type, 0, this.classNames_.length - 1);
	    };
	    ClassNames.prototype.normalizeClassName_ = function (className) {
	      var parameterName = 'Class name';
	      if (typeof className !== 'object' || className.constructor !== Array) {
	        className = TheDatepicker.Helper_.checkString_(parameterName, className).split(/\s+/);
	      }
	      var result = [];
	      for (var index = 0; index < className.length; index++) {
	        var name_1 = TheDatepicker.Helper_.checkString_(parameterName, className[index]);
	        if (name_1) {
	          result.push(name_1);
	        }
	      }
	      return result;
	    };
	    return ClassNames;
	  }();
	  TheDatepicker.ClassNames = ClassNames;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  var CannotParseDateException = function () {
	    function CannotParseDateException() {}
	    return CannotParseDateException;
	  }();
	  TheDatepicker.CannotParseDateException = CannotParseDateException;
	  var ParsedDateData = function () {
	    function ParsedDateData() {
	      this.day = null;
	      this.month = null;
	      this.year = null;
	    }
	    ParsedDateData.prototype.createDate = function () {
	      if (this.day === null || this.month === null || this.year === null) {
	        throw new CannotParseDateException();
	      }
	      var date = new Date(this.year, this.month - 1, this.day);
	      if (isNaN(date.getTime())) {
	        throw new CannotParseDateException();
	      }
	      while (date.getDate() !== this.day || date.getMonth() !== this.month - 1 || date.getFullYear() !== this.year) {
	        if (this.day > 28) {
	          this.day--;
	          date = new Date(this.year, this.month - 1, this.day);
	        } else {
	          throw new CannotParseDateException();
	        }
	      }
	      return date;
	    };
	    return ParsedDateData;
	  }();
	  var DateConverter_ = function () {
	    function DateConverter_() {}
	    DateConverter_.formatDate_ = function (date, options, format) {
	      if (format === void 0) {
	        format = null;
	      }
	      if (!date) {
	        return null;
	      }
	      format = format || options.getInputFormat();
	      var escapeNext = false;
	      var result = '';
	      for (var position = 0; position < format.length; position++) {
	        var char = format.substring(position, position + 1);
	        if (escapeNext) {
	          result += char;
	          escapeNext = false;
	          continue;
	        }
	        if (char === DateConverter_.escapeChar_) {
	          escapeNext = true;
	          continue;
	        }
	        var formatter = DateConverter_.getFormatter_(char);
	        if (formatter) {
	          result += formatter.call(null, date, options);
	          continue;
	        }
	        result += char;
	      }
	      return result;
	    };
	    DateConverter_.parseDate_ = function (text, options) {
	      if ((text.trim ? text.trim() : text) === '') {
	        return null;
	      }
	      var format = options.getInputFormat();
	      var dateData = new ParsedDateData();
	      var escapeNext = false;
	      var textPosition = 0;
	      for (var position = 0; position < format.length; position++) {
	        var char = format.substring(position, position + 1);
	        if (escapeNext) {
	          escapeNext = false;
	        } else if (char === DateConverter_.escapeChar_) {
	          escapeNext = true;
	          continue;
	        } else {
	          var parser = DateConverter_.getParser_(char);
	          if (parser) {
	            try {
	              textPosition += parser.call(null, text.substring(textPosition), dateData, options);
	            } catch (error) {
	              if (!(error instanceof CannotParseDateException)) {
	                throw error;
	              }
	              var textChar_1 = text.substring(textPosition, textPosition + 1);
	              if (textChar_1 === ' ') {
	                textPosition++;
	                position--;
	                continue;
	              } else {
	                throw error;
	              }
	            }
	            continue;
	          }
	        }
	        var textChar = text.substring(textPosition, textPosition + 1);
	        if (textChar !== char) {
	          if (char === ' ') {
	            continue;
	          }
	          if (textChar === ' ') {
	            textPosition++;
	            position--;
	            continue;
	          }
	          throw new CannotParseDateException();
	        }
	        textPosition++;
	      }
	      return dateData.createDate();
	    };
	    DateConverter_.isValidChar_ = function (textChar, options) {
	      if (textChar === '' || /[0-9-]/.test(textChar)) {
	        return true;
	      }
	      var format = options.getInputFormat();
	      var escapeNext = false;
	      for (var position = 0; position < format.length; position++) {
	        var char = format.substring(position, position + 1);
	        if (escapeNext) {
	          escapeNext = false;
	        } else if (char === DateConverter_.escapeChar_) {
	          escapeNext = true;
	          continue;
	        } else {
	          var phrases = DateConverter_.getValidPhrases_(char, options);
	          if (phrases) {
	            var textCharLower = textChar.toLowerCase();
	            for (var index = 0; index < phrases.length; index++) {
	              if (phrases[index].toLowerCase().indexOf(textCharLower) > -1) {
	                return true;
	              }
	            }
	            continue;
	          }
	        }
	        if (textChar === char) {
	          return true;
	        }
	      }
	      return false;
	    };
	    DateConverter_.getFormatter_ = function (type) {
	      switch (type) {
	        case 'j':
	          return DateConverter_.formatDay_;
	        case 'd':
	          return DateConverter_.formatDayWithLeadingZero_;
	        case 'D':
	          return DateConverter_.formatDayOfWeekTextual_;
	        case 'l':
	          return DateConverter_.formatDayOfWeekTextualFull_;
	        case 'n':
	          return DateConverter_.formatMonth_;
	        case 'm':
	          return DateConverter_.formatMonthWithLeadingZero_;
	        case 'F':
	          return DateConverter_.formatMonthTextual_;
	        case 'M':
	          return DateConverter_.formatMonthTextualShort_;
	        case 'Y':
	          return DateConverter_.formatYear_;
	        case 'y':
	          return DateConverter_.formatYearTwoDigits_;
	        default:
	          return null;
	      }
	    };
	    DateConverter_.formatDay_ = function (date) {
	      return date.getDate() + '';
	    };
	    DateConverter_.formatDayWithLeadingZero_ = function (date) {
	      return ('0' + date.getDate()).slice(-2);
	    };
	    DateConverter_.formatDayOfWeekTextual_ = function (date, options) {
	      return options.translator.translateDayOfWeek(date.getDay());
	    };
	    DateConverter_.formatDayOfWeekTextualFull_ = function (date, options) {
	      return options.translator.translateDayOfWeekFull(date.getDay());
	    };
	    DateConverter_.formatMonth_ = function (date) {
	      return date.getMonth() + 1 + '';
	    };
	    DateConverter_.formatMonthWithLeadingZero_ = function (date) {
	      return ('0' + (date.getMonth() + 1)).slice(-2);
	    };
	    DateConverter_.formatMonthTextual_ = function (date, options) {
	      return options.translator.translateMonth(date.getMonth());
	    };
	    DateConverter_.formatMonthTextualShort_ = function (date, options) {
	      return options.translator.translateMonthShort(date.getMonth());
	    };
	    DateConverter_.formatYear_ = function (date) {
	      return date.getFullYear() + '';
	    };
	    DateConverter_.formatYearTwoDigits_ = function (date) {
	      var year = date.getFullYear() + '';
	      return year.substring(year.length - 2);
	    };
	    DateConverter_.getParser_ = function (type) {
	      switch (type) {
	        case 'j':
	        case 'd':
	          return DateConverter_.parseDay_;
	        case 'D':
	          return DateConverter_.parseDayOfWeekTextual_;
	        case 'l':
	          return DateConverter_.parseDayOfWeekTextualFull_;
	        case 'n':
	        case 'm':
	          return DateConverter_.parseMonth_;
	        case 'F':
	          return DateConverter_.parseMonthTextual_;
	        case 'M':
	          return DateConverter_.parseMonthTextualShort_;
	        case 'Y':
	          return DateConverter_.parseYear_;
	        case 'y':
	          return DateConverter_.parseYearTwoDigits_;
	        default:
	          return null;
	      }
	    };
	    DateConverter_.parseDay_ = function (text, dateData) {
	      var took = 0;
	      while (text.substring(0, 1) === '0') {
	        text = text.substring(1);
	        took++;
	      }
	      var day = text.substring(0, 2);
	      if (!/[12][0-9]|3[01]/.test(day)) {
	        day = day.substring(0, 1);
	        if (!/[1-9]/.test(day)) {
	          throw new CannotParseDateException();
	        }
	      }
	      dateData.day = parseInt(day, 10);
	      return took + day.length;
	    };
	    DateConverter_.parseDayOfWeekTextual_ = function (text, dateData, options) {
	      return DateConverter_.parseDayOfWeekByTranslator_(text, function (dayOfWeek) {
	        return options.translator.translateDayOfWeek(dayOfWeek);
	      });
	    };
	    DateConverter_.parseDayOfWeekTextualFull_ = function (text, dateData, options) {
	      return DateConverter_.parseDayOfWeekByTranslator_(text, function (dayOfWeek) {
	        return options.translator.translateDayOfWeekFull(dayOfWeek);
	      });
	    };
	    DateConverter_.parseDayOfWeekByTranslator_ = function (text, translate) {
	      var maxLength = 0;
	      var matchedTranslationLength = 0;
	      for (var dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
	        var translation = translate(dayOfWeek);
	        maxLength = Math.max(maxLength, translation.length);
	        if (text.substring(0, translation.length).toLowerCase() === translation.toLowerCase() && translation.length > matchedTranslationLength) {
	          matchedTranslationLength = translation.length;
	        }
	      }
	      if (matchedTranslationLength > 0) {
	        return matchedTranslationLength;
	      }
	      var took = 0;
	      while (/[a-zA-Z]/.test(text.substring(0, 1))) {
	        text = text.substring(1);
	        took++;
	        if (took === maxLength) {
	          break;
	        }
	      }
	      return took;
	    };
	    DateConverter_.parseMonth_ = function (text, dateData) {
	      var took = 0;
	      while (text.substring(0, 1) === '0') {
	        text = text.substring(1);
	        took++;
	      }
	      var month = text.substring(0, 2);
	      if (month !== '10' && month !== '11' && month !== '12') {
	        month = month.substring(0, 1);
	        if (!/[1-9]/.test(month)) {
	          throw new CannotParseDateException();
	        }
	      }
	      dateData.month = parseInt(month, 10);
	      return took + month.length;
	    };
	    DateConverter_.parseMonthTextual_ = function (text, dateData, options) {
	      return DateConverter_.parseMonthByTranslator_(text, dateData, function (month) {
	        return options.translator.translateMonth(month);
	      });
	    };
	    DateConverter_.parseMonthTextualShort_ = function (text, dateData, options) {
	      return DateConverter_.parseMonthByTranslator_(text, dateData, function (month) {
	        return options.translator.translateMonthShort(month);
	      });
	    };
	    DateConverter_.parseMonthByTranslator_ = function (text, dateData, translate) {
	      var matchedMonth = null;
	      var matchedTranslationLength = 0;
	      for (var month = 1; month <= 12; month++) {
	        var translation = translate(month - 1);
	        if (text.substring(0, translation.length).toLowerCase() === translation.toLowerCase() && translation.length > matchedTranslationLength) {
	          matchedMonth = month;
	          matchedTranslationLength = translation.length;
	        }
	      }
	      if (matchedMonth === null) {
	        throw new CannotParseDateException();
	      }
	      dateData.month = matchedMonth;
	      return matchedTranslationLength;
	    };
	    DateConverter_.parseYear_ = function (text, dateData, options) {
	      var isNegative = false;
	      if (text.substring(0, 1) === '-') {
	        isNegative = true;
	        text = text.substring(1);
	      }
	      var minDate = options.getMinDate_();
	      var maxDate = options.getMaxDate_();
	      var maxPositiveLength = maxDate.getFullYear() > 0 ? (maxDate.getFullYear() + '').length : 0;
	      var maxNegativeLength = minDate.getFullYear() < 0 ? (-minDate.getFullYear() + '').length : 0;
	      var yearLength = 0;
	      while (/[0-9]/.test(text.substring(yearLength, yearLength + 1))) {
	        if (isNegative && yearLength + 1 > maxNegativeLength || !isNegative && yearLength + 1 > maxPositiveLength) {
	          break;
	        }
	        yearLength++;
	      }
	      if (yearLength === 0) {
	        throw new CannotParseDateException();
	      }
	      var year = parseInt(text.substring(0, yearLength), 10);
	      if (isNegative) {
	        year = -year;
	      }
	      dateData.year = year;
	      return yearLength + (isNegative ? 1 : 0);
	    };
	    DateConverter_.parseYearTwoDigits_ = function (text, dateData, options) {
	      var yearEnd = text.substring(0, 2);
	      if (!/[0-9]{2}/.test(yearEnd)) {
	        throw new CannotParseDateException();
	      }
	      var currentYear = options.getToday().getFullYear() + '';
	      var yearBeginning = currentYear.substring(0, currentYear.length - 2);
	      dateData.year = parseInt(yearBeginning + yearEnd, 10);
	      return 2;
	    };
	    DateConverter_.getValidPhrases_ = function (type, options) {
	      switch (type) {
	        case 'j':
	        case 'd':
	        case 'n':
	        case 'm':
	        case 'Y':
	        case 'y':
	          return [];
	        case 'D':
	          return options.translator.dayOfWeekTranslations_;
	        case 'l':
	          return options.translator.dayOfWeekFullTranslations_;
	        case 'F':
	          return options.translator.monthTranslations_;
	        case 'M':
	          return options.translator.monthShortTranslations_;
	        default:
	          return null;
	      }
	    };
	    DateConverter_.escapeChar_ = '\\';
	    return DateConverter_;
	  }();
	  TheDatepicker.DateConverter_ = DateConverter_;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  var InitializationPhase;
	  (function (InitializationPhase) {
	    InitializationPhase[InitializationPhase["Untouched"] = 0] = "Untouched";
	    InitializationPhase[InitializationPhase["Waiting"] = 1] = "Waiting";
	    InitializationPhase[InitializationPhase["Ready"] = 2] = "Ready";
	    InitializationPhase[InitializationPhase["Initialized"] = 3] = "Initialized";
	    InitializationPhase[InitializationPhase["Destroyed"] = 4] = "Destroyed";
	  })(InitializationPhase || (InitializationPhase = {}));
	  var Datepicker = function () {
	    function Datepicker(input, container, options) {
	      if (container === void 0) {
	        container = null;
	      }
	      if (options === void 0) {
	        options = null;
	      }
	      this.inputClickable_ = null;
	      this.inputText_ = null;
	      this.initializationPhase_ = InitializationPhase.Untouched;
	      this.inputListenerRemover_ = null;
	      this.listenerRemovers_ = [];
	      this.deselectElement_ = null;
	      this.deselectButton_ = null;
	      if (!(this instanceof Datepicker)) {
	        throw new Error('Creation must be performed by "new" keyword.');
	      }
	      if (input && !TheDatepicker.Helper_.isElement_(input)) {
	        throw new Error('Input was expected to be null or an HTMLElement.');
	      }
	      if (container && !TheDatepicker.Helper_.isElement_(container)) {
	        throw new Error('Container was expected to be null or an HTMLElement.');
	      }
	      if (!input && !container) {
	        throw new Error('At least one of input or container is mandatory.');
	      }
	      if (options && !(options instanceof TheDatepicker.Options)) {
	        throw new Error('Options was expected to be an instance of Options');
	      }
	      Datepicker.document_ = document;
	      this.options = options ? options.clone() : new TheDatepicker.Options();
	      var duplicateError = 'There is already a datepicker present on ';
	      this.isContainerExternal_ = !!container;
	      if (!container) {
	        container = this.createContainer_();
	        if (input) {
	          input.parentNode.insertBefore(container, input.nextSibling);
	        }
	      } else {
	        if (container.datepicker) {
	          throw new Error(duplicateError + 'container.');
	        }
	      }
	      container.setAttribute('data-credits', 'TheDatepicker - Pure JavaScript Datepicker by Slevomat.cz');
	      container.setAttribute('data-url', 'https://thedatepicker.github.io/thedatepicker/');
	      if (input) {
	        if (input.datepicker) {
	          throw new Error(duplicateError + 'input.');
	        }
	        input.datepicker = this;
	        if (input && typeof HTMLInputElement !== 'undefined' && input instanceof HTMLInputElement) {
	          this.inputClickable_ = input;
	          if (input.type === 'text') {
	            this.inputText_ = input;
	            input.autocomplete = 'off';
	          }
	        }
	      }
	      container.datepicker = this;
	      this.input = input;
	      this.container = container;
	      this.viewModel_ = new TheDatepicker.ViewModel_(this.options, this);
	      this.triggerReady_(input);
	      this.triggerReady_(container);
	    }
	    Datepicker.prototype.render = function () {
	      var _this = this;
	      switch (this.initializationPhase_) {
	        case InitializationPhase.Ready:
	          this.initListeners_();
	          this.initializationPhase_ = InitializationPhase.Initialized;
	          this.render();
	          return;
	        case InitializationPhase.Waiting:
	          this.createDeselectElement_();
	          if (!this.options.isHiddenOnBlur()) {
	            this.open();
	            return;
	          }
	          if (!this.viewModel_.selectPossibleDate_()) {
	            this.updateInput_();
	          }
	          return;
	        case InitializationPhase.Untouched:
	          this.preselectFromInput_();
	          this.createDeselectElement_();
	          if (!this.viewModel_.selectInitialDate_(null)) {
	            this.updateInput_();
	          }
	          if (this.inputClickable_ && this.options.isHiddenOnBlur()) {
	            if (this.inputClickable_ === Datepicker.document_.activeElement) {
	              this.initializationPhase_ = InitializationPhase.Ready;
	              this.render();
	              this.open();
	              return;
	            }
	            this.inputListenerRemover_ = TheDatepicker.Helper_.addEventListener_(this.inputClickable_, TheDatepicker.ListenerType_.Focus, function (event) {
	              _this.open(event);
	            });
	            this.initializationPhase_ = InitializationPhase.Waiting;
	            return;
	          }
	          this.initializationPhase_ = InitializationPhase.Ready;
	          this.render();
	          return;
	        default:
	          this.viewModel_.render_();
	          return;
	      }
	    };
	    Datepicker.prototype.open = function (event) {
	      if (event === void 0) {
	        event = null;
	      }
	      if (this.initializationPhase_ === InitializationPhase.Untouched) {
	        this.render();
	      }
	      if (this.initializationPhase_ === InitializationPhase.Waiting) {
	        this.initializationPhase_ = InitializationPhase.Ready;
	        this.render();
	        Datepicker.hasClickedViewModel_ = true;
	      }
	      if (!Datepicker.activateViewModel_(event, this)) {
	        return false;
	      }
	      if (this.inputClickable_) {
	        this.inputClickable_.focus();
	      }
	      return true;
	    };
	    Datepicker.prototype.isOpened = function () {
	      return this.viewModel_.isActive_();
	    };
	    Datepicker.prototype.close = function (event) {
	      if (event === void 0) {
	        event = null;
	      }
	      if (!this.viewModel_.isActive_()) {
	        return true;
	      }
	      if (!Datepicker.activateViewModel_(event, null)) {
	        return false;
	      }
	      if (this.inputClickable_) {
	        this.inputClickable_.blur();
	      }
	      return true;
	    };
	    Datepicker.prototype.reset = function (event) {
	      if (event === void 0) {
	        event = null;
	      }
	      return this.viewModel_.reset_(event);
	    };
	    Datepicker.prototype.destroy = function () {
	      if (this.initializationPhase_ === InitializationPhase.Destroyed) {
	        return;
	      }
	      for (var index = 0; index < this.listenerRemovers_.length; index++) {
	        this.listenerRemovers_[index]();
	      }
	      this.listenerRemovers_ = [];
	      if (this.isContainerExternal_) {
	        this.container.innerHTML = '';
	      } else {
	        this.container.parentNode.removeChild(this.container);
	      }
	      delete this.container.datepicker;
	      if (this.input) {
	        if (this.inputText_) {
	          this.inputText_.autocomplete = '';
	          this.inputText_.readOnly = false;
	        }
	        delete this.input.datepicker;
	        this.removeInitialInputListener_();
	        this.input = null;
	      }
	      if (this.deselectElement_) {
	        this.deselectElement_.parentNode.removeChild(this.deselectElement_);
	        this.deselectElement_ = null;
	      }
	      this.initializationPhase_ = InitializationPhase.Destroyed;
	    };
	    Datepicker.prototype.isDestroyed = function () {
	      return this.initializationPhase_ === InitializationPhase.Destroyed;
	    };
	    Datepicker.prototype.selectDate = function (date, doUpdateMonth, event) {
	      if (doUpdateMonth === void 0) {
	        doUpdateMonth = true;
	      }
	      if (event === void 0) {
	        event = null;
	      }
	      return this.viewModel_.selectDay_(event, TheDatepicker.Helper_.normalizeDate_('Date', date, true, this.options), !!doUpdateMonth);
	    };
	    Datepicker.prototype.getSelectedDate = function () {
	      return this.viewModel_.selectedDate_ ? new Date(this.viewModel_.selectedDate_.getTime()) : null;
	    };
	    Datepicker.prototype.getSelectedDateFormatted = function (format) {
	      if (format === void 0) {
	        format = null;
	      }
	      return TheDatepicker.DateConverter_.formatDate_(this.viewModel_.selectedDate_, this.options, TheDatepicker.Helper_.checkString_('Format', format));
	    };
	    Datepicker.prototype.getCurrentMonth = function () {
	      return new Date(this.viewModel_.getCurrentMonth_().getTime());
	    };
	    Datepicker.prototype.goToMonth = function (month, event) {
	      if (event === void 0) {
	        event = null;
	      }
	      return this.viewModel_.goToMonth_(event, TheDatepicker.Helper_.normalizeDate_('Month', month, false, this.options));
	    };
	    Datepicker.prototype.parseRawInput = function () {
	      return this.inputText_ ? TheDatepicker.DateConverter_.parseDate_(this.inputText_.value, this.options) : null;
	    };
	    Datepicker.prototype.getDay = function (date) {
	      return this.viewModel_.createDay_(TheDatepicker.Helper_.normalizeDate_('Date', date, false, this.options));
	    };
	    Datepicker.prototype.canType_ = function (char) {
	      if (!this.inputText_ || this.options.isAllowedInputAnyChar()) {
	        return true;
	      }
	      return TheDatepicker.DateConverter_.isValidChar_(char, this.options);
	    };
	    Datepicker.prototype.readInput_ = function (event) {
	      if (event === void 0) {
	        event = null;
	      }
	      if (!this.inputText_) {
	        return false;
	      }
	      try {
	        var date = this.parseRawInput();
	        if (date ? this.viewModel_.selectNearestDate_(event, date) : this.viewModel_.cancelSelection_(event)) {
	          this.updateDeselectElement_();
	          return true;
	        }
	      } catch (error) {
	        if (!(error instanceof TheDatepicker.CannotParseDateException)) {
	          throw error;
	        }
	      }
	      return false;
	    };
	    Datepicker.prototype.updateInput_ = function () {
	      if (!this.inputText_ || this.inputText_ === Datepicker.document_.activeElement) {
	        return;
	      }
	      this.inputText_.value = TheDatepicker.DateConverter_.formatDate_(this.viewModel_.selectedDate_, this.options) || '';
	      this.updateDeselectElement_();
	    };
	    Datepicker.onDatepickerReady = function (element, callback) {
	      if (callback === void 0) {
	        callback = null;
	      }
	      if (!TheDatepicker.Helper_.isElement_(element)) {
	        throw new Error('Element was expected to be an HTMLElement.');
	      }
	      callback = TheDatepicker.Helper_.checkFunction_('Callback', callback);
	      var promise = null;
	      var promiseResolve = null;
	      if (typeof Promise !== 'undefined') {
	        promise = new Promise(function (resolve) {
	          promiseResolve = resolve;
	        });
	      }
	      if (element.datepicker && element.datepicker instanceof Datepicker) {
	        element.datepicker.triggerReadyListener_(callback, element);
	        if (promiseResolve) {
	          promiseResolve(element.datepicker);
	        }
	      } else {
	        Datepicker.readyListeners_.push({
	          promiseResolve: promiseResolve,
	          element: element,
	          callback: callback
	        });
	      }
	      return promise;
	    };
	    Datepicker.prototype.createContainer_ = function () {
	      return TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Container, this.options);
	    };
	    Datepicker.prototype.createDeselectElement_ = function () {
	      var _this = this;
	      if (!this.inputText_ || !this.options.isDeselectButtonShown() || this.deselectElement_) {
	        return null;
	      }
	      var deselectButton = TheDatepicker.HtmlHelper_.createAnchor_(function (event) {
	        deselectButton.focus();
	        _this.viewModel_.cancelSelection_(event);
	      }, this.options, TheDatepicker.ClassNameType.DeselectButton);
	      deselectButton.innerHTML = this.options.getDeselectHtml();
	      var title = this.options.translator.translateTitle(TheDatepicker.TitleName.Deselect);
	      if (title !== '') {
	        deselectButton.title = title;
	      }
	      var deselectElement = TheDatepicker.HtmlHelper_.createSpan_();
	      TheDatepicker.HtmlHelper_.addClass_(deselectElement, TheDatepicker.ClassNameType.Deselect, this.options);
	      deselectElement.appendChild(deselectButton);
	      this.inputText_.parentNode.insertBefore(deselectElement, this.inputText_.nextSibling);
	      this.deselectElement_ = deselectElement;
	      this.deselectButton_ = deselectButton;
	    };
	    Datepicker.prototype.updateDeselectElement_ = function () {
	      if (!this.deselectElement_) {
	        return;
	      }
	      var isVisible = this.options.isDeselectButtonShown() && this.viewModel_.selectedDate_;
	      this.deselectElement_.style.visibility = isVisible ? 'visible' : 'hidden';
	    };
	    Datepicker.prototype.preselectFromInput_ = function () {
	      if (this.inputText_) {
	        try {
	          var date = this.parseRawInput();
	          if (date) {
	            this.options.setInitialDate(date);
	          }
	        } catch (error) {
	          if (!(error instanceof TheDatepicker.CannotParseDateException)) {
	            throw error;
	          }
	        }
	      }
	    };
	    Datepicker.prototype.initListeners_ = function () {
	      var _this = this;
	      if (!Datepicker.areGlobalListenersInitialized_) {
	        var checkMiss = function (event) {
	          if (Datepicker.hasClickedViewModel_) {
	            Datepicker.hasClickedViewModel_ = false;
	          } else {
	            Datepicker.activateViewModel_(event, null);
	          }
	        };
	        TheDatepicker.Helper_.addEventListener_(Datepicker.document_, TheDatepicker.ListenerType_.MouseDown, checkMiss);
	        TheDatepicker.Helper_.addEventListener_(Datepicker.document_, TheDatepicker.ListenerType_.FocusIn, checkMiss);
	        TheDatepicker.Helper_.addEventListener_(Datepicker.document_, TheDatepicker.ListenerType_.KeyDown, function (event) {
	          if (Datepicker.activeViewModel_) {
	            Datepicker.activeViewModel_.triggerKeyPress_(event);
	          }
	        });
	        Datepicker.areGlobalListenersInitialized_ = true;
	      }
	      this.removeInitialInputListener_();
	      var hit = function (event) {
	        Datepicker.activateViewModel_(event, _this);
	        Datepicker.hasClickedViewModel_ = true;
	      };
	      this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.container, TheDatepicker.ListenerType_.MouseDown, hit));
	      this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.container, TheDatepicker.ListenerType_.FocusIn, hit));
	      if (this.deselectButton_) {
	        var hitIfActive = function (event) {
	          if (_this.viewModel_.isActive_()) {
	            hit(event);
	          }
	        };
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.deselectButton_, TheDatepicker.ListenerType_.MouseDown, hitIfActive));
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.deselectButton_, TheDatepicker.ListenerType_.Focus, hitIfActive));
	      }
	      if (this.inputClickable_) {
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.inputClickable_, TheDatepicker.ListenerType_.MouseDown, hit));
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.inputClickable_, TheDatepicker.ListenerType_.Focus, hit));
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.inputClickable_, TheDatepicker.ListenerType_.Blur, function () {
	          _this.updateInput_();
	        }));
	      }
	      if (this.inputText_) {
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.inputText_, TheDatepicker.ListenerType_.KeyDown, function (event) {
	          TheDatepicker.Helper_.stopPropagation_(event);
	          if (event.keyCode === TheDatepicker.KeyCode_.Esc && _this.options.isClosedOnEscPress()) {
	            _this.close(event);
	          }
	        }));
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.inputText_, TheDatepicker.ListenerType_.KeyUp, function (event) {
	          _this.readInput_(event);
	        }));
	        this.listenerRemovers_.push(TheDatepicker.Helper_.addEventListener_(this.inputText_, TheDatepicker.ListenerType_.KeyPress, function (event) {
	          var charCode = event.charCode || event.keyCode;
	          if (charCode && !_this.canType_(String.fromCharCode(charCode))) {
	            TheDatepicker.Helper_.preventDefault_(event);
	          }
	        }));
	      }
	    };
	    Datepicker.prototype.removeInitialInputListener_ = function () {
	      if (this.inputListenerRemover_) {
	        this.inputListenerRemover_();
	        this.inputListenerRemover_ = null;
	      }
	    };
	    Datepicker.prototype.triggerReady_ = function (element) {
	      for (var index = Datepicker.readyListeners_.length - 1; index >= 0; index--) {
	        var listener = Datepicker.readyListeners_[index];
	        if (listener.element === element) {
	          this.triggerReadyListener_(listener.callback, element);
	          if (listener.promiseResolve) {
	            listener.promiseResolve(this);
	          }
	          Datepicker.readyListeners_.splice(index, 1);
	        }
	      }
	    };
	    Datepicker.prototype.triggerReadyListener_ = function (callback, element) {
	      if (callback) {
	        callback.call(element, this, element);
	      }
	    };
	    Datepicker.prototype.onActivate_ = function () {
	      if (this.initializationPhase_ === InitializationPhase.Destroyed) {
	        return;
	      }
	      this.updateContainer_();
	      if (this.inputText_) {
	        this.inputText_.readOnly = !this.options.isKeyboardOnMobile() && TheDatepicker.Helper_.isMobile_();
	      }
	    };
	    Datepicker.prototype.updateContainer_ = function () {
	      if (this.isContainerExternal_) {
	        return;
	      }
	      this.container.className = '';
	      TheDatepicker.HtmlHelper_.addClass_(this.container, TheDatepicker.ClassNameType.Container, this.options);
	      if (this.options.isDarkModeEnabled()) {
	        TheDatepicker.HtmlHelper_.addClass_(this.container, TheDatepicker.ClassNameType.ContainerDarkMode, this.options);
	      }
	      if (this.options.isFullScreenOnMobile()) {
	        TheDatepicker.HtmlHelper_.addClass_(this.container, TheDatepicker.ClassNameType.ContainerResponsive, this.options);
	      }
	      if (this.container.childNodes.length === 0) {
	        return;
	      }
	      var position = this.options.getPosition();
	      var locateOver = position === TheDatepicker.Position.TopRight || position === TheDatepicker.Position.TopLeft;
	      var locateLeft = position === TheDatepicker.Position.BottomLeft || position === TheDatepicker.Position.TopLeft;
	      var mainElement = this.container.childNodes[0];
	      mainElement.style.position = '';
	      mainElement.style.top = '';
	      mainElement.style.left = '';
	      var inputWidth = this.input.offsetWidth;
	      var inputHeight = this.input.offsetHeight;
	      var containerWidth = this.container.offsetWidth;
	      var containerHeight = this.container.offsetHeight;
	      if (this.options.isPositionFixingEnabled()) {
	        var document_1 = Datepicker.document_;
	        var windowTop = window.scrollY || window.pageYOffset || document_1.documentElement.scrollTop || document_1.body.scrollTop || 0;
	        var windowLeft = window.scrollX || window.pageXOffset || document_1.documentElement.scrollLeft || document_1.body.scrollLeft || 0;
	        var isCompactMode = document_1.compatMode === 'CSS1Compat';
	        var windowHeight = window.innerHeight || (isCompactMode ? document_1.documentElement.clientHeight : document_1.body.clientHeight) || 0;
	        var windowWidth = window.innerWidth || (isCompactMode ? document_1.documentElement.clientWidth : document_1.body.clientWidth) || 0;
	        var windowBottom = windowTop + windowHeight;
	        var windowRight = windowLeft + windowWidth;
	        var rect = this.input.getBoundingClientRect();
	        var inputTop = rect.top + windowTop;
	        var inputLeft = rect.left + windowLeft;
	        var inputBottom = inputTop + inputHeight;
	        var inputRight = inputLeft + inputWidth;
	        var fitsTop = inputTop - windowTop > containerHeight;
	        var fitsBottom = windowBottom - inputBottom > containerHeight;
	        var fitsLeft = inputLeft - windowLeft > containerWidth - inputWidth;
	        var fitsRight = windowRight - inputRight > containerWidth - inputWidth;
	        locateOver = locateOver && (fitsTop || !fitsBottom) || fitsTop && !fitsBottom;
	        locateLeft = locateLeft && (fitsLeft || !fitsRight) || fitsLeft && !fitsRight;
	      }
	      mainElement.style.position = locateOver || locateLeft ? 'absolute' : '';
	      if (locateOver) {
	        TheDatepicker.HtmlHelper_.addClass_(this.container, TheDatepicker.ClassNameType.ContainerOver, this.options);
	        mainElement.style.top = '-' + (inputHeight + containerHeight) + 'px';
	      }
	      if (locateLeft) {
	        TheDatepicker.HtmlHelper_.addClass_(this.container, TheDatepicker.ClassNameType.ContainerLeft, this.options);
	        mainElement.style.left = '-' + (containerWidth - inputWidth) + 'px';
	      }
	    };
	    Datepicker.setBodyClass_ = function (enable) {
	      var pageClass = 'the-datepicker-page';
	      var body = Datepicker.document_.body;
	      var className = body.className;
	      var hasClass = className.indexOf(pageClass) > -1;
	      if (!hasClass && enable) {
	        body.className += (className.length > 0 ? ' ' : '') + pageClass;
	      } else if (hasClass && !enable) {
	        var search = pageClass;
	        if (className.indexOf(' ' + pageClass) > -1) {
	          search = ' ' + pageClass;
	        } else if (className.indexOf(pageClass + ' ') > -1) {
	          search = pageClass + ' ';
	        }
	        body.className = className.replace(search, '');
	      }
	    };
	    Datepicker.activateViewModel_ = function (event, datepicker) {
	      var viewModel = datepicker ? datepicker.viewModel_ : null;
	      var activeViewModel = Datepicker.activeViewModel_;
	      if (activeViewModel === viewModel) {
	        return true;
	      }
	      if (activeViewModel && !activeViewModel.setActive_(event, false)) {
	        return false;
	      }
	      if (Datepicker.activeViewModel_ !== activeViewModel) {
	        return true;
	      }
	      if (!viewModel) {
	        Datepicker.setBodyClass_(false);
	        Datepicker.activeViewModel_ = null;
	        return true;
	      }
	      if (!viewModel.setActive_(event, true)) {
	        return false;
	      }
	      if (Datepicker.activeViewModel_ !== activeViewModel) {
	        return true;
	      }
	      datepicker.onActivate_();
	      Datepicker.setBodyClass_(!datepicker.isContainerExternal_ && datepicker.options.isFullScreenOnMobile());
	      Datepicker.activeViewModel_ = viewModel;
	      return true;
	    };
	    Datepicker.readyListeners_ = [];
	    Datepicker.areGlobalListenersInitialized_ = false;
	    Datepicker.activeViewModel_ = null;
	    Datepicker.hasClickedViewModel_ = false;
	    return Datepicker;
	  }();
	  TheDatepicker.Datepicker = Datepicker;
	  TheDatepicker.onDatepickerReady = Datepicker.onDatepickerReady;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  var Day = function () {
	    function Day(date, createDay, formatDate) {
	      this.isToday = false;
	      this.isPast = false;
	      this.isAvailable = true;
	      this.isInValidity = true;
	      this.isVisible = false;
	      this.isInCurrentMonth = false;
	      this.isSelected = false;
	      this.isHighlighted = false;
	      this.isFocused = false;
	      this.dayNumber = date.getDate();
	      this.month = date.getMonth() + 1;
	      this.year = date.getFullYear();
	      this.dayOfWeek = date.getDay();
	      this.isWeekend = this.dayOfWeek === TheDatepicker.DayOfWeek.Saturday || this.dayOfWeek === TheDatepicker.DayOfWeek.Sunday;
	      this.createDay_ = createDay;
	      this.formatDate_ = formatDate;
	    }
	    Day.prototype.getDate = function () {
	      return new Date(this.year, this.month - 1, this.dayNumber, 0, 0, 0, 0);
	    };
	    Day.prototype.getFormatted = function () {
	      return this.year + '-' + ('0' + this.month).slice(-2) + '-' + ('0' + this.dayNumber).slice(-2);
	    };
	    Day.prototype.getInputFormatted = function (format) {
	      if (format === void 0) {
	        format = null;
	      }
	      return this.formatDate_(this.getDate(), TheDatepicker.Helper_.checkString_('Format', format));
	    };
	    Day.prototype.isEqualToDate = function (date) {
	      return TheDatepicker.Helper_.isValidDate_(date) && this.dayNumber === date.getDate() && this.month === date.getMonth() + 1 && this.year === date.getFullYear();
	    };
	    Day.prototype.isEqualToDay = function (day) {
	      return day instanceof Day && this.dayNumber === day.dayNumber && this.month === day.month && this.year === day.year;
	    };
	    Day.prototype.getSibling = function (shift) {
	      if (shift === void 0) {
	        shift = 1;
	      }
	      var date = this.getDate();
	      date.setDate(date.getDate() + TheDatepicker.Helper_.checkNumber_('Shift', shift));
	      return this.createDay_(date);
	    };
	    return Day;
	  }();
	  TheDatepicker.Day = Day;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  (function (DayOfWeek) {
	    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
	    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
	    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
	    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
	    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
	    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
	    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
	  })(TheDatepicker.DayOfWeek || (TheDatepicker.DayOfWeek = {}));
	  (function (Month) {
	    Month[Month["January"] = 0] = "January";
	    Month[Month["February"] = 1] = "February";
	    Month[Month["March"] = 2] = "March";
	    Month[Month["April"] = 3] = "April";
	    Month[Month["May"] = 4] = "May";
	    Month[Month["June"] = 5] = "June";
	    Month[Month["July"] = 6] = "July";
	    Month[Month["August"] = 7] = "August";
	    Month[Month["September"] = 8] = "September";
	    Month[Month["October"] = 9] = "October";
	    Month[Month["November"] = 10] = "November";
	    Month[Month["December"] = 11] = "December";
	  })(TheDatepicker.Month || (TheDatepicker.Month = {}));
	  (function (Align) {
	    Align[Align["Left"] = 1] = "Left";
	    Align[Align["Right"] = 2] = "Right";
	    Align[Align["Center"] = 3] = "Center";
	  })(TheDatepicker.Align || (TheDatepicker.Align = {}));
	  (function (Position) {
	    Position[Position["BottomRight"] = 1] = "BottomRight";
	    Position[Position["BottomLeft"] = 2] = "BottomLeft";
	    Position[Position["TopRight"] = 3] = "TopRight";
	    Position[Position["TopLeft"] = 4] = "TopLeft";
	  })(TheDatepicker.Position || (TheDatepicker.Position = {}));
	  (function (KeyCode_) {
	    KeyCode_[KeyCode_["Enter"] = 13] = "Enter";
	    KeyCode_[KeyCode_["Space"] = 32] = "Space";
	    KeyCode_[KeyCode_["Left"] = 37] = "Left";
	    KeyCode_[KeyCode_["Up"] = 38] = "Up";
	    KeyCode_[KeyCode_["Right"] = 39] = "Right";
	    KeyCode_[KeyCode_["Down"] = 40] = "Down";
	    KeyCode_[KeyCode_["Esc"] = 27] = "Esc";
	  })(TheDatepicker.KeyCode_ || (TheDatepicker.KeyCode_ = {}));
	  var ListenerType_;
	  (function (ListenerType_) {
	    ListenerType_["MouseDown"] = "mousedown";
	    ListenerType_["Focus"] = "focus";
	    ListenerType_["FocusIn"] = "focusin";
	    ListenerType_["Blur"] = "blur";
	    ListenerType_["KeyDown"] = "keydown";
	    ListenerType_["KeyUp"] = "keyup";
	    ListenerType_["KeyPress"] = "keypress";
	    ListenerType_["TouchStart"] = "touchstart";
	    ListenerType_["TouchMove"] = "touchmove";
	    ListenerType_["AnimationEnd"] = "animationend";
	  })(ListenerType_ = TheDatepicker.ListenerType_ || (TheDatepicker.ListenerType_ = {}));
	  var Helper_ = function () {
	    function Helper_() {}
	    Helper_.resetTime_ = function (date) {
	      if (!date) {
	        return null;
	      }
	      date.setHours(0);
	      date.setMinutes(0);
	      date.setSeconds(0);
	      date.setMilliseconds(0);
	      return date;
	    };
	    Helper_.normalizeDate_ = function (parameterName, value, isNullable, options) {
	      if (!value) {
	        if (!isNullable) {
	          throw new Error(parameterName + ' cannot be empty.');
	        }
	        return null;
	      }
	      if (value instanceof TheDatepicker.Day) {
	        return value.getDate();
	      }
	      if (typeof value === 'string') {
	        value = value.trim ? value.trim() : value;
	        if (value === 'today' || value === 'now') {
	          return options.getToday();
	        }
	        if (value === 'tomorrow') {
	          var date_1 = options.getToday();
	          date_1.setDate(date_1.getDate() + 1);
	          return date_1;
	        }
	        if (value === 'yesterday') {
	          var date_2 = options.getToday();
	          date_2.setDate(date_2.getDate() - 1);
	          return date_2;
	        }
	        var date = options.getToday();
	        var parsedValue = value;
	        var matches = value.match(new RegExp('^\\s*([0-9]+)\.?\\s*(' + Helper_.months_.join('|') + ')\\s*', 'i'));
	        if (matches) {
	          var day = parseInt(matches[1], 10);
	          var month = void 0;
	          for (month = 0; month < Helper_.months_.length; month++) {
	            if (matches[2].toLowerCase() === Helper_.months_[month]) {
	              date.setMonth(month);
	              date.setDate(day);
	              break;
	            }
	          }
	          parsedValue = parsedValue.substring(matches[0].length);
	        }
	        var sumPositive = true;
	        while (parsedValue) {
	          var matches_1 = parsedValue.match(/^\s*([+-]?)\s*([0-9]+)\s*(day|week|month|year)s?\s*/i);
	          if (!matches_1) {
	            break;
	          }
	          switch (matches_1[1]) {
	            case '+':
	              sumPositive = true;
	              break;
	            case '-':
	              sumPositive = false;
	          }
	          var amount = parseInt(matches_1[2], 10) * (sumPositive ? 1 : -1);
	          switch (matches_1[3].toLowerCase()) {
	            case 'day':
	            case 'days':
	              date.setDate(date.getDate() + amount);
	              break;
	            case 'week':
	            case 'weeks':
	              date.setDate(date.getDate() + amount * 7);
	              break;
	            case 'month':
	            case 'months':
	              date.setMonth(date.getMonth() + amount);
	              break;
	            case 'year':
	            case 'years':
	              date.setFullYear(date.getFullYear() + amount);
	          }
	          parsedValue = parsedValue.substring(matches_1[0].length);
	          if (!parsedValue) {
	            return date;
	          }
	        }
	        date = Helper_.resetTime_(new Date(value));
	        if (!isNaN(date.getTime())) {
	          return date;
	        }
	      } else if (Helper_.isValidDate_(value)) {
	        var date = Helper_.resetTime_(new Date(value.getTime()));
	        if (!isNaN(date.getTime())) {
	          return date;
	        }
	      }
	      throw new Error(parameterName + ' was expected to be a valid Date string or valid Date or TheDatepicker.Day' + (isNullable ? ' or null.' : '.'));
	    };
	    Helper_.isElement_ = function (element) {
	      return typeof element === 'object' && element.nodeType === 1 && typeof element.style === 'object' && typeof element.ownerDocument === 'object';
	    };
	    Helper_.isValidDate_ = function (value) {
	      return typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value.getTime());
	    };
	    Helper_.inArray_ = function (list, item) {
	      for (var index = 0; index < list.length; index++) {
	        if (list[index] === item) {
	          return true;
	        }
	      }
	      return false;
	    };
	    Helper_.addEventListener_ = function (element, listenerType, listener, isPassive) {
	      if (isPassive === void 0) {
	        isPassive = false;
	      }
	      if (element.addEventListener) {
	        var options = void 0;
	        if (isPassive && Helper_.isPassiveEventListenerSupported_()) {
	          options = {
	            passive: true
	          };
	        }
	        element.addEventListener(listenerType, listener, options);
	        return function () {
	          element.removeEventListener(listenerType, listener);
	        };
	      }
	      var listenerProperty = 'on' + listenerType;
	      var originalListener = element[listenerProperty] || null;
	      element[listenerProperty] = function (event) {
	        event = event || window.event;
	        if (originalListener) {
	          originalListener.call(element, event);
	        }
	        listener(event);
	      };
	      return function () {
	        element[listenerProperty] = originalListener;
	      };
	    };
	    Helper_.preventDefault_ = function (event) {
	      if (event.preventDefault) {
	        event.preventDefault();
	      } else {
	        event.returnValue = false;
	      }
	    };
	    Helper_.stopPropagation_ = function (event) {
	      if (event.stopPropagation) {
	        event.stopPropagation();
	      } else {
	        event.cancelBubble = true;
	      }
	    };
	    Helper_.checkString_ = function (parameterName, value, checkNonEmpty) {
	      if (checkNonEmpty === void 0) {
	        checkNonEmpty = false;
	      }
	      if (!checkNonEmpty && !value) {
	        return '';
	      }
	      if (typeof value !== 'string' || checkNonEmpty && value === '') {
	        throw new Error(parameterName + ' was expected to be a' + (checkNonEmpty ? ' non empty' : '') + ' string.');
	      }
	      return value;
	    };
	    Helper_.checkNumber_ = function (parameterName, value, min, max) {
	      if (min === void 0) {
	        min = null;
	      }
	      if (max === void 0) {
	        max = null;
	      }
	      value = typeof value === 'string' ? parseInt(value, 10) : value;
	      if (typeof value !== 'number' || isNaN(value) || min !== null && value < min || max !== null && value > max) {
	        throw new Error(parameterName + ' was expected to be a valid number' + (min !== null ? ' from ' + min : '') + (max !== null ? ' to ' + max : '') + '.');
	      }
	      return value;
	    };
	    Helper_.checkFunction_ = function (parameterName, value, isNullable) {
	      if (isNullable === void 0) {
	        isNullable = true;
	      }
	      if (isNullable && !value) {
	        return null;
	      }
	      if (typeof value !== 'function') {
	        throw new Error(parameterName + ' was expected to be a function' + (isNullable ? ' or null' : '') + '.');
	      }
	      return value;
	    };
	    Helper_.warnDeprecatedUsage_ = function (deprecatedMethod, alternateMethods) {
	      if (!window.console) {
	        return;
	      }
	      for (var index = 0; index < Helper_.deprecatedMethods_.length; index++) {
	        if (deprecatedMethod === Helper_.deprecatedMethods_[0]) {
	          return;
	        }
	      }
	      // window.console.warn('TheDatepicker: ' + deprecatedMethod + ' is deprecated, use ' + alternateMethods.join(' or '));
	      Helper_.deprecatedMethods_.push(deprecatedMethod);
	    };
	    Helper_.addSwipeListener_ = function (element, listener) {
	      var startPosition = null;
	      var minDistance;
	      Helper_.addEventListener_(element, ListenerType_.TouchStart, function (event) {
	        startPosition = {
	          x: event.touches[0].clientX,
	          y: event.touches[0].clientY
	        };
	        minDistance = {
	          x: element.offsetWidth / 5,
	          y: element.offsetHeight / 5
	        };
	      }, true);
	      Helper_.addEventListener_(element, ListenerType_.TouchMove, function (event) {
	        if (!startPosition) {
	          return;
	        }
	        var diffX = event.touches[0].clientX - startPosition.x;
	        var diffY = event.touches[0].clientY - startPosition.y;
	        var moveDirection = null;
	        if (Math.abs(diffX) > minDistance.x) {
	          moveDirection = diffX > 0 ? TheDatepicker.MoveDirection_.Right : TheDatepicker.MoveDirection_.Left;
	        } else if (Math.abs(diffY) > minDistance.x) {
	          moveDirection = diffY > 0 ? TheDatepicker.MoveDirection_.Down : TheDatepicker.MoveDirection_.Up;
	        }
	        if (moveDirection) {
	          listener(event, moveDirection);
	          startPosition = null;
	        }
	      }, true);
	    };
	    Helper_.isCssAnimationSupported_ = function () {
	      if (Helper_.cssAnimationSupport_ === null) {
	        var fakeElement = document.createElement('div');
	        Helper_.cssAnimationSupport_ = fakeElement.style.animationName === '';
	      }
	      return Helper_.cssAnimationSupport_;
	    };
	    Helper_.isPassiveEventListenerSupported_ = function () {
	      if (Helper_.passiveEventListenerSupport_ === null) {
	        var isSupported_1 = false;
	        try {
	          var options = Object.defineProperty({}, 'passive', {
	            get: function () {
	              isSupported_1 = true;
	              return false;
	            }
	          });
	          window.addEventListener('test', null, options);
	          window.removeEventListener('test', null, options);
	        } catch (error) {}
	        Helper_.passiveEventListenerSupport_ = isSupported_1;
	      }
	      return Helper_.passiveEventListenerSupport_;
	    };
	    Helper_.isMobile_ = function () {
	      var matchMedia = window.matchMedia || window.msMatchMedia;
	      var mediaQuery = 'only all and (max-width: 37.5em)';
	      if (!matchMedia) {
	        return false;
	      }
	      var result = matchMedia(mediaQuery);
	      if (!result) {
	        return false;
	      }
	      return !!result.matches;
	    };
	    Helper_.months_ = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
	    Helper_.deprecatedMethods_ = [];
	    Helper_.cssAnimationSupport_ = null;
	    Helper_.passiveEventListenerSupport_ = null;
	    return Helper_;
	  }();
	  TheDatepicker.Helper_ = Helper_;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  var HtmlHelper_ = function () {
	    function HtmlHelper_() {}
	    HtmlHelper_.createDiv_ = function (type, options) {
	      var div = document.createElement('div');
	      HtmlHelper_.addClass_(div, type, options);
	      return div;
	    };
	    HtmlHelper_.createAnchor_ = function (onClick, options, type) {
	      if (type === void 0) {
	        type = TheDatepicker.ClassNameType.Button;
	      }
	      var anchor = document.createElement('a');
	      HtmlHelper_.addClass_(anchor, type, options);
	      anchor.href = '#';
	      anchor.onclick = function (event) {
	        event = event || window.event;
	        TheDatepicker.Helper_.preventDefault_(event);
	        onClick(event);
	      };
	      anchor.onkeydown = function (event) {
	        event = event || window.event;
	        if (TheDatepicker.Helper_.inArray_([TheDatepicker.KeyCode_.Enter, TheDatepicker.KeyCode_.Space], event.keyCode)) {
	          TheDatepicker.Helper_.preventDefault_(event);
	          onClick(event);
	        }
	      };
	      return anchor;
	    };
	    HtmlHelper_.createSpan_ = function () {
	      return document.createElement('span');
	    };
	    HtmlHelper_.createTable_ = function (header, body, type, options) {
	      var table = document.createElement('table');
	      HtmlHelper_.addClass_(table, type, options);
	      if (header) {
	        table.appendChild(header);
	      }
	      table.appendChild(body);
	      return table;
	    };
	    HtmlHelper_.createTableHeader_ = function (cells, type, options) {
	      var tableHeader = document.createElement('thead');
	      HtmlHelper_.addClass_(tableHeader, type, options);
	      var row = document.createElement('tr');
	      for (var index = 0; index < cells.length; index++) {
	        row.appendChild(cells[index]);
	      }
	      tableHeader.appendChild(row);
	      return tableHeader;
	    };
	    HtmlHelper_.createTableHeaderCell_ = function (type, options) {
	      var cell = document.createElement('th');
	      cell.scope = 'col';
	      HtmlHelper_.addClass_(cell, type, options);
	      return cell;
	    };
	    HtmlHelper_.createTableBody_ = function (rows, type, options) {
	      var tableBody = document.createElement('tbody');
	      HtmlHelper_.addClass_(tableBody, type, options);
	      for (var index = 0; index < rows.length; index++) {
	        tableBody.appendChild(rows[index]);
	      }
	      return tableBody;
	    };
	    HtmlHelper_.createTableRow_ = function (cells, options) {
	      var row = document.createElement('tr');
	      HtmlHelper_.addClass_(row, TheDatepicker.ClassNameType.TableRow, options);
	      for (var index = 0; index < cells.length; index++) {
	        row.appendChild(cells[index]);
	      }
	      return row;
	    };
	    HtmlHelper_.createTableCell_ = function () {
	      return document.createElement('td');
	    };
	    HtmlHelper_.createSelectInput_ = function (selectOptions, onChange, options) {
	      var input = document.createElement('select');
	      HtmlHelper_.addClass_(input, TheDatepicker.ClassNameType.SelectInput, options);
	      for (var index = 0; index < selectOptions.length; index++) {
	        input.appendChild(HtmlHelper_.createSelectOption_(selectOptions[index].value, selectOptions[index].label));
	      }
	      input.onchange = function (event) {
	        onChange(event || window.event, input.value);
	      };
	      input.onkeydown = function (event) {
	        event = event || window.event;
	        TheDatepicker.Helper_.stopPropagation_(event);
	      };
	      return input;
	    };
	    HtmlHelper_.createSelectOption_ = function (value, label) {
	      var option = document.createElement('option');
	      option.value = value;
	      option.innerText = label;
	      return option;
	    };
	    HtmlHelper_.addClass_ = function (element, type, options) {
	      var classNames = options.classNames.getClassName(type);
	      if (!classNames.length) {
	        return;
	      }
	      for (var index = 0; index < classNames.length; index++) {
	        classNames[index] = options.prefixClass_(classNames[index]);
	      }
	      element.className += (element.className ? ' ' : '') + classNames.join(' ');
	    };
	    HtmlHelper_.appendChild_ = function (element, child) {
	      if (child) {
	        element.appendChild(child);
	      }
	    };
	    return HtmlHelper_;
	  }();
	  TheDatepicker.HtmlHelper_ = HtmlHelper_;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  var EventType_;
	  (function (EventType_) {
	    EventType_["BeforeSelect"] = "beforeSelect";
	    EventType_["Select"] = "select";
	    EventType_["BeforeOpen"] = "beforeOpen";
	    EventType_["Open"] = "open";
	    EventType_["BeforeClose"] = "beforeClose";
	    EventType_["Close"] = "close";
	    EventType_["BeforeMonthChange"] = "beforeMonthChange";
	    EventType_["MonthChange"] = "monthChange";
	    EventType_["Focus"] = "focus";
	    EventType_["BeforeFocus"] = "beforeFocus";
	  })(EventType_ = TheDatepicker.EventType_ || (TheDatepicker.EventType_ = {}));
	  var AvailableDateNotFoundException = function () {
	    function AvailableDateNotFoundException() {}
	    return AvailableDateNotFoundException;
	  }();
	  TheDatepicker.AvailableDateNotFoundException = AvailableDateNotFoundException;
	  var Options = function () {
	    function Options(translator, classNames) {
	      if (translator === void 0) {
	        translator = null;
	      }
	      if (classNames === void 0) {
	        classNames = null;
	      }
	      this.hideOnBlur_ = true;
	      this.hideOnSelect_ = true;
	      this.minDate_ = null;
	      this.maxDate_ = null;
	      this.initialDate_ = null;
	      this.initialMonth_ = null;
	      this.initialDatePriority_ = true;
	      this.firstDayOfWeek_ = TheDatepicker.DayOfWeek.Monday;
	      this.dateAvailabilityResolvers_ = [];
	      this.cellContentResolver_ = null;
	      this.cellContentStructureResolver_ = null;
	      this.headerStructureResolver_ = null;
	      this.footerStructureResolver_ = null;
	      this.cellClassesResolvers_ = [];
	      this.dayModifiers_ = [];
	      this.inputFormat_ = 'j. n. Y';
	      this.allowInputAnyChar_ = false;
	      this.daysOutOfMonthVisible_ = false;
	      this.fixedRowsCount_ = false;
	      this.toggleSelection_ = false;
	      this.allowEmpty_ = true;
	      this.showDeselectButton_ = true;
	      this.showResetButton_ = false;
	      this.monthAsDropdown_ = true;
	      this.yearAsDropdown_ = true;
	      this.bindSelectedDateWithMonth_ = false;
	      this.yearSelectedFromTableOfYears_ = true;
	      this.tableOfYearsRowsCount_ = 6;
	      this.tableOfYearsAlign_ = null;
	      this.tableOfYearsOnSwipeDown_ = true;
	      this.yearsOutOfTableOfYearsVisible_ = true;
	      this.monthAndYearSeparated_ = true;
	      this.monthShort_ = false;
	      this.changeMonthOnSwipe_ = true;
	      this.slideAnimation_ = true;
	      this.classesPrefix_ = 'the-datepicker__';
	      this.darkMode_ = false;
	      this.showCloseButton_ = true;
	      this.closeOnEscPress_ = true;
	      this.title_ = '';
	      this.dropdownItemsLimit_ = 200;
	      this.hideDropdownWithOneItem_ = true;
	      this.goBackHtml_ = '&lt;';
	      this.goForwardHtml_ = '&gt;';
	      this.closeHtml_ = '&times;';
	      this.resetHtml_ = '&olarr;';
	      this.deselectHtml_ = '&times;';
	      this.position_ = TheDatepicker.Position.BottomRight;
	      this.positionFixing_ = true;
	      this.fullScreenOnMobile_ = true;
	      this.keyboardOnMobile_ = false;
	      this.includeAria_ = true;
	      this.today_ = null;
	      this.listeners_ = {
	        beforeSelect: [],
	        select: [],
	        beforeOpen: [],
	        open: [],
	        beforeClose: [],
	        close: [],
	        beforeMonthChange: [],
	        monthChange: [],
	        beforeFocus: [],
	        focus: []
	      };
	      this.translator = translator || new TheDatepicker.Translator();
	      this.classNames = classNames || new TheDatepicker.ClassNames();
	    }
	    Options.prototype.clone = function () {
	      var options = new Options(this.translator.clone(), this.classNames.clone());
	      options.hideOnBlur_ = this.hideOnBlur_;
	      options.hideOnSelect_ = this.hideOnSelect_;
	      options.minDate_ = this.minDate_;
	      options.maxDate_ = this.maxDate_;
	      options.initialDate_ = this.initialDate_;
	      options.initialMonth_ = this.initialMonth_;
	      options.initialDatePriority_ = this.initialDatePriority_;
	      options.firstDayOfWeek_ = this.firstDayOfWeek_;
	      options.dateAvailabilityResolvers_ = this.dateAvailabilityResolvers_.slice(0);
	      options.cellContentResolver_ = this.cellContentResolver_;
	      options.cellContentStructureResolver_ = this.cellContentStructureResolver_;
	      options.headerStructureResolver_ = this.headerStructureResolver_;
	      options.footerStructureResolver_ = this.footerStructureResolver_;
	      options.cellClassesResolvers_ = this.cellClassesResolvers_.slice(0);
	      options.dayModifiers_ = this.dayModifiers_.slice(0);
	      options.inputFormat_ = this.inputFormat_;
	      options.allowInputAnyChar_ = this.allowInputAnyChar_;
	      options.daysOutOfMonthVisible_ = this.daysOutOfMonthVisible_;
	      options.fixedRowsCount_ = this.fixedRowsCount_;
	      options.toggleSelection_ = this.toggleSelection_;
	      options.allowEmpty_ = this.allowEmpty_;
	      options.showDeselectButton_ = this.showDeselectButton_;
	      options.showResetButton_ = this.showResetButton_;
	      options.monthAsDropdown_ = this.monthAsDropdown_;
	      options.yearAsDropdown_ = this.yearAsDropdown_;
	      options.bindSelectedDateWithMonth_ = this.bindSelectedDateWithMonth_;
	      options.yearSelectedFromTableOfYears_ = this.yearSelectedFromTableOfYears_;
	      options.tableOfYearsRowsCount_ = this.tableOfYearsRowsCount_;
	      options.tableOfYearsAlign_ = this.tableOfYearsAlign_;
	      options.tableOfYearsOnSwipeDown_ = this.tableOfYearsOnSwipeDown_;
	      options.monthAndYearSeparated_ = this.monthAndYearSeparated_;
	      options.monthShort_ = this.monthShort_;
	      options.changeMonthOnSwipe_ = this.changeMonthOnSwipe_;
	      options.slideAnimation_ = this.slideAnimation_;
	      options.classesPrefix_ = this.classesPrefix_;
	      options.darkMode_ = this.darkMode_;
	      options.showCloseButton_ = this.showCloseButton_;
	      options.closeOnEscPress_ = this.closeOnEscPress_;
	      options.title_ = this.title_;
	      options.dropdownItemsLimit_ = this.dropdownItemsLimit_;
	      options.hideDropdownWithOneItem_ = this.hideDropdownWithOneItem_;
	      options.goBackHtml_ = this.goBackHtml_;
	      options.goForwardHtml_ = this.goForwardHtml_;
	      options.closeHtml_ = this.closeHtml_;
	      options.resetHtml_ = this.resetHtml_;
	      options.deselectHtml_ = this.deselectHtml_;
	      options.position_ = this.position_;
	      options.positionFixing_ = this.positionFixing_;
	      options.fullScreenOnMobile_ = this.fullScreenOnMobile_;
	      options.keyboardOnMobile_ = this.keyboardOnMobile_;
	      options.includeAria_ = this.includeAria_;
	      options.listeners_.beforeSelect = this.listeners_.beforeSelect.slice(0);
	      options.listeners_.select = this.listeners_.select.slice(0);
	      options.listeners_.beforeOpen = this.listeners_.beforeOpen.slice(0);
	      options.listeners_.open = this.listeners_.open.slice(0);
	      options.listeners_.beforeClose = this.listeners_.beforeClose.slice(0);
	      options.listeners_.close = this.listeners_.close.slice(0);
	      options.listeners_.beforeMonthChange = this.listeners_.beforeMonthChange.slice(0);
	      options.listeners_.monthChange = this.listeners_.monthChange.slice(0);
	      options.listeners_.beforeFocus = this.listeners_.beforeFocus.slice(0);
	      options.listeners_.focus = this.listeners_.focus.slice(0);
	      return options;
	    };
	    Options.prototype.setHideOnBlur = function (value) {
	      this.hideOnBlur_ = !!value;
	    };
	    Options.prototype.setHideOnSelect = function (value) {
	      this.hideOnSelect_ = !!value;
	    };
	    Options.prototype.setMinDate = function (date) {
	      var normalizedDate = TheDatepicker.Helper_.normalizeDate_('Min date', date, true, this);
	      this.checkConstraints_(normalizedDate, this.maxDate_);
	      this.minDate_ = normalizedDate;
	    };
	    Options.prototype.setMaxDate = function (date) {
	      var normalizedDate = TheDatepicker.Helper_.normalizeDate_('Max date', date, true, this);
	      this.checkConstraints_(this.minDate_, normalizedDate);
	      this.maxDate_ = normalizedDate;
	    };
	    Options.prototype.setInitialMonth = function (month) {
	      this.initialMonth_ = TheDatepicker.Helper_.normalizeDate_('Initial month', month, true, this);
	    };
	    Options.prototype.setInitialDate = function (value) {
	      this.initialDate_ = TheDatepicker.Helper_.normalizeDate_('Initial date', value, true, this);
	    };
	    Options.prototype.setInitialDatePriority = function (value) {
	      this.initialDatePriority_ = !!value;
	    };
	    Options.prototype.setFirstDayOfWeek = function (dayOfWeek) {
	      this.firstDayOfWeek_ = TheDatepicker.Helper_.checkNumber_('First day of week', dayOfWeek, 0, 6);
	    };
	    Options.prototype.setDateAvailabilityResolver = function (resolver) {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('setDateAvailabilityResolver', ['addDateAvailabilityResolver']);
	      this.removeDateAvailabilityResolver();
	      if (resolver) {
	        this.addDateAvailabilityResolver(resolver);
	      }
	    };
	    Options.prototype.addDateAvailabilityResolver = function (resolver) {
	      this.dateAvailabilityResolvers_.push(TheDatepicker.Helper_.checkFunction_('Resolver', resolver, false));
	    };
	    Options.prototype.removeDateAvailabilityResolver = function (resolver) {
	      if (resolver === void 0) {
	        resolver = null;
	      }
	      this.removeCallback_(this.dateAvailabilityResolvers_, 'Resolver', resolver);
	    };
	    Options.prototype.setCellContentResolver = function (resolver) {
	      this.cellContentResolver_ = TheDatepicker.Helper_.checkFunction_('Resolver', resolver);
	    };
	    Options.prototype.setCellContentStructureResolver = function (init, update) {
	      if (update === void 0) {
	        update = null;
	      }
	      init = TheDatepicker.Helper_.checkFunction_('Resolver (init)', init);
	      update = TheDatepicker.Helper_.checkFunction_('Resolver (update)', update);
	      this.cellContentStructureResolver_ = init ? {
	        init: init,
	        update: update
	      } : null;
	    };
	    Options.prototype.setHeaderStructureResolver = function (resolver) {
	      this.headerStructureResolver_ = TheDatepicker.Helper_.checkFunction_('Resolver', resolver);
	    };
	    Options.prototype.setFooterStructureResolver = function (resolver) {
	      this.footerStructureResolver_ = TheDatepicker.Helper_.checkFunction_('Resolver', resolver);
	    };
	    Options.prototype.addCellClassesResolver = function (resolver) {
	      this.cellClassesResolvers_.push(TheDatepicker.Helper_.checkFunction_('Resolver', resolver, false));
	    };
	    Options.prototype.removeCellClassesResolver = function (resolver) {
	      if (resolver === void 0) {
	        resolver = null;
	      }
	      this.removeCallback_(this.cellClassesResolvers_, 'Resolver', resolver);
	    };
	    Options.prototype.addDayModifier = function (modifier) {
	      this.dayModifiers_.push(TheDatepicker.Helper_.checkFunction_('Modifier', modifier, false));
	    };
	    Options.prototype.removeDayModifier = function (modifier) {
	      if (modifier === void 0) {
	        modifier = null;
	      }
	      this.removeCallback_(this.dayModifiers_, 'Modifier', modifier);
	    };
	    Options.prototype.setInputFormat = function (format) {
	      this.inputFormat_ = TheDatepicker.Helper_.checkString_('Input format', format, true);
	    };
	    Options.prototype.setAllowInputAnyChar = function (value) {
	      this.allowInputAnyChar_ = !!value;
	    };
	    Options.prototype.setDaysOutOfMonthVisible = function (value) {
	      this.daysOutOfMonthVisible_ = !!value;
	    };
	    Options.prototype.setFixedRowsCount = function (value) {
	      this.fixedRowsCount_ = !!value;
	    };
	    Options.prototype.setToggleSelection = function (value) {
	      this.toggleSelection_ = !!value;
	    };
	    Options.prototype.setShowDeselectButton = function (value) {
	      this.showDeselectButton_ = !!value;
	    };
	    Options.prototype.setAllowEmpty = function (value) {
	      this.allowEmpty_ = !!value;
	    };
	    Options.prototype.setShowResetButton = function (value) {
	      this.showResetButton_ = !!value;
	    };
	    Options.prototype.setMonthAsDropdown = function (value) {
	      this.monthAsDropdown_ = !!value;
	    };
	    Options.prototype.setYearAsDropdown = function (value) {
	      this.yearAsDropdown_ = !!value;
	    };
	    Options.prototype.setBindSelectedDateWithMonth = function (value) {
	      this.bindSelectedDateWithMonth_ = !!value;
	    };
	    Options.prototype.setYearSelectedFromTableOfYears = function (value) {
	      this.yearSelectedFromTableOfYears_ = !!value;
	    };
	    Options.prototype.setTableOfYearsRowsCount = function (count) {
	      this.tableOfYearsRowsCount_ = TheDatepicker.Helper_.checkNumber_('Rows count', count, 1);
	    };
	    Options.prototype.setTableOfYearsAlign = function (align) {
	      this.tableOfYearsAlign_ = align ? TheDatepicker.Helper_.checkNumber_('Align', align, 1, 3) : null;
	    };
	    Options.prototype.setTableOfYearsOnSwipeDown = function (value) {
	      this.tableOfYearsOnSwipeDown_ = !!value;
	    };
	    Options.prototype.setYearsOutOfTableOfYearsVisible = function (value) {
	      this.yearsOutOfTableOfYearsVisible_ = !!value;
	    };
	    Options.prototype.setMonthAndYearSeparated = function (value) {
	      this.monthAndYearSeparated_ = !!value;
	    };
	    Options.prototype.setMonthShort = function (value) {
	      this.monthShort_ = !!value;
	    };
	    Options.prototype.setChangeMonthOnSwipe = function (value) {
	      this.changeMonthOnSwipe_ = !!value;
	    };
	    Options.prototype.setAnimateMonthChange = function (value) {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('setAnimateMonthChange', ['setSlideAnimation']);
	      this.setSlideAnimation(value);
	    };
	    Options.prototype.setSlideAnimation = function (value) {
	      this.slideAnimation_ = !!value;
	    };
	    Options.prototype.setClassesPrefix = function (prefix) {
	      this.classesPrefix_ = TheDatepicker.Helper_.checkString_('Prefix', prefix);
	    };
	    Options.prototype.setDarkMode = function (value) {
	      this.darkMode_ = !!value;
	    };
	    Options.prototype.setShowCloseButton = function (value) {
	      this.showCloseButton_ = !!value;
	    };
	    Options.prototype.setCloseOnEscPress = function (value) {
	      this.closeOnEscPress_ = !!value;
	    };
	    Options.prototype.setTitle = function (title) {
	      this.title_ = TheDatepicker.Helper_.checkString_('Title', title);
	    };
	    Options.prototype.setDropdownItemsLimit = function (limit) {
	      this.dropdownItemsLimit_ = TheDatepicker.Helper_.checkNumber_('Items limit', limit, 1);
	    };
	    Options.prototype.setHideDropdownWithOneItem = function (value) {
	      this.hideDropdownWithOneItem_ = !!value;
	    };
	    Options.prototype.setGoBackHtml = function (html) {
	      this.goBackHtml_ = TheDatepicker.Helper_.checkString_('Html', html);
	    };
	    Options.prototype.setGoForwardHtml = function (html) {
	      this.goForwardHtml_ = TheDatepicker.Helper_.checkString_('Html', html);
	    };
	    Options.prototype.setCloseHtml = function (html) {
	      this.closeHtml_ = TheDatepicker.Helper_.checkString_('Html', html);
	    };
	    Options.prototype.setResetHtml = function (html) {
	      this.resetHtml_ = TheDatepicker.Helper_.checkString_('Html', html);
	    };
	    Options.prototype.setDeselectHtml = function (html) {
	      this.deselectHtml_ = TheDatepicker.Helper_.checkString_('Html', html);
	    };
	    Options.prototype.setPosition = function (position) {
	      this.position_ = TheDatepicker.Helper_.checkNumber_('Position', position, 1, 4);
	    };
	    Options.prototype.setPositionFixing = function (value) {
	      this.positionFixing_ = !!value;
	    };
	    Options.prototype.setFullScreenOnMobile = function (value) {
	      this.fullScreenOnMobile_ = !!value;
	    };
	    Options.prototype.setKeyboardOnMobile = function (value) {
	      this.keyboardOnMobile_ = !!value;
	    };
	    Options.prototype.setIncludeAria = function (value) {
	      this.includeAria_ = !!value;
	    };
	    Options.prototype.setToday = function (date) {
	      this.today_ = TheDatepicker.Helper_.normalizeDate_('Today', date, true, this);
	    };
	    Options.prototype.onBeforeSelect = function (listener) {
	      this.onEvent_(EventType_.BeforeSelect, listener);
	    };
	    Options.prototype.offBeforeSelect = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.BeforeSelect, listener);
	    };
	    Options.prototype.onSelect = function (listener) {
	      this.onEvent_(EventType_.Select, listener);
	    };
	    Options.prototype.offSelect = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.Select, listener);
	    };
	    Options.prototype.onBeforeOpen = function (listener) {
	      this.onEvent_(EventType_.BeforeOpen, listener);
	    };
	    Options.prototype.offBeforeOpen = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.BeforeOpen, listener);
	    };
	    Options.prototype.onOpen = function (listener) {
	      this.onEvent_(EventType_.Open, listener);
	    };
	    Options.prototype.offOpen = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.Open, listener);
	    };
	    Options.prototype.onBeforeClose = function (listener) {
	      this.onEvent_(EventType_.BeforeClose, listener);
	    };
	    Options.prototype.offBeforeClose = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.BeforeClose, listener);
	    };
	    Options.prototype.onClose = function (listener) {
	      this.onEvent_(EventType_.Close, listener);
	    };
	    Options.prototype.offClose = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.Close, listener);
	    };
	    Options.prototype.onBeforeOpenAndClose = function (listener) {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('onBeforeOpenAndClose', ['onBeforeOpen', 'onBeforeClose']);
	      this.onBeforeOpen(listener);
	      this.onBeforeClose(listener);
	    };
	    Options.prototype.offBeforeOpenAndClose = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      TheDatepicker.Helper_.warnDeprecatedUsage_('offBeforeOpenAndClose', ['offBeforeOpen', 'offBeforeClose']);
	      this.offBeforeOpen(listener);
	      this.offBeforeClose(listener);
	    };
	    Options.prototype.onOpenAndClose = function (listener) {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('onOpenAndClose', ['onOpen', 'onClose']);
	      this.onOpen(listener);
	      this.onClose(listener);
	    };
	    Options.prototype.offOpenAndClose = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      TheDatepicker.Helper_.warnDeprecatedUsage_('offOpenAndClose', ['offOpen', 'offClose']);
	      this.offOpen(listener);
	      this.offClose(listener);
	    };
	    Options.prototype.onBeforeMonthChange = function (listener) {
	      this.onEvent_(EventType_.BeforeMonthChange, listener);
	    };
	    Options.prototype.offBeforeMonthChange = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.BeforeMonthChange, listener);
	    };
	    Options.prototype.onMonthChange = function (listener) {
	      this.onEvent_(EventType_.MonthChange, listener);
	    };
	    Options.prototype.offMonthChange = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.MonthChange, listener);
	    };
	    Options.prototype.onBeforeFocus = function (listener) {
	      this.onEvent_(EventType_.BeforeFocus, listener);
	    };
	    Options.prototype.offBeforeFocus = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.BeforeFocus, listener);
	    };
	    Options.prototype.onFocus = function (listener) {
	      this.onEvent_(EventType_.Focus, listener);
	    };
	    Options.prototype.offFocus = function (listener) {
	      if (listener === void 0) {
	        listener = null;
	      }
	      this.offEvent_(EventType_.Focus, listener);
	    };
	    Options.prototype.getInitialMonth = function () {
	      var primarySource = this.initialDatePriority_ ? this.initialDate_ : this.initialMonth_;
	      var secondarySource = this.initialDatePriority_ ? this.initialMonth_ : this.initialDate_;
	      var initialMonth = primarySource ? new Date(primarySource.getTime()) : secondarySource ? new Date(secondarySource.getTime()) : this.getToday();
	      initialMonth.setDate(1);
	      return this.correctMonth(initialMonth);
	    };
	    Options.prototype.isMonthInValidity = function (month) {
	      return !this.calculateMonthCorrection_(month);
	    };
	    Options.prototype.correctMonth = function (month) {
	      var correctMonth = this.calculateMonthCorrection_(month);
	      return correctMonth || month;
	    };
	    Options.prototype.getInitialDate = function () {
	      return this.findPossibleAvailableDate(this.initialDate_);
	    };
	    Options.prototype.findPossibleAvailableDate = function (date) {
	      if (this.isAllowedEmpty()) {
	        return date && this.isDateInValidity(date) && this.isDateAvailable(date) ? new Date(date.getTime()) : null;
	      }
	      date = date ? new Date(date.getTime()) : this.getToday();
	      date = this.findNearestAvailableDate(date);
	      if (date) {
	        return date;
	      }
	      throw new AvailableDateNotFoundException();
	    };
	    Options.prototype.findNearestAvailableDate = function (date) {
	      return this.calculateNearestAvailableDate_(date);
	    };
	    Options.prototype.calculateNearestAvailableDate_ = function (date, minDate, maxDate) {
	      if (minDate === void 0) {
	        minDate = null;
	      }
	      if (maxDate === void 0) {
	        maxDate = null;
	      }
	      date = this.correctDate_(date);
	      var defaultMinDate = this.getMinDate_().getTime();
	      var defaultMaxDate = this.getMaxDate_().getTime();
	      var minTimestamp = minDate ? Math.max(defaultMinDate, minDate.getTime()) : defaultMinDate;
	      var maxTimestamp = maxDate ? Math.min(defaultMaxDate, maxDate.getTime()) : defaultMaxDate;
	      if (this.isDateAvailable(date)) {
	        var timestamp = date.getTime();
	        return timestamp >= minTimestamp && timestamp <= maxTimestamp ? date : null;
	      }
	      var maxLoops = 1000;
	      var increasedDate = date;
	      var decreasedDate = new Date(date.getTime());
	      do {
	        if (increasedDate) {
	          increasedDate.setDate(increasedDate.getDate() + 1);
	          if (increasedDate.getTime() > maxTimestamp) {
	            increasedDate = null;
	          } else if (this.isDateAvailable(increasedDate)) {
	            return increasedDate;
	          }
	        }
	        if (decreasedDate) {
	          decreasedDate.setDate(decreasedDate.getDate() - 1);
	          if (decreasedDate.getTime() < minTimestamp) {
	            decreasedDate = null;
	          } else if (this.isDateAvailable(decreasedDate)) {
	            return decreasedDate;
	          }
	        }
	        maxLoops--;
	      } while ((increasedDate || decreasedDate) && maxLoops > 0);
	      return null;
	    };
	    Options.prototype.isDateInValidity = function (date) {
	      return !this.calculateDateCorrection_(date);
	    };
	    Options.prototype.correctDate_ = function (date) {
	      var correctDate = this.calculateDateCorrection_(date);
	      return correctDate || date;
	    };
	    Options.prototype.getFirstDayOfWeek = function () {
	      return this.firstDayOfWeek_;
	    };
	    Options.prototype.areDaysOutOfMonthVisible = function () {
	      return this.daysOutOfMonthVisible_;
	    };
	    Options.prototype.hasFixedRowsCount = function () {
	      return this.fixedRowsCount_;
	    };
	    Options.prototype.hasToggleSelection = function () {
	      return this.allowEmpty_ && this.toggleSelection_;
	    };
	    Options.prototype.isAllowedEmpty = function () {
	      return this.allowEmpty_;
	    };
	    Options.prototype.isDeselectButtonShown = function () {
	      return this.allowEmpty_ && this.showDeselectButton_;
	    };
	    Options.prototype.isResetButtonShown = function () {
	      return this.showResetButton_;
	    };
	    Options.prototype.isMonthAsDropdown = function () {
	      return this.monthAsDropdown_;
	    };
	    Options.prototype.isYearAsDropdown = function () {
	      return this.yearAsDropdown_;
	    };
	    Options.prototype.isYearSelectedFromTableOfYears = function () {
	      return this.yearAsDropdown_ && this.yearSelectedFromTableOfYears_;
	    };
	    Options.prototype.isSelectedDateBoundWithMonth = function () {
	      return this.bindSelectedDateWithMonth_;
	    };
	    Options.prototype.getTableOfYearsRowsCount = function () {
	      return this.tableOfYearsRowsCount_;
	    };
	    Options.prototype.getTableOfYearsColumnsCount = function () {
	      return 4;
	    };
	    Options.prototype.getTableOfYearsAlign = function () {
	      return this.tableOfYearsAlign_;
	    };
	    Options.prototype.isTableOfYearsOnSwipeDownEnabled = function () {
	      return this.tableOfYearsOnSwipeDown_;
	    };
	    Options.prototype.areYearsOutOfTableOfYearsVisible = function () {
	      return this.yearsOutOfTableOfYearsVisible_;
	    };
	    Options.prototype.isMonthAndYearSeparated = function () {
	      return this.isYearSelectedFromTableOfYears() || this.monthAndYearSeparated_;
	    };
	    Options.prototype.isMonthShort = function () {
	      return this.monthShort_;
	    };
	    Options.prototype.isMonthChangeOnSwipeEnabled = function () {
	      return this.changeMonthOnSwipe_;
	    };
	    Options.prototype.isMonthChangeAnimated = function () {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('isMonthChangeAnimated', ['isSlideAnimationEnabled']);
	      return this.isSlideAnimationEnabled();
	    };
	    Options.prototype.isSlideAnimationEnabled = function () {
	      return this.slideAnimation_;
	    };
	    Options.prototype.getClassesPrefix = function () {
	      return this.classesPrefix_;
	    };
	    Options.prototype.isDarkModeEnabled = function () {
	      return this.darkMode_;
	    };
	    Options.prototype.isCloseButtonShown = function () {
	      return this.hideOnBlur_ && this.showCloseButton_;
	    };
	    Options.prototype.isClosedOnEscPress = function () {
	      return this.hideOnBlur_ && this.closeOnEscPress_;
	    };
	    Options.prototype.getTitle = function () {
	      return this.title_;
	    };
	    Options.prototype.getMinDate = function () {
	      return this.minDate_ ? new Date(this.minDate_.getTime()) : null;
	    };
	    Options.prototype.getMaxDate = function () {
	      return this.maxDate_ ? new Date(this.maxDate_.getTime()) : null;
	    };
	    Options.prototype.getMinDate_ = function () {
	      var minDate = this.getMinDate();
	      if (!minDate) {
	        return new Date(-271821, 4, 1);
	      }
	      return minDate;
	    };
	    Options.prototype.getMaxDate_ = function () {
	      var maxDate = this.getMaxDate();
	      if (!maxDate) {
	        return new Date(275760, 7, 31);
	      }
	      return maxDate;
	    };
	    Options.prototype.getMinMonth = function () {
	      if (!this.minDate_) {
	        return null;
	      }
	      var minMonth = new Date(this.minDate_.getTime());
	      minMonth.setDate(1);
	      return minMonth;
	    };
	    Options.prototype.getMaxMonth = function () {
	      if (!this.maxDate_) {
	        return null;
	      }
	      var maxMonth = new Date(this.maxDate_.getTime());
	      maxMonth.setDate(1);
	      return maxMonth;
	    };
	    Options.prototype.getMinMonth_ = function () {
	      var minMonth = this.getMinMonth();
	      if (!minMonth) {
	        minMonth = this.getMinDate_();
	      }
	      return minMonth;
	    };
	    Options.prototype.getMaxMonth_ = function () {
	      var maxMonth = this.getMaxMonth();
	      if (!maxMonth) {
	        maxMonth = this.getMaxDate_();
	        maxMonth.setDate(1);
	      }
	      return maxMonth;
	    };
	    Options.prototype.isDropdownWithOneItemHidden = function () {
	      return this.hideDropdownWithOneItem_;
	    };
	    Options.prototype.getDropdownItemsLimit = function () {
	      return this.dropdownItemsLimit_;
	    };
	    Options.prototype.isDateAvailable = function (date) {
	      var dateAvailabilityResolvers = this.dateAvailabilityResolvers_.slice(0);
	      for (var index = 0; index < dateAvailabilityResolvers.length; index++) {
	        if (!dateAvailabilityResolvers[index](new Date(date.getTime()))) {
	          return false;
	        }
	      }
	      return true;
	    };
	    Options.prototype.getCellContent = function (day) {
	      if (this.cellContentResolver_) {
	        return this.cellContentResolver_(day);
	      }
	      return day.dayNumber + '';
	    };
	    Options.prototype.prefixClass_ = function (name) {
	      return this.classesPrefix_ + name;
	    };
	    Options.prototype.getCellStructure_ = function () {
	      if (this.cellContentStructureResolver_) {
	        return this.cellContentStructureResolver_.init();
	      }
	      return TheDatepicker.HtmlHelper_.createSpan_();
	    };
	    Options.prototype.updateCellStructure_ = function (element, day) {
	      if (this.cellContentStructureResolver_) {
	        this.cellContentStructureResolver_.update(element, day);
	      } else {
	        element.innerText = this.getCellContent(day);
	      }
	    };
	    Options.prototype.getHeaderStructure_ = function () {
	      return this.headerStructureResolver_ ? this.headerStructureResolver_() : null;
	    };
	    Options.prototype.getFooterStructure_ = function () {
	      return this.footerStructureResolver_ ? this.footerStructureResolver_() : null;
	    };
	    Options.prototype.getCellClasses = function (day) {
	      var result = [];
	      var cellClassesResolvers = this.cellClassesResolvers_.slice(0);
	      for (var index = 0; index < cellClassesResolvers.length; index++) {
	        var classes = cellClassesResolvers[index](day);
	        if (typeof classes === 'string') {
	          result.push(classes);
	        } else if (typeof classes === 'object' && classes.constructor === Array) {
	          result = result.concat(classes);
	        }
	      }
	      return result;
	    };
	    Options.prototype.modifyDay = function (day) {
	      var dayModifiers = this.dayModifiers_.slice(0);
	      for (var index = 0; index < dayModifiers.length; index++) {
	        dayModifiers[index](day);
	      }
	    };
	    Options.prototype.getGoBackHtml = function () {
	      return this.goBackHtml_;
	    };
	    Options.prototype.getGoForwardHtml = function () {
	      return this.goForwardHtml_;
	    };
	    Options.prototype.getCloseHtml = function () {
	      return this.closeHtml_;
	    };
	    Options.prototype.getResetHtml = function () {
	      return this.resetHtml_;
	    };
	    Options.prototype.getDeselectHtml = function () {
	      return this.deselectHtml_;
	    };
	    Options.prototype.isHiddenOnBlur = function () {
	      return this.hideOnBlur_;
	    };
	    Options.prototype.isHiddenOnSelect = function () {
	      return this.hideOnBlur_ && this.hideOnSelect_;
	    };
	    Options.prototype.getInputFormat = function () {
	      return this.inputFormat_;
	    };
	    Options.prototype.isAllowedInputAnyChar = function () {
	      return this.allowInputAnyChar_;
	    };
	    Options.prototype.getPosition = function () {
	      return this.position_;
	    };
	    Options.prototype.isPositionFixingEnabled = function () {
	      return this.hideOnBlur_ && this.positionFixing_;
	    };
	    Options.prototype.isFullScreenOnMobile = function () {
	      return this.hideOnBlur_ && this.fullScreenOnMobile_;
	    };
	    Options.prototype.isKeyboardOnMobile = function () {
	      return this.keyboardOnMobile_;
	    };
	    Options.prototype.isAriaIncluded = function () {
	      return this.includeAria_;
	    };
	    Options.prototype.getToday = function () {
	      return this.today_ ? new Date(this.today_.getTime()) : TheDatepicker.Helper_.resetTime_(new Date());
	    };
	    Options.prototype.getDateAvailabilityResolver = function () {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('getDateAvailabilityResolver', ['getDateAvailabilityResolvers']);
	      return this.dateAvailabilityResolvers_.length > 0 ? this.dateAvailabilityResolvers_[0] : null;
	    };
	    Options.prototype.getDateAvailabilityResolvers = function () {
	      return this.dateAvailabilityResolvers_.slice(0);
	    };
	    Options.prototype.getCellContentResolver = function () {
	      return this.cellContentResolver_;
	    };
	    Options.prototype.getCellContentStructureResolver = function () {
	      return this.cellContentStructureResolver_;
	    };
	    Options.prototype.getHeaderStructureResolver = function () {
	      return this.headerStructureResolver_;
	    };
	    Options.prototype.getFooterStructureResolver = function () {
	      return this.footerStructureResolver_;
	    };
	    Options.prototype.getCellClassesResolvers = function () {
	      return this.cellClassesResolvers_.slice(0);
	    };
	    Options.prototype.getDayModifiers = function () {
	      return this.dayModifiers_.slice(0);
	    };
	    Options.prototype.getBeforeSelectListeners = function () {
	      return this.listeners_.beforeSelect.slice(0);
	    };
	    Options.prototype.getSelectListeners = function () {
	      return this.listeners_.select.slice(0);
	    };
	    Options.prototype.getBeforeOpenListeners = function () {
	      return this.listeners_.beforeOpen.slice(0);
	    };
	    Options.prototype.getOpenListeners = function () {
	      return this.listeners_.open.slice(0);
	    };
	    Options.prototype.getBeforeCloseListeners = function () {
	      return this.listeners_.beforeClose.slice(0);
	    };
	    Options.prototype.getCloseListeners = function () {
	      return this.listeners_.close.slice(0);
	    };
	    Options.prototype.getBeforeOpenAndCloseListeners = function () {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('getBeforeOpenAndCloseListeners', ['getBeforeOpenListeners', 'getBeforeCloseListeners']);
	      return this.listeners_.beforeOpen.concat(this.listeners_.beforeClose);
	    };
	    Options.prototype.getOpenAndCloseListeners = function () {
	      TheDatepicker.Helper_.warnDeprecatedUsage_('getOpenAndCloseListeners', ['getOpenListeners', 'getCloseListeners']);
	      return this.listeners_.open.concat(this.listeners_.close);
	    };
	    Options.prototype.getBeforeMonthChangeListeners = function () {
	      return this.listeners_.beforeMonthChange.slice(0);
	    };
	    Options.prototype.getMonthChangeListeners = function () {
	      return this.listeners_.monthChange.slice(0);
	    };
	    Options.prototype.getBeforeFocusListeners = function () {
	      return this.listeners_.beforeFocus.slice(0);
	    };
	    Options.prototype.getFocusListeners = function () {
	      return this.listeners_.focus.slice(0);
	    };
	    Options.prototype.checkConstraints_ = function (minDate, maxDate) {
	      if (minDate && maxDate && minDate.getTime() > maxDate.getTime()) {
	        throw new Error('Min date cannot be higher then max date.');
	      }
	    };
	    Options.prototype.calculateMonthCorrection_ = function (month) {
	      var minMonth = this.getMinMonth_();
	      if (month.getTime() < minMonth.getTime()) {
	        return minMonth;
	      }
	      var maxMonth = this.getMaxMonth_();
	      if (month.getTime() > maxMonth.getTime()) {
	        return maxMonth;
	      }
	      return null;
	    };
	    Options.prototype.calculateDateCorrection_ = function (date) {
	      var minDate = this.getMinDate_();
	      if (date.getTime() < minDate.getTime()) {
	        return minDate;
	      }
	      var maxDate = this.getMaxDate_();
	      if (date.getTime() > maxDate.getTime()) {
	        return maxDate;
	      }
	      return null;
	    };
	    Options.prototype.removeCallback_ = function (callbacksList, parameterName, callback) {
	      callback = TheDatepicker.Helper_.checkFunction_(parameterName, callback);
	      if (!callback) {
	        callbacksList.splice(0, callbacksList.length);
	      } else {
	        var callbacks = callbacksList.slice(0);
	        for (var index = callbacks.length - 1; index >= 0; index--) {
	          if (callbacks[index] === callback) {
	            callbacksList.splice(index, 1);
	          }
	        }
	      }
	    };
	    Options.prototype.onEvent_ = function (eventType, listener) {
	      this.listeners_[eventType].push(TheDatepicker.Helper_.checkFunction_('Event listener', listener, false));
	    };
	    Options.prototype.offEvent_ = function (eventType, listener) {
	      listener = TheDatepicker.Helper_.checkFunction_('Event listener', listener);
	      if (!listener) {
	        this.listeners_[eventType] = [];
	      } else {
	        var newListeners = [];
	        for (var index = 0; index < this.listeners_[eventType].length; index++) {
	          if (this.listeners_[eventType][index] !== listener) {
	            newListeners.push(this.listeners_[eventType][index]);
	          }
	        }
	        this.listeners_[eventType] = newListeners;
	      }
	    };
	    Options.prototype.triggerEvent_ = function (eventType, caller) {
	      var listeners = this.listeners_[eventType].slice(0);
	      for (var index = 0; index < listeners.length; index++) {
	        if (caller(listeners[index]) === false) {
	          return false;
	        }
	      }
	      return true;
	    };
	    return Options;
	  }();
	  TheDatepicker.Options = Options;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  var YearCellData_ = function () {
	    function YearCellData_(yearNumber) {
	      this.yearNumber = yearNumber;
	      this.isAvailable = true;
	      this.isSelected = false;
	      this.isHighlighted = false;
	      this.isFocused = false;
	    }
	    return YearCellData_;
	  }();
	  TheDatepicker.YearCellData_ = YearCellData_;
	  var Template_ = function () {
	    function Template_(options_, container_, hasInput_) {
	      this.options_ = options_;
	      this.container_ = container_;
	      this.hasInput_ = hasInput_;
	      this.mainElement_ = null;
	      this.bodyElement_ = null;
	      this.tablesElement_ = null;
	      this.tableElement_ = null;
	      this.tableOfYearsElement_ = null;
	      this.controlElement_ = null;
	      this.goBackElement_ = null;
	      this.goForwardElement_ = null;
	      this.titleElement_ = null;
	      this.titleContentElement_ = null;
	      this.resetElement_ = null;
	      this.resetButton_ = null;
	      this.closeElement_ = null;
	      this.closeButton_ = null;
	      this.monthSelect_ = null;
	      this.monthElement_ = null;
	      this.yearActiveElement_ = null;
	      this.yearTextElement_ = null;
	      this.monthAndYearSelect_ = null;
	      this.monthAndYearElement_ = null;
	      this.weeksElements_ = [];
	      this.daysElements_ = [];
	      this.daysButtonsElements_ = [];
	      this.daysContentsElements_ = [];
	      this.yearsElements_ = [];
	      this.yearsButtonsElements_ = [];
	      this.yearsContentsElements_ = [];
	      this.onAfterSlide_ = null;
	    }
	    Template_.prototype.render_ = function (viewModel) {
	      if (!this.mainElement_) {
	        if (this.hasInput_ && this.options_.isHiddenOnBlur() && !viewModel.isActive_()) {
	          return;
	        }
	        this.container_.innerHTML = '';
	        this.container_.appendChild(this.createSkeleton_(viewModel));
	      }
	      this.updateMainElement_(viewModel);
	      this.updateTableElements_(viewModel);
	      this.updateTopElement_(viewModel);
	      this.updateTitleElement_(viewModel);
	      this.updateCloseElement_(viewModel);
	      this.updateResetElement_(viewModel);
	      this.updateGoElement_(viewModel, false);
	      this.updateGoElement_(viewModel, true);
	      this.updateMonthElement_(viewModel);
	      this.updateYearElement_(viewModel);
	      this.updateMonthAndYearElement_(viewModel);
	      this.updateWeeksElements_(viewModel);
	      this.updateTableOfYearsRowsElements_(viewModel);
	    };
	    Template_.prototype.createSkeleton_ = function (viewModel) {
	      var main = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Main, this.options_);
	      TheDatepicker.HtmlHelper_.appendChild_(main, this.options_.getHeaderStructure_());
	      main.appendChild(this.createHeaderElement_(viewModel));
	      main.appendChild(this.createBodyElement_(viewModel));
	      TheDatepicker.HtmlHelper_.appendChild_(main, this.options_.getFooterStructure_());
	      this.mainElement_ = main;
	      return main;
	    };
	    Template_.prototype.updateMainElement_ = function (viewModel) {
	      this.mainElement_.style.display = !this.hasInput_ || viewModel.isActive_() || !this.options_.isHiddenOnBlur() ? '' : 'none';
	      this.mainElement_.className = '';
	      TheDatepicker.HtmlHelper_.addClass_(this.mainElement_, TheDatepicker.ClassNameType.Main, this.options_);
	      if (this.options_.isDarkModeEnabled()) {
	        TheDatepicker.HtmlHelper_.addClass_(this.mainElement_, TheDatepicker.ClassNameType.MainDarkMode, this.options_);
	      }
	    };
	    Template_.prototype.updateTableElements_ = function (viewModel) {
	      this.tableElement_.style.display = viewModel.yearSelectionState_ ? 'none' : '';
	      if (this.tableOfYearsElement_) {
	        this.tableOfYearsElement_.style.display = viewModel.yearSelectionState_ ? '' : 'none';
	      }
	    };
	    Template_.prototype.createBodyElement_ = function (viewModel) {
	      var _this = this;
	      var body = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Body, this.options_);
	      var tables = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Tables, this.options_);
	      body.appendChild(tables);
	      if (this.options_.isMonthChangeOnSwipeEnabled() || this.options_.isTableOfYearsOnSwipeDownEnabled()) {
	        TheDatepicker.HtmlHelper_.addClass_(body, TheDatepicker.ClassNameType.BodySwipeable, this.options_);
	        TheDatepicker.Helper_.addSwipeListener_(body, function (event, moveDirection) {
	          var isForward = false;
	          var change = null;
	          switch (moveDirection) {
	            case TheDatepicker.MoveDirection_.Down:
	              isForward = true;
	            case TheDatepicker.MoveDirection_.Up:
	              if (_this.tableOfYearsElement_ && _this.options_.isTableOfYearsOnSwipeDownEnabled() && viewModel.canSetYearSelectionActive_(isForward)) {
	                change = function () {
	                  viewModel.setYearSelectionActive_(isForward);
	                };
	              }
	              break;
	            case TheDatepicker.MoveDirection_.Left:
	              isForward = true;
	            case TheDatepicker.MoveDirection_.Right:
	              if (_this.options_.isMonthChangeOnSwipeEnabled() && viewModel.canGoDirection_(isForward)) {
	                change = function () {
	                  viewModel.goDirection_(event, isForward);
	                };
	              }
	          }
	          if (change) {
	            _this.slideTable_(viewModel, moveDirection, change);
	          }
	        });
	      }
	      var tableElement = this.createTableElement_(viewModel);
	      tables.appendChild(tableElement);
	      this.tableElement_ = tableElement;
	      if (this.options_.isYearSelectedFromTableOfYears()) {
	        var tableOfYearsElement = this.createTableOfYearsElement_(viewModel);
	        tables.appendChild(tableOfYearsElement);
	        this.tableOfYearsElement_ = tableOfYearsElement;
	      }
	      this.bodyElement_ = body;
	      this.tablesElement_ = tables;
	      return body;
	    };
	    Template_.prototype.createHeaderElement_ = function (viewModel) {
	      var header = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Header, this.options_);
	      var top = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderTop, this.options_);
	      header.appendChild(top);
	      top.appendChild(this.createTitleElement_(viewModel));
	      var control = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderControl, this.options_);
	      top.appendChild(control);
	      control.appendChild(this.createResetElement_(viewModel));
	      control.appendChild(this.createCloseElement_(viewModel));
	      var navigation = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderNavigation, this.options_);
	      header.appendChild(navigation);
	      navigation.appendChild(this.createGoElement_(viewModel, false));
	      var state = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderState, this.options_);
	      navigation.appendChild(state);
	      if (this.options_.isMonthAndYearSeparated()) {
	        state.appendChild(this.createMonthElement_(viewModel));
	        state.appendChild(this.createYearElement_(viewModel));
	      } else {
	        state.appendChild(this.createMonthAndYearElement_(viewModel));
	      }
	      navigation.appendChild(this.createGoElement_(viewModel, true));
	      this.controlElement_ = control;
	      return header;
	    };
	    Template_.prototype.updateTopElement_ = function (viewModel) {
	      var isVisible = this.options_.getTitle() !== '' || this.options_.isResetButtonShown() || this.hasInput_ && this.options_.isCloseButtonShown();
	      this.controlElement_.style.display = isVisible ? '' : 'none';
	      this.titleElement_.style.display = isVisible ? '' : 'none';
	    };
	    Template_.prototype.createTitleElement_ = function (viewModel) {
	      var titleElement = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderTitle, this.options_);
	      var titleContent = TheDatepicker.HtmlHelper_.createSpan_();
	      titleElement.appendChild(titleContent);
	      TheDatepicker.HtmlHelper_.addClass_(titleContent, TheDatepicker.ClassNameType.HeaderTitleContent, this.options_);
	      this.titleElement_ = titleElement;
	      this.titleContentElement_ = titleContent;
	      return titleElement;
	    };
	    Template_.prototype.updateTitleElement_ = function (viewModel) {
	      var title = this.options_.getTitle();
	      this.titleContentElement_.style.display = title !== '' ? '' : 'none';
	      this.titleContentElement_.innerText = title;
	    };
	    Template_.prototype.createResetElement_ = function (viewModel) {
	      var resetElement = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Reset, this.options_);
	      var resetButton = TheDatepicker.HtmlHelper_.createAnchor_(function (event) {
	        viewModel.reset_(event);
	      }, this.options_);
	      resetButton.innerHTML = this.options_.getResetHtml();
	      resetElement.appendChild(resetButton);
	      this.resetButton_ = resetButton;
	      this.resetElement_ = resetElement;
	      return resetElement;
	    };
	    Template_.prototype.updateResetElement_ = function (viewModel) {
	      this.resetElement_.style.display = this.options_.isResetButtonShown() ? '' : 'none';
	      this.updateTitle_(this.resetButton_, TheDatepicker.TitleName.Reset);
	    };
	    Template_.prototype.createCloseElement_ = function (viewModel) {
	      var closeElement = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Close, this.options_);
	      var closeButton = TheDatepicker.HtmlHelper_.createAnchor_(function (event) {
	        viewModel.close_(event);
	      }, this.options_);
	      closeButton.innerHTML = this.options_.getCloseHtml();
	      closeElement.appendChild(closeButton);
	      this.closeButton_ = closeButton;
	      this.closeElement_ = closeElement;
	      return closeElement;
	    };
	    Template_.prototype.updateCloseElement_ = function (viewModel) {
	      this.closeElement_.style.display = this.hasInput_ && this.options_.isCloseButtonShown() ? '' : 'none';
	      this.updateTitle_(this.closeButton_, TheDatepicker.TitleName.Close);
	    };
	    Template_.prototype.createGoElement_ = function (viewModel, isForward) {
	      var _this = this;
	      var goElement = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.Go, this.options_);
	      TheDatepicker.HtmlHelper_.addClass_(goElement, isForward ? TheDatepicker.ClassNameType.GoNext : TheDatepicker.ClassNameType.GoPrevious, this.options_);
	      var goButton = TheDatepicker.HtmlHelper_.createAnchor_(function (event) {
	        var moveDirection = isForward ? TheDatepicker.MoveDirection_.Left : TheDatepicker.MoveDirection_.Right;
	        if (viewModel.canGoDirection_(isForward)) {
	          _this.slideTable_(viewModel, moveDirection, function () {
	            viewModel.goDirection_(event, isForward);
	          });
	        }
	      }, this.options_);
	      goButton.innerHTML = isForward ? this.options_.getGoForwardHtml() : this.options_.getGoBackHtml();
	      goElement.appendChild(goButton);
	      if (isForward) {
	        this.goForwardElement_ = goButton;
	      } else {
	        this.goBackElement_ = goButton;
	      }
	      return goElement;
	    };
	    Template_.prototype.updateGoElement_ = function (viewModel, isForward) {
	      var goElement = isForward ? this.goForwardElement_ : this.goBackElement_;
	      goElement.style.visibility = viewModel.canGoDirection_(isForward) ? 'visible' : 'hidden';
	      this.updateTitle_(goElement, viewModel.yearSelectionState_ ? isForward ? TheDatepicker.TitleName.GoForwardTableOfYears : TheDatepicker.TitleName.GoBackTableOfYears : isForward ? TheDatepicker.TitleName.GoForward : TheDatepicker.TitleName.GoBack);
	    };
	    Template_.prototype.createMonthElement_ = function (viewModel) {
	      var _this = this;
	      var options = [];
	      for (var monthNumber = 0; monthNumber < 12; monthNumber++) {
	        options.push({
	          value: monthNumber + '',
	          label: this.translateMonth_(monthNumber)
	        });
	      }
	      var selectElement = TheDatepicker.HtmlHelper_.createSelectInput_(options, function (event, monthNumber) {
	        var currentMonth = viewModel.getCurrentMonth_();
	        var newMonth = new Date(currentMonth.getTime());
	        newMonth.setMonth(parseInt(monthNumber, 10));
	        if (!viewModel.goToMonth_(event, newMonth)) {
	          _this.monthSelect_.value = currentMonth.getMonth() + '';
	        }
	      }, this.options_);
	      var monthElement = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderMonth, this.options_);
	      var monthContent = TheDatepicker.HtmlHelper_.createSpan_();
	      monthElement.appendChild(selectElement);
	      monthElement.appendChild(monthContent);
	      this.monthElement_ = monthContent;
	      this.monthSelect_ = selectElement;
	      return monthElement;
	    };
	    Template_.prototype.updateMonthElement_ = function (viewModel) {
	      if (!this.monthElement_) {
	        return;
	      }
	      var currentMonth = viewModel.getCurrentMonth_().getMonth();
	      this.monthElement_.innerText = this.translateMonth_(currentMonth);
	      this.updateTitle_(this.monthSelect_, TheDatepicker.TitleName.Month);
	      if (!this.options_.isMonthAsDropdown()) {
	        this.monthSelect_.style.display = 'none';
	        this.monthElement_.style.display = '';
	        return;
	      }
	      var valuesCount = 0;
	      for (var monthNumber = 0; monthNumber < 12; monthNumber++) {
	        var newMonth = new Date(viewModel.getCurrentMonth_().getTime());
	        newMonth.setMonth(monthNumber);
	        var option = this.monthSelect_.getElementsByTagName('option')[monthNumber];
	        var canGoToMonth = viewModel.canGoToMonth_(newMonth);
	        option.disabled = !canGoToMonth;
	        option.style.display = canGoToMonth ? '' : 'none';
	        valuesCount += canGoToMonth ? 1 : 0;
	      }
	      this.monthSelect_.value = currentMonth + '';
	      var showSelect = !this.options_.isDropdownWithOneItemHidden() || valuesCount > 1;
	      this.monthSelect_.style.display = showSelect ? '' : 'none';
	      this.monthElement_.style.display = showSelect ? 'none' : '';
	    };
	    Template_.prototype.createYearElement_ = function (viewModel) {
	      var _this = this;
	      var yearElement = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderYear, this.options_);
	      var yearActiveElement;
	      if (this.options_.isYearSelectedFromTableOfYears()) {
	        yearActiveElement = TheDatepicker.HtmlHelper_.createAnchor_(function () {
	          _this.slideTable_(viewModel, viewModel.yearSelectionState_ ? TheDatepicker.MoveDirection_.Up : TheDatepicker.MoveDirection_.Down, function () {
	            viewModel.setYearSelectionActive_(!viewModel.yearSelectionState_);
	          });
	        }, this.options_);
	        TheDatepicker.HtmlHelper_.addClass_(yearActiveElement, TheDatepicker.ClassNameType.HeaderYearsToggle, this.options_);
	      } else {
	        yearActiveElement = TheDatepicker.HtmlHelper_.createSelectInput_([], function (event, year) {
	          var currentMonth = viewModel.getCurrentMonth_();
	          var newMonth = new Date(currentMonth.getTime());
	          newMonth.setFullYear(parseInt(year, 10));
	          var minMonth = _this.options_.getMinMonth_();
	          var maxMonth = _this.options_.getMaxMonth_();
	          if (newMonth.getTime() < minMonth.getTime()) {
	            newMonth = minMonth;
	          }
	          if (newMonth.getTime() > maxMonth.getTime()) {
	            newMonth = maxMonth;
	          }
	          if (!viewModel.goToMonth_(event, newMonth)) {
	            _this.yearActiveElement_.value = currentMonth.getFullYear() + '';
	          }
	        }, this.options_);
	      }
	      var yearTextElement = TheDatepicker.HtmlHelper_.createSpan_();
	      yearElement.appendChild(yearActiveElement);
	      yearElement.appendChild(yearTextElement);
	      this.yearTextElement_ = yearTextElement;
	      this.yearActiveElement_ = yearActiveElement;
	      return yearElement;
	    };
	    Template_.prototype.updateYearElement_ = function (viewModel) {
	      if (!this.yearTextElement_) {
	        return;
	      }
	      var currentYear = viewModel.getCurrentMonth_().getFullYear();
	      this.yearTextElement_.innerText = currentYear + '';
	      this.updateTitle_(this.yearActiveElement_, TheDatepicker.TitleName.Year);
	      var minYear = this.options_.getMinDate_().getFullYear();
	      var maxYear = this.options_.getMaxDate_().getFullYear();
	      if (this.tableOfYearsElement_) {
	        this.yearActiveElement_.innerText = currentYear + '';
	        if (viewModel.isYearSelectionToggleButtonFocused_) {
	          this.yearActiveElement_.focus();
	          viewModel.isYearSelectionToggleButtonFocused_ = false;
	        }
	      } else if (this.options_.isYearAsDropdown()) {
	        var range = this.calculateDropdownRange_(currentYear, minYear, maxYear);
	        var options = this.yearActiveElement_.getElementsByTagName('option');
	        var diff = this.calculateDropdownDiff_(options, range, function (value) {
	          return parseInt(value, 10);
	        });
	        for (var index = 0; index < diff.remove.length; index++) {
	          this.yearActiveElement_.removeChild(diff.remove[index]);
	        }
	        for (var index = diff.prepend.length - 1; index >= 0; index--) {
	          this.yearActiveElement_.insertBefore(TheDatepicker.HtmlHelper_.createSelectOption_(diff.prepend[index] + '', diff.prepend[index] + ''), this.yearActiveElement_.firstChild);
	        }
	        for (var index = 0; index < diff.append.length; index++) {
	          this.yearActiveElement_.appendChild(TheDatepicker.HtmlHelper_.createSelectOption_(diff.append[index] + '', diff.append[index] + ''));
	        }
	        this.yearActiveElement_.value = currentYear + '';
	      } else {
	        this.yearActiveElement_.style.display = 'none';
	        this.yearTextElement_.style.display = '';
	        return;
	      }
	      var showSelect = !this.options_.isDropdownWithOneItemHidden() || minYear !== maxYear;
	      this.yearActiveElement_.style.display = showSelect ? '' : 'none';
	      this.yearTextElement_.style.display = showSelect ? 'none' : '';
	    };
	    Template_.prototype.createMonthAndYearElement_ = function (viewModel) {
	      var _this = this;
	      var monthAndYear = TheDatepicker.HtmlHelper_.createDiv_(TheDatepicker.ClassNameType.HeaderMonthYear, this.options_);
	      var selectElement = TheDatepicker.HtmlHelper_.createSelectInput_([], function (event, value) {
	        var currentMonth = viewModel.getCurrentMonth_();
	        var newMonth = new Date(currentMonth.getTime());
	        var data = _this.parseMonthAndYearOptionValue_(value);
	        newMonth.setFullYear(data.year);
	        newMonth.setMonth(data.month);
	        if (!viewModel.goToMonth_(event, newMonth)) {
	          _this.monthAndYearSelect_.value = _this.getMonthAndYearOptionValue_({
	            month: currentMonth.getMonth(),
	            year: currentMonth.getFullYear()
	          });
	        }
	      }, this.options_);
	      var monthAndYearContent = TheDatepicker.HtmlHelper_.createSpan_();
	      this.monthAndYearElement_ = monthAndYearContent;
	      this.monthAndYearSelect_ = selectElement;
	      monthAndYear.appendChild(monthAndYearContent);
	      monthAndYear.appendChild(selectElement);
	      return monthAndYear;
	    };
	    Template_.prototype.updateMonthAndYearElement_ = function (viewModel) {
	      var _this = this;
	      if (!this.monthAndYearElement_) {
	        return;
	      }
	      var currentMonth = viewModel.getCurrentMonth_();
	      var currentData = {
	        month: currentMonth.getMonth(),
	        year: currentMonth.getFullYear()
	      };
	      var currentIndex = this.calculateMonthAndYearIndex_(currentData);
	      this.monthAndYearElement_.innerText = this.translateMonthAndYear_(currentData);
	      if (!this.options_.isYearAsDropdown() || !this.options_.isMonthAsDropdown()) {
	        this.monthAndYearSelect_.style.display = 'none';
	        this.monthAndYearElement_.style.display = '';
	        return;
	      }
	      var minDate = this.options_.getMinDate_();
	      var maxDate = this.options_.getMaxDate_();
	      var minIndex = minDate.getFullYear() * 12 + minDate.getMonth();
	      var maxIndex = maxDate.getFullYear() * 12 + maxDate.getMonth();
	      var range = this.calculateDropdownRange_(currentIndex, minIndex, maxIndex);
	      var options = this.monthAndYearSelect_.getElementsByTagName('option');
	      var diff = this.calculateDropdownDiff_(options, range, function (value) {
	        return _this.calculateMonthAndYearIndex_(_this.parseMonthAndYearOptionValue_(value));
	      });
	      for (var index = 0; index < diff.remove.length; index++) {
	        this.monthAndYearSelect_.removeChild(diff.remove[index]);
	      }
	      for (var index = diff.prepend.length - 1; index >= 0; index--) {
	        var data = this.getMonthAndYearByIndex_(diff.prepend[index]);
	        this.monthAndYearSelect_.insertBefore(TheDatepicker.HtmlHelper_.createSelectOption_(this.getMonthAndYearOptionValue_(data), this.translateMonthAndYear_(data)), this.monthAndYearSelect_.firstChild);
	      }
	      for (var index = 0; index < diff.append.length; index++) {
	        var data = this.getMonthAndYearByIndex_(diff.append[index]);
	        this.monthAndYearSelect_.appendChild(TheDatepicker.HtmlHelper_.createSelectOption_(this.getMonthAndYearOptionValue_(data), this.translateMonthAndYear_(data)));
	      }
	      this.monthAndYearSelect_.value = this.getMonthAndYearOptionValue_(currentData);
	      var showSelect = !this.options_.isDropdownWithOneItemHidden() || range.from < range.to;
	      this.monthAndYearSelect_.style.display = showSelect ? '' : 'none';
	      this.monthAndYearElement_.style.display = showSelect ? 'none' : '';
	    };
	    Template_.prototype.translateMonthAndYear_ = function (data) {
	      return this.translateMonth_(data.month) + ' ' + data.year;
	    };
	    Template_.prototype.calculateMonthAndYearIndex_ = function (data) {
	      return data.year * 12 + data.month;
	    };
	    Template_.prototype.getMonthAndYearByIndex_ = function (index) {
	      return {
	        year: Math.floor(index / 12),
	        month: index % 12
	      };
	    };
	    Template_.prototype.getMonthAndYearOptionValue_ = function (data) {
	      return data.year + '-' + data.month;
	    };
	    Template_.prototype.parseMonthAndYearOptionValue_ = function (value) {
	      var parts = value.split('-');
	      return {
	        month: parseInt(parts[1], 10),
	        year: parseInt(parts[0], 10)
	      };
	    };
	    Template_.prototype.calculateDropdownRange_ = function (current, min, max) {
	      var limit = this.options_.getDropdownItemsLimit() - 1;
	      var maxAppend = Math.ceil(limit / 2);
	      var from = current - (limit - maxAppend);
	      var to = current + maxAppend;
	      if (from < min) {
	        to += min - from;
	        if (to > max) {
	          to = max;
	        }
	        from = min;
	      } else if (to > max) {
	        from -= to - max;
	        if (from < min) {
	          from = min;
	        }
	        to = max;
	      }
	      return {
	        from: from,
	        to: to
	      };
	    };
	    Template_.prototype.calculateDropdownDiff_ = function (options, newRange, getNumerical) {
	      var firstOption = options.length > 0 ? getNumerical(options[0].value) : null;
	      var lastOption = options.length > 0 ? getNumerical(options[options.length - 1].value) : null;
	      var prepend = [];
	      var append = [];
	      var remove = [];
	      for (var value = newRange.from; value <= newRange.to; value++) {
	        if (firstOption === null || value < firstOption) {
	          prepend.push(value);
	        } else if (value > lastOption) {
	          append.push(value);
	        }
	      }
	      for (var index = 0; index < options.length; index++) {
	        var value = getNumerical(options[index].value);
	        if (value < newRange.from || value > newRange.to) {
	          remove.push(options[index]);
	        }
	      }
	      return {
	        prepend: prepend,
	        append: append,
	        remove: remove
	      };
	    };
	    Template_.prototype.createTableElement_ = function (viewModel) {
	      var tableHeader = this.createTableHeaderElement_(viewModel);
	      var tableBody = this.createTableBodyElement_(viewModel);
	      var table = TheDatepicker.HtmlHelper_.createTable_(tableHeader, tableBody, TheDatepicker.ClassNameType.CalendarTable, this.options_);
	      TheDatepicker.HtmlHelper_.addClass_(table, TheDatepicker.ClassNameType.Table, this.options_);
	      return table;
	    };
	    Template_.prototype.createTableHeaderElement_ = function (viewModel) {
	      var weekDays = viewModel.getWeekDays_();
	      var cells = [];
	      for (var index = 0; index < weekDays.length; index++) {
	        var dayOfWeek = weekDays[index];
	        cells.push(this.createTableHeaderCellElement_(viewModel, dayOfWeek));
	      }
	      return TheDatepicker.HtmlHelper_.createTableHeader_(cells, TheDatepicker.ClassNameType.CalendarTableHeader, this.options_);
	    };
	    Template_.prototype.createTableHeaderCellElement_ = function (viewModel, dayOfWeek) {
	      var headerCell = TheDatepicker.HtmlHelper_.createTableHeaderCell_(TheDatepicker.ClassNameType.CalendarTableHeaderCell, this.options_);
	      if (dayOfWeek === TheDatepicker.DayOfWeek.Saturday || dayOfWeek === TheDatepicker.DayOfWeek.Sunday) {
	        TheDatepicker.HtmlHelper_.addClass_(headerCell, TheDatepicker.ClassNameType.WeekDayWeekend, this.options_);
	      }
	      headerCell.innerText = this.options_.translator.translateDayOfWeek(dayOfWeek);
	      return headerCell;
	    };
	    Template_.prototype.createTableBodyElement_ = function (viewModel) {
	      this.daysElements_ = [];
	      this.daysButtonsElements_ = [];
	      this.daysContentsElements_ = [];
	      var rows = [];
	      for (var index = 0; index < 6; index++) {
	        rows.push(this.createTableRowElement_(viewModel));
	      }
	      this.weeksElements_ = rows;
	      return TheDatepicker.HtmlHelper_.createTableBody_(rows, TheDatepicker.ClassNameType.CalendarTableBody, this.options_);
	    };
	    Template_.prototype.updateWeeksElements_ = function (viewModel) {
	      if (viewModel.yearSelectionState_) {
	        return;
	      }
	      var weeks = viewModel.getWeeks_();
	      for (var weekIndex = 0; weekIndex < this.weeksElements_.length; weekIndex++) {
	        var weekElement = this.weeksElements_[weekIndex];
	        var week = weeks.length > weekIndex ? weeks[weekIndex] : null;
	        weekElement.style.display = week ? '' : 'none';
	        if (week) {
	          for (var dayIndex = 0; dayIndex < this.daysElements_[weekIndex].length; dayIndex++) {
	            this.updateDayElement_(viewModel, this.daysElements_[weekIndex][dayIndex], this.daysButtonsElements_[weekIndex][dayIndex], this.daysContentsElements_[weekIndex][dayIndex], week[dayIndex]);
	          }
	        }
	      }
	    };
	    Template_.prototype.createTableRowElement_ = function (viewModel) {
	      var cells = [];
	      var cellsButtons = [];
	      var cellsContents = [];
	      for (var index = 0; index < 7; index++) {
	        var cell = TheDatepicker.HtmlHelper_.createTableCell_();
	        var cellButton = this.createTableCellButtonElement_(viewModel);
	        var cellContent = this.createTableCellContentElement_(viewModel);
	        cells.push(cell);
	        cellsButtons.push(cellButton);
	        cellsContents.push(cellContent);
	        cell.appendChild(cellButton);
	        cellButton.appendChild(cellContent);
	      }
	      this.daysElements_.push(cells);
	      this.daysButtonsElements_.push(cellsButtons);
	      this.daysContentsElements_.push(cellsContents);
	      return TheDatepicker.HtmlHelper_.createTableRow_(cells, this.options_);
	    };
	    Template_.prototype.updateDayElement_ = function (viewModel, dayElement, dayButtonElement, dayContentElement, day) {
	      dayButtonElement.day = day;
	      dayElement.setAttribute('data-date', day.getFormatted());
	      dayElement.className = '';
	      TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.TableCell, this.options_);
	      this.options_.updateCellStructure_(dayContentElement, day);
	      if (!day.isVisible) {
	        dayButtonElement.removeAttribute('href');
	        dayButtonElement.style.visibility = 'hidden';
	        return;
	      }
	      TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.Day, this.options_);
	      if (day.isToday) {
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.DayToday, this.options_);
	      }
	      if (day.isPast) {
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.DayPast, this.options_);
	      }
	      if (day.isWeekend) {
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.DayWeekend, this.options_);
	      }
	      if (!day.isAvailable) {
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.TableCellUnavailable, this.options_);
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.DayUnavailable, this.options_);
	      }
	      if (!day.isInCurrentMonth) {
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.DayOutside, this.options_);
	      }
	      if (day.isHighlighted) {
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.TableCellHighlighted, this.options_);
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.DayHighlighted, this.options_);
	      }
	      if (day.isSelected) {
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.TableCellSelected, this.options_);
	        TheDatepicker.HtmlHelper_.addClass_(dayElement, TheDatepicker.ClassNameType.DaySelected, this.options_);
	      }
	      var customClasses = this.options_.getCellClasses(day);
	      for (var index = 0; index < customClasses.length; index++) {
	        dayElement.className += ' ' + customClasses[index];
	      }
	      dayButtonElement.style.visibility = 'visible';
	      if (day.isAvailable) {
	        dayButtonElement.href = '#';
	      } else {
	        dayButtonElement.removeAttribute('href');
	      }
	      if (day.isFocused) {
	        dayButtonElement.focus();
	      }
	    };
	    Template_.prototype.createTableCellButtonElement_ = function (viewModel) {
	      var _this = this;
	      var cellButton = TheDatepicker.HtmlHelper_.createAnchor_(function (event) {
	        var previous = viewModel.selectedDate_;
	        var isSelected = viewModel.selectDay_(event, cellButton.day, false, true, true);
	        if (_this.options_.isHiddenOnSelect() && (isSelected || previous && cellButton.day.isEqualToDate(previous))) {
	          viewModel.close_(event);
	        }
	      }, this.options_);
	      TheDatepicker.HtmlHelper_.addClass_(cellButton, TheDatepicker.ClassNameType.DayButton, this.options_);
	      cellButton.onfocus = function (event) {
	        viewModel.highlightDay_(event || window.event, cellButton.day);
	      };
	      cellButton.onmouseenter = function (event) {
	        if (_this.options_.getBeforeFocusListeners().length > 0 || _this.options_.getFocusListeners().length > 0) {
	          viewModel.highlightDay_(event || window.event, cellButton.day, false, false);
	        } else {
	          viewModel.cancelDayHighlight_(event || window.event);
	        }
	      };
	      cellButton.onmouseleave = function (event) {
	        viewModel.cancelDayHighlight_(event || window.event);
	      };
	      return cellButton;
	    };
	    Template_.prototype.createTableCellContentElement_ = function (viewModel) {
	      var cellContent = this.options_.getCellStructure_();
	      TheDatepicker.HtmlHelper_.addClass_(cellContent, TheDatepicker.ClassNameType.ButtonContent, this.options_);
	      TheDatepicker.HtmlHelper_.addClass_(cellContent, TheDatepicker.ClassNameType.DayButtonContent, this.options_);
	      return cellContent;
	    };
	    Template_.prototype.createTableOfYearsElement_ = function (viewModel) {
	      var tableBody = this.createTableOfYearsBodyElement_(viewModel);
	      var table = TheDatepicker.HtmlHelper_.createTable_(null, tableBody, TheDatepicker.ClassNameType.YearsTable, this.options_);
	      TheDatepicker.HtmlHelper_.addClass_(table, TheDatepicker.ClassNameType.Table, this.options_);
	      return table;
	    };
	    Template_.prototype.createTableOfYearsBodyElement_ = function (viewModel) {
	      this.yearsElements_ = [];
	      this.yearsButtonsElements_ = [];
	      this.yearsContentsElements_ = [];
	      var rows = [];
	      for (var index = 0; index < this.options_.getTableOfYearsRowsCount(); index++) {
	        rows.push(this.createTableOfYearsRowElement_(viewModel));
	      }
	      return TheDatepicker.HtmlHelper_.createTableBody_(rows, TheDatepicker.ClassNameType.YearsTableBody, this.options_);
	    };
	    Template_.prototype.updateTableOfYearsRowsElements_ = function (viewModel) {
	      if (!viewModel.yearSelectionState_) {
	        return;
	      }
	      var rows = viewModel.getYearsRows_();
	      for (var rowIndex = 0; rowIndex < this.yearsElements_.length; rowIndex++) {
	        var cells = rows.length > rowIndex ? rows[rowIndex] : null;
	        if (cells) {
	          for (var columnIndex = 0; columnIndex < this.yearsElements_[rowIndex].length; columnIndex++) {
	            this.updateTableOfYearsCellElement_(viewModel, this.yearsElements_[rowIndex][columnIndex], this.yearsButtonsElements_[rowIndex][columnIndex], this.yearsContentsElements_[rowIndex][columnIndex], cells[columnIndex]);
	          }
	        }
	      }
	    };
	    Template_.prototype.updateTableOfYearsCellElement_ = function (viewModel, yearElement, yearButtonElement, yearContentElement, yearCellData) {
	      yearButtonElement.yearCellData = yearCellData;
	      yearElement.setAttribute('data-year', yearCellData.yearNumber + '');
	      yearElement.className = '';
	      TheDatepicker.HtmlHelper_.addClass_(yearElement, TheDatepicker.ClassNameType.TableCell, this.options_);
	      yearContentElement.innerText = yearCellData.yearNumber + '';
	      if (yearCellData.isAvailable) {
	        yearButtonElement.href = '#';
	      } else {
	        yearButtonElement.removeAttribute('href');
	        if (this.options_.areYearsOutOfTableOfYearsVisible()) {
	          TheDatepicker.HtmlHelper_.addClass_(yearElement, TheDatepicker.ClassNameType.TableCellUnavailable, this.options_);
	        } else {
	          yearButtonElement.style.visibility = 'hidden';
	          return;
	        }
	      }
	      if (yearCellData.isHighlighted) {
	        TheDatepicker.HtmlHelper_.addClass_(yearElement, TheDatepicker.ClassNameType.TableCellHighlighted, this.options_);
	      }
	      if (yearCellData.isSelected) {
	        TheDatepicker.HtmlHelper_.addClass_(yearElement, TheDatepicker.ClassNameType.TableCellSelected, this.options_);
	      }
	      yearButtonElement.style.visibility = 'visible';
	      if (yearCellData.isFocused) {
	        yearButtonElement.focus();
	      }
	    };
	    Template_.prototype.createTableOfYearsRowElement_ = function (viewModel) {
	      var cells = [];
	      var cellsButtons = [];
	      var cellsContents = [];
	      for (var index = 0; index < this.options_.getTableOfYearsColumnsCount(); index++) {
	        var cell = TheDatepicker.HtmlHelper_.createTableCell_();
	        var cellButton = this.createTableOfYearsCellButtonElement_(viewModel);
	        var cellContent = this.createTableOfYearsCellContentElement_(viewModel);
	        cells.push(cell);
	        cellsButtons.push(cellButton);
	        cellsContents.push(cellContent);
	        cell.appendChild(cellButton);
	        cellButton.appendChild(cellContent);
	      }
	      this.yearsElements_.push(cells);
	      this.yearsButtonsElements_.push(cellsButtons);
	      this.yearsContentsElements_.push(cellsContents);
	      return TheDatepicker.HtmlHelper_.createTableRow_(cells, this.options_);
	    };
	    Template_.prototype.createTableOfYearsCellButtonElement_ = function (viewModel) {
	      var _this = this;
	      var cellButton = TheDatepicker.HtmlHelper_.createAnchor_(function (event) {
	        var newMonth = new Date(cellButton.yearCellData.yearNumber, viewModel.getCurrentMonth_().getMonth(), 1);
	        var correctMonth = _this.options_.correctMonth(newMonth);
	        if (correctMonth.getFullYear() === newMonth.getFullYear()) {
	          viewModel.goToMonth_(event, correctMonth);
	          viewModel.isYearSelectionToggleButtonFocused_ = true;
	          _this.slideTable_(viewModel, TheDatepicker.MoveDirection_.Up, function () {
	            viewModel.setYearSelectionActive_(false);
	          });
	        }
	      }, this.options_);
	      TheDatepicker.HtmlHelper_.addClass_(cellButton, TheDatepicker.ClassNameType.YearCellButton, this.options_);
	      cellButton.onfocus = function () {
	        viewModel.highlightYear_(cellButton.yearCellData.yearNumber);
	      };
	      cellButton.onmouseenter = function () {
	        viewModel.cancelYearHighlight_();
	      };
	      cellButton.onmouseleave = function () {
	        viewModel.cancelYearHighlight_();
	      };
	      return cellButton;
	    };
	    Template_.prototype.createTableOfYearsCellContentElement_ = function (viewModel) {
	      var cellContent = TheDatepicker.HtmlHelper_.createSpan_();
	      TheDatepicker.HtmlHelper_.addClass_(cellContent, TheDatepicker.ClassNameType.ButtonContent, this.options_);
	      TheDatepicker.HtmlHelper_.addClass_(cellContent, TheDatepicker.ClassNameType.YearCellButtonContent, this.options_);
	      return cellContent;
	    };
	    Template_.prototype.slideTable_ = function (viewModel, moveDirection, onComplete) {
	      var _this = this;
	      if (!this.options_.isSlideAnimationEnabled() || !TheDatepicker.Helper_.isCssAnimationSupported_()) {
	        onComplete();
	        return;
	      }
	      var trigger = function () {
	        var animationOut;
	        var animationIn;
	        switch (moveDirection) {
	          case TheDatepicker.MoveDirection_.Left:
	            animationOut = TheDatepicker.ClassNameType.AnimateFadeOutLeft;
	            animationIn = TheDatepicker.ClassNameType.AnimateFadeInRight;
	            break;
	          case TheDatepicker.MoveDirection_.Up:
	            animationOut = TheDatepicker.ClassNameType.AnimateFadeOutUp;
	            animationIn = TheDatepicker.ClassNameType.AnimateFadeInDown;
	            break;
	          case TheDatepicker.MoveDirection_.Right:
	            animationOut = TheDatepicker.ClassNameType.AnimateFadeOutRight;
	            animationIn = TheDatepicker.ClassNameType.AnimateFadeInLeft;
	            break;
	          case TheDatepicker.MoveDirection_.Down:
	            animationOut = TheDatepicker.ClassNameType.AnimateFadeOutDown;
	            animationIn = TheDatepicker.ClassNameType.AnimateFadeInUp;
	            break;
	        }
	        var originalClassName = _this.tablesElement_.className;
	        var animate = function (type) {
	          TheDatepicker.HtmlHelper_.addClass_(_this.tablesElement_, TheDatepicker.ClassNameType.Animated, _this.options_);
	          TheDatepicker.HtmlHelper_.addClass_(_this.tablesElement_, type, _this.options_);
	        };
	        var onAfterSlide = function () {
	          if (_this.onAfterSlide_.length > 0) {
	            _this.onAfterSlide_.shift()();
	          } else {
	            _this.onAfterSlide_ = null;
	          }
	        };
	        var listenerRemover;
	        var timeoutId = window.setTimeout(function () {
	          listenerRemover();
	          onComplete();
	          onAfterSlide();
	        }, 150);
	        listenerRemover = TheDatepicker.Helper_.addEventListener_(_this.tablesElement_, TheDatepicker.ListenerType_.AnimationEnd, function () {
	          window.clearTimeout(timeoutId);
	          onComplete();
	          listenerRemover();
	          _this.tablesElement_.className = originalClassName;
	          animate(animationIn);
	          listenerRemover = TheDatepicker.Helper_.addEventListener_(_this.tablesElement_, TheDatepicker.ListenerType_.AnimationEnd, function () {
	            listenerRemover();
	            _this.tablesElement_.className = originalClassName;
	            onAfterSlide();
	          });
	        });
	        animate(animationOut);
	      };
	      if (this.onAfterSlide_) {
	        this.onAfterSlide_.push(trigger);
	      } else {
	        this.onAfterSlide_ = [];
	        trigger();
	      }
	    };
	    Template_.prototype.translateMonth_ = function (monthNumber) {
	      return this.options_.isMonthShort() ? this.options_.translator.translateMonthShort(monthNumber) : this.options_.translator.translateMonth(monthNumber);
	    };
	    Template_.prototype.updateTitle_ = function (element, titleName) {
	      var title = this.options_.translator.translateTitle(titleName);
	      if (title !== '') {
	        element.title = title;
	        if (this.options_.isAriaIncluded()) {
	          element.setAttribute('aria-label', title);
	        }
	      } else {
	        element.removeAttribute('title');
	        element.removeAttribute('aria-label');
	      }
	    };
	    return Template_;
	  }();
	  TheDatepicker.Template_ = Template_;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  (function (TitleName) {
	    TitleName[TitleName["GoBack"] = 0] = "GoBack";
	    TitleName[TitleName["GoForward"] = 1] = "GoForward";
	    TitleName[TitleName["Close"] = 2] = "Close";
	    TitleName[TitleName["Reset"] = 3] = "Reset";
	    TitleName[TitleName["Deselect"] = 4] = "Deselect";
	    TitleName[TitleName["Month"] = 5] = "Month";
	    TitleName[TitleName["Year"] = 6] = "Year";
	    TitleName[TitleName["GoBackTableOfYears"] = 7] = "GoBackTableOfYears";
	    TitleName[TitleName["GoForwardTableOfYears"] = 8] = "GoForwardTableOfYears";
	  })(TheDatepicker.TitleName || (TheDatepicker.TitleName = {}));
	  var Translator = function () {
	    function Translator() {
	      this.dayOfWeekFullTranslations_ = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	      this.dayOfWeekTranslations_ = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	      this.monthTranslations_ = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	      this.monthShortTranslations_ = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	      this.titles_ = ['Go to previous month', 'Go to next month', 'Close calendar', 'Reset calendar', 'Deselect date', 'Month selection', 'Year selection', 'Show earlier years', 'Show later years'];
	    }
	    Translator.prototype.clone = function () {
	      var translator = new Translator();
	      var index;
	      for (index = 0; index < this.dayOfWeekFullTranslations_.length; index++) {
	        translator.dayOfWeekFullTranslations_ = this.dayOfWeekFullTranslations_.slice(0);
	      }
	      for (index = 0; index < this.dayOfWeekTranslations_.length; index++) {
	        translator.dayOfWeekTranslations_ = this.dayOfWeekTranslations_.slice(0);
	      }
	      for (index = 0; index < this.monthTranslations_.length; index++) {
	        translator.monthTranslations_ = this.monthTranslations_.slice(0);
	      }
	      for (index = 0; index < this.monthShortTranslations_.length; index++) {
	        translator.monthShortTranslations_ = this.monthShortTranslations_.slice(0);
	      }
	      for (index = 0; index < this.titles_.length; index++) {
	        translator.titles_ = this.titles_.slice(0);
	      }
	      return translator;
	    };
	    Translator.prototype.setDayOfWeekTranslation = function (dayOfWeek, translation) {
	      this.dayOfWeekTranslations_[TheDatepicker.Helper_.checkNumber_('Day of week', dayOfWeek, 0, 6)] = TheDatepicker.Helper_.checkString_('Translation', translation, true);
	    };
	    Translator.prototype.setDayOfWeekFullTranslation = function (dayOfWeek, translation) {
	      this.dayOfWeekFullTranslations_[TheDatepicker.Helper_.checkNumber_('Day of week', dayOfWeek, 0, 6)] = TheDatepicker.Helper_.checkString_('Translation', translation, true);
	    };
	    Translator.prototype.setMonthTranslation = function (month, translation) {
	      this.monthTranslations_[TheDatepicker.Helper_.checkNumber_('Month', month, 0, 11)] = TheDatepicker.Helper_.checkString_('Translation', translation, true);
	    };
	    Translator.prototype.setMonthShortTranslation = function (month, translation) {
	      this.monthShortTranslations_[TheDatepicker.Helper_.checkNumber_('Month', month, 0, 11)] = TheDatepicker.Helper_.checkString_('Translation', translation, true);
	    };
	    Translator.prototype.setTitleTranslation = function (titleName, translation) {
	      this.titles_[TheDatepicker.Helper_.checkNumber_('Title', titleName, 0, this.titles_.length - 1)] = TheDatepicker.Helper_.checkString_('Translation', translation);
	    };
	    Translator.prototype.translateDayOfWeek = function (dayOfWeek) {
	      return this.dayOfWeekTranslations_[dayOfWeek];
	    };
	    Translator.prototype.translateDayOfWeekFull = function (dayOfWeek) {
	      return this.dayOfWeekFullTranslations_[dayOfWeek];
	    };
	    Translator.prototype.translateMonth = function (month) {
	      return this.monthTranslations_[month];
	    };
	    Translator.prototype.translateMonthShort = function (month) {
	      return this.monthShortTranslations_[month];
	    };
	    Translator.prototype.translateTitle = function (titleName) {
	      return this.titles_[titleName];
	    };
	    return Translator;
	  }();
	  TheDatepicker.Translator = Translator;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker;
	(function (TheDatepicker) {
	  var MoveDirection_;
	  (function (MoveDirection_) {
	    MoveDirection_[MoveDirection_["Left"] = 1] = "Left";
	    MoveDirection_[MoveDirection_["Up"] = 2] = "Up";
	    MoveDirection_[MoveDirection_["Right"] = 3] = "Right";
	    MoveDirection_[MoveDirection_["Down"] = 4] = "Down";
	  })(MoveDirection_ = TheDatepicker.MoveDirection_ || (TheDatepicker.MoveDirection_ = {}));
	  var YearSelectionState = function () {
	    function YearSelectionState(cellsCount, lowestYear, maxPage, page) {
	      this.cellsCount = cellsCount;
	      this.lowestYear = lowestYear;
	      this.maxPage = maxPage;
	      this.page = page;
	      this.highlightedYear = null;
	      this.isHighlightedYearFocused = false;
	      this.initialPage = page;
	    }
	    YearSelectionState.prototype.getPage = function () {
	      return this.page;
	    };
	    YearSelectionState.prototype.canShiftPage = function (shift) {
	      var newPage = this.page + shift;
	      return newPage >= 0 && newPage <= this.maxPage;
	    };
	    YearSelectionState.prototype.shiftPage = function (shift) {
	      if (!this.canShiftPage(shift)) {
	        return false;
	      }
	      this.page += shift;
	      return true;
	    };
	    YearSelectionState.prototype.getFirstYear = function () {
	      return this.lowestYear + this.page * this.cellsCount;
	    };
	    YearSelectionState.prototype.getLastYear = function () {
	      return this.lowestYear + this.page * this.cellsCount + this.cellsCount - 1;
	    };
	    YearSelectionState.prototype.highlightYear = function (year, doFocus) {
	      if (doFocus === void 0) {
	        doFocus = true;
	      }
	      if (!this || year === this.highlightedYear) {
	        return false;
	      }
	      this.highlightedYear = year;
	      if (doFocus) {
	        this.isHighlightedYearFocused = true;
	      }
	      if (year < this.getFirstYear()) {
	        this.shiftPage(-1);
	      }
	      if (year > this.getLastYear()) {
	        this.shiftPage(1);
	      }
	      return true;
	    };
	    YearSelectionState.prototype.cancelHighlight = function () {
	      if (!this.highlightedYear) {
	        return false;
	      }
	      this.highlightedYear = null;
	      return true;
	    };
	    return YearSelectionState;
	  }();
	  var ViewModel_ = function () {
	    function ViewModel_(options_, datepicker_) {
	      this.options_ = options_;
	      this.datepicker_ = datepicker_;
	      this.selectedDate_ = null;
	      this.yearSelectionState_ = null;
	      this.isYearSelectionToggleButtonFocused_ = false;
	      this.tableOfYearsSettings_ = null;
	      this.initialMonth_ = null;
	      this.currentMonth_ = null;
	      this.outsideDates_ = null;
	      this.highlightedDay_ = null;
	      this.isHighlightedDayFocused_ = false;
	      this.active_ = false;
	      this.template_ = new TheDatepicker.Template_(this.options_, datepicker_.container, !!datepicker_.input);
	    }
	    ViewModel_.prototype.render_ = function () {
	      if (this.datepicker_.isDestroyed() || this.selectPossibleDate_()) {
	        return;
	      }
	      var correctMonth = this.options_.correctMonth(this.getCurrentMonth_());
	      if (this.goToMonth_(null, correctMonth)) {
	        return;
	      }
	      if (!this.tableOfYearsSettings_) {
	        this.tableOfYearsSettings_ = {
	          rowsCount: this.options_.getTableOfYearsRowsCount(),
	          columnsCount: this.options_.getTableOfYearsColumnsCount()
	        };
	      }
	      this.template_.render_(this);
	      this.datepicker_.updateInput_();
	    };
	    ViewModel_.prototype.setActive_ = function (event, value) {
	      if (this.active_ === value) {
	        return true;
	      }
	      if (value && !this.triggerOnBeforeOpen_(event) || !value && !this.triggerOnBeforeClose_(event)) {
	        return false;
	      }
	      this.active_ = value;
	      if ((!value && !this.setYearSelectionActive_(false) || value) && this.options_.isHiddenOnBlur()) {
	        this.render_();
	      }
	      if (value) {
	        this.triggerOnOpen_(event);
	      } else {
	        this.triggerOnClose_(event);
	      }
	      return true;
	    };
	    ViewModel_.prototype.isActive_ = function () {
	      return this.active_;
	    };
	    ViewModel_.prototype.close_ = function (event) {
	      return this.datepicker_.close(event);
	    };
	    ViewModel_.prototype.getCurrentMonth_ = function () {
	      if (!this.currentMonth_) {
	        this.setCurrentMonth_(this.getInitialMonth_());
	      }
	      return this.currentMonth_;
	    };
	    ViewModel_.prototype.canGoDirection_ = function (isForward) {
	      var delta = isForward ? 1 : -1;
	      if (this.yearSelectionState_) {
	        return this.yearSelectionState_.canShiftPage(delta);
	      }
	      var newMonth = new Date(this.getCurrentMonth_().getTime());
	      newMonth.setMonth(newMonth.getMonth() + delta);
	      return this.canGoToMonth_(newMonth);
	    };
	    ViewModel_.prototype.canGoToMonth_ = function (month) {
	      if (!TheDatepicker.Helper_.isValidDate_(month)) {
	        return false;
	      }
	      return this.options_.isMonthInValidity(month);
	    };
	    ViewModel_.prototype.goDirection_ = function (event, isForward) {
	      var delta = isForward ? 1 : -1;
	      if (this.yearSelectionState_) {
	        if (this.yearSelectionState_.shiftPage(delta)) {
	          this.render_();
	        }
	        return;
	      }
	      var newMonth = new Date(this.getCurrentMonth_().getTime());
	      newMonth.setMonth(newMonth.getMonth() + delta);
	      return this.goToMonth_(event, newMonth);
	    };
	    ViewModel_.prototype.goToMonth_ = function (event, month, doCancelHighlight) {
	      if (doCancelHighlight === void 0) {
	        doCancelHighlight = true;
	      }
	      month = TheDatepicker.Helper_.resetTime_(new Date(month.getTime()));
	      month.setDate(1);
	      if (month.getTime() === this.getCurrentMonth_().getTime() || !this.canGoToMonth_(month)) {
	        return false;
	      }
	      if (!this.triggerOnBeforeMonthChange_(event, month, this.currentMonth_)) {
	        return false;
	      }
	      this.setCurrentMonth_(month);
	      if (!doCancelHighlight || !this.cancelDayHighlight_(event)) {
	        this.render_();
	      }
	      this.triggerOnMonthChange_(event, month, this.currentMonth_);
	      if (this.selectedDate_ && this.options_.isSelectedDateBoundWithMonth()) {
	        var maxDate = new Date(month.getFullYear(), month.getMonth() + 1, 0);
	        var date = this.options_.calculateNearestAvailableDate_(new Date(month.getFullYear(), month.getMonth(), Math.min(this.selectedDate_.getDate(), maxDate.getDate())), month, maxDate);
	        if (date) {
	          this.selectDay_(event, date);
	        }
	      }
	      return true;
	    };
	    ViewModel_.prototype.reset_ = function (event) {
	      this.initialMonth_ = null;
	      var isMonthChanged = this.goToMonth_(event, this.getInitialMonth_());
	      var isDaySelected = this.selectInitialDate_(event);
	      return isMonthChanged || isDaySelected;
	    };
	    ViewModel_.prototype.selectDay_ = function (event, date, doUpdateMonth, doHighlight, canToggle) {
	      if (doUpdateMonth === void 0) {
	        doUpdateMonth = true;
	      }
	      if (doHighlight === void 0) {
	        doHighlight = false;
	      }
	      if (canToggle === void 0) {
	        canToggle = false;
	      }
	      if (!date) {
	        return this.cancelSelection_(event);
	      }
	      var day;
	      if (date instanceof TheDatepicker.Day) {
	        day = date;
	        date = day.getDate();
	      } else {
	        day = this.createDay_(date);
	      }
	      if (!day.isAvailable) {
	        return false;
	      }
	      if (day.isEqualToDate(this.selectedDate_)) {
	        if (canToggle && this.options_.hasToggleSelection()) {
	          return this.cancelSelection_(event);
	        }
	        return false;
	      }
	      var previousDay = this.selectedDate_ ? this.createDay_(this.selectedDate_) : null;
	      if (!this.triggerOnBeforeSelect_(event, day, previousDay)) {
	        return false;
	      }
	      this.selectedDate_ = day.getDate();
	      if (doHighlight) {
	        this.highlightDay_(event, day);
	      }
	      doUpdateMonth = doUpdateMonth || this.options_.isSelectedDateBoundWithMonth();
	      if (!doUpdateMonth || !this.goToMonth_(event, date)) {
	        this.render_();
	      }
	      this.triggerOnSelect_(event, day, previousDay);
	      return true;
	    };
	    ViewModel_.prototype.canSetYearSelectionActive_ = function (value) {
	      return !!this.yearSelectionState_ !== value && (!value || this.options_.getMinDate_().getFullYear() !== this.options_.getMaxDate_().getFullYear());
	    };
	    ViewModel_.prototype.setYearSelectionActive_ = function (value) {
	      if (this.canSetYearSelectionActive_(value)) {
	        this.yearSelectionState_ = value ? this.createYearSelectionState_() : null;
	        this.render_();
	        return true;
	      }
	      return false;
	    };
	    ViewModel_.prototype.selectNearestDate_ = function (event, date) {
	      return this.selectDay_(event, this.options_.findNearestAvailableDate(date));
	    };
	    ViewModel_.prototype.selectPossibleDate_ = function () {
	      try {
	        return this.selectDay_(null, this.options_.findPossibleAvailableDate(this.selectedDate_), false);
	      } catch (error) {
	        if (!(error instanceof TheDatepicker.AvailableDateNotFoundException)) {
	          throw error;
	        }
	        return this.cancelSelection_(null, true);
	      }
	    };
	    ViewModel_.prototype.selectInitialDate_ = function (event) {
	      try {
	        return this.selectDay_(event, this.options_.getInitialDate(), false);
	      } catch (error) {
	        if (!(error instanceof TheDatepicker.AvailableDateNotFoundException)) {
	          throw error;
	        }
	        return this.cancelSelection_(null, true);
	      }
	    };
	    ViewModel_.prototype.highlightDay_ = function (event, day, doUpdateMonth, doFocus) {
	      if (doUpdateMonth === void 0) {
	        doUpdateMonth = false;
	      }
	      if (doFocus === void 0) {
	        doFocus = true;
	      }
	      if (!day.isAvailable) {
	        return false;
	      }
	      if (day.isEqualToDay(this.highlightedDay_)) {
	        return false;
	      }
	      var previousDay = this.highlightedDay_;
	      if (!this.triggerOnBeforeFocus_(event, day, previousDay)) {
	        return false;
	      }
	      this.highlightedDay_ = day;
	      if (doFocus) {
	        this.isHighlightedDayFocused_ = true;
	      }
	      var date = day.getDate();
	      if (!doUpdateMonth || !this.goToMonth_(event, date, false)) {
	        this.render_();
	      }
	      this.triggerOnFocus_(event, day, previousDay);
	      return true;
	    };
	    ViewModel_.prototype.highlightFirstAvailableDay_ = function (event) {
	      var maxDate = this.options_.getMaxDate_();
	      var day = this.createDay_(new Date(this.getCurrentMonth_().getTime()));
	      while (!day.isAvailable) {
	        var sibling = day.getSibling();
	        if (sibling.dayNumber === 1) {
	          break;
	        }
	        if (sibling.getDate().getTime() > maxDate.getTime()) {
	          break;
	        }
	        day = sibling;
	      }
	      return this.highlightDay_(event, day);
	    };
	    ViewModel_.prototype.highlightSiblingDay_ = function (event, day, direction) {
	      var shift;
	      switch (direction) {
	        case MoveDirection_.Left:
	          shift = -1;
	          break;
	        case MoveDirection_.Up:
	          shift = -7;
	          break;
	        case MoveDirection_.Right:
	          shift = 1;
	          break;
	        case MoveDirection_.Down:
	          shift = 7;
	          break;
	      }
	      var newDay = day;
	      var maxLoops = 1000;
	      do {
	        newDay = newDay.getSibling(shift);
	        if (!newDay.isInValidity) {
	          break;
	        }
	        maxLoops--;
	      } while (!newDay.isAvailable && maxLoops > 0);
	      return this.highlightDay_(event, newDay, true);
	    };
	    ViewModel_.prototype.cancelSelection_ = function (event, force) {
	      if (force === void 0) {
	        force = false;
	      }
	      if (!this.options_.isAllowedEmpty() && !force) {
	        return false;
	      }
	      if (!this.selectedDate_) {
	        return false;
	      }
	      var previousDay = this.createDay_(this.selectedDate_);
	      if (!this.triggerOnBeforeSelect_(event, null, previousDay)) {
	        return false;
	      }
	      this.selectedDate_ = null;
	      this.render_();
	      this.triggerOnSelect_(event, null, previousDay);
	      return true;
	    };
	    ViewModel_.prototype.cancelDayHighlight_ = function (event) {
	      if (!this.highlightedDay_) {
	        return false;
	      }
	      var previousDay = this.highlightedDay_;
	      if (!this.triggerOnBeforeFocus_(event, null, previousDay)) {
	        return false;
	      }
	      this.highlightedDay_ = null;
	      this.render_();
	      this.triggerOnFocus_(event, null, previousDay);
	      return true;
	    };
	    ViewModel_.prototype.highlightYear_ = function (year, doFocus) {
	      if (doFocus === void 0) {
	        doFocus = true;
	      }
	      if (this.yearSelectionState_ && this.yearSelectionState_.highlightYear(year, doFocus)) {
	        this.render_();
	        return true;
	      }
	      return false;
	    };
	    ViewModel_.prototype.highlightSiblingYear_ = function (year, direction) {
	      var shift;
	      switch (direction) {
	        case MoveDirection_.Left:
	          shift = -1;
	          break;
	        case MoveDirection_.Up:
	          shift = -this.tableOfYearsSettings_.columnsCount;
	          break;
	        case MoveDirection_.Right:
	          shift = 1;
	          break;
	        case MoveDirection_.Down:
	          shift = this.tableOfYearsSettings_.columnsCount;
	          break;
	      }
	      var newYear = year + shift;
	      if (newYear < this.options_.getMinDate_().getFullYear() || newYear > this.options_.getMaxDate_().getFullYear()) {
	        return;
	      }
	      return this.highlightYear_(newYear, true);
	    };
	    ViewModel_.prototype.cancelYearHighlight_ = function () {
	      if (this.yearSelectionState_ && this.yearSelectionState_.cancelHighlight()) {
	        this.render_();
	        return true;
	      }
	      return true;
	    };
	    ViewModel_.prototype.getWeekDays_ = function () {
	      var weekDays = [];
	      for (var day = 0; day < 7; day++) {
	        weekDays.push((this.options_.getFirstDayOfWeek() + day) % 7);
	      }
	      return weekDays;
	    };
	    ViewModel_.prototype.getWeeks_ = function () {
	      var days = [];
	      var currentMonth = this.getCurrentMonth_();
	      var outsideDates = this.getOutsideDates_();
	      for (var index = 0; index < outsideDates.prepend.length; index++) {
	        var day = this.createDay_(outsideDates.prepend[index]);
	        days.push(day);
	      }
	      var lastDateOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
	      var monthDaysCount = lastDateOfMonth.getDate();
	      for (var date = 1; date <= monthDaysCount; date++) {
	        days.push(this.createDay_(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), date)));
	      }
	      for (var index = 0; index < outsideDates.append.length; index++) {
	        var day = this.createDay_(outsideDates.append[index]);
	        days.push(day);
	      }
	      var weeks = [];
	      for (var i = 0; i < days.length; i += 7) {
	        weeks.push(days.slice(i, i + 7));
	      }
	      this.isHighlightedDayFocused_ = false;
	      return weeks;
	    };
	    ViewModel_.prototype.getYearsRows_ = function () {
	      if (!this.yearSelectionState_) {
	        return [];
	      }
	      var yearsData = [];
	      var minYear = this.options_.getMinDate_().getFullYear();
	      var maxYear = this.options_.getMaxDate_().getFullYear();
	      var currentYear = this.getCurrentMonth_().getFullYear();
	      var firstYear = this.yearSelectionState_.getFirstYear();
	      for (var year = firstYear; year <= firstYear + this.yearSelectionState_.cellsCount; year++) {
	        var yearCellData = new TheDatepicker.YearCellData_(year);
	        if (year > maxYear || year < minYear) {
	          yearCellData.isAvailable = false;
	        } else {
	          if (year === currentYear) {
	            yearCellData.isSelected = true;
	          }
	          if (year === this.yearSelectionState_.highlightedYear) {
	            yearCellData.isHighlighted = true;
	            if (this.yearSelectionState_.isHighlightedYearFocused) {
	              yearCellData.isFocused = true;
	            }
	          }
	        }
	        yearsData.push(yearCellData);
	      }
	      var yearsRows = [];
	      for (var i = 0; i < yearsData.length; i += this.tableOfYearsSettings_.columnsCount) {
	        yearsRows.push(yearsData.slice(i, i + this.tableOfYearsSettings_.columnsCount));
	      }
	      this.yearSelectionState_.isHighlightedYearFocused;
	      return yearsRows;
	    };
	    ViewModel_.prototype.createYearSelectionState_ = function () {
	      var align = this.options_.getTableOfYearsAlign();
	      var minDate = this.options_.getMinDate();
	      var maxDate = this.options_.getMaxDate();
	      var initialYear = this.getInitialMonth_().getFullYear();
	      if (align === TheDatepicker.Align.Left && minDate === null || align === TheDatepicker.Align.Right && maxDate === null) {
	        align = null;
	      }
	      if (!align) {
	        if (minDate && maxDate) {
	          var lowDiff = initialYear - minDate.getFullYear();
	          var highDiff = maxDate.getFullYear() - initialYear;
	          align = lowDiff > highDiff ? TheDatepicker.Align.Right : TheDatepicker.Align.Left;
	        } else if (minDate) {
	          align = TheDatepicker.Align.Left;
	        } else if (maxDate) {
	          align = TheDatepicker.Align.Right;
	        } else {
	          align = TheDatepicker.Align.Center;
	        }
	      }
	      var lowestYear;
	      var cellsCount = this.tableOfYearsSettings_.rowsCount * this.tableOfYearsSettings_.columnsCount;
	      var minYear = this.options_.getMinDate_().getFullYear();
	      var maxYear = this.options_.getMaxDate_().getFullYear();
	      switch (align) {
	        case TheDatepicker.Align.Left:
	          lowestYear = minYear;
	          break;
	        case TheDatepicker.Align.Right:
	          lowestYear = minYear - (cellsCount - (maxYear - minYear) % cellsCount - 1);
	          break;
	        case TheDatepicker.Align.Center:
	          var shift = Math.floor(this.tableOfYearsSettings_.rowsCount / 2) * this.tableOfYearsSettings_.columnsCount + Math.floor(this.tableOfYearsSettings_.columnsCount / 2);
	          lowestYear = minYear - (cellsCount - (initialYear + shift - minYear) % cellsCount - 1);
	          break;
	        default:
	          throw new Error('Invalid align: ' + align);
	      }
	      var currentYear = this.getCurrentMonth_().getFullYear();
	      var page = Math.floor((currentYear - lowestYear) / cellsCount);
	      return new YearSelectionState(cellsCount, lowestYear, Math.floor((maxYear - lowestYear) / cellsCount), page);
	    };
	    ViewModel_.prototype.triggerKeyPress_ = function (event) {
	      if (TheDatepicker.Helper_.inArray_([TheDatepicker.KeyCode_.Left, TheDatepicker.KeyCode_.Up, TheDatepicker.KeyCode_.Right, TheDatepicker.KeyCode_.Down], event.keyCode)) {
	        TheDatepicker.Helper_.preventDefault_(event);
	        var moveDirection = this.translateKeyCodeToMoveDirection_(event.keyCode);
	        if (this.yearSelectionState_) {
	          if (this.yearSelectionState_.highlightedYear) {
	            this.highlightSiblingYear_(this.yearSelectionState_.highlightedYear, moveDirection);
	          } else if (this.yearSelectionState_.getPage() === this.yearSelectionState_.initialPage) {
	            this.highlightSiblingYear_(this.getCurrentMonth_().getFullYear(), moveDirection);
	          } else {
	            this.highlightYear_(this.yearSelectionState_.getPage() === 0 ? this.yearSelectionState_.lowestYear : this.yearSelectionState_.getFirstYear());
	          }
	        } else {
	          if (this.highlightedDay_) {
	            this.highlightSiblingDay_(event, this.highlightedDay_, moveDirection);
	          } else if (this.selectedDate_ && this.selectedDate_.getFullYear() === this.getCurrentMonth_().getFullYear() && this.selectedDate_.getMonth() === this.getCurrentMonth_().getMonth()) {
	            this.highlightSiblingDay_(event, this.createDay_(this.selectedDate_), moveDirection);
	          } else {
	            this.highlightFirstAvailableDay_(event);
	          }
	        }
	      } else if (event.keyCode === TheDatepicker.KeyCode_.Esc && this.options_.isClosedOnEscPress()) {
	        if (this.yearSelectionState_) {
	          this.isYearSelectionToggleButtonFocused_ = true;
	          this.setYearSelectionActive_(false);
	        } else {
	          this.datepicker_.close(event);
	        }
	      }
	    };
	    ViewModel_.prototype.createDay_ = function (date) {
	      var _this = this;
	      date = TheDatepicker.Helper_.resetTime_(new Date(date.getTime()));
	      var today = this.options_.getToday();
	      var currentMonth = this.getCurrentMonth_();
	      var day = new TheDatepicker.Day(date, function (date) {
	        return _this.createDay_(date);
	      }, function (date, format) {
	        if (format === void 0) {
	          format = null;
	        }
	        return TheDatepicker.DateConverter_.formatDate_(date, _this.options_, format);
	      });
	      day.isToday = date.getTime() === today.getTime();
	      day.isPast = date.getTime() < today.getTime();
	      day.isInValidity = this.options_.isDateInValidity(date);
	      day.isAvailable = day.isInValidity && this.options_.isDateAvailable(date);
	      day.isInCurrentMonth = date.getMonth() === currentMonth.getMonth();
	      if (day.isInCurrentMonth) {
	        day.isVisible = true;
	      } else if (this.options_.areDaysOutOfMonthVisible()) {
	        var outsideDates = this.getOutsideDates_();
	        var pendants = outsideDates.prepend.concat(outsideDates.append);
	        for (var index = 0; index < pendants.length; index++) {
	          if (date.getTime() === pendants[index].getTime()) {
	            day.isVisible = true;
	            break;
	          }
	        }
	      }
	      if (day.isAvailable) {
	        if (day.isEqualToDate(this.selectedDate_)) {
	          day.isSelected = true;
	        }
	        if (day.isEqualToDay(this.highlightedDay_)) {
	          day.isHighlighted = true;
	          if (this.isHighlightedDayFocused_) {
	            day.isFocused = true;
	          }
	        }
	      }
	      this.options_.modifyDay(day);
	      return day;
	    };
	    ViewModel_.prototype.triggerOnBeforeSelect_ = function (event, day, previousDay) {
	      var _this = this;
	      return this.options_.triggerEvent_(TheDatepicker.EventType_.BeforeSelect, function (listener) {
	        return listener.call(_this.datepicker_, event, day, previousDay);
	      });
	    };
	    ViewModel_.prototype.triggerOnSelect_ = function (event, day, previousDay) {
	      var _this = this;
	      this.options_.triggerEvent_(TheDatepicker.EventType_.Select, function (listener) {
	        return listener.call(_this.datepicker_, event, day, previousDay);
	      });
	    };
	    ViewModel_.prototype.triggerOnBeforeOpen_ = function (event) {
	      var _this = this;
	      return this.options_.triggerEvent_(TheDatepicker.EventType_.BeforeOpen, function (listener) {
	        return listener.call(_this.datepicker_, event, true);
	      });
	    };
	    ViewModel_.prototype.triggerOnOpen_ = function (event) {
	      var _this = this;
	      this.options_.triggerEvent_(TheDatepicker.EventType_.Open, function (listener) {
	        return listener.call(_this.datepicker_, event, true);
	      });
	    };
	    ViewModel_.prototype.triggerOnBeforeClose_ = function (event) {
	      var _this = this;
	      return this.options_.triggerEvent_(TheDatepicker.EventType_.BeforeClose, function (listener) {
	        return listener.call(_this.datepicker_, event, false);
	      });
	    };
	    ViewModel_.prototype.triggerOnClose_ = function (event) {
	      var _this = this;
	      this.options_.triggerEvent_(TheDatepicker.EventType_.Close, function (listener) {
	        return listener.call(_this.datepicker_, event, false);
	      });
	    };
	    ViewModel_.prototype.triggerOnBeforeMonthChange_ = function (event, month, previousMonth) {
	      var _this = this;
	      return this.options_.triggerEvent_(TheDatepicker.EventType_.BeforeMonthChange, function (listener) {
	        return listener.call(_this.datepicker_, event, month, previousMonth);
	      });
	    };
	    ViewModel_.prototype.triggerOnMonthChange_ = function (event, month, previousMonth) {
	      var _this = this;
	      this.options_.triggerEvent_(TheDatepicker.EventType_.MonthChange, function (listener) {
	        return listener.call(_this.datepicker_, event, month, previousMonth);
	      });
	    };
	    ViewModel_.prototype.triggerOnBeforeFocus_ = function (event, day, previousDay) {
	      var _this = this;
	      return this.options_.triggerEvent_(TheDatepicker.EventType_.BeforeFocus, function (listener) {
	        return listener.call(_this.datepicker_, event, day, previousDay);
	      });
	    };
	    ViewModel_.prototype.triggerOnFocus_ = function (event, day, previousDay) {
	      var _this = this;
	      this.options_.triggerEvent_(TheDatepicker.EventType_.Focus, function (listener) {
	        return listener.call(_this.datepicker_, event, day, previousDay);
	      });
	    };
	    ViewModel_.prototype.setCurrentMonth_ = function (month) {
	      this.currentMonth_ = month;
	      this.outsideDates_ = null;
	    };
	    ViewModel_.prototype.getOutsideDates_ = function () {
	      if (this.outsideDates_) {
	        return this.outsideDates_;
	      }
	      var currentMonth = this.getCurrentMonth_();
	      var firstDayOfWeek = this.options_.getFirstDayOfWeek();
	      var firstDateOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
	      var lastMonthDaysCount = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 0).getDate();
	      var prependDaysCount = (firstDateOfMonth.getDay() - firstDayOfWeek + 7) % 7;
	      var prepend = [];
	      for (var date = lastMonthDaysCount - prependDaysCount + 1; date <= lastMonthDaysCount; date++) {
	        prepend.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, date));
	      }
	      var lastDateOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
	      var appendDaysCount = 6 - (lastDateOfMonth.getDay() - firstDayOfWeek + 7) % 7;
	      var append = [];
	      for (var date = 1; date <= appendDaysCount; date++) {
	        append.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, date));
	      }
	      if (this.options_.hasFixedRowsCount()) {
	        var monthDaysCount = lastDateOfMonth.getDate();
	        for (var date = appendDaysCount + 1; prependDaysCount + monthDaysCount + append.length < 6 * 7; date++) {
	          append.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, date));
	        }
	      }
	      this.outsideDates_ = {
	        prepend: prepend,
	        append: append
	      };
	      return this.outsideDates_;
	    };
	    ViewModel_.prototype.getInitialMonth_ = function () {
	      if (!this.initialMonth_) {
	        this.initialMonth_ = this.options_.getInitialMonth();
	      }
	      return this.initialMonth_;
	    };
	    ViewModel_.prototype.translateKeyCodeToMoveDirection_ = function (key) {
	      switch (key) {
	        case TheDatepicker.KeyCode_.Left:
	          return MoveDirection_.Left;
	        case TheDatepicker.KeyCode_.Up:
	          return MoveDirection_.Up;
	        case TheDatepicker.KeyCode_.Right:
	          return MoveDirection_.Right;
	        case TheDatepicker.KeyCode_.Down:
	          return MoveDirection_.Down;
	        default:
	          throw new Error('Invalid key code: ' + key);
	      }
	    };
	    return ViewModel_;
	  }();
	  TheDatepicker.ViewModel_ = ViewModel_;
	})(TheDatepicker || (TheDatepicker = {}));
	var TheDatepicker$1 = TheDatepicker;

	function datepickers() {
	  DOM.datepickers.forEach(elt => {
	    const datepicker = new TheDatepicker$1.Datepicker(elt);
	    datepicker.options.setInputFormat('d/m/Y');
	    datepicker.options.setFullScreenOnMobile(true);
	    datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker$1.DayOfWeek.Monday, 'Lu');
	    datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker$1.DayOfWeek.Tuesday, 'Ma');
	    datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker$1.DayOfWeek.Wednesday, 'Me');
	    datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker$1.DayOfWeek.Thursday, 'Je');
	    datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker$1.DayOfWeek.Friday, 'Ve');
	    datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker$1.DayOfWeek.Saturday, 'Sa');
	    datepicker.options.translator.setDayOfWeekTranslation(TheDatepicker$1.DayOfWeek.Sunday, 'Di');
	    datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker$1.DayOfWeek.Monday, 'Lundi');
	    datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker$1.DayOfWeek.Tuesday, 'Mardi');
	    datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker$1.DayOfWeek.Wednesday, 'Mercredi');
	    datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker$1.DayOfWeek.Thursday, 'Jeudi');
	    datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker$1.DayOfWeek.Friday, 'Vendredi');
	    datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker$1.DayOfWeek.Saturday, 'Samedi');
	    datepicker.options.translator.setDayOfWeekFullTranslation(TheDatepicker$1.DayOfWeek.Sunday, 'Dimanche');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.January, 'Janvier');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.February, 'Février');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.March, 'Mars');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.April, 'Avril');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.May, 'Mai');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.June, 'Juin');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.July, 'Juillet');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.August, 'Août');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.September, 'Septembre');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.October, 'Octobre');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.November, 'Novembre');
	    datepicker.options.translator.setMonthTranslation(TheDatepicker$1.Month.December, 'Decembre');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.January, 'Janv');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.February, 'Fév');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.March, 'Mars');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.April, 'Avr');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.May, 'Mai');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.June, 'Juin');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.July, 'Juill');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.August, 'Août');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.September, 'Sept');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.October, 'Oct');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.November, 'Nov');
	    datepicker.options.translator.setMonthShortTranslation(TheDatepicker$1.Month.December, 'Déc');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.GoBack, 'Mois précédent');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.GoForward, 'Mois suivant');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.Close, 'Fermer le calendrier');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.Reset, 'Réinitialiser le calendrier');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.Deselect, 'Désélectionner la date');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.Month, 'Sélection du mois');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.Year, 'Sélection de l’année');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.GoBackTableOfYears, 'Afficher les années précédentes');
	    datepicker.options.translator.setTitleTranslation(TheDatepicker$1.TitleName.GoForwardTableOfYears, 'Afficher les années suivantes');
	    if (elt.classList.contains('event')) {
	      const today = new Date();
	      const twoYearsAgo = new Date();
	      twoYearsAgo.setFullYear(today.getFullYear() - 2);
	      const twoYearsLater = new Date();
	      twoYearsLater.setFullYear(today.getFullYear() + 2);
	      datepicker.options.setMinDate(twoYearsAgo);
	      datepicker.options.setMaxDate(twoYearsLater);
	    }
	    if (elt.classList.contains('birthdate')) {
	      const today = new Date();
	      const hundredYearsAgo = new Date();
	      hundredYearsAgo.setFullYear(today.getFullYear() - 100);
	      datepicker.options.setMinDate(hundredYearsAgo);
	      datepicker.options.setMaxDate(today);
	    }
	    if (elt.classList.contains('future-only')) {
	      const today = new Date();
	      const tenYearsFromNow = new Date();
	      tenYearsFromNow.setFullYear(today.getFullYear() + 10);
	      datepicker.options.setMinDate(today);
	      datepicker.options.setMaxDate(tenYearsFromNow);
	    }
	    datepicker.render();
	  });
	}

	var datepicker = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: datepickers
	});

	// Simplebar - custom scrollbar
	window.ResizeObserver = index;
	function transportSearch() {
	  const searchField = DOM.transportsSearchForm.querySelector('.o-trans-search__form__search');
	  const searchDept = DOM.transportsSearchForm.querySelector('.o-trans-search__form__dept');
	  const searchNotServed = DOM.transportsSearchForm.querySelector('.o-trans-search__form__notserved');
	  const requiredErrorLabel = DOM.transportsSearchForm.querySelector('.o-trans-search__form__types .a-label--error');

	  // When type of search is school bus : uncheck others choices
	  // When type of search is != school bus : uncheck school bus
	  const transportsTypesSearch = DOM.transportsSearchForm.querySelectorAll('.o-trans-search__form__types .a-checkbox');
	  transportsTypesSearch.forEach(checkbox => {
	    // On change
	    checkbox.addEventListener('change', evt => {
	      // Checkbox "Cars scolaires" :
	      if (checkbox.id === 'search-school-bus') {
	        const othersThanSchoolBus = DOM.transportsSearchForm.querySelectorAll('.a-checkbox:not(#search-school-bus)');

	        // > hide autocomplete search field
	        // > show custom select "Département"
	        if (checkbox.checked) {
	          othersThanSchoolBus.forEach(others => {
	            others.checked = false;
	          });

	          // Hide search field
	          hideForm(searchField);

	          // Show custom select departement
	          showForm(searchDept);
	          DOM.transportsSearchForm.classList.remove('is-not-served');
	          hideForm(searchNotServed);
	        } else {
	          // On search "Cars scolaires" uncheck, check first of others
	          // othersThanSchoolBus[0].checked = true;
	          showForm(searchField);
	          hideForm(searchDept);
	        }
	      }

	      // Others checkboxes
	      else if (checkbox.id !== 'search-school-bus') {
	        if (checkbox.checked) {
	          DOM.transportsSearchForm.querySelector('#search-school-bus').checked = false;
	          showForm(searchField);
	          hideForm(searchDept);
	        }
	      }

	      // Display error message
	      if (countChecked() < 1) {
	        requiredErrorLabel.classList.remove('hidden');
	        searchField.querySelectorAll('input, button').forEach(focusableElt => {
	          focusableElt.disabled = true;
	        });
	      } else {
	        requiredErrorLabel.classList.add('hidden');
	        searchField.querySelectorAll('input, button').forEach(focusableElt => {
	          focusableElt.disabled = false;
	        });
	      }
	    });
	  });

	  // Simplebar custom scrollbar on results
	  // Add class 'has-simplebar-active' if simplebar is currently active
	  const simpleBar = new SimpleBar(document.querySelector('.o-trans-search__result'), {
	    autoHide: false,
	    ariaLabel: 'Résultat de la recherche - contenu scrollable'
	  });
	  if (simpleBar.axis.y.isOverflowing) {
	    document.querySelector('.o-trans-search__result').classList.add('has-simplebar-active');
	  }
	}
	function countChecked() {
	  return DOM.transportsSearchForm.querySelectorAll('.m-formLabelField--type .a-checkbox:checked').length;
	}
	function showForm(elt) {
	  elt.classList.remove('sr-only');
	  elt.removeAttribute('inert');
	}
	function hideForm(elt) {
	  elt.classList.add('sr-only');
	  elt.setAttribute('inert', '');
	}

	var transportsSearchForm = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: transportSearch
	});

	/* =========================
	   ÉTAT GLOBAL
	========================= */
	const selectedFilters = new Map(); // key -> { id, value, modalId }
	let modalEventsInitialized = false;
	let filterEventsInitialized = false;
	function getFilterKey(input) {
	  const modal = input.closest('.modal-filter');
	  return `${modal?.id || 'global'}::${input.id}`;
	}
	function cssEscape(value) {
	  return window.CSS?.escape ? CSS.escape(value) : value.replace(/["\\]/g, '\\$&');
	}
	function findFilterElements(filter) {
	  const modal = filter.modalId ? document.getElementById(filter.modalId) : document;
	  const escapedId = cssEscape(filter.id);
	  const input = modal?.querySelector(`.chip-input[id="${escapedId}"]`);
	  const label = input?.closest('.chip-wrapper')?.querySelector('label.a-chip--filter') || modal?.querySelector(`label.a-chip--filter[for="${escapedId}"]`);
	  return {
	    input,
	    label
	  };
	}
	function dispatchFilterChange(input) {
	  input?.dispatchEvent(new Event('change', {
	    bubbles: true
	  }));
	}
	function updateFilterCounter(counter, count) {
	  if (counter) {
	    counter.textContent = count;
	  }
	}
	function updateSearchResultsVisibility() {
	  document.querySelectorAll('[data-aides-search-results]').forEach(results => {
	    results.hidden = selectedFilters.size === 0;
	  });
	}

	/* =========================
	   UI — MISE À JOUR COMPTEURS + BADGES
	========================= */
	function updateUI() {
	  const container = document.getElementById('selected-filters-panels');
	  const list = container?.querySelector('.input-checkboxes');
	  if (!container || !list) {
	    updateSearchResultsVisibility();
	    return;
	  }
	  list.innerHTML = '';

	  // Compteurs dans les boutons d'ouverture et dans chaque modale
	  document.querySelectorAll('.modal-filter').forEach(modal => {
	    let count = 0;
	    selectedFilters.forEach(f => {
	      if (f.modalId === modal.id) count++;
	    });
	    updateFilterCounter(modal.querySelector('.filter-count'), count);
	    document.querySelectorAll(`.js-open-modal[aria-controls="${modal.id}"] .filter-count, .js-open-modal[data-modal-target="${modal.id}"] .filter-count`).forEach(counter => updateFilterCounter(counter, count));
	    const srOnly = modal.querySelector('h4 .sr-only');
	    if (srOnly) {
	      srOnly.textContent = count > 0 ? `${count} filtre${count > 1 ? 's' : ''} sélectionné${count > 1 ? 's' : ''}` : 'filtres sélectionnés';
	    }
	  });
	  const visibleFilters = [];
	  selectedFilters.forEach((filter, id) => {
	    visibleFilters.push({
	      id,
	      filter
	    });
	  });
	  if (visibleFilters.length === 0) {
	    container.setAttribute('hidden', '');
	    container.style.display = 'none';
	    updateSearchResultsVisibility();
	    return;
	  }
	  container.removeAttribute('hidden');
	  container.style.display = 'block';
	  updateSearchResultsVisibility();
	  visibleFilters.forEach(({
	    filter,
	    id
	  }, index) => {
	    const li = document.createElement('li');
	    const wrapper = document.createElement('div');
	    wrapper.className = 'chip-wrapper';
	    const cb = document.createElement('input');
	    cb.type = 'checkbox';
	    cb.className = 'chip-input';
	    cb.id = `selected-filter-${index}`;
	    cb.dataset.filterKey = id;
	    cb.checked = true;
	    cb.setAttribute('aria-label', `Retirer le filtre : ${filter.value}`);
	    const label = document.createElement('label');
	    label.htmlFor = cb.id;
	    label.className = 'a-chip a-chip--filter is-active';
	    label.textContent = filter.value;
	    label.addEventListener('click', e => {
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      removeFilter(id);
	    });
	    wrapper.appendChild(cb);
	    wrapper.appendChild(label);
	    li.appendChild(wrapper);
	    list.appendChild(li);
	  });
	}

	/* =========================
	   ANNONCE LECTEUR D'ÉCRAN
	========================= */
	function announceToScreenReader(message) {
	  let announcer = document.getElementById('chip-filter-announcer');
	  if (!announcer) {
	    announcer = document.createElement('div');
	    announcer.id = 'chip-filter-announcer';
	    announcer.setAttribute('aria-live', 'polite');
	    announcer.setAttribute('aria-atomic', 'true');
	    announcer.setAttribute('role', 'status');
	    announcer.className = 'sr-only';
	    announcer.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;';
	    document.body.appendChild(announcer);
	  }
	  announcer.textContent = '';
	  requestAnimationFrame(() => {
	    announcer.textContent = message;
	  });
	}

	/* =========================
	   TOGGLE FILTRE
	========================= */
	function toggleFilter(id, input, label = null) {
	  if (selectedFilters.has(id)) {
	    removeFilter(id);
	  } else if (input) {
	    addFilter(id, input, label);
	  }
	}
	function removeFilter(id) {
	  if (!selectedFilters.has(id)) {
	    return;
	  }
	  const filter = selectedFilters.get(id);
	  selectedFilters.delete(id);
	  const {
	    input,
	    label
	  } = findFilterElements(filter);
	  if (input) {
	    input.checked = false;
	    dispatchFilterChange(input);
	  }
	  if (label) {
	    label.classList.remove('is-active');
	    label.setAttribute('aria-checked', 'false');
	  }
	  updateUI();
	  const total = selectedFilters.size;
	  announceToScreenReader(total > 0 ? `Filtre ${filter.value} retiré. ${total} filtre${total > 1 ? 's' : ''} sélectionné${total > 1 ? 's' : ''}.` : `Filtre ${filter.value} retiré. Aucun filtre sélectionné.`);
	}
	function addFilter(id, input, label) {
	  if (!input || !label) {
	    return;
	  }
	  const modal = input.closest('.modal-filter');
	  selectedFilters.set(id, {
	    id: input.id,
	    value: input.value,
	    modalId: modal?.id
	  });
	  input.checked = true;
	  dispatchFilterChange(input);
	  label.classList.add('is-active');
	  label.setAttribute('aria-checked', 'true');
	  updateUI();
	  const total = selectedFilters.size;
	  announceToScreenReader(`Filtre ${input.value} ajouté. ${total} filtre${total > 1 ? 's' : ''} sélectionné${total > 1 ? 's' : ''}.`);
	}

	/* =========================
	   INIT CHIPS DANS UNE MODALE
	========================= */
	function initChipsInModal(modal) {
	  modal.querySelectorAll('.chip-wrapper').forEach(wrapper => {
	    if (wrapper.dataset.chipInitialized === 'true') {
	      return;
	    }
	    const cb = wrapper.querySelector('.chip-input');
	    const label = wrapper.querySelector('label.a-chip--filter');
	    if (!cb || !label) {
	      return;
	    }
	    cb.addEventListener('click', e => {
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      toggleFilter(getFilterKey(cb), cb, label);
	    });
	    label.addEventListener('click', e => {
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      toggleFilter(getFilterKey(cb), cb, label);
	    });
	    cb.addEventListener('keydown', e => {
	      if (e.key === ' ' || e.key === 'Enter') {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	        toggleFilter(getFilterKey(cb), cb, label);
	      }
	    });
	    wrapper.innerHTML = '';
	    wrapper.appendChild(cb);
	    wrapper.appendChild(label);
	    wrapper.dataset.chipInitialized = 'true';
	  });
	}

	/* =========================
	   TRAP FOCUS
	========================= */
	function trapFocus(modal) {
	  const getFocusable = () => Array.from(modal.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(el => !el.closest('[hidden]') && el.offsetParent !== null);
	  modal._trapHandler = e => {
	    if (e.key !== 'Tab') {
	      return;
	    }
	    const focusable = getFocusable();
	    if (!focusable.length) {
	      return;
	    }
	    const first = focusable[0];
	    const last = focusable[focusable.length - 1];
	    if (e.shiftKey) {
	      if (document.activeElement === first) {
	        e.preventDefault();
	        last.focus();
	      }
	    } else if (document.activeElement === last) {
	      e.preventDefault();
	      first.focus();
	    }
	  };
	  modal.addEventListener('keydown', modal._trapHandler);
	}
	const BREAKPOINT_MD = 768;
	function setTriggersExpanded(modalId, open) {
	  document.querySelectorAll(`.js-open-modal[aria-controls="${modalId}"], .js-open-modal[data-modal-target="${modalId}"]`).forEach(btn => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
	}
	function positionMobileModal(modal) {
	  modal.style.setProperty('--filter-modal-left', `${window.innerWidth / 2}px`);
	  modal.style.setProperty('--filter-modal-top', '150px');
	}
	function positionModalArrow(modal, button) {
	  const buttonRect = button.getBoundingClientRect();
	  const modalRect = modal.getBoundingClientRect();
	  const buttonCenter = buttonRect.left + buttonRect.width / 2;
	  const arrowLeft = buttonCenter - modalRect.left;
	  modal.style.setProperty('--filter-arrow-left', `${arrowLeft}px`);
	}
	function openModal(button) {
	  const modalId = button.getAttribute('data-modal-target') || button.getAttribute('aria-controls');
	  const modal = document.getElementById(modalId);
	  if (!modal) {
	    return;
	  }
	  document.querySelectorAll('.modal-filter.is-open').forEach(m => {
	    if (m !== modal) {
	      closeModal(m, false);
	    }
	  });

	  // Overlay uniquement sur mobile
	  if (window.innerWidth < BREAKPOINT_MD) {
	    positionMobileModal(modal);
	    let overlay = document.getElementById('faq-modal-overlay');
	    const overlayRoot = modal.closest('.mod-hero--search') || document.body;
	    if (!overlay) {
	      overlay = document.createElement('div');
	      overlay.id = 'faq-modal-overlay';
	      overlay.className = 'faq-modal-overlay';
	    }
	    overlayRoot.appendChild(overlay);
	    overlay.onclick = () => closeModal(document.querySelector('.modal-filter.is-open'));
	    overlay.classList.add('is-visible');
	  }
	  modal.removeAttribute('hidden');
	  modal.classList.add('is-open');
	  setTriggersExpanded(modalId, true);
	  positionModalArrow(modal, button);
	  initChipsInModal(modal);
	  trapFocus(modal);
	  setTimeout(() => {
	    modal.querySelector('.modal-close')?.focus();
	  }, 50);
	  announceToScreenReader(`Panneau ${modal.querySelector('h3')?.textContent.trim()} ouvert`);
	}
	function closeModal(modal, returnFocus = true) {
	  if (!modal) {
	    return;
	  }

	  // Retire l'overlay
	  const overlay = document.getElementById('faq-modal-overlay');
	  if (overlay) overlay.classList.remove('is-visible');
	  modal.setAttribute('hidden', '');
	  modal.classList.remove('is-open');
	  modal.style.removeProperty('--filter-modal-left');
	  modal.style.removeProperty('--filter-modal-top');
	  modal.style.removeProperty('--filter-arrow-left');
	  if (modal._trapHandler) {
	    modal.removeEventListener('keydown', modal._trapHandler);
	    modal._trapHandler = null;
	  }
	  if (returnFocus) {
	    const trigger = document.querySelector(`[aria-controls="${modal.id}"], [data-modal-target="${modal.id}"]`);
	    if (trigger) {
	      setTriggersExpanded(modal.id, false);
	      trigger.focus();
	    }
	    announceToScreenReader('Panneau fermé');
	  }

	  // Toujours fermer visuellement tous les chevrons liés
	  setTriggersExpanded(modal.id, false);
	}

	/* =========================
	   INIT EVENTS MODALES
	========================= */
	function initModalEvents() {
	  if (modalEventsInitialized) {
	    return;
	  }
	  modalEventsInitialized = true;
	  document.addEventListener('click', e => {
	    const trigger = e.target.closest('.js-open-modal');
	    if (trigger) {
	      e.preventDefault();
	      const modalId = trigger.getAttribute('data-modal-target') || trigger.getAttribute('aria-controls');
	      const modal = document.getElementById(modalId);
	      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
	      if (isOpen) {
	        closeModal(modal);
	      } else {
	        openModal(trigger);
	      }
	      return;
	    }
	    const closeBtn = e.target.closest('.js-close-modal');
	    if (closeBtn) {
	      e.preventDefault();
	      closeModal(closeBtn.closest('.modal-filter'));
	      return;
	    }
	    const overlay = e.target.closest('.modal-overlay, #faq-modal-overlay');
	    if (overlay) {
	      closeModal(document.querySelector('.modal-filter.is-open'));
	      return;
	    }
	    const openedModal = document.querySelector('.modal-filter.is-open');
	    if (!openedModal) return;
	    const clickedInsideModal = openedModal.contains(e.target);
	    const selectedFiltersPanel = document.getElementById('selected-filters-panels');
	    const clickedInsideSelectedFilters = selectedFiltersPanel?.contains(e.target);
	    if (!clickedInsideModal && !clickedInsideSelectedFilters) {
	      closeModal(openedModal);
	    }
	  });
	  document.addEventListener('keydown', e => {
	    if (e.key !== 'Escape') {
	      return;
	    }
	    const opened = document.querySelector('.modal-filter.is-open');
	    if (opened) {
	      closeModal(opened);
	    }
	  });
	}

	/* =========================
	   SYNC FILTERS TO FORM INPUTS
	========================= */
	function submitOwnerFormIfNeeded(container) {
	  // Only auto-submit when the chip lives inside the FAQ transports module
	  // (classic GET form, not a modal-only context like the Aides hero search).
	  const faqRoot = container.closest('.mod-faq-transports');
	  if (!faqRoot) {
	    return;
	  }
	  const form = faqRoot.closest('form') || faqRoot.querySelector('form');
	  if (!form) {
	    return;
	  }
	  syncFiltersToForm();
	  if (typeof form.requestSubmit === 'function') {
	    form.requestSubmit();
	  } else {
	    form.submit();
	  }
	}
	function syncFiltersToForm() {
	  // Uncheck all checkboxes first
	  document.querySelectorAll('.modal-filter .chip-input').forEach(cb => {
	    cb.checked = false;
	  });

	  // Check only the selected filters
	  selectedFilters.forEach(filter => {
	    const {
	      input
	    } = findFilterElements(filter);
	    if (input) {
	      input.checked = true;
	    }
	  });
	}

	/* =========================
	   INIT EVENTS FILTRES
	========================= */
	function initFilterEvents() {
	  if (filterEventsInitialized) {
	    return;
	  }
	  filterEventsInitialized = true;

	  // Sync filters before form submission
	  document.addEventListener('submit', e => {
	    const form = e.target.closest('form[data-validate-on-blur]');
	    if (form) {
	      syncFiltersToForm();
	    }
	  }, true);

	  // Réinitialiser les filtres
	  document.addEventListener('click', e => {
	    const btn = e.target.closest('.init-filters');
	    if (!btn) {
	      return;
	    }
	    e.preventDefault();
	    e.stopImmediatePropagation();
	    const modal = btn.closest('.modal-filter');
	    const idsToRemove = modal ? [...selectedFilters.keys()].filter(id => selectedFilters.get(id).modalId === modal.id) : [...selectedFilters.keys()];
	    idsToRemove.forEach(id => toggleFilter(id, null));
	    const count = idsToRemove.length;
	    if (count > 0) {
	      announceToScreenReader(`${count} filtre${count > 1 ? 's' : ''} réinitialisé${count > 1 ? 's' : ''}`);
	    }
	  });

	  // Retirer les chips du panneau selected-filters-panels
	  document.addEventListener('click', e => {
	    const container = document.getElementById('selected-filters-panels');
	    if (!container) {
	      return;
	    }
	    const cb = e.target.closest('#selected-filters-panels .chip-input');
	    if (!cb) {
	      return;
	    }
	    e.preventDefault();
	    e.stopImmediatePropagation();
	    const id = cb.dataset.filterKey;
	    if (!id) {
	      return;
	    }
	    toggleFilter(id, null);
	    submitOwnerFormIfNeeded(container);
	  });

	  // Support du clavier pour retirer les chips
	  document.addEventListener('keydown', e => {
	    if (e.key !== ' ' && e.key !== 'Enter') {
	      return;
	    }
	    const container = document.getElementById('selected-filters-panels');
	    if (!container) {
	      return;
	    }
	    const cb = e.target.closest('#selected-filters-panels .chip-input');
	    if (!cb) {
	      return;
	    }
	    e.preventDefault();
	    e.stopImmediatePropagation();
	    const id = cb.dataset.filterKey;
	    if (!id) {
	      return;
	    }
	    toggleFilter(id, null);
	    submitOwnerFormIfNeeded(container);
	  });
	}

	/* =========================
	   INIT — CHARGER LES FILTRES DEPUIS LE DOM
	========================= */
	function loadExistingChips() {
	  // Parcourir tous les chips existants dans les modales
	  document.querySelectorAll('.modal-filter .chip-input[id]:checked').forEach(cb => {
	    const label = cb.closest('.chip-wrapper')?.querySelector('label.a-chip--filter');
	    if (!label) {
	      return;
	    }
	    const id = getFilterKey(cb);
	    const value = cb.value || label.textContent.trim();
	    const modal = cb.closest('.modal-filter');
	    selectedFilters.set(id, {
	      id: cb.id,
	      value,
	      modalId: modal?.id
	    });
	    label.classList.add('is-active');
	    label.setAttribute('aria-checked', 'true');
	  });
	  document.querySelectorAll('#selected-filters-panels .chip-input[id]:checked').forEach(cb => {
	    const id = cb.dataset.filterKey || cb.id.replace(/^selected-/, '');
	    const label = cb.closest('.chip-wrapper')?.querySelector('label.a-chip--filter');
	    if (!label || selectedFilters.has(id)) {
	      return;
	    }
	    const value = cb.value || label.textContent.trim();
	    selectedFilters.set(id, {
	      value,
	      modalId: null
	    });
	    label.classList.add('is-active');
	    label.setAttribute('aria-checked', 'true');
	  });
	}

	/* =========================
	   INIT
	========================= */
	function init() {
	  selectedFilters.clear();
	  loadExistingChips();
	  updateUI();
	  initModalEvents();
	  initFilterEvents();
	}

	var formSearchFilters = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: init,
		init: init,
		initFilterEvents: initFilterEvents,
		initModalEvents: initModalEvents
	});

	function initCardsFullText() {
	  const modules = DOM?.cardsFullText;
	  if (!modules.length) return;

	  // Sliders cards full text
	  const splideOptions = {
	    type: 'slide',
	    pagination: true,
	    autoplay: false,
	    drag: true,
	    role: 'group',
	    autoWidth: true,
	    perMove: 1,
	    perPage: 1,
	    accessibility: {
	      pagination: {
	        role: false,
	        tab: false
	      }
	    },
	    mediaQuery: 'min',
	    breakpoints: {
	      768: {
	        perPage: 2
	      },
	      1440: {
	        perPage: 3
	      }
	    }
	  };
	  DOM.cardsFullText.forEach(modContainer => {
	    const sliderElt = modContainer.querySelector('.splide');
	    if (!sliderElt) return;
	    const moduleOptions = {
	      ...splideOptions
	    };
	    const isAidesSlider = modContainer.classList.contains('mod-cards-full-text--aide');
	    if (isAidesSlider) {
	      moduleOptions.i18n = SLIDER_OPTIONS_I18N_AIDES;
	      moduleOptions.traversing = true;
	      moduleOptions.breakpoints = {};
	      const list = sliderElt.querySelector('.splide__list');
	      const allOriginalItems = [...list.querySelectorAll('.splide__slide')];
	      const MOBILE_MAX = 5;
	      let currentMode = null;

	      // Link element and its initial state for reset on mode switch
	      const viewMoreLink = modContainer.querySelector('.js-more-link');
	      let isExpanded = false;
	      function setMobileMode() {
	        // Remove items beyond MOBILE_MAX
	        allOriginalItems.slice(MOBILE_MAX).forEach(item => {
	          if (item.isConnected) item.remove();
	        });
	        currentMode = 'mobile';
	      }
	      function setDesktopMode() {
	        // Restore all items in original order (appendChild moves if already connected)
	        allOriginalItems.forEach(item => list.appendChild(item));
	        // Reset view-more state
	        if (isExpanded) {
	          isExpanded = false;
	          allOriginalItems.slice(3).forEach(item => item.classList.remove('is-active'));
	          if (viewMoreLink) {
	            viewMoreLink.setAttribute('aria-expanded', 'false');
	            const labelNode = viewMoreLink.querySelector('span') || viewMoreLink;
	            labelNode.textContent = viewMoreLink.dataset.labelMore;
	          }
	        }
	        currentMode = 'desktop';
	      }

	      // Initial setup
	      if (isMobile()) {
	        setMobileMode();
	      } else {
	        setDesktopMode();
	      }
	      const splideObj = new Splide(sliderElt, moduleOptions);
	      splideObj.on('mounted', () => {
	        onSplideMounted(splideObj, sliderElt);
	        splideObj.Components.Elements.list.removeAttribute('role');
	      });
	      splideObj.on('mounted move updated resized', () => {
	        window.setTimeout(() => updateTabIndex(splideObj), 450);
	      });
	      splideObj.on('destroy', () => {
	        onSplideDestroy(splideObj, sliderElt);
	      });
	      splideObj.mount();

	      // If initial state is desktop, destroy slider
	      if (!isMobile()) {
	        splideObj.destroy();
	        disableSplideControls(sliderElt);
	      }

	      // View more button — active on desktop only, hidden by CSS on mobile
	      initViewMoreButton(modContainer, allOriginalItems, () => isExpanded, val => {
	        isExpanded = val;
	      });
	      window.addEventListener('optimizedResize', () => {
	        if (isMobile() && currentMode !== 'mobile') {
	          // Desktop → mobile : restore slider with max 5 items
	          setMobileMode();
	          enableSplideControls(sliderElt); // Reset controls before mount so Splide initializes on a clean state
	          splideObj.mount();
	        } else if (!isMobile() && currentMode !== 'desktop') {
	          // Mobile → desktop : destroy slider, show grid with view-more
	          setDesktopMode();
	          splideObj.destroy();
	          disableSplideControls(sliderElt);
	        }
	      });
	    } else {
	      if (modContainer.classList.contains('mod-cards-full-text--vote-debat')) {
	        moduleOptions.i18n = SLIDER_OPTIONS_I18N_VOTES_DEBATS;
	        moduleOptions.traversing = true;
	      }
	      const splideObj = new Splide(sliderElt, moduleOptions);
	      splideObj.on('mounted', () => {
	        onSplideMounted(splideObj, sliderElt);
	        splideObj.Components.Elements.list.removeAttribute('role');
	      });
	      if (typeof moduleOptions.traversing !== 'undefined') {
	        splideObj.on('mounted move updated resized', () => {
	          window.setTimeout(() => updateTabIndex(splideObj), 450);
	        });
	      }
	      splideObj.on('destroy', () => {
	        onSplideDestroy(splideObj, sliderElt);
	      });
	      splideObj.mount();
	    }
	  });
	}

	/**
	 * Bouton "afficher plus" pour le mode desktop du module --aide.
	 * Les items à partir de l'index 3 sont masqués par CSS (.no-splide li:nth-child(n+4))
	 * et révélés avec la classe is-active au clic.
	 * @param {HTMLElement} modContainer
	 * @param {HTMLElement[]} allItems - tableau complet des slides dans l'ordre original
	 * @param {Function} getExpanded - getter de l'état isExpanded (closure partagée)
	 * @param {Function} setExpanded - setter de l'état isExpanded (closure partagée)
	 */
	function initViewMoreButton(modContainer, allItems, getExpanded, setExpanded) {
	  const link = modContainer.querySelector('.js-more-link');
	  if (!link) return;
	  const itemsToToggle = allItems.slice(3);
	  if (!itemsToToggle.length) return;
	  const labelMore = link.dataset.labelMore;
	  const labelLess = link.dataset.labelLess;
	  link.addEventListener('click', e => {
	    e.preventDefault();
	    const expanded = !getExpanded();
	    setExpanded(expanded);
	    link.setAttribute('aria-expanded', String(expanded));
	    const labelNode = link.querySelector('span') || link;
	    labelNode.textContent = expanded ? labelLess : labelMore;
	    itemsToToggle.forEach(item => {
	      item.classList.toggle('is-active', expanded);
	    });
	  });
	}

	var cardsFullText = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: initCardsFullText
	});

	function faqResponses(container) {
	  const getRoot = el => el.closest('.mod-faq-transports') || container;
	  const setModalOpen = (modal, open) => {
	    modal.hidden = !open;
	    modal.classList.toggle('is-open', open);
	    const btns = document.querySelectorAll(`.js-open-modal[aria-controls="${modal.id}"], .js-open-modal[data-modal-target="${modal.id}"]`);
	    btns.forEach(btn => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
	  };
	  const closeOtherModals = (root, exceptId) => {
	    root.querySelectorAll('.modal-filter').forEach(modal => {
	      if (modal.id === exceptId) return;
	      setModalOpen(modal, false);
	    });
	  };
	  const getModalLabel = modal => {
	    if (!modal) return '';
	    const btn = document.querySelector(`.js-open-modal[aria-controls="${modal.id}"], .js-open-modal[data-modal-target="${modal.id}"]`);
	    return btn?.textContent?.trim() || '';
	  };
	  const updateSelectedFilterBadge = root => {
	    const badge = root.querySelector('#js-selected-filter');
	    if (!badge) return;
	    const openModal = root.querySelector('.modal-filter.is-open:not([hidden])');
	    if (!openModal) {
	      badge.textContent = '';
	      return;
	    }
	    const hasChecked = openModal.querySelector('input[type="checkbox"]:checked');
	    badge.textContent = hasChecked ? getModalLabel(openModal) : '';
	  };
	  const updateFromSelection = root => {
	    const responses = root.querySelectorAll('.faq-responses');
	    if (!responses.length) return;
	    responses.forEach(block => {
	      block.hidden = true;
	    });
	    const modals = root.querySelectorAll('.modal-filter');
	    modals.forEach(modal => {
	      if (modal.hidden) return;
	      const hasChecked = modal.querySelector('input[type="checkbox"]:checked');
	      if (!hasChecked) return;
	      const block = root.querySelector(`.faq-responses[data-faq-for="${modal.id}"]`);
	      if (block) block.hidden = false;
	    });
	    updateSelectedFilterBadge(root);
	  };
	  const faqResponses = container.querySelectorAll('.faq-responses');
	  if (!faqResponses.length) return;
	  faqResponses.forEach(block => {
	    block.hidden = true;
	  });
	  const checkboxes = container.querySelectorAll('.modal-filter input[type="checkbox"]');
	  checkboxes.forEach(checkbox => {
	    checkbox.checked = false;
	  });
	  container.addEventListener('change', event => {
	    const checkbox = event.target.closest('.modal-filter input[type="checkbox"]');
	    if (!checkbox) return;
	    const root = getRoot(checkbox);
	    updateFromSelection(root);
	  });

	  // IMPORTANT: écouter sur document pour ne pas manquer le clic
	  document.addEventListener('click', event => {
	    const openBtn = event.target.closest('.js-open-modal');
	    const closeBtn = event.target.closest('.js-close-modal');
	    if (!openBtn && !closeBtn) return;
	    if (openBtn) {
	      const targetId = openBtn.getAttribute('aria-controls') || openBtn.dataset.modalTarget;
	      if (!targetId) return;
	      const root = getRoot(openBtn);
	      // Fermer visuellement tous les chevrons du groupe
	      root.querySelectorAll('.js-open-modal').forEach(btn => {
	        btn.setAttribute('aria-expanded', 'false');
	      });
	      const modal = root.querySelector(`#${targetId}`);
	      if (!modal) return;
	      const isOpen = modal.hidden === false;
	      if (isOpen) {
	        setModalOpen(modal, false);
	        updateFromSelection(root);
	        return;
	      }

	      // Considérer l’onglet précédent comme fermé
	      closeOtherModals(root, targetId);

	      // Ouvrir immédiatement le filtre ciblé
	      setModalOpen(modal, true);
	      updateFromSelection(root);
	      return;
	    }
	    if (closeBtn) {
	      const modal = closeBtn.closest('.modal-filter');
	      if (!modal) return;
	      const root = getRoot(modal);
	      setModalOpen(modal, false);
	      updateFromSelection(root);
	    }
	  });
	}

	var searchResponses = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: faqResponses
	});

	var leafletSrc = {exports: {}};

	/* @preserve
	 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
	 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	(function (module, exports$1) {
	  (function (global, factory) {
	    factory(exports$1) ;
	  })(commonjsGlobal, function (exports$1) {

	    var version = "1.9.4";

	    /*
	     * @namespace Util
	     *
	     * Various utility functions, used by Leaflet internally.
	     */

	    // @function extend(dest: Object, src?: Object): Object
	    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	    function extend(dest) {
	      var i, j, len, src;
	      for (j = 1, len = arguments.length; j < len; j++) {
	        src = arguments[j];
	        for (i in src) {
	          dest[i] = src[i];
	        }
	      }
	      return dest;
	    }

	    // @function create(proto: Object, properties?: Object): Object
	    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	    var create$2 = Object.create || function () {
	      function F() {}
	      return function (proto) {
	        F.prototype = proto;
	        return new F();
	      };
	    }();

	    // @function bind(fn: Function, …): Function
	    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	    // Has a `L.bind()` shortcut.
	    function bind(fn, obj) {
	      var slice = Array.prototype.slice;
	      if (fn.bind) {
	        return fn.bind.apply(fn, slice.call(arguments, 1));
	      }
	      var args = slice.call(arguments, 2);
	      return function () {
	        return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
	      };
	    }

	    // @property lastId: Number
	    // Last unique ID used by [`stamp()`](#util-stamp)
	    var lastId = 0;

	    // @function stamp(obj: Object): Number
	    // Returns the unique ID of an object, assigning it one if it doesn't have it.
	    function stamp(obj) {
	      if (!('_leaflet_id' in obj)) {
	        obj['_leaflet_id'] = ++lastId;
	      }
	      return obj._leaflet_id;
	    }

	    // @function throttle(fn: Function, time: Number, context: Object): Function
	    // Returns a function which executes function `fn` with the given scope `context`
	    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	    // `fn` will be called no more than one time per given amount of `time`. The arguments
	    // received by the bound function will be any arguments passed when binding the
	    // function, followed by any arguments passed when invoking the bound function.
	    // Has an `L.throttle` shortcut.
	    function throttle(fn, time, context) {
	      var lock, args, wrapperFn, later;
	      later = function () {
	        // reset lock and call if queued
	        lock = false;
	        if (args) {
	          wrapperFn.apply(context, args);
	          args = false;
	        }
	      };
	      wrapperFn = function () {
	        if (lock) {
	          // called too soon, queue to call later
	          args = arguments;
	        } else {
	          // call and lock until later
	          fn.apply(context, arguments);
	          setTimeout(later, time);
	          lock = true;
	        }
	      };
	      return wrapperFn;
	    }

	    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	    // Returns the number `num` modulo `range` in such a way so it lies within
	    // `range[0]` and `range[1]`. The returned value will be always smaller than
	    // `range[1]` unless `includeMax` is set to `true`.
	    function wrapNum(x, range, includeMax) {
	      var max = range[1],
	        min = range[0],
	        d = max - min;
	      return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	    }

	    // @function falseFn(): Function
	    // Returns a function which always returns `false`.
	    function falseFn() {
	      return false;
	    }

	    // @function formatNum(num: Number, precision?: Number|false): Number
	    // Returns the number `num` rounded with specified `precision`.
	    // The default `precision` value is 6 decimal places.
	    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
	    function formatNum(num, precision) {
	      if (precision === false) {
	        return num;
	      }
	      var pow = Math.pow(10, precision === undefined ? 6 : precision);
	      return Math.round(num * pow) / pow;
	    }

	    // @function trim(str: String): String
	    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	    function trim(str) {
	      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	    }

	    // @function splitWords(str: String): String[]
	    // Trims and splits the string on whitespace and returns the array of parts.
	    function splitWords(str) {
	      return trim(str).split(/\s+/);
	    }

	    // @function setOptions(obj: Object, options: Object): Object
	    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	    function setOptions(obj, options) {
	      if (!Object.prototype.hasOwnProperty.call(obj, 'options')) {
	        obj.options = obj.options ? create$2(obj.options) : {};
	      }
	      for (var i in options) {
	        obj.options[i] = options[i];
	      }
	      return obj.options;
	    }

	    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	    // be appended at the end. If `uppercase` is `true`, the parameter names will
	    // be uppercased (e.g. `'?A=foo&B=bar'`)
	    function getParamString(obj, existingUrl, uppercase) {
	      var params = [];
	      for (var i in obj) {
	        params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
	      }
	      return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
	    }
	    var templateRe = /\{ *([\w_ -]+) *\}/g;

	    // @function template(str: String, data: Object): String
	    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	    // `('Hello foo, bar')`. You can also specify functions instead of strings for
	    // data values — they will be evaluated passing `data` as an argument.
	    function template(str, data) {
	      return str.replace(templateRe, function (str, key) {
	        var value = data[key];
	        if (value === undefined) {
	          throw new Error('No value provided for variable ' + str);
	        } else if (typeof value === 'function') {
	          value = value(data);
	        }
	        return value;
	      });
	    }

	    // @function isArray(obj): Boolean
	    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	    var isArray = Array.isArray || function (obj) {
	      return Object.prototype.toString.call(obj) === '[object Array]';
	    };

	    // @function indexOf(array: Array, el: Object): Number
	    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	    function indexOf(array, el) {
	      for (var i = 0; i < array.length; i++) {
	        if (array[i] === el) {
	          return i;
	        }
	      }
	      return -1;
	    }

	    // @property emptyImageUrl: String
	    // Data URI string containing a base64-encoded empty GIF image.
	    // Used as a hack to free memory from unused images on WebKit-powered
	    // mobile devices (by setting image `src` to this string).
	    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

	    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/

	    function getPrefixed(name) {
	      return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	    }
	    var lastTime = 0;

	    // fallback for IE 7-8
	    function timeoutDefer(fn) {
	      var time = +new Date(),
	        timeToCall = Math.max(0, 16 - (time - lastTime));
	      lastTime = time + timeToCall;
	      return window.setTimeout(fn, timeToCall);
	    }
	    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function (id) {
	      window.clearTimeout(id);
	    };

	    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	    // `context` if given. When `immediate` is set, `fn` is called immediately if
	    // the browser doesn't have native support for
	    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	    function requestAnimFrame(fn, context, immediate) {
	      if (immediate && requestFn === timeoutDefer) {
	        fn.call(context);
	      } else {
	        return requestFn.call(window, bind(fn, context));
	      }
	    }

	    // @function cancelAnimFrame(id: Number): undefined
	    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	    function cancelAnimFrame(id) {
	      if (id) {
	        cancelFn.call(window, id);
	      }
	    }
	    var Util = {
	      __proto__: null,
	      extend: extend,
	      create: create$2,
	      bind: bind,
	      get lastId() {
	        return lastId;
	      },
	      stamp: stamp,
	      throttle: throttle,
	      wrapNum: wrapNum,
	      falseFn: falseFn,
	      formatNum: formatNum,
	      trim: trim,
	      splitWords: splitWords,
	      setOptions: setOptions,
	      getParamString: getParamString,
	      template: template,
	      isArray: isArray,
	      indexOf: indexOf,
	      emptyImageUrl: emptyImageUrl,
	      requestFn: requestFn,
	      cancelFn: cancelFn,
	      requestAnimFrame: requestAnimFrame,
	      cancelAnimFrame: cancelAnimFrame
	    };

	    // @class Class
	    // @aka L.Class

	    // @section
	    // @uninheritable

	    // Thanks to John Resig and Dean Edwards for inspiration!

	    function Class() {}
	    Class.extend = function (props) {
	      // @function extend(props: Object): Function
	      // [Extends the current class](#class-inheritance) given the properties to be included.
	      // Returns a Javascript function that is a class constructor (to be called with `new`).
	      var NewClass = function () {
	        setOptions(this);

	        // call the constructor
	        if (this.initialize) {
	          this.initialize.apply(this, arguments);
	        }

	        // call all constructor hooks
	        this.callInitHooks();
	      };
	      var parentProto = NewClass.__super__ = this.prototype;
	      var proto = create$2(parentProto);
	      proto.constructor = NewClass;
	      NewClass.prototype = proto;

	      // inherit parent's statics
	      for (var i in this) {
	        if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') {
	          NewClass[i] = this[i];
	        }
	      }

	      // mix static properties into the class
	      if (props.statics) {
	        extend(NewClass, props.statics);
	      }

	      // mix includes into the prototype
	      if (props.includes) {
	        checkDeprecatedMixinEvents(props.includes);
	        extend.apply(null, [proto].concat(props.includes));
	      }

	      // mix given properties into the prototype
	      extend(proto, props);
	      delete proto.statics;
	      delete proto.includes;

	      // merge options
	      if (proto.options) {
	        proto.options = parentProto.options ? create$2(parentProto.options) : {};
	        extend(proto.options, props.options);
	      }
	      proto._initHooks = [];

	      // add method for calling all hooks
	      proto.callInitHooks = function () {
	        if (this._initHooksCalled) {
	          return;
	        }
	        if (parentProto.callInitHooks) {
	          parentProto.callInitHooks.call(this);
	        }
	        this._initHooksCalled = true;
	        for (var i = 0, len = proto._initHooks.length; i < len; i++) {
	          proto._initHooks[i].call(this);
	        }
	      };
	      return NewClass;
	    };

	    // @function include(properties: Object): this
	    // [Includes a mixin](#class-includes) into the current class.
	    Class.include = function (props) {
	      var parentOptions = this.prototype.options;
	      extend(this.prototype, props);
	      if (props.options) {
	        this.prototype.options = parentOptions;
	        this.mergeOptions(props.options);
	      }
	      return this;
	    };

	    // @function mergeOptions(options: Object): this
	    // [Merges `options`](#class-options) into the defaults of the class.
	    Class.mergeOptions = function (options) {
	      extend(this.prototype.options, options);
	      return this;
	    };

	    // @function addInitHook(fn: Function): this
	    // Adds a [constructor hook](#class-constructor-hooks) to the class.
	    Class.addInitHook = function (fn) {
	      // (Function) || (String, args...)
	      var args = Array.prototype.slice.call(arguments, 1);
	      var init = typeof fn === 'function' ? fn : function () {
	        this[fn].apply(this, args);
	      };
	      this.prototype._initHooks = this.prototype._initHooks || [];
	      this.prototype._initHooks.push(init);
	      return this;
	    };
	    function checkDeprecatedMixinEvents(includes) {
	      /* global L: true */
	      if (typeof L === 'undefined' || !L || !L.Mixin) {
	        return;
	      }
	      includes = isArray(includes) ? includes : [includes];
	      for (var i = 0; i < includes.length; i++) {
	        if (includes[i] === L.Mixin.Events) {
	          console.warn('Deprecated include of L.Mixin.Events: ' + 'this property will be removed in future releases, ' + 'please inherit from L.Evented instead.', new Error().stack);
	        }
	      }
	    }

	    /*
	     * @class Evented
	     * @aka L.Evented
	     * @inherits Class
	     *
	     * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	     *
	     * @example
	     *
	     * ```js
	     * map.on('click', function(e) {
	     * 	alert(e.latlng);
	     * } );
	     * ```
	     *
	     * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	     *
	     * ```js
	     * function onClick(e) { ... }
	     *
	     * map.on('click', onClick);
	     * map.off('click', onClick);
	     * ```
	     */

	    var Events = {
	      /* @method on(type: String, fn: Function, context?: Object): this
	       * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	       *
	       * @alternative
	       * @method on(eventMap: Object): this
	       * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	       */
	      on: function (types, fn, context) {
	        // types can be a map of types/handlers
	        if (typeof types === 'object') {
	          for (var type in types) {
	            // we don't process space-separated events here for performance;
	            // it's a hot path since Layer uses the on(obj) syntax
	            this._on(type, types[type], fn);
	          }
	        } else {
	          // types can be a string of space-separated words
	          types = splitWords(types);
	          for (var i = 0, len = types.length; i < len; i++) {
	            this._on(types[i], fn, context);
	          }
	        }
	        return this;
	      },
	      /* @method off(type: String, fn?: Function, context?: Object): this
	       * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	       *
	       * @alternative
	       * @method off(eventMap: Object): this
	       * Removes a set of type/listener pairs.
	       *
	       * @alternative
	       * @method off: this
	       * Removes all listeners to all events on the object. This includes implicitly attached events.
	       */
	      off: function (types, fn, context) {
	        if (!arguments.length) {
	          // clear all listeners if called without arguments
	          delete this._events;
	        } else if (typeof types === 'object') {
	          for (var type in types) {
	            this._off(type, types[type], fn);
	          }
	        } else {
	          types = splitWords(types);
	          var removeAll = arguments.length === 1;
	          for (var i = 0, len = types.length; i < len; i++) {
	            if (removeAll) {
	              this._off(types[i]);
	            } else {
	              this._off(types[i], fn, context);
	            }
	          }
	        }
	        return this;
	      },
	      // attach listener (without syntactic sugar now)
	      _on: function (type, fn, context, _once) {
	        if (typeof fn !== 'function') {
	          console.warn('wrong listener type: ' + typeof fn);
	          return;
	        }

	        // check if fn already there
	        if (this._listens(type, fn, context) !== false) {
	          return;
	        }
	        if (context === this) {
	          // Less memory footprint.
	          context = undefined;
	        }
	        var newListener = {
	          fn: fn,
	          ctx: context
	        };
	        if (_once) {
	          newListener.once = true;
	        }
	        this._events = this._events || {};
	        this._events[type] = this._events[type] || [];
	        this._events[type].push(newListener);
	      },
	      _off: function (type, fn, context) {
	        var listeners, i, len;
	        if (!this._events) {
	          return;
	        }
	        listeners = this._events[type];
	        if (!listeners) {
	          return;
	        }
	        if (arguments.length === 1) {
	          // remove all
	          if (this._firingCount) {
	            // Set all removed listeners to noop
	            // so they are not called if remove happens in fire
	            for (i = 0, len = listeners.length; i < len; i++) {
	              listeners[i].fn = falseFn;
	            }
	          }
	          // clear all listeners for a type if function isn't specified
	          delete this._events[type];
	          return;
	        }
	        if (typeof fn !== 'function') {
	          console.warn('wrong listener type: ' + typeof fn);
	          return;
	        }

	        // find fn and remove it
	        var index = this._listens(type, fn, context);
	        if (index !== false) {
	          var listener = listeners[index];
	          if (this._firingCount) {
	            // set the removed listener to noop so that's not called if remove happens in fire
	            listener.fn = falseFn;

	            /* copy array in case events are being fired */
	            this._events[type] = listeners = listeners.slice();
	          }
	          listeners.splice(index, 1);
	        }
	      },
	      // @method fire(type: String, data?: Object, propagate?: Boolean): this
	      // Fires an event of the specified type. You can optionally provide a data
	      // object — the first argument of the listener function will contain its
	      // properties. The event can optionally be propagated to event parents.
	      fire: function (type, data, propagate) {
	        if (!this.listens(type, propagate)) {
	          return this;
	        }
	        var event = extend({}, data, {
	          type: type,
	          target: this,
	          sourceTarget: data && data.sourceTarget || this
	        });
	        if (this._events) {
	          var listeners = this._events[type];
	          if (listeners) {
	            this._firingCount = this._firingCount + 1 || 1;
	            for (var i = 0, len = listeners.length; i < len; i++) {
	              var l = listeners[i];
	              // off overwrites l.fn, so we need to copy fn to a var
	              var fn = l.fn;
	              if (l.once) {
	                this.off(type, fn, l.ctx);
	              }
	              fn.call(l.ctx || this, event);
	            }
	            this._firingCount--;
	          }
	        }
	        if (propagate) {
	          // propagate the event to parents (set with addEventParent)
	          this._propagateEvent(event);
	        }
	        return this;
	      },
	      // @method listens(type: String, propagate?: Boolean): Boolean
	      // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
	      // Returns `true` if a particular event type has any listeners attached to it.
	      // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
	      listens: function (type, fn, context, propagate) {
	        if (typeof type !== 'string') {
	          console.warn('"string" type argument expected');
	        }

	        // we don't overwrite the input `fn` value, because we need to use it for propagation
	        var _fn = fn;
	        if (typeof fn !== 'function') {
	          propagate = !!fn;
	          _fn = undefined;
	          context = undefined;
	        }
	        var listeners = this._events && this._events[type];
	        if (listeners && listeners.length) {
	          if (this._listens(type, _fn, context) !== false) {
	            return true;
	          }
	        }
	        if (propagate) {
	          // also check parents for listeners if event propagates
	          for (var id in this._eventParents) {
	            if (this._eventParents[id].listens(type, fn, context, propagate)) {
	              return true;
	            }
	          }
	        }
	        return false;
	      },
	      // returns the index (number) or false
	      _listens: function (type, fn, context) {
	        if (!this._events) {
	          return false;
	        }
	        var listeners = this._events[type] || [];
	        if (!fn) {
	          return !!listeners.length;
	        }
	        if (context === this) {
	          // Less memory footprint.
	          context = undefined;
	        }
	        for (var i = 0, len = listeners.length; i < len; i++) {
	          if (listeners[i].fn === fn && listeners[i].ctx === context) {
	            return i;
	          }
	        }
	        return false;
	      },
	      // @method once(…): this
	      // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	      once: function (types, fn, context) {
	        // types can be a map of types/handlers
	        if (typeof types === 'object') {
	          for (var type in types) {
	            // we don't process space-separated events here for performance;
	            // it's a hot path since Layer uses the on(obj) syntax
	            this._on(type, types[type], fn, true);
	          }
	        } else {
	          // types can be a string of space-separated words
	          types = splitWords(types);
	          for (var i = 0, len = types.length; i < len; i++) {
	            this._on(types[i], fn, context, true);
	          }
	        }
	        return this;
	      },
	      // @method addEventParent(obj: Evented): this
	      // Adds an event parent - an `Evented` that will receive propagated events
	      addEventParent: function (obj) {
	        this._eventParents = this._eventParents || {};
	        this._eventParents[stamp(obj)] = obj;
	        return this;
	      },
	      // @method removeEventParent(obj: Evented): this
	      // Removes an event parent, so it will stop receiving propagated events
	      removeEventParent: function (obj) {
	        if (this._eventParents) {
	          delete this._eventParents[stamp(obj)];
	        }
	        return this;
	      },
	      _propagateEvent: function (e) {
	        for (var id in this._eventParents) {
	          this._eventParents[id].fire(e.type, extend({
	            layer: e.target,
	            propagatedFrom: e.target
	          }, e), true);
	        }
	      }
	    };

	    // aliases; we should ditch those eventually

	    // @method addEventListener(…): this
	    // Alias to [`on(…)`](#evented-on)
	    Events.addEventListener = Events.on;

	    // @method removeEventListener(…): this
	    // Alias to [`off(…)`](#evented-off)

	    // @method clearAllEventListeners(…): this
	    // Alias to [`off()`](#evented-off)
	    Events.removeEventListener = Events.clearAllEventListeners = Events.off;

	    // @method addOneTimeEventListener(…): this
	    // Alias to [`once(…)`](#evented-once)
	    Events.addOneTimeEventListener = Events.once;

	    // @method fireEvent(…): this
	    // Alias to [`fire(…)`](#evented-fire)
	    Events.fireEvent = Events.fire;

	    // @method hasEventListeners(…): Boolean
	    // Alias to [`listens(…)`](#evented-listens)
	    Events.hasEventListeners = Events.listens;
	    var Evented = Class.extend(Events);

	    /*
	     * @class Point
	     * @aka L.Point
	     *
	     * Represents a point with `x` and `y` coordinates in pixels.
	     *
	     * @example
	     *
	     * ```js
	     * var point = L.point(200, 300);
	     * ```
	     *
	     * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	     *
	     * ```js
	     * map.panBy([200, 300]);
	     * map.panBy(L.point(200, 300));
	     * ```
	     *
	     * Note that `Point` does not inherit from Leaflet's `Class` object,
	     * which means new classes can't inherit from it, and new methods
	     * can't be added to it with the `include` function.
	     */

	    function Point(x, y, round) {
	      // @property x: Number; The `x` coordinate of the point
	      this.x = round ? Math.round(x) : x;
	      // @property y: Number; The `y` coordinate of the point
	      this.y = round ? Math.round(y) : y;
	    }
	    var trunc = Math.trunc || function (v) {
	      return v > 0 ? Math.floor(v) : Math.ceil(v);
	    };
	    Point.prototype = {
	      // @method clone(): Point
	      // Returns a copy of the current point.
	      clone: function () {
	        return new Point(this.x, this.y);
	      },
	      // @method add(otherPoint: Point): Point
	      // Returns the result of addition of the current and the given points.
	      add: function (point) {
	        // non-destructive, returns a new point
	        return this.clone()._add(toPoint(point));
	      },
	      _add: function (point) {
	        // destructive, used directly for performance in situations where it's safe to modify existing point
	        this.x += point.x;
	        this.y += point.y;
	        return this;
	      },
	      // @method subtract(otherPoint: Point): Point
	      // Returns the result of subtraction of the given point from the current.
	      subtract: function (point) {
	        return this.clone()._subtract(toPoint(point));
	      },
	      _subtract: function (point) {
	        this.x -= point.x;
	        this.y -= point.y;
	        return this;
	      },
	      // @method divideBy(num: Number): Point
	      // Returns the result of division of the current point by the given number.
	      divideBy: function (num) {
	        return this.clone()._divideBy(num);
	      },
	      _divideBy: function (num) {
	        this.x /= num;
	        this.y /= num;
	        return this;
	      },
	      // @method multiplyBy(num: Number): Point
	      // Returns the result of multiplication of the current point by the given number.
	      multiplyBy: function (num) {
	        return this.clone()._multiplyBy(num);
	      },
	      _multiplyBy: function (num) {
	        this.x *= num;
	        this.y *= num;
	        return this;
	      },
	      // @method scaleBy(scale: Point): Point
	      // Multiply each coordinate of the current point by each coordinate of
	      // `scale`. In linear algebra terms, multiply the point by the
	      // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	      // defined by `scale`.
	      scaleBy: function (point) {
	        return new Point(this.x * point.x, this.y * point.y);
	      },
	      // @method unscaleBy(scale: Point): Point
	      // Inverse of `scaleBy`. Divide each coordinate of the current point by
	      // each coordinate of `scale`.
	      unscaleBy: function (point) {
	        return new Point(this.x / point.x, this.y / point.y);
	      },
	      // @method round(): Point
	      // Returns a copy of the current point with rounded coordinates.
	      round: function () {
	        return this.clone()._round();
	      },
	      _round: function () {
	        this.x = Math.round(this.x);
	        this.y = Math.round(this.y);
	        return this;
	      },
	      // @method floor(): Point
	      // Returns a copy of the current point with floored coordinates (rounded down).
	      floor: function () {
	        return this.clone()._floor();
	      },
	      _floor: function () {
	        this.x = Math.floor(this.x);
	        this.y = Math.floor(this.y);
	        return this;
	      },
	      // @method ceil(): Point
	      // Returns a copy of the current point with ceiled coordinates (rounded up).
	      ceil: function () {
	        return this.clone()._ceil();
	      },
	      _ceil: function () {
	        this.x = Math.ceil(this.x);
	        this.y = Math.ceil(this.y);
	        return this;
	      },
	      // @method trunc(): Point
	      // Returns a copy of the current point with truncated coordinates (rounded towards zero).
	      trunc: function () {
	        return this.clone()._trunc();
	      },
	      _trunc: function () {
	        this.x = trunc(this.x);
	        this.y = trunc(this.y);
	        return this;
	      },
	      // @method distanceTo(otherPoint: Point): Number
	      // Returns the cartesian distance between the current and the given points.
	      distanceTo: function (point) {
	        point = toPoint(point);
	        var x = point.x - this.x,
	          y = point.y - this.y;
	        return Math.sqrt(x * x + y * y);
	      },
	      // @method equals(otherPoint: Point): Boolean
	      // Returns `true` if the given point has the same coordinates.
	      equals: function (point) {
	        point = toPoint(point);
	        return point.x === this.x && point.y === this.y;
	      },
	      // @method contains(otherPoint: Point): Boolean
	      // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	      contains: function (point) {
	        point = toPoint(point);
	        return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
	      },
	      // @method toString(): String
	      // Returns a string representation of the point for debugging purposes.
	      toString: function () {
	        return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
	      }
	    };

	    // @factory L.point(x: Number, y: Number, round?: Boolean)
	    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.

	    // @alternative
	    // @factory L.point(coords: Number[])
	    // Expects an array of the form `[x, y]` instead.

	    // @alternative
	    // @factory L.point(coords: Object)
	    // Expects a plain object of the form `{x: Number, y: Number}` instead.
	    function toPoint(x, y, round) {
	      if (x instanceof Point) {
	        return x;
	      }
	      if (isArray(x)) {
	        return new Point(x[0], x[1]);
	      }
	      if (x === undefined || x === null) {
	        return x;
	      }
	      if (typeof x === 'object' && 'x' in x && 'y' in x) {
	        return new Point(x.x, x.y);
	      }
	      return new Point(x, y, round);
	    }

	    /*
	     * @class Bounds
	     * @aka L.Bounds
	     *
	     * Represents a rectangular area in pixel coordinates.
	     *
	     * @example
	     *
	     * ```js
	     * var p1 = L.point(10, 10),
	     * p2 = L.point(40, 60),
	     * bounds = L.bounds(p1, p2);
	     * ```
	     *
	     * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	     *
	     * ```js
	     * otherBounds.intersects([[10, 10], [40, 60]]);
	     * ```
	     *
	     * Note that `Bounds` does not inherit from Leaflet's `Class` object,
	     * which means new classes can't inherit from it, and new methods
	     * can't be added to it with the `include` function.
	     */

	    function Bounds(a, b) {
	      if (!a) {
	        return;
	      }
	      var points = b ? [a, b] : a;
	      for (var i = 0, len = points.length; i < len; i++) {
	        this.extend(points[i]);
	      }
	    }
	    Bounds.prototype = {
	      // @method extend(point: Point): this
	      // Extends the bounds to contain the given point.

	      // @alternative
	      // @method extend(otherBounds: Bounds): this
	      // Extend the bounds to contain the given bounds
	      extend: function (obj) {
	        var min2, max2;
	        if (!obj) {
	          return this;
	        }
	        if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) {
	          min2 = max2 = toPoint(obj);
	        } else {
	          obj = toBounds(obj);
	          min2 = obj.min;
	          max2 = obj.max;
	          if (!min2 || !max2) {
	            return this;
	          }
	        }

	        // @property min: Point
	        // The top left corner of the rectangle.
	        // @property max: Point
	        // The bottom right corner of the rectangle.
	        if (!this.min && !this.max) {
	          this.min = min2.clone();
	          this.max = max2.clone();
	        } else {
	          this.min.x = Math.min(min2.x, this.min.x);
	          this.max.x = Math.max(max2.x, this.max.x);
	          this.min.y = Math.min(min2.y, this.min.y);
	          this.max.y = Math.max(max2.y, this.max.y);
	        }
	        return this;
	      },
	      // @method getCenter(round?: Boolean): Point
	      // Returns the center point of the bounds.
	      getCenter: function (round) {
	        return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
	      },
	      // @method getBottomLeft(): Point
	      // Returns the bottom-left point of the bounds.
	      getBottomLeft: function () {
	        return toPoint(this.min.x, this.max.y);
	      },
	      // @method getTopRight(): Point
	      // Returns the top-right point of the bounds.
	      getTopRight: function () {
	        // -> Point
	        return toPoint(this.max.x, this.min.y);
	      },
	      // @method getTopLeft(): Point
	      // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
	      getTopLeft: function () {
	        return this.min; // left, top
	      },
	      // @method getBottomRight(): Point
	      // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
	      getBottomRight: function () {
	        return this.max; // right, bottom
	      },
	      // @method getSize(): Point
	      // Returns the size of the given bounds
	      getSize: function () {
	        return this.max.subtract(this.min);
	      },
	      // @method contains(otherBounds: Bounds): Boolean
	      // Returns `true` if the rectangle contains the given one.
	      // @alternative
	      // @method contains(point: Point): Boolean
	      // Returns `true` if the rectangle contains the given point.
	      contains: function (obj) {
	        var min, max;
	        if (typeof obj[0] === 'number' || obj instanceof Point) {
	          obj = toPoint(obj);
	        } else {
	          obj = toBounds(obj);
	        }
	        if (obj instanceof Bounds) {
	          min = obj.min;
	          max = obj.max;
	        } else {
	          min = max = obj;
	        }
	        return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
	      },
	      // @method intersects(otherBounds: Bounds): Boolean
	      // Returns `true` if the rectangle intersects the given bounds. Two bounds
	      // intersect if they have at least one point in common.
	      intersects: function (bounds) {
	        // (Bounds) -> Boolean
	        bounds = toBounds(bounds);
	        var min = this.min,
	          max = this.max,
	          min2 = bounds.min,
	          max2 = bounds.max,
	          xIntersects = max2.x >= min.x && min2.x <= max.x,
	          yIntersects = max2.y >= min.y && min2.y <= max.y;
	        return xIntersects && yIntersects;
	      },
	      // @method overlaps(otherBounds: Bounds): Boolean
	      // Returns `true` if the rectangle overlaps the given bounds. Two bounds
	      // overlap if their intersection is an area.
	      overlaps: function (bounds) {
	        // (Bounds) -> Boolean
	        bounds = toBounds(bounds);
	        var min = this.min,
	          max = this.max,
	          min2 = bounds.min,
	          max2 = bounds.max,
	          xOverlaps = max2.x > min.x && min2.x < max.x,
	          yOverlaps = max2.y > min.y && min2.y < max.y;
	        return xOverlaps && yOverlaps;
	      },
	      // @method isValid(): Boolean
	      // Returns `true` if the bounds are properly initialized.
	      isValid: function () {
	        return !!(this.min && this.max);
	      },
	      // @method pad(bufferRatio: Number): Bounds
	      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
	      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
	      // Negative values will retract the bounds.
	      pad: function (bufferRatio) {
	        var min = this.min,
	          max = this.max,
	          heightBuffer = Math.abs(min.x - max.x) * bufferRatio,
	          widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
	        return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
	      },
	      // @method equals(otherBounds: Bounds): Boolean
	      // Returns `true` if the rectangle is equivalent to the given bounds.
	      equals: function (bounds) {
	        if (!bounds) {
	          return false;
	        }
	        bounds = toBounds(bounds);
	        return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
	      }
	    };

	    // @factory L.bounds(corner1: Point, corner2: Point)
	    // Creates a Bounds object from two corners coordinate pairs.
	    // @alternative
	    // @factory L.bounds(points: Point[])
	    // Creates a Bounds object from the given array of points.
	    function toBounds(a, b) {
	      if (!a || a instanceof Bounds) {
	        return a;
	      }
	      return new Bounds(a, b);
	    }

	    /*
	     * @class LatLngBounds
	     * @aka L.LatLngBounds
	     *
	     * Represents a rectangular geographical area on a map.
	     *
	     * @example
	     *
	     * ```js
	     * var corner1 = L.latLng(40.712, -74.227),
	     * corner2 = L.latLng(40.774, -74.125),
	     * bounds = L.latLngBounds(corner1, corner2);
	     * ```
	     *
	     * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	     *
	     * ```js
	     * map.fitBounds([
	     * 	[40.712, -74.227],
	     * 	[40.774, -74.125]
	     * ]);
	     * ```
	     *
	     * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	     *
	     * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
	     * which means new classes can't inherit from it, and new methods
	     * can't be added to it with the `include` function.
	     */

	    function LatLngBounds(corner1, corner2) {
	      // (LatLng, LatLng) or (LatLng[])
	      if (!corner1) {
	        return;
	      }
	      var latlngs = corner2 ? [corner1, corner2] : corner1;
	      for (var i = 0, len = latlngs.length; i < len; i++) {
	        this.extend(latlngs[i]);
	      }
	    }
	    LatLngBounds.prototype = {
	      // @method extend(latlng: LatLng): this
	      // Extend the bounds to contain the given point

	      // @alternative
	      // @method extend(otherBounds: LatLngBounds): this
	      // Extend the bounds to contain the given bounds
	      extend: function (obj) {
	        var sw = this._southWest,
	          ne = this._northEast,
	          sw2,
	          ne2;
	        if (obj instanceof LatLng) {
	          sw2 = obj;
	          ne2 = obj;
	        } else if (obj instanceof LatLngBounds) {
	          sw2 = obj._southWest;
	          ne2 = obj._northEast;
	          if (!sw2 || !ne2) {
	            return this;
	          }
	        } else {
	          return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
	        }
	        if (!sw && !ne) {
	          this._southWest = new LatLng(sw2.lat, sw2.lng);
	          this._northEast = new LatLng(ne2.lat, ne2.lng);
	        } else {
	          sw.lat = Math.min(sw2.lat, sw.lat);
	          sw.lng = Math.min(sw2.lng, sw.lng);
	          ne.lat = Math.max(ne2.lat, ne.lat);
	          ne.lng = Math.max(ne2.lng, ne.lng);
	        }
	        return this;
	      },
	      // @method pad(bufferRatio: Number): LatLngBounds
	      // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
	      // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
	      // Negative values will retract the bounds.
	      pad: function (bufferRatio) {
	        var sw = this._southWest,
	          ne = this._northEast,
	          heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
	          widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	        return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	      },
	      // @method getCenter(): LatLng
	      // Returns the center point of the bounds.
	      getCenter: function () {
	        return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
	      },
	      // @method getSouthWest(): LatLng
	      // Returns the south-west point of the bounds.
	      getSouthWest: function () {
	        return this._southWest;
	      },
	      // @method getNorthEast(): LatLng
	      // Returns the north-east point of the bounds.
	      getNorthEast: function () {
	        return this._northEast;
	      },
	      // @method getNorthWest(): LatLng
	      // Returns the north-west point of the bounds.
	      getNorthWest: function () {
	        return new LatLng(this.getNorth(), this.getWest());
	      },
	      // @method getSouthEast(): LatLng
	      // Returns the south-east point of the bounds.
	      getSouthEast: function () {
	        return new LatLng(this.getSouth(), this.getEast());
	      },
	      // @method getWest(): Number
	      // Returns the west longitude of the bounds
	      getWest: function () {
	        return this._southWest.lng;
	      },
	      // @method getSouth(): Number
	      // Returns the south latitude of the bounds
	      getSouth: function () {
	        return this._southWest.lat;
	      },
	      // @method getEast(): Number
	      // Returns the east longitude of the bounds
	      getEast: function () {
	        return this._northEast.lng;
	      },
	      // @method getNorth(): Number
	      // Returns the north latitude of the bounds
	      getNorth: function () {
	        return this._northEast.lat;
	      },
	      // @method contains(otherBounds: LatLngBounds): Boolean
	      // Returns `true` if the rectangle contains the given one.

	      // @alternative
	      // @method contains (latlng: LatLng): Boolean
	      // Returns `true` if the rectangle contains the given point.
	      contains: function (obj) {
	        // (LatLngBounds) or (LatLng) -> Boolean
	        if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
	          obj = toLatLng(obj);
	        } else {
	          obj = toLatLngBounds(obj);
	        }
	        var sw = this._southWest,
	          ne = this._northEast,
	          sw2,
	          ne2;
	        if (obj instanceof LatLngBounds) {
	          sw2 = obj.getSouthWest();
	          ne2 = obj.getNorthEast();
	        } else {
	          sw2 = ne2 = obj;
	        }
	        return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
	      },
	      // @method intersects(otherBounds: LatLngBounds): Boolean
	      // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	      intersects: function (bounds) {
	        bounds = toLatLngBounds(bounds);
	        var sw = this._southWest,
	          ne = this._northEast,
	          sw2 = bounds.getSouthWest(),
	          ne2 = bounds.getNorthEast(),
	          latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat,
	          lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
	        return latIntersects && lngIntersects;
	      },
	      // @method overlaps(otherBounds: LatLngBounds): Boolean
	      // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	      overlaps: function (bounds) {
	        bounds = toLatLngBounds(bounds);
	        var sw = this._southWest,
	          ne = this._northEast,
	          sw2 = bounds.getSouthWest(),
	          ne2 = bounds.getNorthEast(),
	          latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat,
	          lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
	        return latOverlaps && lngOverlaps;
	      },
	      // @method toBBoxString(): String
	      // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	      toBBoxString: function () {
	        return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	      },
	      // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
	      // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
	      equals: function (bounds, maxMargin) {
	        if (!bounds) {
	          return false;
	        }
	        bounds = toLatLngBounds(bounds);
	        return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
	      },
	      // @method isValid(): Boolean
	      // Returns `true` if the bounds are properly initialized.
	      isValid: function () {
	        return !!(this._southWest && this._northEast);
	      }
	    };

	    // TODO International date line?

	    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.

	    // @alternative
	    // @factory L.latLngBounds(latlngs: LatLng[])
	    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	    function toLatLngBounds(a, b) {
	      if (a instanceof LatLngBounds) {
	        return a;
	      }
	      return new LatLngBounds(a, b);
	    }

	    /* @class LatLng
	     * @aka L.LatLng
	     *
	     * Represents a geographical point with a certain latitude and longitude.
	     *
	     * @example
	     *
	     * ```
	     * var latlng = L.latLng(50.5, 30.5);
	     * ```
	     *
	     * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	     *
	     * ```
	     * map.panTo([50, 30]);
	     * map.panTo({lon: 30, lat: 50});
	     * map.panTo({lat: 50, lng: 30});
	     * map.panTo(L.latLng(50, 30));
	     * ```
	     *
	     * Note that `LatLng` does not inherit from Leaflet's `Class` object,
	     * which means new classes can't inherit from it, and new methods
	     * can't be added to it with the `include` function.
	     */

	    function LatLng(lat, lng, alt) {
	      if (isNaN(lat) || isNaN(lng)) {
	        throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	      }

	      // @property lat: Number
	      // Latitude in degrees
	      this.lat = +lat;

	      // @property lng: Number
	      // Longitude in degrees
	      this.lng = +lng;

	      // @property alt: Number
	      // Altitude in meters (optional)
	      if (alt !== undefined) {
	        this.alt = +alt;
	      }
	    }
	    LatLng.prototype = {
	      // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	      // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
	      equals: function (obj, maxMargin) {
	        if (!obj) {
	          return false;
	        }
	        obj = toLatLng(obj);
	        var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
	        return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	      },
	      // @method toString(): String
	      // Returns a string representation of the point (for debugging purposes).
	      toString: function (precision) {
	        return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
	      },
	      // @method distanceTo(otherLatLng: LatLng): Number
	      // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
	      distanceTo: function (other) {
	        return Earth.distance(this, toLatLng(other));
	      },
	      // @method wrap(): LatLng
	      // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	      wrap: function () {
	        return Earth.wrapLatLng(this);
	      },
	      // @method toBounds(sizeInMeters: Number): LatLngBounds
	      // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
	      toBounds: function (sizeInMeters) {
	        var latAccuracy = 180 * sizeInMeters / 40075017,
	          lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
	        return toLatLngBounds([this.lat - latAccuracy, this.lng - lngAccuracy], [this.lat + latAccuracy, this.lng + lngAccuracy]);
	      },
	      clone: function () {
	        return new LatLng(this.lat, this.lng, this.alt);
	      }
	    };

	    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).

	    // @alternative
	    // @factory L.latLng(coords: Array): LatLng
	    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.

	    // @alternative
	    // @factory L.latLng(coords: Object): LatLng
	    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.

	    function toLatLng(a, b, c) {
	      if (a instanceof LatLng) {
	        return a;
	      }
	      if (isArray(a) && typeof a[0] !== 'object') {
	        if (a.length === 3) {
	          return new LatLng(a[0], a[1], a[2]);
	        }
	        if (a.length === 2) {
	          return new LatLng(a[0], a[1]);
	        }
	        return null;
	      }
	      if (a === undefined || a === null) {
	        return a;
	      }
	      if (typeof a === 'object' && 'lat' in a) {
	        return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	      }
	      if (b === undefined) {
	        return null;
	      }
	      return new LatLng(a, b, c);
	    }

	    /*
	     * @namespace CRS
	     * @crs L.CRS.Base
	     * Object that defines coordinate reference systems for projecting
	     * geographical points into pixel (screen) coordinates and back (and to
	     * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	     * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
	     *
	     * Leaflet defines the most usual CRSs by default. If you want to use a
	     * CRS not defined by default, take a look at the
	     * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	     *
	     * Note that the CRS instances do not inherit from Leaflet's `Class` object,
	     * and can't be instantiated. Also, new classes can't inherit from them,
	     * and methods can't be added to them with the `include` function.
	     */

	    var CRS = {
	      // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	      // Projects geographical coordinates into pixel coordinates for a given zoom.
	      latLngToPoint: function (latlng, zoom) {
	        var projectedPoint = this.projection.project(latlng),
	          scale = this.scale(zoom);
	        return this.transformation._transform(projectedPoint, scale);
	      },
	      // @method pointToLatLng(point: Point, zoom: Number): LatLng
	      // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	      // zoom into geographical coordinates.
	      pointToLatLng: function (point, zoom) {
	        var scale = this.scale(zoom),
	          untransformedPoint = this.transformation.untransform(point, scale);
	        return this.projection.unproject(untransformedPoint);
	      },
	      // @method project(latlng: LatLng): Point
	      // Projects geographical coordinates into coordinates in units accepted for
	      // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	      project: function (latlng) {
	        return this.projection.project(latlng);
	      },
	      // @method unproject(point: Point): LatLng
	      // Given a projected coordinate returns the corresponding LatLng.
	      // The inverse of `project`.
	      unproject: function (point) {
	        return this.projection.unproject(point);
	      },
	      // @method scale(zoom: Number): Number
	      // Returns the scale used when transforming projected coordinates into
	      // pixel coordinates for a particular zoom. For example, it returns
	      // `256 * 2^zoom` for Mercator-based CRS.
	      scale: function (zoom) {
	        return 256 * Math.pow(2, zoom);
	      },
	      // @method zoom(scale: Number): Number
	      // Inverse of `scale()`, returns the zoom level corresponding to a scale
	      // factor of `scale`.
	      zoom: function (scale) {
	        return Math.log(scale / 256) / Math.LN2;
	      },
	      // @method getProjectedBounds(zoom: Number): Bounds
	      // Returns the projection's bounds scaled and transformed for the provided `zoom`.
	      getProjectedBounds: function (zoom) {
	        if (this.infinite) {
	          return null;
	        }
	        var b = this.projection.bounds,
	          s = this.scale(zoom),
	          min = this.transformation.transform(b.min, s),
	          max = this.transformation.transform(b.max, s);
	        return new Bounds(min, max);
	      },
	      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
	      // Returns the distance between two geographical coordinates.

	      // @property code: String
	      // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	      //
	      // @property wrapLng: Number[]
	      // An array of two numbers defining whether the longitude (horizontal) coordinate
	      // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	      // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	      //
	      // @property wrapLat: Number[]
	      // Like `wrapLng`, but for the latitude (vertical) axis.

	      // wrapLng: [min, max],
	      // wrapLat: [min, max],

	      // @property infinite: Boolean
	      // If true, the coordinate space will be unbounded (infinite in both axes)
	      infinite: false,
	      // @method wrapLatLng(latlng: LatLng): LatLng
	      // Returns a `LatLng` where lat and lng has been wrapped according to the
	      // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	      wrapLatLng: function (latlng) {
	        var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
	          lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
	          alt = latlng.alt;
	        return new LatLng(lat, lng, alt);
	      },
	      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	      // Returns a `LatLngBounds` with the same size as the given one, ensuring
	      // that its center is within the CRS's bounds.
	      // Only accepts actual `L.LatLngBounds` instances, not arrays.
	      wrapLatLngBounds: function (bounds) {
	        var center = bounds.getCenter(),
	          newCenter = this.wrapLatLng(center),
	          latShift = center.lat - newCenter.lat,
	          lngShift = center.lng - newCenter.lng;
	        if (latShift === 0 && lngShift === 0) {
	          return bounds;
	        }
	        var sw = bounds.getSouthWest(),
	          ne = bounds.getNorthEast(),
	          newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
	          newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	        return new LatLngBounds(newSw, newNe);
	      }
	    };

	    /*
	     * @namespace CRS
	     * @crs L.CRS.Earth
	     *
	     * Serves as the base for CRS that are global such that they cover the earth.
	     * Can only be used as the base for other CRS and cannot be used directly,
	     * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	     * meters.
	     */

	    var Earth = extend({}, CRS, {
	      wrapLng: [-180, 180],
	      // Mean Earth Radius, as recommended for use by
	      // the International Union of Geodesy and Geophysics,
	      // see https://rosettacode.org/wiki/Haversine_formula
	      R: 6371000,
	      // distance between two geographical points using spherical law of cosines approximation
	      distance: function (latlng1, latlng2) {
	        var rad = Math.PI / 180,
	          lat1 = latlng1.lat * rad,
	          lat2 = latlng2.lat * rad,
	          sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
	          sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
	          a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
	          c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	        return this.R * c;
	      }
	    });

	    /*
	     * @namespace Projection
	     * @projection L.Projection.SphericalMercator
	     *
	     * Spherical Mercator projection — the most common projection for online maps,
	     * used by almost all free and commercial tile providers. Assumes that Earth is
	     * a sphere. Used by the `EPSG:3857` CRS.
	     */

	    var earthRadius = 6378137;
	    var SphericalMercator = {
	      R: earthRadius,
	      MAX_LATITUDE: 85.0511287798,
	      project: function (latlng) {
	        var d = Math.PI / 180,
	          max = this.MAX_LATITUDE,
	          lat = Math.max(Math.min(max, latlng.lat), -max),
	          sin = Math.sin(lat * d);
	        return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	      },
	      unproject: function (point) {
	        var d = 180 / Math.PI;
	        return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
	      },
	      bounds: function () {
	        var d = earthRadius * Math.PI;
	        return new Bounds([-d, -d], [d, d]);
	      }()
	    };

	    /*
	     * @class Transformation
	     * @aka L.Transformation
	     *
	     * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	     * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	     * the reverse. Used by Leaflet in its projections code.
	     *
	     * @example
	     *
	     * ```js
	     * var transformation = L.transformation(2, 5, -1, 10),
	     * 	p = L.point(1, 2),
	     * 	p2 = transformation.transform(p), //  L.point(7, 8)
	     * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	     * ```
	     */

	    // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	    // Creates a `Transformation` object with the given coefficients.
	    function Transformation(a, b, c, d) {
	      if (isArray(a)) {
	        // use array properties
	        this._a = a[0];
	        this._b = a[1];
	        this._c = a[2];
	        this._d = a[3];
	        return;
	      }
	      this._a = a;
	      this._b = b;
	      this._c = c;
	      this._d = d;
	    }
	    Transformation.prototype = {
	      // @method transform(point: Point, scale?: Number): Point
	      // Returns a transformed point, optionally multiplied by the given scale.
	      // Only accepts actual `L.Point` instances, not arrays.
	      transform: function (point, scale) {
	        // (Point, Number) -> Point
	        return this._transform(point.clone(), scale);
	      },
	      // destructive transform (faster)
	      _transform: function (point, scale) {
	        scale = scale || 1;
	        point.x = scale * (this._a * point.x + this._b);
	        point.y = scale * (this._c * point.y + this._d);
	        return point;
	      },
	      // @method untransform(point: Point, scale?: Number): Point
	      // Returns the reverse transformation of the given point, optionally divided
	      // by the given scale. Only accepts actual `L.Point` instances, not arrays.
	      untransform: function (point, scale) {
	        scale = scale || 1;
	        return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
	      }
	    };

	    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)

	    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	    // Instantiates a Transformation object with the given coefficients.

	    // @alternative
	    // @factory L.transformation(coefficients: Array): Transformation
	    // Expects an coefficients array of the form
	    // `[a: Number, b: Number, c: Number, d: Number]`.

	    function toTransformation(a, b, c, d) {
	      return new Transformation(a, b, c, d);
	    }

	    /*
	     * @namespace CRS
	     * @crs L.CRS.EPSG3857
	     *
	     * The most common CRS for online maps, used by almost all free and commercial
	     * tile providers. Uses Spherical Mercator projection. Set in by default in
	     * Map's `crs` option.
	     */

	    var EPSG3857 = extend({}, Earth, {
	      code: 'EPSG:3857',
	      projection: SphericalMercator,
	      transformation: function () {
	        var scale = 0.5 / (Math.PI * SphericalMercator.R);
	        return toTransformation(scale, 0.5, -scale, 0.5);
	      }()
	    });
	    var EPSG900913 = extend({}, EPSG3857, {
	      code: 'EPSG:900913'
	    });

	    // @namespace SVG; @section
	    // There are several static functions which can be called without instantiating L.SVG:

	    // @function create(name: String): SVGElement
	    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	    // corresponding to the class name passed. For example, using 'line' will return
	    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	    function svgCreate(name) {
	      return document.createElementNS('http://www.w3.org/2000/svg', name);
	    }

	    // @function pointsToPath(rings: Point[], closed: Boolean): String
	    // Generates a SVG path string for multiple rings, with each ring turning
	    // into "M..L..L.." instructions
	    function pointsToPath(rings, closed) {
	      var str = '',
	        i,
	        j,
	        len,
	        len2,
	        points,
	        p;
	      for (i = 0, len = rings.length; i < len; i++) {
	        points = rings[i];
	        for (j = 0, len2 = points.length; j < len2; j++) {
	          p = points[j];
	          str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
	        }

	        // closes the ring for polygons; "x" is VML syntax
	        str += closed ? Browser.svg ? 'z' : 'x' : '';
	      }

	      // SVG complains about empty path strings
	      return str || 'M0 0';
	    }

	    /*
	     * @namespace Browser
	     * @aka L.Browser
	     *
	     * A namespace with static properties for browser/feature detection used by Leaflet internally.
	     *
	     * @example
	     *
	     * ```js
	     * if (L.Browser.ielt9) {
	     *   alert('Upgrade your browser, dude!');
	     * }
	     * ```
	     */

	    var style = document.documentElement.style;

	    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	    var ie = 'ActiveXObject' in window;

	    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	    var ielt9 = ie && !document.addEventListener;

	    // @property edge: Boolean; `true` for the Edge web browser.
	    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);

	    // @property webkit: Boolean;
	    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	    var webkit = userAgentContains('webkit');

	    // @property android: Boolean
	    // **Deprecated.** `true` for any browser running on an Android platform.
	    var android = userAgentContains('android');

	    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
	    var android23 = userAgentContains('android 2') || userAgentContains('android 3');

	    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
	    var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
	    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
	    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);

	    // @property opera: Boolean; `true` for the Opera browser
	    var opera = !!window.opera;

	    // @property chrome: Boolean; `true` for the Chrome browser.
	    var chrome = !edge && userAgentContains('chrome');

	    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;

	    // @property safari: Boolean; `true` for the Safari browser.
	    var safari = !chrome && userAgentContains('safari');
	    var phantom = userAgentContains('phantom');

	    // @property opera12: Boolean
	    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
	    var opera12 = 'OTransition' in style;

	    // @property win: Boolean; `true` when the browser is running in a Windows platform
	    var win = navigator.platform.indexOf('Win') === 0;

	    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	    var ie3d = ie && 'transition' in style;

	    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;

	    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	    var gecko3d = 'MozPerspective' in style;

	    // @property any3d: Boolean
	    // `true` for all browsers supporting CSS transforms.
	    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;

	    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
	    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');

	    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	    var mobileWebkit = mobile && webkit;

	    // @property mobileWebkit3d: Boolean
	    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	    var mobileWebkit3d = mobile && webkit3d;

	    // @property msPointer: Boolean
	    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
	    var msPointer = !window.PointerEvent && window.MSPointerEvent;

	    // @property pointer: Boolean
	    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	    var pointer = !!(window.PointerEvent || msPointer);

	    // @property touchNative: Boolean
	    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	    // **This does not necessarily mean** that the browser is running in a computer with
	    // a touchscreen, it only means that the browser is capable of understanding
	    // touch events.
	    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;

	    // @property touch: Boolean
	    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
	    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
	    var touch = !window.L_NO_TOUCH && (touchNative || pointer);

	    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	    var mobileOpera = mobile && opera;

	    // @property mobileGecko: Boolean
	    // `true` for gecko-based browsers running in a mobile device.
	    var mobileGecko = mobile && gecko;

	    // @property retina: Boolean
	    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
	    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;

	    // @property passiveEvents: Boolean
	    // `true` for browsers that support passive events.
	    var passiveEvents = function () {
	      var supportsPassiveOption = false;
	      try {
	        var opts = Object.defineProperty({}, 'passive', {
	          get: function () {
	            // eslint-disable-line getter-return
	            supportsPassiveOption = true;
	          }
	        });
	        window.addEventListener('testPassiveEventSupport', falseFn, opts);
	        window.removeEventListener('testPassiveEventSupport', falseFn, opts);
	      } catch (e) {
	        // Errors can safely be ignored since this is only a browser support test.
	      }
	      return supportsPassiveOption;
	    }();

	    // @property canvas: Boolean
	    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	    var canvas$1 = function () {
	      return !!document.createElement('canvas').getContext;
	    }();

	    // @property svg: Boolean
	    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	    var inlineSvg = !!svg$1 && function () {
	      var div = document.createElement('div');
	      div.innerHTML = '<svg/>';
	      return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
	    }();

	    // @property vml: Boolean
	    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	    var vml = !svg$1 && function () {
	      try {
	        var div = document.createElement('div');
	        div.innerHTML = '<v:shape adj="1"/>';
	        var shape = div.firstChild;
	        shape.style.behavior = 'url(#default#VML)';
	        return shape && typeof shape.adj === 'object';
	      } catch (e) {
	        return false;
	      }
	    }();

	    // @property mac: Boolean; `true` when the browser is running in a Mac platform
	    var mac = navigator.platform.indexOf('Mac') === 0;

	    // @property mac: Boolean; `true` when the browser is running in a Linux platform
	    var linux = navigator.platform.indexOf('Linux') === 0;
	    function userAgentContains(str) {
	      return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	    }
	    var Browser = {
	      ie: ie,
	      ielt9: ielt9,
	      edge: edge,
	      webkit: webkit,
	      android: android,
	      android23: android23,
	      androidStock: androidStock,
	      opera: opera,
	      chrome: chrome,
	      gecko: gecko,
	      safari: safari,
	      phantom: phantom,
	      opera12: opera12,
	      win: win,
	      ie3d: ie3d,
	      webkit3d: webkit3d,
	      gecko3d: gecko3d,
	      any3d: any3d,
	      mobile: mobile,
	      mobileWebkit: mobileWebkit,
	      mobileWebkit3d: mobileWebkit3d,
	      msPointer: msPointer,
	      pointer: pointer,
	      touch: touch,
	      touchNative: touchNative,
	      mobileOpera: mobileOpera,
	      mobileGecko: mobileGecko,
	      retina: retina,
	      passiveEvents: passiveEvents,
	      canvas: canvas$1,
	      svg: svg$1,
	      vml: vml,
	      inlineSvg: inlineSvg,
	      mac: mac,
	      linux: linux
	    };

	    /*
	     * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	     */

	    var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
	    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
	    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
	    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
	    var pEvent = {
	      touchstart: POINTER_DOWN,
	      touchmove: POINTER_MOVE,
	      touchend: POINTER_UP,
	      touchcancel: POINTER_CANCEL
	    };
	    var handle = {
	      touchstart: _onPointerStart,
	      touchmove: _handlePointer,
	      touchend: _handlePointer,
	      touchcancel: _handlePointer
	    };
	    var _pointers = {};
	    var _pointerDocListener = false;

	    // Provides a touch events wrapper for (ms)pointer events.
	    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890

	    function addPointerListener(obj, type, handler) {
	      if (type === 'touchstart') {
	        _addPointerDocListener();
	      }
	      if (!handle[type]) {
	        console.warn('wrong event specified:', type);
	        return falseFn;
	      }
	      handler = handle[type].bind(this, handler);
	      obj.addEventListener(pEvent[type], handler, false);
	      return handler;
	    }
	    function removePointerListener(obj, type, handler) {
	      if (!pEvent[type]) {
	        console.warn('wrong event specified:', type);
	        return;
	      }
	      obj.removeEventListener(pEvent[type], handler, false);
	    }
	    function _globalPointerDown(e) {
	      _pointers[e.pointerId] = e;
	    }
	    function _globalPointerMove(e) {
	      if (_pointers[e.pointerId]) {
	        _pointers[e.pointerId] = e;
	      }
	    }
	    function _globalPointerUp(e) {
	      delete _pointers[e.pointerId];
	    }
	    function _addPointerDocListener() {
	      // need to keep track of what pointers and how many are active to provide e.touches emulation
	      if (!_pointerDocListener) {
	        // we listen document as any drags that end by moving the touch off the screen get fired there
	        document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
	        document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
	        document.addEventListener(POINTER_UP, _globalPointerUp, true);
	        document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	        _pointerDocListener = true;
	      }
	    }
	    function _handlePointer(handler, e) {
	      if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) {
	        return;
	      }
	      e.touches = [];
	      for (var i in _pointers) {
	        e.touches.push(_pointers[i]);
	      }
	      e.changedTouches = [e];
	      handler(e);
	    }
	    function _onPointerStart(handler, e) {
	      // IE10 specific: MsTouch needs preventDefault. See #2000
	      if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
	        preventDefault(e);
	      }
	      _handlePointer(handler, e);
	    }

	    /*
	     * Extends the event handling code with double tap support for mobile browsers.
	     *
	     * Note: currently most browsers fire native dblclick, with only a few exceptions
	     * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
	     */

	    function makeDblclick(event) {
	      // in modern browsers `type` cannot be just overridden:
	      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
	      var newEvent = {},
	        prop,
	        i;
	      for (i in event) {
	        prop = event[i];
	        newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
	      }
	      event = newEvent;
	      newEvent.type = 'dblclick';
	      newEvent.detail = 2;
	      newEvent.isTrusted = false;
	      newEvent._simulated = true; // for debug purposes
	      return newEvent;
	    }
	    var delay = 200;
	    function addDoubleTapListener(obj, handler) {
	      // Most browsers handle double tap natively
	      obj.addEventListener('dblclick', handler);

	      // On some platforms the browser doesn't fire native dblclicks for touch events.
	      // It seems that in all such cases `detail` property of `click` event is always `1`.
	      // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
	      var last = 0,
	        detail;
	      function simDblclick(e) {
	        if (e.detail !== 1) {
	          detail = e.detail; // keep in sync to avoid false dblclick in some cases
	          return;
	        }
	        if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) {
	          return;
	        }

	        // When clicking on an <input>, the browser generates a click on its
	        // <label> (and vice versa) triggering two clicks in quick succession.
	        // This ignores clicks on elements which are a label with a 'for'
	        // attribute (or children of such a label), but not children of
	        // a <input>.
	        var path = getPropagationPath(e);
	        if (path.some(function (el) {
	          return el instanceof HTMLLabelElement && el.attributes.for;
	        }) && !path.some(function (el) {
	          return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
	        })) {
	          return;
	        }
	        var now = Date.now();
	        if (now - last <= delay) {
	          detail++;
	          if (detail === 2) {
	            handler(makeDblclick(e));
	          }
	        } else {
	          detail = 1;
	        }
	        last = now;
	      }
	      obj.addEventListener('click', simDblclick);
	      return {
	        dblclick: handler,
	        simDblclick: simDblclick
	      };
	    }
	    function removeDoubleTapListener(obj, handlers) {
	      obj.removeEventListener('dblclick', handlers.dblclick);
	      obj.removeEventListener('click', handlers.simDblclick);
	    }

	    /*
	     * @namespace DomUtil
	     *
	     * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	     * tree, used by Leaflet internally.
	     *
	     * Most functions expecting or returning a `HTMLElement` also work for
	     * SVG elements. The only difference is that classes refer to CSS classes
	     * in HTML and SVG classes in SVG.
	     */

	    // @property TRANSFORM: String
	    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	    var TRANSFORM = testProp(['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);

	    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
	    // the same for the transitionend event, in particular the Android 4.1 stock browser

	    // @property TRANSITION: String
	    // Vendor-prefixed transition style name.
	    var TRANSITION = testProp(['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);

	    // @property TRANSITION_END: String
	    // Vendor-prefixed transitionend event name.
	    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';

	    // @function get(id: String|HTMLElement): HTMLElement
	    // Returns an element given its DOM id, or returns the element itself
	    // if it was passed directly.
	    function get(id) {
	      return typeof id === 'string' ? document.getElementById(id) : id;
	    }

	    // @function getStyle(el: HTMLElement, styleAttrib: String): String
	    // Returns the value for a certain style attribute on an element,
	    // including computed values or values set through CSS.
	    function getStyle(el, style) {
	      var value = el.style[style] || el.currentStyle && el.currentStyle[style];
	      if ((!value || value === 'auto') && document.defaultView) {
	        var css = document.defaultView.getComputedStyle(el, null);
	        value = css ? css[style] : null;
	      }
	      return value === 'auto' ? null : value;
	    }

	    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	    function create$1(tagName, className, container) {
	      var el = document.createElement(tagName);
	      el.className = className || '';
	      if (container) {
	        container.appendChild(el);
	      }
	      return el;
	    }

	    // @function remove(el: HTMLElement)
	    // Removes `el` from its parent element
	    function remove(el) {
	      var parent = el.parentNode;
	      if (parent) {
	        parent.removeChild(el);
	      }
	    }

	    // @function empty(el: HTMLElement)
	    // Removes all of `el`'s children elements from `el`
	    function empty(el) {
	      while (el.firstChild) {
	        el.removeChild(el.firstChild);
	      }
	    }

	    // @function toFront(el: HTMLElement)
	    // Makes `el` the last child of its parent, so it renders in front of the other children.
	    function toFront(el) {
	      var parent = el.parentNode;
	      if (parent && parent.lastChild !== el) {
	        parent.appendChild(el);
	      }
	    }

	    // @function toBack(el: HTMLElement)
	    // Makes `el` the first child of its parent, so it renders behind the other children.
	    function toBack(el) {
	      var parent = el.parentNode;
	      if (parent && parent.firstChild !== el) {
	        parent.insertBefore(el, parent.firstChild);
	      }
	    }

	    // @function hasClass(el: HTMLElement, name: String): Boolean
	    // Returns `true` if the element's class attribute contains `name`.
	    function hasClass(el, name) {
	      if (el.classList !== undefined) {
	        return el.classList.contains(name);
	      }
	      var className = getClass(el);
	      return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	    }

	    // @function addClass(el: HTMLElement, name: String)
	    // Adds `name` to the element's class attribute.
	    function addClass(el, name) {
	      if (el.classList !== undefined) {
	        var classes = splitWords(name);
	        for (var i = 0, len = classes.length; i < len; i++) {
	          el.classList.add(classes[i]);
	        }
	      } else if (!hasClass(el, name)) {
	        var className = getClass(el);
	        setClass(el, (className ? className + ' ' : '') + name);
	      }
	    }

	    // @function removeClass(el: HTMLElement, name: String)
	    // Removes `name` from the element's class attribute.
	    function removeClass(el, name) {
	      if (el.classList !== undefined) {
	        el.classList.remove(name);
	      } else {
	        setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
	      }
	    }

	    // @function setClass(el: HTMLElement, name: String)
	    // Sets the element's class.
	    function setClass(el, name) {
	      if (el.className.baseVal === undefined) {
	        el.className = name;
	      } else {
	        // in case of SVG element
	        el.className.baseVal = name;
	      }
	    }

	    // @function getClass(el: HTMLElement): String
	    // Returns the element's class.
	    function getClass(el) {
	      // Check if the element is an SVGElementInstance and use the correspondingElement instead
	      // (Required for linked SVG elements in IE11.)
	      if (el.correspondingElement) {
	        el = el.correspondingElement;
	      }
	      return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	    }

	    // @function setOpacity(el: HTMLElement, opacity: Number)
	    // Set the opacity of an element (including old IE support).
	    // `opacity` must be a number from `0` to `1`.
	    function setOpacity(el, value) {
	      if ('opacity' in el.style) {
	        el.style.opacity = value;
	      } else if ('filter' in el.style) {
	        _setOpacityIE(el, value);
	      }
	    }
	    function _setOpacityIE(el, value) {
	      var filter = false,
	        filterName = 'DXImageTransform.Microsoft.Alpha';

	      // filters collection throws an error if we try to retrieve a filter that doesn't exist
	      try {
	        filter = el.filters.item(filterName);
	      } catch (e) {
	        // don't set opacity to 1 if we haven't already set an opacity,
	        // it isn't needed and breaks transparent pngs.
	        if (value === 1) {
	          return;
	        }
	      }
	      value = Math.round(value * 100);
	      if (filter) {
	        filter.Enabled = value !== 100;
	        filter.Opacity = value;
	      } else {
	        el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
	      }
	    }

	    // @function testProp(props: String[]): String|false
	    // Goes through the array of style names and returns the first name
	    // that is a valid style name for an element. If no such name is found,
	    // it returns false. Useful for vendor-prefixed styles like `transform`.
	    function testProp(props) {
	      var style = document.documentElement.style;
	      for (var i = 0; i < props.length; i++) {
	        if (props[i] in style) {
	          return props[i];
	        }
	      }
	      return false;
	    }

	    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	    // and optionally scaled by `scale`. Does not have an effect if the
	    // browser doesn't support 3D CSS transforms.
	    function setTransform(el, offset, scale) {
	      var pos = offset || new Point(0, 0);
	      el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
	    }

	    // @function setPosition(el: HTMLElement, position: Point)
	    // Sets the position of `el` to coordinates specified by `position`,
	    // using CSS translate or top/left positioning depending on the browser
	    // (used by Leaflet internally to position its layers).
	    function setPosition(el, point) {
	      /*eslint-disable */
	      el._leaflet_pos = point;
	      /* eslint-enable */

	      if (Browser.any3d) {
	        setTransform(el, point);
	      } else {
	        el.style.left = point.x + 'px';
	        el.style.top = point.y + 'px';
	      }
	    }

	    // @function getPosition(el: HTMLElement): Point
	    // Returns the coordinates of an element previously positioned with setPosition.
	    function getPosition(el) {
	      // this method is only used for elements previously positioned using setPosition,
	      // so it's safe to cache the position for performance

	      return el._leaflet_pos || new Point(0, 0);
	    }

	    // @function disableTextSelection()
	    // Prevents the user from generating `selectstart` DOM events, usually generated
	    // when the user drags the mouse through a page with text. Used internally
	    // by Leaflet to override the behaviour of any click-and-drag interaction on
	    // the map. Affects drag interactions on the whole document.

	    // @function enableTextSelection()
	    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	    var disableTextSelection;
	    var enableTextSelection;
	    var _userSelect;
	    if ('onselectstart' in document) {
	      disableTextSelection = function () {
	        on(window, 'selectstart', preventDefault);
	      };
	      enableTextSelection = function () {
	        off(window, 'selectstart', preventDefault);
	      };
	    } else {
	      var userSelectProperty = testProp(['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	      disableTextSelection = function () {
	        if (userSelectProperty) {
	          var style = document.documentElement.style;
	          _userSelect = style[userSelectProperty];
	          style[userSelectProperty] = 'none';
	        }
	      };
	      enableTextSelection = function () {
	        if (userSelectProperty) {
	          document.documentElement.style[userSelectProperty] = _userSelect;
	          _userSelect = undefined;
	        }
	      };
	    }

	    // @function disableImageDrag()
	    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	    // for `dragstart` DOM events, usually generated when the user drags an image.
	    function disableImageDrag() {
	      on(window, 'dragstart', preventDefault);
	    }

	    // @function enableImageDrag()
	    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	    function enableImageDrag() {
	      off(window, 'dragstart', preventDefault);
	    }
	    var _outlineElement, _outlineStyle;
	    // @function preventOutline(el: HTMLElement)
	    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	    // of the element `el` invisible. Used internally by Leaflet to prevent
	    // focusable elements from displaying an outline when the user performs a
	    // drag interaction on them.
	    function preventOutline(element) {
	      while (element.tabIndex === -1) {
	        element = element.parentNode;
	      }
	      if (!element.style) {
	        return;
	      }
	      restoreOutline();
	      _outlineElement = element;
	      _outlineStyle = element.style.outlineStyle;
	      element.style.outlineStyle = 'none';
	      on(window, 'keydown', restoreOutline);
	    }

	    // @function restoreOutline()
	    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	    function restoreOutline() {
	      if (!_outlineElement) {
	        return;
	      }
	      _outlineElement.style.outlineStyle = _outlineStyle;
	      _outlineElement = undefined;
	      _outlineStyle = undefined;
	      off(window, 'keydown', restoreOutline);
	    }

	    // @function getSizedParentNode(el: HTMLElement): HTMLElement
	    // Finds the closest parent node which size (width and height) is not null.
	    function getSizedParentNode(element) {
	      do {
	        element = element.parentNode;
	      } while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
	      return element;
	    }

	    // @function getScale(el: HTMLElement): Object
	    // Computes the CSS scale currently applied on the element.
	    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
	    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
	    function getScale(element) {
	      var rect = element.getBoundingClientRect(); // Read-only in old browsers.

	      return {
	        x: rect.width / element.offsetWidth || 1,
	        y: rect.height / element.offsetHeight || 1,
	        boundingClientRect: rect
	      };
	    }
	    var DomUtil = {
	      __proto__: null,
	      TRANSFORM: TRANSFORM,
	      TRANSITION: TRANSITION,
	      TRANSITION_END: TRANSITION_END,
	      get: get,
	      getStyle: getStyle,
	      create: create$1,
	      remove: remove,
	      empty: empty,
	      toFront: toFront,
	      toBack: toBack,
	      hasClass: hasClass,
	      addClass: addClass,
	      removeClass: removeClass,
	      setClass: setClass,
	      getClass: getClass,
	      setOpacity: setOpacity,
	      testProp: testProp,
	      setTransform: setTransform,
	      setPosition: setPosition,
	      getPosition: getPosition,
	      get disableTextSelection() {
	        return disableTextSelection;
	      },
	      get enableTextSelection() {
	        return enableTextSelection;
	      },
	      disableImageDrag: disableImageDrag,
	      enableImageDrag: enableImageDrag,
	      preventOutline: preventOutline,
	      restoreOutline: restoreOutline,
	      getSizedParentNode: getSizedParentNode,
	      getScale: getScale
	    };

	    /*
	     * @namespace DomEvent
	     * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	     */

	    // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.

	    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	    // Adds a listener function (`fn`) to a particular DOM event type of the
	    // element `el`. You can optionally specify the context of the listener
	    // (object the `this` keyword will point to). You can also pass several
	    // space-separated types (e.g. `'click dblclick'`).

	    // @alternative
	    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	    function on(obj, types, fn, context) {
	      if (types && typeof types === 'object') {
	        for (var type in types) {
	          addOne(obj, type, types[type], fn);
	        }
	      } else {
	        types = splitWords(types);
	        for (var i = 0, len = types.length; i < len; i++) {
	          addOne(obj, types[i], fn, context);
	        }
	      }
	      return this;
	    }
	    var eventsKey = '_leaflet_events';

	    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	    // Removes a previously added listener function.
	    // Note that if you passed a custom context to on, you must pass the same
	    // context to `off` in order to remove the listener.

	    // @alternative
	    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`

	    // @alternative
	    // @function off(el: HTMLElement, types: String): this
	    // Removes all previously added listeners of given types.

	    // @alternative
	    // @function off(el: HTMLElement): this
	    // Removes all previously added listeners from given HTMLElement
	    function off(obj, types, fn, context) {
	      if (arguments.length === 1) {
	        batchRemove(obj);
	        delete obj[eventsKey];
	      } else if (types && typeof types === 'object') {
	        for (var type in types) {
	          removeOne(obj, type, types[type], fn);
	        }
	      } else {
	        types = splitWords(types);
	        if (arguments.length === 2) {
	          batchRemove(obj, function (type) {
	            return indexOf(types, type) !== -1;
	          });
	        } else {
	          for (var i = 0, len = types.length; i < len; i++) {
	            removeOne(obj, types[i], fn, context);
	          }
	        }
	      }
	      return this;
	    }
	    function batchRemove(obj, filterFn) {
	      for (var id in obj[eventsKey]) {
	        var type = id.split(/\d/)[0];
	        if (!filterFn || filterFn(type)) {
	          removeOne(obj, type, null, null, id);
	        }
	      }
	    }
	    var mouseSubst = {
	      mouseenter: 'mouseover',
	      mouseleave: 'mouseout',
	      wheel: !('onwheel' in window) && 'mousewheel'
	    };
	    function addOne(obj, type, fn, context) {
	      var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	      if (obj[eventsKey] && obj[eventsKey][id]) {
	        return this;
	      }
	      var handler = function (e) {
	        return fn.call(context || obj, e || window.event);
	      };
	      var originalHandler = handler;
	      if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) {
	        // Needs DomEvent.Pointer.js
	        handler = addPointerListener(obj, type, handler);
	      } else if (Browser.touch && type === 'dblclick') {
	        handler = addDoubleTapListener(obj, handler);
	      } else if ('addEventListener' in obj) {
	        if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') {
	          obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
	            passive: false
	          } : false);
	        } else if (type === 'mouseenter' || type === 'mouseleave') {
	          handler = function (e) {
	            e = e || window.event;
	            if (isExternalTarget(obj, e)) {
	              originalHandler(e);
	            }
	          };
	          obj.addEventListener(mouseSubst[type], handler, false);
	        } else {
	          obj.addEventListener(type, originalHandler, false);
	        }
	      } else {
	        obj.attachEvent('on' + type, handler);
	      }
	      obj[eventsKey] = obj[eventsKey] || {};
	      obj[eventsKey][id] = handler;
	    }
	    function removeOne(obj, type, fn, context, id) {
	      id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
	      var handler = obj[eventsKey] && obj[eventsKey][id];
	      if (!handler) {
	        return this;
	      }
	      if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) {
	        removePointerListener(obj, type, handler);
	      } else if (Browser.touch && type === 'dblclick') {
	        removeDoubleTapListener(obj, handler);
	      } else if ('removeEventListener' in obj) {
	        obj.removeEventListener(mouseSubst[type] || type, handler, false);
	      } else {
	        obj.detachEvent('on' + type, handler);
	      }
	      obj[eventsKey][id] = null;
	    }

	    // @function stopPropagation(ev: DOMEvent): this
	    // Stop the given event from propagation to parent elements. Used inside the listener functions:
	    // ```js
	    // L.DomEvent.on(div, 'click', function (ev) {
	    // 	L.DomEvent.stopPropagation(ev);
	    // });
	    // ```
	    function stopPropagation(e) {
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      } else if (e.originalEvent) {
	        // In case of Leaflet event.
	        e.originalEvent._stopped = true;
	      } else {
	        e.cancelBubble = true;
	      }
	      return this;
	    }

	    // @function disableScrollPropagation(el: HTMLElement): this
	    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
	    function disableScrollPropagation(el) {
	      addOne(el, 'wheel', stopPropagation);
	      return this;
	    }

	    // @function disableClickPropagation(el: HTMLElement): this
	    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
	    // `'mousedown'` and `'touchstart'` events (plus browser variants).
	    function disableClickPropagation(el) {
	      on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
	      el['_leaflet_disable_click'] = true;
	      return this;
	    }

	    // @function preventDefault(ev: DOMEvent): this
	    // Prevents the default action of the DOM Event `ev` from happening (such as
	    // following a link in the href of the a element, or doing a POST request
	    // with page reload when a `<form>` is submitted).
	    // Use it inside listener functions.
	    function preventDefault(e) {
	      if (e.preventDefault) {
	        e.preventDefault();
	      } else {
	        e.returnValue = false;
	      }
	      return this;
	    }

	    // @function stop(ev: DOMEvent): this
	    // Does `stopPropagation` and `preventDefault` at the same time.
	    function stop(e) {
	      preventDefault(e);
	      stopPropagation(e);
	      return this;
	    }

	    // @function getPropagationPath(ev: DOMEvent): Array
	    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
	    // Returns an array containing the `HTMLElement`s that the given DOM event
	    // should propagate to (if not stopped).
	    function getPropagationPath(ev) {
	      if (ev.composedPath) {
	        return ev.composedPath();
	      }
	      var path = [];
	      var el = ev.target;
	      while (el) {
	        path.push(el);
	        el = el.parentNode;
	      }
	      return path;
	    }

	    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	    // Gets normalized mouse position from a DOM event relative to the
	    // `container` (border excluded) or to the whole page if not specified.
	    function getMousePosition(e, container) {
	      if (!container) {
	        return new Point(e.clientX, e.clientY);
	      }
	      var scale = getScale(container),
	        offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)

	      return new Point(
	      // offset.left/top values are in page scale (like clientX/Y),
	      // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
	      (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
	    }

	    //  except , Safari and
	    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
	    // except OSX (Mac) -> 3x, Chrome running on Linux 1x

	    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
	    // @function getWheelDelta(ev: DOMEvent): Number
	    // Gets normalized wheel delta from a wheel DOM event, in vertical
	    // pixels scrolled (negative if scrolling down).
	    // Events from pointing devices without precise scrolling are mapped to
	    // a best guess of 60 pixels.
	    function getWheelDelta(e) {
	      return Browser.edge ? e.wheelDeltaY / 2 :
	      // Don't trust window-geometry-based delta
	      e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor :
	      // Pixels
	      e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 :
	      // Lines
	      e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 :
	      // Pages
	      e.deltaX || e.deltaZ ? 0 :
	      // Skip horizontal/depth wheel events
	      e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 :
	      // Legacy IE pixels
	      e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 :
	      // Legacy Moz lines
	      e.detail ? e.detail / -32765 * 60 :
	      // Legacy Moz pages
	      0;
	    }

	    // check if element really left/entered the event target (for mouseenter/mouseleave)
	    function isExternalTarget(el, e) {
	      var related = e.relatedTarget;
	      if (!related) {
	        return true;
	      }
	      try {
	        while (related && related !== el) {
	          related = related.parentNode;
	        }
	      } catch (err) {
	        return false;
	      }
	      return related !== el;
	    }
	    var DomEvent = {
	      __proto__: null,
	      on: on,
	      off: off,
	      stopPropagation: stopPropagation,
	      disableScrollPropagation: disableScrollPropagation,
	      disableClickPropagation: disableClickPropagation,
	      preventDefault: preventDefault,
	      stop: stop,
	      getPropagationPath: getPropagationPath,
	      getMousePosition: getMousePosition,
	      getWheelDelta: getWheelDelta,
	      isExternalTarget: isExternalTarget,
	      addListener: on,
	      removeListener: off
	    };

	    /*
	     * @class PosAnimation
	     * @aka L.PosAnimation
	     * @inherits Evented
	     * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	     *
	     * @example
	     * ```js
	     * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
	     *
	     * myPositionMarker.on("click", function() {
	     * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
	     * 	pos.y -= 25;
	     * 	var fx = new L.PosAnimation();
	     *
	     * 	fx.once('end',function() {
	     * 		pos.y += 25;
	     * 		fx.run(myPositionMarker._icon, pos, 0.8);
	     * 	});
	     *
	     * 	fx.run(myPositionMarker._icon, pos, 0.3);
	     * });
	     *
	     * ```
	     *
	     * @constructor L.PosAnimation()
	     * Creates a `PosAnimation` object.
	     *
	     */

	    var PosAnimation = Evented.extend({
	      // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	      // Run an animation of a given element to a new position, optionally setting
	      // duration in seconds (`0.25` by default) and easing linearity factor (3rd
	      // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
	      // `0.5` by default).
	      run: function (el, newPos, duration, easeLinearity) {
	        this.stop();
	        this._el = el;
	        this._inProgress = true;
	        this._duration = duration || 0.25;
	        this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	        this._startPos = getPosition(el);
	        this._offset = newPos.subtract(this._startPos);
	        this._startTime = +new Date();

	        // @event start: Event
	        // Fired when the animation starts
	        this.fire('start');
	        this._animate();
	      },
	      // @method stop()
	      // Stops the animation (if currently running).
	      stop: function () {
	        if (!this._inProgress) {
	          return;
	        }
	        this._step(true);
	        this._complete();
	      },
	      _animate: function () {
	        // animation loop
	        this._animId = requestAnimFrame(this._animate, this);
	        this._step();
	      },
	      _step: function (round) {
	        var elapsed = +new Date() - this._startTime,
	          duration = this._duration * 1000;
	        if (elapsed < duration) {
	          this._runFrame(this._easeOut(elapsed / duration), round);
	        } else {
	          this._runFrame(1);
	          this._complete();
	        }
	      },
	      _runFrame: function (progress, round) {
	        var pos = this._startPos.add(this._offset.multiplyBy(progress));
	        if (round) {
	          pos._round();
	        }
	        setPosition(this._el, pos);

	        // @event step: Event
	        // Fired continuously during the animation.
	        this.fire('step');
	      },
	      _complete: function () {
	        cancelAnimFrame(this._animId);
	        this._inProgress = false;
	        // @event end: Event
	        // Fired when the animation ends.
	        this.fire('end');
	      },
	      _easeOut: function (t) {
	        return 1 - Math.pow(1 - t, this._easeOutPower);
	      }
	    });

	    /*
	     * @class Map
	     * @aka L.Map
	     * @inherits Evented
	     *
	     * The central class of the API — it is used to create a map on a page and manipulate it.
	     *
	     * @example
	     *
	     * ```js
	     * // initialize the map on the "map" div with a given center and zoom
	     * var map = L.map('map', {
	     * 	center: [51.505, -0.09],
	     * 	zoom: 13
	     * });
	     * ```
	     *
	     */

	    var Map = Evented.extend({
	      options: {
	        // @section Map State Options
	        // @option crs: CRS = L.CRS.EPSG3857
	        // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
	        // sure what it means.
	        crs: EPSG3857,
	        // @option center: LatLng = undefined
	        // Initial geographic center of the map
	        center: undefined,
	        // @option zoom: Number = undefined
	        // Initial map zoom level
	        zoom: undefined,
	        // @option minZoom: Number = *
	        // Minimum zoom level of the map.
	        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	        // the lowest of their `minZoom` options will be used instead.
	        minZoom: undefined,
	        // @option maxZoom: Number = *
	        // Maximum zoom level of the map.
	        // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	        // the highest of their `maxZoom` options will be used instead.
	        maxZoom: undefined,
	        // @option layers: Layer[] = []
	        // Array of layers that will be added to the map initially
	        layers: [],
	        // @option maxBounds: LatLngBounds = null
	        // When this option is set, the map restricts the view to the given
	        // geographical bounds, bouncing the user back if the user tries to pan
	        // outside the view. To set the restriction dynamically, use
	        // [`setMaxBounds`](#map-setmaxbounds) method.
	        maxBounds: undefined,
	        // @option renderer: Renderer = *
	        // The default method for drawing vector layers on the map. `L.SVG`
	        // or `L.Canvas` by default depending on browser support.
	        renderer: undefined,
	        // @section Animation Options
	        // @option zoomAnimation: Boolean = true
	        // Whether the map zoom animation is enabled. By default it's enabled
	        // in all browsers that support CSS3 Transitions except Android.
	        zoomAnimation: true,
	        // @option zoomAnimationThreshold: Number = 4
	        // Won't animate zoom if the zoom difference exceeds this value.
	        zoomAnimationThreshold: 4,
	        // @option fadeAnimation: Boolean = true
	        // Whether the tile fade animation is enabled. By default it's enabled
	        // in all browsers that support CSS3 Transitions except Android.
	        fadeAnimation: true,
	        // @option markerZoomAnimation: Boolean = true
	        // Whether markers animate their zoom with the zoom animation, if disabled
	        // they will disappear for the length of the animation. By default it's
	        // enabled in all browsers that support CSS3 Transitions except Android.
	        markerZoomAnimation: true,
	        // @option transform3DLimit: Number = 2^23
	        // Defines the maximum size of a CSS translation transform. The default
	        // value should not be changed unless a web browser positions layers in
	        // the wrong place after doing a large `panBy`.
	        transform3DLimit: 8388608,
	        // Precision limit of a 32-bit float

	        // @section Interaction Options
	        // @option zoomSnap: Number = 1
	        // Forces the map's zoom level to always be a multiple of this, particularly
	        // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
	        // By default, the zoom level snaps to the nearest integer; lower values
	        // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
	        // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
	        zoomSnap: 1,
	        // @option zoomDelta: Number = 1
	        // Controls how much the map's zoom level will change after a
	        // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
	        // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
	        // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
	        zoomDelta: 1,
	        // @option trackResize: Boolean = true
	        // Whether the map automatically handles browser window resize to update itself.
	        trackResize: true
	      },
	      initialize: function (id, options) {
	        // (HTMLElement or String, Object)
	        options = setOptions(this, options);

	        // Make sure to assign internal flags at the beginning,
	        // to avoid inconsistent state in some edge cases.
	        this._handlers = [];
	        this._layers = {};
	        this._zoomBoundLayers = {};
	        this._sizeChanged = true;
	        this._initContainer(id);
	        this._initLayout();

	        // hack for https://github.com/Leaflet/Leaflet/issues/1980
	        this._onResize = bind(this._onResize, this);
	        this._initEvents();
	        if (options.maxBounds) {
	          this.setMaxBounds(options.maxBounds);
	        }
	        if (options.zoom !== undefined) {
	          this._zoom = this._limitZoom(options.zoom);
	        }
	        if (options.center && options.zoom !== undefined) {
	          this.setView(toLatLng(options.center), options.zoom, {
	            reset: true
	          });
	        }
	        this.callInitHooks();

	        // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
	        this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;

	        // zoom transitions run with the same duration for all layers, so if one of transitionend events
	        // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
	        if (this._zoomAnimated) {
	          this._createAnimProxy();
	          on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
	        }
	        this._addLayers(this.options.layers);
	      },
	      // @section Methods for modifying map state

	      // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	      // Sets the view of the map (geographical center and zoom) with the given
	      // animation options.
	      setView: function (center, zoom, options) {
	        zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
	        center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
	        options = options || {};
	        this._stop();
	        if (this._loaded && !options.reset && options !== true) {
	          if (options.animate !== undefined) {
	            options.zoom = extend({
	              animate: options.animate
	            }, options.zoom);
	            options.pan = extend({
	              animate: options.animate,
	              duration: options.duration
	            }, options.pan);
	          }

	          // try animating pan or zoom
	          var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
	          if (moved) {
	            // prevent resize handler call, the view will refresh after animation anyway
	            clearTimeout(this._sizeTimer);
	            return this;
	          }
	        }

	        // animation didn't start, just reset the map view
	        this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
	        return this;
	      },
	      // @method setZoom(zoom: Number, options?: Zoom/pan options): this
	      // Sets the zoom of the map.
	      setZoom: function (zoom, options) {
	        if (!this._loaded) {
	          this._zoom = zoom;
	          return this;
	        }
	        return this.setView(this.getCenter(), zoom, {
	          zoom: options
	        });
	      },
	      // @method zoomIn(delta?: Number, options?: Zoom options): this
	      // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	      zoomIn: function (delta, options) {
	        delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
	        return this.setZoom(this._zoom + delta, options);
	      },
	      // @method zoomOut(delta?: Number, options?: Zoom options): this
	      // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	      zoomOut: function (delta, options) {
	        delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
	        return this.setZoom(this._zoom - delta, options);
	      },
	      // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	      // Zooms the map while keeping a specified geographical point on the map
	      // stationary (e.g. used internally for scroll zoom and double-click zoom).
	      // @alternative
	      // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	      // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	      setZoomAround: function (latlng, zoom, options) {
	        var scale = this.getZoomScale(zoom),
	          viewHalf = this.getSize().divideBy(2),
	          containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	          centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
	          newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	        return this.setView(newCenter, zoom, {
	          zoom: options
	        });
	      },
	      _getBoundsCenterZoom: function (bounds, options) {
	        options = options || {};
	        bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	        var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	          paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	          zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	        zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
	        if (zoom === Infinity) {
	          return {
	            center: bounds.getCenter(),
	            zoom: zoom
	          };
	        }
	        var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	          swPoint = this.project(bounds.getSouthWest(), zoom),
	          nePoint = this.project(bounds.getNorthEast(), zoom),
	          center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	        return {
	          center: center,
	          zoom: zoom
	        };
	      },
	      // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
	      // Sets a map view that contains the given geographical bounds with the
	      // maximum zoom level possible.
	      fitBounds: function (bounds, options) {
	        bounds = toLatLngBounds(bounds);
	        if (!bounds.isValid()) {
	          throw new Error('Bounds are not valid.');
	        }
	        var target = this._getBoundsCenterZoom(bounds, options);
	        return this.setView(target.center, target.zoom, options);
	      },
	      // @method fitWorld(options?: fitBounds options): this
	      // Sets a map view that mostly contains the whole world with the maximum
	      // zoom level possible.
	      fitWorld: function (options) {
	        return this.fitBounds([[-90, -180], [90, 180]], options);
	      },
	      // @method panTo(latlng: LatLng, options?: Pan options): this
	      // Pans the map to a given center.
	      panTo: function (center, options) {
	        // (LatLng)
	        return this.setView(center, this._zoom, {
	          pan: options
	        });
	      },
	      // @method panBy(offset: Point, options?: Pan options): this
	      // Pans the map by a given number of pixels (animated).
	      panBy: function (offset, options) {
	        offset = toPoint(offset).round();
	        options = options || {};
	        if (!offset.x && !offset.y) {
	          return this.fire('moveend');
	        }
	        // If we pan too far, Chrome gets issues with tiles
	        // and makes them disappear or appear in the wrong place (slightly offset) #2602
	        if (options.animate !== true && !this.getSize().contains(offset)) {
	          this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
	          return this;
	        }
	        if (!this._panAnim) {
	          this._panAnim = new PosAnimation();
	          this._panAnim.on({
	            'step': this._onPanTransitionStep,
	            'end': this._onPanTransitionEnd
	          }, this);
	        }

	        // don't fire movestart if animating inertia
	        if (!options.noMoveStart) {
	          this.fire('movestart');
	        }

	        // animate pan unless animate: false specified
	        if (options.animate !== false) {
	          addClass(this._mapPane, 'leaflet-pan-anim');
	          var newPos = this._getMapPanePos().subtract(offset).round();
	          this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
	        } else {
	          this._rawPanBy(offset);
	          this.fire('move').fire('moveend');
	        }
	        return this;
	      },
	      // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	      // Sets the view of the map (geographical center and zoom) performing a smooth
	      // pan-zoom animation.
	      flyTo: function (targetCenter, targetZoom, options) {
	        options = options || {};
	        if (options.animate === false || !Browser.any3d) {
	          return this.setView(targetCenter, targetZoom, options);
	        }
	        this._stop();
	        var from = this.project(this.getCenter()),
	          to = this.project(targetCenter),
	          size = this.getSize(),
	          startZoom = this._zoom;
	        targetCenter = toLatLng(targetCenter);
	        targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	        var w0 = Math.max(size.x, size.y),
	          w1 = w0 * this.getZoomScale(startZoom, targetZoom),
	          u1 = to.distanceTo(from) || 1,
	          rho = 1.42,
	          rho2 = rho * rho;
	        function r(i) {
	          var s1 = i ? -1 : 1,
	            s2 = i ? w1 : w0,
	            t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
	            b1 = 2 * s2 * rho2 * u1,
	            b = t1 / b1,
	            sq = Math.sqrt(b * b + 1) - b;

	          // workaround for floating point precision bug when sq = 0, log = -Infinite,
	          // thus triggering an infinite loop in flyTo
	          var log = sq < 0.000000001 ? -18 : Math.log(sq);
	          return log;
	        }
	        function sinh(n) {
	          return (Math.exp(n) - Math.exp(-n)) / 2;
	        }
	        function cosh(n) {
	          return (Math.exp(n) + Math.exp(-n)) / 2;
	        }
	        function tanh(n) {
	          return sinh(n) / cosh(n);
	        }
	        var r0 = r(0);
	        function w(s) {
	          return w0 * (cosh(r0) / cosh(r0 + rho * s));
	        }
	        function u(s) {
	          return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
	        }
	        function easeOut(t) {
	          return 1 - Math.pow(1 - t, 1.5);
	        }
	        var start = Date.now(),
	          S = (r(1) - r0) / rho,
	          duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	        function frame() {
	          var t = (Date.now() - start) / duration,
	            s = easeOut(t) * S;
	          if (t <= 1) {
	            this._flyToFrame = requestAnimFrame(frame, this);
	            this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
	              flyTo: true
	            });
	          } else {
	            this._move(targetCenter, targetZoom)._moveEnd(true);
	          }
	        }
	        this._moveStart(true, options.noMoveStart);
	        frame.call(this);
	        return this;
	      },
	      // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	      // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	      // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	      flyToBounds: function (bounds, options) {
	        var target = this._getBoundsCenterZoom(bounds, options);
	        return this.flyTo(target.center, target.zoom, options);
	      },
	      // @method setMaxBounds(bounds: LatLngBounds): this
	      // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	      setMaxBounds: function (bounds) {
	        bounds = toLatLngBounds(bounds);
	        if (this.listens('moveend', this._panInsideMaxBounds)) {
	          this.off('moveend', this._panInsideMaxBounds);
	        }
	        if (!bounds.isValid()) {
	          this.options.maxBounds = null;
	          return this;
	        }
	        this.options.maxBounds = bounds;
	        if (this._loaded) {
	          this._panInsideMaxBounds();
	        }
	        return this.on('moveend', this._panInsideMaxBounds);
	      },
	      // @method setMinZoom(zoom: Number): this
	      // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	      setMinZoom: function (zoom) {
	        var oldZoom = this.options.minZoom;
	        this.options.minZoom = zoom;
	        if (this._loaded && oldZoom !== zoom) {
	          this.fire('zoomlevelschange');
	          if (this.getZoom() < this.options.minZoom) {
	            return this.setZoom(zoom);
	          }
	        }
	        return this;
	      },
	      // @method setMaxZoom(zoom: Number): this
	      // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	      setMaxZoom: function (zoom) {
	        var oldZoom = this.options.maxZoom;
	        this.options.maxZoom = zoom;
	        if (this._loaded && oldZoom !== zoom) {
	          this.fire('zoomlevelschange');
	          if (this.getZoom() > this.options.maxZoom) {
	            return this.setZoom(zoom);
	          }
	        }
	        return this;
	      },
	      // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	      // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	      panInsideBounds: function (bounds, options) {
	        this._enforcingBounds = true;
	        var center = this.getCenter(),
	          newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	        if (!center.equals(newCenter)) {
	          this.panTo(newCenter, options);
	        }
	        this._enforcingBounds = false;
	        return this;
	      },
	      // @method panInside(latlng: LatLng, options?: padding options): this
	      // Pans the map the minimum amount to make the `latlng` visible. Use
	      // padding options to fit the display to more restricted bounds.
	      // If `latlng` is already within the (optionally padded) display bounds,
	      // the map will not be panned.
	      panInside: function (latlng, options) {
	        options = options || {};
	        var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	          paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	          pixelCenter = this.project(this.getCenter()),
	          pixelPoint = this.project(latlng),
	          pixelBounds = this.getPixelBounds(),
	          paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]),
	          paddedSize = paddedBounds.getSize();
	        if (!paddedBounds.contains(pixelPoint)) {
	          this._enforcingBounds = true;
	          var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
	          var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
	          pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
	          pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
	          this.panTo(this.unproject(pixelCenter), options);
	          this._enforcingBounds = false;
	        }
	        return this;
	      },
	      // @method invalidateSize(options: Zoom/pan options): this
	      // Checks if the map container size changed and updates the map if so —
	      // call it after you've changed the map size dynamically, also animating
	      // pan by default. If `options.pan` is `false`, panning will not occur.
	      // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	      // that it doesn't happen often even if the method is called many
	      // times in a row.

	      // @alternative
	      // @method invalidateSize(animate: Boolean): this
	      // Checks if the map container size changed and updates the map if so —
	      // call it after you've changed the map size dynamically, also animating
	      // pan by default.
	      invalidateSize: function (options) {
	        if (!this._loaded) {
	          return this;
	        }
	        options = extend({
	          animate: false,
	          pan: true
	        }, options === true ? {
	          animate: true
	        } : options);
	        var oldSize = this.getSize();
	        this._sizeChanged = true;
	        this._lastCenter = null;
	        var newSize = this.getSize(),
	          oldCenter = oldSize.divideBy(2).round(),
	          newCenter = newSize.divideBy(2).round(),
	          offset = oldCenter.subtract(newCenter);
	        if (!offset.x && !offset.y) {
	          return this;
	        }
	        if (options.animate && options.pan) {
	          this.panBy(offset);
	        } else {
	          if (options.pan) {
	            this._rawPanBy(offset);
	          }
	          this.fire('move');
	          if (options.debounceMoveend) {
	            clearTimeout(this._sizeTimer);
	            this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
	          } else {
	            this.fire('moveend');
	          }
	        }

	        // @section Map state change events
	        // @event resize: ResizeEvent
	        // Fired when the map is resized.
	        return this.fire('resize', {
	          oldSize: oldSize,
	          newSize: newSize
	        });
	      },
	      // @section Methods for modifying map state
	      // @method stop(): this
	      // Stops the currently running `panTo` or `flyTo` animation, if any.
	      stop: function () {
	        this.setZoom(this._limitZoom(this._zoom));
	        if (!this.options.zoomSnap) {
	          this.fire('viewreset');
	        }
	        return this._stop();
	      },
	      // @section Geolocation methods
	      // @method locate(options?: Locate options): this
	      // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	      // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	      // and optionally sets the map view to the user's location with respect to
	      // detection accuracy (or to the world view if geolocation failed).
	      // Note that, if your page doesn't use HTTPS, this method will fail in
	      // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	      // See `Locate options` for more details.
	      locate: function (options) {
	        options = this._locateOptions = extend({
	          timeout: 10000,
	          watch: false
	          // setView: false
	          // maxZoom: <Number>
	          // maximumAge: 0
	          // enableHighAccuracy: false
	        }, options);
	        if (!('geolocation' in navigator)) {
	          this._handleGeolocationError({
	            code: 0,
	            message: 'Geolocation not supported.'
	          });
	          return this;
	        }
	        var onResponse = bind(this._handleGeolocationResponse, this),
	          onError = bind(this._handleGeolocationError, this);
	        if (options.watch) {
	          this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
	        } else {
	          navigator.geolocation.getCurrentPosition(onResponse, onError, options);
	        }
	        return this;
	      },
	      // @method stopLocate(): this
	      // Stops watching location previously initiated by `map.locate({watch: true})`
	      // and aborts resetting the map view if map.locate was called with
	      // `{setView: true}`.
	      stopLocate: function () {
	        if (navigator.geolocation && navigator.geolocation.clearWatch) {
	          navigator.geolocation.clearWatch(this._locationWatchId);
	        }
	        if (this._locateOptions) {
	          this._locateOptions.setView = false;
	        }
	        return this;
	      },
	      _handleGeolocationError: function (error) {
	        if (!this._container._leaflet_id) {
	          return;
	        }
	        var c = error.code,
	          message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
	        if (this._locateOptions.setView && !this._loaded) {
	          this.fitWorld();
	        }

	        // @section Location events
	        // @event locationerror: ErrorEvent
	        // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
	        this.fire('locationerror', {
	          code: c,
	          message: 'Geolocation error: ' + message + '.'
	        });
	      },
	      _handleGeolocationResponse: function (pos) {
	        if (!this._container._leaflet_id) {
	          return;
	        }
	        var lat = pos.coords.latitude,
	          lng = pos.coords.longitude,
	          latlng = new LatLng(lat, lng),
	          bounds = latlng.toBounds(pos.coords.accuracy * 2),
	          options = this._locateOptions;
	        if (options.setView) {
	          var zoom = this.getBoundsZoom(bounds);
	          this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
	        }
	        var data = {
	          latlng: latlng,
	          bounds: bounds,
	          timestamp: pos.timestamp
	        };
	        for (var i in pos.coords) {
	          if (typeof pos.coords[i] === 'number') {
	            data[i] = pos.coords[i];
	          }
	        }

	        // @event locationfound: LocationEvent
	        // Fired when geolocation (using the [`locate`](#map-locate) method)
	        // went successfully.
	        this.fire('locationfound', data);
	      },
	      // TODO Appropriate docs section?
	      // @section Other Methods
	      // @method addHandler(name: String, HandlerClass: Function): this
	      // Adds a new `Handler` to the map, given its name and constructor function.
	      addHandler: function (name, HandlerClass) {
	        if (!HandlerClass) {
	          return this;
	        }
	        var handler = this[name] = new HandlerClass(this);
	        this._handlers.push(handler);
	        if (this.options[name]) {
	          handler.enable();
	        }
	        return this;
	      },
	      // @method remove(): this
	      // Destroys the map and clears all related event listeners.
	      remove: function () {
	        this._initEvents(true);
	        if (this.options.maxBounds) {
	          this.off('moveend', this._panInsideMaxBounds);
	        }
	        if (this._containerId !== this._container._leaflet_id) {
	          throw new Error('Map container is being reused by another instance');
	        }
	        try {
	          // throws error in IE6-8
	          delete this._container._leaflet_id;
	          delete this._containerId;
	        } catch (e) {
	          /*eslint-disable */
	          this._container._leaflet_id = undefined;
	          /* eslint-enable */
	          this._containerId = undefined;
	        }
	        if (this._locationWatchId !== undefined) {
	          this.stopLocate();
	        }
	        this._stop();
	        remove(this._mapPane);
	        if (this._clearControlPos) {
	          this._clearControlPos();
	        }
	        if (this._resizeRequest) {
	          cancelAnimFrame(this._resizeRequest);
	          this._resizeRequest = null;
	        }
	        this._clearHandlers();
	        if (this._loaded) {
	          // @section Map state change events
	          // @event unload: Event
	          // Fired when the map is destroyed with [remove](#map-remove) method.
	          this.fire('unload');
	        }
	        var i;
	        for (i in this._layers) {
	          this._layers[i].remove();
	        }
	        for (i in this._panes) {
	          remove(this._panes[i]);
	        }
	        this._layers = [];
	        this._panes = [];
	        delete this._mapPane;
	        delete this._renderer;
	        return this;
	      },
	      // @section Other Methods
	      // @method createPane(name: String, container?: HTMLElement): HTMLElement
	      // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	      // then returns it. The pane is created as a child of `container`, or
	      // as a child of the main map pane if not set.
	      createPane: function (name, container) {
	        var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
	          pane = create$1('div', className, container || this._mapPane);
	        if (name) {
	          this._panes[name] = pane;
	        }
	        return pane;
	      },
	      // @section Methods for Getting Map State

	      // @method getCenter(): LatLng
	      // Returns the geographical center of the map view
	      getCenter: function () {
	        this._checkIfLoaded();
	        if (this._lastCenter && !this._moved()) {
	          return this._lastCenter.clone();
	        }
	        return this.layerPointToLatLng(this._getCenterLayerPoint());
	      },
	      // @method getZoom(): Number
	      // Returns the current zoom level of the map view
	      getZoom: function () {
	        return this._zoom;
	      },
	      // @method getBounds(): LatLngBounds
	      // Returns the geographical bounds visible in the current map view
	      getBounds: function () {
	        var bounds = this.getPixelBounds(),
	          sw = this.unproject(bounds.getBottomLeft()),
	          ne = this.unproject(bounds.getTopRight());
	        return new LatLngBounds(sw, ne);
	      },
	      // @method getMinZoom(): Number
	      // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	      getMinZoom: function () {
	        return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	      },
	      // @method getMaxZoom(): Number
	      // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	      getMaxZoom: function () {
	        return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
	      },
	      // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
	      // Returns the maximum zoom level on which the given bounds fit to the map
	      // view in its entirety. If `inside` (optional) is set to `true`, the method
	      // instead returns the minimum zoom level on which the map view fits into
	      // the given bounds in its entirety.
	      getBoundsZoom: function (bounds, inside, padding) {
	        // (LatLngBounds[, Boolean, Point]) -> Number
	        bounds = toLatLngBounds(bounds);
	        padding = toPoint(padding || [0, 0]);
	        var zoom = this.getZoom() || 0,
	          min = this.getMinZoom(),
	          max = this.getMaxZoom(),
	          nw = bounds.getNorthWest(),
	          se = bounds.getSouthEast(),
	          size = this.getSize().subtract(padding),
	          boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
	          snap = Browser.any3d ? this.options.zoomSnap : 1,
	          scalex = size.x / boundsSize.x,
	          scaley = size.y / boundsSize.y,
	          scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	        zoom = this.getScaleZoom(scale, zoom);
	        if (snap) {
	          zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
	          zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
	        }
	        return Math.max(min, Math.min(max, zoom));
	      },
	      // @method getSize(): Point
	      // Returns the current size of the map container (in pixels).
	      getSize: function () {
	        if (!this._size || this._sizeChanged) {
	          this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
	          this._sizeChanged = false;
	        }
	        return this._size.clone();
	      },
	      // @method getPixelBounds(): Bounds
	      // Returns the bounds of the current map view in projected pixel
	      // coordinates (sometimes useful in layer and overlay implementations).
	      getPixelBounds: function (center, zoom) {
	        var topLeftPoint = this._getTopLeftPoint(center, zoom);
	        return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	      },
	      // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	      // the map pane? "left point of the map layer" can be confusing, specially
	      // since there can be negative offsets.
	      // @method getPixelOrigin(): Point
	      // Returns the projected pixel coordinates of the top left point of
	      // the map layer (useful in custom layer and overlay implementations).
	      getPixelOrigin: function () {
	        this._checkIfLoaded();
	        return this._pixelOrigin;
	      },
	      // @method getPixelWorldBounds(zoom?: Number): Bounds
	      // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	      // If `zoom` is omitted, the map's current zoom level is used.
	      getPixelWorldBounds: function (zoom) {
	        return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	      },
	      // @section Other Methods

	      // @method getPane(pane: String|HTMLElement): HTMLElement
	      // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	      getPane: function (pane) {
	        return typeof pane === 'string' ? this._panes[pane] : pane;
	      },
	      // @method getPanes(): Object
	      // Returns a plain object containing the names of all [panes](#map-pane) as keys and
	      // the panes as values.
	      getPanes: function () {
	        return this._panes;
	      },
	      // @method getContainer: HTMLElement
	      // Returns the HTML element that contains the map.
	      getContainer: function () {
	        return this._container;
	      },
	      // @section Conversion Methods

	      // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	      // Returns the scale factor to be applied to a map transition from zoom level
	      // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	      getZoomScale: function (toZoom, fromZoom) {
	        // TODO replace with universal implementation after refactoring projections
	        var crs = this.options.crs;
	        fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	        return crs.scale(toZoom) / crs.scale(fromZoom);
	      },
	      // @method getScaleZoom(scale: Number, fromZoom: Number): Number
	      // Returns the zoom level that the map would end up at, if it is at `fromZoom`
	      // level and everything is scaled by a factor of `scale`. Inverse of
	      // [`getZoomScale`](#map-getZoomScale).
	      getScaleZoom: function (scale, fromZoom) {
	        var crs = this.options.crs;
	        fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	        var zoom = crs.zoom(scale * crs.scale(fromZoom));
	        return isNaN(zoom) ? Infinity : zoom;
	      },
	      // @method project(latlng: LatLng, zoom: Number): Point
	      // Projects a geographical coordinate `LatLng` according to the projection
	      // of the map's CRS, then scales it according to `zoom` and the CRS's
	      // `Transformation`. The result is pixel coordinate relative to
	      // the CRS origin.
	      project: function (latlng, zoom) {
	        zoom = zoom === undefined ? this._zoom : zoom;
	        return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
	      },
	      // @method unproject(point: Point, zoom: Number): LatLng
	      // Inverse of [`project`](#map-project).
	      unproject: function (point, zoom) {
	        zoom = zoom === undefined ? this._zoom : zoom;
	        return this.options.crs.pointToLatLng(toPoint(point), zoom);
	      },
	      // @method layerPointToLatLng(point: Point): LatLng
	      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	      // returns the corresponding geographical coordinate (for the current zoom level).
	      layerPointToLatLng: function (point) {
	        var projectedPoint = toPoint(point).add(this.getPixelOrigin());
	        return this.unproject(projectedPoint);
	      },
	      // @method latLngToLayerPoint(latlng: LatLng): Point
	      // Given a geographical coordinate, returns the corresponding pixel coordinate
	      // relative to the [origin pixel](#map-getpixelorigin).
	      latLngToLayerPoint: function (latlng) {
	        var projectedPoint = this.project(toLatLng(latlng))._round();
	        return projectedPoint._subtract(this.getPixelOrigin());
	      },
	      // @method wrapLatLng(latlng: LatLng): LatLng
	      // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	      // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	      // CRS's bounds.
	      // By default this means longitude is wrapped around the dateline so its
	      // value is between -180 and +180 degrees.
	      wrapLatLng: function (latlng) {
	        return this.options.crs.wrapLatLng(toLatLng(latlng));
	      },
	      // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	      // Returns a `LatLngBounds` with the same size as the given one, ensuring that
	      // its center is within the CRS's bounds.
	      // By default this means the center longitude is wrapped around the dateline so its
	      // value is between -180 and +180 degrees, and the majority of the bounds
	      // overlaps the CRS's bounds.
	      wrapLatLngBounds: function (latlng) {
	        return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
	      },
	      // @method distance(latlng1: LatLng, latlng2: LatLng): Number
	      // Returns the distance between two geographical coordinates according to
	      // the map's CRS. By default this measures distance in meters.
	      distance: function (latlng1, latlng2) {
	        return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
	      },
	      // @method containerPointToLayerPoint(point: Point): Point
	      // Given a pixel coordinate relative to the map container, returns the corresponding
	      // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	      containerPointToLayerPoint: function (point) {
	        // (Point)
	        return toPoint(point).subtract(this._getMapPanePos());
	      },
	      // @method layerPointToContainerPoint(point: Point): Point
	      // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	      // returns the corresponding pixel coordinate relative to the map container.
	      layerPointToContainerPoint: function (point) {
	        // (Point)
	        return toPoint(point).add(this._getMapPanePos());
	      },
	      // @method containerPointToLatLng(point: Point): LatLng
	      // Given a pixel coordinate relative to the map container, returns
	      // the corresponding geographical coordinate (for the current zoom level).
	      containerPointToLatLng: function (point) {
	        var layerPoint = this.containerPointToLayerPoint(toPoint(point));
	        return this.layerPointToLatLng(layerPoint);
	      },
	      // @method latLngToContainerPoint(latlng: LatLng): Point
	      // Given a geographical coordinate, returns the corresponding pixel coordinate
	      // relative to the map container.
	      latLngToContainerPoint: function (latlng) {
	        return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
	      },
	      // @method mouseEventToContainerPoint(ev: MouseEvent): Point
	      // Given a MouseEvent object, returns the pixel coordinate relative to the
	      // map container where the event took place.
	      mouseEventToContainerPoint: function (e) {
	        return getMousePosition(e, this._container);
	      },
	      // @method mouseEventToLayerPoint(ev: MouseEvent): Point
	      // Given a MouseEvent object, returns the pixel coordinate relative to
	      // the [origin pixel](#map-getpixelorigin) where the event took place.
	      mouseEventToLayerPoint: function (e) {
	        return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	      },
	      // @method mouseEventToLatLng(ev: MouseEvent): LatLng
	      // Given a MouseEvent object, returns geographical coordinate where the
	      // event took place.
	      mouseEventToLatLng: function (e) {
	        // (MouseEvent)
	        return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	      },
	      // map initialization methods

	      _initContainer: function (id) {
	        var container = this._container = get(id);
	        if (!container) {
	          throw new Error('Map container not found.');
	        } else if (container._leaflet_id) {
	          throw new Error('Map container is already initialized.');
	        }
	        on(container, 'scroll', this._onScroll, this);
	        this._containerId = stamp(container);
	      },
	      _initLayout: function () {
	        var container = this._container;
	        this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
	        addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	        var position = getStyle(container, 'position');
	        if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') {
	          container.style.position = 'relative';
	        }
	        this._initPanes();
	        if (this._initControlPos) {
	          this._initControlPos();
	        }
	      },
	      _initPanes: function () {
	        var panes = this._panes = {};
	        this._paneRenderers = {};

	        // @section
	        //
	        // Panes are DOM elements used to control the ordering of layers on the map. You
	        // can access panes with [`map.getPane`](#map-getpane) or
	        // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
	        // [`map.createPane`](#map-createpane) method.
	        //
	        // Every map has the following default panes that differ only in zIndex.
	        //
	        // @pane mapPane: HTMLElement = 'auto'
	        // Pane that contains all other map panes

	        this._mapPane = this.createPane('mapPane', this._container);
	        setPosition(this._mapPane, new Point(0, 0));

	        // @pane tilePane: HTMLElement = 200
	        // Pane for `GridLayer`s and `TileLayer`s
	        this.createPane('tilePane');
	        // @pane overlayPane: HTMLElement = 400
	        // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
	        this.createPane('overlayPane');
	        // @pane shadowPane: HTMLElement = 500
	        // Pane for overlay shadows (e.g. `Marker` shadows)
	        this.createPane('shadowPane');
	        // @pane markerPane: HTMLElement = 600
	        // Pane for `Icon`s of `Marker`s
	        this.createPane('markerPane');
	        // @pane tooltipPane: HTMLElement = 650
	        // Pane for `Tooltip`s.
	        this.createPane('tooltipPane');
	        // @pane popupPane: HTMLElement = 700
	        // Pane for `Popup`s.
	        this.createPane('popupPane');
	        if (!this.options.markerZoomAnimation) {
	          addClass(panes.markerPane, 'leaflet-zoom-hide');
	          addClass(panes.shadowPane, 'leaflet-zoom-hide');
	        }
	      },
	      // private methods that modify map state

	      // @section Map state change events
	      _resetView: function (center, zoom, noMoveStart) {
	        setPosition(this._mapPane, new Point(0, 0));
	        var loading = !this._loaded;
	        this._loaded = true;
	        zoom = this._limitZoom(zoom);
	        this.fire('viewprereset');
	        var zoomChanged = this._zoom !== zoom;
	        this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);

	        // @event viewreset: Event
	        // Fired when the map needs to redraw its content (this usually happens
	        // on map zoom or load). Very useful for creating custom overlays.
	        this.fire('viewreset');

	        // @event load: Event
	        // Fired when the map is initialized (when its center and zoom are set
	        // for the first time).
	        if (loading) {
	          this.fire('load');
	        }
	      },
	      _moveStart: function (zoomChanged, noMoveStart) {
	        // @event zoomstart: Event
	        // Fired when the map zoom is about to change (e.g. before zoom animation).
	        // @event movestart: Event
	        // Fired when the view of the map starts changing (e.g. user starts dragging the map).
	        if (zoomChanged) {
	          this.fire('zoomstart');
	        }
	        if (!noMoveStart) {
	          this.fire('movestart');
	        }
	        return this;
	      },
	      _move: function (center, zoom, data, supressEvent) {
	        if (zoom === undefined) {
	          zoom = this._zoom;
	        }
	        var zoomChanged = this._zoom !== zoom;
	        this._zoom = zoom;
	        this._lastCenter = center;
	        this._pixelOrigin = this._getNewPixelOrigin(center);
	        if (!supressEvent) {
	          // @event zoom: Event
	          // Fired repeatedly during any change in zoom level,
	          // including zoom and fly animations.
	          if (zoomChanged || data && data.pinch) {
	            // Always fire 'zoom' if pinching because #3530
	            this.fire('zoom', data);
	          }

	          // @event move: Event
	          // Fired repeatedly during any movement of the map,
	          // including pan and fly animations.
	          this.fire('move', data);
	        } else if (data && data.pinch) {
	          // Always fire 'zoom' if pinching because #3530
	          this.fire('zoom', data);
	        }
	        return this;
	      },
	      _moveEnd: function (zoomChanged) {
	        // @event zoomend: Event
	        // Fired when the map zoom changed, after any animations.
	        if (zoomChanged) {
	          this.fire('zoomend');
	        }

	        // @event moveend: Event
	        // Fired when the center of the map stops changing
	        // (e.g. user stopped dragging the map or after non-centered zoom).
	        return this.fire('moveend');
	      },
	      _stop: function () {
	        cancelAnimFrame(this._flyToFrame);
	        if (this._panAnim) {
	          this._panAnim.stop();
	        }
	        return this;
	      },
	      _rawPanBy: function (offset) {
	        setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	      },
	      _getZoomSpan: function () {
	        return this.getMaxZoom() - this.getMinZoom();
	      },
	      _panInsideMaxBounds: function () {
	        if (!this._enforcingBounds) {
	          this.panInsideBounds(this.options.maxBounds);
	        }
	      },
	      _checkIfLoaded: function () {
	        if (!this._loaded) {
	          throw new Error('Set map center and zoom first.');
	        }
	      },
	      // DOM event handling

	      // @section Interaction events
	      _initEvents: function (remove) {
	        this._targets = {};
	        this._targets[stamp(this._container)] = this;
	        var onOff = remove ? off : on;

	        // @event click: MouseEvent
	        // Fired when the user clicks (or taps) the map.
	        // @event dblclick: MouseEvent
	        // Fired when the user double-clicks (or double-taps) the map.
	        // @event mousedown: MouseEvent
	        // Fired when the user pushes the mouse button on the map.
	        // @event mouseup: MouseEvent
	        // Fired when the user releases the mouse button on the map.
	        // @event mouseover: MouseEvent
	        // Fired when the mouse enters the map.
	        // @event mouseout: MouseEvent
	        // Fired when the mouse leaves the map.
	        // @event mousemove: MouseEvent
	        // Fired while the mouse moves over the map.
	        // @event contextmenu: MouseEvent
	        // Fired when the user pushes the right mouse button on the map, prevents
	        // default browser context menu from showing if there are listeners on
	        // this event. Also fired on mobile when the user holds a single touch
	        // for a second (also called long press).
	        // @event keypress: KeyboardEvent
	        // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
	        // @event keydown: KeyboardEvent
	        // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
	        // the `keydown` event is fired for keys that produce a character value and for keys
	        // that do not produce a character value.
	        // @event keyup: KeyboardEvent
	        // Fired when the user releases a key from the keyboard while the map is focused.
	        onOff(this._container, 'click dblclick mousedown mouseup ' + 'mouseover mouseout mousemove contextmenu keypress keydown keyup', this._handleDOMEvent, this);
	        if (this.options.trackResize) {
	          onOff(window, 'resize', this._onResize, this);
	        }
	        if (Browser.any3d && this.options.transform3DLimit) {
	          (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
	        }
	      },
	      _onResize: function () {
	        cancelAnimFrame(this._resizeRequest);
	        this._resizeRequest = requestAnimFrame(function () {
	          this.invalidateSize({
	            debounceMoveend: true
	          });
	        }, this);
	      },
	      _onScroll: function () {
	        this._container.scrollTop = 0;
	        this._container.scrollLeft = 0;
	      },
	      _onMoveEnd: function () {
	        var pos = this._getMapPanePos();
	        if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
	          // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
	          // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
	          this._resetView(this.getCenter(), this.getZoom());
	        }
	      },
	      _findEventTargets: function (e, type) {
	        var targets = [],
	          target,
	          isHover = type === 'mouseout' || type === 'mouseover',
	          src = e.target || e.srcElement,
	          dragging = false;
	        while (src) {
	          target = this._targets[stamp(src)];
	          if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
	            // Prevent firing click after you just dragged an object.
	            dragging = true;
	            break;
	          }
	          if (target && target.listens(type, true)) {
	            if (isHover && !isExternalTarget(src, e)) {
	              break;
	            }
	            targets.push(target);
	            if (isHover) {
	              break;
	            }
	          }
	          if (src === this._container) {
	            break;
	          }
	          src = src.parentNode;
	        }
	        if (!targets.length && !dragging && !isHover && this.listens(type, true)) {
	          targets = [this];
	        }
	        return targets;
	      },
	      _isClickDisabled: function (el) {
	        while (el && el !== this._container) {
	          if (el['_leaflet_disable_click']) {
	            return true;
	          }
	          el = el.parentNode;
	        }
	      },
	      _handleDOMEvent: function (e) {
	        var el = e.target || e.srcElement;
	        if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) {
	          return;
	        }
	        var type = e.type;
	        if (type === 'mousedown') {
	          // prevents outline when clicking on keyboard-focusable element
	          preventOutline(el);
	        }
	        this._fireDOMEvent(e, type);
	      },
	      _mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	      _fireDOMEvent: function (e, type, canvasTargets) {
	        if (e.type === 'click') {
	          // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
	          // @event preclick: MouseEvent
	          // Fired before mouse click on the map (sometimes useful when you
	          // want something to happen on click before any existing click
	          // handlers start running).
	          var synth = extend({}, e);
	          synth.type = 'preclick';
	          this._fireDOMEvent(synth, synth.type, canvasTargets);
	        }

	        // Find the layer the event is propagating from and its parents.
	        var targets = this._findEventTargets(e, type);
	        if (canvasTargets) {
	          var filtered = []; // pick only targets with listeners
	          for (var i = 0; i < canvasTargets.length; i++) {
	            if (canvasTargets[i].listens(type, true)) {
	              filtered.push(canvasTargets[i]);
	            }
	          }
	          targets = filtered.concat(targets);
	        }
	        if (!targets.length) {
	          return;
	        }
	        if (type === 'contextmenu') {
	          preventDefault(e);
	        }
	        var target = targets[0];
	        var data = {
	          originalEvent: e
	        };
	        if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
	          var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
	          data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
	          data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
	          data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
	        }
	        for (i = 0; i < targets.length; i++) {
	          targets[i].fire(type, data, true);
	          if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) {
	            return;
	          }
	        }
	      },
	      _draggableMoved: function (obj) {
	        obj = obj.dragging && obj.dragging.enabled() ? obj : this;
	        return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
	      },
	      _clearHandlers: function () {
	        for (var i = 0, len = this._handlers.length; i < len; i++) {
	          this._handlers[i].disable();
	        }
	      },
	      // @section Other Methods

	      // @method whenReady(fn: Function, context?: Object): this
	      // Runs the given function `fn` when the map gets initialized with
	      // a view (center and zoom) and at least one layer, or immediately
	      // if it's already initialized, optionally passing a function context.
	      whenReady: function (callback, context) {
	        if (this._loaded) {
	          callback.call(context || this, {
	            target: this
	          });
	        } else {
	          this.on('load', callback, context);
	        }
	        return this;
	      },
	      // private methods for getting map state

	      _getMapPanePos: function () {
	        return getPosition(this._mapPane) || new Point(0, 0);
	      },
	      _moved: function () {
	        var pos = this._getMapPanePos();
	        return pos && !pos.equals([0, 0]);
	      },
	      _getTopLeftPoint: function (center, zoom) {
	        var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
	        return pixelOrigin.subtract(this._getMapPanePos());
	      },
	      _getNewPixelOrigin: function (center, zoom) {
	        var viewHalf = this.getSize()._divideBy(2);
	        return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	      },
	      _latLngToNewLayerPoint: function (latlng, zoom, center) {
	        var topLeft = this._getNewPixelOrigin(center, zoom);
	        return this.project(latlng, zoom)._subtract(topLeft);
	      },
	      _latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
	        var topLeft = this._getNewPixelOrigin(center, zoom);
	        return toBounds([this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft), this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft), this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft), this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)]);
	      },
	      // layer point of the current center
	      _getCenterLayerPoint: function () {
	        return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	      },
	      // offset of the specified place to the current center in pixels
	      _getCenterOffset: function (latlng) {
	        return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	      },
	      // adjust center for view to get inside bounds
	      _limitCenter: function (center, zoom, bounds) {
	        if (!bounds) {
	          return center;
	        }
	        var centerPoint = this.project(center, zoom),
	          viewHalf = this.getSize().divideBy(2),
	          viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
	          offset = this._getBoundsOffset(viewBounds, bounds, zoom);

	        // If offset is less than a pixel, ignore.
	        // This prevents unstable projections from getting into
	        // an infinite loop of tiny offsets.
	        if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) {
	          return center;
	        }
	        return this.unproject(centerPoint.add(offset), zoom);
	      },
	      // adjust offset for view to get inside bounds
	      _limitOffset: function (offset, bounds) {
	        if (!bounds) {
	          return offset;
	        }
	        var viewBounds = this.getPixelBounds(),
	          newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	        return offset.add(this._getBoundsOffset(newBounds, bounds));
	      },
	      // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	      _getBoundsOffset: function (pxBounds, maxBounds, zoom) {
	        var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)),
	          minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
	          maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	          dx = this._rebound(minOffset.x, -maxOffset.x),
	          dy = this._rebound(minOffset.y, -maxOffset.y);
	        return new Point(dx, dy);
	      },
	      _rebound: function (left, right) {
	        return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	      },
	      _limitZoom: function (zoom) {
	        var min = this.getMinZoom(),
	          max = this.getMaxZoom(),
	          snap = Browser.any3d ? this.options.zoomSnap : 1;
	        if (snap) {
	          zoom = Math.round(zoom / snap) * snap;
	        }
	        return Math.max(min, Math.min(max, zoom));
	      },
	      _onPanTransitionStep: function () {
	        this.fire('move');
	      },
	      _onPanTransitionEnd: function () {
	        removeClass(this._mapPane, 'leaflet-pan-anim');
	        this.fire('moveend');
	      },
	      _tryAnimatedPan: function (center, options) {
	        // difference between the new and current centers in pixels
	        var offset = this._getCenterOffset(center)._trunc();

	        // don't animate too far unless animate: true specified in options
	        if ((options && options.animate) !== true && !this.getSize().contains(offset)) {
	          return false;
	        }
	        this.panBy(offset, options);
	        return true;
	      },
	      _createAnimProxy: function () {
	        var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
	        this._panes.mapPane.appendChild(proxy);
	        this.on('zoomanim', function (e) {
	          var prop = TRANSFORM,
	            transform = this._proxy.style[prop];
	          setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));

	          // workaround for case when transform is the same and so transitionend event is not fired
	          if (transform === this._proxy.style[prop] && this._animatingZoom) {
	            this._onZoomTransitionEnd();
	          }
	        }, this);
	        this.on('load moveend', this._animMoveEnd, this);
	        this._on('unload', this._destroyAnimProxy, this);
	      },
	      _destroyAnimProxy: function () {
	        remove(this._proxy);
	        this.off('load moveend', this._animMoveEnd, this);
	        delete this._proxy;
	      },
	      _animMoveEnd: function () {
	        var c = this.getCenter(),
	          z = this.getZoom();
	        setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
	      },
	      _catchTransitionEnd: function (e) {
	        if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
	          this._onZoomTransitionEnd();
	        }
	      },
	      _nothingToAnimate: function () {
	        return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	      },
	      _tryAnimatedZoom: function (center, zoom, options) {
	        if (this._animatingZoom) {
	          return true;
	        }
	        options = options || {};

	        // don't animate if disabled, not supported or zoom difference is too large
	        if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) {
	          return false;
	        }

	        // offset is the pixel coords of the zoom origin relative to the current center
	        var scale = this.getZoomScale(zoom),
	          offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);

	        // don't animate if the zoom origin isn't within one screen from the current center, unless forced
	        if (options.animate !== true && !this.getSize().contains(offset)) {
	          return false;
	        }
	        requestAnimFrame(function () {
	          this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
	        }, this);
	        return true;
	      },
	      _animateZoom: function (center, zoom, startAnim, noUpdate) {
	        if (!this._mapPane) {
	          return;
	        }
	        if (startAnim) {
	          this._animatingZoom = true;

	          // remember what center/zoom to set after animation
	          this._animateToCenter = center;
	          this._animateToZoom = zoom;
	          addClass(this._mapPane, 'leaflet-zoom-anim');
	        }

	        // @section Other Events
	        // @event zoomanim: ZoomAnimEvent
	        // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
	        this.fire('zoomanim', {
	          center: center,
	          zoom: zoom,
	          noUpdate: noUpdate
	        });
	        if (!this._tempFireZoomEvent) {
	          this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
	        }
	        this._move(this._animateToCenter, this._animateToZoom, undefined, true);

	        // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
	        setTimeout(bind(this._onZoomTransitionEnd, this), 250);
	      },
	      _onZoomTransitionEnd: function () {
	        if (!this._animatingZoom) {
	          return;
	        }
	        if (this._mapPane) {
	          removeClass(this._mapPane, 'leaflet-zoom-anim');
	        }
	        this._animatingZoom = false;
	        this._move(this._animateToCenter, this._animateToZoom, undefined, true);
	        if (this._tempFireZoomEvent) {
	          this.fire('zoom');
	        }
	        delete this._tempFireZoomEvent;
	        this.fire('move');
	        this._moveEnd(true);
	      }
	    });

	    // @section

	    // @factory L.map(id: String, options?: Map options)
	    // Instantiates a map object given the DOM ID of a `<div>` element
	    // and optionally an object literal with `Map options`.
	    //
	    // @alternative
	    // @factory L.map(el: HTMLElement, options?: Map options)
	    // Instantiates a map object given an instance of a `<div>` HTML element
	    // and optionally an object literal with `Map options`.
	    function createMap(id, options) {
	      return new Map(id, options);
	    }

	    /*
	     * @class Control
	     * @aka L.Control
	     * @inherits Class
	     *
	     * L.Control is a base class for implementing map controls. Handles positioning.
	     * All other controls extend from this class.
	     */

	    var Control = Class.extend({
	      // @section
	      // @aka Control Options
	      options: {
	        // @option position: String = 'topright'
	        // The position of the control (one of the map corners). Possible values are `'topleft'`,
	        // `'topright'`, `'bottomleft'` or `'bottomright'`
	        position: 'topright'
	      },
	      initialize: function (options) {
	        setOptions(this, options);
	      },
	      /* @section
	       * Classes extending L.Control will inherit the following methods:
	       *
	       * @method getPosition: string
	       * Returns the position of the control.
	       */
	      getPosition: function () {
	        return this.options.position;
	      },
	      // @method setPosition(position: string): this
	      // Sets the position of the control.
	      setPosition: function (position) {
	        var map = this._map;
	        if (map) {
	          map.removeControl(this);
	        }
	        this.options.position = position;
	        if (map) {
	          map.addControl(this);
	        }
	        return this;
	      },
	      // @method getContainer: HTMLElement
	      // Returns the HTMLElement that contains the control.
	      getContainer: function () {
	        return this._container;
	      },
	      // @method addTo(map: Map): this
	      // Adds the control to the given map.
	      addTo: function (map) {
	        this.remove();
	        this._map = map;
	        var container = this._container = this.onAdd(map),
	          pos = this.getPosition(),
	          corner = map._controlCorners[pos];
	        addClass(container, 'leaflet-control');
	        if (pos.indexOf('bottom') !== -1) {
	          corner.insertBefore(container, corner.firstChild);
	        } else {
	          corner.appendChild(container);
	        }
	        this._map.on('unload', this.remove, this);
	        return this;
	      },
	      // @method remove: this
	      // Removes the control from the map it is currently active on.
	      remove: function () {
	        if (!this._map) {
	          return this;
	        }
	        remove(this._container);
	        if (this.onRemove) {
	          this.onRemove(this._map);
	        }
	        this._map.off('unload', this.remove, this);
	        this._map = null;
	        return this;
	      },
	      _refocusOnMap: function (e) {
	        // if map exists and event is not a keyboard event
	        if (this._map && e && e.screenX > 0 && e.screenY > 0) {
	          this._map.getContainer().focus();
	        }
	      }
	    });
	    var control = function (options) {
	      return new Control(options);
	    };

	    /* @section Extension methods
	     * @uninheritable
	     *
	     * Every control should extend from `L.Control` and (re-)implement the following methods.
	     *
	     * @method onAdd(map: Map): HTMLElement
	     * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	     *
	     * @method onRemove(map: Map)
	     * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	     */

	    /* @namespace Map
	     * @section Methods for Layers and Controls
	     */
	    Map.include({
	      // @method addControl(control: Control): this
	      // Adds the given control to the map
	      addControl: function (control) {
	        control.addTo(this);
	        return this;
	      },
	      // @method removeControl(control: Control): this
	      // Removes the given control from the map
	      removeControl: function (control) {
	        control.remove();
	        return this;
	      },
	      _initControlPos: function () {
	        var corners = this._controlCorners = {},
	          l = 'leaflet-',
	          container = this._controlContainer = create$1('div', l + 'control-container', this._container);
	        function createCorner(vSide, hSide) {
	          var className = l + vSide + ' ' + l + hSide;
	          corners[vSide + hSide] = create$1('div', className, container);
	        }
	        createCorner('top', 'left');
	        createCorner('top', 'right');
	        createCorner('bottom', 'left');
	        createCorner('bottom', 'right');
	      },
	      _clearControlPos: function () {
	        for (var i in this._controlCorners) {
	          remove(this._controlCorners[i]);
	        }
	        remove(this._controlContainer);
	        delete this._controlCorners;
	        delete this._controlContainer;
	      }
	    });

	    /*
	     * @class Control.Layers
	     * @aka L.Control.Layers
	     * @inherits Control
	     *
	     * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
	     *
	     * @example
	     *
	     * ```js
	     * var baseLayers = {
	     * 	"Mapbox": mapbox,
	     * 	"OpenStreetMap": osm
	     * };
	     *
	     * var overlays = {
	     * 	"Marker": marker,
	     * 	"Roads": roadsLayer
	     * };
	     *
	     * L.control.layers(baseLayers, overlays).addTo(map);
	     * ```
	     *
	     * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	     *
	     * ```js
	     * {
	     *     "<someName1>": layer1,
	     *     "<someName2>": layer2
	     * }
	     * ```
	     *
	     * The layer names can contain HTML, which allows you to add additional styling to the items:
	     *
	     * ```js
	     * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	     * ```
	     */

	    var Layers = Control.extend({
	      // @section
	      // @aka Control.Layers options
	      options: {
	        // @option collapsed: Boolean = true
	        // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
	        collapsed: true,
	        position: 'topright',
	        // @option autoZIndex: Boolean = true
	        // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
	        autoZIndex: true,
	        // @option hideSingleBase: Boolean = false
	        // If `true`, the base layers in the control will be hidden when there is only one.
	        hideSingleBase: false,
	        // @option sortLayers: Boolean = false
	        // Whether to sort the layers. When `false`, layers will keep the order
	        // in which they were added to the control.
	        sortLayers: false,
	        // @option sortFunction: Function = *
	        // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
	        // that will be used for sorting the layers, when `sortLayers` is `true`.
	        // The function receives both the `L.Layer` instances and their names, as in
	        // `sortFunction(layerA, layerB, nameA, nameB)`.
	        // By default, it sorts layers alphabetically by their name.
	        sortFunction: function (layerA, layerB, nameA, nameB) {
	          return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
	        }
	      },
	      initialize: function (baseLayers, overlays, options) {
	        setOptions(this, options);
	        this._layerControlInputs = [];
	        this._layers = [];
	        this._lastZIndex = 0;
	        this._handlingClick = false;
	        this._preventClick = false;
	        for (var i in baseLayers) {
	          this._addLayer(baseLayers[i], i);
	        }
	        for (i in overlays) {
	          this._addLayer(overlays[i], i, true);
	        }
	      },
	      onAdd: function (map) {
	        this._initLayout();
	        this._update();
	        this._map = map;
	        map.on('zoomend', this._checkDisabledLayers, this);
	        for (var i = 0; i < this._layers.length; i++) {
	          this._layers[i].layer.on('add remove', this._onLayerChange, this);
	        }
	        return this._container;
	      },
	      addTo: function (map) {
	        Control.prototype.addTo.call(this, map);
	        // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
	        return this._expandIfNotCollapsed();
	      },
	      onRemove: function () {
	        this._map.off('zoomend', this._checkDisabledLayers, this);
	        for (var i = 0; i < this._layers.length; i++) {
	          this._layers[i].layer.off('add remove', this._onLayerChange, this);
	        }
	      },
	      // @method addBaseLayer(layer: Layer, name: String): this
	      // Adds a base layer (radio button entry) with the given name to the control.
	      addBaseLayer: function (layer, name) {
	        this._addLayer(layer, name);
	        return this._map ? this._update() : this;
	      },
	      // @method addOverlay(layer: Layer, name: String): this
	      // Adds an overlay (checkbox entry) with the given name to the control.
	      addOverlay: function (layer, name) {
	        this._addLayer(layer, name, true);
	        return this._map ? this._update() : this;
	      },
	      // @method removeLayer(layer: Layer): this
	      // Remove the given layer from the control.
	      removeLayer: function (layer) {
	        layer.off('add remove', this._onLayerChange, this);
	        var obj = this._getLayer(stamp(layer));
	        if (obj) {
	          this._layers.splice(this._layers.indexOf(obj), 1);
	        }
	        return this._map ? this._update() : this;
	      },
	      // @method expand(): this
	      // Expand the control container if collapsed.
	      expand: function () {
	        addClass(this._container, 'leaflet-control-layers-expanded');
	        this._section.style.height = null;
	        var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
	        if (acceptableHeight < this._section.clientHeight) {
	          addClass(this._section, 'leaflet-control-layers-scrollbar');
	          this._section.style.height = acceptableHeight + 'px';
	        } else {
	          removeClass(this._section, 'leaflet-control-layers-scrollbar');
	        }
	        this._checkDisabledLayers();
	        return this;
	      },
	      // @method collapse(): this
	      // Collapse the control container if expanded.
	      collapse: function () {
	        removeClass(this._container, 'leaflet-control-layers-expanded');
	        return this;
	      },
	      _initLayout: function () {
	        var className = 'leaflet-control-layers',
	          container = this._container = create$1('div', className),
	          collapsed = this.options.collapsed;

	        // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
	        container.setAttribute('aria-haspopup', true);
	        disableClickPropagation(container);
	        disableScrollPropagation(container);
	        var section = this._section = create$1('section', className + '-list');
	        if (collapsed) {
	          this._map.on('click', this.collapse, this);
	          on(container, {
	            mouseenter: this._expandSafely,
	            mouseleave: this.collapse
	          }, this);
	        }
	        var link = this._layersLink = create$1('a', className + '-toggle', container);
	        link.href = '#';
	        link.title = 'Layers';
	        link.setAttribute('role', 'button');
	        on(link, {
	          keydown: function (e) {
	            if (e.keyCode === 13) {
	              this._expandSafely();
	            }
	          },
	          // Certain screen readers intercept the key event and instead send a click event
	          click: function (e) {
	            preventDefault(e);
	            this._expandSafely();
	          }
	        }, this);
	        if (!collapsed) {
	          this.expand();
	        }
	        this._baseLayersList = create$1('div', className + '-base', section);
	        this._separator = create$1('div', className + '-separator', section);
	        this._overlaysList = create$1('div', className + '-overlays', section);
	        container.appendChild(section);
	      },
	      _getLayer: function (id) {
	        for (var i = 0; i < this._layers.length; i++) {
	          if (this._layers[i] && stamp(this._layers[i].layer) === id) {
	            return this._layers[i];
	          }
	        }
	      },
	      _addLayer: function (layer, name, overlay) {
	        if (this._map) {
	          layer.on('add remove', this._onLayerChange, this);
	        }
	        this._layers.push({
	          layer: layer,
	          name: name,
	          overlay: overlay
	        });
	        if (this.options.sortLayers) {
	          this._layers.sort(bind(function (a, b) {
	            return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
	          }, this));
	        }
	        if (this.options.autoZIndex && layer.setZIndex) {
	          this._lastZIndex++;
	          layer.setZIndex(this._lastZIndex);
	        }
	        this._expandIfNotCollapsed();
	      },
	      _update: function () {
	        if (!this._container) {
	          return this;
	        }
	        empty(this._baseLayersList);
	        empty(this._overlaysList);
	        this._layerControlInputs = [];
	        var baseLayersPresent,
	          overlaysPresent,
	          i,
	          obj,
	          baseLayersCount = 0;
	        for (i = 0; i < this._layers.length; i++) {
	          obj = this._layers[i];
	          this._addItem(obj);
	          overlaysPresent = overlaysPresent || obj.overlay;
	          baseLayersPresent = baseLayersPresent || !obj.overlay;
	          baseLayersCount += !obj.overlay ? 1 : 0;
	        }

	        // Hide base layers section if there's only one layer.
	        if (this.options.hideSingleBase) {
	          baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
	          this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
	        }
	        this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	        return this;
	      },
	      _onLayerChange: function (e) {
	        if (!this._handlingClick) {
	          this._update();
	        }
	        var obj = this._getLayer(stamp(e.target));

	        // @namespace Map
	        // @section Layer events
	        // @event baselayerchange: LayersControlEvent
	        // Fired when the base layer is changed through the [layers control](#control-layers).
	        // @event overlayadd: LayersControlEvent
	        // Fired when an overlay is selected through the [layers control](#control-layers).
	        // @event overlayremove: LayersControlEvent
	        // Fired when an overlay is deselected through the [layers control](#control-layers).
	        // @namespace Control.Layers
	        var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
	        if (type) {
	          this._map.fire(type, obj);
	        }
	      },
	      // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
	      _createRadioElement: function (name, checked) {
	        var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	        var radioFragment = document.createElement('div');
	        radioFragment.innerHTML = radioHtml;
	        return radioFragment.firstChild;
	      },
	      _addItem: function (obj) {
	        var label = document.createElement('label'),
	          checked = this._map.hasLayer(obj.layer),
	          input;
	        if (obj.overlay) {
	          input = document.createElement('input');
	          input.type = 'checkbox';
	          input.className = 'leaflet-control-layers-selector';
	          input.defaultChecked = checked;
	        } else {
	          input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
	        }
	        this._layerControlInputs.push(input);
	        input.layerId = stamp(obj.layer);
	        on(input, 'click', this._onInputClick, this);
	        var name = document.createElement('span');
	        name.innerHTML = ' ' + obj.name;

	        // Helps from preventing layer control flicker when checkboxes are disabled
	        // https://github.com/Leaflet/Leaflet/issues/2771
	        var holder = document.createElement('span');
	        label.appendChild(holder);
	        holder.appendChild(input);
	        holder.appendChild(name);
	        var container = obj.overlay ? this._overlaysList : this._baseLayersList;
	        container.appendChild(label);
	        this._checkDisabledLayers();
	        return label;
	      },
	      _onInputClick: function () {
	        // expanding the control on mobile with a click can cause adding a layer - we don't want this
	        if (this._preventClick) {
	          return;
	        }
	        var inputs = this._layerControlInputs,
	          input,
	          layer;
	        var addedLayers = [],
	          removedLayers = [];
	        this._handlingClick = true;
	        for (var i = inputs.length - 1; i >= 0; i--) {
	          input = inputs[i];
	          layer = this._getLayer(input.layerId).layer;
	          if (input.checked) {
	            addedLayers.push(layer);
	          } else if (!input.checked) {
	            removedLayers.push(layer);
	          }
	        }

	        // Bugfix issue 2318: Should remove all old layers before readding new ones
	        for (i = 0; i < removedLayers.length; i++) {
	          if (this._map.hasLayer(removedLayers[i])) {
	            this._map.removeLayer(removedLayers[i]);
	          }
	        }
	        for (i = 0; i < addedLayers.length; i++) {
	          if (!this._map.hasLayer(addedLayers[i])) {
	            this._map.addLayer(addedLayers[i]);
	          }
	        }
	        this._handlingClick = false;
	        this._refocusOnMap();
	      },
	      _checkDisabledLayers: function () {
	        var inputs = this._layerControlInputs,
	          input,
	          layer,
	          zoom = this._map.getZoom();
	        for (var i = inputs.length - 1; i >= 0; i--) {
	          input = inputs[i];
	          layer = this._getLayer(input.layerId).layer;
	          input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
	        }
	      },
	      _expandIfNotCollapsed: function () {
	        if (this._map && !this.options.collapsed) {
	          this.expand();
	        }
	        return this;
	      },
	      _expandSafely: function () {
	        var section = this._section;
	        this._preventClick = true;
	        on(section, 'click', preventDefault);
	        this.expand();
	        var that = this;
	        setTimeout(function () {
	          off(section, 'click', preventDefault);
	          that._preventClick = false;
	        });
	      }
	    });

	    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	    var layers = function (baseLayers, overlays, options) {
	      return new Layers(baseLayers, overlays, options);
	    };

	    /*
	     * @class Control.Zoom
	     * @aka L.Control.Zoom
	     * @inherits Control
	     *
	     * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	     */

	    var Zoom = Control.extend({
	      // @section
	      // @aka Control.Zoom options
	      options: {
	        position: 'topleft',
	        // @option zoomInText: String = '<span aria-hidden="true">+</span>'
	        // The text set on the 'zoom in' button.
	        zoomInText: '<span aria-hidden="true">+</span>',
	        // @option zoomInTitle: String = 'Zoom in'
	        // The title set on the 'zoom in' button.
	        zoomInTitle: 'Zoom in',
	        // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
	        // The text set on the 'zoom out' button.
	        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
	        // @option zoomOutTitle: String = 'Zoom out'
	        // The title set on the 'zoom out' button.
	        zoomOutTitle: 'Zoom out'
	      },
	      onAdd: function (map) {
	        var zoomName = 'leaflet-control-zoom',
	          container = create$1('div', zoomName + ' leaflet-bar'),
	          options = this.options;
	        this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
	        this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
	        this._updateDisabled();
	        map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	        return container;
	      },
	      onRemove: function (map) {
	        map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	      },
	      disable: function () {
	        this._disabled = true;
	        this._updateDisabled();
	        return this;
	      },
	      enable: function () {
	        this._disabled = false;
	        this._updateDisabled();
	        return this;
	      },
	      _zoomIn: function (e) {
	        if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
	          this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	        }
	      },
	      _zoomOut: function (e) {
	        if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
	          this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	        }
	      },
	      _createButton: function (html, title, className, container, fn) {
	        var link = create$1('a', className, container);
	        link.innerHTML = html;
	        link.href = '#';
	        link.title = title;

	        /*
	         * Will force screen readers like VoiceOver to read this as "Zoom in - button"
	         */
	        link.setAttribute('role', 'button');
	        link.setAttribute('aria-label', title);
	        disableClickPropagation(link);
	        on(link, 'click', stop);
	        on(link, 'click', fn, this);
	        on(link, 'click', this._refocusOnMap, this);
	        return link;
	      },
	      _updateDisabled: function () {
	        var map = this._map,
	          className = 'leaflet-disabled';
	        removeClass(this._zoomInButton, className);
	        removeClass(this._zoomOutButton, className);
	        this._zoomInButton.setAttribute('aria-disabled', 'false');
	        this._zoomOutButton.setAttribute('aria-disabled', 'false');
	        if (this._disabled || map._zoom === map.getMinZoom()) {
	          addClass(this._zoomOutButton, className);
	          this._zoomOutButton.setAttribute('aria-disabled', 'true');
	        }
	        if (this._disabled || map._zoom === map.getMaxZoom()) {
	          addClass(this._zoomInButton, className);
	          this._zoomInButton.setAttribute('aria-disabled', 'true');
	        }
	      }
	    });

	    // @namespace Map
	    // @section Control options
	    // @option zoomControl: Boolean = true
	    // Whether a [zoom control](#control-zoom) is added to the map by default.
	    Map.mergeOptions({
	      zoomControl: true
	    });
	    Map.addInitHook(function () {
	      if (this.options.zoomControl) {
	        // @section Controls
	        // @property zoomControl: Control.Zoom
	        // The default zoom control (only available if the
	        // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
	        this.zoomControl = new Zoom();
	        this.addControl(this.zoomControl);
	      }
	    });

	    // @namespace Control.Zoom
	    // @factory L.control.zoom(options: Control.Zoom options)
	    // Creates a zoom control
	    var zoom = function (options) {
	      return new Zoom(options);
	    };

	    /*
	     * @class Control.Scale
	     * @aka L.Control.Scale
	     * @inherits Control
	     *
	     * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	     *
	     * @example
	     *
	     * ```js
	     * L.control.scale().addTo(map);
	     * ```
	     */

	    var Scale = Control.extend({
	      // @section
	      // @aka Control.Scale options
	      options: {
	        position: 'bottomleft',
	        // @option maxWidth: Number = 100
	        // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
	        maxWidth: 100,
	        // @option metric: Boolean = True
	        // Whether to show the metric scale line (m/km).
	        metric: true,
	        // @option imperial: Boolean = True
	        // Whether to show the imperial scale line (mi/ft).
	        imperial: true

	        // @option updateWhenIdle: Boolean = false
	        // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	      },
	      onAdd: function (map) {
	        var className = 'leaflet-control-scale',
	          container = create$1('div', className),
	          options = this.options;
	        this._addScales(options, className + '-line', container);
	        map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	        map.whenReady(this._update, this);
	        return container;
	      },
	      onRemove: function (map) {
	        map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	      },
	      _addScales: function (options, className, container) {
	        if (options.metric) {
	          this._mScale = create$1('div', className, container);
	        }
	        if (options.imperial) {
	          this._iScale = create$1('div', className, container);
	        }
	      },
	      _update: function () {
	        var map = this._map,
	          y = map.getSize().y / 2;
	        var maxMeters = map.distance(map.containerPointToLatLng([0, y]), map.containerPointToLatLng([this.options.maxWidth, y]));
	        this._updateScales(maxMeters);
	      },
	      _updateScales: function (maxMeters) {
	        if (this.options.metric && maxMeters) {
	          this._updateMetric(maxMeters);
	        }
	        if (this.options.imperial && maxMeters) {
	          this._updateImperial(maxMeters);
	        }
	      },
	      _updateMetric: function (maxMeters) {
	        var meters = this._getRoundNum(maxMeters),
	          label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
	        this._updateScale(this._mScale, label, meters / maxMeters);
	      },
	      _updateImperial: function (maxMeters) {
	        var maxFeet = maxMeters * 3.2808399,
	          maxMiles,
	          miles,
	          feet;
	        if (maxFeet > 5280) {
	          maxMiles = maxFeet / 5280;
	          miles = this._getRoundNum(maxMiles);
	          this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	        } else {
	          feet = this._getRoundNum(maxFeet);
	          this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
	        }
	      },
	      _updateScale: function (scale, text, ratio) {
	        scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
	        scale.innerHTML = text;
	      },
	      _getRoundNum: function (num) {
	        var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
	          d = num / pow10;
	        d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
	        return pow10 * d;
	      }
	    });

	    // @factory L.control.scale(options?: Control.Scale options)
	    // Creates an scale control with the given options.
	    var scale = function (options) {
	      return new Scale(options);
	    };
	    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';

	    /*
	     * @class Control.Attribution
	     * @aka L.Control.Attribution
	     * @inherits Control
	     *
	     * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	     */

	    var Attribution = Control.extend({
	      // @section
	      // @aka Control.Attribution options
	      options: {
	        position: 'bottomright',
	        // @option prefix: String|false = 'Leaflet'
	        // The HTML text shown before the attributions. Pass `false` to disable.
	        prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
	      },
	      initialize: function (options) {
	        setOptions(this, options);
	        this._attributions = {};
	      },
	      onAdd: function (map) {
	        map.attributionControl = this;
	        this._container = create$1('div', 'leaflet-control-attribution');
	        disableClickPropagation(this._container);

	        // TODO ugly, refactor
	        for (var i in map._layers) {
	          if (map._layers[i].getAttribution) {
	            this.addAttribution(map._layers[i].getAttribution());
	          }
	        }
	        this._update();
	        map.on('layeradd', this._addAttribution, this);
	        return this._container;
	      },
	      onRemove: function (map) {
	        map.off('layeradd', this._addAttribution, this);
	      },
	      _addAttribution: function (ev) {
	        if (ev.layer.getAttribution) {
	          this.addAttribution(ev.layer.getAttribution());
	          ev.layer.once('remove', function () {
	            this.removeAttribution(ev.layer.getAttribution());
	          }, this);
	        }
	      },
	      // @method setPrefix(prefix: String|false): this
	      // The HTML text shown before the attributions. Pass `false` to disable.
	      setPrefix: function (prefix) {
	        this.options.prefix = prefix;
	        this._update();
	        return this;
	      },
	      // @method addAttribution(text: String): this
	      // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
	      addAttribution: function (text) {
	        if (!text) {
	          return this;
	        }
	        if (!this._attributions[text]) {
	          this._attributions[text] = 0;
	        }
	        this._attributions[text]++;
	        this._update();
	        return this;
	      },
	      // @method removeAttribution(text: String): this
	      // Removes an attribution text.
	      removeAttribution: function (text) {
	        if (!text) {
	          return this;
	        }
	        if (this._attributions[text]) {
	          this._attributions[text]--;
	          this._update();
	        }
	        return this;
	      },
	      _update: function () {
	        if (!this._map) {
	          return;
	        }
	        var attribs = [];
	        for (var i in this._attributions) {
	          if (this._attributions[i]) {
	            attribs.push(i);
	          }
	        }
	        var prefixAndAttribs = [];
	        if (this.options.prefix) {
	          prefixAndAttribs.push(this.options.prefix);
	        }
	        if (attribs.length) {
	          prefixAndAttribs.push(attribs.join(', '));
	        }
	        this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
	      }
	    });

	    // @namespace Map
	    // @section Control options
	    // @option attributionControl: Boolean = true
	    // Whether a [attribution control](#control-attribution) is added to the map by default.
	    Map.mergeOptions({
	      attributionControl: true
	    });
	    Map.addInitHook(function () {
	      if (this.options.attributionControl) {
	        new Attribution().addTo(this);
	      }
	    });

	    // @namespace Control.Attribution
	    // @factory L.control.attribution(options: Control.Attribution options)
	    // Creates an attribution control.
	    var attribution = function (options) {
	      return new Attribution(options);
	    };
	    Control.Layers = Layers;
	    Control.Zoom = Zoom;
	    Control.Scale = Scale;
	    Control.Attribution = Attribution;
	    control.layers = layers;
	    control.zoom = zoom;
	    control.scale = scale;
	    control.attribution = attribution;

	    /*
	    	L.Handler is a base class for handler classes that are used internally to inject
	    	interaction features like dragging to classes like Map and Marker.
	    */

	    // @class Handler
	    // @aka L.Handler
	    // Abstract class for map interaction handlers

	    var Handler = Class.extend({
	      initialize: function (map) {
	        this._map = map;
	      },
	      // @method enable(): this
	      // Enables the handler
	      enable: function () {
	        if (this._enabled) {
	          return this;
	        }
	        this._enabled = true;
	        this.addHooks();
	        return this;
	      },
	      // @method disable(): this
	      // Disables the handler
	      disable: function () {
	        if (!this._enabled) {
	          return this;
	        }
	        this._enabled = false;
	        this.removeHooks();
	        return this;
	      },
	      // @method enabled(): Boolean
	      // Returns `true` if the handler is enabled
	      enabled: function () {
	        return !!this._enabled;
	      }

	      // @section Extension methods
	      // Classes inheriting from `Handler` must implement the two following methods:
	      // @method addHooks()
	      // Called when the handler is enabled, should add event hooks.
	      // @method removeHooks()
	      // Called when the handler is disabled, should remove the event hooks added previously.
	    });

	    // @section There is static function which can be called without instantiating L.Handler:
	    // @function addTo(map: Map, name: String): this
	    // Adds a new Handler to the given map with the given name.
	    Handler.addTo = function (map, name) {
	      map.addHandler(name, this);
	      return this;
	    };
	    var Mixin = {
	      Events: Events
	    };

	    /*
	     * @class Draggable
	     * @aka L.Draggable
	     * @inherits Evented
	     *
	     * A class for making DOM elements draggable (including touch support).
	     * Used internally for map and marker dragging. Only works for elements
	     * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	     *
	     * @example
	     * ```js
	     * var draggable = new L.Draggable(elementToDrag);
	     * draggable.enable();
	     * ```
	     */

	    var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
	    var Draggable = Evented.extend({
	      options: {
	        // @section
	        // @aka Draggable options
	        // @option clickTolerance: Number = 3
	        // The max number of pixels a user can shift the mouse pointer during a click
	        // for it to be considered a valid click (as opposed to a mouse drag).
	        clickTolerance: 3
	      },
	      // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
	      // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	      initialize: function (element, dragStartTarget, preventOutline, options) {
	        setOptions(this, options);
	        this._element = element;
	        this._dragStartTarget = dragStartTarget || element;
	        this._preventOutline = preventOutline;
	      },
	      // @method enable()
	      // Enables the dragging ability
	      enable: function () {
	        if (this._enabled) {
	          return;
	        }
	        on(this._dragStartTarget, START, this._onDown, this);
	        this._enabled = true;
	      },
	      // @method disable()
	      // Disables the dragging ability
	      disable: function () {
	        if (!this._enabled) {
	          return;
	        }

	        // If we're currently dragging this draggable,
	        // disabling it counts as first ending the drag.
	        if (Draggable._dragging === this) {
	          this.finishDrag(true);
	        }
	        off(this._dragStartTarget, START, this._onDown, this);
	        this._enabled = false;
	        this._moved = false;
	      },
	      _onDown: function (e) {
	        // Ignore the event if disabled; this happens in IE11
	        // under some circumstances, see #3666.
	        if (!this._enabled) {
	          return;
	        }
	        this._moved = false;
	        if (hasClass(this._element, 'leaflet-zoom-anim')) {
	          return;
	        }
	        if (e.touches && e.touches.length !== 1) {
	          // Finish dragging to avoid conflict with touchZoom
	          if (Draggable._dragging === this) {
	            this.finishDrag();
	          }
	          return;
	        }
	        if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) {
	          return;
	        }
	        Draggable._dragging = this; // Prevent dragging multiple objects at once.

	        if (this._preventOutline) {
	          preventOutline(this._element);
	        }
	        disableImageDrag();
	        disableTextSelection();
	        if (this._moving) {
	          return;
	        }

	        // @event down: Event
	        // Fired when a drag is about to start.
	        this.fire('down');
	        var first = e.touches ? e.touches[0] : e,
	          sizedParent = getSizedParentNode(this._element);
	        this._startPoint = new Point(first.clientX, first.clientY);
	        this._startPos = getPosition(this._element);

	        // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
	        this._parentScale = getScale(sizedParent);
	        var mouseevent = e.type === 'mousedown';
	        on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
	        on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
	      },
	      _onMove: function (e) {
	        // Ignore the event if disabled; this happens in IE11
	        // under some circumstances, see #3666.
	        if (!this._enabled) {
	          return;
	        }
	        if (e.touches && e.touches.length > 1) {
	          this._moved = true;
	          return;
	        }
	        var first = e.touches && e.touches.length === 1 ? e.touches[0] : e,
	          offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
	        if (!offset.x && !offset.y) {
	          return;
	        }
	        if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) {
	          return;
	        }

	        // We assume that the parent container's position, border and scale do not change for the duration of the drag.
	        // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
	        // and we can use the cached value for the scale.
	        offset.x /= this._parentScale.x;
	        offset.y /= this._parentScale.y;
	        preventDefault(e);
	        if (!this._moved) {
	          // @event dragstart: Event
	          // Fired when a drag starts
	          this.fire('dragstart');
	          this._moved = true;
	          addClass(document.body, 'leaflet-dragging');
	          this._lastTarget = e.target || e.srcElement;
	          // IE and Edge do not give the <use> element, so fetch it
	          // if necessary
	          if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
	            this._lastTarget = this._lastTarget.correspondingUseElement;
	          }
	          addClass(this._lastTarget, 'leaflet-drag-target');
	        }
	        this._newPos = this._startPos.add(offset);
	        this._moving = true;
	        this._lastEvent = e;
	        this._updatePosition();
	      },
	      _updatePosition: function () {
	        var e = {
	          originalEvent: this._lastEvent
	        };

	        // @event predrag: Event
	        // Fired continuously during dragging *before* each corresponding
	        // update of the element's position.
	        this.fire('predrag', e);
	        setPosition(this._element, this._newPos);

	        // @event drag: Event
	        // Fired continuously during dragging.
	        this.fire('drag', e);
	      },
	      _onUp: function () {
	        // Ignore the event if disabled; this happens in IE11
	        // under some circumstances, see #3666.
	        if (!this._enabled) {
	          return;
	        }
	        this.finishDrag();
	      },
	      finishDrag: function (noInertia) {
	        removeClass(document.body, 'leaflet-dragging');
	        if (this._lastTarget) {
	          removeClass(this._lastTarget, 'leaflet-drag-target');
	          this._lastTarget = null;
	        }
	        off(document, 'mousemove touchmove', this._onMove, this);
	        off(document, 'mouseup touchend touchcancel', this._onUp, this);
	        enableImageDrag();
	        enableTextSelection();
	        var fireDragend = this._moved && this._moving;
	        this._moving = false;
	        Draggable._dragging = false;
	        if (fireDragend) {
	          // @event dragend: DragEndEvent
	          // Fired when the drag ends.
	          this.fire('dragend', {
	            noInertia: noInertia,
	            distance: this._newPos.distanceTo(this._startPos)
	          });
	        }
	      }
	    });

	    /*
	     * @namespace PolyUtil
	     * Various utility functions for polygon geometries.
	     */

	    /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	     * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	     * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	     * performance. Note that polygon points needs different algorithm for clipping
	     * than polyline, so there's a separate method for it.
	     */
	    function clipPolygon(points, bounds, round) {
	      var clippedPoints,
	        edges = [1, 4, 2, 8],
	        i,
	        j,
	        k,
	        a,
	        b,
	        len,
	        edge,
	        p;
	      for (i = 0, len = points.length; i < len; i++) {
	        points[i]._code = _getBitCode(points[i], bounds);
	      }

	      // for each edge (left, bottom, right, top)
	      for (k = 0; k < 4; k++) {
	        edge = edges[k];
	        clippedPoints = [];
	        for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
	          a = points[i];
	          b = points[j];

	          // if a is inside the clip window
	          if (!(a._code & edge)) {
	            // if b is outside the clip window (a->b goes out of screen)
	            if (b._code & edge) {
	              p = _getEdgeIntersection(b, a, edge, bounds, round);
	              p._code = _getBitCode(p, bounds);
	              clippedPoints.push(p);
	            }
	            clippedPoints.push(a);

	            // else if b is inside the clip window (a->b enters the screen)
	          } else if (!(b._code & edge)) {
	            p = _getEdgeIntersection(b, a, edge, bounds, round);
	            p._code = _getBitCode(p, bounds);
	            clippedPoints.push(p);
	          }
	        }
	        points = clippedPoints;
	      }
	      return points;
	    }

	    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
	     * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
	     */
	    function polygonCenter(latlngs, crs) {
	      var i, j, p1, p2, f, area, x, y, center;
	      if (!latlngs || latlngs.length === 0) {
	        throw new Error('latlngs not passed');
	      }
	      if (!isFlat(latlngs)) {
	        console.warn('latlngs are not flat! Only the first ring will be used');
	        latlngs = latlngs[0];
	      }
	      var centroidLatLng = toLatLng([0, 0]);
	      var bounds = toLatLngBounds(latlngs);
	      var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
	      // tests showed that below 1700 rounding errors are happening
	      if (areaBounds < 1700) {
	        // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
	        centroidLatLng = centroid(latlngs);
	      }
	      var len = latlngs.length;
	      var points = [];
	      for (i = 0; i < len; i++) {
	        var latlng = toLatLng(latlngs[i]);
	        points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
	      }
	      area = x = y = 0;

	      // polygon centroid algorithm;
	      for (i = 0, j = len - 1; i < len; j = i++) {
	        p1 = points[i];
	        p2 = points[j];
	        f = p1.y * p2.x - p2.y * p1.x;
	        x += (p1.x + p2.x) * f;
	        y += (p1.y + p2.y) * f;
	        area += f * 3;
	      }
	      if (area === 0) {
	        // Polygon is so small that all points are on same pixel.
	        center = points[0];
	      } else {
	        center = [x / area, y / area];
	      }
	      var latlngCenter = crs.unproject(toPoint(center));
	      return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
	    }

	    /* @function centroid(latlngs: LatLng[]): LatLng
	     * Returns the 'center of mass' of the passed LatLngs.
	     */
	    function centroid(coords) {
	      var latSum = 0;
	      var lngSum = 0;
	      var len = 0;
	      for (var i = 0; i < coords.length; i++) {
	        var latlng = toLatLng(coords[i]);
	        latSum += latlng.lat;
	        lngSum += latlng.lng;
	        len++;
	      }
	      return toLatLng([latSum / len, lngSum / len]);
	    }
	    var PolyUtil = {
	      __proto__: null,
	      clipPolygon: clipPolygon,
	      polygonCenter: polygonCenter,
	      centroid: centroid
	    };

	    /*
	     * @namespace LineUtil
	     *
	     * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
	     */

	    // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	    // Improves rendering performance dramatically by lessening the number of points to draw.

	    // @function simplify(points: Point[], tolerance: Number): Point[]
	    // Dramatically reduces the number of points in a polyline while retaining
	    // its shape and returns a new array of simplified points, using the
	    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
	    // Used for a huge performance boost when processing/displaying Leaflet polylines for
	    // each zoom level and also reducing visual noise. tolerance affects the amount of
	    // simplification (lesser value means higher quality but slower and with more points).
	    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
	    function simplify(points, tolerance) {
	      if (!tolerance || !points.length) {
	        return points.slice();
	      }
	      var sqTolerance = tolerance * tolerance;

	      // stage 1: vertex reduction
	      points = _reducePoints(points, sqTolerance);

	      // stage 2: Douglas-Peucker simplification
	      points = _simplifyDP(points, sqTolerance);
	      return points;
	    }

	    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	    // Returns the distance between point `p` and segment `p1` to `p2`.
	    function pointToSegmentDistance(p, p1, p2) {
	      return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	    }

	    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
	    function closestPointOnSegment(p, p1, p2) {
	      return _sqClosestPointOnSegment(p, p1, p2);
	    }

	    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
	    function _simplifyDP(points, sqTolerance) {
	      var len = points.length,
	        ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
	        markers = new ArrayConstructor(len);
	      markers[0] = markers[len - 1] = 1;
	      _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	      var i,
	        newPoints = [];
	      for (i = 0; i < len; i++) {
	        if (markers[i]) {
	          newPoints.push(points[i]);
	        }
	      }
	      return newPoints;
	    }
	    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	      var maxSqDist = 0,
	        index,
	        i,
	        sqDist;
	      for (i = first + 1; i <= last - 1; i++) {
	        sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	        if (sqDist > maxSqDist) {
	          index = i;
	          maxSqDist = sqDist;
	        }
	      }
	      if (maxSqDist > sqTolerance) {
	        markers[index] = 1;
	        _simplifyDPStep(points, markers, sqTolerance, first, index);
	        _simplifyDPStep(points, markers, sqTolerance, index, last);
	      }
	    }

	    // reduce points that are too close to each other to a single point
	    function _reducePoints(points, sqTolerance) {
	      var reducedPoints = [points[0]];
	      for (var i = 1, prev = 0, len = points.length; i < len; i++) {
	        if (_sqDist(points[i], points[prev]) > sqTolerance) {
	          reducedPoints.push(points[i]);
	          prev = i;
	        }
	      }
	      if (prev < len - 1) {
	        reducedPoints.push(points[len - 1]);
	      }
	      return reducedPoints;
	    }
	    var _lastCode;

	    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	    // Clips the segment a to b by rectangular bounds with the
	    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	    // (modifying the segment points directly!). Used by Leaflet to only show polyline
	    // points that are on the screen or near, increasing performance.
	    function clipSegment(a, b, bounds, useLastCode, round) {
	      var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
	        codeB = _getBitCode(b, bounds),
	        codeOut,
	        p,
	        newCode;

	      // save 2nd code to avoid calculating it on the next segment
	      _lastCode = codeB;
	      while (true) {
	        // if a,b is inside the clip window (trivial accept)
	        if (!(codeA | codeB)) {
	          return [a, b];
	        }

	        // if a,b is outside the clip window (trivial reject)
	        if (codeA & codeB) {
	          return false;
	        }

	        // other cases
	        codeOut = codeA || codeB;
	        p = _getEdgeIntersection(a, b, codeOut, bounds, round);
	        newCode = _getBitCode(p, bounds);
	        if (codeOut === codeA) {
	          a = p;
	          codeA = newCode;
	        } else {
	          b = p;
	          codeB = newCode;
	        }
	      }
	    }
	    function _getEdgeIntersection(a, b, code, bounds, round) {
	      var dx = b.x - a.x,
	        dy = b.y - a.y,
	        min = bounds.min,
	        max = bounds.max,
	        x,
	        y;
	      if (code & 8) {
	        // top
	        x = a.x + dx * (max.y - a.y) / dy;
	        y = max.y;
	      } else if (code & 4) {
	        // bottom
	        x = a.x + dx * (min.y - a.y) / dy;
	        y = min.y;
	      } else if (code & 2) {
	        // right
	        x = max.x;
	        y = a.y + dy * (max.x - a.x) / dx;
	      } else if (code & 1) {
	        // left
	        x = min.x;
	        y = a.y + dy * (min.x - a.x) / dx;
	      }
	      return new Point(x, y, round);
	    }
	    function _getBitCode(p, bounds) {
	      var code = 0;
	      if (p.x < bounds.min.x) {
	        // left
	        code |= 1;
	      } else if (p.x > bounds.max.x) {
	        // right
	        code |= 2;
	      }
	      if (p.y < bounds.min.y) {
	        // bottom
	        code |= 4;
	      } else if (p.y > bounds.max.y) {
	        // top
	        code |= 8;
	      }
	      return code;
	    }

	    // square distance (to avoid unnecessary Math.sqrt calls)
	    function _sqDist(p1, p2) {
	      var dx = p2.x - p1.x,
	        dy = p2.y - p1.y;
	      return dx * dx + dy * dy;
	    }

	    // return closest point on segment or distance to that point
	    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
	      var x = p1.x,
	        y = p1.y,
	        dx = p2.x - x,
	        dy = p2.y - y,
	        dot = dx * dx + dy * dy,
	        t;
	      if (dot > 0) {
	        t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	        if (t > 1) {
	          x = p2.x;
	          y = p2.y;
	        } else if (t > 0) {
	          x += dx * t;
	          y += dy * t;
	        }
	      }
	      dx = p.x - x;
	      dy = p.y - y;
	      return sqDist ? dx * dx + dy * dy : new Point(x, y);
	    }

	    // @function isFlat(latlngs: LatLng[]): Boolean
	    // Returns true if `latlngs` is a flat array, false is nested.
	    function isFlat(latlngs) {
	      return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
	    }
	    function _flat(latlngs) {
	      console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
	      return isFlat(latlngs);
	    }

	    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
	     * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
	     */
	    function polylineCenter(latlngs, crs) {
	      var i, halfDist, segDist, dist, p1, p2, ratio, center;
	      if (!latlngs || latlngs.length === 0) {
	        throw new Error('latlngs not passed');
	      }
	      if (!isFlat(latlngs)) {
	        console.warn('latlngs are not flat! Only the first ring will be used');
	        latlngs = latlngs[0];
	      }
	      var centroidLatLng = toLatLng([0, 0]);
	      var bounds = toLatLngBounds(latlngs);
	      var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
	      // tests showed that below 1700 rounding errors are happening
	      if (areaBounds < 1700) {
	        // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
	        centroidLatLng = centroid(latlngs);
	      }
	      var len = latlngs.length;
	      var points = [];
	      for (i = 0; i < len; i++) {
	        var latlng = toLatLng(latlngs[i]);
	        points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
	      }
	      for (i = 0, halfDist = 0; i < len - 1; i++) {
	        halfDist += points[i].distanceTo(points[i + 1]) / 2;
	      }

	      // The line is so small in the current view that all points are on the same pixel.
	      if (halfDist === 0) {
	        center = points[0];
	      } else {
	        for (i = 0, dist = 0; i < len - 1; i++) {
	          p1 = points[i];
	          p2 = points[i + 1];
	          segDist = p1.distanceTo(p2);
	          dist += segDist;
	          if (dist > halfDist) {
	            ratio = (dist - halfDist) / segDist;
	            center = [p2.x - ratio * (p2.x - p1.x), p2.y - ratio * (p2.y - p1.y)];
	            break;
	          }
	        }
	      }
	      var latlngCenter = crs.unproject(toPoint(center));
	      return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
	    }
	    var LineUtil = {
	      __proto__: null,
	      simplify: simplify,
	      pointToSegmentDistance: pointToSegmentDistance,
	      closestPointOnSegment: closestPointOnSegment,
	      clipSegment: clipSegment,
	      _getEdgeIntersection: _getEdgeIntersection,
	      _getBitCode: _getBitCode,
	      _sqClosestPointOnSegment: _sqClosestPointOnSegment,
	      isFlat: isFlat,
	      _flat: _flat,
	      polylineCenter: polylineCenter
	    };

	    /*
	     * @namespace Projection
	     * @section
	     * Leaflet comes with a set of already defined Projections out of the box:
	     *
	     * @projection L.Projection.LonLat
	     *
	     * Equirectangular, or Plate Carree projection — the most simple projection,
	     * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	     * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	     * `EPSG:4326` and `Simple` CRS.
	     */

	    var LonLat = {
	      project: function (latlng) {
	        return new Point(latlng.lng, latlng.lat);
	      },
	      unproject: function (point) {
	        return new LatLng(point.y, point.x);
	      },
	      bounds: new Bounds([-180, -90], [180, 90])
	    };

	    /*
	     * @namespace Projection
	     * @projection L.Projection.Mercator
	     *
	     * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
	     */

	    var Mercator = {
	      R: 6378137,
	      R_MINOR: 6356752.314245179,
	      bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	      project: function (latlng) {
	        var d = Math.PI / 180,
	          r = this.R,
	          y = latlng.lat * d,
	          tmp = this.R_MINOR / r,
	          e = Math.sqrt(1 - tmp * tmp),
	          con = e * Math.sin(y);
	        var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
	        y = -r * Math.log(Math.max(ts, 1E-10));
	        return new Point(latlng.lng * d * r, y);
	      },
	      unproject: function (point) {
	        var d = 180 / Math.PI,
	          r = this.R,
	          tmp = this.R_MINOR / r,
	          e = Math.sqrt(1 - tmp * tmp),
	          ts = Math.exp(-point.y / r),
	          phi = Math.PI / 2 - 2 * Math.atan(ts);
	        for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
	          con = e * Math.sin(phi);
	          con = Math.pow((1 - con) / (1 + con), e / 2);
	          dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
	          phi += dphi;
	        }
	        return new LatLng(phi * d, point.x * d / r);
	      }
	    };

	    /*
	     * @class Projection
	      * An object with methods for projecting geographical coordinates of the world onto
	     * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).
	      * @property bounds: Bounds
	     * The bounds (specified in CRS units) where the projection is valid
	      * @method project(latlng: LatLng): Point
	     * Projects geographical coordinates into a 2D point.
	     * Only accepts actual `L.LatLng` instances, not arrays.
	      * @method unproject(point: Point): LatLng
	     * The inverse of `project`. Projects a 2D point into a geographical location.
	     * Only accepts actual `L.Point` instances, not arrays.
	      * Note that the projection instances do not inherit from Leaflet's `Class` object,
	     * and can't be instantiated. Also, new classes can't inherit from them,
	     * and methods can't be added to them with the `include` function.
	      */

	    var index = {
	      __proto__: null,
	      LonLat: LonLat,
	      Mercator: Mercator,
	      SphericalMercator: SphericalMercator
	    };

	    /*
	     * @namespace CRS
	     * @crs L.CRS.EPSG3395
	     *
	     * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	     */
	    var EPSG3395 = extend({}, Earth, {
	      code: 'EPSG:3395',
	      projection: Mercator,
	      transformation: function () {
	        var scale = 0.5 / (Math.PI * Mercator.R);
	        return toTransformation(scale, 0.5, -scale, 0.5);
	      }()
	    });

	    /*
	     * @namespace CRS
	     * @crs L.CRS.EPSG4326
	     *
	     * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	     *
	     * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	     * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	     * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	     * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	     * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	     */

	    var EPSG4326 = extend({}, Earth, {
	      code: 'EPSG:4326',
	      projection: LonLat,
	      transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	    });

	    /*
	     * @namespace CRS
	     * @crs L.CRS.Simple
	     *
	     * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	     * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	     * axis should still be inverted (going from bottom to top). `distance()` returns
	     * simple euclidean distance.
	     */

	    var Simple = extend({}, CRS, {
	      projection: LonLat,
	      transformation: toTransformation(1, 0, -1, 0),
	      scale: function (zoom) {
	        return Math.pow(2, zoom);
	      },
	      zoom: function (scale) {
	        return Math.log(scale) / Math.LN2;
	      },
	      distance: function (latlng1, latlng2) {
	        var dx = latlng2.lng - latlng1.lng,
	          dy = latlng2.lat - latlng1.lat;
	        return Math.sqrt(dx * dx + dy * dy);
	      },
	      infinite: true
	    });
	    CRS.Earth = Earth;
	    CRS.EPSG3395 = EPSG3395;
	    CRS.EPSG3857 = EPSG3857;
	    CRS.EPSG900913 = EPSG900913;
	    CRS.EPSG4326 = EPSG4326;
	    CRS.Simple = Simple;

	    /*
	     * @class Layer
	     * @inherits Evented
	     * @aka L.Layer
	     * @aka ILayer
	     *
	     * A set of methods from the Layer base class that all Leaflet layers use.
	     * Inherits all methods, options and events from `L.Evented`.
	     *
	     * @example
	     *
	     * ```js
	     * var layer = L.marker(latlng).addTo(map);
	     * layer.addTo(map);
	     * layer.remove();
	     * ```
	     *
	     * @event add: Event
	     * Fired after the layer is added to a map
	     *
	     * @event remove: Event
	     * Fired after the layer is removed from a map
	     */

	    var Layer = Evented.extend({
	      // Classes extending `L.Layer` will inherit the following options:
	      options: {
	        // @option pane: String = 'overlayPane'
	        // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
	        pane: 'overlayPane',
	        // @option attribution: String = null
	        // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
	        attribution: null,
	        bubblingMouseEvents: true
	      },
	      /* @section
	       * Classes extending `L.Layer` will inherit the following methods:
	       *
	       * @method addTo(map: Map|LayerGroup): this
	       * Adds the layer to the given map or layer group.
	       */
	      addTo: function (map) {
	        map.addLayer(this);
	        return this;
	      },
	      // @method remove: this
	      // Removes the layer from the map it is currently active on.
	      remove: function () {
	        return this.removeFrom(this._map || this._mapToAdd);
	      },
	      // @method removeFrom(map: Map): this
	      // Removes the layer from the given map
	      //
	      // @alternative
	      // @method removeFrom(group: LayerGroup): this
	      // Removes the layer from the given `LayerGroup`
	      removeFrom: function (obj) {
	        if (obj) {
	          obj.removeLayer(this);
	        }
	        return this;
	      },
	      // @method getPane(name? : String): HTMLElement
	      // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	      getPane: function (name) {
	        return this._map.getPane(name ? this.options[name] || name : this.options.pane);
	      },
	      addInteractiveTarget: function (targetEl) {
	        this._map._targets[stamp(targetEl)] = this;
	        return this;
	      },
	      removeInteractiveTarget: function (targetEl) {
	        delete this._map._targets[stamp(targetEl)];
	        return this;
	      },
	      // @method getAttribution: String
	      // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	      getAttribution: function () {
	        return this.options.attribution;
	      },
	      _layerAdd: function (e) {
	        var map = e.target;

	        // check in case layer gets added and then removed before the map is ready
	        if (!map.hasLayer(this)) {
	          return;
	        }
	        this._map = map;
	        this._zoomAnimated = map._zoomAnimated;
	        if (this.getEvents) {
	          var events = this.getEvents();
	          map.on(events, this);
	          this.once('remove', function () {
	            map.off(events, this);
	          }, this);
	        }
	        this.onAdd(map);
	        this.fire('add');
	        map.fire('layeradd', {
	          layer: this
	        });
	      }
	    });

	    /* @section Extension methods
	     * @uninheritable
	     *
	     * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	     *
	     * @method onAdd(map: Map): this
	     * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	     *
	     * @method onRemove(map: Map): this
	     * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	     *
	     * @method getEvents(): Object
	     * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	     *
	     * @method getAttribution(): String
	     * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	     *
	     * @method beforeAdd(map: Map): this
	     * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	     */

	    /* @namespace Map
	     * @section Layer events
	     *
	     * @event layeradd: LayerEvent
	     * Fired when a new layer is added to the map.
	     *
	     * @event layerremove: LayerEvent
	     * Fired when some layer is removed from the map
	     *
	     * @section Methods for Layers and Controls
	     */
	    Map.include({
	      // @method addLayer(layer: Layer): this
	      // Adds the given layer to the map
	      addLayer: function (layer) {
	        if (!layer._layerAdd) {
	          throw new Error('The provided object is not a Layer.');
	        }
	        var id = stamp(layer);
	        if (this._layers[id]) {
	          return this;
	        }
	        this._layers[id] = layer;
	        layer._mapToAdd = this;
	        if (layer.beforeAdd) {
	          layer.beforeAdd(this);
	        }
	        this.whenReady(layer._layerAdd, layer);
	        return this;
	      },
	      // @method removeLayer(layer: Layer): this
	      // Removes the given layer from the map.
	      removeLayer: function (layer) {
	        var id = stamp(layer);
	        if (!this._layers[id]) {
	          return this;
	        }
	        if (this._loaded) {
	          layer.onRemove(this);
	        }
	        delete this._layers[id];
	        if (this._loaded) {
	          this.fire('layerremove', {
	            layer: layer
	          });
	          layer.fire('remove');
	        }
	        layer._map = layer._mapToAdd = null;
	        return this;
	      },
	      // @method hasLayer(layer: Layer): Boolean
	      // Returns `true` if the given layer is currently added to the map
	      hasLayer: function (layer) {
	        return stamp(layer) in this._layers;
	      },
	      /* @method eachLayer(fn: Function, context?: Object): this
	       * Iterates over the layers of the map, optionally specifying context of the iterator function.
	       * ```
	       * map.eachLayer(function(layer){
	       *     layer.bindPopup('Hello');
	       * });
	       * ```
	       */
	      eachLayer: function (method, context) {
	        for (var i in this._layers) {
	          method.call(context, this._layers[i]);
	        }
	        return this;
	      },
	      _addLayers: function (layers) {
	        layers = layers ? isArray(layers) ? layers : [layers] : [];
	        for (var i = 0, len = layers.length; i < len; i++) {
	          this.addLayer(layers[i]);
	        }
	      },
	      _addZoomLimit: function (layer) {
	        if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
	          this._zoomBoundLayers[stamp(layer)] = layer;
	          this._updateZoomLevels();
	        }
	      },
	      _removeZoomLimit: function (layer) {
	        var id = stamp(layer);
	        if (this._zoomBoundLayers[id]) {
	          delete this._zoomBoundLayers[id];
	          this._updateZoomLevels();
	        }
	      },
	      _updateZoomLevels: function () {
	        var minZoom = Infinity,
	          maxZoom = -Infinity,
	          oldZoomSpan = this._getZoomSpan();
	        for (var i in this._zoomBoundLayers) {
	          var options = this._zoomBoundLayers[i].options;
	          minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
	          maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
	        }
	        this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
	        this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;

	        // @section Map state change events
	        // @event zoomlevelschange: Event
	        // Fired when the number of zoomlevels on the map is changed due
	        // to adding or removing a layer.
	        if (oldZoomSpan !== this._getZoomSpan()) {
	          this.fire('zoomlevelschange');
	        }
	        if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
	          this.setZoom(this._layersMaxZoom);
	        }
	        if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
	          this.setZoom(this._layersMinZoom);
	        }
	      }
	    });

	    /*
	     * @class LayerGroup
	     * @aka L.LayerGroup
	     * @inherits Interactive layer
	     *
	     * Used to group several layers and handle them as one. If you add it to the map,
	     * any layers added or removed from the group will be added/removed on the map as
	     * well. Extends `Layer`.
	     *
	     * @example
	     *
	     * ```js
	     * L.layerGroup([marker1, marker2])
	     * 	.addLayer(polyline)
	     * 	.addTo(map);
	     * ```
	     */

	    var LayerGroup = Layer.extend({
	      initialize: function (layers, options) {
	        setOptions(this, options);
	        this._layers = {};
	        var i, len;
	        if (layers) {
	          for (i = 0, len = layers.length; i < len; i++) {
	            this.addLayer(layers[i]);
	          }
	        }
	      },
	      // @method addLayer(layer: Layer): this
	      // Adds the given layer to the group.
	      addLayer: function (layer) {
	        var id = this.getLayerId(layer);
	        this._layers[id] = layer;
	        if (this._map) {
	          this._map.addLayer(layer);
	        }
	        return this;
	      },
	      // @method removeLayer(layer: Layer): this
	      // Removes the given layer from the group.
	      // @alternative
	      // @method removeLayer(id: Number): this
	      // Removes the layer with the given internal ID from the group.
	      removeLayer: function (layer) {
	        var id = layer in this._layers ? layer : this.getLayerId(layer);
	        if (this._map && this._layers[id]) {
	          this._map.removeLayer(this._layers[id]);
	        }
	        delete this._layers[id];
	        return this;
	      },
	      // @method hasLayer(layer: Layer): Boolean
	      // Returns `true` if the given layer is currently added to the group.
	      // @alternative
	      // @method hasLayer(id: Number): Boolean
	      // Returns `true` if the given internal ID is currently added to the group.
	      hasLayer: function (layer) {
	        var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
	        return layerId in this._layers;
	      },
	      // @method clearLayers(): this
	      // Removes all the layers from the group.
	      clearLayers: function () {
	        return this.eachLayer(this.removeLayer, this);
	      },
	      // @method invoke(methodName: String, …): this
	      // Calls `methodName` on every layer contained in this group, passing any
	      // additional parameters. Has no effect if the layers contained do not
	      // implement `methodName`.
	      invoke: function (methodName) {
	        var args = Array.prototype.slice.call(arguments, 1),
	          i,
	          layer;
	        for (i in this._layers) {
	          layer = this._layers[i];
	          if (layer[methodName]) {
	            layer[methodName].apply(layer, args);
	          }
	        }
	        return this;
	      },
	      onAdd: function (map) {
	        this.eachLayer(map.addLayer, map);
	      },
	      onRemove: function (map) {
	        this.eachLayer(map.removeLayer, map);
	      },
	      // @method eachLayer(fn: Function, context?: Object): this
	      // Iterates over the layers of the group, optionally specifying context of the iterator function.
	      // ```js
	      // group.eachLayer(function (layer) {
	      // 	layer.bindPopup('Hello');
	      // });
	      // ```
	      eachLayer: function (method, context) {
	        for (var i in this._layers) {
	          method.call(context, this._layers[i]);
	        }
	        return this;
	      },
	      // @method getLayer(id: Number): Layer
	      // Returns the layer with the given internal ID.
	      getLayer: function (id) {
	        return this._layers[id];
	      },
	      // @method getLayers(): Layer[]
	      // Returns an array of all the layers added to the group.
	      getLayers: function () {
	        var layers = [];
	        this.eachLayer(layers.push, layers);
	        return layers;
	      },
	      // @method setZIndex(zIndex: Number): this
	      // Calls `setZIndex` on every layer contained in this group, passing the z-index.
	      setZIndex: function (zIndex) {
	        return this.invoke('setZIndex', zIndex);
	      },
	      // @method getLayerId(layer: Layer): Number
	      // Returns the internal ID for a layer
	      getLayerId: function (layer) {
	        return stamp(layer);
	      }
	    });

	    // @factory L.layerGroup(layers?: Layer[], options?: Object)
	    // Create a layer group, optionally given an initial set of layers and an `options` object.
	    var layerGroup = function (layers, options) {
	      return new LayerGroup(layers, options);
	    };

	    /*
	     * @class FeatureGroup
	     * @aka L.FeatureGroup
	     * @inherits LayerGroup
	     *
	     * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	     *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	     *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	     * handler, it will handle events from any of the layers. This includes mouse events
	     * and custom events.
	     *  * Has `layeradd` and `layerremove` events
	     *
	     * @example
	     *
	     * ```js
	     * L.featureGroup([marker1, marker2, polyline])
	     * 	.bindPopup('Hello world!')
	     * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	     * 	.addTo(map);
	     * ```
	     */

	    var FeatureGroup = LayerGroup.extend({
	      addLayer: function (layer) {
	        if (this.hasLayer(layer)) {
	          return this;
	        }
	        layer.addEventParent(this);
	        LayerGroup.prototype.addLayer.call(this, layer);

	        // @event layeradd: LayerEvent
	        // Fired when a layer is added to this `FeatureGroup`
	        return this.fire('layeradd', {
	          layer: layer
	        });
	      },
	      removeLayer: function (layer) {
	        if (!this.hasLayer(layer)) {
	          return this;
	        }
	        if (layer in this._layers) {
	          layer = this._layers[layer];
	        }
	        layer.removeEventParent(this);
	        LayerGroup.prototype.removeLayer.call(this, layer);

	        // @event layerremove: LayerEvent
	        // Fired when a layer is removed from this `FeatureGroup`
	        return this.fire('layerremove', {
	          layer: layer
	        });
	      },
	      // @method setStyle(style: Path options): this
	      // Sets the given path options to each layer of the group that has a `setStyle` method.
	      setStyle: function (style) {
	        return this.invoke('setStyle', style);
	      },
	      // @method bringToFront(): this
	      // Brings the layer group to the top of all other layers
	      bringToFront: function () {
	        return this.invoke('bringToFront');
	      },
	      // @method bringToBack(): this
	      // Brings the layer group to the back of all other layers
	      bringToBack: function () {
	        return this.invoke('bringToBack');
	      },
	      // @method getBounds(): LatLngBounds
	      // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	      getBounds: function () {
	        var bounds = new LatLngBounds();
	        for (var id in this._layers) {
	          var layer = this._layers[id];
	          bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
	        }
	        return bounds;
	      }
	    });

	    // @factory L.featureGroup(layers?: Layer[], options?: Object)
	    // Create a feature group, optionally given an initial set of layers and an `options` object.
	    var featureGroup = function (layers, options) {
	      return new FeatureGroup(layers, options);
	    };

	    /*
	     * @class Icon
	     * @aka L.Icon
	     *
	     * Represents an icon to provide when creating a marker.
	     *
	     * @example
	     *
	     * ```js
	     * var myIcon = L.icon({
	     *     iconUrl: 'my-icon.png',
	     *     iconRetinaUrl: 'my-icon@2x.png',
	     *     iconSize: [38, 95],
	     *     iconAnchor: [22, 94],
	     *     popupAnchor: [-3, -76],
	     *     shadowUrl: 'my-icon-shadow.png',
	     *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	     *     shadowSize: [68, 95],
	     *     shadowAnchor: [22, 94]
	     * });
	     *
	     * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	     * ```
	     *
	     * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	     *
	     */

	    var Icon = Class.extend({
	      /* @section
	       * @aka Icon options
	       *
	       * @option iconUrl: String = null
	       * **(required)** The URL to the icon image (absolute or relative to your script path).
	       *
	       * @option iconRetinaUrl: String = null
	       * The URL to a retina sized version of the icon image (absolute or relative to your
	       * script path). Used for Retina screen devices.
	       *
	       * @option iconSize: Point = null
	       * Size of the icon image in pixels.
	       *
	       * @option iconAnchor: Point = null
	       * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	       * will be aligned so that this point is at the marker's geographical location. Centered
	       * by default if size is specified, also can be set in CSS with negative margins.
	       *
	       * @option popupAnchor: Point = [0, 0]
	       * The coordinates of the point from which popups will "open", relative to the icon anchor.
	       *
	       * @option tooltipAnchor: Point = [0, 0]
	       * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
	       *
	       * @option shadowUrl: String = null
	       * The URL to the icon shadow image. If not specified, no shadow image will be created.
	       *
	       * @option shadowRetinaUrl: String = null
	       *
	       * @option shadowSize: Point = null
	       * Size of the shadow image in pixels.
	       *
	       * @option shadowAnchor: Point = null
	       * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	       * as iconAnchor if not specified).
	       *
	       * @option className: String = ''
	       * A custom class name to assign to both icon and shadow images. Empty by default.
	       */

	      options: {
	        popupAnchor: [0, 0],
	        tooltipAnchor: [0, 0],
	        // @option crossOrigin: Boolean|String = false
	        // Whether the crossOrigin attribute will be added to the tiles.
	        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
	        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	        crossOrigin: false
	      },
	      initialize: function (options) {
	        setOptions(this, options);
	      },
	      // @method createIcon(oldIcon?: HTMLElement): HTMLElement
	      // Called internally when the icon has to be shown, returns a `<img>` HTML element
	      // styled according to the options.
	      createIcon: function (oldIcon) {
	        return this._createIcon('icon', oldIcon);
	      },
	      // @method createShadow(oldIcon?: HTMLElement): HTMLElement
	      // As `createIcon`, but for the shadow beneath it.
	      createShadow: function (oldIcon) {
	        return this._createIcon('shadow', oldIcon);
	      },
	      _createIcon: function (name, oldIcon) {
	        var src = this._getIconUrl(name);
	        if (!src) {
	          if (name === 'icon') {
	            throw new Error('iconUrl not set in Icon options (see the docs).');
	          }
	          return null;
	        }
	        var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
	        this._setIconStyles(img, name);
	        if (this.options.crossOrigin || this.options.crossOrigin === '') {
	          img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	        }
	        return img;
	      },
	      _setIconStyles: function (img, name) {
	        var options = this.options;
	        var sizeOption = options[name + 'Size'];
	        if (typeof sizeOption === 'number') {
	          sizeOption = [sizeOption, sizeOption];
	        }
	        var size = toPoint(sizeOption),
	          anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
	        img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	        if (anchor) {
	          img.style.marginLeft = -anchor.x + 'px';
	          img.style.marginTop = -anchor.y + 'px';
	        }
	        if (size) {
	          img.style.width = size.x + 'px';
	          img.style.height = size.y + 'px';
	        }
	      },
	      _createImg: function (src, el) {
	        el = el || document.createElement('img');
	        el.src = src;
	        return el;
	      },
	      _getIconUrl: function (name) {
	        return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	      }
	    });

	    // @factory L.icon(options: Icon options)
	    // Creates an icon instance with the given options.
	    function icon(options) {
	      return new Icon(options);
	    }

	    /*
	     * @miniclass Icon.Default (Icon)
	     * @aka L.Icon.Default
	     * @section
	     *
	     * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	     * no icon is specified. Points to the blue marker image distributed with Leaflet
	     * releases.
	     *
	     * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	     * (which is a set of `Icon options`).
	     *
	     * If you want to _completely_ replace the default icon, override the
	     * `L.Marker.prototype.options.icon` with your own icon instead.
	     */

	    var IconDefault = Icon.extend({
	      options: {
	        iconUrl: 'marker-icon.png',
	        iconRetinaUrl: 'marker-icon-2x.png',
	        shadowUrl: 'marker-shadow.png',
	        iconSize: [25, 41],
	        iconAnchor: [12, 41],
	        popupAnchor: [1, -34],
	        tooltipAnchor: [16, -28],
	        shadowSize: [41, 41]
	      },
	      _getIconUrl: function (name) {
	        if (typeof IconDefault.imagePath !== 'string') {
	          // Deprecated, backwards-compatibility only
	          IconDefault.imagePath = this._detectIconPath();
	        }

	        // @option imagePath: String
	        // `Icon.Default` will try to auto-detect the location of the
	        // blue icon images. If you are placing these images in a non-standard
	        // way, set this option to point to the right path.
	        return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
	      },
	      _stripUrl: function (path) {
	        // separate function to use in tests
	        var strip = function (str, re, idx) {
	          var match = re.exec(str);
	          return match && match[idx];
	        };
	        path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
	        return path && strip(path, /^(.*)marker-icon\.png$/, 1);
	      },
	      _detectIconPath: function () {
	        var el = create$1('div', 'leaflet-default-icon-path', document.body);
	        var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8

	        document.body.removeChild(el);
	        path = this._stripUrl(path);
	        if (path) {
	          return path;
	        }
	        var link = document.querySelector('link[href$="leaflet.css"]');
	        if (!link) {
	          return '';
	        }
	        return link.href.substring(0, link.href.length - 'leaflet.css'.length - 1);
	      }
	    });

	    /*
	     * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	     */

	    /* @namespace Marker
	     * @section Interaction handlers
	     *
	     * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	     *
	     * ```js
	     * marker.dragging.disable();
	     * ```
	     *
	     * @property dragging: Handler
	     * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	     */

	    var MarkerDrag = Handler.extend({
	      initialize: function (marker) {
	        this._marker = marker;
	      },
	      addHooks: function () {
	        var icon = this._marker._icon;
	        if (!this._draggable) {
	          this._draggable = new Draggable(icon, icon, true);
	        }
	        this._draggable.on({
	          dragstart: this._onDragStart,
	          predrag: this._onPreDrag,
	          drag: this._onDrag,
	          dragend: this._onDragEnd
	        }, this).enable();
	        addClass(icon, 'leaflet-marker-draggable');
	      },
	      removeHooks: function () {
	        this._draggable.off({
	          dragstart: this._onDragStart,
	          predrag: this._onPreDrag,
	          drag: this._onDrag,
	          dragend: this._onDragEnd
	        }, this).disable();
	        if (this._marker._icon) {
	          removeClass(this._marker._icon, 'leaflet-marker-draggable');
	        }
	      },
	      moved: function () {
	        return this._draggable && this._draggable._moved;
	      },
	      _adjustPan: function (e) {
	        var marker = this._marker,
	          map = marker._map,
	          speed = this._marker.options.autoPanSpeed,
	          padding = this._marker.options.autoPanPadding,
	          iconPos = getPosition(marker._icon),
	          bounds = map.getPixelBounds(),
	          origin = map.getPixelOrigin();
	        var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
	        if (!panBounds.contains(iconPos)) {
	          // Compute incremental movement
	          var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
	          map.panBy(movement, {
	            animate: false
	          });
	          this._draggable._newPos._add(movement);
	          this._draggable._startPos._add(movement);
	          setPosition(marker._icon, this._draggable._newPos);
	          this._onDrag(e);
	          this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	        }
	      },
	      _onDragStart: function () {
	        // @section Dragging events
	        // @event dragstart: Event
	        // Fired when the user starts dragging the marker.

	        // @event movestart: Event
	        // Fired when the marker starts moving (because of dragging).

	        this._oldLatLng = this._marker.getLatLng();

	        // When using ES6 imports it could not be set when `Popup` was not imported as well
	        this._marker.closePopup && this._marker.closePopup();
	        this._marker.fire('movestart').fire('dragstart');
	      },
	      _onPreDrag: function (e) {
	        if (this._marker.options.autoPan) {
	          cancelAnimFrame(this._panRequest);
	          this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	        }
	      },
	      _onDrag: function (e) {
	        var marker = this._marker,
	          shadow = marker._shadow,
	          iconPos = getPosition(marker._icon),
	          latlng = marker._map.layerPointToLatLng(iconPos);

	        // update shadow position
	        if (shadow) {
	          setPosition(shadow, iconPos);
	        }
	        marker._latlng = latlng;
	        e.latlng = latlng;
	        e.oldLatLng = this._oldLatLng;

	        // @event drag: Event
	        // Fired repeatedly while the user drags the marker.
	        marker.fire('move', e).fire('drag', e);
	      },
	      _onDragEnd: function (e) {
	        // @event dragend: DragEndEvent
	        // Fired when the user stops dragging the marker.

	        cancelAnimFrame(this._panRequest);

	        // @event moveend: Event
	        // Fired when the marker stops moving (because of dragging).
	        delete this._oldLatLng;
	        this._marker.fire('moveend').fire('dragend', e);
	      }
	    });

	    /*
	     * @class Marker
	     * @inherits Interactive layer
	     * @aka L.Marker
	     * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	     *
	     * @example
	     *
	     * ```js
	     * L.marker([50.5, 30.5]).addTo(map);
	     * ```
	     */

	    var Marker = Layer.extend({
	      // @section
	      // @aka Marker options
	      options: {
	        // @option icon: Icon = *
	        // Icon instance to use for rendering the marker.
	        // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
	        // If not specified, a common instance of `L.Icon.Default` is used.
	        icon: new IconDefault(),
	        // Option inherited from "Interactive layer" abstract class
	        interactive: true,
	        // @option keyboard: Boolean = true
	        // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
	        keyboard: true,
	        // @option title: String = ''
	        // Text for the browser tooltip that appear on marker hover (no tooltip by default).
	        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
	        title: '',
	        // @option alt: String = 'Marker'
	        // Text for the `alt` attribute of the icon image.
	        // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
	        alt: 'Marker',
	        // @option zIndexOffset: Number = 0
	        // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
	        zIndexOffset: 0,
	        // @option opacity: Number = 1.0
	        // The opacity of the marker.
	        opacity: 1,
	        // @option riseOnHover: Boolean = false
	        // If `true`, the marker will get on top of others when you hover the mouse over it.
	        riseOnHover: false,
	        // @option riseOffset: Number = 250
	        // The z-index offset used for the `riseOnHover` feature.
	        riseOffset: 250,
	        // @option pane: String = 'markerPane'
	        // `Map pane` where the markers icon will be added.
	        pane: 'markerPane',
	        // @option shadowPane: String = 'shadowPane'
	        // `Map pane` where the markers shadow will be added.
	        shadowPane: 'shadowPane',
	        // @option bubblingMouseEvents: Boolean = false
	        // When `true`, a mouse event on this marker will trigger the same event on the map
	        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	        bubblingMouseEvents: false,
	        // @option autoPanOnFocus: Boolean = true
	        // When `true`, the map will pan whenever the marker is focused (via
	        // e.g. pressing `tab` on the keyboard) to ensure the marker is
	        // visible within the map's bounds
	        autoPanOnFocus: true,
	        // @section Draggable marker options
	        // @option draggable: Boolean = false
	        // Whether the marker is draggable with mouse/touch or not.
	        draggable: false,
	        // @option autoPan: Boolean = false
	        // Whether to pan the map when dragging this marker near its edge or not.
	        autoPan: false,
	        // @option autoPanPadding: Point = Point(50, 50)
	        // Distance (in pixels to the left/right and to the top/bottom) of the
	        // map edge to start panning the map.
	        autoPanPadding: [50, 50],
	        // @option autoPanSpeed: Number = 10
	        // Number of pixels the map should pan by.
	        autoPanSpeed: 10
	      },
	      /* @section
	       *
	       * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	       */

	      initialize: function (latlng, options) {
	        setOptions(this, options);
	        this._latlng = toLatLng(latlng);
	      },
	      onAdd: function (map) {
	        this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	        if (this._zoomAnimated) {
	          map.on('zoomanim', this._animateZoom, this);
	        }
	        this._initIcon();
	        this.update();
	      },
	      onRemove: function (map) {
	        if (this.dragging && this.dragging.enabled()) {
	          this.options.draggable = true;
	          this.dragging.removeHooks();
	        }
	        delete this.dragging;
	        if (this._zoomAnimated) {
	          map.off('zoomanim', this._animateZoom, this);
	        }
	        this._removeIcon();
	        this._removeShadow();
	      },
	      getEvents: function () {
	        return {
	          zoom: this.update,
	          viewreset: this.update
	        };
	      },
	      // @method getLatLng: LatLng
	      // Returns the current geographical position of the marker.
	      getLatLng: function () {
	        return this._latlng;
	      },
	      // @method setLatLng(latlng: LatLng): this
	      // Changes the marker position to the given point.
	      setLatLng: function (latlng) {
	        var oldLatLng = this._latlng;
	        this._latlng = toLatLng(latlng);
	        this.update();

	        // @event move: Event
	        // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	        return this.fire('move', {
	          oldLatLng: oldLatLng,
	          latlng: this._latlng
	        });
	      },
	      // @method setZIndexOffset(offset: Number): this
	      // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	      setZIndexOffset: function (offset) {
	        this.options.zIndexOffset = offset;
	        return this.update();
	      },
	      // @method getIcon: Icon
	      // Returns the current icon used by the marker
	      getIcon: function () {
	        return this.options.icon;
	      },
	      // @method setIcon(icon: Icon): this
	      // Changes the marker icon.
	      setIcon: function (icon) {
	        this.options.icon = icon;
	        if (this._map) {
	          this._initIcon();
	          this.update();
	        }
	        if (this._popup) {
	          this.bindPopup(this._popup, this._popup.options);
	        }
	        return this;
	      },
	      getElement: function () {
	        return this._icon;
	      },
	      update: function () {
	        if (this._icon && this._map) {
	          var pos = this._map.latLngToLayerPoint(this._latlng).round();
	          this._setPos(pos);
	        }
	        return this;
	      },
	      _initIcon: function () {
	        var options = this.options,
	          classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	        var icon = options.icon.createIcon(this._icon),
	          addIcon = false;

	        // if we're not reusing the icon, remove the old one and init new one
	        if (icon !== this._icon) {
	          if (this._icon) {
	            this._removeIcon();
	          }
	          addIcon = true;
	          if (options.title) {
	            icon.title = options.title;
	          }
	          if (icon.tagName === 'IMG') {
	            icon.alt = options.alt || '';
	          }
	        }
	        addClass(icon, classToAdd);
	        if (options.keyboard) {
	          icon.tabIndex = '0';
	          icon.setAttribute('role', 'button');
	        }
	        this._icon = icon;
	        if (options.riseOnHover) {
	          this.on({
	            mouseover: this._bringToFront,
	            mouseout: this._resetZIndex
	          });
	        }
	        if (this.options.autoPanOnFocus) {
	          on(icon, 'focus', this._panOnFocus, this);
	        }
	        var newShadow = options.icon.createShadow(this._shadow),
	          addShadow = false;
	        if (newShadow !== this._shadow) {
	          this._removeShadow();
	          addShadow = true;
	        }
	        if (newShadow) {
	          addClass(newShadow, classToAdd);
	          newShadow.alt = '';
	        }
	        this._shadow = newShadow;
	        if (options.opacity < 1) {
	          this._updateOpacity();
	        }
	        if (addIcon) {
	          this.getPane().appendChild(this._icon);
	        }
	        this._initInteraction();
	        if (newShadow && addShadow) {
	          this.getPane(options.shadowPane).appendChild(this._shadow);
	        }
	      },
	      _removeIcon: function () {
	        if (this.options.riseOnHover) {
	          this.off({
	            mouseover: this._bringToFront,
	            mouseout: this._resetZIndex
	          });
	        }
	        if (this.options.autoPanOnFocus) {
	          off(this._icon, 'focus', this._panOnFocus, this);
	        }
	        remove(this._icon);
	        this.removeInteractiveTarget(this._icon);
	        this._icon = null;
	      },
	      _removeShadow: function () {
	        if (this._shadow) {
	          remove(this._shadow);
	        }
	        this._shadow = null;
	      },
	      _setPos: function (pos) {
	        if (this._icon) {
	          setPosition(this._icon, pos);
	        }
	        if (this._shadow) {
	          setPosition(this._shadow, pos);
	        }
	        this._zIndex = pos.y + this.options.zIndexOffset;
	        this._resetZIndex();
	      },
	      _updateZIndex: function (offset) {
	        if (this._icon) {
	          this._icon.style.zIndex = this._zIndex + offset;
	        }
	      },
	      _animateZoom: function (opt) {
	        var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	        this._setPos(pos);
	      },
	      _initInteraction: function () {
	        if (!this.options.interactive) {
	          return;
	        }
	        addClass(this._icon, 'leaflet-interactive');
	        this.addInteractiveTarget(this._icon);
	        if (MarkerDrag) {
	          var draggable = this.options.draggable;
	          if (this.dragging) {
	            draggable = this.dragging.enabled();
	            this.dragging.disable();
	          }
	          this.dragging = new MarkerDrag(this);
	          if (draggable) {
	            this.dragging.enable();
	          }
	        }
	      },
	      // @method setOpacity(opacity: Number): this
	      // Changes the opacity of the marker.
	      setOpacity: function (opacity) {
	        this.options.opacity = opacity;
	        if (this._map) {
	          this._updateOpacity();
	        }
	        return this;
	      },
	      _updateOpacity: function () {
	        var opacity = this.options.opacity;
	        if (this._icon) {
	          setOpacity(this._icon, opacity);
	        }
	        if (this._shadow) {
	          setOpacity(this._shadow, opacity);
	        }
	      },
	      _bringToFront: function () {
	        this._updateZIndex(this.options.riseOffset);
	      },
	      _resetZIndex: function () {
	        this._updateZIndex(0);
	      },
	      _panOnFocus: function () {
	        var map = this._map;
	        if (!map) {
	          return;
	        }
	        var iconOpts = this.options.icon.options;
	        var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
	        var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
	        map.panInside(this._latlng, {
	          paddingTopLeft: anchor,
	          paddingBottomRight: size.subtract(anchor)
	        });
	      },
	      _getPopupAnchor: function () {
	        return this.options.icon.options.popupAnchor;
	      },
	      _getTooltipAnchor: function () {
	        return this.options.icon.options.tooltipAnchor;
	      }
	    });

	    // factory L.marker(latlng: LatLng, options? : Marker options)

	    // @factory L.marker(latlng: LatLng, options? : Marker options)
	    // Instantiates a Marker object given a geographical point and optionally an options object.
	    function marker(latlng, options) {
	      return new Marker(latlng, options);
	    }

	    /*
	     * @class Path
	     * @aka L.Path
	     * @inherits Interactive layer
	     *
	     * An abstract class that contains options and constants shared between vector
	     * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	     */

	    var Path = Layer.extend({
	      // @section
	      // @aka Path options
	      options: {
	        // @option stroke: Boolean = true
	        // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
	        stroke: true,
	        // @option color: String = '#3388ff'
	        // Stroke color
	        color: '#3388ff',
	        // @option weight: Number = 3
	        // Stroke width in pixels
	        weight: 3,
	        // @option opacity: Number = 1.0
	        // Stroke opacity
	        opacity: 1,
	        // @option lineCap: String= 'round'
	        // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
	        lineCap: 'round',
	        // @option lineJoin: String = 'round'
	        // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
	        lineJoin: 'round',
	        // @option dashArray: String = null
	        // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	        dashArray: null,
	        // @option dashOffset: String = null
	        // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	        dashOffset: null,
	        // @option fill: Boolean = depends
	        // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
	        fill: false,
	        // @option fillColor: String = *
	        // Fill color. Defaults to the value of the [`color`](#path-color) option
	        fillColor: null,
	        // @option fillOpacity: Number = 0.2
	        // Fill opacity.
	        fillOpacity: 0.2,
	        // @option fillRule: String = 'evenodd'
	        // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
	        fillRule: 'evenodd',
	        // className: '',

	        // Option inherited from "Interactive layer" abstract class
	        interactive: true,
	        // @option bubblingMouseEvents: Boolean = true
	        // When `true`, a mouse event on this path will trigger the same event on the map
	        // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	        bubblingMouseEvents: true
	      },
	      beforeAdd: function (map) {
	        // Renderer is set here because we need to call renderer.getEvents
	        // before this.getEvents.
	        this._renderer = map.getRenderer(this);
	      },
	      onAdd: function () {
	        this._renderer._initPath(this);
	        this._reset();
	        this._renderer._addPath(this);
	      },
	      onRemove: function () {
	        this._renderer._removePath(this);
	      },
	      // @method redraw(): this
	      // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	      redraw: function () {
	        if (this._map) {
	          this._renderer._updatePath(this);
	        }
	        return this;
	      },
	      // @method setStyle(style: Path options): this
	      // Changes the appearance of a Path based on the options in the `Path options` object.
	      setStyle: function (style) {
	        setOptions(this, style);
	        if (this._renderer) {
	          this._renderer._updateStyle(this);
	          if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) {
	            this._updateBounds();
	          }
	        }
	        return this;
	      },
	      // @method bringToFront(): this
	      // Brings the layer to the top of all path layers.
	      bringToFront: function () {
	        if (this._renderer) {
	          this._renderer._bringToFront(this);
	        }
	        return this;
	      },
	      // @method bringToBack(): this
	      // Brings the layer to the bottom of all path layers.
	      bringToBack: function () {
	        if (this._renderer) {
	          this._renderer._bringToBack(this);
	        }
	        return this;
	      },
	      getElement: function () {
	        return this._path;
	      },
	      _reset: function () {
	        // defined in child classes
	        this._project();
	        this._update();
	      },
	      _clickTolerance: function () {
	        // used when doing hit detection for Canvas layers
	        return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
	      }
	    });

	    /*
	     * @class CircleMarker
	     * @aka L.CircleMarker
	     * @inherits Path
	     *
	     * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	     */

	    var CircleMarker = Path.extend({
	      // @section
	      // @aka CircleMarker options
	      options: {
	        fill: true,
	        // @option radius: Number = 10
	        // Radius of the circle marker, in pixels
	        radius: 10
	      },
	      initialize: function (latlng, options) {
	        setOptions(this, options);
	        this._latlng = toLatLng(latlng);
	        this._radius = this.options.radius;
	      },
	      // @method setLatLng(latLng: LatLng): this
	      // Sets the position of a circle marker to a new location.
	      setLatLng: function (latlng) {
	        var oldLatLng = this._latlng;
	        this._latlng = toLatLng(latlng);
	        this.redraw();

	        // @event move: Event
	        // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	        return this.fire('move', {
	          oldLatLng: oldLatLng,
	          latlng: this._latlng
	        });
	      },
	      // @method getLatLng(): LatLng
	      // Returns the current geographical position of the circle marker
	      getLatLng: function () {
	        return this._latlng;
	      },
	      // @method setRadius(radius: Number): this
	      // Sets the radius of a circle marker. Units are in pixels.
	      setRadius: function (radius) {
	        this.options.radius = this._radius = radius;
	        return this.redraw();
	      },
	      // @method getRadius(): Number
	      // Returns the current radius of the circle
	      getRadius: function () {
	        return this._radius;
	      },
	      setStyle: function (options) {
	        var radius = options && options.radius || this._radius;
	        Path.prototype.setStyle.call(this, options);
	        this.setRadius(radius);
	        return this;
	      },
	      _project: function () {
	        this._point = this._map.latLngToLayerPoint(this._latlng);
	        this._updateBounds();
	      },
	      _updateBounds: function () {
	        var r = this._radius,
	          r2 = this._radiusY || r,
	          w = this._clickTolerance(),
	          p = [r + w, r2 + w];
	        this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
	      },
	      _update: function () {
	        if (this._map) {
	          this._updatePath();
	        }
	      },
	      _updatePath: function () {
	        this._renderer._updateCircle(this);
	      },
	      _empty: function () {
	        return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	      },
	      // Needed by the `Canvas` renderer for interactivity
	      _containsPoint: function (p) {
	        return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	      }
	    });

	    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	    // Instantiates a circle marker object given a geographical point, and an optional options object.
	    function circleMarker(latlng, options) {
	      return new CircleMarker(latlng, options);
	    }

	    /*
	     * @class Circle
	     * @aka L.Circle
	     * @inherits CircleMarker
	     *
	     * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	     *
	     * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	     *
	     * @example
	     *
	     * ```js
	     * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	     * ```
	     */

	    var Circle = CircleMarker.extend({
	      initialize: function (latlng, options, legacyOptions) {
	        if (typeof options === 'number') {
	          // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
	          options = extend({}, legacyOptions, {
	            radius: options
	          });
	        }
	        setOptions(this, options);
	        this._latlng = toLatLng(latlng);
	        if (isNaN(this.options.radius)) {
	          throw new Error('Circle radius cannot be NaN');
	        }

	        // @section
	        // @aka Circle options
	        // @option radius: Number; Radius of the circle, in meters.
	        this._mRadius = this.options.radius;
	      },
	      // @method setRadius(radius: Number): this
	      // Sets the radius of a circle. Units are in meters.
	      setRadius: function (radius) {
	        this._mRadius = radius;
	        return this.redraw();
	      },
	      // @method getRadius(): Number
	      // Returns the current radius of a circle. Units are in meters.
	      getRadius: function () {
	        return this._mRadius;
	      },
	      // @method getBounds(): LatLngBounds
	      // Returns the `LatLngBounds` of the path.
	      getBounds: function () {
	        var half = [this._radius, this._radiusY || this._radius];
	        return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
	      },
	      setStyle: Path.prototype.setStyle,
	      _project: function () {
	        var lng = this._latlng.lng,
	          lat = this._latlng.lat,
	          map = this._map,
	          crs = map.options.crs;
	        if (crs.distance === Earth.distance) {
	          var d = Math.PI / 180,
	            latR = this._mRadius / Earth.R / d,
	            top = map.project([lat + latR, lng]),
	            bottom = map.project([lat - latR, lng]),
	            p = top.add(bottom).divideBy(2),
	            lat2 = map.unproject(p).lat,
	            lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	          if (isNaN(lngR) || lngR === 0) {
	            lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
	          }
	          this._point = p.subtract(map.getPixelOrigin());
	          this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
	          this._radiusY = p.y - top.y;
	        } else {
	          var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	          this._point = map.latLngToLayerPoint(this._latlng);
	          this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
	        }
	        this._updateBounds();
	      }
	    });

	    // @factory L.circle(latlng: LatLng, options?: Circle options)
	    // Instantiates a circle object given a geographical point, and an options object
	    // which contains the circle radius.
	    // @alternative
	    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	    // Do not use in new applications or plugins.
	    function circle(latlng, options, legacyOptions) {
	      return new Circle(latlng, options, legacyOptions);
	    }

	    /*
	     * @class Polyline
	     * @aka L.Polyline
	     * @inherits Path
	     *
	     * A class for drawing polyline overlays on a map. Extends `Path`.
	     *
	     * @example
	     *
	     * ```js
	     * // create a red polyline from an array of LatLng points
	     * var latlngs = [
	     * 	[45.51, -122.68],
	     * 	[37.77, -122.43],
	     * 	[34.04, -118.2]
	     * ];
	     *
	     * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	     *
	     * // zoom the map to the polyline
	     * map.fitBounds(polyline.getBounds());
	     * ```
	     *
	     * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	     *
	     * ```js
	     * // create a red polyline from an array of arrays of LatLng points
	     * var latlngs = [
	     * 	[[45.51, -122.68],
	     * 	 [37.77, -122.43],
	     * 	 [34.04, -118.2]],
	     * 	[[40.78, -73.91],
	     * 	 [41.83, -87.62],
	     * 	 [32.76, -96.72]]
	     * ];
	     * ```
	     */

	    var Polyline = Path.extend({
	      // @section
	      // @aka Polyline options
	      options: {
	        // @option smoothFactor: Number = 1.0
	        // How much to simplify the polyline on each zoom level. More means
	        // better performance and smoother look, and less means more accurate representation.
	        smoothFactor: 1.0,
	        // @option noClip: Boolean = false
	        // Disable polyline clipping.
	        noClip: false
	      },
	      initialize: function (latlngs, options) {
	        setOptions(this, options);
	        this._setLatLngs(latlngs);
	      },
	      // @method getLatLngs(): LatLng[]
	      // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	      getLatLngs: function () {
	        return this._latlngs;
	      },
	      // @method setLatLngs(latlngs: LatLng[]): this
	      // Replaces all the points in the polyline with the given array of geographical points.
	      setLatLngs: function (latlngs) {
	        this._setLatLngs(latlngs);
	        return this.redraw();
	      },
	      // @method isEmpty(): Boolean
	      // Returns `true` if the Polyline has no LatLngs.
	      isEmpty: function () {
	        return !this._latlngs.length;
	      },
	      // @method closestLayerPoint(p: Point): Point
	      // Returns the point closest to `p` on the Polyline.
	      closestLayerPoint: function (p) {
	        var minDistance = Infinity,
	          minPoint = null,
	          closest = _sqClosestPointOnSegment,
	          p1,
	          p2;
	        for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
	          var points = this._parts[j];
	          for (var i = 1, len = points.length; i < len; i++) {
	            p1 = points[i - 1];
	            p2 = points[i];
	            var sqDist = closest(p, p1, p2, true);
	            if (sqDist < minDistance) {
	              minDistance = sqDist;
	              minPoint = closest(p, p1, p2);
	            }
	          }
	        }
	        if (minPoint) {
	          minPoint.distance = Math.sqrt(minDistance);
	        }
	        return minPoint;
	      },
	      // @method getCenter(): LatLng
	      // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
	      getCenter: function () {
	        // throws error when not yet added to map as this center calculation requires projected coordinates
	        if (!this._map) {
	          throw new Error('Must add layer to map before using getCenter()');
	        }
	        return polylineCenter(this._defaultShape(), this._map.options.crs);
	      },
	      // @method getBounds(): LatLngBounds
	      // Returns the `LatLngBounds` of the path.
	      getBounds: function () {
	        return this._bounds;
	      },
	      // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
	      // Adds a given point to the polyline. By default, adds to the first ring of
	      // the polyline in case of a multi-polyline, but can be overridden by passing
	      // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	      addLatLng: function (latlng, latlngs) {
	        latlngs = latlngs || this._defaultShape();
	        latlng = toLatLng(latlng);
	        latlngs.push(latlng);
	        this._bounds.extend(latlng);
	        return this.redraw();
	      },
	      _setLatLngs: function (latlngs) {
	        this._bounds = new LatLngBounds();
	        this._latlngs = this._convertLatLngs(latlngs);
	      },
	      _defaultShape: function () {
	        return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
	      },
	      // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	      _convertLatLngs: function (latlngs) {
	        var result = [],
	          flat = isFlat(latlngs);
	        for (var i = 0, len = latlngs.length; i < len; i++) {
	          if (flat) {
	            result[i] = toLatLng(latlngs[i]);
	            this._bounds.extend(result[i]);
	          } else {
	            result[i] = this._convertLatLngs(latlngs[i]);
	          }
	        }
	        return result;
	      },
	      _project: function () {
	        var pxBounds = new Bounds();
	        this._rings = [];
	        this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	        if (this._bounds.isValid() && pxBounds.isValid()) {
	          this._rawPxBounds = pxBounds;
	          this._updateBounds();
	        }
	      },
	      _updateBounds: function () {
	        var w = this._clickTolerance(),
	          p = new Point(w, w);
	        if (!this._rawPxBounds) {
	          return;
	        }
	        this._pxBounds = new Bounds([this._rawPxBounds.min.subtract(p), this._rawPxBounds.max.add(p)]);
	      },
	      // recursively turns latlngs into a set of rings with projected coordinates
	      _projectLatlngs: function (latlngs, result, projectedBounds) {
	        var flat = latlngs[0] instanceof LatLng,
	          len = latlngs.length,
	          i,
	          ring;
	        if (flat) {
	          ring = [];
	          for (i = 0; i < len; i++) {
	            ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
	            projectedBounds.extend(ring[i]);
	          }
	          result.push(ring);
	        } else {
	          for (i = 0; i < len; i++) {
	            this._projectLatlngs(latlngs[i], result, projectedBounds);
	          }
	        }
	      },
	      // clip polyline by renderer bounds so that we have less to render for performance
	      _clipPoints: function () {
	        var bounds = this._renderer._bounds;
	        this._parts = [];
	        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	          return;
	        }
	        if (this.options.noClip) {
	          this._parts = this._rings;
	          return;
	        }
	        var parts = this._parts,
	          i,
	          j,
	          k,
	          len,
	          len2,
	          segment,
	          points;
	        for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
	          points = this._rings[i];
	          for (j = 0, len2 = points.length; j < len2 - 1; j++) {
	            segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	            if (!segment) {
	              continue;
	            }
	            parts[k] = parts[k] || [];
	            parts[k].push(segment[0]);

	            // if segment goes out of screen, or it's the last one, it's the end of the line part
	            if (segment[1] !== points[j + 1] || j === len2 - 2) {
	              parts[k].push(segment[1]);
	              k++;
	            }
	          }
	        }
	      },
	      // simplify each clipped part of the polyline for performance
	      _simplifyPoints: function () {
	        var parts = this._parts,
	          tolerance = this.options.smoothFactor;
	        for (var i = 0, len = parts.length; i < len; i++) {
	          parts[i] = simplify(parts[i], tolerance);
	        }
	      },
	      _update: function () {
	        if (!this._map) {
	          return;
	        }
	        this._clipPoints();
	        this._simplifyPoints();
	        this._updatePath();
	      },
	      _updatePath: function () {
	        this._renderer._updatePoly(this);
	      },
	      // Needed by the `Canvas` renderer for interactivity
	      _containsPoint: function (p, closed) {
	        var i,
	          j,
	          k,
	          len,
	          len2,
	          part,
	          w = this._clickTolerance();
	        if (!this._pxBounds || !this._pxBounds.contains(p)) {
	          return false;
	        }

	        // hit detection for polylines
	        for (i = 0, len = this._parts.length; i < len; i++) {
	          part = this._parts[i];
	          for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	            if (!closed && j === 0) {
	              continue;
	            }
	            if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
	              return true;
	            }
	          }
	        }
	        return false;
	      }
	    });

	    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	    // Instantiates a polyline object given an array of geographical points and
	    // optionally an options object. You can create a `Polyline` object with
	    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
	    // of geographic points.
	    function polyline(latlngs, options) {
	      return new Polyline(latlngs, options);
	    }

	    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	    Polyline._flat = _flat;

	    /*
	     * @class Polygon
	     * @aka L.Polygon
	     * @inherits Polyline
	     *
	     * A class for drawing polygon overlays on a map. Extends `Polyline`.
	     *
	     * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	     *
	     *
	     * @example
	     *
	     * ```js
	     * // create a red polygon from an array of LatLng points
	     * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	     *
	     * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	     *
	     * // zoom the map to the polygon
	     * map.fitBounds(polygon.getBounds());
	     * ```
	     *
	     * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	     *
	     * ```js
	     * var latlngs = [
	     *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	     *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	     * ];
	     * ```
	     *
	     * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	     *
	     * ```js
	     * var latlngs = [
	     *   [ // first polygon
	     *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	     *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	     *   ],
	     *   [ // second polygon
	     *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	     *   ]
	     * ];
	     * ```
	     */

	    var Polygon = Polyline.extend({
	      options: {
	        fill: true
	      },
	      isEmpty: function () {
	        return !this._latlngs.length || !this._latlngs[0].length;
	      },
	      // @method getCenter(): LatLng
	      // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
	      getCenter: function () {
	        // throws error when not yet added to map as this center calculation requires projected coordinates
	        if (!this._map) {
	          throw new Error('Must add layer to map before using getCenter()');
	        }
	        return polygonCenter(this._defaultShape(), this._map.options.crs);
	      },
	      _convertLatLngs: function (latlngs) {
	        var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
	          len = result.length;

	        // remove last point if it equals first one
	        if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
	          result.pop();
	        }
	        return result;
	      },
	      _setLatLngs: function (latlngs) {
	        Polyline.prototype._setLatLngs.call(this, latlngs);
	        if (isFlat(this._latlngs)) {
	          this._latlngs = [this._latlngs];
	        }
	      },
	      _defaultShape: function () {
	        return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	      },
	      _clipPoints: function () {
	        // polygons need a different clipping algorithm so we redefine that

	        var bounds = this._renderer._bounds,
	          w = this.options.weight,
	          p = new Point(w, w);

	        // increase clip padding by stroke width to avoid stroke on clip edges
	        bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	        this._parts = [];
	        if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	          return;
	        }
	        if (this.options.noClip) {
	          this._parts = this._rings;
	          return;
	        }
	        for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
	          clipped = clipPolygon(this._rings[i], bounds, true);
	          if (clipped.length) {
	            this._parts.push(clipped);
	          }
	        }
	      },
	      _updatePath: function () {
	        this._renderer._updatePoly(this, true);
	      },
	      // Needed by the `Canvas` renderer for interactivity
	      _containsPoint: function (p) {
	        var inside = false,
	          part,
	          p1,
	          p2,
	          i,
	          j,
	          k,
	          len,
	          len2;
	        if (!this._pxBounds || !this._pxBounds.contains(p)) {
	          return false;
	        }

	        // ray casting algorithm for detecting if point is in polygon
	        for (i = 0, len = this._parts.length; i < len; i++) {
	          part = this._parts[i];
	          for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	            p1 = part[j];
	            p2 = part[k];
	            if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
	              inside = !inside;
	            }
	          }
	        }

	        // also check if it's on polygon stroke
	        return inside || Polyline.prototype._containsPoint.call(this, p, true);
	      }
	    });

	    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	    function polygon(latlngs, options) {
	      return new Polygon(latlngs, options);
	    }

	    /*
	     * @class GeoJSON
	     * @aka L.GeoJSON
	     * @inherits FeatureGroup
	     *
	     * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	     * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	     *
	     * @example
	     *
	     * ```js
	     * L.geoJSON(data, {
	     * 	style: function (feature) {
	     * 		return {color: feature.properties.color};
	     * 	}
	     * }).bindPopup(function (layer) {
	     * 	return layer.feature.properties.description;
	     * }).addTo(map);
	     * ```
	     */

	    var GeoJSON = FeatureGroup.extend({
	      /* @section
	       * @aka GeoJSON options
	       *
	       * @option pointToLayer: Function = *
	       * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	       * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	       * The default is to spawn a default `Marker`:
	       * ```js
	       * function(geoJsonPoint, latlng) {
	       * 	return L.marker(latlng);
	       * }
	       * ```
	       *
	       * @option style: Function = *
	       * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	       * called internally when data is added.
	       * The default value is to not override any defaults:
	       * ```js
	       * function (geoJsonFeature) {
	       * 	return {}
	       * }
	       * ```
	       *
	       * @option onEachFeature: Function = *
	       * A `Function` that will be called once for each created `Feature`, after it has
	       * been created and styled. Useful for attaching events and popups to features.
	       * The default is to do nothing with the newly created layers:
	       * ```js
	       * function (feature, layer) {}
	       * ```
	       *
	       * @option filter: Function = *
	       * A `Function` that will be used to decide whether to include a feature or not.
	       * The default is to include all features:
	       * ```js
	       * function (geoJsonFeature) {
	       * 	return true;
	       * }
	       * ```
	       * Note: dynamically changing the `filter` option will have effect only on newly
	       * added data. It will _not_ re-evaluate already included features.
	       *
	       * @option coordsToLatLng: Function = *
	       * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	       * The default is the `coordsToLatLng` static method.
	       *
	       * @option markersInheritOptions: Boolean = false
	       * Whether default Markers for "Point" type Features inherit from group options.
	       */

	      initialize: function (geojson, options) {
	        setOptions(this, options);
	        this._layers = {};
	        if (geojson) {
	          this.addData(geojson);
	        }
	      },
	      // @method addData( <GeoJSON> data ): this
	      // Adds a GeoJSON object to the layer.
	      addData: function (geojson) {
	        var features = isArray(geojson) ? geojson : geojson.features,
	          i,
	          len,
	          feature;
	        if (features) {
	          for (i = 0, len = features.length; i < len; i++) {
	            // only add this if geometry or geometries are set and not null
	            feature = features[i];
	            if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
	              this.addData(feature);
	            }
	          }
	          return this;
	        }
	        var options = this.options;
	        if (options.filter && !options.filter(geojson)) {
	          return this;
	        }
	        var layer = geometryToLayer(geojson, options);
	        if (!layer) {
	          return this;
	        }
	        layer.feature = asFeature(geojson);
	        layer.defaultOptions = layer.options;
	        this.resetStyle(layer);
	        if (options.onEachFeature) {
	          options.onEachFeature(geojson, layer);
	        }
	        return this.addLayer(layer);
	      },
	      // @method resetStyle( <Path> layer? ): this
	      // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	      // If `layer` is omitted, the style of all features in the current layer is reset.
	      resetStyle: function (layer) {
	        if (layer === undefined) {
	          return this.eachLayer(this.resetStyle, this);
	        }
	        // reset any custom styles
	        layer.options = extend({}, layer.defaultOptions);
	        this._setLayerStyle(layer, this.options.style);
	        return this;
	      },
	      // @method setStyle( <Function> style ): this
	      // Changes styles of GeoJSON vector layers with the given style function.
	      setStyle: function (style) {
	        return this.eachLayer(function (layer) {
	          this._setLayerStyle(layer, style);
	        }, this);
	      },
	      _setLayerStyle: function (layer, style) {
	        if (layer.setStyle) {
	          if (typeof style === 'function') {
	            style = style(layer.feature);
	          }
	          layer.setStyle(style);
	        }
	      }
	    });

	    // @section
	    // There are several static functions which can be called without instantiating L.GeoJSON:

	    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
	    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	    // functions if provided as options.
	    function geometryToLayer(geojson, options) {
	      var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
	        coords = geometry ? geometry.coordinates : null,
	        layers = [],
	        pointToLayer = options && options.pointToLayer,
	        _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
	        latlng,
	        latlngs,
	        i,
	        len;
	      if (!coords && !geometry) {
	        return null;
	      }
	      switch (geometry.type) {
	        case 'Point':
	          latlng = _coordsToLatLng(coords);
	          return _pointToLayer(pointToLayer, geojson, latlng, options);
	        case 'MultiPoint':
	          for (i = 0, len = coords.length; i < len; i++) {
	            latlng = _coordsToLatLng(coords[i]);
	            layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
	          }
	          return new FeatureGroup(layers);
	        case 'LineString':
	        case 'MultiLineString':
	          latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
	          return new Polyline(latlngs, options);
	        case 'Polygon':
	        case 'MultiPolygon':
	          latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
	          return new Polygon(latlngs, options);
	        case 'GeometryCollection':
	          for (i = 0, len = geometry.geometries.length; i < len; i++) {
	            var geoLayer = geometryToLayer({
	              geometry: geometry.geometries[i],
	              type: 'Feature',
	              properties: geojson.properties
	            }, options);
	            if (geoLayer) {
	              layers.push(geoLayer);
	            }
	          }
	          return new FeatureGroup(layers);
	        case 'FeatureCollection':
	          for (i = 0, len = geometry.features.length; i < len; i++) {
	            var featureLayer = geometryToLayer(geometry.features[i], options);
	            if (featureLayer) {
	              layers.push(featureLayer);
	            }
	          }
	          return new FeatureGroup(layers);
	        default:
	          throw new Error('Invalid GeoJSON object.');
	      }
	    }
	    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
	      return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
	    }

	    // @function coordsToLatLng(coords: Array): LatLng
	    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	    function coordsToLatLng(coords) {
	      return new LatLng(coords[1], coords[0], coords[2]);
	    }

	    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
	      var latlngs = [];
	      for (var i = 0, len = coords.length, latlng; i < len; i++) {
	        latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
	        latlngs.push(latlng);
	      }
	      return latlngs;
	    }

	    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
	    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
	    function latLngToCoords(latlng, precision) {
	      latlng = toLatLng(latlng);
	      return latlng.alt !== undefined ? [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] : [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	    }

	    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
	    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
	    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
	      var coords = [];
	      for (var i = 0, len = latlngs.length; i < len; i++) {
	        // Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
	        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
	      }
	      if (!levelsDeep && closed && coords.length > 0) {
	        coords.push(coords[0].slice());
	      }
	      return coords;
	    }
	    function getFeature(layer, newGeometry) {
	      return layer.feature ? extend({}, layer.feature, {
	        geometry: newGeometry
	      }) : asFeature(newGeometry);
	    }

	    // @function asFeature(geojson: Object): Object
	    // Normalize GeoJSON geometries/features into GeoJSON features.
	    function asFeature(geojson) {
	      if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
	        return geojson;
	      }
	      return {
	        type: 'Feature',
	        properties: {},
	        geometry: geojson
	      };
	    }
	    var PointToGeoJSON = {
	      toGeoJSON: function (precision) {
	        return getFeature(this, {
	          type: 'Point',
	          coordinates: latLngToCoords(this.getLatLng(), precision)
	        });
	      }
	    };

	    // @namespace Marker
	    // @section Other methods
	    // @method toGeoJSON(precision?: Number|false): Object
	    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	    Marker.include(PointToGeoJSON);

	    // @namespace CircleMarker
	    // @method toGeoJSON(precision?: Number|false): Object
	    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	    Circle.include(PointToGeoJSON);
	    CircleMarker.include(PointToGeoJSON);

	    // @namespace Polyline
	    // @method toGeoJSON(precision?: Number|false): Object
	    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	    Polyline.include({
	      toGeoJSON: function (precision) {
	        var multi = !isFlat(this._latlngs);
	        var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	        return getFeature(this, {
	          type: (multi ? 'Multi' : '') + 'LineString',
	          coordinates: coords
	        });
	      }
	    });

	    // @namespace Polygon
	    // @method toGeoJSON(precision?: Number|false): Object
	    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	    Polygon.include({
	      toGeoJSON: function (precision) {
	        var holes = !isFlat(this._latlngs),
	          multi = holes && !isFlat(this._latlngs[0]);
	        var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	        if (!holes) {
	          coords = [coords];
	        }
	        return getFeature(this, {
	          type: (multi ? 'Multi' : '') + 'Polygon',
	          coordinates: coords
	        });
	      }
	    });

	    // @namespace LayerGroup
	    LayerGroup.include({
	      toMultiPoint: function (precision) {
	        var coords = [];
	        this.eachLayer(function (layer) {
	          coords.push(layer.toGeoJSON(precision).geometry.coordinates);
	        });
	        return getFeature(this, {
	          type: 'MultiPoint',
	          coordinates: coords
	        });
	      },
	      // @method toGeoJSON(precision?: Number|false): Object
	      // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	      // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
	      toGeoJSON: function (precision) {
	        var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	        if (type === 'MultiPoint') {
	          return this.toMultiPoint(precision);
	        }
	        var isGeometryCollection = type === 'GeometryCollection',
	          jsons = [];
	        this.eachLayer(function (layer) {
	          if (layer.toGeoJSON) {
	            var json = layer.toGeoJSON(precision);
	            if (isGeometryCollection) {
	              jsons.push(json.geometry);
	            } else {
	              var feature = asFeature(json);
	              // Squash nested feature collections
	              if (feature.type === 'FeatureCollection') {
	                jsons.push.apply(jsons, feature.features);
	              } else {
	                jsons.push(feature);
	              }
	            }
	          }
	        });
	        if (isGeometryCollection) {
	          return getFeature(this, {
	            geometries: jsons,
	            type: 'GeometryCollection'
	          });
	        }
	        return {
	          type: 'FeatureCollection',
	          features: jsons
	        };
	      }
	    });

	    // @namespace GeoJSON
	    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	    // Creates a GeoJSON layer. Optionally accepts an object in
	    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
	    // (you can alternatively add it later with `addData` method) and an `options` object.
	    function geoJSON(geojson, options) {
	      return new GeoJSON(geojson, options);
	    }

	    // Backward compatibility.
	    var geoJson = geoJSON;

	    /*
	     * @class ImageOverlay
	     * @aka L.ImageOverlay
	     * @inherits Interactive layer
	     *
	     * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	     *
	     * @example
	     *
	     * ```js
	     * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	     * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	     * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	     * ```
	     */

	    var ImageOverlay = Layer.extend({
	      // @section
	      // @aka ImageOverlay options
	      options: {
	        // @option opacity: Number = 1.0
	        // The opacity of the image overlay.
	        opacity: 1,
	        // @option alt: String = ''
	        // Text for the `alt` attribute of the image (useful for accessibility).
	        alt: '',
	        // @option interactive: Boolean = false
	        // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
	        interactive: false,
	        // @option crossOrigin: Boolean|String = false
	        // Whether the crossOrigin attribute will be added to the image.
	        // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
	        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	        crossOrigin: false,
	        // @option errorOverlayUrl: String = ''
	        // URL to the overlay image to show in place of the overlay that failed to load.
	        errorOverlayUrl: '',
	        // @option zIndex: Number = 1
	        // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
	        zIndex: 1,
	        // @option className: String = ''
	        // A custom class name to assign to the image. Empty by default.
	        className: ''
	      },
	      initialize: function (url, bounds, options) {
	        // (String, LatLngBounds, Object)
	        this._url = url;
	        this._bounds = toLatLngBounds(bounds);
	        setOptions(this, options);
	      },
	      onAdd: function () {
	        if (!this._image) {
	          this._initImage();
	          if (this.options.opacity < 1) {
	            this._updateOpacity();
	          }
	        }
	        if (this.options.interactive) {
	          addClass(this._image, 'leaflet-interactive');
	          this.addInteractiveTarget(this._image);
	        }
	        this.getPane().appendChild(this._image);
	        this._reset();
	      },
	      onRemove: function () {
	        remove(this._image);
	        if (this.options.interactive) {
	          this.removeInteractiveTarget(this._image);
	        }
	      },
	      // @method setOpacity(opacity: Number): this
	      // Sets the opacity of the overlay.
	      setOpacity: function (opacity) {
	        this.options.opacity = opacity;
	        if (this._image) {
	          this._updateOpacity();
	        }
	        return this;
	      },
	      setStyle: function (styleOpts) {
	        if (styleOpts.opacity) {
	          this.setOpacity(styleOpts.opacity);
	        }
	        return this;
	      },
	      // @method bringToFront(): this
	      // Brings the layer to the top of all overlays.
	      bringToFront: function () {
	        if (this._map) {
	          toFront(this._image);
	        }
	        return this;
	      },
	      // @method bringToBack(): this
	      // Brings the layer to the bottom of all overlays.
	      bringToBack: function () {
	        if (this._map) {
	          toBack(this._image);
	        }
	        return this;
	      },
	      // @method setUrl(url: String): this
	      // Changes the URL of the image.
	      setUrl: function (url) {
	        this._url = url;
	        if (this._image) {
	          this._image.src = url;
	        }
	        return this;
	      },
	      // @method setBounds(bounds: LatLngBounds): this
	      // Update the bounds that this ImageOverlay covers
	      setBounds: function (bounds) {
	        this._bounds = toLatLngBounds(bounds);
	        if (this._map) {
	          this._reset();
	        }
	        return this;
	      },
	      getEvents: function () {
	        var events = {
	          zoom: this._reset,
	          viewreset: this._reset
	        };
	        if (this._zoomAnimated) {
	          events.zoomanim = this._animateZoom;
	        }
	        return events;
	      },
	      // @method setZIndex(value: Number): this
	      // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
	      setZIndex: function (value) {
	        this.options.zIndex = value;
	        this._updateZIndex();
	        return this;
	      },
	      // @method getBounds(): LatLngBounds
	      // Get the bounds that this ImageOverlay covers
	      getBounds: function () {
	        return this._bounds;
	      },
	      // @method getElement(): HTMLElement
	      // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
	      // used by this overlay.
	      getElement: function () {
	        return this._image;
	      },
	      _initImage: function () {
	        var wasElementSupplied = this._url.tagName === 'IMG';
	        var img = this._image = wasElementSupplied ? this._url : create$1('img');
	        addClass(img, 'leaflet-image-layer');
	        if (this._zoomAnimated) {
	          addClass(img, 'leaflet-zoom-animated');
	        }
	        if (this.options.className) {
	          addClass(img, this.options.className);
	        }
	        img.onselectstart = falseFn;
	        img.onmousemove = falseFn;

	        // @event load: Event
	        // Fired when the ImageOverlay layer has loaded its image
	        img.onload = bind(this.fire, this, 'load');
	        img.onerror = bind(this._overlayOnError, this, 'error');
	        if (this.options.crossOrigin || this.options.crossOrigin === '') {
	          img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	        }
	        if (this.options.zIndex) {
	          this._updateZIndex();
	        }
	        if (wasElementSupplied) {
	          this._url = img.src;
	          return;
	        }
	        img.src = this._url;
	        img.alt = this.options.alt;
	      },
	      _animateZoom: function (e) {
	        var scale = this._map.getZoomScale(e.zoom),
	          offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	        setTransform(this._image, offset, scale);
	      },
	      _reset: function () {
	        var image = this._image,
	          bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
	          size = bounds.getSize();
	        setPosition(image, bounds.min);
	        image.style.width = size.x + 'px';
	        image.style.height = size.y + 'px';
	      },
	      _updateOpacity: function () {
	        setOpacity(this._image, this.options.opacity);
	      },
	      _updateZIndex: function () {
	        if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	          this._image.style.zIndex = this.options.zIndex;
	        }
	      },
	      _overlayOnError: function () {
	        // @event error: Event
	        // Fired when the ImageOverlay layer fails to load its image
	        this.fire('error');
	        var errorUrl = this.options.errorOverlayUrl;
	        if (errorUrl && this._url !== errorUrl) {
	          this._url = errorUrl;
	          this._image.src = errorUrl;
	        }
	      },
	      // @method getCenter(): LatLng
	      // Returns the center of the ImageOverlay.
	      getCenter: function () {
	        return this._bounds.getCenter();
	      }
	    });

	    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	    // Instantiates an image overlay object given the URL of the image and the
	    // geographical bounds it is tied to.
	    var imageOverlay = function (url, bounds, options) {
	      return new ImageOverlay(url, bounds, options);
	    };

	    /*
	     * @class VideoOverlay
	     * @aka L.VideoOverlay
	     * @inherits ImageOverlay
	     *
	     * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	     *
	     * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	     * HTML5 element.
	     *
	     * @example
	     *
	     * ```js
	     * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	     * 	videoBounds = [[ 32, -130], [ 13, -100]];
	     * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
	     * ```
	     */

	    var VideoOverlay = ImageOverlay.extend({
	      // @section
	      // @aka VideoOverlay options
	      options: {
	        // @option autoplay: Boolean = true
	        // Whether the video starts playing automatically when loaded.
	        // On some browsers autoplay will only work with `muted: true`
	        autoplay: true,
	        // @option loop: Boolean = true
	        // Whether the video will loop back to the beginning when played.
	        loop: true,
	        // @option keepAspectRatio: Boolean = true
	        // Whether the video will save aspect ratio after the projection.
	        // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
	        keepAspectRatio: true,
	        // @option muted: Boolean = false
	        // Whether the video starts on mute when loaded.
	        muted: false,
	        // @option playsInline: Boolean = true
	        // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
	        playsInline: true
	      },
	      _initImage: function () {
	        var wasElementSupplied = this._url.tagName === 'VIDEO';
	        var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	        addClass(vid, 'leaflet-image-layer');
	        if (this._zoomAnimated) {
	          addClass(vid, 'leaflet-zoom-animated');
	        }
	        if (this.options.className) {
	          addClass(vid, this.options.className);
	        }
	        vid.onselectstart = falseFn;
	        vid.onmousemove = falseFn;

	        // @event load: Event
	        // Fired when the video has finished loading the first frame
	        vid.onloadeddata = bind(this.fire, this, 'load');
	        if (wasElementSupplied) {
	          var sourceElements = vid.getElementsByTagName('source');
	          var sources = [];
	          for (var j = 0; j < sourceElements.length; j++) {
	            sources.push(sourceElements[j].src);
	          }
	          this._url = sourceElements.length > 0 ? sources : [vid.src];
	          return;
	        }
	        if (!isArray(this._url)) {
	          this._url = [this._url];
	        }
	        if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) {
	          vid.style['objectFit'] = 'fill';
	        }
	        vid.autoplay = !!this.options.autoplay;
	        vid.loop = !!this.options.loop;
	        vid.muted = !!this.options.muted;
	        vid.playsInline = !!this.options.playsInline;
	        for (var i = 0; i < this._url.length; i++) {
	          var source = create$1('source');
	          source.src = this._url[i];
	          vid.appendChild(source);
	        }
	      }

	      // @method getElement(): HTMLVideoElement
	      // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
	      // used by this overlay.
	    });

	    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	    // geographical bounds it is tied to.

	    function videoOverlay(video, bounds, options) {
	      return new VideoOverlay(video, bounds, options);
	    }

	    /*
	     * @class SVGOverlay
	     * @aka L.SVGOverlay
	     * @inherits ImageOverlay
	     *
	     * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
	     *
	     * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
	     *
	     * @example
	     *
	     * ```js
	     * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	     * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	     * svgElement.setAttribute('viewBox', "0 0 200 200");
	     * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
	     * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
	     * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
	     * ```
	     */

	    var SVGOverlay = ImageOverlay.extend({
	      _initImage: function () {
	        var el = this._image = this._url;
	        addClass(el, 'leaflet-image-layer');
	        if (this._zoomAnimated) {
	          addClass(el, 'leaflet-zoom-animated');
	        }
	        if (this.options.className) {
	          addClass(el, this.options.className);
	        }
	        el.onselectstart = falseFn;
	        el.onmousemove = falseFn;
	      }

	      // @method getElement(): SVGElement
	      // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
	      // used by this overlay.
	    });

	    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
	    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
	    // A viewBox attribute is required on the SVG element to zoom in and out properly.

	    function svgOverlay(el, bounds, options) {
	      return new SVGOverlay(el, bounds, options);
	    }

	    /*
	     * @class DivOverlay
	     * @inherits Interactive layer
	     * @aka L.DivOverlay
	     * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
	     */

	    // @namespace DivOverlay
	    var DivOverlay = Layer.extend({
	      // @section
	      // @aka DivOverlay options
	      options: {
	        // @option interactive: Boolean = false
	        // If true, the popup/tooltip will listen to the mouse events.
	        interactive: false,
	        // @option offset: Point = Point(0, 0)
	        // The offset of the overlay position.
	        offset: [0, 0],
	        // @option className: String = ''
	        // A custom CSS class name to assign to the overlay.
	        className: '',
	        // @option pane: String = undefined
	        // `Map pane` where the overlay will be added.
	        pane: undefined,
	        // @option content: String|HTMLElement|Function = ''
	        // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
	        // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
	        content: ''
	      },
	      initialize: function (options, source) {
	        if (options && (options instanceof LatLng || isArray(options))) {
	          this._latlng = toLatLng(options);
	          setOptions(this, source);
	        } else {
	          setOptions(this, options);
	          this._source = source;
	        }
	        if (this.options.content) {
	          this._content = this.options.content;
	        }
	      },
	      // @method openOn(map: Map): this
	      // Adds the overlay to the map.
	      // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
	      openOn: function (map) {
	        map = arguments.length ? map : this._source._map; // experimental, not the part of public api
	        if (!map.hasLayer(this)) {
	          map.addLayer(this);
	        }
	        return this;
	      },
	      // @method close(): this
	      // Closes the overlay.
	      // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
	      // and `layer.closePopup()`/`.closeTooltip()`.
	      close: function () {
	        if (this._map) {
	          this._map.removeLayer(this);
	        }
	        return this;
	      },
	      // @method toggle(layer?: Layer): this
	      // Opens or closes the overlay bound to layer depending on its current state.
	      // Argument may be omitted only for overlay bound to layer.
	      // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
	      toggle: function (layer) {
	        if (this._map) {
	          this.close();
	        } else {
	          if (arguments.length) {
	            this._source = layer;
	          } else {
	            layer = this._source;
	          }
	          this._prepareOpen();

	          // open the overlay on the map
	          this.openOn(layer._map);
	        }
	        return this;
	      },
	      onAdd: function (map) {
	        this._zoomAnimated = map._zoomAnimated;
	        if (!this._container) {
	          this._initLayout();
	        }
	        if (map._fadeAnimated) {
	          setOpacity(this._container, 0);
	        }
	        clearTimeout(this._removeTimeout);
	        this.getPane().appendChild(this._container);
	        this.update();
	        if (map._fadeAnimated) {
	          setOpacity(this._container, 1);
	        }
	        this.bringToFront();
	        if (this.options.interactive) {
	          addClass(this._container, 'leaflet-interactive');
	          this.addInteractiveTarget(this._container);
	        }
	      },
	      onRemove: function (map) {
	        if (map._fadeAnimated) {
	          setOpacity(this._container, 0);
	          this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
	        } else {
	          remove(this._container);
	        }
	        if (this.options.interactive) {
	          removeClass(this._container, 'leaflet-interactive');
	          this.removeInteractiveTarget(this._container);
	        }
	      },
	      // @namespace DivOverlay
	      // @method getLatLng: LatLng
	      // Returns the geographical point of the overlay.
	      getLatLng: function () {
	        return this._latlng;
	      },
	      // @method setLatLng(latlng: LatLng): this
	      // Sets the geographical point where the overlay will open.
	      setLatLng: function (latlng) {
	        this._latlng = toLatLng(latlng);
	        if (this._map) {
	          this._updatePosition();
	          this._adjustPan();
	        }
	        return this;
	      },
	      // @method getContent: String|HTMLElement
	      // Returns the content of the overlay.
	      getContent: function () {
	        return this._content;
	      },
	      // @method setContent(htmlContent: String|HTMLElement|Function): this
	      // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
	      // The function should return a `String` or `HTMLElement` to be used in the overlay.
	      setContent: function (content) {
	        this._content = content;
	        this.update();
	        return this;
	      },
	      // @method getElement: String|HTMLElement
	      // Returns the HTML container of the overlay.
	      getElement: function () {
	        return this._container;
	      },
	      // @method update: null
	      // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
	      update: function () {
	        if (!this._map) {
	          return;
	        }
	        this._container.style.visibility = 'hidden';
	        this._updateContent();
	        this._updateLayout();
	        this._updatePosition();
	        this._container.style.visibility = '';
	        this._adjustPan();
	      },
	      getEvents: function () {
	        var events = {
	          zoom: this._updatePosition,
	          viewreset: this._updatePosition
	        };
	        if (this._zoomAnimated) {
	          events.zoomanim = this._animateZoom;
	        }
	        return events;
	      },
	      // @method isOpen: Boolean
	      // Returns `true` when the overlay is visible on the map.
	      isOpen: function () {
	        return !!this._map && this._map.hasLayer(this);
	      },
	      // @method bringToFront: this
	      // Brings this overlay in front of other overlays (in the same map pane).
	      bringToFront: function () {
	        if (this._map) {
	          toFront(this._container);
	        }
	        return this;
	      },
	      // @method bringToBack: this
	      // Brings this overlay to the back of other overlays (in the same map pane).
	      bringToBack: function () {
	        if (this._map) {
	          toBack(this._container);
	        }
	        return this;
	      },
	      // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
	      _prepareOpen: function (latlng) {
	        var source = this._source;
	        if (!source._map) {
	          return false;
	        }
	        if (source instanceof FeatureGroup) {
	          source = null;
	          var layers = this._source._layers;
	          for (var id in layers) {
	            if (layers[id]._map) {
	              source = layers[id];
	              break;
	            }
	          }
	          if (!source) {
	            return false;
	          } // Unable to get source layer.

	          // set overlay source to this layer
	          this._source = source;
	        }
	        if (!latlng) {
	          if (source.getCenter) {
	            latlng = source.getCenter();
	          } else if (source.getLatLng) {
	            latlng = source.getLatLng();
	          } else if (source.getBounds) {
	            latlng = source.getBounds().getCenter();
	          } else {
	            throw new Error('Unable to get source layer LatLng.');
	          }
	        }
	        this.setLatLng(latlng);
	        if (this._map) {
	          // update the overlay (content, layout, etc...)
	          this.update();
	        }
	        return true;
	      },
	      _updateContent: function () {
	        if (!this._content) {
	          return;
	        }
	        var node = this._contentNode;
	        var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
	        if (typeof content === 'string') {
	          node.innerHTML = content;
	        } else {
	          while (node.hasChildNodes()) {
	            node.removeChild(node.firstChild);
	          }
	          node.appendChild(content);
	        }

	        // @namespace DivOverlay
	        // @section DivOverlay events
	        // @event contentupdate: Event
	        // Fired when the content of the overlay is updated
	        this.fire('contentupdate');
	      },
	      _updatePosition: function () {
	        if (!this._map) {
	          return;
	        }
	        var pos = this._map.latLngToLayerPoint(this._latlng),
	          offset = toPoint(this.options.offset),
	          anchor = this._getAnchor();
	        if (this._zoomAnimated) {
	          setPosition(this._container, pos.add(anchor));
	        } else {
	          offset = offset.add(pos).add(anchor);
	        }
	        var bottom = this._containerBottom = -offset.y,
	          left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;

	        // bottom position the overlay in case the height of the overlay changes (images loading etc)
	        this._container.style.bottom = bottom + 'px';
	        this._container.style.left = left + 'px';
	      },
	      _getAnchor: function () {
	        return [0, 0];
	      }
	    });
	    Map.include({
	      _initOverlay: function (OverlayClass, content, latlng, options) {
	        var overlay = content;
	        if (!(overlay instanceof OverlayClass)) {
	          overlay = new OverlayClass(options).setContent(content);
	        }
	        if (latlng) {
	          overlay.setLatLng(latlng);
	        }
	        return overlay;
	      }
	    });
	    Layer.include({
	      _initOverlay: function (OverlayClass, old, content, options) {
	        var overlay = content;
	        if (overlay instanceof OverlayClass) {
	          setOptions(overlay, options);
	          overlay._source = this;
	        } else {
	          overlay = old && !options ? old : new OverlayClass(options, this);
	          overlay.setContent(content);
	        }
	        return overlay;
	      }
	    });

	    /*
	     * @class Popup
	     * @inherits DivOverlay
	     * @aka L.Popup
	     * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	     * open popups while making sure that only one popup is open at one time
	     * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	     *
	     * @example
	     *
	     * If you want to just bind a popup to marker click and then open it, it's really easy:
	     *
	     * ```js
	     * marker.bindPopup(popupContent).openPopup();
	     * ```
	     * Path overlays like polylines also have a `bindPopup` method.
	     *
	     * A popup can be also standalone:
	     *
	     * ```js
	     * var popup = L.popup()
	     * 	.setLatLng(latlng)
	     * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	     * 	.openOn(map);
	     * ```
	     * or
	     * ```js
	     * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
	     * 	.openOn(map);
	     * ```
	     */

	    // @namespace Popup
	    var Popup = DivOverlay.extend({
	      // @section
	      // @aka Popup options
	      options: {
	        // @option pane: String = 'popupPane'
	        // `Map pane` where the popup will be added.
	        pane: 'popupPane',
	        // @option offset: Point = Point(0, 7)
	        // The offset of the popup position.
	        offset: [0, 7],
	        // @option maxWidth: Number = 300
	        // Max width of the popup, in pixels.
	        maxWidth: 300,
	        // @option minWidth: Number = 50
	        // Min width of the popup, in pixels.
	        minWidth: 50,
	        // @option maxHeight: Number = null
	        // If set, creates a scrollable container of the given height
	        // inside a popup if its content exceeds it.
	        // The scrollable container can be styled using the
	        // `leaflet-popup-scrolled` CSS class selector.
	        maxHeight: null,
	        // @option autoPan: Boolean = true
	        // Set it to `false` if you don't want the map to do panning animation
	        // to fit the opened popup.
	        autoPan: true,
	        // @option autoPanPaddingTopLeft: Point = null
	        // The margin between the popup and the top left corner of the map
	        // view after autopanning was performed.
	        autoPanPaddingTopLeft: null,
	        // @option autoPanPaddingBottomRight: Point = null
	        // The margin between the popup and the bottom right corner of the map
	        // view after autopanning was performed.
	        autoPanPaddingBottomRight: null,
	        // @option autoPanPadding: Point = Point(5, 5)
	        // Equivalent of setting both top left and bottom right autopan padding to the same value.
	        autoPanPadding: [5, 5],
	        // @option keepInView: Boolean = false
	        // Set it to `true` if you want to prevent users from panning the popup
	        // off of the screen while it is open.
	        keepInView: false,
	        // @option closeButton: Boolean = true
	        // Controls the presence of a close button in the popup.
	        closeButton: true,
	        // @option autoClose: Boolean = true
	        // Set it to `false` if you want to override the default behavior of
	        // the popup closing when another popup is opened.
	        autoClose: true,
	        // @option closeOnEscapeKey: Boolean = true
	        // Set it to `false` if you want to override the default behavior of
	        // the ESC key for closing of the popup.
	        closeOnEscapeKey: true,
	        // @option closeOnClick: Boolean = *
	        // Set it if you want to override the default behavior of the popup closing when user clicks
	        // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.

	        // @option className: String = ''
	        // A custom CSS class name to assign to the popup.
	        className: ''
	      },
	      // @namespace Popup
	      // @method openOn(map: Map): this
	      // Alternative to `map.openPopup(popup)`.
	      // Adds the popup to the map and closes the previous one.
	      openOn: function (map) {
	        map = arguments.length ? map : this._source._map; // experimental, not the part of public api

	        if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) {
	          map.removeLayer(map._popup);
	        }
	        map._popup = this;
	        return DivOverlay.prototype.openOn.call(this, map);
	      },
	      onAdd: function (map) {
	        DivOverlay.prototype.onAdd.call(this, map);

	        // @namespace Map
	        // @section Popup events
	        // @event popupopen: PopupEvent
	        // Fired when a popup is opened in the map
	        map.fire('popupopen', {
	          popup: this
	        });
	        if (this._source) {
	          // @namespace Layer
	          // @section Popup events
	          // @event popupopen: PopupEvent
	          // Fired when a popup bound to this layer is opened
	          this._source.fire('popupopen', {
	            popup: this
	          }, true);
	          // For non-path layers, we toggle the popup when clicking
	          // again the layer, so prevent the map to reopen it.
	          if (!(this._source instanceof Path)) {
	            this._source.on('preclick', stopPropagation);
	          }
	        }
	      },
	      onRemove: function (map) {
	        DivOverlay.prototype.onRemove.call(this, map);

	        // @namespace Map
	        // @section Popup events
	        // @event popupclose: PopupEvent
	        // Fired when a popup in the map is closed
	        map.fire('popupclose', {
	          popup: this
	        });
	        if (this._source) {
	          // @namespace Layer
	          // @section Popup events
	          // @event popupclose: PopupEvent
	          // Fired when a popup bound to this layer is closed
	          this._source.fire('popupclose', {
	            popup: this
	          }, true);
	          if (!(this._source instanceof Path)) {
	            this._source.off('preclick', stopPropagation);
	          }
	        }
	      },
	      getEvents: function () {
	        var events = DivOverlay.prototype.getEvents.call(this);
	        if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
	          events.preclick = this.close;
	        }
	        if (this.options.keepInView) {
	          events.moveend = this._adjustPan;
	        }
	        return events;
	      },
	      _initLayout: function () {
	        var prefix = 'leaflet-popup',
	          container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
	        var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
	        this._contentNode = create$1('div', prefix + '-content', wrapper);
	        disableClickPropagation(container);
	        disableScrollPropagation(this._contentNode);
	        on(container, 'contextmenu', stopPropagation);
	        this._tipContainer = create$1('div', prefix + '-tip-container', container);
	        this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	        if (this.options.closeButton) {
	          var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
	          closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
	          closeButton.setAttribute('aria-label', 'Close popup');
	          closeButton.href = '#close';
	          closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
	          on(closeButton, 'click', function (ev) {
	            preventDefault(ev);
	            this.close();
	          }, this);
	        }
	      },
	      _updateLayout: function () {
	        var container = this._contentNode,
	          style = container.style;
	        style.width = '';
	        style.whiteSpace = 'nowrap';
	        var width = container.offsetWidth;
	        width = Math.min(width, this.options.maxWidth);
	        width = Math.max(width, this.options.minWidth);
	        style.width = width + 1 + 'px';
	        style.whiteSpace = '';
	        style.height = '';
	        var height = container.offsetHeight,
	          maxHeight = this.options.maxHeight,
	          scrolledClass = 'leaflet-popup-scrolled';
	        if (maxHeight && height > maxHeight) {
	          style.height = maxHeight + 'px';
	          addClass(container, scrolledClass);
	        } else {
	          removeClass(container, scrolledClass);
	        }
	        this._containerWidth = this._container.offsetWidth;
	      },
	      _animateZoom: function (e) {
	        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
	          anchor = this._getAnchor();
	        setPosition(this._container, pos.add(anchor));
	      },
	      _adjustPan: function () {
	        if (!this.options.autoPan) {
	          return;
	        }
	        if (this._map._panAnim) {
	          this._map._panAnim.stop();
	        }

	        // We can endlessly recurse if keepInView is set and the view resets.
	        // Let's guard against that by exiting early if we're responding to our own autopan.
	        if (this._autopanning) {
	          this._autopanning = false;
	          return;
	        }
	        var map = this._map,
	          marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
	          containerHeight = this._container.offsetHeight + marginBottom,
	          containerWidth = this._containerWidth,
	          layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	        layerPos._add(getPosition(this._container));
	        var containerPos = map.layerPointToContainerPoint(layerPos),
	          padding = toPoint(this.options.autoPanPadding),
	          paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
	          paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
	          size = map.getSize(),
	          dx = 0,
	          dy = 0;
	        if (containerPos.x + containerWidth + paddingBR.x > size.x) {
	          // right
	          dx = containerPos.x + containerWidth - size.x + paddingBR.x;
	        }
	        if (containerPos.x - dx - paddingTL.x < 0) {
	          // left
	          dx = containerPos.x - paddingTL.x;
	        }
	        if (containerPos.y + containerHeight + paddingBR.y > size.y) {
	          // bottom
	          dy = containerPos.y + containerHeight - size.y + paddingBR.y;
	        }
	        if (containerPos.y - dy - paddingTL.y < 0) {
	          // top
	          dy = containerPos.y - paddingTL.y;
	        }

	        // @namespace Map
	        // @section Popup events
	        // @event autopanstart: Event
	        // Fired when the map starts autopanning when opening a popup.
	        if (dx || dy) {
	          // Track that we're autopanning, as this function will be re-ran on moveend
	          if (this.options.keepInView) {
	            this._autopanning = true;
	          }
	          map.fire('autopanstart').panBy([dx, dy]);
	        }
	      },
	      _getAnchor: function () {
	        // Where should we anchor the popup on the source layer?
	        return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	      }
	    });

	    // @namespace Popup
	    // @factory L.popup(options?: Popup options, source?: Layer)
	    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	    // @alternative
	    // @factory L.popup(latlng: LatLng, options?: Popup options)
	    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
	    var popup = function (options, source) {
	      return new Popup(options, source);
	    };

	    /* @namespace Map
	     * @section Interaction Options
	     * @option closePopupOnClick: Boolean = true
	     * Set it to `false` if you don't want popups to close when user clicks the map.
	     */
	    Map.mergeOptions({
	      closePopupOnClick: true
	    });

	    // @namespace Map
	    // @section Methods for Layers and Controls
	    Map.include({
	      // @method openPopup(popup: Popup): this
	      // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	      // @alternative
	      // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	      // Creates a popup with the specified content and options and opens it in the given point on a map.
	      openPopup: function (popup, latlng, options) {
	        this._initOverlay(Popup, popup, latlng, options).openOn(this);
	        return this;
	      },
	      // @method closePopup(popup?: Popup): this
	      // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	      closePopup: function (popup) {
	        popup = arguments.length ? popup : this._popup;
	        if (popup) {
	          popup.close();
	        }
	        return this;
	      }
	    });

	    /*
	     * @namespace Layer
	     * @section Popup methods example
	     *
	     * All layers share a set of methods convenient for binding popups to it.
	     *
	     * ```js
	     * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	     * layer.openPopup();
	     * layer.closePopup();
	     * ```
	     *
	     * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	     */

	    // @section Popup methods
	    Layer.include({
	      // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	      // Binds a popup to the layer with the passed `content` and sets up the
	      // necessary event listeners. If a `Function` is passed it will receive
	      // the layer as the first argument and should return a `String` or `HTMLElement`.
	      bindPopup: function (content, options) {
	        this._popup = this._initOverlay(Popup, this._popup, content, options);
	        if (!this._popupHandlersAdded) {
	          this.on({
	            click: this._openPopup,
	            keypress: this._onKeyPress,
	            remove: this.closePopup,
	            move: this._movePopup
	          });
	          this._popupHandlersAdded = true;
	        }
	        return this;
	      },
	      // @method unbindPopup(): this
	      // Removes the popup previously bound with `bindPopup`.
	      unbindPopup: function () {
	        if (this._popup) {
	          this.off({
	            click: this._openPopup,
	            keypress: this._onKeyPress,
	            remove: this.closePopup,
	            move: this._movePopup
	          });
	          this._popupHandlersAdded = false;
	          this._popup = null;
	        }
	        return this;
	      },
	      // @method openPopup(latlng?: LatLng): this
	      // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
	      openPopup: function (latlng) {
	        if (this._popup) {
	          if (!(this instanceof FeatureGroup)) {
	            this._popup._source = this;
	          }
	          if (this._popup._prepareOpen(latlng || this._latlng)) {
	            // open the popup on the map
	            this._popup.openOn(this._map);
	          }
	        }
	        return this;
	      },
	      // @method closePopup(): this
	      // Closes the popup bound to this layer if it is open.
	      closePopup: function () {
	        if (this._popup) {
	          this._popup.close();
	        }
	        return this;
	      },
	      // @method togglePopup(): this
	      // Opens or closes the popup bound to this layer depending on its current state.
	      togglePopup: function () {
	        if (this._popup) {
	          this._popup.toggle(this);
	        }
	        return this;
	      },
	      // @method isPopupOpen(): boolean
	      // Returns `true` if the popup bound to this layer is currently open.
	      isPopupOpen: function () {
	        return this._popup ? this._popup.isOpen() : false;
	      },
	      // @method setPopupContent(content: String|HTMLElement|Popup): this
	      // Sets the content of the popup bound to this layer.
	      setPopupContent: function (content) {
	        if (this._popup) {
	          this._popup.setContent(content);
	        }
	        return this;
	      },
	      // @method getPopup(): Popup
	      // Returns the popup bound to this layer.
	      getPopup: function () {
	        return this._popup;
	      },
	      _openPopup: function (e) {
	        if (!this._popup || !this._map) {
	          return;
	        }
	        // prevent map click
	        stop(e);
	        var target = e.layer || e.target;
	        if (this._popup._source === target && !(target instanceof Path)) {
	          // treat it like a marker and figure out
	          // if we should toggle it open/closed
	          if (this._map.hasLayer(this._popup)) {
	            this.closePopup();
	          } else {
	            this.openPopup(e.latlng);
	          }
	          return;
	        }
	        this._popup._source = target;
	        this.openPopup(e.latlng);
	      },
	      _movePopup: function (e) {
	        this._popup.setLatLng(e.latlng);
	      },
	      _onKeyPress: function (e) {
	        if (e.originalEvent.keyCode === 13) {
	          this._openPopup(e);
	        }
	      }
	    });

	    /*
	     * @class Tooltip
	     * @inherits DivOverlay
	     * @aka L.Tooltip
	     * Used to display small texts on top of map layers.
	     *
	     * @example
	     * If you want to just bind a tooltip to marker:
	     *
	     * ```js
	     * marker.bindTooltip("my tooltip text").openTooltip();
	     * ```
	     * Path overlays like polylines also have a `bindTooltip` method.
	     *
	     * A tooltip can be also standalone:
	     *
	     * ```js
	     * var tooltip = L.tooltip()
	     * 	.setLatLng(latlng)
	     * 	.setContent('Hello world!<br />This is a nice tooltip.')
	     * 	.addTo(map);
	     * ```
	     * or
	     * ```js
	     * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
	     * 	.addTo(map);
	     * ```
	     *
	     *
	     * Note about tooltip offset. Leaflet takes two options in consideration
	     * for computing tooltip offsetting:
	     * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	     *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	     *   move it to the bottom. Negatives will move to the left and top.
	     * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	     *   should adapt this value if you use a custom icon.
	     */

	    // @namespace Tooltip
	    var Tooltip = DivOverlay.extend({
	      // @section
	      // @aka Tooltip options
	      options: {
	        // @option pane: String = 'tooltipPane'
	        // `Map pane` where the tooltip will be added.
	        pane: 'tooltipPane',
	        // @option offset: Point = Point(0, 0)
	        // Optional offset of the tooltip position.
	        offset: [0, 0],
	        // @option direction: String = 'auto'
	        // Direction where to open the tooltip. Possible values are: `right`, `left`,
	        // `top`, `bottom`, `center`, `auto`.
	        // `auto` will dynamically switch between `right` and `left` according to the tooltip
	        // position on the map.
	        direction: 'auto',
	        // @option permanent: Boolean = false
	        // Whether to open the tooltip permanently or only on mouseover.
	        permanent: false,
	        // @option sticky: Boolean = false
	        // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
	        sticky: false,
	        // @option opacity: Number = 0.9
	        // Tooltip container opacity.
	        opacity: 0.9
	      },
	      onAdd: function (map) {
	        DivOverlay.prototype.onAdd.call(this, map);
	        this.setOpacity(this.options.opacity);

	        // @namespace Map
	        // @section Tooltip events
	        // @event tooltipopen: TooltipEvent
	        // Fired when a tooltip is opened in the map.
	        map.fire('tooltipopen', {
	          tooltip: this
	        });
	        if (this._source) {
	          this.addEventParent(this._source);

	          // @namespace Layer
	          // @section Tooltip events
	          // @event tooltipopen: TooltipEvent
	          // Fired when a tooltip bound to this layer is opened.
	          this._source.fire('tooltipopen', {
	            tooltip: this
	          }, true);
	        }
	      },
	      onRemove: function (map) {
	        DivOverlay.prototype.onRemove.call(this, map);

	        // @namespace Map
	        // @section Tooltip events
	        // @event tooltipclose: TooltipEvent
	        // Fired when a tooltip in the map is closed.
	        map.fire('tooltipclose', {
	          tooltip: this
	        });
	        if (this._source) {
	          this.removeEventParent(this._source);

	          // @namespace Layer
	          // @section Tooltip events
	          // @event tooltipclose: TooltipEvent
	          // Fired when a tooltip bound to this layer is closed.
	          this._source.fire('tooltipclose', {
	            tooltip: this
	          }, true);
	        }
	      },
	      getEvents: function () {
	        var events = DivOverlay.prototype.getEvents.call(this);
	        if (!this.options.permanent) {
	          events.preclick = this.close;
	        }
	        return events;
	      },
	      _initLayout: function () {
	        var prefix = 'leaflet-tooltip',
	          className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	        this._contentNode = this._container = create$1('div', className);
	        this._container.setAttribute('role', 'tooltip');
	        this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
	      },
	      _updateLayout: function () {},
	      _adjustPan: function () {},
	      _setPosition: function (pos) {
	        var subX,
	          subY,
	          map = this._map,
	          container = this._container,
	          centerPoint = map.latLngToContainerPoint(map.getCenter()),
	          tooltipPoint = map.layerPointToContainerPoint(pos),
	          direction = this.options.direction,
	          tooltipWidth = container.offsetWidth,
	          tooltipHeight = container.offsetHeight,
	          offset = toPoint(this.options.offset),
	          anchor = this._getAnchor();
	        if (direction === 'top') {
	          subX = tooltipWidth / 2;
	          subY = tooltipHeight;
	        } else if (direction === 'bottom') {
	          subX = tooltipWidth / 2;
	          subY = 0;
	        } else if (direction === 'center') {
	          subX = tooltipWidth / 2;
	          subY = tooltipHeight / 2;
	        } else if (direction === 'right') {
	          subX = 0;
	          subY = tooltipHeight / 2;
	        } else if (direction === 'left') {
	          subX = tooltipWidth;
	          subY = tooltipHeight / 2;
	        } else if (tooltipPoint.x < centerPoint.x) {
	          direction = 'right';
	          subX = 0;
	          subY = tooltipHeight / 2;
	        } else {
	          direction = 'left';
	          subX = tooltipWidth + (offset.x + anchor.x) * 2;
	          subY = tooltipHeight / 2;
	        }
	        pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
	        removeClass(container, 'leaflet-tooltip-right');
	        removeClass(container, 'leaflet-tooltip-left');
	        removeClass(container, 'leaflet-tooltip-top');
	        removeClass(container, 'leaflet-tooltip-bottom');
	        addClass(container, 'leaflet-tooltip-' + direction);
	        setPosition(container, pos);
	      },
	      _updatePosition: function () {
	        var pos = this._map.latLngToLayerPoint(this._latlng);
	        this._setPosition(pos);
	      },
	      setOpacity: function (opacity) {
	        this.options.opacity = opacity;
	        if (this._container) {
	          setOpacity(this._container, opacity);
	        }
	      },
	      _animateZoom: function (e) {
	        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
	        this._setPosition(pos);
	      },
	      _getAnchor: function () {
	        // Where should we anchor the tooltip on the source layer?
	        return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	      }
	    });

	    // @namespace Tooltip
	    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
	    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	    // @alternative
	    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
	    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
	    var tooltip = function (options, source) {
	      return new Tooltip(options, source);
	    };

	    // @namespace Map
	    // @section Methods for Layers and Controls
	    Map.include({
	      // @method openTooltip(tooltip: Tooltip): this
	      // Opens the specified tooltip.
	      // @alternative
	      // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	      // Creates a tooltip with the specified content and options and open it.
	      openTooltip: function (tooltip, latlng, options) {
	        this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
	        return this;
	      },
	      // @method closeTooltip(tooltip: Tooltip): this
	      // Closes the tooltip given as parameter.
	      closeTooltip: function (tooltip) {
	        tooltip.close();
	        return this;
	      }
	    });

	    /*
	     * @namespace Layer
	     * @section Tooltip methods example
	     *
	     * All layers share a set of methods convenient for binding tooltips to it.
	     *
	     * ```js
	     * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	     * layer.openTooltip();
	     * layer.closeTooltip();
	     * ```
	     */

	    // @section Tooltip methods
	    Layer.include({
	      // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	      // Binds a tooltip to the layer with the passed `content` and sets up the
	      // necessary event listeners. If a `Function` is passed it will receive
	      // the layer as the first argument and should return a `String` or `HTMLElement`.
	      bindTooltip: function (content, options) {
	        if (this._tooltip && this.isTooltipOpen()) {
	          this.unbindTooltip();
	        }
	        this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
	        this._initTooltipInteractions();
	        if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
	          this.openTooltip();
	        }
	        return this;
	      },
	      // @method unbindTooltip(): this
	      // Removes the tooltip previously bound with `bindTooltip`.
	      unbindTooltip: function () {
	        if (this._tooltip) {
	          this._initTooltipInteractions(true);
	          this.closeTooltip();
	          this._tooltip = null;
	        }
	        return this;
	      },
	      _initTooltipInteractions: function (remove) {
	        if (!remove && this._tooltipHandlersAdded) {
	          return;
	        }
	        var onOff = remove ? 'off' : 'on',
	          events = {
	            remove: this.closeTooltip,
	            move: this._moveTooltip
	          };
	        if (!this._tooltip.options.permanent) {
	          events.mouseover = this._openTooltip;
	          events.mouseout = this.closeTooltip;
	          events.click = this._openTooltip;
	          if (this._map) {
	            this._addFocusListeners();
	          } else {
	            events.add = this._addFocusListeners;
	          }
	        } else {
	          events.add = this._openTooltip;
	        }
	        if (this._tooltip.options.sticky) {
	          events.mousemove = this._moveTooltip;
	        }
	        this[onOff](events);
	        this._tooltipHandlersAdded = !remove;
	      },
	      // @method openTooltip(latlng?: LatLng): this
	      // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
	      openTooltip: function (latlng) {
	        if (this._tooltip) {
	          if (!(this instanceof FeatureGroup)) {
	            this._tooltip._source = this;
	          }
	          if (this._tooltip._prepareOpen(latlng)) {
	            // open the tooltip on the map
	            this._tooltip.openOn(this._map);
	            if (this.getElement) {
	              this._setAriaDescribedByOnLayer(this);
	            } else if (this.eachLayer) {
	              this.eachLayer(this._setAriaDescribedByOnLayer, this);
	            }
	          }
	        }
	        return this;
	      },
	      // @method closeTooltip(): this
	      // Closes the tooltip bound to this layer if it is open.
	      closeTooltip: function () {
	        if (this._tooltip) {
	          return this._tooltip.close();
	        }
	      },
	      // @method toggleTooltip(): this
	      // Opens or closes the tooltip bound to this layer depending on its current state.
	      toggleTooltip: function () {
	        if (this._tooltip) {
	          this._tooltip.toggle(this);
	        }
	        return this;
	      },
	      // @method isTooltipOpen(): boolean
	      // Returns `true` if the tooltip bound to this layer is currently open.
	      isTooltipOpen: function () {
	        return this._tooltip.isOpen();
	      },
	      // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	      // Sets the content of the tooltip bound to this layer.
	      setTooltipContent: function (content) {
	        if (this._tooltip) {
	          this._tooltip.setContent(content);
	        }
	        return this;
	      },
	      // @method getTooltip(): Tooltip
	      // Returns the tooltip bound to this layer.
	      getTooltip: function () {
	        return this._tooltip;
	      },
	      _addFocusListeners: function () {
	        if (this.getElement) {
	          this._addFocusListenersOnLayer(this);
	        } else if (this.eachLayer) {
	          this.eachLayer(this._addFocusListenersOnLayer, this);
	        }
	      },
	      _addFocusListenersOnLayer: function (layer) {
	        var el = typeof layer.getElement === 'function' && layer.getElement();
	        if (el) {
	          on(el, 'focus', function () {
	            this._tooltip._source = layer;
	            this.openTooltip();
	          }, this);
	          on(el, 'blur', this.closeTooltip, this);
	        }
	      },
	      _setAriaDescribedByOnLayer: function (layer) {
	        var el = typeof layer.getElement === 'function' && layer.getElement();
	        if (el) {
	          el.setAttribute('aria-describedby', this._tooltip._container.id);
	        }
	      },
	      _openTooltip: function (e) {
	        if (!this._tooltip || !this._map) {
	          return;
	        }

	        // If the map is moving, we will show the tooltip after it's done.
	        if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
	          this._openOnceFlag = true;
	          var that = this;
	          this._map.once('moveend', function () {
	            that._openOnceFlag = false;
	            that._openTooltip(e);
	          });
	          return;
	        }
	        this._tooltip._source = e.layer || e.target;
	        this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
	      },
	      _moveTooltip: function (e) {
	        var latlng = e.latlng,
	          containerPoint,
	          layerPoint;
	        if (this._tooltip.options.sticky && e.originalEvent) {
	          containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
	          layerPoint = this._map.containerPointToLayerPoint(containerPoint);
	          latlng = this._map.layerPointToLatLng(layerPoint);
	        }
	        this._tooltip.setLatLng(latlng);
	      }
	    });

	    /*
	     * @class DivIcon
	     * @aka L.DivIcon
	     * @inherits Icon
	     *
	     * Represents a lightweight icon for markers that uses a simple `<div>`
	     * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	     *
	     * @example
	     * ```js
	     * var myIcon = L.divIcon({className: 'my-div-icon'});
	     * // you can set .my-div-icon styles in CSS
	     *
	     * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	     * ```
	     *
	     * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	     */

	    var DivIcon = Icon.extend({
	      options: {
	        // @section
	        // @aka DivIcon options
	        iconSize: [12, 12],
	        // also can be set through CSS

	        // iconAnchor: (Point),
	        // popupAnchor: (Point),

	        // @option html: String|HTMLElement = ''
	        // Custom HTML code to put inside the div element, empty by default. Alternatively,
	        // an instance of `HTMLElement`.
	        html: false,
	        // @option bgPos: Point = [0, 0]
	        // Optional relative position of the background, in pixels
	        bgPos: null,
	        className: 'leaflet-div-icon'
	      },
	      createIcon: function (oldIcon) {
	        var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'),
	          options = this.options;
	        if (options.html instanceof Element) {
	          empty(div);
	          div.appendChild(options.html);
	        } else {
	          div.innerHTML = options.html !== false ? options.html : '';
	        }
	        if (options.bgPos) {
	          var bgPos = toPoint(options.bgPos);
	          div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
	        }
	        this._setIconStyles(div, 'icon');
	        return div;
	      },
	      createShadow: function () {
	        return null;
	      }
	    });

	    // @factory L.divIcon(options: DivIcon options)
	    // Creates a `DivIcon` instance with the given options.
	    function divIcon(options) {
	      return new DivIcon(options);
	    }
	    Icon.Default = IconDefault;

	    /*
	     * @class GridLayer
	     * @inherits Layer
	     * @aka L.GridLayer
	     *
	     * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	     * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	     *
	     *
	     * @section Synchronous usage
	     * @example
	     *
	     * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	     *
	     * ```js
	     * var CanvasLayer = L.GridLayer.extend({
	     *     createTile: function(coords){
	     *         // create a <canvas> element for drawing
	     *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	     *
	     *         // setup tile width and height according to the options
	     *         var size = this.getTileSize();
	     *         tile.width = size.x;
	     *         tile.height = size.y;
	     *
	     *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	     *         var ctx = tile.getContext('2d');
	     *
	     *         // return the tile so it can be rendered on screen
	     *         return tile;
	     *     }
	     * });
	     * ```
	     *
	     * @section Asynchronous usage
	     * @example
	     *
	     * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	     *
	     * ```js
	     * var CanvasLayer = L.GridLayer.extend({
	     *     createTile: function(coords, done){
	     *         var error;
	     *
	     *         // create a <canvas> element for drawing
	     *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	     *
	     *         // setup tile width and height according to the options
	     *         var size = this.getTileSize();
	     *         tile.width = size.x;
	     *         tile.height = size.y;
	     *
	     *         // draw something asynchronously and pass the tile to the done() callback
	     *         setTimeout(function() {
	     *             done(error, tile);
	     *         }, 1000);
	     *
	     *         return tile;
	     *     }
	     * });
	     * ```
	     *
	     * @section
	     */

	    var GridLayer = Layer.extend({
	      // @section
	      // @aka GridLayer options
	      options: {
	        // @option tileSize: Number|Point = 256
	        // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
	        tileSize: 256,
	        // @option opacity: Number = 1.0
	        // Opacity of the tiles. Can be used in the `createTile()` function.
	        opacity: 1,
	        // @option updateWhenIdle: Boolean = (depends)
	        // Load new tiles only when panning ends.
	        // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
	        // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
	        // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
	        updateWhenIdle: Browser.mobile,
	        // @option updateWhenZooming: Boolean = true
	        // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
	        updateWhenZooming: true,
	        // @option updateInterval: Number = 200
	        // Tiles will not update more than once every `updateInterval` milliseconds when panning.
	        updateInterval: 200,
	        // @option zIndex: Number = 1
	        // The explicit zIndex of the tile layer.
	        zIndex: 1,
	        // @option bounds: LatLngBounds = undefined
	        // If set, tiles will only be loaded inside the set `LatLngBounds`.
	        bounds: null,
	        // @option minZoom: Number = 0
	        // The minimum zoom level down to which this layer will be displayed (inclusive).
	        minZoom: 0,
	        // @option maxZoom: Number = undefined
	        // The maximum zoom level up to which this layer will be displayed (inclusive).
	        maxZoom: undefined,
	        // @option maxNativeZoom: Number = undefined
	        // Maximum zoom number the tile source has available. If it is specified,
	        // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
	        // from `maxNativeZoom` level and auto-scaled.
	        maxNativeZoom: undefined,
	        // @option minNativeZoom: Number = undefined
	        // Minimum zoom number the tile source has available. If it is specified,
	        // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
	        // from `minNativeZoom` level and auto-scaled.
	        minNativeZoom: undefined,
	        // @option noWrap: Boolean = false
	        // Whether the layer is wrapped around the antimeridian. If `true`, the
	        // GridLayer will only be displayed once at low zoom levels. Has no
	        // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
	        // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
	        // tiles outside the CRS limits.
	        noWrap: false,
	        // @option pane: String = 'tilePane'
	        // `Map pane` where the grid layer will be added.
	        pane: 'tilePane',
	        // @option className: String = ''
	        // A custom class name to assign to the tile layer. Empty by default.
	        className: '',
	        // @option keepBuffer: Number = 2
	        // When panning the map, keep this many rows and columns of tiles before unloading them.
	        keepBuffer: 2
	      },
	      initialize: function (options) {
	        setOptions(this, options);
	      },
	      onAdd: function () {
	        this._initContainer();
	        this._levels = {};
	        this._tiles = {};
	        this._resetView(); // implicit _update() call
	      },
	      beforeAdd: function (map) {
	        map._addZoomLimit(this);
	      },
	      onRemove: function (map) {
	        this._removeAllTiles();
	        remove(this._container);
	        map._removeZoomLimit(this);
	        this._container = null;
	        this._tileZoom = undefined;
	      },
	      // @method bringToFront: this
	      // Brings the tile layer to the top of all tile layers.
	      bringToFront: function () {
	        if (this._map) {
	          toFront(this._container);
	          this._setAutoZIndex(Math.max);
	        }
	        return this;
	      },
	      // @method bringToBack: this
	      // Brings the tile layer to the bottom of all tile layers.
	      bringToBack: function () {
	        if (this._map) {
	          toBack(this._container);
	          this._setAutoZIndex(Math.min);
	        }
	        return this;
	      },
	      // @method getContainer: HTMLElement
	      // Returns the HTML element that contains the tiles for this layer.
	      getContainer: function () {
	        return this._container;
	      },
	      // @method setOpacity(opacity: Number): this
	      // Changes the [opacity](#gridlayer-opacity) of the grid layer.
	      setOpacity: function (opacity) {
	        this.options.opacity = opacity;
	        this._updateOpacity();
	        return this;
	      },
	      // @method setZIndex(zIndex: Number): this
	      // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	      setZIndex: function (zIndex) {
	        this.options.zIndex = zIndex;
	        this._updateZIndex();
	        return this;
	      },
	      // @method isLoading: Boolean
	      // Returns `true` if any tile in the grid layer has not finished loading.
	      isLoading: function () {
	        return this._loading;
	      },
	      // @method redraw: this
	      // Causes the layer to clear all the tiles and request them again.
	      redraw: function () {
	        if (this._map) {
	          this._removeAllTiles();
	          var tileZoom = this._clampZoom(this._map.getZoom());
	          if (tileZoom !== this._tileZoom) {
	            this._tileZoom = tileZoom;
	            this._updateLevels();
	          }
	          this._update();
	        }
	        return this;
	      },
	      getEvents: function () {
	        var events = {
	          viewprereset: this._invalidateAll,
	          viewreset: this._resetView,
	          zoom: this._resetView,
	          moveend: this._onMoveEnd
	        };
	        if (!this.options.updateWhenIdle) {
	          // update tiles on move, but not more often than once per given interval
	          if (!this._onMove) {
	            this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
	          }
	          events.move = this._onMove;
	        }
	        if (this._zoomAnimated) {
	          events.zoomanim = this._animateZoom;
	        }
	        return events;
	      },
	      // @section Extension methods
	      // Layers extending `GridLayer` shall reimplement the following method.
	      // @method createTile(coords: Object, done?: Function): HTMLElement
	      // Called only internally, must be overridden by classes extending `GridLayer`.
	      // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	      // is specified, it must be called when the tile has finished loading and drawing.
	      createTile: function () {
	        return document.createElement('div');
	      },
	      // @section
	      // @method getTileSize: Point
	      // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	      getTileSize: function () {
	        var s = this.options.tileSize;
	        return s instanceof Point ? s : new Point(s, s);
	      },
	      _updateZIndex: function () {
	        if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	          this._container.style.zIndex = this.options.zIndex;
	        }
	      },
	      _setAutoZIndex: function (compare) {
	        // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)

	        var layers = this.getPane().children,
	          edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min

	        for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	          zIndex = layers[i].style.zIndex;
	          if (layers[i] !== this._container && zIndex) {
	            edgeZIndex = compare(edgeZIndex, +zIndex);
	          }
	        }
	        if (isFinite(edgeZIndex)) {
	          this.options.zIndex = edgeZIndex + compare(-1, 1);
	          this._updateZIndex();
	        }
	      },
	      _updateOpacity: function () {
	        if (!this._map) {
	          return;
	        }

	        // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
	        if (Browser.ielt9) {
	          return;
	        }
	        setOpacity(this._container, this.options.opacity);
	        var now = +new Date(),
	          nextFrame = false,
	          willPrune = false;
	        for (var key in this._tiles) {
	          var tile = this._tiles[key];
	          if (!tile.current || !tile.loaded) {
	            continue;
	          }
	          var fade = Math.min(1, (now - tile.loaded) / 200);
	          setOpacity(tile.el, fade);
	          if (fade < 1) {
	            nextFrame = true;
	          } else {
	            if (tile.active) {
	              willPrune = true;
	            } else {
	              this._onOpaqueTile(tile);
	            }
	            tile.active = true;
	          }
	        }
	        if (willPrune && !this._noPrune) {
	          this._pruneTiles();
	        }
	        if (nextFrame) {
	          cancelAnimFrame(this._fadeFrame);
	          this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	        }
	      },
	      _onOpaqueTile: falseFn,
	      _initContainer: function () {
	        if (this._container) {
	          return;
	        }
	        this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
	        this._updateZIndex();
	        if (this.options.opacity < 1) {
	          this._updateOpacity();
	        }
	        this.getPane().appendChild(this._container);
	      },
	      _updateLevels: function () {
	        var zoom = this._tileZoom,
	          maxZoom = this.options.maxZoom;
	        if (zoom === undefined) {
	          return undefined;
	        }
	        for (var z in this._levels) {
	          z = Number(z);
	          if (this._levels[z].el.children.length || z === zoom) {
	            this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
	            this._onUpdateLevel(z);
	          } else {
	            remove(this._levels[z].el);
	            this._removeTilesAtZoom(z);
	            this._onRemoveLevel(z);
	            delete this._levels[z];
	          }
	        }
	        var level = this._levels[zoom],
	          map = this._map;
	        if (!level) {
	          level = this._levels[zoom] = {};
	          level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
	          level.el.style.zIndex = maxZoom;
	          level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
	          level.zoom = zoom;
	          this._setZoomTransform(level, map.getCenter(), map.getZoom());

	          // force the browser to consider the newly added element for transition
	          falseFn(level.el.offsetWidth);
	          this._onCreateLevel(level);
	        }
	        this._level = level;
	        return level;
	      },
	      _onUpdateLevel: falseFn,
	      _onRemoveLevel: falseFn,
	      _onCreateLevel: falseFn,
	      _pruneTiles: function () {
	        if (!this._map) {
	          return;
	        }
	        var key, tile;
	        var zoom = this._map.getZoom();
	        if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
	          this._removeAllTiles();
	          return;
	        }
	        for (key in this._tiles) {
	          tile = this._tiles[key];
	          tile.retain = tile.current;
	        }
	        for (key in this._tiles) {
	          tile = this._tiles[key];
	          if (tile.current && !tile.active) {
	            var coords = tile.coords;
	            if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
	              this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
	            }
	          }
	        }
	        for (key in this._tiles) {
	          if (!this._tiles[key].retain) {
	            this._removeTile(key);
	          }
	        }
	      },
	      _removeTilesAtZoom: function (zoom) {
	        for (var key in this._tiles) {
	          if (this._tiles[key].coords.z !== zoom) {
	            continue;
	          }
	          this._removeTile(key);
	        }
	      },
	      _removeAllTiles: function () {
	        for (var key in this._tiles) {
	          this._removeTile(key);
	        }
	      },
	      _invalidateAll: function () {
	        for (var z in this._levels) {
	          remove(this._levels[z].el);
	          this._onRemoveLevel(Number(z));
	          delete this._levels[z];
	        }
	        this._removeAllTiles();
	        this._tileZoom = undefined;
	      },
	      _retainParent: function (x, y, z, minZoom) {
	        var x2 = Math.floor(x / 2),
	          y2 = Math.floor(y / 2),
	          z2 = z - 1,
	          coords2 = new Point(+x2, +y2);
	        coords2.z = +z2;
	        var key = this._tileCoordsToKey(coords2),
	          tile = this._tiles[key];
	        if (tile && tile.active) {
	          tile.retain = true;
	          return true;
	        } else if (tile && tile.loaded) {
	          tile.retain = true;
	        }
	        if (z2 > minZoom) {
	          return this._retainParent(x2, y2, z2, minZoom);
	        }
	        return false;
	      },
	      _retainChildren: function (x, y, z, maxZoom) {
	        for (var i = 2 * x; i < 2 * x + 2; i++) {
	          for (var j = 2 * y; j < 2 * y + 2; j++) {
	            var coords = new Point(i, j);
	            coords.z = z + 1;
	            var key = this._tileCoordsToKey(coords),
	              tile = this._tiles[key];
	            if (tile && tile.active) {
	              tile.retain = true;
	              continue;
	            } else if (tile && tile.loaded) {
	              tile.retain = true;
	            }
	            if (z + 1 < maxZoom) {
	              this._retainChildren(i, j, z + 1, maxZoom);
	            }
	          }
	        }
	      },
	      _resetView: function (e) {
	        var animating = e && (e.pinch || e.flyTo);
	        this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	      },
	      _animateZoom: function (e) {
	        this._setView(e.center, e.zoom, true, e.noUpdate);
	      },
	      _clampZoom: function (zoom) {
	        var options = this.options;
	        if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
	          return options.minNativeZoom;
	        }
	        if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
	          return options.maxNativeZoom;
	        }
	        return zoom;
	      },
	      _setView: function (center, zoom, noPrune, noUpdate) {
	        var tileZoom = Math.round(zoom);
	        if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) {
	          tileZoom = undefined;
	        } else {
	          tileZoom = this._clampZoom(tileZoom);
	        }
	        var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
	        if (!noUpdate || tileZoomChanged) {
	          this._tileZoom = tileZoom;
	          if (this._abortLoading) {
	            this._abortLoading();
	          }
	          this._updateLevels();
	          this._resetGrid();
	          if (tileZoom !== undefined) {
	            this._update(center);
	          }
	          if (!noPrune) {
	            this._pruneTiles();
	          }

	          // Flag to prevent _updateOpacity from pruning tiles during
	          // a zoom anim or a pinch gesture
	          this._noPrune = !!noPrune;
	        }
	        this._setZoomTransforms(center, zoom);
	      },
	      _setZoomTransforms: function (center, zoom) {
	        for (var i in this._levels) {
	          this._setZoomTransform(this._levels[i], center, zoom);
	        }
	      },
	      _setZoomTransform: function (level, center, zoom) {
	        var scale = this._map.getZoomScale(zoom, level.zoom),
	          translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	        if (Browser.any3d) {
	          setTransform(level.el, translate, scale);
	        } else {
	          setPosition(level.el, translate);
	        }
	      },
	      _resetGrid: function () {
	        var map = this._map,
	          crs = map.options.crs,
	          tileSize = this._tileSize = this.getTileSize(),
	          tileZoom = this._tileZoom;
	        var bounds = this._map.getPixelWorldBounds(this._tileZoom);
	        if (bounds) {
	          this._globalTileRange = this._pxBoundsToTileRange(bounds);
	        }
	        this._wrapX = crs.wrapLng && !this.options.noWrap && [Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x), Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)];
	        this._wrapY = crs.wrapLat && !this.options.noWrap && [Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x), Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)];
	      },
	      _onMoveEnd: function () {
	        if (!this._map || this._map._animatingZoom) {
	          return;
	        }
	        this._update();
	      },
	      _getTiledPixelBounds: function (center) {
	        var map = this._map,
	          mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
	          scale = map.getZoomScale(mapZoom, this._tileZoom),
	          pixelCenter = map.project(center, this._tileZoom).floor(),
	          halfSize = map.getSize().divideBy(scale * 2);
	        return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	      },
	      // Private method to load tiles in the grid's active zoom level according to map bounds
	      _update: function (center) {
	        var map = this._map;
	        if (!map) {
	          return;
	        }
	        var zoom = this._clampZoom(map.getZoom());
	        if (center === undefined) {
	          center = map.getCenter();
	        }
	        if (this._tileZoom === undefined) {
	          return;
	        } // if out of minzoom/maxzoom

	        var pixelBounds = this._getTiledPixelBounds(center),
	          tileRange = this._pxBoundsToTileRange(pixelBounds),
	          tileCenter = tileRange.getCenter(),
	          queue = [],
	          margin = this.options.keepBuffer,
	          noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]), tileRange.getTopRight().add([margin, -margin]));

	        // Sanity check: panic if the tile range contains Infinity somewhere.
	        if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) {
	          throw new Error('Attempted to load an infinite number of tiles');
	        }
	        for (var key in this._tiles) {
	          var c = this._tiles[key].coords;
	          if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
	            this._tiles[key].current = false;
	          }
	        }

	        // _update just loads more tiles. If the tile zoom level differs too much
	        // from the map's, let _setView reset levels and prune old tiles.
	        if (Math.abs(zoom - this._tileZoom) > 1) {
	          this._setView(center, zoom);
	          return;
	        }

	        // create a queue of coordinates to load tiles from
	        for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
	          for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
	            var coords = new Point(i, j);
	            coords.z = this._tileZoom;
	            if (!this._isValidTile(coords)) {
	              continue;
	            }
	            var tile = this._tiles[this._tileCoordsToKey(coords)];
	            if (tile) {
	              tile.current = true;
	            } else {
	              queue.push(coords);
	            }
	          }
	        }

	        // sort tile queue to load tiles in order of their distance to center
	        queue.sort(function (a, b) {
	          return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
	        });
	        if (queue.length !== 0) {
	          // if it's the first batch of tiles to load
	          if (!this._loading) {
	            this._loading = true;
	            // @event loading: Event
	            // Fired when the grid layer starts loading tiles.
	            this.fire('loading');
	          }

	          // create DOM fragment to append tiles in one batch
	          var fragment = document.createDocumentFragment();
	          for (i = 0; i < queue.length; i++) {
	            this._addTile(queue[i], fragment);
	          }
	          this._level.el.appendChild(fragment);
	        }
	      },
	      _isValidTile: function (coords) {
	        var crs = this._map.options.crs;
	        if (!crs.infinite) {
	          // don't load tile if it's out of bounds and not wrapped
	          var bounds = this._globalTileRange;
	          if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) {
	            return false;
	          }
	        }
	        if (!this.options.bounds) {
	          return true;
	        }

	        // don't load tile if it doesn't intersect the bounds in options
	        var tileBounds = this._tileCoordsToBounds(coords);
	        return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
	      },
	      _keyToBounds: function (key) {
	        return this._tileCoordsToBounds(this._keyToTileCoords(key));
	      },
	      _tileCoordsToNwSe: function (coords) {
	        var map = this._map,
	          tileSize = this.getTileSize(),
	          nwPoint = coords.scaleBy(tileSize),
	          sePoint = nwPoint.add(tileSize),
	          nw = map.unproject(nwPoint, coords.z),
	          se = map.unproject(sePoint, coords.z);
	        return [nw, se];
	      },
	      // converts tile coordinates to its geographical bounds
	      _tileCoordsToBounds: function (coords) {
	        var bp = this._tileCoordsToNwSe(coords),
	          bounds = new LatLngBounds(bp[0], bp[1]);
	        if (!this.options.noWrap) {
	          bounds = this._map.wrapLatLngBounds(bounds);
	        }
	        return bounds;
	      },
	      // converts tile coordinates to key for the tile cache
	      _tileCoordsToKey: function (coords) {
	        return coords.x + ':' + coords.y + ':' + coords.z;
	      },
	      // converts tile cache key to coordinates
	      _keyToTileCoords: function (key) {
	        var k = key.split(':'),
	          coords = new Point(+k[0], +k[1]);
	        coords.z = +k[2];
	        return coords;
	      },
	      _removeTile: function (key) {
	        var tile = this._tiles[key];
	        if (!tile) {
	          return;
	        }
	        remove(tile.el);
	        delete this._tiles[key];

	        // @event tileunload: TileEvent
	        // Fired when a tile is removed (e.g. when a tile goes off the screen).
	        this.fire('tileunload', {
	          tile: tile.el,
	          coords: this._keyToTileCoords(key)
	        });
	      },
	      _initTile: function (tile) {
	        addClass(tile, 'leaflet-tile');
	        var tileSize = this.getTileSize();
	        tile.style.width = tileSize.x + 'px';
	        tile.style.height = tileSize.y + 'px';
	        tile.onselectstart = falseFn;
	        tile.onmousemove = falseFn;

	        // update opacity on tiles in IE7-8 because of filter inheritance problems
	        if (Browser.ielt9 && this.options.opacity < 1) {
	          setOpacity(tile, this.options.opacity);
	        }
	      },
	      _addTile: function (coords, container) {
	        var tilePos = this._getTilePos(coords),
	          key = this._tileCoordsToKey(coords);
	        var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	        this._initTile(tile);

	        // if createTile is defined with a second argument ("done" callback),
	        // we know that tile is async and will be ready later; otherwise
	        if (this.createTile.length < 2) {
	          // mark tile as ready, but delay one frame for opacity animation to happen
	          requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
	        }
	        setPosition(tile, tilePos);

	        // save tile in cache
	        this._tiles[key] = {
	          el: tile,
	          coords: coords,
	          current: true
	        };
	        container.appendChild(tile);
	        // @event tileloadstart: TileEvent
	        // Fired when a tile is requested and starts loading.
	        this.fire('tileloadstart', {
	          tile: tile,
	          coords: coords
	        });
	      },
	      _tileReady: function (coords, err, tile) {
	        if (err) {
	          // @event tileerror: TileErrorEvent
	          // Fired when there is an error loading a tile.
	          this.fire('tileerror', {
	            error: err,
	            tile: tile,
	            coords: coords
	          });
	        }
	        var key = this._tileCoordsToKey(coords);
	        tile = this._tiles[key];
	        if (!tile) {
	          return;
	        }
	        tile.loaded = +new Date();
	        if (this._map._fadeAnimated) {
	          setOpacity(tile.el, 0);
	          cancelAnimFrame(this._fadeFrame);
	          this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	        } else {
	          tile.active = true;
	          this._pruneTiles();
	        }
	        if (!err) {
	          addClass(tile.el, 'leaflet-tile-loaded');

	          // @event tileload: TileEvent
	          // Fired when a tile loads.
	          this.fire('tileload', {
	            tile: tile.el,
	            coords: coords
	          });
	        }
	        if (this._noTilesToLoad()) {
	          this._loading = false;
	          // @event load: Event
	          // Fired when the grid layer loaded all visible tiles.
	          this.fire('load');
	          if (Browser.ielt9 || !this._map._fadeAnimated) {
	            requestAnimFrame(this._pruneTiles, this);
	          } else {
	            // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
	            // to trigger a pruning.
	            setTimeout(bind(this._pruneTiles, this), 250);
	          }
	        }
	      },
	      _getTilePos: function (coords) {
	        return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	      },
	      _wrapCoords: function (coords) {
	        var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
	        newCoords.z = coords.z;
	        return newCoords;
	      },
	      _pxBoundsToTileRange: function (bounds) {
	        var tileSize = this.getTileSize();
	        return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	      },
	      _noTilesToLoad: function () {
	        for (var key in this._tiles) {
	          if (!this._tiles[key].loaded) {
	            return false;
	          }
	        }
	        return true;
	      }
	    });

	    // @factory L.gridLayer(options?: GridLayer options)
	    // Creates a new instance of GridLayer with the supplied options.
	    function gridLayer(options) {
	      return new GridLayer(options);
	    }

	    /*
	     * @class TileLayer
	     * @inherits GridLayer
	     * @aka L.TileLayer
	     * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
	     *
	     * @example
	     *
	     * ```js
	     * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
	     * ```
	     *
	     * @section URL template
	     * @example
	     *
	     * A string of the following form:
	     *
	     * ```
	     * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	     * ```
	     *
	     * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	     *
	     * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	     *
	     * ```
	     * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	     * ```
	     */

	    var TileLayer = GridLayer.extend({
	      // @section
	      // @aka TileLayer options
	      options: {
	        // @option minZoom: Number = 0
	        // The minimum zoom level down to which this layer will be displayed (inclusive).
	        minZoom: 0,
	        // @option maxZoom: Number = 18
	        // The maximum zoom level up to which this layer will be displayed (inclusive).
	        maxZoom: 18,
	        // @option subdomains: String|String[] = 'abc'
	        // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
	        subdomains: 'abc',
	        // @option errorTileUrl: String = ''
	        // URL to the tile image to show in place of the tile that failed to load.
	        errorTileUrl: '',
	        // @option zoomOffset: Number = 0
	        // The zoom number used in tile URLs will be offset with this value.
	        zoomOffset: 0,
	        // @option tms: Boolean = false
	        // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
	        tms: false,
	        // @option zoomReverse: Boolean = false
	        // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
	        zoomReverse: false,
	        // @option detectRetina: Boolean = false
	        // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
	        detectRetina: false,
	        // @option crossOrigin: Boolean|String = false
	        // Whether the crossOrigin attribute will be added to the tiles.
	        // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
	        // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	        crossOrigin: false,
	        // @option referrerPolicy: Boolean|String = false
	        // Whether the referrerPolicy attribute will be added to the tiles.
	        // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
	        // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
	        // (e.g. to validate an API token).
	        // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
	        referrerPolicy: false
	      },
	      initialize: function (url, options) {
	        this._url = url;
	        options = setOptions(this, options);

	        // detecting retina displays, adjusting tileSize and zoom levels
	        if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
	          options.tileSize = Math.floor(options.tileSize / 2);
	          if (!options.zoomReverse) {
	            options.zoomOffset++;
	            options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
	          } else {
	            options.zoomOffset--;
	            options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
	          }
	          options.minZoom = Math.max(0, options.minZoom);
	        } else if (!options.zoomReverse) {
	          // make sure maxZoom is gte minZoom
	          options.maxZoom = Math.max(options.minZoom, options.maxZoom);
	        } else {
	          // make sure minZoom is lte maxZoom
	          options.minZoom = Math.min(options.maxZoom, options.minZoom);
	        }
	        if (typeof options.subdomains === 'string') {
	          options.subdomains = options.subdomains.split('');
	        }
	        this.on('tileunload', this._onTileRemove);
	      },
	      // @method setUrl(url: String, noRedraw?: Boolean): this
	      // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	      // If the URL does not change, the layer will not be redrawn unless
	      // the noRedraw parameter is set to false.
	      setUrl: function (url, noRedraw) {
	        if (this._url === url && noRedraw === undefined) {
	          noRedraw = true;
	        }
	        this._url = url;
	        if (!noRedraw) {
	          this.redraw();
	        }
	        return this;
	      },
	      // @method createTile(coords: Object, done?: Function): HTMLElement
	      // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	      // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
	      // callback is called when the tile has been loaded.
	      createTile: function (coords, done) {
	        var tile = document.createElement('img');
	        on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
	        on(tile, 'error', bind(this._tileOnError, this, done, tile));
	        if (this.options.crossOrigin || this.options.crossOrigin === '') {
	          tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	        }

	        // for this new option we follow the documented behavior
	        // more closely by only setting the property when string
	        if (typeof this.options.referrerPolicy === 'string') {
	          tile.referrerPolicy = this.options.referrerPolicy;
	        }

	        // The alt attribute is set to the empty string,
	        // allowing screen readers to ignore the decorative image tiles.
	        // https://www.w3.org/WAI/tutorials/images/decorative/
	        // https://www.w3.org/TR/html-aria/#el-img-empty-alt
	        tile.alt = '';
	        tile.src = this.getTileUrl(coords);
	        return tile;
	      },
	      // @section Extension methods
	      // @uninheritable
	      // Layers extending `TileLayer` might reimplement the following method.
	      // @method getTileUrl(coords: Object): String
	      // Called only internally, returns the URL for a tile given its coordinates.
	      // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	      getTileUrl: function (coords) {
	        var data = {
	          r: Browser.retina ? '@2x' : '',
	          s: this._getSubdomain(coords),
	          x: coords.x,
	          y: coords.y,
	          z: this._getZoomForUrl()
	        };
	        if (this._map && !this._map.options.crs.infinite) {
	          var invertedY = this._globalTileRange.max.y - coords.y;
	          if (this.options.tms) {
	            data['y'] = invertedY;
	          }
	          data['-y'] = invertedY;
	        }
	        return template(this._url, extend(data, this.options));
	      },
	      _tileOnLoad: function (done, tile) {
	        // For https://github.com/Leaflet/Leaflet/issues/3332
	        if (Browser.ielt9) {
	          setTimeout(bind(done, this, null, tile), 0);
	        } else {
	          done(null, tile);
	        }
	      },
	      _tileOnError: function (done, tile, e) {
	        var errorUrl = this.options.errorTileUrl;
	        if (errorUrl && tile.getAttribute('src') !== errorUrl) {
	          tile.src = errorUrl;
	        }
	        done(e, tile);
	      },
	      _onTileRemove: function (e) {
	        e.tile.onload = null;
	      },
	      _getZoomForUrl: function () {
	        var zoom = this._tileZoom,
	          maxZoom = this.options.maxZoom,
	          zoomReverse = this.options.zoomReverse,
	          zoomOffset = this.options.zoomOffset;
	        if (zoomReverse) {
	          zoom = maxZoom - zoom;
	        }
	        return zoom + zoomOffset;
	      },
	      _getSubdomain: function (tilePoint) {
	        var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
	        return this.options.subdomains[index];
	      },
	      // stops loading all tiles in the background layer
	      _abortLoading: function () {
	        var i, tile;
	        for (i in this._tiles) {
	          if (this._tiles[i].coords.z !== this._tileZoom) {
	            tile = this._tiles[i].el;
	            tile.onload = falseFn;
	            tile.onerror = falseFn;
	            if (!tile.complete) {
	              tile.src = emptyImageUrl;
	              var coords = this._tiles[i].coords;
	              remove(tile);
	              delete this._tiles[i];
	              // @event tileabort: TileEvent
	              // Fired when a tile was loading but is now not wanted.
	              this.fire('tileabort', {
	                tile: tile,
	                coords: coords
	              });
	            }
	          }
	        }
	      },
	      _removeTile: function (key) {
	        var tile = this._tiles[key];
	        if (!tile) {
	          return;
	        }

	        // Cancels any pending http requests associated with the tile
	        tile.el.setAttribute('src', emptyImageUrl);
	        return GridLayer.prototype._removeTile.call(this, key);
	      },
	      _tileReady: function (coords, err, tile) {
	        if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) {
	          return;
	        }
	        return GridLayer.prototype._tileReady.call(this, coords, err, tile);
	      }
	    });

	    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	    // Instantiates a tile layer object given a `URL template` and optionally an options object.

	    function tileLayer(url, options) {
	      return new TileLayer(url, options);
	    }

	    /*
	     * @class TileLayer.WMS
	     * @inherits TileLayer
	     * @aka L.TileLayer.WMS
	     * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	     *
	     * @example
	     *
	     * ```js
	     * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	     * 	layers: 'nexrad-n0r-900913',
	     * 	format: 'image/png',
	     * 	transparent: true,
	     * 	attribution: "Weather data © 2012 IEM Nexrad"
	     * });
	     * ```
	     */

	    var TileLayerWMS = TileLayer.extend({
	      // @section
	      // @aka TileLayer.WMS options
	      // If any custom options not documented here are used, they will be sent to the
	      // WMS server as extra parameters in each request URL. This can be useful for
	      // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	      defaultWmsParams: {
	        service: 'WMS',
	        request: 'GetMap',
	        // @option layers: String = ''
	        // **(required)** Comma-separated list of WMS layers to show.
	        layers: '',
	        // @option styles: String = ''
	        // Comma-separated list of WMS styles.
	        styles: '',
	        // @option format: String = 'image/jpeg'
	        // WMS image format (use `'image/png'` for layers with transparency).
	        format: 'image/jpeg',
	        // @option transparent: Boolean = false
	        // If `true`, the WMS service will return images with transparency.
	        transparent: false,
	        // @option version: String = '1.1.1'
	        // Version of the WMS service to use
	        version: '1.1.1'
	      },
	      options: {
	        // @option crs: CRS = null
	        // Coordinate Reference System to use for the WMS requests, defaults to
	        // map CRS. Don't change this if you're not sure what it means.
	        crs: null,
	        // @option uppercase: Boolean = false
	        // If `true`, WMS request parameter keys will be uppercase.
	        uppercase: false
	      },
	      initialize: function (url, options) {
	        this._url = url;
	        var wmsParams = extend({}, this.defaultWmsParams);

	        // all keys that are not TileLayer options go to WMS params
	        for (var i in options) {
	          if (!(i in this.options)) {
	            wmsParams[i] = options[i];
	          }
	        }
	        options = setOptions(this, options);
	        var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
	        var tileSize = this.getTileSize();
	        wmsParams.width = tileSize.x * realRetina;
	        wmsParams.height = tileSize.y * realRetina;
	        this.wmsParams = wmsParams;
	      },
	      onAdd: function (map) {
	        this._crs = this.options.crs || map.options.crs;
	        this._wmsVersion = parseFloat(this.wmsParams.version);
	        var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
	        this.wmsParams[projectionKey] = this._crs.code;
	        TileLayer.prototype.onAdd.call(this, map);
	      },
	      getTileUrl: function (coords) {
	        var tileBounds = this._tileCoordsToNwSe(coords),
	          crs = this._crs,
	          bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
	          min = bounds.min,
	          max = bounds.max,
	          bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [min.y, min.x, max.y, max.x] : [min.x, min.y, max.x, max.y]).join(','),
	          url = TileLayer.prototype.getTileUrl.call(this, coords);
	        return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	      },
	      // @method setParams(params: Object, noRedraw?: Boolean): this
	      // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	      setParams: function (params, noRedraw) {
	        extend(this.wmsParams, params);
	        if (!noRedraw) {
	          this.redraw();
	        }
	        return this;
	      }
	    });

	    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	    function tileLayerWMS(url, options) {
	      return new TileLayerWMS(url, options);
	    }
	    TileLayer.WMS = TileLayerWMS;
	    tileLayer.wms = tileLayerWMS;

	    /*
	     * @class Renderer
	     * @inherits Layer
	     * @aka L.Renderer
	     *
	     * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	     * DOM container of the renderer, its bounds, and its zoom animation.
	     *
	     * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	     * itself can be added or removed to the map. All paths use a renderer, which can
	     * be implicit (the map will decide the type of renderer and use it automatically)
	     * or explicit (using the [`renderer`](#path-renderer) option of the path).
	     *
	     * Do not use this class directly, use `SVG` and `Canvas` instead.
	     *
	     * @event update: Event
	     * Fired when the renderer updates its bounds, center and zoom, for example when
	     * its map has moved
	     */

	    var Renderer = Layer.extend({
	      // @section
	      // @aka Renderer options
	      options: {
	        // @option padding: Number = 0.1
	        // How much to extend the clip area around the map view (relative to its size)
	        // e.g. 0.1 would be 10% of map view in each direction
	        padding: 0.1
	      },
	      initialize: function (options) {
	        setOptions(this, options);
	        stamp(this);
	        this._layers = this._layers || {};
	      },
	      onAdd: function () {
	        if (!this._container) {
	          this._initContainer(); // defined by renderer implementations

	          // always keep transform-origin as 0 0
	          addClass(this._container, 'leaflet-zoom-animated');
	        }
	        this.getPane().appendChild(this._container);
	        this._update();
	        this.on('update', this._updatePaths, this);
	      },
	      onRemove: function () {
	        this.off('update', this._updatePaths, this);
	        this._destroyContainer();
	      },
	      getEvents: function () {
	        var events = {
	          viewreset: this._reset,
	          zoom: this._onZoom,
	          moveend: this._update,
	          zoomend: this._onZoomEnd
	        };
	        if (this._zoomAnimated) {
	          events.zoomanim = this._onAnimZoom;
	        }
	        return events;
	      },
	      _onAnimZoom: function (ev) {
	        this._updateTransform(ev.center, ev.zoom);
	      },
	      _onZoom: function () {
	        this._updateTransform(this._map.getCenter(), this._map.getZoom());
	      },
	      _updateTransform: function (center, zoom) {
	        var scale = this._map.getZoomScale(zoom, this._zoom),
	          viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
	          currentCenterPoint = this._map.project(this._center, zoom),
	          topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
	        if (Browser.any3d) {
	          setTransform(this._container, topLeftOffset, scale);
	        } else {
	          setPosition(this._container, topLeftOffset);
	        }
	      },
	      _reset: function () {
	        this._update();
	        this._updateTransform(this._center, this._zoom);
	        for (var id in this._layers) {
	          this._layers[id]._reset();
	        }
	      },
	      _onZoomEnd: function () {
	        for (var id in this._layers) {
	          this._layers[id]._project();
	        }
	      },
	      _updatePaths: function () {
	        for (var id in this._layers) {
	          this._layers[id]._update();
	        }
	      },
	      _update: function () {
	        // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
	        // Subclasses are responsible of firing the 'update' event.
	        var p = this.options.padding,
	          size = this._map.getSize(),
	          min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	        this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	        this._center = this._map.getCenter();
	        this._zoom = this._map.getZoom();
	      }
	    });

	    /*
	     * @class Canvas
	     * @inherits Renderer
	     * @aka L.Canvas
	     *
	     * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	     * Inherits `Renderer`.
	     *
	     * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
	     * available in all web browsers, notably IE8, and overlapping geometries might
	     * not display properly in some edge cases.
	     *
	     * @example
	     *
	     * Use Canvas by default for all paths in the map:
	     *
	     * ```js
	     * var map = L.map('map', {
	     * 	renderer: L.canvas()
	     * });
	     * ```
	     *
	     * Use a Canvas renderer with extra padding for specific vector geometries:
	     *
	     * ```js
	     * var map = L.map('map');
	     * var myRenderer = L.canvas({ padding: 0.5 });
	     * var line = L.polyline( coordinates, { renderer: myRenderer } );
	     * var circle = L.circle( center, { renderer: myRenderer } );
	     * ```
	     */

	    var Canvas = Renderer.extend({
	      // @section
	      // @aka Canvas options
	      options: {
	        // @option tolerance: Number = 0
	        // How much to extend the click tolerance around a path/object on the map.
	        tolerance: 0
	      },
	      getEvents: function () {
	        var events = Renderer.prototype.getEvents.call(this);
	        events.viewprereset = this._onViewPreReset;
	        return events;
	      },
	      _onViewPreReset: function () {
	        // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
	        this._postponeUpdatePaths = true;
	      },
	      onAdd: function () {
	        Renderer.prototype.onAdd.call(this);

	        // Redraw vectors since canvas is cleared upon removal,
	        // in case of removing the renderer itself from the map.
	        this._draw();
	      },
	      _initContainer: function () {
	        var container = this._container = document.createElement('canvas');
	        on(container, 'mousemove', this._onMouseMove, this);
	        on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
	        on(container, 'mouseout', this._handleMouseOut, this);
	        container['_leaflet_disable_events'] = true;
	        this._ctx = container.getContext('2d');
	      },
	      _destroyContainer: function () {
	        cancelAnimFrame(this._redrawRequest);
	        delete this._ctx;
	        remove(this._container);
	        off(this._container);
	        delete this._container;
	      },
	      _updatePaths: function () {
	        if (this._postponeUpdatePaths) {
	          return;
	        }
	        var layer;
	        this._redrawBounds = null;
	        for (var id in this._layers) {
	          layer = this._layers[id];
	          layer._update();
	        }
	        this._redraw();
	      },
	      _update: function () {
	        if (this._map._animatingZoom && this._bounds) {
	          return;
	        }
	        Renderer.prototype._update.call(this);
	        var b = this._bounds,
	          container = this._container,
	          size = b.getSize(),
	          m = Browser.retina ? 2 : 1;
	        setPosition(container, b.min);

	        // set canvas size (also clearing it); use double size on retina
	        container.width = m * size.x;
	        container.height = m * size.y;
	        container.style.width = size.x + 'px';
	        container.style.height = size.y + 'px';
	        if (Browser.retina) {
	          this._ctx.scale(2, 2);
	        }

	        // translate so we use the same path coordinates after canvas element moves
	        this._ctx.translate(-b.min.x, -b.min.y);

	        // Tell paths to redraw themselves
	        this.fire('update');
	      },
	      _reset: function () {
	        Renderer.prototype._reset.call(this);
	        if (this._postponeUpdatePaths) {
	          this._postponeUpdatePaths = false;
	          this._updatePaths();
	        }
	      },
	      _initPath: function (layer) {
	        this._updateDashArray(layer);
	        this._layers[stamp(layer)] = layer;
	        var order = layer._order = {
	          layer: layer,
	          prev: this._drawLast,
	          next: null
	        };
	        if (this._drawLast) {
	          this._drawLast.next = order;
	        }
	        this._drawLast = order;
	        this._drawFirst = this._drawFirst || this._drawLast;
	      },
	      _addPath: function (layer) {
	        this._requestRedraw(layer);
	      },
	      _removePath: function (layer) {
	        var order = layer._order;
	        var next = order.next;
	        var prev = order.prev;
	        if (next) {
	          next.prev = prev;
	        } else {
	          this._drawLast = prev;
	        }
	        if (prev) {
	          prev.next = next;
	        } else {
	          this._drawFirst = next;
	        }
	        delete layer._order;
	        delete this._layers[stamp(layer)];
	        this._requestRedraw(layer);
	      },
	      _updatePath: function (layer) {
	        // Redraw the union of the layer's old pixel
	        // bounds and the new pixel bounds.
	        this._extendRedrawBounds(layer);
	        layer._project();
	        layer._update();
	        // The redraw will extend the redraw bounds
	        // with the new pixel bounds.
	        this._requestRedraw(layer);
	      },
	      _updateStyle: function (layer) {
	        this._updateDashArray(layer);
	        this._requestRedraw(layer);
	      },
	      _updateDashArray: function (layer) {
	        if (typeof layer.options.dashArray === 'string') {
	          var parts = layer.options.dashArray.split(/[, ]+/),
	            dashArray = [],
	            dashValue,
	            i;
	          for (i = 0; i < parts.length; i++) {
	            dashValue = Number(parts[i]);
	            // Ignore dash array containing invalid lengths
	            if (isNaN(dashValue)) {
	              return;
	            }
	            dashArray.push(dashValue);
	          }
	          layer.options._dashArray = dashArray;
	        } else {
	          layer.options._dashArray = layer.options.dashArray;
	        }
	      },
	      _requestRedraw: function (layer) {
	        if (!this._map) {
	          return;
	        }
	        this._extendRedrawBounds(layer);
	        this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
	      },
	      _extendRedrawBounds: function (layer) {
	        if (layer._pxBounds) {
	          var padding = (layer.options.weight || 0) + 1;
	          this._redrawBounds = this._redrawBounds || new Bounds();
	          this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
	          this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
	        }
	      },
	      _redraw: function () {
	        this._redrawRequest = null;
	        if (this._redrawBounds) {
	          this._redrawBounds.min._floor();
	          this._redrawBounds.max._ceil();
	        }
	        this._clear(); // clear layers in redraw bounds
	        this._draw(); // draw layers

	        this._redrawBounds = null;
	      },
	      _clear: function () {
	        var bounds = this._redrawBounds;
	        if (bounds) {
	          var size = bounds.getSize();
	          this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
	        } else {
	          this._ctx.save();
	          this._ctx.setTransform(1, 0, 0, 1, 0, 0);
	          this._ctx.clearRect(0, 0, this._container.width, this._container.height);
	          this._ctx.restore();
	        }
	      },
	      _draw: function () {
	        var layer,
	          bounds = this._redrawBounds;
	        this._ctx.save();
	        if (bounds) {
	          var size = bounds.getSize();
	          this._ctx.beginPath();
	          this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
	          this._ctx.clip();
	        }
	        this._drawing = true;
	        for (var order = this._drawFirst; order; order = order.next) {
	          layer = order.layer;
	          if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) {
	            layer._updatePath();
	          }
	        }
	        this._drawing = false;
	        this._ctx.restore(); // Restore state before clipping.
	      },
	      _updatePoly: function (layer, closed) {
	        if (!this._drawing) {
	          return;
	        }
	        var i,
	          j,
	          len2,
	          p,
	          parts = layer._parts,
	          len = parts.length,
	          ctx = this._ctx;
	        if (!len) {
	          return;
	        }
	        ctx.beginPath();
	        for (i = 0; i < len; i++) {
	          for (j = 0, len2 = parts[i].length; j < len2; j++) {
	            p = parts[i][j];
	            ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
	          }
	          if (closed) {
	            ctx.closePath();
	          }
	        }
	        this._fillStroke(ctx, layer);

	        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	      },
	      _updateCircle: function (layer) {
	        if (!this._drawing || layer._empty()) {
	          return;
	        }
	        var p = layer._point,
	          ctx = this._ctx,
	          r = Math.max(Math.round(layer._radius), 1),
	          s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
	        if (s !== 1) {
	          ctx.save();
	          ctx.scale(1, s);
	        }
	        ctx.beginPath();
	        ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	        if (s !== 1) {
	          ctx.restore();
	        }
	        this._fillStroke(ctx, layer);
	      },
	      _fillStroke: function (ctx, layer) {
	        var options = layer.options;
	        if (options.fill) {
	          ctx.globalAlpha = options.fillOpacity;
	          ctx.fillStyle = options.fillColor || options.color;
	          ctx.fill(options.fillRule || 'evenodd');
	        }
	        if (options.stroke && options.weight !== 0) {
	          if (ctx.setLineDash) {
	            ctx.setLineDash(layer.options && layer.options._dashArray || []);
	          }
	          ctx.globalAlpha = options.opacity;
	          ctx.lineWidth = options.weight;
	          ctx.strokeStyle = options.color;
	          ctx.lineCap = options.lineCap;
	          ctx.lineJoin = options.lineJoin;
	          ctx.stroke();
	        }
	      },
	      // Canvas obviously doesn't have mouse events for individual drawn objects,
	      // so we emulate that by calculating what's under the mouse on mousemove/click manually

	      _onClick: function (e) {
	        var point = this._map.mouseEventToLayerPoint(e),
	          layer,
	          clickedLayer;
	        for (var order = this._drawFirst; order; order = order.next) {
	          layer = order.layer;
	          if (layer.options.interactive && layer._containsPoint(point)) {
	            if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) {
	              clickedLayer = layer;
	            }
	          }
	        }
	        this._fireEvent(clickedLayer ? [clickedLayer] : false, e);
	      },
	      _onMouseMove: function (e) {
	        if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) {
	          return;
	        }
	        var point = this._map.mouseEventToLayerPoint(e);
	        this._handleMouseHover(e, point);
	      },
	      _handleMouseOut: function (e) {
	        var layer = this._hoveredLayer;
	        if (layer) {
	          // if we're leaving the layer, fire mouseout
	          removeClass(this._container, 'leaflet-interactive');
	          this._fireEvent([layer], e, 'mouseout');
	          this._hoveredLayer = null;
	          this._mouseHoverThrottled = false;
	        }
	      },
	      _handleMouseHover: function (e, point) {
	        if (this._mouseHoverThrottled) {
	          return;
	        }
	        var layer, candidateHoveredLayer;
	        for (var order = this._drawFirst; order; order = order.next) {
	          layer = order.layer;
	          if (layer.options.interactive && layer._containsPoint(point)) {
	            candidateHoveredLayer = layer;
	          }
	        }
	        if (candidateHoveredLayer !== this._hoveredLayer) {
	          this._handleMouseOut(e);
	          if (candidateHoveredLayer) {
	            addClass(this._container, 'leaflet-interactive'); // change cursor
	            this._fireEvent([candidateHoveredLayer], e, 'mouseover');
	            this._hoveredLayer = candidateHoveredLayer;
	          }
	        }
	        this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : false, e);
	        this._mouseHoverThrottled = true;
	        setTimeout(bind(function () {
	          this._mouseHoverThrottled = false;
	        }, this), 32);
	      },
	      _fireEvent: function (layers, e, type) {
	        this._map._fireDOMEvent(e, type || e.type, layers);
	      },
	      _bringToFront: function (layer) {
	        var order = layer._order;
	        if (!order) {
	          return;
	        }
	        var next = order.next;
	        var prev = order.prev;
	        if (next) {
	          next.prev = prev;
	        } else {
	          // Already last
	          return;
	        }
	        if (prev) {
	          prev.next = next;
	        } else if (next) {
	          // Update first entry unless this is the
	          // single entry
	          this._drawFirst = next;
	        }
	        order.prev = this._drawLast;
	        this._drawLast.next = order;
	        order.next = null;
	        this._drawLast = order;
	        this._requestRedraw(layer);
	      },
	      _bringToBack: function (layer) {
	        var order = layer._order;
	        if (!order) {
	          return;
	        }
	        var next = order.next;
	        var prev = order.prev;
	        if (prev) {
	          prev.next = next;
	        } else {
	          // Already first
	          return;
	        }
	        if (next) {
	          next.prev = prev;
	        } else if (prev) {
	          // Update last entry unless this is the
	          // single entry
	          this._drawLast = prev;
	        }
	        order.prev = null;
	        order.next = this._drawFirst;
	        this._drawFirst.prev = order;
	        this._drawFirst = order;
	        this._requestRedraw(layer);
	      }
	    });

	    // @factory L.canvas(options?: Renderer options)
	    // Creates a Canvas renderer with the given options.
	    function canvas(options) {
	      return Browser.canvas ? new Canvas(options) : null;
	    }

	    /*
	     * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	     */

	    var vmlCreate = function () {
	      try {
	        document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
	        return function (name) {
	          return document.createElement('<lvml:' + name + ' class="lvml">');
	        };
	      } catch (e) {
	        // Do not return fn from catch block so `e` can be garbage collected
	        // See https://github.com/Leaflet/Leaflet/pull/7279
	      }
	      return function (name) {
	        return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
	      };
	    }();

	    /*
	     * @class SVG
	     *
	     *
	     * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	     * with old versions of Internet Explorer.
	     */

	    // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	    var vmlMixin = {
	      _initContainer: function () {
	        this._container = create$1('div', 'leaflet-vml-container');
	      },
	      _update: function () {
	        if (this._map._animatingZoom) {
	          return;
	        }
	        Renderer.prototype._update.call(this);
	        this.fire('update');
	      },
	      _initPath: function (layer) {
	        var container = layer._container = vmlCreate('shape');
	        addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	        container.coordsize = '1 1';
	        layer._path = vmlCreate('path');
	        container.appendChild(layer._path);
	        this._updateStyle(layer);
	        this._layers[stamp(layer)] = layer;
	      },
	      _addPath: function (layer) {
	        var container = layer._container;
	        this._container.appendChild(container);
	        if (layer.options.interactive) {
	          layer.addInteractiveTarget(container);
	        }
	      },
	      _removePath: function (layer) {
	        var container = layer._container;
	        remove(container);
	        layer.removeInteractiveTarget(container);
	        delete this._layers[stamp(layer)];
	      },
	      _updateStyle: function (layer) {
	        var stroke = layer._stroke,
	          fill = layer._fill,
	          options = layer.options,
	          container = layer._container;
	        container.stroked = !!options.stroke;
	        container.filled = !!options.fill;
	        if (options.stroke) {
	          if (!stroke) {
	            stroke = layer._stroke = vmlCreate('stroke');
	          }
	          container.appendChild(stroke);
	          stroke.weight = options.weight + 'px';
	          stroke.color = options.color;
	          stroke.opacity = options.opacity;
	          if (options.dashArray) {
	            stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
	          } else {
	            stroke.dashStyle = '';
	          }
	          stroke.endcap = options.lineCap.replace('butt', 'flat');
	          stroke.joinstyle = options.lineJoin;
	        } else if (stroke) {
	          container.removeChild(stroke);
	          layer._stroke = null;
	        }
	        if (options.fill) {
	          if (!fill) {
	            fill = layer._fill = vmlCreate('fill');
	          }
	          container.appendChild(fill);
	          fill.color = options.fillColor || options.color;
	          fill.opacity = options.fillOpacity;
	        } else if (fill) {
	          container.removeChild(fill);
	          layer._fill = null;
	        }
	      },
	      _updateCircle: function (layer) {
	        var p = layer._point.round(),
	          r = Math.round(layer._radius),
	          r2 = Math.round(layer._radiusY || r);
	        this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 65535 * 360);
	      },
	      _setPath: function (layer, path) {
	        layer._path.v = path;
	      },
	      _bringToFront: function (layer) {
	        toFront(layer._container);
	      },
	      _bringToBack: function (layer) {
	        toBack(layer._container);
	      }
	    };
	    var create = Browser.vml ? vmlCreate : svgCreate;

	    /*
	     * @class SVG
	     * @inherits Renderer
	     * @aka L.SVG
	     *
	     * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	     * Inherits `Renderer`.
	     *
	     * Due to [technical limitations](https://caniuse.com/svg), SVG is not
	     * available in all web browsers, notably Android 2.x and 3.x.
	     *
	     * Although SVG is not available on IE7 and IE8, these browsers support
	     * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	     * (a now deprecated technology), and the SVG renderer will fall back to VML in
	     * this case.
	     *
	     * @example
	     *
	     * Use SVG by default for all paths in the map:
	     *
	     * ```js
	     * var map = L.map('map', {
	     * 	renderer: L.svg()
	     * });
	     * ```
	     *
	     * Use a SVG renderer with extra padding for specific vector geometries:
	     *
	     * ```js
	     * var map = L.map('map');
	     * var myRenderer = L.svg({ padding: 0.5 });
	     * var line = L.polyline( coordinates, { renderer: myRenderer } );
	     * var circle = L.circle( center, { renderer: myRenderer } );
	     * ```
	     */

	    var SVG = Renderer.extend({
	      _initContainer: function () {
	        this._container = create('svg');

	        // makes it possible to click through svg root; we'll reset it back in individual paths
	        this._container.setAttribute('pointer-events', 'none');
	        this._rootGroup = create('g');
	        this._container.appendChild(this._rootGroup);
	      },
	      _destroyContainer: function () {
	        remove(this._container);
	        off(this._container);
	        delete this._container;
	        delete this._rootGroup;
	        delete this._svgSize;
	      },
	      _update: function () {
	        if (this._map._animatingZoom && this._bounds) {
	          return;
	        }
	        Renderer.prototype._update.call(this);
	        var b = this._bounds,
	          size = b.getSize(),
	          container = this._container;

	        // set size of svg-container if changed
	        if (!this._svgSize || !this._svgSize.equals(size)) {
	          this._svgSize = size;
	          container.setAttribute('width', size.x);
	          container.setAttribute('height', size.y);
	        }

	        // movement: update container viewBox so that we don't have to change coordinates of individual layers
	        setPosition(container, b.min);
	        container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	        this.fire('update');
	      },
	      // methods below are called by vector layers implementations

	      _initPath: function (layer) {
	        var path = layer._path = create('path');

	        // @namespace Path
	        // @option className: String = null
	        // Custom class name set on an element. Only for SVG renderer.
	        if (layer.options.className) {
	          addClass(path, layer.options.className);
	        }
	        if (layer.options.interactive) {
	          addClass(path, 'leaflet-interactive');
	        }
	        this._updateStyle(layer);
	        this._layers[stamp(layer)] = layer;
	      },
	      _addPath: function (layer) {
	        if (!this._rootGroup) {
	          this._initContainer();
	        }
	        this._rootGroup.appendChild(layer._path);
	        layer.addInteractiveTarget(layer._path);
	      },
	      _removePath: function (layer) {
	        remove(layer._path);
	        layer.removeInteractiveTarget(layer._path);
	        delete this._layers[stamp(layer)];
	      },
	      _updatePath: function (layer) {
	        layer._project();
	        layer._update();
	      },
	      _updateStyle: function (layer) {
	        var path = layer._path,
	          options = layer.options;
	        if (!path) {
	          return;
	        }
	        if (options.stroke) {
	          path.setAttribute('stroke', options.color);
	          path.setAttribute('stroke-opacity', options.opacity);
	          path.setAttribute('stroke-width', options.weight);
	          path.setAttribute('stroke-linecap', options.lineCap);
	          path.setAttribute('stroke-linejoin', options.lineJoin);
	          if (options.dashArray) {
	            path.setAttribute('stroke-dasharray', options.dashArray);
	          } else {
	            path.removeAttribute('stroke-dasharray');
	          }
	          if (options.dashOffset) {
	            path.setAttribute('stroke-dashoffset', options.dashOffset);
	          } else {
	            path.removeAttribute('stroke-dashoffset');
	          }
	        } else {
	          path.setAttribute('stroke', 'none');
	        }
	        if (options.fill) {
	          path.setAttribute('fill', options.fillColor || options.color);
	          path.setAttribute('fill-opacity', options.fillOpacity);
	          path.setAttribute('fill-rule', options.fillRule || 'evenodd');
	        } else {
	          path.setAttribute('fill', 'none');
	        }
	      },
	      _updatePoly: function (layer, closed) {
	        this._setPath(layer, pointsToPath(layer._parts, closed));
	      },
	      _updateCircle: function (layer) {
	        var p = layer._point,
	          r = Math.max(Math.round(layer._radius), 1),
	          r2 = Math.max(Math.round(layer._radiusY), 1) || r,
	          arc = 'a' + r + ',' + r2 + ' 0 1,0 ';

	        // drawing a circle with two half-arcs
	        var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
	        this._setPath(layer, d);
	      },
	      _setPath: function (layer, path) {
	        layer._path.setAttribute('d', path);
	      },
	      // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	      _bringToFront: function (layer) {
	        toFront(layer._path);
	      },
	      _bringToBack: function (layer) {
	        toBack(layer._path);
	      }
	    });
	    if (Browser.vml) {
	      SVG.include(vmlMixin);
	    }

	    // @namespace SVG
	    // @factory L.svg(options?: Renderer options)
	    // Creates a SVG renderer with the given options.
	    function svg(options) {
	      return Browser.svg || Browser.vml ? new SVG(options) : null;
	    }
	    Map.include({
	      // @namespace Map; @method getRenderer(layer: Path): Renderer
	      // Returns the instance of `Renderer` that should be used to render the given
	      // `Path`. It will ensure that the `renderer` options of the map and paths
	      // are respected, and that the renderers do exist on the map.
	      getRenderer: function (layer) {
	        // @namespace Path; @option renderer: Renderer
	        // Use this specific instance of `Renderer` for this path. Takes
	        // precedence over the map's [default renderer](#map-renderer).
	        var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	        if (!renderer) {
	          renderer = this._renderer = this._createRenderer();
	        }
	        if (!this.hasLayer(renderer)) {
	          this.addLayer(renderer);
	        }
	        return renderer;
	      },
	      _getPaneRenderer: function (name) {
	        if (name === 'overlayPane' || name === undefined) {
	          return false;
	        }
	        var renderer = this._paneRenderers[name];
	        if (renderer === undefined) {
	          renderer = this._createRenderer({
	            pane: name
	          });
	          this._paneRenderers[name] = renderer;
	        }
	        return renderer;
	      },
	      _createRenderer: function (options) {
	        // @namespace Map; @option preferCanvas: Boolean = false
	        // Whether `Path`s should be rendered on a `Canvas` renderer.
	        // By default, all `Path`s are rendered in a `SVG` renderer.
	        return this.options.preferCanvas && canvas(options) || svg(options);
	      }
	    });

	    /*
	     * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	     */

	    /*
	     * @class Rectangle
	     * @aka L.Rectangle
	     * @inherits Polygon
	     *
	     * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	     *
	     * @example
	     *
	     * ```js
	     * // define rectangle geographical bounds
	     * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	     *
	     * // create an orange rectangle
	     * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	     *
	     * // zoom the map to the rectangle bounds
	     * map.fitBounds(bounds);
	     * ```
	     *
	     */

	    var Rectangle = Polygon.extend({
	      initialize: function (latLngBounds, options) {
	        Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	      },
	      // @method setBounds(latLngBounds: LatLngBounds): this
	      // Redraws the rectangle with the passed bounds.
	      setBounds: function (latLngBounds) {
	        return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	      },
	      _boundsToLatLngs: function (latLngBounds) {
	        latLngBounds = toLatLngBounds(latLngBounds);
	        return [latLngBounds.getSouthWest(), latLngBounds.getNorthWest(), latLngBounds.getNorthEast(), latLngBounds.getSouthEast()];
	      }
	    });

	    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	    function rectangle(latLngBounds, options) {
	      return new Rectangle(latLngBounds, options);
	    }
	    SVG.create = create;
	    SVG.pointsToPath = pointsToPath;
	    GeoJSON.geometryToLayer = geometryToLayer;
	    GeoJSON.coordsToLatLng = coordsToLatLng;
	    GeoJSON.coordsToLatLngs = coordsToLatLngs;
	    GeoJSON.latLngToCoords = latLngToCoords;
	    GeoJSON.latLngsToCoords = latLngsToCoords;
	    GeoJSON.getFeature = getFeature;
	    GeoJSON.asFeature = asFeature;

	    /*
	     * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	     * (zoom to a selected bounding box), enabled by default.
	     */

	    // @namespace Map
	    // @section Interaction Options
	    Map.mergeOptions({
	      // @option boxZoom: Boolean = true
	      // Whether the map can be zoomed to a rectangular area specified by
	      // dragging the mouse while pressing the shift key.
	      boxZoom: true
	    });
	    var BoxZoom = Handler.extend({
	      initialize: function (map) {
	        this._map = map;
	        this._container = map._container;
	        this._pane = map._panes.overlayPane;
	        this._resetStateTimeout = 0;
	        map.on('unload', this._destroy, this);
	      },
	      addHooks: function () {
	        on(this._container, 'mousedown', this._onMouseDown, this);
	      },
	      removeHooks: function () {
	        off(this._container, 'mousedown', this._onMouseDown, this);
	      },
	      moved: function () {
	        return this._moved;
	      },
	      _destroy: function () {
	        remove(this._pane);
	        delete this._pane;
	      },
	      _resetState: function () {
	        this._resetStateTimeout = 0;
	        this._moved = false;
	      },
	      _clearDeferredResetState: function () {
	        if (this._resetStateTimeout !== 0) {
	          clearTimeout(this._resetStateTimeout);
	          this._resetStateTimeout = 0;
	        }
	      },
	      _onMouseDown: function (e) {
	        if (!e.shiftKey || e.which !== 1 && e.button !== 1) {
	          return false;
	        }

	        // Clear the deferred resetState if it hasn't executed yet, otherwise it
	        // will interrupt the interaction and orphan a box element in the container.
	        this._clearDeferredResetState();
	        this._resetState();
	        disableTextSelection();
	        disableImageDrag();
	        this._startPoint = this._map.mouseEventToContainerPoint(e);
	        on(document, {
	          contextmenu: stop,
	          mousemove: this._onMouseMove,
	          mouseup: this._onMouseUp,
	          keydown: this._onKeyDown
	        }, this);
	      },
	      _onMouseMove: function (e) {
	        if (!this._moved) {
	          this._moved = true;
	          this._box = create$1('div', 'leaflet-zoom-box', this._container);
	          addClass(this._container, 'leaflet-crosshair');
	          this._map.fire('boxzoomstart');
	        }
	        this._point = this._map.mouseEventToContainerPoint(e);
	        var bounds = new Bounds(this._point, this._startPoint),
	          size = bounds.getSize();
	        setPosition(this._box, bounds.min);
	        this._box.style.width = size.x + 'px';
	        this._box.style.height = size.y + 'px';
	      },
	      _finish: function () {
	        if (this._moved) {
	          remove(this._box);
	          removeClass(this._container, 'leaflet-crosshair');
	        }
	        enableTextSelection();
	        enableImageDrag();
	        off(document, {
	          contextmenu: stop,
	          mousemove: this._onMouseMove,
	          mouseup: this._onMouseUp,
	          keydown: this._onKeyDown
	        }, this);
	      },
	      _onMouseUp: function (e) {
	        if (e.which !== 1 && e.button !== 1) {
	          return;
	        }
	        this._finish();
	        if (!this._moved) {
	          return;
	        }
	        // Postpone to next JS tick so internal click event handling
	        // still see it as "moved".
	        this._clearDeferredResetState();
	        this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	        var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
	        this._map.fitBounds(bounds).fire('boxzoomend', {
	          boxZoomBounds: bounds
	        });
	      },
	      _onKeyDown: function (e) {
	        if (e.keyCode === 27) {
	          this._finish();
	          this._clearDeferredResetState();
	          this._resetState();
	        }
	      }
	    });

	    // @section Handlers
	    // @property boxZoom: Handler
	    // Box (shift-drag with mouse) zoom handler.
	    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);

	    /*
	     * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	     */

	    // @namespace Map
	    // @section Interaction Options

	    Map.mergeOptions({
	      // @option doubleClickZoom: Boolean|String = true
	      // Whether the map can be zoomed in by double clicking on it and
	      // zoomed out by double clicking while holding shift. If passed
	      // `'center'`, double-click zoom will zoom to the center of the
	      //  view regardless of where the mouse was.
	      doubleClickZoom: true
	    });
	    var DoubleClickZoom = Handler.extend({
	      addHooks: function () {
	        this._map.on('dblclick', this._onDoubleClick, this);
	      },
	      removeHooks: function () {
	        this._map.off('dblclick', this._onDoubleClick, this);
	      },
	      _onDoubleClick: function (e) {
	        var map = this._map,
	          oldZoom = map.getZoom(),
	          delta = map.options.zoomDelta,
	          zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	        if (map.options.doubleClickZoom === 'center') {
	          map.setZoom(zoom);
	        } else {
	          map.setZoomAround(e.containerPoint, zoom);
	        }
	      }
	    });

	    // @section Handlers
	    //
	    // Map properties include interaction handlers that allow you to control
	    // interaction behavior in runtime, enabling or disabling certain features such
	    // as dragging or touch zoom (see `Handler` methods). For example:
	    //
	    // ```js
	    // map.doubleClickZoom.disable();
	    // ```
	    //
	    // @property doubleClickZoom: Handler
	    // Double click zoom handler.
	    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);

	    /*
	     * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	     */

	    // @namespace Map
	    // @section Interaction Options
	    Map.mergeOptions({
	      // @option dragging: Boolean = true
	      // Whether the map is draggable with mouse/touch or not.
	      dragging: true,
	      // @section Panning Inertia Options
	      // @option inertia: Boolean = *
	      // If enabled, panning of the map will have an inertia effect where
	      // the map builds momentum while dragging and continues moving in
	      // the same direction for some time. Feels especially nice on touch
	      // devices. Enabled by default.
	      inertia: true,
	      // @option inertiaDeceleration: Number = 3000
	      // The rate with which the inertial movement slows down, in pixels/second².
	      inertiaDeceleration: 3400,
	      // px/s^2

	      // @option inertiaMaxSpeed: Number = Infinity
	      // Max speed of the inertial movement, in pixels/second.
	      inertiaMaxSpeed: Infinity,
	      // px/s

	      // @option easeLinearity: Number = 0.2
	      easeLinearity: 0.2,
	      // TODO refactor, move to CRS
	      // @option worldCopyJump: Boolean = false
	      // With this option enabled, the map tracks when you pan to another "copy"
	      // of the world and seamlessly jumps to the original one so that all overlays
	      // like markers and vector layers are still visible.
	      worldCopyJump: false,
	      // @option maxBoundsViscosity: Number = 0.0
	      // If `maxBounds` is set, this option will control how solid the bounds
	      // are when dragging the map around. The default value of `0.0` allows the
	      // user to drag outside the bounds at normal speed, higher values will
	      // slow down map dragging outside bounds, and `1.0` makes the bounds fully
	      // solid, preventing the user from dragging outside the bounds.
	      maxBoundsViscosity: 0.0
	    });
	    var Drag = Handler.extend({
	      addHooks: function () {
	        if (!this._draggable) {
	          var map = this._map;
	          this._draggable = new Draggable(map._mapPane, map._container);
	          this._draggable.on({
	            dragstart: this._onDragStart,
	            drag: this._onDrag,
	            dragend: this._onDragEnd
	          }, this);
	          this._draggable.on('predrag', this._onPreDragLimit, this);
	          if (map.options.worldCopyJump) {
	            this._draggable.on('predrag', this._onPreDragWrap, this);
	            map.on('zoomend', this._onZoomEnd, this);
	            map.whenReady(this._onZoomEnd, this);
	          }
	        }
	        addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
	        this._draggable.enable();
	        this._positions = [];
	        this._times = [];
	      },
	      removeHooks: function () {
	        removeClass(this._map._container, 'leaflet-grab');
	        removeClass(this._map._container, 'leaflet-touch-drag');
	        this._draggable.disable();
	      },
	      moved: function () {
	        return this._draggable && this._draggable._moved;
	      },
	      moving: function () {
	        return this._draggable && this._draggable._moving;
	      },
	      _onDragStart: function () {
	        var map = this._map;
	        map._stop();
	        if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
	          var bounds = toLatLngBounds(this._map.options.maxBounds);
	          this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
	          this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
	        } else {
	          this._offsetLimit = null;
	        }
	        map.fire('movestart').fire('dragstart');
	        if (map.options.inertia) {
	          this._positions = [];
	          this._times = [];
	        }
	      },
	      _onDrag: function (e) {
	        if (this._map.options.inertia) {
	          var time = this._lastTime = +new Date(),
	            pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	          this._positions.push(pos);
	          this._times.push(time);
	          this._prunePositions(time);
	        }
	        this._map.fire('move', e).fire('drag', e);
	      },
	      _prunePositions: function (time) {
	        while (this._positions.length > 1 && time - this._times[0] > 50) {
	          this._positions.shift();
	          this._times.shift();
	        }
	      },
	      _onZoomEnd: function () {
	        var pxCenter = this._map.getSize().divideBy(2),
	          pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	        this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
	        this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	      },
	      _viscousLimit: function (value, threshold) {
	        return value - (value - threshold) * this._viscosity;
	      },
	      _onPreDragLimit: function () {
	        if (!this._viscosity || !this._offsetLimit) {
	          return;
	        }
	        var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	        var limit = this._offsetLimit;
	        if (offset.x < limit.min.x) {
	          offset.x = this._viscousLimit(offset.x, limit.min.x);
	        }
	        if (offset.y < limit.min.y) {
	          offset.y = this._viscousLimit(offset.y, limit.min.y);
	        }
	        if (offset.x > limit.max.x) {
	          offset.x = this._viscousLimit(offset.x, limit.max.x);
	        }
	        if (offset.y > limit.max.y) {
	          offset.y = this._viscousLimit(offset.y, limit.max.y);
	        }
	        this._draggable._newPos = this._draggable._startPos.add(offset);
	      },
	      _onPreDragWrap: function () {
	        // TODO refactor to be able to adjust map pane position after zoom
	        var worldWidth = this._worldWidth,
	          halfWidth = Math.round(worldWidth / 2),
	          dx = this._initialWorldOffset,
	          x = this._draggable._newPos.x,
	          newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
	          newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
	          newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	        this._draggable._absPos = this._draggable._newPos.clone();
	        this._draggable._newPos.x = newX;
	      },
	      _onDragEnd: function (e) {
	        var map = this._map,
	          options = map.options,
	          noInertia = !options.inertia || e.noInertia || this._times.length < 2;
	        map.fire('dragend', e);
	        if (noInertia) {
	          map.fire('moveend');
	        } else {
	          this._prunePositions(+new Date());
	          var direction = this._lastPos.subtract(this._positions[0]),
	            duration = (this._lastTime - this._times[0]) / 1000,
	            ease = options.easeLinearity,
	            speedVector = direction.multiplyBy(ease / duration),
	            speed = speedVector.distanceTo([0, 0]),
	            limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
	            limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	            decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
	            offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	          if (!offset.x && !offset.y) {
	            map.fire('moveend');
	          } else {
	            offset = map._limitOffset(offset, map.options.maxBounds);
	            requestAnimFrame(function () {
	              map.panBy(offset, {
	                duration: decelerationDuration,
	                easeLinearity: ease,
	                noMoveStart: true,
	                animate: true
	              });
	            });
	          }
	        }
	      }
	    });

	    // @section Handlers
	    // @property dragging: Handler
	    // Map dragging handler (by both mouse and touch).
	    Map.addInitHook('addHandler', 'dragging', Drag);

	    /*
	     * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	     */

	    // @namespace Map
	    // @section Keyboard Navigation Options
	    Map.mergeOptions({
	      // @option keyboard: Boolean = true
	      // Makes the map focusable and allows users to navigate the map with keyboard
	      // arrows and `+`/`-` keys.
	      keyboard: true,
	      // @option keyboardPanDelta: Number = 80
	      // Amount of pixels to pan when pressing an arrow key.
	      keyboardPanDelta: 80
	    });
	    var Keyboard = Handler.extend({
	      keyCodes: {
	        left: [37],
	        right: [39],
	        down: [40],
	        up: [38],
	        zoomIn: [187, 107, 61, 171],
	        zoomOut: [189, 109, 54, 173]
	      },
	      initialize: function (map) {
	        this._map = map;
	        this._setPanDelta(map.options.keyboardPanDelta);
	        this._setZoomDelta(map.options.zoomDelta);
	      },
	      addHooks: function () {
	        var container = this._map._container;

	        // make the container focusable by tabbing
	        if (container.tabIndex <= 0) {
	          container.tabIndex = '0';
	        }
	        on(container, {
	          focus: this._onFocus,
	          blur: this._onBlur,
	          mousedown: this._onMouseDown
	        }, this);
	        this._map.on({
	          focus: this._addHooks,
	          blur: this._removeHooks
	        }, this);
	      },
	      removeHooks: function () {
	        this._removeHooks();
	        off(this._map._container, {
	          focus: this._onFocus,
	          blur: this._onBlur,
	          mousedown: this._onMouseDown
	        }, this);
	        this._map.off({
	          focus: this._addHooks,
	          blur: this._removeHooks
	        }, this);
	      },
	      _onMouseDown: function () {
	        if (this._focused) {
	          return;
	        }
	        var body = document.body,
	          docEl = document.documentElement,
	          top = body.scrollTop || docEl.scrollTop,
	          left = body.scrollLeft || docEl.scrollLeft;
	        this._map._container.focus();
	        window.scrollTo(left, top);
	      },
	      _onFocus: function () {
	        this._focused = true;
	        this._map.fire('focus');
	      },
	      _onBlur: function () {
	        this._focused = false;
	        this._map.fire('blur');
	      },
	      _setPanDelta: function (panDelta) {
	        var keys = this._panKeys = {},
	          codes = this.keyCodes,
	          i,
	          len;
	        for (i = 0, len = codes.left.length; i < len; i++) {
	          keys[codes.left[i]] = [-1 * panDelta, 0];
	        }
	        for (i = 0, len = codes.right.length; i < len; i++) {
	          keys[codes.right[i]] = [panDelta, 0];
	        }
	        for (i = 0, len = codes.down.length; i < len; i++) {
	          keys[codes.down[i]] = [0, panDelta];
	        }
	        for (i = 0, len = codes.up.length; i < len; i++) {
	          keys[codes.up[i]] = [0, -1 * panDelta];
	        }
	      },
	      _setZoomDelta: function (zoomDelta) {
	        var keys = this._zoomKeys = {},
	          codes = this.keyCodes,
	          i,
	          len;
	        for (i = 0, len = codes.zoomIn.length; i < len; i++) {
	          keys[codes.zoomIn[i]] = zoomDelta;
	        }
	        for (i = 0, len = codes.zoomOut.length; i < len; i++) {
	          keys[codes.zoomOut[i]] = -zoomDelta;
	        }
	      },
	      _addHooks: function () {
	        on(document, 'keydown', this._onKeyDown, this);
	      },
	      _removeHooks: function () {
	        off(document, 'keydown', this._onKeyDown, this);
	      },
	      _onKeyDown: function (e) {
	        if (e.altKey || e.ctrlKey || e.metaKey) {
	          return;
	        }
	        var key = e.keyCode,
	          map = this._map,
	          offset;
	        if (key in this._panKeys) {
	          if (!map._panAnim || !map._panAnim._inProgress) {
	            offset = this._panKeys[key];
	            if (e.shiftKey) {
	              offset = toPoint(offset).multiplyBy(3);
	            }
	            if (map.options.maxBounds) {
	              offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
	            }
	            if (map.options.worldCopyJump) {
	              var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
	              map.panTo(newLatLng);
	            } else {
	              map.panBy(offset);
	            }
	          }
	        } else if (key in this._zoomKeys) {
	          map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	        } else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
	          map.closePopup();
	        } else {
	          return;
	        }
	        stop(e);
	      }
	    });

	    // @section Handlers
	    // @section Handlers
	    // @property keyboard: Handler
	    // Keyboard navigation handler.
	    Map.addInitHook('addHandler', 'keyboard', Keyboard);

	    /*
	     * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	     */

	    // @namespace Map
	    // @section Interaction Options
	    Map.mergeOptions({
	      // @section Mouse wheel options
	      // @option scrollWheelZoom: Boolean|String = true
	      // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	      // it will zoom to the center of the view regardless of where the mouse was.
	      scrollWheelZoom: true,
	      // @option wheelDebounceTime: Number = 40
	      // Limits the rate at which a wheel can fire (in milliseconds). By default
	      // user can't zoom via wheel more often than once per 40 ms.
	      wheelDebounceTime: 40,
	      // @option wheelPxPerZoomLevel: Number = 60
	      // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	      // mean a change of one full zoom level. Smaller values will make wheel-zooming
	      // faster (and vice versa).
	      wheelPxPerZoomLevel: 60
	    });
	    var ScrollWheelZoom = Handler.extend({
	      addHooks: function () {
	        on(this._map._container, 'wheel', this._onWheelScroll, this);
	        this._delta = 0;
	      },
	      removeHooks: function () {
	        off(this._map._container, 'wheel', this._onWheelScroll, this);
	      },
	      _onWheelScroll: function (e) {
	        var delta = getWheelDelta(e);
	        var debounce = this._map.options.wheelDebounceTime;
	        this._delta += delta;
	        this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	        if (!this._startTime) {
	          this._startTime = +new Date();
	        }
	        var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	        clearTimeout(this._timer);
	        this._timer = setTimeout(bind(this._performZoom, this), left);
	        stop(e);
	      },
	      _performZoom: function () {
	        var map = this._map,
	          zoom = map.getZoom(),
	          snap = this._map.options.zoomSnap || 0;
	        map._stop(); // stop panning and fly animations if any

	        // map the delta with a sigmoid function to -4..4 range leaning on -1..1
	        var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
	          d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
	          d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
	          delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	        this._delta = 0;
	        this._startTime = null;
	        if (!delta) {
	          return;
	        }
	        if (map.options.scrollWheelZoom === 'center') {
	          map.setZoom(zoom + delta);
	        } else {
	          map.setZoomAround(this._lastMousePos, zoom + delta);
	        }
	      }
	    });

	    // @section Handlers
	    // @property scrollWheelZoom: Handler
	    // Scroll wheel zoom handler.
	    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);

	    /*
	     * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
	     * which otherwise is not fired by mobile Safari.
	     */

	    var tapHoldDelay = 600;

	    // @namespace Map
	    // @section Interaction Options
	    Map.mergeOptions({
	      // @section Touch interaction options
	      // @option tapHold: Boolean
	      // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
	      tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
	      // @option tapTolerance: Number = 15
	      // The max number of pixels a user can shift his finger during touch
	      // for it to be considered a valid tap.
	      tapTolerance: 15
	    });
	    var TapHold = Handler.extend({
	      addHooks: function () {
	        on(this._map._container, 'touchstart', this._onDown, this);
	      },
	      removeHooks: function () {
	        off(this._map._container, 'touchstart', this._onDown, this);
	      },
	      _onDown: function (e) {
	        clearTimeout(this._holdTimeout);
	        if (e.touches.length !== 1) {
	          return;
	        }
	        var first = e.touches[0];
	        this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	        this._holdTimeout = setTimeout(bind(function () {
	          this._cancel();
	          if (!this._isTapValid()) {
	            return;
	          }

	          // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
	          on(document, 'touchend', preventDefault);
	          on(document, 'touchend touchcancel', this._cancelClickPrevent);
	          this._simulateEvent('contextmenu', first);
	        }, this), tapHoldDelay);
	        on(document, 'touchend touchcancel contextmenu', this._cancel, this);
	        on(document, 'touchmove', this._onMove, this);
	      },
	      _cancelClickPrevent: function cancelClickPrevent() {
	        off(document, 'touchend', preventDefault);
	        off(document, 'touchend touchcancel', cancelClickPrevent);
	      },
	      _cancel: function () {
	        clearTimeout(this._holdTimeout);
	        off(document, 'touchend touchcancel contextmenu', this._cancel, this);
	        off(document, 'touchmove', this._onMove, this);
	      },
	      _onMove: function (e) {
	        var first = e.touches[0];
	        this._newPos = new Point(first.clientX, first.clientY);
	      },
	      _isTapValid: function () {
	        return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	      },
	      _simulateEvent: function (type, e) {
	        var simulatedEvent = new MouseEvent(type, {
	          bubbles: true,
	          cancelable: true,
	          view: window,
	          // detail: 1,
	          screenX: e.screenX,
	          screenY: e.screenY,
	          clientX: e.clientX,
	          clientY: e.clientY
	          // button: 2,
	          // buttons: 2
	        });
	        simulatedEvent._simulated = true;
	        e.target.dispatchEvent(simulatedEvent);
	      }
	    });

	    // @section Handlers
	    // @property tapHold: Handler
	    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
	    Map.addInitHook('addHandler', 'tapHold', TapHold);

	    /*
	     * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	     */

	    // @namespace Map
	    // @section Interaction Options
	    Map.mergeOptions({
	      // @section Touch interaction options
	      // @option touchZoom: Boolean|String = *
	      // Whether the map can be zoomed by touch-dragging with two fingers. If
	      // passed `'center'`, it will zoom to the center of the view regardless of
	      // where the touch events (fingers) were. Enabled for touch-capable web
	      // browsers.
	      touchZoom: Browser.touch,
	      // @option bounceAtZoomLimits: Boolean = true
	      // Set it to false if you don't want the map to zoom beyond min/max zoom
	      // and then bounce back when pinch-zooming.
	      bounceAtZoomLimits: true
	    });
	    var TouchZoom = Handler.extend({
	      addHooks: function () {
	        addClass(this._map._container, 'leaflet-touch-zoom');
	        on(this._map._container, 'touchstart', this._onTouchStart, this);
	      },
	      removeHooks: function () {
	        removeClass(this._map._container, 'leaflet-touch-zoom');
	        off(this._map._container, 'touchstart', this._onTouchStart, this);
	      },
	      _onTouchStart: function (e) {
	        var map = this._map;
	        if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) {
	          return;
	        }
	        var p1 = map.mouseEventToContainerPoint(e.touches[0]),
	          p2 = map.mouseEventToContainerPoint(e.touches[1]);
	        this._centerPoint = map.getSize()._divideBy(2);
	        this._startLatLng = map.containerPointToLatLng(this._centerPoint);
	        if (map.options.touchZoom !== 'center') {
	          this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
	        }
	        this._startDist = p1.distanceTo(p2);
	        this._startZoom = map.getZoom();
	        this._moved = false;
	        this._zooming = true;
	        map._stop();
	        on(document, 'touchmove', this._onTouchMove, this);
	        on(document, 'touchend touchcancel', this._onTouchEnd, this);
	        preventDefault(e);
	      },
	      _onTouchMove: function (e) {
	        if (!e.touches || e.touches.length !== 2 || !this._zooming) {
	          return;
	        }
	        var map = this._map,
	          p1 = map.mouseEventToContainerPoint(e.touches[0]),
	          p2 = map.mouseEventToContainerPoint(e.touches[1]),
	          scale = p1.distanceTo(p2) / this._startDist;
	        this._zoom = map.getScaleZoom(scale, this._startZoom);
	        if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) {
	          this._zoom = map._limitZoom(this._zoom);
	        }
	        if (map.options.touchZoom === 'center') {
	          this._center = this._startLatLng;
	          if (scale === 1) {
	            return;
	          }
	        } else {
	          // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
	          var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
	          if (scale === 1 && delta.x === 0 && delta.y === 0) {
	            return;
	          }
	          this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
	        }
	        if (!this._moved) {
	          map._moveStart(true, false);
	          this._moved = true;
	        }
	        cancelAnimFrame(this._animRequest);
	        var moveFn = bind(map._move, map, this._center, this._zoom, {
	          pinch: true,
	          round: false
	        }, undefined);
	        this._animRequest = requestAnimFrame(moveFn, this, true);
	        preventDefault(e);
	      },
	      _onTouchEnd: function () {
	        if (!this._moved || !this._zooming) {
	          this._zooming = false;
	          return;
	        }
	        this._zooming = false;
	        cancelAnimFrame(this._animRequest);
	        off(document, 'touchmove', this._onTouchMove, this);
	        off(document, 'touchend touchcancel', this._onTouchEnd, this);

	        // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
	        if (this._map.options.zoomAnimation) {
	          this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
	        } else {
	          this._map._resetView(this._center, this._map._limitZoom(this._zoom));
	        }
	      }
	    });

	    // @section Handlers
	    // @property touchZoom: Handler
	    // Touch zoom handler.
	    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	    Map.BoxZoom = BoxZoom;
	    Map.DoubleClickZoom = DoubleClickZoom;
	    Map.Drag = Drag;
	    Map.Keyboard = Keyboard;
	    Map.ScrollWheelZoom = ScrollWheelZoom;
	    Map.TapHold = TapHold;
	    Map.TouchZoom = TouchZoom;
	    exports$1.Bounds = Bounds;
	    exports$1.Browser = Browser;
	    exports$1.CRS = CRS;
	    exports$1.Canvas = Canvas;
	    exports$1.Circle = Circle;
	    exports$1.CircleMarker = CircleMarker;
	    exports$1.Class = Class;
	    exports$1.Control = Control;
	    exports$1.DivIcon = DivIcon;
	    exports$1.DivOverlay = DivOverlay;
	    exports$1.DomEvent = DomEvent;
	    exports$1.DomUtil = DomUtil;
	    exports$1.Draggable = Draggable;
	    exports$1.Evented = Evented;
	    exports$1.FeatureGroup = FeatureGroup;
	    exports$1.GeoJSON = GeoJSON;
	    exports$1.GridLayer = GridLayer;
	    exports$1.Handler = Handler;
	    exports$1.Icon = Icon;
	    exports$1.ImageOverlay = ImageOverlay;
	    exports$1.LatLng = LatLng;
	    exports$1.LatLngBounds = LatLngBounds;
	    exports$1.Layer = Layer;
	    exports$1.LayerGroup = LayerGroup;
	    exports$1.LineUtil = LineUtil;
	    exports$1.Map = Map;
	    exports$1.Marker = Marker;
	    exports$1.Mixin = Mixin;
	    exports$1.Path = Path;
	    exports$1.Point = Point;
	    exports$1.PolyUtil = PolyUtil;
	    exports$1.Polygon = Polygon;
	    exports$1.Polyline = Polyline;
	    exports$1.Popup = Popup;
	    exports$1.PosAnimation = PosAnimation;
	    exports$1.Projection = index;
	    exports$1.Rectangle = Rectangle;
	    exports$1.Renderer = Renderer;
	    exports$1.SVG = SVG;
	    exports$1.SVGOverlay = SVGOverlay;
	    exports$1.TileLayer = TileLayer;
	    exports$1.Tooltip = Tooltip;
	    exports$1.Transformation = Transformation;
	    exports$1.Util = Util;
	    exports$1.VideoOverlay = VideoOverlay;
	    exports$1.bind = bind;
	    exports$1.bounds = toBounds;
	    exports$1.canvas = canvas;
	    exports$1.circle = circle;
	    exports$1.circleMarker = circleMarker;
	    exports$1.control = control;
	    exports$1.divIcon = divIcon;
	    exports$1.extend = extend;
	    exports$1.featureGroup = featureGroup;
	    exports$1.geoJSON = geoJSON;
	    exports$1.geoJson = geoJson;
	    exports$1.gridLayer = gridLayer;
	    exports$1.icon = icon;
	    exports$1.imageOverlay = imageOverlay;
	    exports$1.latLng = toLatLng;
	    exports$1.latLngBounds = toLatLngBounds;
	    exports$1.layerGroup = layerGroup;
	    exports$1.map = createMap;
	    exports$1.marker = marker;
	    exports$1.point = toPoint;
	    exports$1.polygon = polygon;
	    exports$1.polyline = polyline;
	    exports$1.popup = popup;
	    exports$1.rectangle = rectangle;
	    exports$1.setOptions = setOptions;
	    exports$1.stamp = stamp;
	    exports$1.svg = svg;
	    exports$1.svgOverlay = svgOverlay;
	    exports$1.tileLayer = tileLayer;
	    exports$1.tooltip = tooltip;
	    exports$1.transformation = toTransformation;
	    exports$1.version = version;
	    exports$1.videoOverlay = videoOverlay;
	    var oldL = window.L;
	    exports$1.noConflict = function () {
	      window.L = oldL;
	      return this;
	    };
	    // Always export us to window global (see #2364)
	    window.L = exports$1;
	  });
	})(leafletSrc, leafletSrc.exports);
	var leafletSrcExports = leafletSrc.exports;
	var L$1 = /*@__PURE__*/getDefaultExportFromCjs(leafletSrcExports);

	function initLeaflet() {
	  const el = document.querySelector('[data-map]');
	  if (!el) return;
	  const map = L$1.map(el).setView([44.85, 0.4], 7);
	  L$1.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	    attribution: '&copy; OpenStreetMap'
	  }).addTo(map);
	  L$1.marker([48.8566, 2.3522]).addTo(map);
	  const fix = () => {
	    map.invalidateSize();
	    map._onResize();
	    map.setZoom(map.getZoom());
	  };
	  setTimeout(fix, 100);
	  setTimeout(fix, 300);
	  return map;
	}

	var leaflet = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: initLeaflet
	});

	function initNotification() {
	  DOM.notifications.forEach(notification => {
	    const itemNotificationButton = notification.querySelector('button');
	    itemNotificationButton.addEventListener('click', () => {
	      notification.classList.add('m-notification--close');
	    });
	  });
	}

	var notification = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: initNotification
	});

	function dataViz() {
	  const dataVizAssembleeElus = document.getElementById('dataviz-assemblee');
	  if (dataVizAssembleeElus) {
	    loadChartJS().then(() => {
	      const dataVizCanvas = dataVizAssembleeElus.querySelector('.o-data-viz__pie_canvas');
	      const percents = [];
	      const colors = [];
	      const jsonDatas = document.getElementById('dataviz-assemblee-datas').value;
	      if (jsonDatas) {
	        const obj = JSON.parse(jsonDatas);
	        for (const i in obj) {
	          percents.push(obj[i][0]);
	          colors.push(obj[i][1]);
	        }
	        const datasetAssemblee = [{
	          data: percents,
	          backgroundColor: colors,
	          borderWidth: 0
	        }];
	        const datavizAssemblee = new Chart(dataVizCanvas, {
	          type: 'pie',
	          data: {
	            datasets: datasetAssemblee
	          },
	          options: {
	            responsive: true,
	            rotation: 1 * Math.PI,
	            circumference: 1 * Math.PI,
	            animateRotate: false,
	            animateScale: true,
	            animation: {
	              duration: 1500,
	              easing: 'easeInOutQuart'
	            }
	          }
	        });
	        datavizAssemblee.update();
	      }
	    }).catch(error => {
	      // console.error('Erreur de chargement de Chart.js:', error);
	    });
	  }
	}
	function loadChartJS() {
	  return new Promise((resolve, reject) => {
	    // Vérifier si Chart.js est déjà chargé
	    if (typeof Chart !== 'undefined') {
	      resolve();
	      return;
	    }

	    // Vérifier si le script est déjà en cours de chargement
	    const existingScript = document.querySelector('script[src*="Chart.js"]');
	    if (existingScript) {
	      existingScript.addEventListener('load', resolve);
	      existingScript.addEventListener('error', reject);
	      return;
	    }

	    // Charger le script
	    const script = document.createElement('script');
	    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.3/Chart.bundle.min.js';
	    script.onload = resolve;
	    script.onerror = reject;
	    document.head.appendChild(script);
	  });
	}

	var dataViz$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: dataViz
	});

	/**
	 * Gestionnaire d'accordéon accessible
	 * Gère l'ouverture/fermeture de panels avec animation et accessibilité ARIA
	 */
	class ToggleManager {
	  constructor() {
	    this.containers = [];
	    this.animationDuration = 300; // ms
	  }
	  init() {
	    // Récupérer tous les conteneurs d'accordéon
	    const containers = document.querySelectorAll('[data-toggle-container]');

	    // Si aucun conteneur trouvé, ne rien faire
	    if (!containers.length) return;
	    containers.forEach(container => this.initContainer(container));
	  }
	  initContainer(container) {
	    const allowMultiple = container.hasAttribute('data-toggle-allow-multiple');
	    const buttons = container.querySelectorAll('.toggle-head .a-btn--toggle');

	    // Stocker la configuration du conteneur
	    this.containers.push({
	      element: container,
	      allowMultiple,
	      buttons: Array.from(buttons)
	    });
	    buttons.forEach(btn => {
	      // Récupérer le panel associé
	      const panel = this.getAssociatedPanel(btn);
	      if (!panel) return;

	      // Configuration initiale
	      this.setupPanel(panel);

	      // Gérer l'état initial (ouvert ou fermé)
	      const expandedAttr = btn.getAttribute('aria-expanded');
	      const isExpanded = expandedAttr === 'true';
	      if (isExpanded) {
	        // Seulement traiter les panels ouverts au chargement
	        this.openPanel(panel, btn, false);
	      } else {
	        // S'assurer que aria-expanded est défini à false si absent ou vide
	        btn.setAttribute('aria-expanded', 'false');
	        // L'état fermé est géré par CSS, pas besoin de JS
	      }

	      // Ajouter les écouteurs d'événements
	      btn.addEventListener('click', e => this.handleToggle(e, container, allowMultiple));

	      // Navigation au clavier
	      btn.addEventListener('keydown', e => this.handleKeyboard(e, container));
	    });
	  }
	  setupPanel(panel) {
	    // S'assurer que le panel a un role="region"
	    if (!panel.hasAttribute('role')) {
	      panel.setAttribute('role', 'region');
	    }
	  }
	  getAssociatedPanel(btn) {
	    // Priorité à aria-controls
	    const controlsId = btn.getAttribute('aria-controls');
	    if (controlsId) {
	      return document.getElementById(controlsId);
	    }

	    // Fallback sur data-target
	    const target = btn.getAttribute('data-target');
	    if (target) {
	      return target.startsWith('#') ? document.querySelector(target) : document.getElementById(target);
	    }
	    return null;
	  }
	  handleToggle(e, container, allowMultiple) {
	    e.preventDefault();
	    const btn = e.currentTarget;
	    const panel = this.getAssociatedPanel(btn);
	    if (!panel) return;
	    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
	    if (isExpanded) {
	      // Fermer le panel
	      this.closePanel(panel, btn, true);
	    } else {
	      // Mode accordéon : fermer les autres panels
	      if (!allowMultiple) {
	        this.closeOtherPanels(container, btn);
	      }

	      // Ouvrir le panel
	      this.openPanel(panel, btn, true);
	    }
	  }
	  openPanel(panel, btn, animated = true) {
	    const body = panel.querySelector('.toggle-panel__body');
	    if (!body) return;

	    // Mettre à jour ARIA
	    btn.setAttribute('aria-expanded', 'true');

	    // Retirer l'attribut inert pour rendre le contenu accessible
	    panel.removeAttribute('inert');

	    // Ajouter la classe d'état
	    btn.classList.add('is-open');
	    if (animated) {
	      // Classe pour activer la transition
	      panel.classList.add('is-transitioning');

	      // Calculer la hauteur cible
	      const targetHeight = body.offsetHeight;

	      // Partir de 0
	      panel.style.height = '0px';

	      // Force reflow
	      panel.offsetHeight;

	      // Animer vers la hauteur cible
	      panel.style.height = `${targetHeight}px`;

	      // Après l'animation : passer à is-open et nettoyer
	      setTimeout(() => {
	        panel.classList.remove('is-transitioning');
	        panel.classList.add('is-open');
	        panel.style.height = '';
	      }, this.animationDuration);
	    } else {
	      // Pas d'animation : directement ouvert
	      panel.classList.add('is-open');
	      panel.style.height = '';
	    }
	  }
	  closePanel(panel, btn, animated = true) {
	    // Mettre à jour ARIA
	    btn.setAttribute('aria-expanded', 'false');

	    // Ajouter l'attribut inert pour rendre le contenu inaccessible
	    panel.setAttribute('inert', '');

	    // Retirer la classe d'état du bouton
	    btn.classList.remove('is-open');
	    if (animated) {
	      // Fixer la hauteur actuelle AVANT de retirer .is-open
	      const currentHeight = panel.offsetHeight;
	      panel.style.height = `${currentHeight}px`;

	      // Force reflow pour appliquer la hauteur fixe
	      panel.offsetHeight;

	      // Maintenant retirer .is-open et ajouter .is-transitioning
	      panel.classList.remove('is-open');
	      panel.classList.add('is-transitioning');

	      // Force reflow avant d'animer
	      panel.offsetHeight;

	      // Animer vers 0
	      panel.style.height = '0px';

	      // Après l'animation : nettoyer
	      setTimeout(() => {
	        panel.classList.remove('is-transitioning');
	        panel.style.height = '';
	      }, this.animationDuration);
	    } else {
	      // Pas d'animation : directement fermé
	      panel.classList.remove('is-open');
	      panel.style.height = '';
	    }
	  }
	  closeOtherPanels(container, currentBtn) {
	    // CORRECTION : Retirer le ">" pour chercher dans tous les descendants
	    const buttons = container.querySelectorAll('.toggle-head .a-btn--toggle');
	    buttons.forEach(btn => {
	      if (btn === currentBtn) return;
	      const panel = this.getAssociatedPanel(btn);
	      if (panel && btn.getAttribute('aria-expanded') === 'true') {
	        this.closePanel(panel, btn, true);
	      }
	    });
	  }
	  handleKeyboard(e, container) {
	    const buttons = Array.from(container.querySelectorAll('.toggle-head .a-btn--toggle'));
	    const currentIndex = buttons.indexOf(e.currentTarget);
	    let nextIndex;
	    switch (e.key) {
	      case 'ArrowDown':
	      case 'Down':
	        e.preventDefault();
	        nextIndex = (currentIndex + 1) % buttons.length;
	        buttons[nextIndex].focus();
	        break;
	      case 'ArrowUp':
	      case 'Up':
	        e.preventDefault();
	        nextIndex = currentIndex - 1;
	        if (nextIndex < 0) nextIndex = buttons.length - 1;
	        buttons[nextIndex].focus();
	        break;
	      case 'Home':
	        e.preventDefault();
	        buttons[0].focus();
	        break;
	      case 'End':
	        e.preventDefault();
	        buttons[buttons.length - 1].focus();
	        break;
	    }
	  }

	  // Méthode publique pour réinitialiser/mettre à jour
	  refresh() {
	    this.containers = [];
	    this.init();
	  }

	  // Méthode publique pour ouvrir un panel spécifique
	  openPanelById(panelId) {
	    const panel = document.getElementById(panelId);
	    if (!panel) return;
	    const btn = document.querySelector(`[aria-controls="${panelId}"]`);
	    if (btn) {
	      this.openPanel(panel, btn, true);
	    }
	  }

	  // Méthode publique pour fermer un panel spécifique
	  closePanelById(panelId) {
	    const panel = document.getElementById(panelId);
	    if (!panel) return;
	    const btn = document.querySelector(`[aria-controls="${panelId}"]`);
	    if (btn) {
	      this.closePanel(panel, btn, true);
	    }
	  }
	}

	// Instance singleton
	let instance = null;

	// Export par défaut : initialise automatiquement
	function initToggleManager() {
	  if (!instance) {
	    instance = new ToggleManager();
	  }
	  instance.init();
	  return instance;
	}

	var toggle = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ToggleManager: ToggleManager,
		default: initToggleManager
	});

	// modules/select-departement.js

	/* const SVG_PATHS = {
	  prod : '/themes/custom/naq_custom_transports/img/map-aquitaine-departements.svg',
	  // dev :  '../assets/img/svg/map-aquitaine-departements.svg'
	  dev :  './img/svg/map-aquitaine-departements.svg'
	}; */

	function getSvgPath() {
	  // Environnement de production
	  if (!IS_NOT_PROD) {
	    return '/themes/dsnaq/storybook/dist/assets/img/svg/map-aquitaine-departements.svg';
	  }

	  // Storybook (port 6006 ou hostname contient 'storybook')
	  if (location.port === '6006' || location.port === '63342' || location.hostname.includes('storybook')) {
	    return '/assets/img/svg/map-aquitaine-departements.svg';
	  }

	  // Projet local (localhost:3000)
	  return '../assets/img/svg/map-aquitaine-departements.svg';
	}
	const SVG_PATH = getSvgPath();

	// --- État de module (accessible dans toutes les fonctions) ---
	const state = {
	  svg: null,
	  // <svg> root
	  container: null,
	  // #dept-map-nav
	  ul: null,
	  // ul.departements
	  currentDeptNum: '' // code courant
	};
	function selectDept() {
	  state.container = DOM?.selectDepartement?.querySelector?.('#dept-map-nav') || document.querySelector('#dept-map-nav');
	  if (!state.container) {
	    // console.warn('[selectDept] Container #dept-map-nav introuvable');
	    return;
	  }
	  state.ul = DOM?.selectDepartement?.querySelector?.('ul.departements') || document.querySelector('ul.departements');

	  // Déjà chargé ?
	  const existingSvg = state.container.firstElementChild instanceof SVGSVGElement ? state.container.firstElementChild : null;
	  if (state.container.dataset.mapReady === 'true' && existingSvg) {
	    state.svg = existingSvg;
	    postInit();
	    return;
	  }
	  const url = SVG_PATH;
	  loadInlineSVG(url, state.container).then(svg => {
	    state.svg = svg;
	    state.container.dataset.mapReady = 'true';
	    postInit();
	  }).catch(() => {
	    state.container.dataset.mapReady = 'false';
	  });
	}

	/* ------------------ helpers ------------------ */

	function loadInlineSVG(url, container) {
	  const fetchOpts = IS_NOT_PROD ? {
	    cache: 'no-store'
	  } : {};
	  return fetch(url, fetchOpts).then(res => {
	    if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText}`);
	    return res.text();
	  }).then(svgText => {
	    const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
	    const svgEl = doc.documentElement;

	    // SVG responsive : on conserve viewBox, on retire width/height
	    svgEl.removeAttribute('width');
	    svgEl.removeAttribute('height');
	    const imported = document.importNode(svgEl, true);
	    container.replaceChildren(imported);
	    return imported;
	  });
	}

	/**
	 * Traitements "post-chargement" : branche tes listeners, styles, etc.
	 */
	function postInit() {
	  if (!state.svg) return;
	  eventsListUl();
	  eventsMapSvg();

	  // Event custom si tu veux écouter ailleurs
	  state.container.dispatchEvent(new CustomEvent('deptmap:ready', {
	    detail: {
	      svg: state.svg
	    }
	  }));
	}
	function eventsListUl() {
	  if (!state.ul) return;

	  // Éviter les doublons si appelé plusieurs fois
	  if (state.ul.dataset.eventsAttached === 'true') return;
	  state.ul.dataset.eventsAttached = 'true';

	  // Events sur la liste UL > LI
	  state.ul.querySelectorAll('.a-link').forEach(link => {
	    link.addEventListener('mouseover', e => {
	      unFillAllDepts();
	      state.currentDeptNum = e.currentTarget.getAttribute('data-dept-num') || '';
	      fillDept();
	    });

	    // Focus/keyboard
	    link.addEventListener('focus', e => {
	      unFillAllDepts();
	      state.currentDeptNum = e.currentTarget.getAttribute('data-dept-num') || '';
	      fillDept();
	    });
	  });

	  // Reset quand on quitte la liste
	  state.ul.addEventListener('mouseleave', () => {
	    unFillAllDepts();
	    state.currentDeptNum = '';
	  });
	}
	function eventsMapSvg() {
	  if (!state.svg) return;

	  // Éviter les doublons
	  if (state.svg.dataset.eventsAttached === 'true') return;
	  state.svg.dataset.eventsAttached = 'true';

	  // Populate tous les liens une seule fois au chargement (optimal)
	  populateAllDeptLinks();

	  // Events sur la map svg (uniquement souris)
	  state.svg.querySelectorAll('path[data-target_dept]').forEach(path => {
	    path.style.pointerEvents = 'all';
	    path.style.cursor = 'pointer';
	    path.addEventListener('mouseenter', e => {
	      state.currentDeptNum = e.currentTarget.getAttribute('data-target_dept') || '';
	      unFillAllDepts();
	      fillDept();
	    });
	  });

	  // Reset quand on quitte la carte
	  state.svg.addEventListener('mouseleave', () => {
	    unFillAllDepts();
	    state.currentDeptNum = '';
	  });
	}

	/**
	 * Populate tous les liens des départements SVG à partir de la liste UL
	 * Appelé une seule fois au chargement du SVG (optimal)
	 */
	function populateAllDeptLinks() {
	  if (!state.svg || !state.ul) return;

	  // Pour chaque lien dans la liste UL
	  state.ul.querySelectorAll('a[data-dept-num]').forEach(listLink => {
	    const deptNum = listLink.getAttribute('data-dept-num');
	    const href = listLink.getAttribute('href');
	    if (!deptNum || !href) return;

	    // Trouver le groupe SVG correspondant
	    const code = CSS.escape(String(deptNum));
	    const svgGroup = state.svg.querySelector(`g.departement-${code}`);
	    if (!svgGroup) return;

	    // Trouver le lien <a> dans ce groupe
	    const svgLink = svgGroup.querySelector('a');
	    if (svgLink) {
	      // Restaurer le href (on l'avait retiré pour désactiver la tabulation)
	      svgLink.setAttribute('href', href);

	      // Garder les attributs pour désactiver la navigation clavier
	      svgLink.setAttribute('tabindex', '-1');
	      svgLink.setAttribute('role', 'presentation');

	      // Le lien fonctionne à la souris, mais pas au clavier
	      svgLink.addEventListener('keydown', e => {
	        e.preventDefault();
	        e.stopPropagation();
	      });
	    }
	  });
	}
	function unFillAllDepts() {
	  if (!state.svg) return;

	  // Re-init visuellement tous les départements
	  state.svg.querySelectorAll('path.filled').forEach(elt => {
	    elt.classList.remove('filled');
	    elt.style.fill = '';
	    elt.style.stroke = '';
	    elt.style.filter = '';
	  });
	  state.svg.querySelectorAll('g[data-dept]').forEach(elt => {
	    elt.classList.remove(CLASS.IS_ACTIVE);
	  });

	  // Reset le lien actif dans la liste
	  if (state.ul) {
	    state.ul.querySelectorAll(`.a-link.${CLASS.IS_ACTIVE}`).forEach(link => {
	      link.classList.remove(CLASS.IS_ACTIVE);
	    });
	  }
	}
	function fillDept() {
	  if (!state.svg || !state.currentDeptNum) return;

	  // Paths du département
	  const code = CSS.escape(String(state.currentDeptNum));
	  const deptPaths = state.svg.querySelectorAll(`path[data-target_dept="${code}"]`);

	  // Style et ordre d'affichage
	  deptPaths.forEach(p => {
	    p.style.fill = '#F6E8DE';
	    p.style.stroke = '#B48161';
	    p.style.filter = 'url(#shadow)';
	    p.classList.add('filled');

	    // Amener le groupe du département tout en haut (superposition)
	    const g = p.closest('g');
	    if (g?.parentNode) {
	      g.parentNode.appendChild(g);
	    }
	  });

	  // Libellé département (fond rouge)
	  state.svg.querySelector(`g[data-dept="${code}"]`)?.classList.add(CLASS.IS_ACTIVE);

	  // Highlight le LI du département dans la liste
	  state.ul?.querySelector(`a[data-dept-num="${code}"]`)?.classList.add(CLASS.IS_ACTIVE);
	}

	var selectDepartement = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: selectDept
	});

	/**
	 * FormValidator - Librairie de validation de formulaires accessible
	 * Respecte les standards WCAG et ARIA
	 * @version 1.0.1
	 */

	class FormValidator {
	  constructor(formSelector, options = {}) {
	    this.form = document.querySelector(formSelector);
	    if (!this.form) {
	      throw new Error(`Formulaire "${formSelector}" introuvable`);
	    }
	    this.options = {
	      liveRegionId: 'form-live-region',
	      errorClass: 'field-error',
	      errorMessageClass: 'a-hint--error',
	      errorMessageTag: 'p',
	      validateOnBlur: true,
	      validateOnInput: false,
	      submitOnSuccess: true,
	      ...options
	    };
	    this.fields = new Map();
	    this.liveRegion = null;
	    this.hasCustomSuccessCallback = false;
	    this.init();
	  }

	  /**
	   * Initialisation de la librairie
	   */
	  init() {
	    this.createLiveRegion();
	    this.detectFields();
	    this.attachEvents();
	  }

	  /**
	   * Création de la zone live ARIA pour les messages d'erreur
	   */
	  createLiveRegion() {
	    let liveRegion = document.getElementById(this.options.liveRegionId);
	    if (!liveRegion) {
	      liveRegion = document.createElement('div');
	      liveRegion.id = this.options.liveRegionId;
	      liveRegion.setAttribute('aria-live', 'polite');
	      liveRegion.setAttribute('aria-atomic', 'true');
	      liveRegion.setAttribute('role', 'status');
	      liveRegion.className = 'sr-only';
	      liveRegion.style.cssText = `
        position: absolute;
        left: -10000px;
        width: 1px;
        height: 1px;
        overflow: hidden;
      `;
	      document.body.appendChild(liveRegion);
	    }
	    this.liveRegion = liveRegion;
	  }

	  /**
	   * Détection automatique des champs et construction des règles
	   */
	  detectFields() {
	    const fieldSelectors = ['input[type="text"]', 'input[type="email"]', 'input[type="url"]', 'input[type="tel"]', 'input[type="search"]', 'input[type="number"]', 'input[type="password"]', 'input[type="checkbox"]', 'input[type="radio"]', 'textarea', 'select'];
	    const fields = this.form.querySelectorAll(fieldSelectors.join(','));
	    fields.forEach(field => {
	      if (!field.name) return;
	      const rules = this.buildRulesFromAttributes(field);

	      // Ne créer un validateur que si le champ a des règles OU est required
	      if (rules.length > 0 || field.required) {
	        this.fields.set(field, rules);
	        this.setupFieldAria(field);
	      }
	    });
	  }

	  /**
	   * Construction dynamique des règles depuis les attributs HTML
	   */
	  buildRulesFromAttributes(field) {
	    const rules = [];
	    const type = field.type;
	    const tagName = field.tagName.toLowerCase();

	    // Required
	    if (field.required) {
	      rules.push({
	        name: 'required',
	        validate: value => {
	          if (type === 'checkbox') return field.checked;
	          if (type === 'radio') {
	            const radioGroup = this.form.querySelectorAll(`input[name="${field.name}"]`);
	            return Array.from(radioGroup).some(r => r.checked);
	          }
	          // Pour les selects, vérifier que ce n'est pas la valeur par défaut (-1, "", etc.)
	          if (tagName === 'select') {
	            return value && value !== '' && value !== '-1';
	          }
	          return value.trim() !== '';
	        },
	        message: field.getAttribute('data-error-required') || 'Ce champ est obligatoire'
	      });
	    }

	    // Min/Max length (pas pour select, uniquement pour input text et textarea)
	    if (tagName !== 'select' && type !== 'number') {
	      if (field.minLength && field.minLength > 0) {
	        rules.push({
	          name: 'minlength',
	          validate: value => !value || value.length >= field.minLength,
	          message: field.getAttribute('data-error-minlength') || `Minimum ${field.minLength} caractères requis`
	        });
	      }
	      if (field.maxLength && field.maxLength > 0) {
	        rules.push({
	          name: 'maxlength',
	          validate: value => value.length <= field.maxLength,
	          message: field.getAttribute('data-error-maxlength') || `Maximum ${field.maxLength} caractères autorisés`
	        });
	      }
	    }

	    // Min/Max value (uniquement pour input type="number")
	    if (type === 'number') {
	      if (field.min !== '' && field.min !== undefined) {
	        rules.push({
	          name: 'min',
	          validate: value => !value || parseFloat(value) >= parseFloat(field.min),
	          message: field.getAttribute('data-error-min') || `La valeur minimale est ${field.min}`
	        });
	      }
	      if (field.max !== '' && field.max !== undefined) {
	        rules.push({
	          name: 'max',
	          validate: value => !value || parseFloat(value) <= parseFloat(field.max),
	          message: field.getAttribute('data-error-max') || `La valeur maximale est ${field.max}`
	        });
	      }
	    }

	    // Pattern (pas pour select)
	    if (field.pattern && tagName !== 'select') {
	      const regex = new RegExp(field.pattern);
	      rules.push({
	        name: 'pattern',
	        validate: value => !value || regex.test(value),
	        message: field.getAttribute('data-error-pattern') || field.title || 'Le format est invalide'
	      });
	    }

	    // Type-specific validations
	    if (type === 'email') {
	      rules.push({
	        name: 'email',
	        validate: value => {
	          if (!value) return true;
	          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	          return emailRegex.test(value);
	        },
	        message: field.getAttribute('data-error-email') || 'Adresse email invalide'
	      });
	    }
	    if (type === 'tel') {
	      rules.push({
	        name: 'tel',
	        validate: value => {
	          if (!value) return true;
	          const telRegex = /^(?:\+33|0)[1-9](?:[ .-]?\d{2}){4}$/;
	          return telRegex.test(value);
	        },
	        message: field.getAttribute('data-error-tel') || 'Numéro de téléphone invalide'
	      });
	    }
	    if (type === 'url') {
	      rules.push({
	        name: 'url',
	        validate: value => {
	          if (!value) return true;
	          try {
	            new URL(value);
	            return true;
	          } catch {
	            return false;
	          }
	        },
	        message: field.getAttribute('data-error-url') || 'URL invalide'
	      });
	    }
	    return rules;
	  }

	  /**
	   * Configuration des attributs ARIA pour un champ
	   */
	  setupFieldAria(field) {
	    const fieldId = field.id || `field-${Math.random().toString(36).substr(2, 9)}`;
	    field.id = fieldId;

	    // Ajout de aria-required si nécessaire
	    if (field.required && !field.getAttribute('aria-required')) {
	      field.setAttribute('aria-required', 'true');
	    }

	    // Récupérer l'aria-describedby existant (pour les hints/helpers)
	    const existingDescribedBy = field.getAttribute('aria-describedby');

	    // Création du conteneur d'erreur associé
	    const errorId = `${fieldId}-error`;
	    let errorContainer = document.getElementById(errorId);
	    if (!errorContainer) {
	      errorContainer = document.createElement(this.options.errorMessageTag);
	      errorContainer.id = errorId;
	      errorContainer.className = this.options.errorMessageClass;
	      errorContainer.setAttribute('aria-live', 'polite');
	      errorContainer.setAttribute('aria-hidden', 'true');

	      // Pour les custom selects, insérer après l'élément .cs
	      const isSelect = field.tagName.toLowerCase() === 'select';
	      const customSelectWrapper = isSelect ? field.closest('.cs') : null;
	      if (customSelectWrapper) {
	        // Custom select : insérer après l'élément .cs
	        customSelectWrapper.parentElement.insertBefore(errorContainer, customSelectWrapper.nextSibling);
	      } else {
	        // Insertion normale après le champ
	        const parent = field.closest('.form-group') || field.closest('.m-label-field') || field.parentElement;
	        parent.appendChild(errorContainer);
	      }
	    }

	    // Combiner l'aria-describedby existant avec celui de l'erreur
	    // Format: "existing-id error-id" (séparés par un espace)
	    if (existingDescribedBy && existingDescribedBy.trim() !== '') {
	      // Ne pas ajouter l'errorId si déjà présent
	      if (!existingDescribedBy.includes(errorId)) {
	        field.setAttribute('aria-describedby', `${existingDescribedBy} ${errorId}`);
	      }
	    } else {
	      field.setAttribute('aria-describedby', errorId);
	    }

	    // Stocker l'aria-describedby original pour pouvoir le restaurer
	    if (existingDescribedBy && !field.dataset.originalDescribedby) {
	      field.dataset.originalDescribedby = existingDescribedBy;
	    }
	  }

	  /**
	   * Attachement des événements
	   */
	  attachEvents() {
	    // Validation à la soumission
	    this.form.addEventListener('submit', e => {
	      e.preventDefault();
	      if (this.validateAll()) {
	        this.onSuccess();
	      }
	    });

	    // Validation sur blur/input selon options
	    this.fields.forEach((rules, field) => {
	      const isSelect = field.tagName.toLowerCase() === 'select';
	      if (this.options.validateOnBlur && !isSelect) {
	        field.addEventListener('blur', () => this.validateField(field));
	      }
	      if (this.options.validateOnInput && !isSelect) {
	        field.addEventListener('input', () => this.validateField(field));
	      }

	      // Pour les radio/checkbox et select, validation sur change
	      if (field.type === 'checkbox' || field.type === 'radio' || isSelect) {
	        field.addEventListener('change', () => this.validateField(field));
	      }
	    });
	  }

	  /**
	   * Validation d'un champ individuel
	   */
	  validateField(field) {
	    const rules = this.fields.get(field);
	    if (!rules) return true;
	    const value = field.value;
	    let isValid = true;
	    let errorMessage = '';

	    // Test de chaque règle
	    for (const rule of rules) {
	      if (!rule.validate(value)) {
	        isValid = false;
	        errorMessage = rule.message;
	        break;
	      }
	    }

	    // Mise à jour de l'UI
	    this.updateFieldUI(field, isValid, errorMessage);
	    return isValid;
	  }

	  /**
	   * Mise à jour de l'interface pour un champ
	   */
	  updateFieldUI(field, isValid, errorMessage = '') {
	    const errorId = `${field.id}-error`;
	    const errorContainer = document.getElementById(errorId);
	    const isSelect = field.tagName.toLowerCase() === 'select';

	    // Pour les custom selects, cibler le bouton personnalisé
	    const customSelectButton = isSelect ? field.parentElement.querySelector('.cs__button') : null;
	    const targetElement = customSelectButton || field;
	    if (isValid) {
	      targetElement.classList.remove(this.options.errorClass);
	      field.setAttribute('aria-invalid', 'false');
	      if (errorContainer) {
	        errorContainer.textContent = '';
	        errorContainer.classList.remove('is-active');
	        errorContainer.setAttribute('aria-hidden', 'true');
	      }
	    } else {
	      targetElement.classList.add(this.options.errorClass);
	      field.setAttribute('aria-invalid', 'true');
	      if (errorContainer) {
	        errorContainer.textContent = errorMessage;
	        errorContainer.classList.add('is-active');
	        errorContainer.setAttribute('aria-hidden', 'false');
	      }

	      // Annonce dans la région live
	      this.announceLiveRegion(errorMessage);
	    }
	  }

	  /**
	   * Annonce d'un message dans la région live ARIA
	   */
	  announceLiveRegion(message) {
	    if (this.liveRegion) {
	      this.liveRegion.textContent = message;

	      // Clear après quelques secondes
	      setTimeout(() => {
	        this.liveRegion.textContent = '';
	      }, 3000);
	    }
	  }

	  /**
	   * Validation de tous les champs
	   */
	  validateAll() {
	    this.detectFields();
	    let isFormValid = true;
	    const errors = [];
	    this.fields.forEach((rules, field) => {
	      const isFieldValid = this.validateField(field);
	      if (!isFieldValid) {
	        isFormValid = false;
	        const label = this.getFieldLabel(field);
	        errors.push(label || field.name);
	      }
	    });

	    // Annonce globale des erreurs
	    if (!isFormValid && errors.length > 0) {
	      const message = `Le formulaire contient ${errors.length} erreur${errors.length > 1 ? 's' : ''}`;
	      this.announceLiveRegion(message);

	      // Focus sur le premier champ en erreur
	      const firstErrorField = Array.from(this.fields.keys()).find(field => field.classList.contains(this.options.errorClass));
	      if (firstErrorField) {
	        firstErrorField.focus();
	      }
	    }
	    return isFormValid;
	  }

	  /**
	   * Récupération du label d'un champ
	   */
	  getFieldLabel(field) {
	    const label = this.form.querySelector(`label[for="${field.id}"]`);
	    return label ? label.textContent.trim() : null;
	  }

	  /**
	   * Ajout d'une règle personnalisée
	   */
	  addCustomRule(fieldSelector, ruleName, validateFn, message) {
	    const field = this.form.querySelector(fieldSelector);
	    if (!field) return;
	    const rules = this.fields.get(field) || [];
	    rules.push({
	      name: ruleName,
	      validate: validateFn,
	      message
	    });
	    this.fields.set(field, rules);
	  }

	  /**
	   * Réinitialisation du formulaire
	   */
	  reset() {
	    this.form.reset();
	    this.fields.forEach((rules, field) => {
	      this.updateFieldUI(field, true);

	      // Restaurer l'aria-describedby original si nécessaire
	      if (field.dataset.originalDescribedby) {
	        const errorId = `${field.id}-error`;
	        const currentDescribedBy = field.getAttribute('aria-describedby');

	        // Si l'aria-describedby contient l'errorId, le retirer
	        if (currentDescribedBy && currentDescribedBy.includes(errorId)) {
	          field.setAttribute('aria-describedby', field.dataset.originalDescribedby);
	        }
	      }
	    });
	    if (this.liveRegion) {
	      this.liveRegion.textContent = '';
	    }
	  }

	  /**
	   * Callback de succès (à surcharger)
	   */
	  onSuccess() {
	    new FormData(this.form);
	    // console.log('Formulaire valide !');
	    // console.log('Données:', Object.fromEntries(formData));

	    this.announceLiveRegion('Formulaire envoyé avec succès');

	    // Si aucun callback personnalisé et submitOnSuccess activé, soumettre le formulaire
	    if (!this.hasCustomSuccessCallback && this.options.submitOnSuccess) {
	      // console.log('Soumission du formulaire...');

	      // Utiliser submit() pour soumettre directement sans re-déclencher l'événement
	      this.form.submit();
	    }
	  }

	  /**
	   * Destruction de l'instance
	   */
	  destroy() {
	    this.fields.clear();
	    if (this.liveRegion && this.liveRegion.parentElement) {
	      this.liveRegion.parentElement.removeChild(this.liveRegion);
	    }
	  }
	}

	/**
	 * Fonction d'initialisation par défaut
	 * Détecte et valide automatiquement tous les formulaires avec l'attribut data-validate
	 */
	function initFormValidators() {
	  // Sélection de tous les formulaires à valider
	  const forms = document.querySelectorAll('form[data-validate]');
	  if (forms.length === 0) {
	    // console.warn('FormValidator: Aucun formulaire avec [data-validate] trouvé');
	    return [];
	  }
	  const validators = [];
	  forms.forEach((form, index) => {
	    try {
	      // Assigner un ID si le formulaire n'en a pas
	      if (!form.id) {
	        form.id = `form-${index}-${Math.random().toString(36).substr(2, 9)}`;
	      }

	      // Récupération des options depuis data-attributes
	      const options = {
	        validateOnBlur: form.dataset.validateOnBlur !== 'false',
	        validateOnInput: form.dataset.validateOnInput === 'true',
	        submitOnSuccess: form.dataset.submitOnSuccess !== 'false',
	        liveRegionId: form.dataset.liveRegion || `form-live-region-${index}`
	      };

	      // Création de l'instance avec le formulaire DOM directement
	      const validator = new FormValidator(`#${form.id}`, options);

	      // Gestion du callback onSuccess si défini
	      if (form.dataset.onSuccess) {
	        validator.hasCustomSuccessCallback = true;
	        validator.onSuccess = function onSuccessHandler() {
	          const formData = new FormData(this.form);

	          // Si c'est le nom d'une fonction globale
	          if (typeof window[form.dataset.onSuccess] === 'function') {
	            window[form.dataset.onSuccess](formData, this.form);
	          } else {
	            // console.log('Formulaire validé:', Object.fromEntries(formData));
	            this.announceLiveRegion('Formulaire envoyé avec succès');
	          }
	        };
	      }
	      validators.push(validator);
	      // console.log(`FormValidator initialisé pour #${form.id}`);
	    } catch (error) {
	      // console.error(`Erreur lors de l'initialisation du formulaire:`, error);
	    }
	  });
	  return validators;
	}

	var formValidator = /*#__PURE__*/Object.freeze({
		__proto__: null,
		FormValidator: FormValidator,
		default: initFormValidators
	});

	/**
	 * RangeSlider - Module ES6 accessible et configurable
	 * Support complet de l'accessibilité WCAG 2.1 AA
	 * @version 2.0.1 - Corrections des régressions
	 */

	// ============================================
	// Configuration Globale
	// ============================================

	const DEFAULT_CONFIG = {
	  // Classes CSS (personnalisables)
	  classes: {
	    container: 'm-range-slider',
	    track: 'range-slider-track',
	    thumb: 'range-slider-thumb',
	    tooltip: 'range-slider-tooltip',
	    dragging: 'dragging',
	    isNull: 'is-null',
	    disabled: 'disabled'
	  },
	  // Sélecteurs pour l'initialisation
	  selectors: {
	    slider: '.slide'
	  },
	  // Configuration par défaut des sliders
	  defaults: {
	    min: 0,
	    max: 100,
	    start: [25, 75],
	    step: 1,
	    steps: null,
	    format: null,
	    formatNull: null,
	    onChange: null,
	    onUpdate: null,
	    tooltips: true,
	    ariaLabel: ['Valeur minimum', 'Valeur maximum'],
	    nullLabel: ['Pas de minimum', 'Pas de maximum'],
	    single: false,
	    // Configuration d'accessibilité
	    accessibility: {
	      announceValues: true,
	      announceDelay: 500,
	      keyboardStep: 1,
	      keyboardStepLarge: 10
	    }
	  }
	};
	let globalConfig = {
	  ...DEFAULT_CONFIG
	};

	/**
	 * Obtenir la configuration globale
	 */
	function getGlobalConfig() {
	  return {
	    ...globalConfig
	  };
	}

	// ============================================
	// Classe RangeSlider
	// ============================================

	class RangeSlider {
	  constructor(selector, options = {}) {
	    // Récupérer la config globale
	    this.config = getGlobalConfig();

	    // Merger avec les options locales
	    if (options.classes) {
	      this.config.classes = {
	        ...this.config.classes,
	        ...options.classes
	      };
	    }

	    // Container principal
	    this.container = typeof selector === 'string' ? document.querySelector(selector) : selector;
	    if (!this.container) {
	      throw new Error('Slider container not found');
	    }

	    // Options finales
	    this.options = {
	      ...this.config.defaults,
	      ...options
	    };

	    // Classes CSS
	    this.classes = this.config.classes;

	    // Adapter pour mode single
	    if (this.options.single) {
	      if (Array.isArray(this.options.start)) {
	        this.options.start = this.options.start[0];
	      }
	      if (!options.ariaLabel) {
	        this.options.ariaLabel = ['Valeur'];
	      }
	    }

	    // Steps personnalisés
	    if (this.options.steps && Array.isArray(this.options.steps)) {
	      this.customSteps = [...this.options.steps];
	      const realValues = this.customSteps.filter(v => v !== null);
	      if (realValues.length > 0) {
	        this.options.min = Math.min(...realValues);
	        this.options.max = Math.max(...realValues);
	      }

	      // CORRECTION : Tracker les index pour éviter le problème des null multiples
	      this.currentIndexes = [];
	      if (this.options.single) {
	        const startValue = this.options.start;
	        if (startValue === null) {
	          this.values = [null];
	          this.currentIndexes = [this.customSteps.indexOf(null)];
	        } else {
	          const closestValue = this.findClosestStep(startValue);
	          this.values = [closestValue];
	          this.currentIndexes = [this.customSteps.indexOf(closestValue)];
	        }
	      } else {
	        this.values = [];
	        this.options.start.forEach((v, idx) => {
	          if (v === null) {
	            this.values.push(null);
	            // Pour le START (0), premier null. Pour le END (1), dernier null
	            const nullIndex = idx === 0 ? this.customSteps.indexOf(null) : this.customSteps.lastIndexOf(null);
	            this.currentIndexes.push(nullIndex);
	          } else {
	            const closestValue = this.findClosestStep(v);
	            this.values.push(closestValue);
	            this.currentIndexes.push(this.customSteps.indexOf(closestValue));
	          }
	        });
	      }
	    } else {
	      this.customSteps = null;
	      this.currentIndexes = null;
	      if (this.options.single) {
	        this.values = [this.options.start];
	      } else {
	        this.values = [...this.options.start];
	      }
	    }
	    this.listeners = {
	      change: [],
	      update: []
	    };
	    this.isDragging = false;
	    this.activeThumb = null;
	    this.announceTimeout = null;
	    this.liveRegion = null;
	    this.init();
	  }
	  init() {
	    this.createAccessibilityElements();
	    this.createSlider();
	    this.attachEvents();
	    this.updateUI();
	  }

	  /**
	   * Crée la live region pour l'accessibilité
	   */
	  createAccessibilityElements() {
	    if (!this.options.accessibility.announceValues) return;
	    this.liveRegion = document.createElement('div');
	    this.liveRegion.setAttribute('role', 'status');
	    this.liveRegion.setAttribute('aria-live', 'polite');
	    this.liveRegion.setAttribute('aria-atomic', 'true');
	    this.liveRegion.className = 'sr-only';
	    this.liveRegion.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;';
	    this.container.appendChild(this.liveRegion);
	  }

	  /**
	   * Annonce une valeur aux lecteurs d'écran
	   */
	  announceValue(message) {
	    if (!this.liveRegion || !this.options.accessibility.announceValues) return;
	    clearTimeout(this.announceTimeout);
	    this.announceTimeout = setTimeout(() => {
	      if (this.liveRegion) {
	        this.liveRegion.textContent = message;
	      }
	    }, this.options.accessibility.announceDelay);
	  }
	  isNull(value) {
	    return value === null || value === undefined;
	  }
	  findClosestStep(value) {
	    if (!this.customSteps) return value;
	    if (this.isNull(value)) return null;
	    return this.customSteps.reduce((prev, curr) => {
	      if (this.isNull(curr)) return prev;
	      if (this.isNull(prev)) return curr;
	      return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
	    });
	  }
	  getStepIndex(value, thumbIndex = null) {
	    if (!this.customSteps) return null;
	    if (this.isNull(value)) {
	      if (thumbIndex === 0) {
	        return this.customSteps.indexOf(null);
	      }
	      if (thumbIndex === 1) {
	        return this.customSteps.lastIndexOf(null);
	      }
	      return this.customSteps.indexOf(null);
	    }
	    return this.customSteps.indexOf(value);
	  }
	  percentToValue(percent) {
	    if (this.customSteps) {
	      const totalSteps = this.customSteps.length - 1;
	      const stepFloat = percent * totalSteps;
	      const stepIndex = Math.round(stepFloat);
	      return this.customSteps[Math.max(0, Math.min(stepIndex, totalSteps))];
	    }
	    const range = this.options.max - this.options.min;
	    const value = this.options.min + percent * range;
	    return Math.round(value / this.options.step) * this.options.step;
	  }
	  valueToPercent(value, thumbIndex = null) {
	    if (this.isNull(value)) {
	      if (this.customSteps) {
	        if (thumbIndex === 1 || thumbIndex === null) {
	          const lastNullIndex = this.customSteps.lastIndexOf(null);
	          if (lastNullIndex !== -1) {
	            return lastNullIndex / (this.customSteps.length - 1);
	          }
	        }
	        const firstNullIndex = this.customSteps.indexOf(null);
	        if (firstNullIndex !== -1) {
	          return firstNullIndex / (this.customSteps.length - 1);
	        }
	      }
	      return 0;
	    }
	    if (this.customSteps) {
	      const index = this.getStepIndex(value);
	      if (index === null) return 0;
	      return index / (this.customSteps.length - 1);
	    }
	    const range = this.options.max - this.options.min;
	    return (value - this.options.min) / range;
	  }

	  /**
	   * CORRECTION FINALE : Utilise les index trackés au lieu de deviner
	   */
	  getAdjacentStep(currentValue, direction, thumbIndex) {
	    if (this.customSteps) {
	      // Utiliser l'index tracké au lieu de getStepIndex
	      const currentIndex = this.currentIndexes[thumbIndex];
	      if (currentIndex === undefined || currentIndex === -1) return currentValue;
	      const newIndex = currentIndex + direction;

	      // Vérifier les limites sans boucler
	      if (newIndex < 0 || newIndex >= this.customSteps.length) {
	        return currentValue;
	      }
	      const newValue = this.customSteps[newIndex];

	      // En mode range, vérifier les contraintes entre thumbs
	      if (!this.options.single) {
	        if (thumbIndex === 0) {
	          const endIndex = this.currentIndexes[1];
	          if (endIndex !== undefined && newIndex >= endIndex) {
	            return currentValue;
	          }
	        } else if (thumbIndex === 1) {
	          const startIndex = this.currentIndexes[0];
	          if (startIndex !== undefined && newIndex <= startIndex) {
	            return currentValue;
	          }
	        }
	      }
	      return newValue;
	    }
	    // Mode sans customSteps
	    const newValue = currentValue + direction * this.options.step;
	    if (newValue < this.options.min || newValue > this.options.max) {
	      return currentValue;
	    }
	    if (!this.options.single) {
	      if (thumbIndex === 0 && newValue >= this.values[1]) {
	        return currentValue;
	      }
	      if (thumbIndex === 1 && newValue <= this.values[0]) {
	        return currentValue;
	      }
	    }
	    return newValue;
	  }
	  formatValue(value, thumbIndex = 0) {
	    if (this.isNull(value)) {
	      if (this.options.formatNull) {
	        return this.options.formatNull(thumbIndex);
	      }
	      return this.options.nullLabel[thumbIndex] || 'Aucune limite';
	    }
	    if (this.options.format) {
	      return this.options.format(value);
	    }
	    return value.toString();
	  }
	  createSlider() {
	    // Track
	    this.track = document.createElement('div');
	    this.track.className = this.classes.track;
	    this.container.appendChild(this.track);

	    // Thumbs
	    this.thumbs = [];
	    this.tooltips = [];
	    const numThumbs = this.options.single ? 1 : 2;
	    for (let i = 0; i < numThumbs; i++) {
	      const thumb = document.createElement('div');
	      thumb.className = this.classes.thumb;
	      thumb.setAttribute('role', 'slider');
	      thumb.setAttribute('tabindex', '0');

	      // ARIA labels
	      if (this.options.single) {
	        thumb.setAttribute('aria-label', this.options.ariaLabel[0] || 'Valeur');
	      } else {
	        thumb.setAttribute('aria-label', this.options.ariaLabel[i]);
	      }
	      const ariaMin = this.customSteps ? this.customSteps.filter(v => v !== null)[0] : this.options.min;
	      const ariaMax = this.customSteps ? this.customSteps.filter(v => v !== null).pop() : this.options.max;
	      thumb.setAttribute('aria-valuemin', ariaMin);
	      thumb.setAttribute('aria-valuemax', ariaMax);
	      thumb.setAttribute('aria-valuenow', this.values[i] !== null ? this.values[i] : ariaMin);
	      thumb.setAttribute('aria-valuetext', this.formatValue(this.values[i], i));

	      // Tooltip
	      if (this.options.tooltips) {
	        const tooltip = document.createElement('div');
	        tooltip.className = this.classes.tooltip;
	        tooltip.textContent = this.formatValue(this.values[i], i);
	        tooltip.setAttribute('aria-hidden', 'true');
	        thumb.appendChild(tooltip);
	        this.tooltips.push(tooltip);
	      }
	      this.container.appendChild(thumb);
	      this.thumbs.push(thumb);
	    }
	  }
	  attachEvents() {
	    this.thumbs.forEach((thumb, index) => {
	      thumb.addEventListener('mousedown', e => this.startDrag(e, index));
	      thumb.addEventListener('touchstart', e => this.startDrag(e, index), {
	        passive: false
	      });
	      thumb.addEventListener('keydown', e => this.handleKeyboard(e, index));
	      thumb.addEventListener('focus', () => this.handleFocus(index));
	    });
	    this.container.addEventListener('click', e => this.handleTrackClick(e));
	    document.addEventListener('mousemove', e => this.drag(e));
	    document.addEventListener('mouseup', () => this.endDrag());
	    document.addEventListener('touchmove', e => this.drag(e), {
	      passive: false
	    });
	    document.addEventListener('touchend', () => this.endDrag());
	  }
	  handleFocus(index) {
	    const value = this.values[index];
	    const formattedValue = this.formatValue(value, index);
	    const label = this.options.ariaLabel[index] || 'Valeur';
	    this.announceValue(`${label}: ${formattedValue}`);
	  }
	  startDrag(e, index) {
	    e.preventDefault();
	    this.isDragging = true;
	    this.activeThumb = index;
	    this.thumbs[index].classList.add(this.classes.dragging);
	    this.announceValue(`Déplacement du curseur ${this.options.ariaLabel[index] || 'Valeur'}`);
	  }

	  /**
	   * CORRECTION FINALE : Drag simplifié avec tracking des index
	   */
	  drag(e) {
	    if (!this.isDragging || this.activeThumb === null) return;
	    const rect = this.container.getBoundingClientRect();
	    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
	    let percent = (clientX - rect.left) / rect.width;
	    percent = Math.max(0, Math.min(1, percent));
	    if (this.customSteps) {
	      // Calculer l'index cible
	      const totalSteps = this.customSteps.length - 1;
	      const targetIndex = Math.round(percent * totalSteps);

	      // Obtenir l'index actuel
	      const currentIndex = this.currentIndexes[this.activeThumb];

	      // Ne rien faire si l'index n'a pas changé
	      if (targetIndex === currentIndex) {
	        return;
	      }

	      // Vérifier les contraintes
	      if (!this.options.single) {
	        if (this.activeThumb === 0) {
	          const endIndex = this.currentIndexes[1];
	          if (endIndex !== undefined && targetIndex >= endIndex) {
	            return;
	          }
	        } else {
	          const startIndex = this.currentIndexes[0];
	          if (startIndex !== undefined && targetIndex <= startIndex) {
	            return;
	          }
	        }
	      }

	      // Mettre à jour
	      this.values[this.activeThumb] = this.customSteps[targetIndex];
	      this.currentIndexes[this.activeThumb] = targetIndex;
	    } else {
	      // Mode sans customSteps
	      let newValue = this.percentToValue(percent);
	      if (newValue === this.values[this.activeThumb]) {
	        return;
	      }
	      if (!this.options.single) {
	        if (this.activeThumb === 0) {
	          if (!this.isNull(newValue) && !this.isNull(this.values[1])) {
	            if (newValue >= this.values[1]) {
	              return;
	            }
	            newValue = Math.min(newValue, this.values[1] - this.options.step);
	          }
	        } else if (!this.isNull(newValue) && !this.isNull(this.values[0])) {
	          if (newValue <= this.values[0]) {
	            return;
	          }
	          newValue = Math.max(newValue, this.values[0] + this.options.step);
	        }
	      }
	      this.values[this.activeThumb] = newValue;
	    }
	    this.updateUI();
	    this.emit('update', this.getValues());
	    if (this.options.onUpdate) {
	      this.options.onUpdate(this.getValues());
	    }
	  }
	  endDrag() {
	    if (!this.isDragging) return;
	    this.isDragging = false;
	    if (this.activeThumb !== null) {
	      this.thumbs[this.activeThumb].classList.remove(this.classes.dragging);
	      const value = this.values[this.activeThumb];
	      const formattedValue = this.formatValue(value, this.activeThumb);
	      const label = this.options.ariaLabel[this.activeThumb] || 'Valeur';
	      this.announceValue(`${label}: ${formattedValue}`);
	    }
	    this.activeThumb = null;
	    this.emit('change', this.getValues());
	    if (this.options.onChange) {
	      this.options.onChange(this.getValues());
	    }
	  }

	  /**
	   * CORRECTION: Gestion du clavier améliorée avec support complet des contraintes
	   */
	  handleKeyboard(e, index) {
	    const key = e.key;
	    let handled = false;
	    let newValue = null;
	    let computedNewIndex = null; // CORRECTION : Stocker l'index calculé pour les flèches

	    const currentValue = this.values[index];
	    const keyboardStep = this.options.accessibility.keyboardStep;
	    const keyboardStepLarge = this.options.accessibility.keyboardStepLarge;
	    if (this.customSteps) {
	      // Mode avec steps personnalisés
	      const currentIndex = this.currentIndexes[index];
	      let newIndex = currentIndex;
	      switch (key) {
	        case 'ArrowRight':
	        case 'ArrowUp':
	          // CORRECTION CRITIQUE : Empêcher le bouclage à la fin
	          if (currentIndex < this.customSteps.length - 1) {
	            newIndex = currentIndex + 1;
	          }
	          handled = true;
	          break;
	        case 'ArrowLeft':
	        case 'ArrowDown':
	          // CORRECTION CRITIQUE : Empêcher le bouclage au début
	          if (currentIndex > 0) {
	            newIndex = currentIndex - 1;
	          }
	          handled = true;
	          break;
	        case 'Home':
	          const homeIndex = 0;
	          const currentHomeIdx = this.currentIndexes[index];

	          // Si on est déjà au début, ne rien faire (éviter le bouclage)
	          if (currentHomeIdx === homeIndex) return;
	          newValue = this.customSteps[homeIndex];

	          // Vérifier les contraintes pour le thumb de fin
	          if (!this.options.single && index === 1 && !this.isNull(this.values[0])) {
	            const startIndex = this.currentIndexes[0];
	            if (startIndex !== undefined && homeIndex <= startIndex) {
	              return;
	            }
	          }
	          handled = true;
	          break;
	        case 'End':
	          const lastIndex = this.customSteps.length - 1;
	          const currentEndIdx = this.currentIndexes[index];

	          // Si on est déjà à la fin, ne rien faire (éviter le bouclage)
	          if (currentEndIdx === lastIndex) return;
	          newValue = this.customSteps[lastIndex];

	          // Vérifier les contraintes pour le thumb de départ
	          if (!this.options.single && index === 0 && !this.isNull(this.values[1])) {
	            const endIndex = this.currentIndexes[1];
	            if (endIndex !== undefined && lastIndex >= endIndex) {
	              return;
	            }
	          }
	          handled = true;
	          break;
	        case 'PageUp':
	          const currentIdx = this.currentIndexes[index];
	          if (currentIdx === undefined || currentIdx === -1) return;
	          let targetIdx = Math.min(currentIdx + 5, this.customSteps.length - 1);

	          // Empêcher le bouclage : si on est déjà au max, ne pas bouger
	          if (targetIdx === currentIdx) return;

	          // Vérifier les contraintes
	          if (!this.options.single && index === 0 && !this.isNull(this.values[1])) {
	            const endIndex = this.currentIndexes[1];
	            if (endIndex !== undefined) {
	              targetIdx = Math.min(targetIdx, endIndex - 1);
	            }
	          }
	          newValue = this.customSteps[targetIdx];
	          handled = true;
	          break;
	        case 'PageDown':
	          const currentIdxDown = this.currentIndexes[index];
	          if (currentIdxDown === undefined || currentIdxDown === -1) return;
	          let targetIdxDown = Math.max(currentIdxDown - 5, 0);

	          // Empêcher le bouclage : si on est déjà au min, ne pas bouger
	          if (targetIdxDown === currentIdxDown) return;

	          // Vérifier les contraintes
	          if (!this.options.single && index === 1 && !this.isNull(this.values[0])) {
	            const startIndex = this.currentIndexes[0];
	            if (startIndex !== undefined) {
	              targetIdxDown = Math.max(targetIdxDown, startIndex + 1);
	            }
	          }
	          newValue = this.customSteps[targetIdxDown];
	          handled = true;
	          break;
	      }

	      // CORRECTION : Pour les flèches, vérifier les contraintes et calculer newValue
	      if ((key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowLeft' || key === 'ArrowDown') && newIndex !== currentIndex) {
	        // Vérifier les contraintes en mode range
	        if (!this.options.single) {
	          const otherIndex = index === 0 ? 1 : 0;
	          const otherCurrentIndex = this.currentIndexes[otherIndex];
	          if (index === 0) {
	            // START ne peut pas dépasser ou atteindre END
	            if (otherCurrentIndex !== undefined && newIndex >= otherCurrentIndex) {
	              return; // Ne rien faire
	            }
	          } else {
	            // END ne peut pas descendre sous ou atteindre START
	            if (otherCurrentIndex !== undefined && newIndex <= otherCurrentIndex) {
	              return; // Ne rien faire
	            }
	          }
	        }

	        // Calculer la nouvelle valeur et stocker l'index
	        computedNewIndex = newIndex;
	        newValue = this.customSteps[newIndex];
	      }
	    } else {
	      // Mode sans steps personnalisés
	      let targetValue = this.isNull(currentValue) ? this.options.min : currentValue;
	      switch (key) {
	        case 'ArrowRight':
	        case 'ArrowUp':
	          targetValue += keyboardStep;
	          handled = true;
	          break;
	        case 'ArrowLeft':
	        case 'ArrowDown':
	          targetValue -= keyboardStep;
	          handled = true;
	          break;
	        case 'Home':
	          targetValue = this.options.min;
	          handled = true;
	          break;
	        case 'End':
	          targetValue = this.options.max;
	          handled = true;
	          break;
	        case 'PageDown':
	          targetValue -= keyboardStepLarge;
	          handled = true;
	          break;
	        case 'PageUp':
	          targetValue += keyboardStepLarge;
	          handled = true;
	          break;
	      }

	      // Vérifier les limites
	      if (targetValue < this.options.min || targetValue > this.options.max) {
	        return;
	      }

	      // Vérifier les contraintes en mode range
	      if (!this.options.single) {
	        if (index === 0) {
	          if (!this.isNull(this.values[1]) && targetValue >= this.values[1]) {
	            return;
	          }
	        } else if (!this.isNull(this.values[0]) && targetValue <= this.values[0]) {
	          return;
	        }
	      }
	      newValue = targetValue;
	    }
	    if (handled) {
	      e.preventDefault();

	      // Mettre à jour seulement si la valeur a changé
	      if (newValue !== this.values[index]) {
	        this.values[index] = newValue;

	        // CORRECTION : Mettre à jour l'index tracké
	        if (this.customSteps && this.currentIndexes) {
	          // Utiliser l'index déjà calculé pour les flèches, sinon calculer avec indexOf
	          if (computedNewIndex !== null) {
	            this.currentIndexes[index] = computedNewIndex;
	          } else {
	            const newIndex = this.customSteps.indexOf(newValue);
	            if (newIndex !== -1) {
	              this.currentIndexes[index] = newIndex;
	            } else if (this.isNull(newValue)) {
	              // Pour null, utiliser le bon index selon le thumb
	              this.currentIndexes[index] = index === 0 ? this.customSteps.indexOf(null) : this.customSteps.lastIndexOf(null);
	            }
	          }
	        }
	        this.updateUI();
	        this.emit('change', this.getValues());
	        if (this.options.onChange) {
	          this.options.onChange(this.getValues());
	        }
	        const formattedValue = this.formatValue(newValue, index);
	        const label = this.options.ariaLabel[index] || 'Valeur';
	        this.announceValue(`${label}: ${formattedValue}`);
	      }
	    }
	  }
	  handleTrackClick(e) {
	    if (e.target === this.container || e.target === this.track) {
	      const rect = this.container.getBoundingClientRect();
	      const percent = (e.clientX - rect.left) / rect.width;
	      const value = this.percentToValue(percent);
	      if (this.options.single) {
	        this.values[0] = value;

	        // CORRECTION : Mettre à jour l'index tracké en mode single
	        if (this.customSteps && this.currentIndexes) {
	          const newIndex = this.customSteps.indexOf(value);
	          if (newIndex !== -1) {
	            this.currentIndexes[0] = newIndex;
	          } else if (this.isNull(value)) {
	            this.currentIndexes[0] = this.customSteps.indexOf(null);
	          }
	        }
	        this.updateUI();
	        this.emit('change', this.getValues());
	        if (this.options.onChange) {
	          this.options.onChange(this.getValues());
	        }
	        return;
	      }
	      const distances = this.values.map(v => {
	        if (this.isNull(v)) return Infinity;
	        if (this.isNull(value)) return Infinity;
	        return Math.abs(v - value);
	      });
	      const closestIndex = distances[0] < distances[1] ? 0 : 1;
	      let newValue = value;
	      if (closestIndex === 0) {
	        if (this.customSteps) {
	          if (!this.isNull(newValue) && !this.isNull(this.values[1])) {
	            const maxIndex = this.getStepIndex(this.values[1], 1);
	            const newIndex = this.getStepIndex(newValue, 0);
	            if (newIndex >= maxIndex) {
	              newValue = this.customSteps[Math.max(0, maxIndex - 1)];
	            }
	          }
	        } else if (!this.isNull(newValue)) {
	          newValue = Math.min(newValue, this.values[1] - this.options.step);
	        }
	      } else if (this.customSteps) {
	        if (!this.isNull(newValue) && !this.isNull(this.values[0])) {
	          const minIndex = this.getStepIndex(this.values[0], 0);
	          const newIndex = this.getStepIndex(newValue, 1);
	          if (newIndex <= minIndex) {
	            newValue = this.customSteps[Math.min(this.customSteps.length - 1, minIndex + 1)];
	          }
	        }
	      } else if (!this.isNull(newValue)) {
	        newValue = Math.max(newValue, this.values[0] + this.options.step);
	      }
	      this.values[closestIndex] = newValue;

	      // CORRECTION : Mettre à jour l'index tracké
	      if (this.customSteps && this.currentIndexes) {
	        const newIndex = this.customSteps.indexOf(newValue);
	        if (newIndex !== -1) {
	          this.currentIndexes[closestIndex] = newIndex;
	        } else if (this.isNull(newValue)) {
	          this.currentIndexes[closestIndex] = closestIndex === 0 ? this.customSteps.indexOf(null) : this.customSteps.lastIndexOf(null);
	        }
	      }
	      this.updateUI();
	      this.emit('change', this.getValues());
	      if (this.options.onChange) {
	        this.options.onChange(this.getValues());
	      }
	    }
	  }
	  updateUI() {
	    if (this.options.single) {
	      const percent = this.valueToPercent(this.values[0], 0) * 100;
	      this.thumbs[0].style.left = `${percent}%`;
	      this.track.style.left = '0%';
	      this.track.style.width = `${percent}%`;
	      const value = this.values[0];
	      this.thumbs[0].setAttribute('aria-valuenow', this.isNull(value) ? '' : value);
	      this.thumbs[0].setAttribute('aria-valuetext', this.formatValue(value, 0));
	      if (this.options.tooltips && this.tooltips[0]) {
	        this.tooltips[0].textContent = this.formatValue(value, 0);
	      }
	      this.thumbs[0].classList.toggle(this.classes.isNull, this.isNull(value));
	    } else {
	      const percent0 = this.valueToPercent(this.values[0], 0) * 100;
	      const percent1 = this.valueToPercent(this.values[1], 1) * 100;
	      this.thumbs[0].style.left = `${percent0}%`;
	      this.thumbs[1].style.left = `${percent1}%`;
	      this.track.style.left = `${percent0}%`;
	      this.track.style.width = `${percent1 - percent0}%`;
	      this.thumbs[0].setAttribute('aria-valuenow', this.isNull(this.values[0]) ? '' : this.values[0]);
	      this.thumbs[0].setAttribute('aria-valuetext', this.formatValue(this.values[0], 0));
	      this.thumbs[1].setAttribute('aria-valuenow', this.isNull(this.values[1]) ? '' : this.values[1]);
	      this.thumbs[1].setAttribute('aria-valuetext', this.formatValue(this.values[1], 1));
	      if (this.options.tooltips) {
	        if (this.tooltips[0]) {
	          this.tooltips[0].textContent = this.formatValue(this.values[0], 0);
	        }
	        if (this.tooltips[1]) {
	          this.tooltips[1].textContent = this.formatValue(this.values[1], 1);
	        }
	      }
	      this.thumbs[0].classList.toggle(this.classes.isNull, this.isNull(this.values[0]));
	      this.thumbs[1].classList.toggle(this.classes.isNull, this.isNull(this.values[1]));
	    }
	  }

	  // API publique
	  getValues() {
	    if (this.options.single) {
	      return this.values[0];
	    }
	    return [...this.values];
	  }
	  getInterpretedValues() {
	    if (this.options.single) {
	      return {
	        value: this.values[0],
	        hasValue: !this.isNull(this.values[0])
	      };
	    }
	    return {
	      min: this.values[0],
	      max: this.values[1],
	      hasMin: !this.isNull(this.values[0]),
	      hasMax: !this.isNull(this.values[1])
	    };
	  }
	  setValues(values) {
	    if (this.options.single) {
	      const newValue = Array.isArray(values) ? values[0] : values;
	      if (this.customSteps) {
	        this.values = [this.isNull(newValue) ? null : this.findClosestStep(newValue)];
	        // CORRECTION : Mettre à jour l'index tracké
	        if (this.currentIndexes) {
	          const val = this.values[0];
	          if (this.isNull(val)) {
	            this.currentIndexes[0] = this.customSteps.indexOf(null);
	          } else {
	            this.currentIndexes[0] = this.customSteps.indexOf(val);
	          }
	        }
	      } else {
	        this.values = [this.isNull(newValue) ? null : Math.max(this.options.min, Math.min(newValue, this.options.max))];
	      }
	    } else if (Array.isArray(values) && values.length === 2) {
	      if (this.customSteps) {
	        this.values = [this.isNull(values[0]) ? null : this.findClosestStep(values[0]), this.isNull(values[1]) ? null : this.findClosestStep(values[1])];
	        // CORRECTION : Mettre à jour les index trackés
	        if (this.currentIndexes) {
	          for (let i = 0; i < 2; i++) {
	            const val = this.values[i];
	            if (this.isNull(val)) {
	              this.currentIndexes[i] = i === 0 ? this.customSteps.indexOf(null) : this.customSteps.lastIndexOf(null);
	            } else {
	              this.currentIndexes[i] = this.customSteps.indexOf(val);
	            }
	          }
	        }
	      } else {
	        this.values = [this.isNull(values[0]) ? null : Math.max(this.options.min, Math.min(values[0], this.options.max)), this.isNull(values[1]) ? null : Math.max(this.options.min, Math.min(values[1], this.options.max))];
	      }
	    }
	    this.updateUI();
	    this.emit('change', this.getValues());
	    if (this.options.onChange) {
	      this.options.onChange(this.getValues());
	    }
	  }
	  reset() {
	    this.setValues(this.options.start);
	  }
	  on(event, callback) {
	    if (this.listeners[event]) {
	      this.listeners[event].push(callback);
	    }
	  }
	  off(event, callback) {
	    if (this.listeners[event]) {
	      const index = this.listeners[event].indexOf(callback);
	      if (index > -1) {
	        this.listeners[event].splice(index, 1);
	      }
	    }
	  }
	  emit(event, data) {
	    if (this.listeners[event]) {
	      this.listeners[event].forEach(callback => callback(data));
	    }
	  }
	  destroy() {
	    clearTimeout(this.announceTimeout);
	    this.container.innerHTML = '';
	    this.listeners = {
	      change: [],
	      update: []
	    };
	  }
	}

	/**
	 * Range Sliders Module - Version améliorée
	 * - Vérifications robustes des éléments DOM
	 * - Configuration flexible des classes
	 * - Gestion des erreurs gracieuse
	 */


	/**
	 * Initialise tous les range sliders de la page
	 * @param {Object} options - Options globales (optionnel)
	 * @returns {Array} Instances des sliders créés
	 */
	function initRangeSliders(options = {}) {
	  const config = getGlobalConfig();

	  // Récupérer le sélecteur depuis la config ou les options
	  const selector = options.selector || config.selectors.slider;

	  // Récupérer tous les sliders
	  const sliders = document.querySelectorAll(selector);
	  if (!sliders.length) {
	    // console.warn(`[RangeSliders] Aucun range slider trouvé avec le sélecteur "${selector}"`);
	    return [];
	  }

	  // Instances des sliders
	  const instances = [];
	  sliders.forEach((sliderElement, index) => {
	    try {
	      // Récupérer la configuration depuis les data-attributes
	      const sliderConfig = getSliderConfig(sliderElement);

	      // Créer l'instance du slider
	      const slider = new RangeSlider(sliderElement, sliderConfig);

	      // Gérer les bindings si des éléments associés existent
	      setupSliderBindings(slider, sliderElement);

	      // Stocker l'instance
	      instances.push(slider);

	      // Attacher l'instance au DOM pour un accès facile
	      sliderElement.rangeSlider = slider;
	    } catch (error) {
	      // console.error(`[RangeSliders] Erreur lors de l'initialisation du slider #${index}:`, error);
	      // Continuer avec les autres sliders même si un échoue
	    }
	  });

	  // console.log(`[RangeSliders] ${instances.length}/${sliders.length} slider(s) initialisé(s)`);

	  return instances;
	}

	/**
	 * Récupère la configuration depuis les data-attributes
	 * @param {HTMLElement} element
	 * @returns {Object}
	 */
	function getSliderConfig(element) {
	  const dataset = element.dataset;
	  const config = {
	    min: parseFloat(dataset.sliderMin) || 0,
	    max: parseFloat(dataset.sliderMax) || 100,
	    start: dataset.sliderStart ? JSON.parse(dataset.sliderStart) : [25, 75],
	    step: parseFloat(dataset.sliderStep) || 1,
	    tooltips: dataset.sliderTooltips !== 'false',
	    format: getFormatter(dataset.sliderFormat),
	    ariaLabel: dataset.sliderAriaLabel ? JSON.parse(dataset.sliderAriaLabel) : ['Valeur minimum', 'Valeur maximum'],
	    single: dataset.sliderSingle === 'true'
	  };

	  // Support des steps personnalisés (avec null)
	  if (dataset.sliderSteps) {
	    try {
	      config.steps = JSON.parse(dataset.sliderSteps);
	    } catch (e) {
	      // console.error('[RangeSliders] Erreur lors du parsing des steps personnalisés:', e);
	    }
	  }

	  // Support des labels null
	  if (dataset.sliderNullLabel) {
	    try {
	      config.nullLabel = JSON.parse(dataset.sliderNullLabel);
	    } catch (e) {
	      // console.warn('[RangeSliders] Erreur lors du parsing des nullLabel, utilisation des valeurs par défaut');
	      config.nullLabel = ['Pas de minimum', 'Pas de maximum'];
	    }
	  } else {
	    config.nullLabel = getNullLabels(dataset.sliderFormat);
	  }
	  return config;
	}

	/**
	 * Retourne les labels null par défaut selon le format
	 */
	function getNullLabels(formatType) {
	  const labels = {
	    currency: ['Pas de minimum', 'Pas de maximum'],
	    m2: ['Indifférent', 'Indifférent'],
	    km: ['Aucune limite', 'Aucune limite'],
	    percent: ['0%', '100%'],
	    number: ['Min', 'Max']
	  };
	  return labels[formatType] || ['Pas de minimum', 'Pas de maximum'];
	}

	/**
	 * Retourne une fonction de formatage selon le type
	 * @param {string} formatType
	 * @returns {Function|null}
	 */
	function getFormatter(formatType) {
	  const formatters = {
	    currency: value => {
	      return new Intl.NumberFormat('fr-FR', {
	        style: 'currency',
	        currency: 'EUR',
	        minimumFractionDigits: 0,
	        notation: value >= 1000000 ? 'compact' : 'standard'
	      }).format(value);
	    },
	    percent: value => `${value}%`,
	    number: value => {
	      return new Intl.NumberFormat('fr-FR').format(value);
	    },
	    m2: value => `${value} m²`,
	    km: value => `${value} km`
	  };
	  return formatters[formatType] || null;
	}

	/**
	 * Configure les bindings pour un slider (vérifie la présence des éléments)
	 */
	function setupSliderBindings(slider, sliderElement) {
	  const dataset = sliderElement.dataset;
	  if (slider.options.single) {
	    setupSingleSliderBindings(slider, sliderElement, dataset);
	  } else {
	    setupRangeSliderBindings(slider, sliderElement, dataset);
	  }
	}

	/**
	 * Configure les bindings pour un single slider
	 * Avec vérifications robustes des éléments DOM
	 */
	function setupSingleSliderBindings(slider, sliderElement, dataset) {
	  // Trouver l'élément d'affichage (avec fallback)
	  let display = null;
	  if (dataset.sliderDisplay) {
	    display = safeQuerySelector(dataset.sliderDisplay, 'display element');
	  } else if (dataset.sliderMinDisplay) {
	    display = safeQuerySelector(dataset.sliderMinDisplay, 'min display element');
	  }

	  // Trouver l'input (avec fallback)
	  let input = null;
	  if (dataset.sliderInput) {
	    input = safeQuerySelector(dataset.sliderInput, 'input element');
	  } else if (dataset.sliderMinInput) {
	    input = safeQuerySelector(dataset.sliderMinInput, 'min input element');
	  }

	  // Flags pour éviter les boucles infinies
	  let isUpdatingFromSlider = false;
	  let isUpdatingFromInput = false;

	  // Fonction pour mettre à jour les affichages
	  const updateDisplay = value => {
	    // Affichage textuel (seulement si l'élément existe)
	    if (display) {
	      try {
	        if (slider.isNull(value)) {
	          display.textContent = slider.options.nullLabel[0] || 'Aucune valeur';
	        } else {
	          display.textContent = slider.formatValue(value, 0);
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du display:', e);
	      }
	    }

	    // Input (seulement si l'élément existe)
	    if (input) {
	      try {
	        input.value = slider.isNull(value) ? '' : value;
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour de l\'input:', e);
	      }
	    }
	  };

	  // Callback onChange
	  slider.on('change', value => {
	    if (isUpdatingFromInput) return;
	    isUpdatingFromSlider = true;
	    updateDisplay(value);

	    // Événement custom
	    sliderElement.dispatchEvent(new CustomEvent('rangeSliderChange', {
	      detail: {
	        value
	      },
	      bubbles: true
	    }));
	    requestAnimationFrame(() => {
	      isUpdatingFromSlider = false;
	    });
	  });

	  // Callback onUpdate (pendant le drag)
	  slider.on('update', value => {
	    if (isUpdatingFromInput) return;
	    if (display) {
	      try {
	        if (slider.isNull(value)) {
	          display.textContent = slider.options.nullLabel[0] || 'Aucune valeur';
	        } else {
	          display.textContent = slider.formatValue(value, 0);
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du display (update):', e);
	      }
	    }
	  });

	  // Initialiser les valeurs
	  setTimeout(() => {
	    const initialValue = slider.getValues();
	    updateDisplay(initialValue);
	  }, 0);

	  // Synchronisation bidirectionnelle avec l'input (si activée et input existe)
	  if (input && dataset.sliderSyncInputs === 'true') {
	    input.addEventListener('input', handleInputChange);
	    input.addEventListener('change', handleInputChange);
	    function handleInputChange(e) {
	      if (isUpdatingFromSlider) return;
	      isUpdatingFromInput = true;
	      try {
	        const inputValue = e.target.value;
	        if (inputValue === '' || inputValue === null || inputValue === undefined) {
	          slider.setValues(null);
	        } else {
	          const newValue = parseFloat(inputValue);
	          if (!isNaN(newValue)) {
	            slider.setValues(newValue);
	          }
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors du traitement de l\'input change:', e);
	      }
	      requestAnimationFrame(() => {
	        isUpdatingFromInput = false;
	      });
	    }
	  }
	}

	/**
	 * Configure les bindings pour un range slider
	 * Avec vérifications robustes des éléments DOM
	 */
	function setupRangeSliderBindings(slider, sliderElement, dataset) {
	  // Trouver les éléments d'affichage (avec vérifications)
	  const minDisplay = dataset.sliderMinDisplay ? safeQuerySelector(dataset.sliderMinDisplay, 'min display element') : null;
	  const maxDisplay = dataset.sliderMaxDisplay ? safeQuerySelector(dataset.sliderMaxDisplay, 'max display element') : null;

	  // Trouver les inputs (avec vérifications)
	  const minInput = dataset.sliderMinInput ? safeQuerySelector(dataset.sliderMinInput, 'min input element') : null;
	  const maxInput = dataset.sliderMaxInput ? safeQuerySelector(dataset.sliderMaxInput, 'max input element') : null;

	  // Flags pour éviter les boucles infinies
	  let isUpdatingFromSlider = false;
	  let isUpdatingFromInput = false;

	  // Fonction pour mettre à jour tous les affichages
	  const updateDisplays = values => {
	    const interpreted = slider.getInterpretedValues();

	    // Affichage min (seulement si l'élément existe)
	    if (minDisplay) {
	      try {
	        if (interpreted.hasMin) {
	          minDisplay.textContent = slider.formatValue(interpreted.min, 0);
	        } else {
	          minDisplay.textContent = slider.options.nullLabel[0];
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du minDisplay:', e);
	      }
	    }

	    // Affichage max (seulement si l'élément existe)
	    if (maxDisplay) {
	      try {
	        if (interpreted.hasMax) {
	          maxDisplay.textContent = slider.formatValue(interpreted.max, 1);
	        } else {
	          maxDisplay.textContent = slider.options.nullLabel[1];
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du maxDisplay:', e);
	      }
	    }

	    // Input min (seulement si l'élément existe)
	    if (minInput) {
	      try {
	        minInput.value = interpreted.hasMin ? interpreted.min : '';
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du minInput:', e);
	      }
	    }

	    // Input max (seulement si l'élément existe)
	    if (maxInput) {
	      try {
	        maxInput.value = interpreted.hasMax ? interpreted.max : '';
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du maxInput:', e);
	      }
	    }
	  };

	  // Callback onChange
	  slider.on('change', values => {
	    if (isUpdatingFromInput) return;
	    isUpdatingFromSlider = true;

	    // Mettre à jour tous les affichages
	    updateDisplays();

	    // Événement custom
	    const interpreted = slider.getInterpretedValues();
	    sliderElement.dispatchEvent(new CustomEvent('rangeSliderChange', {
	      detail: {
	        values,
	        interpreted
	      },
	      bubbles: true
	    }));
	    requestAnimationFrame(() => {
	      isUpdatingFromSlider = false;
	    });
	  });

	  // Callback onUpdate (pendant le drag)
	  slider.on('update', values => {
	    if (isUpdatingFromInput) return;
	    const interpreted = slider.getInterpretedValues();
	    if (minDisplay) {
	      try {
	        if (interpreted.hasMin) {
	          minDisplay.textContent = slider.formatValue(interpreted.min, 0);
	        } else {
	          minDisplay.textContent = slider.options.nullLabel[0];
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du minDisplay (update):', e);
	      }
	    }
	    if (maxDisplay) {
	      try {
	        if (interpreted.hasMax) {
	          maxDisplay.textContent = slider.formatValue(interpreted.max, 1);
	        } else {
	          maxDisplay.textContent = slider.options.nullLabel[1];
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors de la mise à jour du maxDisplay (update):', e);
	      }
	    }
	  });

	  // Initialiser les valeurs
	  setTimeout(() => {
	    slider.getValues();
	    updateDisplays();
	  }, 0);

	  // Synchronisation bidirectionnelle avec minInput
	  if (minInput && dataset.sliderSyncInputs === 'true') {
	    minInput.addEventListener('input', handleMinInputChange);
	    minInput.addEventListener('change', handleMinInputChange);
	    function handleMinInputChange(e) {
	      if (isUpdatingFromSlider) return;
	      isUpdatingFromInput = true;
	      try {
	        const inputValue = e.target.value;
	        const values = slider.getValues();
	        if (inputValue === '' || inputValue === null || inputValue === undefined) {
	          slider.setValues([null, values[1]]);
	        } else {
	          const newValue = parseFloat(inputValue);
	          if (!isNaN(newValue) && newValue !== values[0]) {
	            let constrainedValue;
	            if (slider.customSteps) {
	              constrainedValue = slider.findClosestStep(newValue);
	              if (!slider.isNull(values[1])) {
	                const maxIndex = slider.getStepIndex(values[1], 1);
	                const newIndex = slider.getStepIndex(constrainedValue, 0);
	                if (newIndex >= maxIndex) {
	                  constrainedValue = slider.customSteps[Math.max(0, maxIndex - 1)];
	                }
	              }
	            } else {
	              constrainedValue = Math.max(slider.options.min, Math.min(newValue, values[1] - slider.options.step));
	            }
	            slider.setValues([constrainedValue, values[1]]);
	          }
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors du traitement du minInput change:', e);
	      }
	      requestAnimationFrame(() => {
	        isUpdatingFromInput = false;
	      });
	    }
	  }

	  // Synchronisation bidirectionnelle avec maxInput
	  if (maxInput && dataset.sliderSyncInputs === 'true') {
	    maxInput.addEventListener('input', handleMaxInputChange);
	    maxInput.addEventListener('change', handleMaxInputChange);
	    function handleMaxInputChange(e) {
	      if (isUpdatingFromSlider) return;
	      isUpdatingFromInput = true;
	      try {
	        const inputValue = e.target.value;
	        const values = slider.getValues();
	        if (inputValue === '' || inputValue === null || inputValue === undefined) {
	          slider.setValues([values[0], null]);
	        } else {
	          const newValue = parseFloat(inputValue);
	          if (!isNaN(newValue) && newValue !== values[1]) {
	            let constrainedValue;
	            if (slider.customSteps) {
	              constrainedValue = slider.findClosestStep(newValue);
	              if (!slider.isNull(values[0])) {
	                const minIndex = slider.getStepIndex(values[0], 0);
	                const newIndex = slider.getStepIndex(constrainedValue, 1);
	                if (newIndex <= minIndex) {
	                  constrainedValue = slider.customSteps[Math.min(slider.customSteps.length - 1, minIndex + 1)];
	                }
	              }
	            } else {
	              constrainedValue = Math.min(slider.options.max, Math.max(newValue, values[0] + slider.options.step));
	            }
	            slider.setValues([values[0], constrainedValue]);
	          }
	        }
	      } catch (e) {
	        // console.warn('[RangeSliders] Erreur lors du traitement du maxInput change:', e);
	      }
	      requestAnimationFrame(() => {
	        isUpdatingFromInput = false;
	      });
	    }
	  }
	}

	/**
	 * Fonction utilitaire pour sélectionner un élément de manière sûre
	 * @param {string} selector - Sélecteur CSS
	 * @param {string} description - Description de l'élément (pour les logs)
	 * @returns {HTMLElement|null}
	 */
	function safeQuerySelector(selector, description = 'element') {
	  try {
	    const element = document.querySelector(selector);
	    if (!element) {
	      // console.warn(`[RangeSliders] Élément "${description}" non trouvé: ${selector}`);
	    }
	    return element;
	  } catch (e) {
	    // console.error(`[RangeSliders] Sélecteur invalide pour "${description}": ${selector}`, e);
	    return null;
	  }
	}

	/**
	 * Créer un slider programmatiquement
	 * @param {string|HTMLElement} selector
	 * @param {Object} options
	 * @returns {RangeSlider}
	 */
	function createRangeSlider(selector, options) {
	  try {
	    return new RangeSlider(selector, options);
	  } catch (error) {
	    // console.error('[RangeSliders] Erreur lors de la création du slider:', error);
	    throw error;
	  }
	}

	/**
	 * Détruire tous les sliders
	 */
	function destroyAllRangeSliders() {
	  const config = getGlobalConfig();
	  const selector = config.selectors.slider;
	  const sliders = document.querySelectorAll(selector);
	  let destroyedCount = 0;
	  sliders.forEach((slider, index) => {
	    try {
	      if (slider.rangeSlider) {
	        slider.rangeSlider.destroy();
	        delete slider.rangeSlider;
	        destroyedCount++;
	      }
	    } catch (error) {
	      // console.error(`[RangeSliders] Erreur lors de la destruction du slider #${index}:`, error);
	    }
	  });

	  // console.log(`[RangeSliders] ${destroyedCount}/${sliders.length} slider(s) détruit(s)`);
	}

	var rangeSliders = /*#__PURE__*/Object.freeze({
		__proto__: null,
		createRangeSlider: createRangeSlider,
		default: initRangeSliders,
		destroyAllRangeSliders: destroyAllRangeSliders
	});

	const STATUS_CLASSES = ['is-coming', 'is-current', 'is-past'];
	const STATUS_LABELS = {
	  'is-current': 'En ce moment',
	  'is-coming': 'À venir',
	  'is-past': 'Passé'
	};

	/**
	 * Updates the visible status label inside .status, preserving the sr-only span.
	 */
	const updateStatusLabel = (card, statusClass) => {
	  const statusEl = card.querySelector('.status');
	  if (!statusEl) return;
	  const srOnly = statusEl.querySelector('.sr-only');

	  // Clear all child nodes, then restore the sr-only span and new text
	  statusEl.replaceChildren();
	  if (srOnly) statusEl.appendChild(srOnly);
	  statusEl.appendChild(document.createTextNode(STATUS_LABELS[statusClass]));
	};

	/**
	 * Determines and applies the temporal status class to each event card.
	 * Reads startDate/endDate from itemprop content attributes and compares
	 * them to today's date (time-agnostic, using date-only comparison).
	 * Also updates the visible status label text accordingly.
	 */
	const initEventCards = () => {
	  const cards = document.querySelectorAll('.m-card--event, .m-card--result--long');
	  if (!cards.length) return;
	  const today = new Date();
	  today.setHours(0, 0, 0, 0);
	  cards.forEach(card => {
	    const startEl = card.querySelector('[itemprop="startDate"]');
	    const endEl = card.querySelector('[itemprop="endDate"]');
	    const startAttr = startEl?.getAttribute('content');
	    const endAttr = endEl?.getAttribute('content');
	    if (!startAttr) return;
	    const startDate = new Date(startAttr);
	    startDate.setHours(0, 0, 0, 0);
	    const endDate = endAttr ? new Date(endAttr) : new Date(startAttr);
	    endDate.setHours(0, 0, 0, 0);
	    card.classList.remove(...STATUS_CLASSES);
	    let statusClass;
	    if (endDate < today) {
	      statusClass = 'is-past';
	    } else if (startDate > today) {
	      statusClass = 'is-coming';
	    } else {
	      statusClass = 'is-current';
	    }
	    card.classList.add(statusClass);
	    updateStatusLabel(card, statusClass);
	  });
	};

	var eventCards = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: initEventCards
	});

})();
